import { AppBar, Autocomplete, Avatar, Backdrop, Badge, Box, Button, Card, CardHeader, Checkbox, Chip, CircularProgress, Collapse, Container, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, FormControlLabel, Grid, IconButton, InputAdornment, List, ListItem, ListItemIcon, ListItemText, Menu, MenuItem, Paper, Radio, RadioGroup, Slide, Skeleton, Stack, Switch, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs, TextField, Toolbar, Tooltip, Typography } from "@material-ui/core";
import Page from '../../components/Page';
import { capitalCase, sentenceCase } from "change-case";
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill';
import trash2Outline from '@iconify/icons-eva/trash-2-outline';
import lockOpenFill from '@iconify/icons-ph/lock-open-fill';
import editFill from '@iconify/icons-eva/edit-fill';
import checkmarkFill from '@iconify/icons-eva/checkmark-fill';
import closeFill from '@iconify/icons-eva/close-fill';
import plusFill from '@iconify/icons-eva/plus-fill';  
import { isAdminUser } from '../../utils/adminUserTypes';
//materail
import * as Yup from 'yup';
import { getBaseUnixForLeadTime, getInstallEndPatchFromLead, isInstallBeforeRequiredLead, resolveProductsLeadTime } from 'src/utils/installationLeadTime';
import { isRushFeeOn, calcRushFeeAmount, calcTotalWithRushFee, createRushFeeSyncRefs, runRushFeeLeadSync, markRushFeeUserToggled } from 'src/utils/rushFee';
import getLabourCostServiceTabLabel from 'src/utils/getLabourCostServiceTabLabel';
import {
  computeFilteredServicesForDropdown,
  fetchLabourCostServicesForDropdown,
} from 'src/utils/labourCostServiceDropdown';
import { Form, FormikProvider, useFormik } from 'formik';
import { alpha, experimentalStyled as styled } from '@material-ui/core/styles';
import { useTheme } from '@material-ui/core/styles';
import HeaderBreadcrumbs from "src/components/HeaderBreadcrumbs";
import Label from "src/components/Label";
import { useLocation, useNavigate, useParams } from "react-router";

import ViewRequest from "src/components/_dashboard/official-request/ViewRequest";
import { forwardRef, useEffect, useImperativeHandle, useMemo, useRef, useState } from "react";
import PublicMsgBoard from "src/components/_dashboard/official-request/PublicMsgBoard";
import RequestTabUpdates from 'src/components/_dashboard/user/account/RequestTabUpdates'
import PublicMessageBoard from 'src/components/_dashboard/user/profile/PublicMessageBoard.js'
import RequestUpdates from "src/components/_dashboard/official-request/RequestUpdates";
import PaymentRequest from "src/components/_dashboard/official-request/PaymentRequest";
import { AddCircle, BlockOutlined, Delete, KeyboardBackspaceOutlined, Print, LocationOn, Add, Remove, CenterFocusStrong, NoteAdd, Close, UploadFile, DragIndicator, SwapHorizontalCircleOutlined } from "@material-ui/icons";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import Modal from "src/components/_dashboard/blog/ProjectModel";
import { Icon } from "@iconify/react";
import filePdfIcon from '@iconify/icons-mdi/file-pdf';
import Scrollbar from "src/components/Scrollbar";
import axios from "axios";
import { currentFacilityId, DOMAIN, FacilityTypes, REST_API, REST_API_END_POINT, REST_API_IO, SEND_EMAIL, UNITS } from "src/constants/Defaultvalues";
// import { io } from "socket.io-client"; // OLD — restore with createAppSocket removal when re-enabling
import createAppSocket from "src/Helpers/createSocket";
import moment from "moment";

const splitOrderCatalogTypes = [
  { id: 'all', label: 'All', inhouse: null, isTrafficCatalog: null },
  { id: 'in_stock', label: 'In Stock', inhouse: 4, isTrafficCatalog: false },
  { id: 'client_owned', label: 'Client Owned', inhouse: 5, isTrafficCatalog: false },
  { id: 'traffic', label: 'Traffic', inhouse: 1, isTrafficCatalog: true },
  { id: 'production_catalog', label: 'Production Catalog', inhouse: 1, isTrafficCatalog: false },
  { id: 'split_catalog', label: 'Split Catalog', inhouse: 6, isTrafficCatalog: false },
  { id: 'estimate_catalog', label: 'Estimate Catalog', inhouse: 7, isTrafficCatalog: false }
];

const getCatalogProductSuffix = (option) => {
  if (!option) return ''
  if (option.isTrafficCatalog) return '(TC)'
  if (option.inhouse === 5) return '(Client Owned Catalog)'
  if (option.inhouse === 4) return '(In Stock Catalog)'
  if (option.inhouse === 0) return '(Sub Contract)'
  if (option.inhouse === 6) return '(Split Catalog)'
  if (option.inhouse === 7) return '(Estimate Catalog)'
  return '(Production Catalog)'
}

const PRODUCT_ENTRY_TOGGLE_PAD = 4

const ProductLineEntryToggle = ({ mode, onChange, disabled, lockDisplay }) => {
  const theme = useTheme()
  const isWrite = mode === 'write'
  const pad = PRODUCT_ENTRY_TOGGLE_PAD
  const inactiveColor =
    theme.palette.mode === 'dark' ? theme.palette.grey[300] : theme.palette.grey[800]
  const activeColor = theme.palette.common.white

  const segmentButtonSx = (active) => ({
    flex: 1,
    position: 'relative',
    zIndex: 1,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 0.5,
    minWidth: 0,
    px: 1.25,
    py: 0.75,
    borderRadius: '12px',
    fontSize: '0.75rem',
    fontWeight: active ? 800 : 600,
    lineHeight: 1.25,
    color: active ? activeColor : inactiveColor,
    textTransform: 'none',
    letterSpacing: 0.2,
    transition: 'color 0.25s ease, transform 0.15s ease',
    '&:hover': {
      bgcolor: active ? 'transparent' : (theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.04)'),
      color: active ? activeColor : (theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.grey[900]),
    },
  })

  const shellSx = {
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'stretch',
    width: '100%',
    maxWidth: 176,
    minWidth: 160,
    p: `${pad}px`,
    borderRadius: '14px',
    border: `1px solid ${theme.palette.divider}`,
    bgcolor:
      theme.palette.mode === 'dark'
        ? 'rgba(255, 255, 255, 0.04)'
        : 'rgba(145, 158, 171, 0.1)',
    opacity: disabled && !lockDisplay ? 0.55 : 1,
    pointerEvents: disabled || lockDisplay ? 'none' : 'auto',
  }

  if (lockDisplay) {
    return (
      <Box role="group" aria-label="Product entry mode" sx={shellSx}>
        <Box
          aria-hidden
          sx={{
            position: 'absolute',
            top: pad,
            left: pad,
            right: pad,
            bottom: pad,
            borderRadius: '10px',
            zIndex: 0,
            background: isWrite
              ? `linear-gradient(145deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 55%, ${theme.palette.primary.dark} 100%)`
              : `linear-gradient(145deg, ${theme.palette.success.light} 0%, ${theme.palette.success.main} 55%, ${theme.palette.success.dark} 100%)`,
          }}
        />
        <Button
          variant="text"
          disableRipple
          size="small"
          sx={{
            ...segmentButtonSx(true),
            width: '100%',
            color: activeColor,
          }}
        >
          <Icon icon={isWrite ? 'eva:edit-2-outline' : 'eva:grid-outline'} width={15} height={15} />
          {isWrite ? 'Write' : 'Choose'}
        </Button>
      </Box>
    )
  }

  return (
    <Box
      role="group"
      aria-label="Product entry mode"
      sx={shellSx}
    >
      <Box
        aria-hidden
        sx={{
          position: 'absolute',
          top: pad,
          left: pad,
          bottom: pad,
          width: `calc((100% - ${pad * 2}px) / 2)`,
          borderRadius: '10px',
          transform: isWrite ? 'translateX(0)' : 'translateX(100%)',
          transition: 'transform 0.32s cubic-bezier(0.34, 1.2, 0.64, 1)',
          zIndex: 0,
          background: isWrite
            ? `linear-gradient(145deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 55%, ${theme.palette.primary.dark} 100%)`
            : `linear-gradient(145deg, ${theme.palette.success.light} 0%, ${theme.palette.success.main} 55%, ${theme.palette.success.dark} 100%)`,
        }}
      />
      <Button variant="text" disableRipple size="small" onClick={() => onChange('write')} sx={segmentButtonSx(isWrite)}>
        <Icon icon="eva:edit-2-outline" width={15} height={15} />
        Write
      </Button>
      <Button variant="text" disableRipple size="small" onClick={() => onChange('choose')} sx={segmentButtonSx(!isWrite)}>
        <Icon icon="eva:grid-outline" width={15} height={15} />
        Choose
      </Button>
    </Box>
  )
}

const createEmptyQuotationProductRow = (indexId = 1, community = null, projectCategoryId = null) => {
  const {
    address: projAddress = '',
    city: projCity = '',
    state: projState = '',
    zip: projZip = '',
  } = community || {}
  return {
    indexId,
    entryMode: 'write',
    name: '',
    product_name: '',
    product_desc: '',
    quantity: 1,
    price: 0,
    retail_price: 0,
    adjustment: 0,
    unit: 4,
    locationQuantity: 1,
    expected_cost: 1,
    expected_total_service_cost: 0,
    expected_service_cost: 0,
    expected_material_cost: 0,
    discount: 0,
    allLocationSame: true,
    service: [],
    isAdditionalProduct: true,
    is_product_row: 1,
    markAdjType: 1,
    wholesaleMarkup: 0,
    retailMarkup: 0,
    location: [{ id: 0, address: projAddress, city: projCity, state: projState, zip: projZip }],
    is_single_card: projectCategoryId !== 14,
  }
}

const isApiProductWriteRow = (row) =>
  row?.is_product_row == 1 ||
  row?.is_product_row === '1' ||
  row?.is_product_row === true ||
  row?.product_write == 1 ||
  row?.product_write === '1' ||
  row?.product_write === true

const isQuotationWriteRow = (product) =>
  isApiProductWriteRow(product) ||
  product?.entryMode === 'write' ||
  (product?.isAdditionalProduct && product?.entryMode !== 'choose')

/** Estimate service — product_write or entryMode write, excluding catalog rows (is_product_row=0). */
const isQuotationEstimateWriteProduct = (product) => {
  if (Number(product?.is_product_row) === 0) return false
  return (
    Number(product?.product_write) === 1 ||
    product?.product_write === '1' ||
    product?.product_write === true ||
    product?.entryMode === 'write'
  )
}

const isQuotationChooseEmptyRow = (product) =>
  !isQuotationWriteRow(product) && product?.entryMode === 'choose' && !product?.id

/** Ignore untouched placeholder write rows (no name, desc, or backend id). */
const isBlankEstimatePlaceholderRow = (product) => {
  if (!isQuotationWriteRow(product)) return false
  const hasName = Boolean((product.name || product.product_name || '').trim())
  const hasDesc = Boolean((product.product_desc || '').trim())
  const hasBackend = Boolean(product.backendId || product.id)
  return !hasName && !hasDesc && !hasBackend
}

const hasEmptyRequiredWriteProductName = (products) =>
  (products || []).some((product) => {
    if (!isQuotationWriteRow(product) || isQuotationChooseEmptyRow(product)) return false
    if (isBlankEstimatePlaceholderRow(product)) return false
    return !(product.name || product.product_name || '').trim()
  })

/** Draft save: any Write row without a product name must be filled or removed. */
const hasUnnamedWriteProductRow = (products) =>
  (products || []).some((product) => {
    if (product?.fromMapServices) return false
    if (!isQuotationWriteRow(product) || isQuotationChooseEmptyRow(product)) return false
    return !(product.name || product.product_name || '').trim()
  })

const getEffectiveIsRequestEstimate = (
  details,
  selectedProducts,
  additionalSelectedServices,
  serviceRows = [],
) => {
  const hasAnyProductRowFlag = (selectedProducts || []).some((row) =>
    isQuotationEstimateWriteProduct(row),
  )
  // BACKUP: (selectedProducts || []).some((row) => isQuotationWriteRow(row))
  const hasAnyServiceRowFlag =
    (additionalSelectedServices || []).some((row) => isQuotationWriteService(row)) ||
    (serviceRows || []).some((row) => (row?.service_name || '').trim() !== '')
  return (
    Number(details?.is_request_estimate) === 1 ||
    hasAnyProductRowFlag ||
    hasAnyServiceRowFlag
  )
}

const shouldPersistDraftProduct = (product) => {
  if (product?.fromMapServices) return false
  if (isBlankEstimatePlaceholderRow(product)) return false
  if (isQuotationChooseEmptyRow(product)) return false
  if (
    isQuotationWriteRow(product) &&
    !(product.name || product.product_name || '').trim()
  ) {
    return false
  }
  return true
}

const isQuotationProductRowForValues = (product) =>
  Number(product?.is_product_row) === 1

const isSavedManualWriteProductRow = (row) => {
  if (Number(row?.is_product_row) !== 1) return false
  // BACKUP: isApiProductWriteRow(row) ||
  //   (Boolean(String(row?.product_name || '').trim()) &&
  //     (row?.product_id == null || row?.product_id === ''))
  return (
    isApiProductWriteRow(row) ||
    (Boolean(String(row?.product_name || '').trim()) &&
      (row?.product_id == null || row?.product_id === ''))
  )
}

const getQuotationRowEntryMode = (product) => {
  if (isApiProductWriteRow(product)) return 'write'
  if (product?.id) return 'choose'
  if (product?.entryMode) return product.entryMode
  if (product?.isAdditionalProduct) return 'write'
  return 'write'
}

/** Catalog "choose" rows eligible for product grouping (not write / empty choose rows). */
const isViewQuotationChooseCatalogRow = (product) => {
  if (!product || product?.fromMapServices) return false
  if (isQuotationWriteRow(product)) return false
  if (isQuotationChooseEmptyRow(product)) return false
  if (Number(product?.is_line_catalog) === 1) return true
  return getQuotationRowEntryMode(product) === 'choose' && Boolean(product?.id)
}

const getProductToggleDisplayModeFromProductWrite = (row) => {
  if (Number(row?.product_write) === 1 || row?.product_write === '1' || row?.product_write === true) {
    return 'write'
  }
  return 'choose'
}

const getProductToggleDisplayMode = (row) => {
  if (Number(row?.product_write) === 1 || row?.product_write === '1' || row?.product_write === true) {
    return 'write'
  }
  if (
    Number(row?.product_write) === 0 ||
    row?.product_write === '0' ||
    row?.product_write === false
  ) {
    return 'choose'
  }
  // BACKUP: fallbacks when product_write unset — used for rows without saved product_write
  // if (Number(row?.product_write) === 1) return 'write'
  if (row?.entryMode === 'write' || row?.entryMode === 'choose') return row.entryMode
  if (row?.is_product_row == 1 || row?.isAdditionalProduct) return 'write'
  return 'choose'
}

const hasToggleValue = (value) =>
  value !== undefined &&
  value !== null &&
  value !== ''

const isRequestEstimateLockedProductToggle = (
  row,
  isRequestEstimate,
  userType,
) => {
  if (userType == 1 || userType == 12) return false
  if (
    userType == 18 &&
    (row?.addedByUserType ?? row?.added_by_user_type) == 18
  ) {
    return false
  }
  if (isRequestEstimate != 1) return false
  if (row?.isNewlyAddedProductRow) return false

  return hasToggleValue(row?.product_write)
}

const isRequestEstimateLockedServiceToggle = (
  row,
  isRequestEstimate,
  userType,
) => {
  if (userType == 1 || userType == 12) return false
  if (
    userType == 18 &&
    (row?.addedByUserType ?? row?.added_by_user_type) == 18
  ) {
    return false
  }
  if (isRequestEstimate != 1) return false
  if (row?.isNewlyAddedServiceRow) return false

  return hasToggleValue(row?.service_write)
}

// const getProductToggleDisplayMode = (row) => {
//   if (Number(row?.product_write) === 1) return 'write'
//   if (Number(row?.product_write) === 0) return 'choose'

//   if (row?.entryMode === 'write' || row?.entryMode === 'choose') {
//     return row.entryMode
//   }

//   if (row?.is_product_row == 1 || row?.isAdditionalProduct) return 'write'

//   return 'choose'
// }

const getServiceToggleDisplayMode = (row) => {
  if (Number(row?.service_write) === 1) return 'write'
  if (Number(row?.service_write) === 0) return 'choose'

  if (row?.entryMode === 'write' || row?.entryMode === 'choose') {
    return row.entryMode
  }

  if (row?.is_service_row == 1 || row?.isAdditionalProduct) return 'write'

  return 'choose'
}

const createEmptyQuotationServiceRow = (newIndexId = 1, community = null) => {
  const {
    address: projAddress = '',
    city: projCity = '',
    state: projState = '',
    zip: projZip = '',
  } = community || {}
  return {
    id: null,
    newIndexId,
    indexId: newIndexId,
    product_index: newIndexId,
    // entryMode: 'choose',
    entryMode: 'write',
    name: '',
    service_name: '',
    service_desc: '',
    quantity: 1,
    cost: 0,
    markup: 0,
    total_cost: 0,
    originalMarkup: 0,
    service_type: null,
    allLocationSame: true,
    // isAdditionalProduct: false,
    isAdditionalProduct: true,
    // is_service_row: 0,
    is_service_row: 1,
    addresses: [{ id: 0, address: projAddress, city: projCity, state: projState, zip: projZip }],
  }
}

const isApiServiceWriteRow = (row) =>
  row?.is_service_row == 1 || row?.is_service_row === '1' || row?.is_service_row === true

const isQuotationWriteService = (service) =>
  isApiServiceWriteRow(service) ||
  service?.entryMode === 'write' ||
  (service?.isAdditionalProduct && service?.entryMode !== 'choose')

const isQuotationChooseEmptyService = (service) =>
  !isQuotationWriteService(service) && service?.entryMode === 'choose' && !service?.id

const isEstimateCatalogServiceRow = (service) =>
  Number(service?.service_type) === 44 && !isQuotationWriteService(service)

const parseEstimatorIdSet = (estimatorIds) =>
  new Set(
    String(estimatorIds || '')
      .split(',')
      .map((id) => id.trim())
      .filter(Boolean)
      .map((id) => String(id)),
  )

const matchEstimatorsFromDetails = (estimatorIds, estimatorsList) => {
  const idSet = parseEstimatorIdSet(estimatorIds)
  if (!idSet.size || !estimatorsList?.length) return []
  return estimatorsList.filter((estimator) => idSet.has(String(estimator.id)))
}

/** Dedupe estimate services — id can be request_services.id OR labour_cost_services.id on the same row. */
const getEstimateServiceDedupeKey = (service) => {
  if (Number(service?.service_type) === 44 && !isQuotationWriteService(service)) {
    const lcsId = service?.labour_cost_service_id ?? service?.id
    const lineIdx = String(service?.newIndexId ?? service?.indexId ?? service?.product_index ?? '0')
    return `catalog-44:${lcsId}:${lineIdx}`
  }
  const requestServiceId = service?.request_service_id ?? service?.backendId ?? service?.id
  if (requestServiceId != null && requestServiceId !== '') {
    return `rs:${requestServiceId}`
  }
  const lcsId = service?.labour_cost_service_id ?? service?.id
  const lineIdx = String(service?.newIndexId ?? service?.indexId ?? service?.product_index ?? '')
  return `lcs:${lcsId}:idx:${lineIdx}`
}

const dedupeEstimateServicesByLine = (list) => {
  const seen = new Set()
  return (list || []).filter((service) => {
    const key = getEstimateServiceDedupeKey(service)
    if (seen.has(key)) return false
    seen.add(key)
    return true
  })
}

const shouldIncludeRequestServiceInTable = (serviceItem) =>
  serviceItem?.labour_cost_service_id != null ||
  Number(serviceItem?.service_type) === 44 ||
  serviceItem?.is_service_row == 1 ||
  serviceItem?.is_service_row === '1' ||
  serviceItem?.is_service_row === true

const getServiceHourlyCost = (service) => {
  if (!service) return 0
  const unitCost = service.unit_cost
  if (unitCost != null && unitCost !== '') return Number(unitCost) || 0
  if (service?.total_cost != null && service?.total_cost !== '') return Number(service?.total_cost) || 0
  if (service.cost != null && service.cost !== '') return Number(service.cost) || 0
  const totalCost = Number(service.total_cost)
  const qty = Number(service.quantity) || 1
  if (Number.isFinite(totalCost) && totalCost !== 0) {
    return qty > 0 ? totalCost / qty : totalCost
  }
  return 0
}

const formatServiceHourlyCost = (service) => getServiceHourlyCost(service).toFixed(2)

const getQuotationServiceEntryMode = (service) => {
  if (isApiServiceWriteRow(service)) return 'write'
  if (service?.entryMode) return service.entryMode
  if (service?.isAdditionalProduct) return 'write'
  if (service?.id) return 'choose'
  return 'write'
  // if (service?.entryMode === 'choose' || service?.id) return 'choose'
  // return 'choose'
  // Previous Write/Choose resolution (may restore later):
  // if (service?.entryMode) return service.entryMode
  // if (service?.isAdditionalProduct) return 'write'
  // if (service?.id) return 'choose'
  // return 'write'
}

import { PATH_DASHBOARD, ROOTS_PCB } from "src/routes/paths";
import { useSnackbar } from "notistack";
import { LoadingButton, MobileDatePicker, MobileDateRangePicker } from "@material-ui/lab";
import { formatDateOnly, dateOnlyMoment, dateOnlyToUnix, estimateDatePickerMoment, localTodayDateOnlyUnix, toDateOnlyUnix } from "src/utils/dateOnly";
import { useCallback } from "react";
import { UploadAvatar, UploadMultiFile } from "src/components/upload";
import AddClients from "src/components/_dashboard/official-request/AddClients";
import AddProposal from "src/components/_dashboard/official-request/AddProposal";
import ConfirmationPopup from "src/components/_dashboard/official-request/ConfirmationPopup";
import ReactToPrint, { useReactToPrint } from 'react-to-print'
import {storage} from '../../firebase/firebase'
import { getDownloadURL, ref as imageref , uploadBytesResumable } from 'firebase/storage';
import { Link } from "react-router-dom";
import { empty } from "src/Helpers/Common";
import { resolveAttachmentProxyPath } from 'src/Helpers/FileDownloadUtils';
import Locations from "src/components/_dashboard/official-request/Locations";
import Workflow from "src/components/_dashboard/general-analytics/RfqForm";
import {  AccountNotifications } from '../../components/_dashboard/user/account'
import { set } from "lodash";
import Proposals from "src/components/_dashboard/official-request/Proposals";
import useCompanyProfile from "src/hooks/useCompanyProfile";
import LoadingScreen from "src/components/LoadingScreen";
import { ButtonAnimate, DialogAnimate } from "src/components/animate";
import AnimatedButton from "src/components/animate/AnimatedButton";
import RouteMap from "src/components/_dashboard/official-request/RouteMap";
import React from 'react'
import { supabase } from '../../supabase/supabaseClient';
import AVALARALOGO from 'src/assets/Avalara_Logo.png';
import JobNoteWindow from 'src/components/_dashboard/chat/JobNoteWindow';
import { SalesOrderNewBadgeList } from 'src/components/_dashboard/official-request/SalesOrderNewBadge';
import useJobNoteTabUnread from 'src/hooks/useJobNoteTabUnread';
import RequestProgressModal from "src/components/RequestProgressModal";
import emailFillIcon from '@iconify/icons-eva/email-fill';
import signAgreementIcon from '@iconify/icons-eva/file-text-fill';
import SendDesignsEmailModal from 'src/components/_dashboard/official-request/SendDesignsEmailModal';
import InvoicePdfPreviewPage from 'src/components/_dashboard/official-request/InvoicePdfPreviewPage';
import EditEstimateJob from "./EditEstimateJob";
import ViewQuotationGroupedProductLocationModal from './ViewQuotationGroupedProductLocationModal';
import EstimateOrderInvoicePage from "./EstimateOrderInvoicePage";
import {
  sortServicesByProductIndex,
  buildServiceIndexMapping,
  serviceLineMatches,
} from 'src/utils/sortServicesByIndex';
import quickbookLogo from 'src/assets/quickbookLogo-removebg-preview.png';
import { use } from "react";
import { is } from "immutable";
import { fUSPrice } from "src/utils/formatNumber";
import ViewProductFormulaModal from "src/components/ViewProductFormulaModal";
import AttachmentDownloadIconButton from 'src/components/_dashboard/official-request/AttachmentDownloadIconButton';
import AttachmentDownloadAllButton from 'src/components/_dashboard/official-request/AttachmentDownloadAllButton';
import {
  applyInstallPriceEdit,
  applyRetailPriceEdit,
  distributeGroupTotalByFormulaShare,
  ensureCatalogBaselines,
  formatPriceToTwoDecimals,
  formatRetailPriceDisplay,
  getDisplayedInstallPrice,
  getInstallFormulaEach,
  getProductFormulaEach,
  getSignedMarketingAdjustment,
  getSignedInstallMarketingAdjustment,
  hydrateEstimateLineMarketingPrices,
  canShowProductFormulaIcon,
  hydrateSavedOrderLinePrices,
  limitDecimalInput,
  normalizeRetailArrowChange,
  normalizeProductForSave,
  reconcileCatalogMarketingPrices,
  clearCatalogInstallCost,
  applyProductAdjValueTypeChange,
  applyInstallAdjValueTypeChange,
  stepRetailPriceByArrow,
} from 'src/utils/retailPriceEdit';
import {
  buildGroupAddressesForProduct,
  getCatalogSourceDropdownOptions,
  getCatalogSourceOptions,
  getSelectedLineCatalogCount,
  getSelectedLineCatalogProducts,
  isSameGroupId,
  normalizeGroupLineQuantity,
  quotationGroupNameExists,
  getNestedLineMarketingAdjustmentValue,
  formatNestedMarketingAdjustmentDisplay,
  getNestedLineMarketingAdjValueType,
  restoreUngroupedProductMarketing,
  snapshotGroupMemberMarketing,
  ensureGroupMemberMarketingSnapshot,
  hydrateGroupedMemberMarketingFromRow,
  resolveGroupMemberMarketingForSave,
  QUOTATION_ROW_DELETE_CELL_SX,
  QUOTATION_ROW_ACTIONS_BOX_SX,
  QUOTATION_ROW_ACTIONS_LEADING_SLOT_SX,
  enrichQuotationAttachmentForDisplay,
  mapQuotationProductAttachmentForDisplay,
  getCustomerOrderProductGroupDisplayName,
  getGroupInstallNotesDisplay,
  collapseProductsForAutocompleteChips,
  getCatalogAutocompleteDisplayName,
  getCatalogAutocompleteTooltip,
  getAddToGroupOptions,
  getValidUngroupedSelectionIds,
  isIndexIdInList,
  withInheritedGroupNotes,
  getSingleProductFormulaCostEach,
  computeGroupedProducts,
  GROUP_QUANTITY_MODE_SET_MULTIPLIER,
  getGroupProductMarketingAdjustmentDisplay,
  getGroupInstallMarketingAdjustmentDisplay,
  resolveGroupProductMarketingAdjustment,
  resolveGroupInstallMarketingAdjustment,
  getNestedLineLosingMoneyFlags,
  getGroupMemberProductQty,
  getGroupMemberInstallQty,
} from './quotation/quotationGroupingHelpers';
import {
  buildGroupedDesignOrderDisplayRows,
  getInvoiceProductDisplayName,
  serializeDesignOrderGroupedRowsForInvoice,
} from 'src/utils/designOrderInvoiceUtils';
import {
  QuotationGroupActionBar,
  QuotationGroupDialogs,
  GroupEditActionButtons,
  GroupDeleteIconButton,
  getGroupRowAlignSx,
} from './quotation/QuotationProductGroupingUI';
import { roundMoneyValue } from 'src/utils/formatNumber';

/** Stable id for comparing uploaded files (url vs name can differ between pool and line items). */
/** Normalize URL for compare (strip query/hash; API pool vs line items often differ). */
const ATTACHMENTS_PUBLIC_MARKER = '/storage/v1/object/public/signwise-attachments/';

const normalizeUrlString = (s) => {
  const raw = String(s || '').trim();
  if (!raw) return '';
  try {
    const u = new URL(raw);
    return `${u.origin}${u.pathname}`.replace(/\/+$/, '');
  } catch {
    return raw.split('?')[0].split('#')[0].trim();
  }
};

/** True for URLs / storage paths — false for bare filenames like "Screenshot.png". */
const looksLikeAttachmentRef = (raw) => {
  const s = String(raw || '');
  if (!s) return false;
  if (
    s.includes('://') ||
    s.includes('/attachments/file') ||
    s.includes('/storage/v1/object/') ||
    s.includes(ATTACHMENTS_PUBLIC_MARKER)
  ) {
    return true;
  }
  // storage-relative path e.g. sales-orders/123_file.png
  return s.includes('/') && /\.[a-z0-9]+$/i.test(s);
};

/** Collapse proxy URLs + direct Supabase URLs to the same storage path. */
const normalizeAttachmentIdentifier = (raw) => {
  if (!raw) return '';
  const str = String(raw).trim();
  if (!str) return '';

  if (str.includes('/attachments/file') && str.includes('path=')) {
    return normalizeUrlString(resolveAttachmentProxyPath(str));
  }

  const publicIdx = str.indexOf(ATTACHMENTS_PUBLIC_MARKER);
  if (publicIdx !== -1) {
    return normalizeUrlString(str.slice(publicIdx + ATTACHMENTS_PUBLIC_MARKER.length));
  }

  return normalizeUrlString(str);
};

const getAttachmentRecordId = (f) =>
  f?.id ?? f?.ID ?? f?.attachment_id ?? f?.request_attachment_id ?? null;

/** Prefer url/file_url; only use name when it is a URL/path (not a bare filename). */
const getAttachmentPrimaryRef = (f) => {
  if (!f) return '';
  if (f.url) return f.url;
  if (f.file_url) return f.file_url;
  if (looksLikeAttachmentRef(f.name)) return f.name;
  return '';
};

/** Single-string id for dedupe lists (prefers url, then name, then file_url). */
const attachmentFileKey = (f) => {
  const primary = getAttachmentPrimaryRef(f);
  if (primary) return normalizeAttachmentIdentifier(primary);
  // last resort: bare name (unique only when filenames differ)
  return normalizeAttachmentIdentifier(f?.name || '');
};

/** Compare two file rows: prefer a shared record id, else fall back to the normalized path. */
const attachmentMatches = (a, b) => {
  const idA = getAttachmentRecordId(a);
  const idB = getAttachmentRecordId(b);
  if (idA != null && idB != null && String(idA) !== '' && String(idB) !== '') {
    return String(idA) === String(idB);
  }

  const keyA = attachmentFileKey(a);
  const keyB = attachmentFileKey(b);
  return Boolean(keyA && keyB && keyA === keyB);
};

/** Drop any file rows that match fileToRemove from each array in map; drop empty keys. */
const pruneAttachmentMapsByFile = (map, fileToRemove) => {
  if (!fileToRemove || !map) return map || {};
  const next = { ...map };
  Object.keys(next).forEach((k) => {
    const arr = next[k];
    if (!Array.isArray(arr)) return;
    const filtered = arr.filter((f) => !attachmentMatches(f, fileToRemove));
    if (filtered.length === 0) {
      delete next[k];
    } else {
      next[k] = filtered;
    }
  });
  return next;
};

const RowResultStyle = styled(TableRow)(({ theme }) => ({
  '& td': {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1)
  }
}));
const MAX_CHARACTERS = 500;
const formatProjectAddress = (project) => {
  if (!project) return 'No address available';
  const addressParts = [project.address, project.city, project.state, project.zip]
    .map((part) => (part || '').toString().trim())
    .filter(Boolean);
  return addressParts.length > 0 ? addressParts.join(', ') : 'No address available';
};

/** Group marketing: DB stores 1 = positive, 0 = negative (must not use || when loading). */
const parseGroupMarketingAdjValueTypeFromDb = (raw) => {
  if (raw === 0 || raw === false || raw === '0') return false
  if (raw === 1 || raw === true || raw === '1') return true
  if (raw != null && raw !== '') return Number(raw) !== 0
  return true
}

const selectInputValue = (event) => {
  const input = event.target;
  setTimeout(() => {
    if (input?.select) {
      input.select();
    }
  }, 0);
};

const getStatusColorAndLabel = (status , quotation, estimate_job_status, hold, manager_approval_required, send_to_client, send_for_manager_approval, is_request_estimate,details) => {
  console.log("statussss",status , quotation, estimate_job_status, hold)
  if (Number(status) === 12) {
    return { color: 'error', label: 'Status: Void' };
  }
  if(hold == 1){
    return { color: 'warning', label: 'Status: Hold' };
  }
  const isRequestEstimate = is_request_estimate == 1;
  const resolvedStatus = Number(status);
  const isRejectedEstimate = resolvedStatus === 6 || resolvedStatus === 11;
  const managerReviewPending =
    !isRejectedEstimate &&
    isRequestEstimate &&
    Number(estimate_job_status) === 3 &&
    (manager_approval_required === 1 || manager_approval_required === true) &&
    (send_for_manager_approval === 1 || send_for_manager_approval === true) &&
    send_to_client != 1;
  // Previous (also applied manager review to regular estimates with no job):
  // const managerReviewPending =
  //   !isRejectedEstimate &&
  //   (manager_approval_required === 1 || manager_approval_required === true) &&
  //   (send_for_manager_approval === 1 || send_for_manager_approval === true) &&
  //   send_to_client != 1;
  if (
    (!isRejectedEstimate &&
    status !== 1 &&
    managerReviewPending) || (status == 2 && details.project_type != null)
  ) {
    // Previous: (!isRequestEstimate || Number(estimate_job_status) === 3) && managerReviewPending
    return { color: 'info', label: 'Status: Review/ Send for Approval' };
  }
  switch (status) {
    case 0:
      return { color: 'error', label: 'Status: Removed' };
    case 1:
      return { color: 'warning', label: 'Status: Draft' };
    case 2: 
      return { color: 'info', label: send_to_client == 1 ? 'Status: Awaiting Approval' : 'Status: New' };
    case 3:
      // if (isRequestEstimate) {
      if (estimate_job_status) {
        console.log("######estimate_job_status",estimate_job_status);
        console.log("######isRequestEstimate",isRequestEstimate);
        return {
          color: estimate_job_status == 3 ? 'info' : estimate_job_status == 2 ? 'info': 'primary',
          label: estimate_job_status == 3 ? 'Status: Review/ Send for Approval' : estimate_job_status == 2 ? 'Status: In Progress': 'Status: In Queue'
        };
      }
      return {
        color: managerReviewPending ? 'info' : estimate_job_status == 2 ? 'info' : 'primary',
        label: managerReviewPending
          ? 'Status: Review/ Send for Approval'
          : estimate_job_status == 2
          ? 'Status: In Progress'
          : 'Status: In Queue',
      };
    case 4:
      return { color: quotation == 0 ? 'default' : 'success', label: quotation == 0 ? 'Status: Archive' :'Status: Approved' };
    case 5:
      return { color: 'warning', label: 'Status: Closed' };
    case 6:
      return { color: 'error', label: 'Status: Rejected' };
    case 9:
      if (isRequestEstimate) {
          return {
              color:
                Number(estimate_job_status) !== 3
                  ? Number(estimate_job_status) === 2
                    ? 'info'
                    : 'primary'
                  : 'info',
        
              label:
                Number(estimate_job_status) !== 3
                  ? Number(estimate_job_status) === 2
                    ? 'Status: In Progress'
                    : 'Status: In Queue'
                  : (manager_approval_required === true ||
                      manager_approval_required === 1) &&
                    (send_for_manager_approval === true ||
                      send_for_manager_approval === 1) &&
                    send_to_client != 1
                  ? 'Status: Review/ Send for Approval'
                  : send_to_client == 1
                  ? 'Status: Awaiting Approval'
                  : (manager_approval_required === true ||
                      manager_approval_required === 1)
                  ? 'Status: Awaiting Manager Approval'
                  : 'Status: Awaiting Approval',
            };
          }
        
          // Regular estimate
          return {
            color: 'info',
            label:
              (manager_approval_required === true ||
                manager_approval_required === 1) &&
              (send_for_manager_approval === true ||
                send_for_manager_approval === 1) &&
              send_to_client != 1
                ? 'Status: Review/ Send for Approval'
                : send_to_client == 1
                ? 'Status: Awaiting Approval'
                : (manager_approval_required === true ||
                    manager_approval_required === 1)
                ? 'Status: Awaiting Manager Approval'
                : 'Status: Awaiting Approval',
          };
    case 10:
      if (estimate_job_status) {
        // if (isRequestEstimate) {
        if (Number(estimate_job_status) === 2) {
          return { color: 'info', label: 'Status: In Progress' };
        }
        if (Number(estimate_job_status) !== 3) {
          return { color: 'primary', label: 'Status: In Queue' };
        }
      }
      return { color: 'info', label: 'Status: Review/ Send for Approval' };
    case 11:
      return { color: 'error', label: 'Status: Rejected by Manager' };
    case 12:
      return { color: 'error', label: 'Void' };
    default:
      return { color: 'default', label: 'Status: Open' };
  }
};

const markupTypes = [
  {id : 1 , name : 'Wholesale Markup'},
  {id : 2 , name : 'Retail Markup'}
]

const marketingAdjustmentType = [
  { id: 1, name: '%' },
  { id: 2, name: '$' },
  { id: 3, name: '¢' }
];
const getMaterialMaxNegativeAdjustment = (item, hasPermission) => {
  // Quantity and location quantities
  const qty = Number(item.quantity) || 1;
  const formulaEach = Number(item.price)
  const retailEachBase = Number(item.markUpCost)
  const formulaTotal = formulaEach * qty ;
  const retailTotal = retailEachBase * qty ;

  // Max negative adjustment allowed so that retailTotal - adjustment >= formulaTotal
  // const maxNegative = Math.max(0, retailTotal - formulaTotal);
  let maxNegative = Math.max(0, retailEachBase - formulaEach);

  if (hasPermission) {
    maxNegative = retailEachBase;
  }

  console.log('getMaxNegativeAdjustment1-item--', item);
  console.log('getMaxNegativeAdjustment1-formulaEach--', formulaEach);
  console.log('getMaxNegativeAdjustment1-retailEachBase--', retailEachBase);
  console.log('getMaxNegativeAdjustment1-qty--', qty);
  console.log('getMaxNegativeAdjustment1-formulaTotal--', formulaTotal);
  console.log('getMaxNegativeAdjustment1-retailTotal--', retailTotal);
  console.log('getMaxNegativeAdjustment1-maxNegative--', maxNegative);

  return maxNegative.toFixed(2);
};
const getMaxNegativeAdjustment = (item, hasPermission) => {
  const qty = Number(item.quantity) || 1;
  const locQty = Number(item.locationQuantity) || 1;

  // Product Formula Cost per unit
  // const formulaEach = Number(item.formula_cost ?? item.expected_cost ?? 0);
  const formulaEach = getSingleProductFormulaCostEach(item);
  const formulaTotal = formulaEach * qty * locQty;

  // Base retail each BEFORE marketing adjustment
  const retailEachBase = Math.max(
    0,
    Number(
      item.original_actual_retail_price ??
      item.original_retail_price ??
      item.actual_retail_price ??
      item.retail_price ??
      item.product_retail_price ??
      0
    )
  );
  const retailTotal = retailEachBase * qty * locQty;

  // Max negative adjustment allowed so that retailTotal - adjustment >= formulaTotal
  // const maxNegative = Math.max(0, retailTotal - formulaTotal);
  let maxNegative = Math.max(0, retailEachBase - formulaEach);
  if (hasPermission) {
    maxNegative = retailEachBase;
  }
  console.log('getMaxNegativeAdjustment-maxNegative--',maxNegative)
  return { maxNegative, formulaTotal, retailTotal };
};

const MIN_INSTALL_RETAIL_EACH = 0.01

const computeInstallCostFromAdjustment = (baseInstall, adjustment, isPositiveType) => {
  const adj = Number(adjustment) || 0
  const signed =
    isPositiveType !== false && isPositiveType !== 0 ? adj : -adj
  return Number((Number(baseInstall) + signed).toFixed(2))
}

const isInstallRetailPriceAllowed = (installCost, formulaEach, hasPermission) => {
  const minAllowed = hasPermission ? MIN_INSTALL_RETAIL_EACH : formulaEach
  return Number(installCost) >= minAllowed - 0.001
}

const getMaxNegativeInstallAdjustment = (data, hasPermission) => {
  const formula = Number(data?.expected_install_labor_cost_with_markup) || 0
  const retail = Math.max(
    0,
    Number(data?.original_install_cost) || Number(data?.install_cost) || 0,
  )
  if (hasPermission) {
    return Math.max(0, Number((retail - MIN_INSTALL_RETAIL_EACH).toFixed(2)))
  }
  return Math.max(0, Number((retail - formula).toFixed(2)))
}

const Transition = forwardRef((props, ref) => <Slide direction="down" ref={ref} {...props} />);

// Alphanumeric comparison helper function (natural sort)
function alphanumericCompare(str1, str2) {
  const normalize = (str) => {
    if (str === null || str === undefined) return '';
    // Strip leading and trailing quotes before comparison
    let normalized = str.toString().trim();
    // Remove leading and trailing quotes (both single and double)
    normalized = normalized.replace(/^["']+|["']+$/g, '');
    return normalized;
  };

  const a = normalize(str1);
  const b = normalize(str2);

  if (!a && !b) return 0;
  if (!a) return -1;
  if (!b) return 1;

  const getChunks = (str) => {
    const chunks = [];
    let currentChunk = '';
    let chunkType = null; // 'hash', 'otherSpecial', 'digit', or 'letter'

    for (let i = 0; i < str.length; i++) {
      const char = str[i];
      const isDigit = /\d/.test(char);
      const isLetter = /[a-zA-Z]/.test(char);
      const isHash = char === '#';
      const isOtherSpecial = !isDigit && !isLetter && !isHash;
      
      // Determine chunk type with priority: hash < otherSpecial < digit < letter
      let currentType;
      if (isHash) {
        currentType = 'hash';
      } else if (isOtherSpecial) {
        currentType = 'otherSpecial';
      } else if (isDigit) {
        currentType = 'digit';
      } else {
        currentType = 'letter';
      }

      if (i === 0) {
        chunkType = currentType;
        currentChunk = char;
      } else if (currentType === chunkType) {
        currentChunk += char;
      } else {
        chunks.push({
          value: chunkType === 'digit' ? parseInt(currentChunk, 10) : currentChunk.toLowerCase(),
          type: chunkType
        });
        currentChunk = char;
        chunkType = currentType;
      }
    }

    if (currentChunk) {
      chunks.push({
        value: chunkType === 'digit' ? parseInt(currentChunk, 10) : currentChunk.toLowerCase(),
        type: chunkType
      });
    }

    return chunks;
  };

  const chunksA = getChunks(a);
  const chunksB = getChunks(b);
  const len = Math.min(chunksA.length, chunksB.length);

  // Type priority: hash (0) < otherSpecial (1) < digit (2) < letter (3)
  const getTypePriority = (type) => {
    if (type === 'hash') return 0;
    if (type === 'otherSpecial') return 1;
    if (type === 'digit') return 2;
    return 3; // letter
  };

  for (let i = 0; i < len; i++) {
    const chunkA = chunksA[i];
    const chunkB = chunksB[i];

    const priorityA = getTypePriority(chunkA.type);
    const priorityB = getTypePriority(chunkB.type);

    if (priorityA !== priorityB) {
      return priorityA - priorityB;
    }

    // Same type, compare values
    if (chunkA.type === 'digit') {
      if (chunkA.value < chunkB.value) return -1;
      if (chunkA.value > chunkB.value) return 1;
    } else {
      if (chunkA.value < chunkB.value) return -1;
      if (chunkA.value > chunkB.value) return 1;
    }
  }

  if (chunksA.length < chunksB.length) return -1;
  if (chunksA.length > chunksB.length) return 1;

  return 0;
}

  const getSalesRepOptionsFromCommunity = (community) => {
    // Use ?? so an empty eligible list does not fall back to raw stored IDs.
    const rawNames = community?.all_sales_rep_names ?? community?.sales_rep_names;
    const rawIds = community?.all_sales_rep_ids ?? community?.sales_rep_ids;

    const names = Array.isArray(rawNames)
      ? rawNames
      : typeof rawNames === 'string'
        ? rawNames.split(',').map((s) => s.trim()).filter(Boolean)
        : [];

    const ids = Array.isArray(rawIds)
      ? rawIds
      : typeof rawIds === 'string'
        ? rawIds.split(',').map((s) => s.trim()).filter(Boolean)
        : [];

    return names.map((name, idx) => ({ id: ids[idx] ?? null, name }));
  };

  const getCommunitySalesRepIds = (community) => {
    const rawIds = community?.all_sales_rep_ids ?? community?.sales_rep_ids;
    if (!rawIds) {
      return [];
    }

    const ids = Array.isArray(rawIds)
      ? rawIds
      : typeof rawIds === 'string'
        ? rawIds.split(',')
        : [];

    return ids
      .map((id) => String(id ?? '').trim())
      .filter(Boolean);
  };

// Shared by any text field whose parent-state commit is expensive (feeds selectedProducts /
// the grouping useMemos / the totals useEffect): typing writes to a lightweight local draft
// keyed by a stable id, and only that draft is committed into parent state, debounced 400ms or
// flushed on blur. Kept generic so new heavy fields (e.g. group name/description) don't need
// their own copy of the draft/ref/timer boilerplate — see Product Name/Description in
// ViewofficialRequest for the original, hand-written version this mirrors (left as-is to avoid
// touching that already-verified fix).
const useKeyedDraftField = (commitToParentState) => {
  const [drafts, setDrafts] = useState({})
  const draftsRef = useRef({})
  const timersRef = useRef({})

  useEffect(() => {
    return () => {
      Object.values(timersRef.current).forEach((timerId) => clearTimeout(timerId))
    }
  }, [])

  const commit = (key) => {
    const timerId = timersRef.current[key]
    if (timerId) {
      clearTimeout(timerId)
      delete timersRef.current[key]
    }
    if (!(key in draftsRef.current)) return
    const value = draftsRef.current[key]
    delete draftsRef.current[key]
    commitToParentState(key, value)
    setDrafts((prev) => {
      if (!(key in prev)) return prev
      const next = { ...prev }
      delete next[key]
      return next
    })
  }

  const handleChange = (key, value) => {
    draftsRef.current[key] = value
    setDrafts((prev) => ({ ...prev, [key]: value }))
    if (timersRef.current[key]) clearTimeout(timersRef.current[key])
    timersRef.current[key] = setTimeout(() => commit(key), 400)
  }

  const getValue = (key, fallback) => (drafts[key] !== undefined ? drafts[key] : fallback)

  // For fields keyed by a row id that gets renumbered on delete/reorder (e.g. product indexId,
  // service newIndexId): discard (never commit) any pending draft when the caller detects the
  // id sequence changed, so a stale timer can't land on whatever row now holds that old id.
  const clearAll = () => {
    Object.values(timersRef.current).forEach((timerId) => clearTimeout(timerId))
    timersRef.current = {}
    draftsRef.current = {}
    setDrafts({})
  }

  return { commit, handleChange, getValue, clearAll, draftsRef }
}

// A useState/useRef hook called inside ViewQuotation — even wrapped in a custom hook like the
// (now removed) useSingleDraftField — is still ViewQuotation's OWN state; its setter still
// re-renders the whole ~27k-line component. Custom hooks don't create a render boundary, only a
// separate component does. DraftTextField is that boundary: it owns the visible keystroke-by-
// keystroke value in ITS OWN local state, so typing re-renders only this small memoized
// component. The parent is kept in sync two ways, neither of which re-renders it: an out-of-band
// ref (topLevelDraftsRef, for Save/Save-as-Draft/submit to read synchronously) updated on every
// keystroke, and an eventual real commit (400ms pause or blur) via setFieldValue — that commit
// does cause one normal parent/Formik render, same as before, which is expected and cheap since
// it isn't repeated per character.
const DraftTextField = React.memo(function DraftTextField({
  fieldName,
  externalValue,
  resetToken,
  onDraftChange,
  onCommit,
  onBlurCommit,
  computeError,
  touched,
  charCounterMax,
  ...textFieldProps
}) {
  const [localValue, setLocalValue] = useState(externalValue)
  const timerRef = useRef(null)
  const lastResetTokenRef = useRef(resetToken)
  // true while localValue has been typed into and not yet committed — guards the passive
  // externalValue-follow effect below from clobbering an in-progress edit.
  const pendingRef = useRef(false)

  useEffect(() => {
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current)
    }
  }, [])

  // Genuine reset (quotation switched): discard any in-flight edit unconditionally and adopt the
  // freshly-loaded value, regardless of whether one was pending.
  useEffect(() => {
    if (lastResetTokenRef.current !== resetToken) {
      lastResetTokenRef.current = resetToken
      if (timerRef.current) {
        clearTimeout(timerRef.current)
        timerRef.current = null
      }
      pendingRef.current = false
      setLocalValue(externalValue)
      onDraftChange(fieldName, undefined)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resetToken])

  // Passive follow: while nothing is actively being typed here, keep mirroring the committed
  // Formik value (covers initial load and a delayed enableReinitialize catching up one render
  // after the resetToken effect above). Never overwrites an in-progress edit.
  useEffect(() => {
    if (!pendingRef.current) {
      setLocalValue(externalValue)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [externalValue])

  const commitNow = (value) => {
    if (timerRef.current) {
      clearTimeout(timerRef.current)
      timerRef.current = null
    }
    // Nothing pending (already committed by the timer, then blur fires a beat later, or vice
    // versa) — skip the redundant setFieldValue/render.
    if (!pendingRef.current) return
    pendingRef.current = false
    onCommit(fieldName, value)
  }

  const handleChange = (event) => {
    const nextValue = event.target.value
    setLocalValue(nextValue)
    pendingRef.current = true
    onDraftChange(fieldName, nextValue)
    if (timerRef.current) clearTimeout(timerRef.current)
    timerRef.current = setTimeout(() => commitNow(nextValue), 400)
  }

  const handleBlur = () => {
    commitNow(localValue)
    if (onBlurCommit) onBlurCommit(fieldName)
  }

  const liveError = computeError && touched ? computeError(localValue) : null
  const helperText = liveError
    || (charCounterMax != null ? `${localValue.length}/${charCounterMax} characters` : textFieldProps.helperText)

  return (
    <TextField
      {...textFieldProps}
      value={localValue}
      onChange={handleChange}
      onBlur={handleBlur}
      error={textFieldProps.error || Boolean(liveError)}
      helperText={helperText}
    />
  )
})

export default function ViewofficialRequest({popupOn,idOfProject,isEditEstimate,closeView,setRenderCards,renderCards,onDataChange, saveTrigger, closeAfterSave,projectEstimate,isOpenModal,setIsOpenModal,heading,setHeading = () => {}, headerStepBackRef, onExitEstimateEditMode}) {
  
    // console.log("tttttttttt22",isOpenModal);

  useEffect(() => {
  if(isOpenModal){
     if(isOpenModal)
      { 
        setTimeout(() => {
          setOpenInvoice(true)
      }, 3000);
    }
  }
  }, [isOpenModal])

  const [openEdit, setOpenEdit] = useState(false)
  console.log('openEditopenEdit',openEdit)
  console.log('projectEstimateprojectEstimate',projectEstimate)
  const autoCloseSaveRef = useRef(false);
  const rushFeeSyncRefs = useRef(createRushFeeSyncRefs());
  const autoSavingFieldRef = useRef(null);
  // When closing the fullscreen popup on a NON-draft estimate, we want to
  // wait for the normal save (edit-request) to finish and THEN close.
  const autoCloseAfterNormalSaveRef = useRef(false);
 const {COMPANY_LOGO,COMPANY_NAME} = useCompanyProfile()
  const theme = useTheme()
  const { id:ids } = useParams()
  const id =popupOn ? idOfProject :ids
  const location = useLocation()
  // Auto-open edit when navigated with state (e.g. after design → estimate convert).
  // fromDesignConvert is an object state, so it is truthy and still opens edit.
  let edit= popupOn ? isEditEstimate : !!(location.state && !location.state?.fromProjects && !location.state?.fromEstimateCalendar)
  const isFromProjects = location.state?.fromProjects || false
  const isFromEstimateCalendar = location.state?.fromEstimateCalendar || false
  const componentRef = useRef();
  const prevGroupFormulaTotalsRef = useRef({ product: {}, install: {} });
  const productInputValueRef = useRef(''); // Track product autocomplete input value for production builds
  const handlePrintEstimate = useReactToPrint({
    content: () => componentRef.current,
    pageStyle: `
      @page { size: A3; margin: 12mm; }
      body { font-family: 'Public Sans', sans-serif; font-size: 12pt; }
      table { width: 100%; border-collapse: collapse; }
      #right { text-align: right; margin-top: -200px; }
      #total { text-align: right; display:flex; justify-content: flex-end; }
      #subtotal { text-align: left; }
      #discount { text-align: left; word-wrap: break-word; margin-right: 100px; }
      #totalmain { text-align: left; }
      #subtotal1 { text-align: left; }
      #discount1 { text-align: left; word-wrap: break-word; margin-right: 30px; }
      #totalmain1 { text-align: left; }
      #total1 { text-align: right; display:flex; justify-content: flex-end; margin-top: -320px; }
      .quotation-heading-print { text-align: center; width: 100%; position: absolute; left: -60px; right: 0; top: -20px; }
      #logoImage { height: 100px; width:100px; }
      #order, #title, #orderID, #to { margin-bottom:-20px; }
    `,
  });
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar();
  const user = JSON.parse(localStorage.getItem('user'))
  const [currentRFQData, setCurrentRFQdata] = useState({})
  console.log('currentRFQDataaaa', currentRFQData)
  const [showProgressModal, setShowProgressModal] = useState(false);
  const [createJob, setCreateJob] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [progressRequestData, setProgressRequestData] = useState(null);
  const [socketReady, setSocketReady] = useState(false);
  const [socket, setSocket] = useState(null);
  const [showServices, setShowServices] = useState(true)
  const [selectedProducts, setSelectedProducts] = useState([])
  const [customerOrderProductGroups, setCustomerOrderProductGroups] = useState([])
  console.log('selectedProductsssssssss', selectedProducts)
  const [initialServiceCostInProductFormula, setInitialServiceCostInProductFormula] = useState(0)
  const [markupType, setMarkupType] = useState();
  const [clientApprove, setClientApprove] = useState();
  const [managerApprovalRequired, setManagerApprovalRequired] = useState(0);
  const [designs, setDesigns] = useState([])
  const [details, setDetails] = useState(null)
  const [skills, setSkill] = useState(null)
  const [workflow, setWorkFlow] = useState(null)
  const [allProducts, setAllproducts] = useState(null)
  console.log('allProductsssssssss', allProducts)
  const [invoice, setInvoice] = useState(null)
  const [open, setIsOpen] = useState(false)
  const [totalsum, setTotalSum] = useState(0);
  const [rfqSubTotal, setRFQSubTotal] = useState(0);
  const [DiscountTotal, setDiscountTotal] = useState(0);
  const [totalWholesalePrice, setTotalWholesalePrice] = useState(0);
  const [totalRetailPrice, setTotalRetailPrice] = useState(0);
  const [totalProductFormula, setTotalProductFormula] = useState(0);
  const [addClient, setAddClient] = useState(false)
  const [addVendor, setAddVendor] = useState(false)
  const [addProposal, setAddProposal] = useState(false)
  const [openInvoice, setOpenInvoice] = useState(false)
  const [requestAccept,setRequestAccept] = useState(false)
  const [requestReject,setRequestReject] = useState(false)
  const [allClients, setAllClients] = useState(null)
  const [allClientsEdit, setAllClientsEdit] = useState(null)
  const [customerData, setCustomerData] = useState([])
  const [openSignAgreements, setOpenSignAgreements] = useState(false)
  const [currentDate, setCurrentDate] = useState(moment().format('YYYY-MM-DD'));
  const [currentTab, setCurrentTab] = useState(user.isVendor ? 'Details' : 'Estimate Details')
  const {
    hasNew: designNotesHasNew,
    clearNew: clearDesignNotesNew,
  } = useJobNoteTabUnread({
    requestId: id,
    designOrderId: details?.design_order_id || null,
    noteType: 'design',
    userId: user?.user_id,
    // Wait for details so design_order_id is known — avoids NEW flash on open
    enabled: !user?.isVendor && details != null,
    isActiveTab: currentTab === 'Design Notes',
    activeTab: currentTab,
  })
  const {
    hasNew: jobNotesHasNew,
    clearNew: clearJobNotesNew,
  } = useJobNoteTabUnread({
    requestId: id,
    designOrderId: details?.design_order_id || null,
    noteType: 'job',
    userId: user?.user_id,
    enabled: !user?.isVendor && details != null,
    isActiveTab: currentTab === 'Job Notes',
    activeTab: currentTab,
  })
  const [openPreview, setOpenPreview] = useState(false)
const [openProductFormulaModal, setOpenProductFormulaModal] = useState(false);
const [selectedProductFormulaId, setSelectedProductFormulaId] = useState(null);
  // console.log("aaaaaaaa",details?.name);
 useEffect(() => {
if (typeof setHeading === 'function') {
setHeading(details?.name);
} 
}, [details?.name, setHeading]);

  const isProposal =
  (currentFacilityId === 3) &&
  !(
    ((details?.is_request_estimate == 1 &&
      details?.hold == 0 &&
      details?.estimate_job_status == 3 &&
      details?.quotation_status == 3) ||
      (details?.is_request_estimate == 0 &&
        details?.quotation_status != 4)) &&
    details?.send_to_client == 0
  );

  useEffect(() => {
    if (!user?.isVendor && details) {
      const showProposalDetails = isProposal
      setCurrentTab(showProposalDetails ? 'Proposal Details' : 'Estimate Details')
    }
  }, [details, user?.isVendor])

  const [avatarUrl,setAvatarUrl] = useState([])
  const [isUploading,setIsUploading] = useState(false)
  const [productAttachments, setProductAttachments] = useState({})
  const [isUploadingProduct, setIsUploadingProduct] = useState({})
  const [productAttachmentDragOver, setProductAttachmentDragOver] = useState({})
  const [attachmentTabValue, setAttachmentTabValue] = useState({})
  const [selectedUploadedImages, setSelectedUploadedImages] = useState({})
  const [openProductAttachment, setOpenProductAttachment] = useState({})
  const [serviceAttachments, setServiceAttachments] = useState({})
  const [isUploadingService, setIsUploadingService] = useState({})
  const [serviceAttachmentDragOver, setServiceAttachmentDragOver] = useState({})
  const [attachmentTabValueService, setAttachmentTabValueService] = useState({})
  const [selectedUploadedImagesService, setSelectedUploadedImagesService] = useState({})
  const [openServiceAttachment, setOpenServiceAttachment] = useState({})
  const [serviceRowErrors, setServiceRowErrors] = useState({})
  const [servicePickerOpen, setServicePickerOpen] = useState(false)
  const [servicePickerRowNewIndexId, setServicePickerRowNewIndexId] = useState(null)
  const [servicePickerDraft, setServicePickerDraft] = useState(null)
  const [selectedPDF, setSelectedPDF] = useState(null)
  const [openPDFModal, setOpenPDFModal] = useState(false)
  const [pdfLoading, setPdfLoading] = useState(true)
  const [useOfficeViewer, setUseOfficeViewer] = useState(true)
  const [openDelete,setOpenDelete] = useState(false)
  const [openCancelNoJobConfirm, setOpenCancelNoJobConfirm] = useState(false)
  const [reOpen,setReopen] = useState(false)
  const [convertRfq,setConvertRfq] = useState(false)
  const [convertDesignOrder,setConvertDesignOrder] = useState(false)
  const [confirmInvoice,setConfirmInvoice] = useState(false)
  const [confirmManagerAccept, setConfirmManagerAccept] = useState(false)
  const [invoiceReject,setRejectInvoice] = useState(false)
  const [rejectInvoiceLoading,setRejectInvoiceLoading] = useState(false)
  const [openHoldEstimate, setOpenHoldEstimate] = useState(false)
  const [holdEstimateLoading, setHoldEstimateLoading] = useState(false)
  const holdSubmitInProgressRef = useRef(false)
  const [holdReason, setHoldReason] = useState('')
  const [holdReasonError, setHoldReasonError] = useState('')
  const [openVoid, setOpenVoid] = useState(false)
  const [openReopenVoid, setOpenReopenVoid] = useState(false)
  const [voidReason, setVoidReason] = useState('')
  const [voidReasonError, setVoidReasonError] = useState('')
  const [loadingVoid, setLoadingVoid] = useState(false)
  const [loadingReopenVoid, setLoadingReopenVoid] = useState(false)
  const [openInvoiceEmailModal, setOpenInvoiceEmailModal] = useState(false);
  const [invoicePdfData, setInvoicePdfData] = useState(null);
  // Print/preview ready only after products fetch + requestServices (additional services) are wired
  const [invoicePreviewReady, setInvoicePreviewReady] = useState(false);
  // const [reqAcceptClient,setReqAcceptClient] = useState(false)
  const [reason,setReason] = useState('')
  const [rejectFile, setRejectFile] = useState(null)
  const [isUploadingRejectFile, setIsUploadingRejectFile] = useState(false)
  const [acceptedClients,setAcceptedClients] = useState(null)
  const [updates,setUpdates] = useState(null)
  const [isSaving,setIsSaving] = useState(false)
  const [previewData,setPreviewData] = useState({})
  const [locationStates, setLocationStates] = useState({});
  const [openGroupedRows, setOpenGroupedRows] = useState({})
  const [groupProductMarketingValues, setGroupProductMarketingValues] = useState({})
  const [groupInstallMarketingValues, setGroupInstallMarketingValues] = useState({})
  console.log('groupProductMarketingValues=====',{ groupProductMarketingValues :groupProductMarketingValues ,groupInstallMarketingValues :groupInstallMarketingValues})
  const [groupProductRetailDrafts, setGroupProductRetailDrafts] = useState({})
  const [groupInstallRetailDrafts, setGroupInstallRetailDrafts] = useState({})
  const [groupNoteTargets, setGroupNoteTargets] = useState({})
  const [groupInstallNoteTargets, setGroupInstallNoteTargets] = useState({})
  const [groupAttachmentTargets, setGroupAttachmentTargets] = useState({})
  const [openGroupProductNoteIndex, setOpenGroupProductNoteIndex] = useState(null)
  const [openGroupInstallNoteIndex, setOpenGroupInstallNoteIndex] = useState(null)
  const [groupEditMode, setGroupEditMode] = useState({})
  const [groupSelectedProductIds, setGroupSelectedProductIds] = useState([])
  const [addToGroupId, setAddToGroupId] = useState(null)
  const [openAddToGroupModal, setOpenAddToGroupModal] = useState(false)
  const [openGroupCatalogSourceModal, setOpenGroupCatalogSourceModal] = useState(false)
  const [groupCatalogSourceIndexId, setGroupCatalogSourceIndexId] = useState(null)
  const [groupCatalogCustomSourceId, setGroupCatalogCustomSourceId] = useState(null)
  const [customCatalogGroupSources, setCustomCatalogGroupSources] = useState([])
  const [groupCatalogSourceInputValue, setGroupCatalogSourceInputValue] = useState('')
  const [showGroupCatalogCreateForm, setShowGroupCatalogCreateForm] = useState(false)
  const [groupCatalogCustomName, setGroupCatalogCustomName] = useState('')
  const [groupCatalogCustomDescription, setGroupCatalogCustomDescription] = useState('')
  const [groupCatalogCreateError, setGroupCatalogCreateError] = useState('')
  const [groupProductQuantityDrafts, setGroupProductQuantityDrafts] = useState({})
  const [payments,setPayments]= useState(null)
  const [projectTypes, setProjectTypes] = useState([]);
  const [agreements, setAgreements] = useState([]);
  const [projectCategories, setProjectCategories] = useState([]);
  const [communities, setCommunities] = useState([]);
  const [allCommunities, setAllCommunities] = useState([]);
  const [salesRepName, setSalesRepName] = useState('');
  const [salesRepId, setSalesRepId] = useState(null);
  const [salesRepOptions, setSalesRepOptions] = useState([]);
  const [allSalesRepIds, setAllSalesRepIds] = useState('');
  const [collaborators, setCollaborators] = useState([]);
  const [teamMembersOptions, setTeamMembersOptions] = useState([]);
  const [teamMembersLoading, setTeamMembersLoading] = useState(false);
  const [jobNoteMembers, setJobNoteMembers] = useState(null);
  const [isMember, setIsMember] = useState(false);
  const [refresh,setRefresh]=useState(false)
  const [refreshData,setRefreshData]=useState(false)
  const [justSubmittedEstimate,setJustSubmittedEstimate]=useState(false)
  const [openUpdateRequestConfirm, setOpenUpdateRequestConfirm] = useState(false)
  const [openSaveEstimateConfirm, setOpenSaveEstimateConfirm] = useState(false);
  const ref = useRef()
  const saveAsDraftRef = useRef(false)
  const updateRequestClickedRef = useRef(false)
  const latestEditDraftRef = useRef(null)
  const [openWorkflow,setWorkflowOpen]=useState(false)
  const [manual, setManual] = useState(false)
  const [signAgreements,setSignAgreements] = useState(null)
  const [portfolio,setPortfolio] = useState(null)
  const [customTemplate,setCustomTemplate] = useState(null)
  const [questionnaireTemplate,setQuestionnaireTemplate] = useState(null)
  const [allDataEmpty,setDataEmpty]=useState(true)
  const [proposalData,setProposalData]=useState(null)
  const [teamMembers,setTeamMember] = useState([])
  const [productAttached,setProductAttached] = useState([])
  const [labourCostServices, setLabourCostServices] = useState([])
  const [allEstimators, setAllEstimators] = useState([])
  const [selectedEstimators, setSelectedEstimators] = useState([])
  const [selectedServices, setSelectedServices] = useState([]);
  const [invoiceSelectedServices, setInvoiceSelectedServices] = useState([]);
  const [filteredServices, setFilteredServices] = useState([])
  const [requestServices, setRequestServices] = useState([])
  const [loading,setLoading]=useState(false)
  const [isLoadingProducts, setIsLoadingProducts] = useState(false)
  const [budget,setBudget]=useState(0)
  const [totalMarkupPercentage,setTotalMarkupPercentage]=useState(0)
  const [totalMarkupAmount,setTotalMarkupAmount]=useState(0)
  const [isSubmitted, setIsSubmitted] = useState(false);    const [labourInstallService, setLabourInstallService] = useState([]);
  const [designersList, setDesignersList] = useState([])
  const [produtFormulaMaterial,setProductFormulaMaterial] = useState([])
  const [refreshCalculation,setRefreshCalculation] = useState(false)
  const [openDuplicate,setOpenDuplicate] = useState(false)
  const [settingsAnchorEl, setSettingsAnchorEl] = useState(null)
  const [progressHeading, setProgressHeading] = useState("Processing Estimate"); 
  const [salesRepCommunity,setSalesRepCommunity] = useState(null)
  const [allTeamMembers, setAllTeamMembers] = useState([])
  const socketRef = useRef(null)
  const [onlineUsers, setOnlineUsers] = useState([])
  console.log('allTeamMembersallTeamMembers', allTeamMembers)
  const [additionalSelectedServices, setAdditionalSelectedServices] = useState([]);
  const [estimateCatalogServices, setEstimateCatalogServices] = useState([])
  const estimateServiceAutofillDoneRef = useRef(false)
  const estimatorsHydratedFromDetailsRef = useRef(false)
  const [serviceIndexCounter, setServiceIndexCounter] = useState(0);
  const [newproductformulacost,setNewproductformulacost] = useState('')
  localStorage.setItem('requestId',id?id:null)
  let isClient =user?.isClient
  let userType=isClient ? 3 : user.user_type
  console.log('userTypeisClient', userType)
  let userId=user.user_id
  let teamId=user.team_id||null;
  if(user.added_by_client && user.parent_user_type && user.parent_id) {
    userId = user.parent_id
    userType =3 //user.parent_user_type
  }


  const explodedPermissions = user?.exploded_permissions
  const hasMarkupPermission=explodedPermissions?.some(permission => ['View Markup'].includes(permission)) ? true : false
  const hasDiscountPermission = explodedPermissions?.some(permission => ['Manage Discount'].includes(permission)) ? false : true
  const hasViewCostPermission = explodedPermissions?.some((permission) =>
    ['View Estimate Cost'].includes(permission),
  )
  const canViewCosts = !!hasViewCostPermission
  const fetchTeamMembersForCollaborators = async () => {
    if (!userId) return; // Guard: don't fetch if userId is not available
    setTeamMembersLoading(true);
    try {
      const res = await axios.post(`${REST_API_END_POINT}teams/get-all-teams-data-collaborators`, {
        usersId: userId,
        usersType: userType,
        isClient: isClient || false,
        page: 1,
        rowsPerPage: 5000,
        orderBy: 'name',
        order: 'asc',
      });
      const raw = res.data?.team_members?.data || res.data?.team_members || [];
      const list = Array.isArray(raw) ? raw : [];
      const filteredList = list.filter(member => member.userRole !== "Development" && member.user_type !== 51);
      setTeamMembersOptions(filteredList);
      setAllTeamMembers(filteredList);
    } catch (error) {
      console.log(error, 'Error fetching team members for collaborators');
      setTeamMembersOptions([]);
    } finally {
      setTeamMembersLoading(false);
    }
  };

  // Fetch team members on mount
  useEffect(() => {
    if (userId) {
      fetchTeamMembersForCollaborators();
    }
  }, []);

  useEffect(() => {
    if (!socketRef.current) {
      // OLD CODE (keep for future restore):
      // socketRef.current = io(REST_API_IO, { path: "/socket.io", transports: ["websocket", "polling"], secure: true });
      socketRef.current = createAppSocket();
    }
    if (user?.user_id && socketRef.current && id) {
      socketRef.current.emit("request-online-user", { userId: user.user_id, requestId: id });
      socketRef.current.emit("get-request-online-users", { requestId: id });
    }
    if (socketRef.current) {
      socketRef.current.on("update-request-online-users", (payload) => {
        if (!payload) return;
        const { requestId, users } = payload;
        if (String(requestId) !== String(id)) return;
        setOnlineUsers((users || []).map(String));
      });
    }
    return () => {
      if (socketRef.current && user?.user_id && id) {
        socketRef.current.emit("leave-request", { userId: user.user_id, requestId: id });
      }
      if (socketRef.current) socketRef.current.off("update-request-online-users");
    };
  }, [user?.user_id, id]);

  // Sync collaborators from details when team members options load
  useEffect(() => {
    if (teamMembersOptions && teamMembersOptions.length > 0) {
      const collaboratorsData = details?.collaborators || currentRFQData?.collaborators || '';
      if (collaboratorsData) {
        const collaboratorIds = String(collaboratorsData).split(',').map(id => id.trim()).filter(Boolean);
        const matchedCollaborators = teamMembersOptions.filter(member => 
          collaboratorIds.includes(String(member.id))
        );
        setCollaborators(matchedCollaborators);
      } else {
        setCollaborators([]);
      }
    }
  }, [teamMembersOptions, details, currentRFQData, allTeamMembers]);

  const accessForApproveEstimateForClient = explodedPermissions?.some((permission) =>
    ['Approve Estimate For Client'].includes(permission),
  )
  const accessForSendEstimateToClient = explodedPermissions?.some((permission) =>
    ['Send Estimate To Client'].includes(permission),
  )
  const [showWarning, setShowWarning] = useState(selectedServices.map(() => false));
  const [allLocationSame, setAllLocationSame] = useState(false)
  const [indexCounter, setIndexCounter] = useState(0)
  const [indexCounterService, setIndexCounterService] = useState(0)
  const [productRows, setProductRows] = useState([]);
  console.log(productRows,'productRows')
  const [serviceRows, setServiceRows] = useState([{ indexId: 1, service_name: '', service_desc: '', price: 0, retail_price: 0, is_service_row: 1, backendId: null,facility_id:currentFacilityId }]);
  const [rowErrors, setRowErrors] = useState({});
  const [productRowsIndexCounter, setProductRowsIndexCounter] = useState(1);
  const [serviceRowsIndexCounter, setServiceRowsIndexCounter] = useState(1);
  const [catalogPickerOpen, setCatalogPickerOpen] = useState(false)
  const [catalogPickerRowIndexId, setCatalogPickerRowIndexId] = useState(null)
  const [catalogPickerDraft, setCatalogPickerDraft] = useState(null)
  const [productRowErrors, setProductRowErrors] = useState({})
  const [autoSavingField, setAutoSavingField] = useState(null); // Track which field is being auto-saved: { indexId, field: 'name' | 'desc' }
  const originalValuesRef = useRef({}); // Track original values when field is focused
  const debounceTimerRef = useRef(null); // Debounce timer for auto-save after typing
  let productFormulaCost=0
  const [totalLabourCost, setTotalLabourCost] = useState(0)
  const [totalProductLabourCost, setTotalProductLabourCost] = useState(0)
  const [rfps, setRfps] = useState([]); // List of RFPs
  const [selectedRfp, setSelectedRfp] = useState(null); // Selected RFP
  const [openModal, setOpenModal] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);
  const [rfpServices, setRfpServices] = useState([]);
  const [rfpProducts, setRfpProducts] = useState([]);
  const [cart, setCart] = useState([]);
  console.log('cartcart', cart)
  const [cartService, setCartService] = useState([]);
  const [rfpServicesEdit, setRfpServicesEdit] = useState([]);
  const [rfpLocationStates, setRfpLocationStates] = useState({});
  const [selectedMaterials, setSelectedMaterials] = useState([]);
  const [materials, setAllMaterials] = useState([])
  const [openProductNote, setOpenProductNote] = useState({});
  const [openInstallNote, setOpenInstallNote] = useState({});
  const [openServiceNote, setOpenServiceNote] = useState({});
  const [openMaterialNote, setOpenMaterialNote] = useState({});
  const [isClearingNote, setIsClearingNote] = useState(false);
  const [isSavingNote, setIsSavingNote] = useState(false);
  const [currentNote, setCurrentNote] = useState('');
  const [error, setError] = useState(false);
  const [taxAmount, setTaxAmount] = useState(0);
  const [taxRateData, setTaxRateData] = useState([]);
  const fetchedTaxEstimateIdRef = useRef(null);
  const getTaxRateItems = (data = taxRateData) => {
    if (Array.isArray(data)) return data;
    if (Array.isArray(data?.items)) return data.items;
    return [];
  };
  const findMatchingTaxItem = (quickbookId, itemName) => {
    const items = getTaxRateItems();
    if (!items.length) return null;
    if (quickbookId) {
      const matched = items.find(item =>
        String(item.item_id) === String(quickbookId) ||
        String(item.qb_item_id) === String(quickbookId)
      );
      if (matched) return matched;
    }
    if (itemName) {
      return items.find(item =>
        item.item_name && String(item.item_name).toLowerCase() === String(itemName).toLowerCase()
      ) || null;
    }
    return null;
  };
  const findMatchingInstallTaxItem = () => {
    const items = getTaxRateItems();
    return items.find(item =>
      item.item_name && String(item.item_name).toLowerCase().includes('install')
    ) || null;
  };
  const findMatchingServiceTaxItem = (ser) => {
    const serviceQuickbookId = ser?.quickbookId || ser?.quickbook_id;
    const serviceName = ser?.service_name || ser?.name;
    return findMatchingTaxItem(serviceQuickbookId, serviceName);
  };
  const getTaxPercent = (matchingItem) => {
    if (matchingItem && matchingItem.tax_percent !== null && matchingItem.tax_percent !== undefined) {
      return matchingItem.tax_percent;
    }
    const totalPercent = taxRateData?.total_tax_percent ?? taxRateData?.total_tax_rate;
    if (totalPercent !== null && totalPercent !== undefined) {
      return totalPercent;
    }
    const items = getTaxRateItems();
    const found = items.find(item => item && item.tax_percent !== null && item.tax_percent !== undefined);
    if (found) return found.tax_percent;
    return '';
  };
  const shouldShowTaxIndicator = (matchingItem) => {
    const percent = getTaxPercent(matchingItem);
    if (percent === '' || percent === null || percent === undefined) return false;
    if (matchingItem?.is_taxable) return true;
    if (taxAmount != 0) return true;
    if (Number(taxRateData?.total_tax_amount) > 0) return true;
    return false;
  };
  // const renderTaxIndicator = (matchingItem) => (
  //   shouldShowTaxIndicator(matchingItem)
  //     ? <><span className="tabler--letter-t-small"></span> <br /> <span style={{ fontSize: '12px' }}> {getTaxPercent(matchingItem)}%</span></>
  //     : '-'
  // );
  const [grandTotal, setGrandTotal] = useState(0);
  const [selectedTaxCategory,setSelectedTaxCategory]=  useState(null);
  const [taxCategories,setTaxCategories]=  useState([]);
  const [data, setData] = useState({});
  const [isCommunityLoading, setIsCommunityLoading] = useState(false);
  const [mapServices,setMapServices]=  useState([]);
  const [mapServicesLoading, setMapServicesLoading] = useState(false);
  const [selectedMapserviceProducts, setSelectedMapserviceProducts] = useState([]);
  const [rfpServiceLocationStates, setRfpServiceLocationStates] = useState({});
  const [allRfpServiceLocationSame, setAllRfpServiceLocationSame] = useState(true)
  const [allRfpProductsLocationSame, setAllRfpProductsLocationSame] = useState(true)
  const [singleLocationCard,setSingleLocationCard] = useState(false);
    const [pendingAutocompleteMaterials, setPendingAutocompleteMaterials] = useState([]);
    const [openDialog,setOpenDialog] = useState(false);
    const [pendingProject, setPendingProject] = useState(null);
    const [stockType, setStockType] = useState(1);
    const [pendingMaterial, setPendingMaterial] = useState(null);
    const [partialProducts, setPartialProducts] = useState([]);
  // Track whether any field has been changed while in edit mode
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
    const [convertionUnit, setConvertionUnit] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [totalProductInstallCost, setTotalProductInstallCost] = useState(0)
    const [installCost, setInstallCost] = useState(0);
    const [incomingSplitMarkup,setIncomingSplitMarkup] = useState(0)
    const [splitPercentage,setSplitPerscentage] = useState(0)
    const [splitManagementSettings,setSplitManagementSettings] = useState([])
    const [isSplitOrder,setIsSplitOrder] = useState(false)
    const [selectedSplitOrderSettings,setSelectedSplitOrderSettings] = useState([])
    const [isOpenEdit, setIsOpenEdit] = useState(false)
    const handleMaterialStockCheck = async (material) => {
  setPendingMaterial(material);
  setStockType(1); // default to Finished
  setConvertionUnit(0);
  setPartialProducts([]);

  // if (material.inhouse !== 1) {
  //   enqueueSnackbar('Only inhouse materials can be stocked', { variant: 'warning' });
  //   return;
  // }

  try {
    const res = await axios.post(
      `${REST_API_END_POINT}product/get-partial-finished-products-stock-by-unit`, 
      { editId: material?.id }
    );
    const productListData = res.data.results;

    // Check if partial already selected for this material
    const alreadyPartialSelected = selectedMaterials.some(
      item => item.product_id === material.product_id && item.stock_type === 2
    );

    if (alreadyPartialSelected) {
      // Only allow finished, as partial already exists
      setPartialProducts([]);
      setStockType(1); // Force finished
      enqueueSnackbar('Partial stock already selected. Only Finished stock available.', { variant: 'info' });
    } else {
      setPartialProducts(productListData || []);
    }
  } catch (err) {
    console.error(err);
    setPartialProducts([]);
  } finally {
    openDialogs(); // open the stock type dialog
  }
};

const handleSubmitPopUp = () => {
  if (!pendingMaterial) return;

  if (stockType === 2 && !convertionUnit) {
    enqueueSnackbar('Please choose a conversion unit', { variant: 'error' });
    return;
  }

  const normalizedId = pendingMaterial.product_id || pendingMaterial.id;

  // Check if the same partial stock for this material already exists
  const alreadyHasPartial = selectedMaterials.some(
    (item) => item.product_id === normalizedId && item.stock_type === 2
  );

  if (stockType === 2 && alreadyHasPartial) {
    enqueueSnackbar('Partial stock type for this product already added', { variant: 'error' });
    return;
  }

  // Prevent exact duplicates
  const alreadyAdded = selectedMaterials.some(
    (item) =>
      item.product_id === normalizedId &&
      item.stock_type === stockType &&
      (stockType === 1 || item.convertion_unit === convertionUnit)
  );

  if (alreadyAdded) {
    enqueueSnackbar('Material Already Added', { variant: 'error' });
    return;
  }

  let initial_max_price = 0;
  let unit = 4;

  if (stockType === 1) {
    initial_max_price = pendingMaterial.max_price || pendingMaterial.special_price;
    unit = pendingMaterial.unit || 4;
  } else {
    const selectedUnitData = partialProducts.find(p => p.partial_unit === convertionUnit);
    if (!selectedUnitData || selectedUnitData.total_qty <= 0) {
      enqueueSnackbar('No Partial Stock Available', { variant: 'error' });
      return;
    }
    initial_max_price = selectedUnitData.max_unit_cost || 0;
    unit = selectedUnitData.partial_unit || 4;
  }

  const maxIndexId = Math.max(0, ...selectedMaterials.map(item => item.newIndexId || 0));

  const newMaterial = {
    ...pendingMaterial,
    product_id: normalizedId,
    quantity: 1,
    price: initial_max_price,
    unit,
    stock_type: stockType,
    convertion_unit: convertionUnit || 0,
    initial_max_price,
    newIndexId: maxIndexId + 1
  };

  const updatedMaterials = [...selectedMaterials, newMaterial];

  setPendingAutocompleteMaterials(updatedMaterials);
  setFieldValue('additionalMaterials', updatedMaterials);
  handleMaterial(updatedMaterials);
  setSelectedMaterials(updatedMaterials);

  setPendingMaterial(null);
  setPartialProducts([]);
  setStockType(1);
  setConvertionUnit(0);
  closeDialog();
};
    const closeDialog=()=>{
      setOpenDialog(false);
    }
    const openDialogs=()=>{
      setOpenDialog(true);
    }

  const accessPublicMessageBoard =  explodedPermissions?.some((permission) => ['Access Estimate Client Message Board'].includes(permission)) 

  // Manager-level permissions for Estimates
  const canEstimateManagerApprove = explodedPermissions?.some((permission) =>
    ['Estimate Manager Approve'].includes(permission),
  );
  const canEstimateManagerReject = explodedPermissions?.some((permission) =>
    ['Estimate Manager Reject'].includes(permission),
  );


  const fetchDetails = async () => {
    try {
      const res = await axios.post(`${REST_API_END_POINT}settings/get-companyProfile-details`);
      if (res.data.status === 1) {
        setData(...res.data.data);
      }
    } catch (error) {
      console.log('get-companyProfile-details error : ', error);
    }
  };

  useEffect(() => {
    fetchDetails();
    fetchProducts();
  }, []);

  // Clear popup-related localStorage when component mounts or URL changes
  useEffect(() => {
    // Clear popup state from localStorage to prevent popups from persisting
    localStorage.removeItem('estimateProjectId');
    localStorage.removeItem('estimateProjectName');
    localStorage.removeItem('isEditEstimate');
    localStorage.removeItem('estimateOpenProductionPopup');
    localStorage.removeItem('openProductionPopup');
  }, [id]); // Clear when ID changes (URL change)

  useEffect(() => {
    if (Array.isArray(jobNoteMembers) && user?.user_id) {
      const found = jobNoteMembers?.some(member => member.user_id === user.user_id);
      console.log('jobNoteMembers:', jobNoteMembers);
      console.log('user.user_id:', user.user_id);
      console.log('isMember found:', found);
      setIsMember(found);
    }
  }, [jobNoteMembers, user?.user_id]);

  const getGroupMemberIndexIdsByAnchor = (anchorIndexId) => {
    const anchor = (selectedProducts || []).find(
      (p) => Number(p?.indexId) === Number(anchorIndexId),
    )
    if (!anchor?.group_id) return [anchorIndexId]
    return (selectedProducts || [])
      .filter((p) => String(p?.group_id) === String(anchor.group_id))
      .map((p) => p?.indexId)
      .filter((id) => id != null)
  }

  const handleOpenNote = (indexId, note, applyToGroup = false) => {
    console.log('handleOpenNote====', indexId, note, applyToGroup)
    setCurrentNote(note || '');
    const key = String(indexId)
    if (applyToGroup) {
      setGroupNoteTargets((prev) => ({
        ...prev,
        [key]: getGroupMemberIndexIdsByAnchor(indexId),
      }))
    } else {
      setGroupNoteTargets((prev) => ({ ...prev, [key]: undefined }))
    }
    setOpenProductNote((prev) => ({ ...prev, [indexId]: true }));
  };

  const handleOpenGroupNote = (indexId, note) => {
    const key = String(indexId)
    setCurrentNote(note || '')
    setGroupNoteTargets((prev) => ({
      ...prev,
      [key]: getGroupMemberIndexIdsByAnchor(indexId),
    }))
    setOpenGroupProductNoteIndex(indexId)
  }

  const handleCloseNote = (indexId) => {
    setOpenProductNote((prev) => ({ ...prev, [indexId]: false }));
    setCurrentNote('');
  };

  const handleNoteChange = (event) => {
    const newNote = event.target.value;
    if (newNote.length <= MAX_CHARACTERS) {
      setCurrentNote(newNote);
    }
    if (error) {
      setError(false);
    }
  };

  const handleSaveNote = (indexId) => {
    if (!currentNote.trim()) {
      setError('Note cannot be empty or just spaces');
      return; // Exit early if validation fails
    }
    setIsSavingNote(true);
    setTimeout(() => {
      const targetIds = groupNoteTargets[String(indexId)] || [indexId]
      setSelectedProducts((prev) =>
        prev.map((product) =>
          targetIds.includes(product.indexId)
            ? { ...product, product_notes: currentNote }
            : product
        )
      );
      setIsSavingNote(false);
      handleCloseNote(indexId);
    }, 100);
  };

  // Clear product note and save empty value
  const handleClearNote = (indexId) => {
    setError(false);
    setIsClearingNote(true);
    setTimeout(() => {
      const targetIds = groupNoteTargets[String(indexId)] || [indexId]
      setSelectedProducts((prev) =>
        prev.map((product) =>
          targetIds.includes(product.indexId)
            ? { ...product, product_notes: '' }
            : product
        )
      );
      setCurrentNote('');
      setIsClearingNote(false);
    }, 100);
  };

  // Install notes handlers
  const handleOpenInstallNote = (indexId, note, applyToGroup = false) => {
    setCurrentNote(note || '');
    const key = String(indexId)
    if (applyToGroup) {
      setGroupInstallNoteTargets((prev) => ({
        ...prev,
        [key]: getGroupMemberIndexIdsByAnchor(indexId),
      }))
    } else {
      setGroupInstallNoteTargets((prev) => ({ ...prev, [key]: undefined }))
    }
    setOpenInstallNote((prev) => ({ ...prev, [indexId]: true }));
  };

  const handleOpenGroupInstallNote = (indexId, note) => {
    const key = String(indexId)
    setCurrentNote(note || '')
    setGroupInstallNoteTargets((prev) => ({
      ...prev,
      [key]: getGroupMemberIndexIdsByAnchor(indexId),
    }))
    setOpenGroupInstallNoteIndex(indexId)
  }

  const handleCloseInstallNote = (indexId) => {
    setOpenInstallNote((prev) => ({ ...prev, [indexId]: false }));
    setCurrentNote('');
  };

  const handleSaveInstallNote = (indexId) => {
    if (!currentNote.trim()) {
      setError('Note cannot be empty or just spaces');
      return; // Exit early if validation fails
    }
    setIsSavingNote(true);
    setTimeout(() => {
      const targetIds = groupInstallNoteTargets[String(indexId)] || [indexId]
      setSelectedProducts((prev) =>
        prev.map((product) =>
          targetIds.some((id) => Number(id) === Number(product.indexId))
            ? { ...product, install_notes: currentNote }
            : product
        )
      );
      setIsSavingNote(false);
      handleCloseInstallNote(indexId);
    }, 100);
  };

  // Clear install note and save empty value
  const handleClearInstallNote = (indexId) => {
    setError(false);
    setIsClearingNote(true);
    setTimeout(() => {
      const targetIds = groupInstallNoteTargets[String(indexId)] || [indexId]
      setSelectedProducts((prev) =>
        prev.map((product) =>
          targetIds.some((id) => Number(id) === Number(product.indexId))
            ? { ...product, install_notes: '' }
            : product
        )
      );
      setCurrentNote('');
      setIsClearingNote(false);
    }, 100);
  };

  // Service notes handlers
  const handleOpenServiceNote = (indexId, note) => {
    console.log("index.......1",indexId);
    console.log("index.......",note);
    setCurrentNote(note || '');
    setOpenServiceNote((prev) => {
      // Create a new object with all keys set to false except the one we want to open
      const updatedState = Object.keys(prev).reduce((acc, key) => {
        acc[key] = key === indexId; // Set true for the selected id, false for others
        return acc;
      }, {});
  
      return { ...updatedState, [indexId]: true }; // Ensure the selected index is true
    });
  };

  const handleCloseServiceNote = (indexId) => {
    setOpenServiceNote((prev) => ({ ...prev, [indexId]: false }));
    setCurrentNote('');
  };

  const handleServiceNoteChange = (event) => {
    const newNote = event.target.value;
    if (newNote.length <= MAX_CHARACTERS) {
      setCurrentNote(newNote);
    }
    if (error) {
      setError(false);
    }
  };
// Material notes handlers
  const handleOpenMaterialNote = (indexId, note) => {
    setCurrentNote(note || '');
    setOpenMaterialNote((prev) => ({ ...prev, [indexId]: true }));
  };
  const handleCloseMaterialNote = (indexId) => {
    setOpenMaterialNote((prev) => ({ ...prev, [indexId]: false }));
    setCurrentNote('');
  };
  const handleSaveMaterialNote = (indexId) => {
    if (!currentNote.trim()) {
      setError('Note cannot be empty or just spaces');
      return; 
    }
    setIsSavingNote(true);
    setTimeout(() => {
      setSelectedMaterials((prev) =>
        prev.map((material) =>
          material.newIndexId === indexId ? { ...material, material_notes: currentNote } : material
        )
      );
      setIsSavingNote(false);
      handleCloseMaterialNote(indexId);
    }, 100);
  };
  const handleSignAgreements = () => {
    setOpenSignAgreements(true)
  }
  const handleCloseSignAgreements = () => {
    setOpenSignAgreements(false)
  }

  const handleSaveServiceNote = (indexId) => {
    if (!currentNote.trim()) {
      setError('Note cannot be empty or just spaces');
      return; // Exit early if validation fails
    }
    setIsSavingNote(true);
    setTimeout(() => {
      // Update selectedServices
      setSelectedServices((prev) =>
        prev.map((service) =>
          serviceLineMatches(service, indexId) ? { ...service, service_notes: currentNote } : service
        )
      );
      // Update additionalSelectedServices
      setAdditionalSelectedServices((prev) =>
        prev.map((service) =>
          serviceLineMatches(service, indexId) ? { ...service, service_notes: currentNote } : service
        )
      );
      // Update cartService
      setCartService((prev) =>
        prev.map((service) =>
          serviceLineMatches(service, indexId) ? { ...service, service_notes: currentNote } : service
        )
      );
      setIsSavingNote(false);
      handleCloseServiceNote(indexId);
    }, 100);
  };
  // Clear material note and save empty value
  const handleClearMaterialNote = (indexId) => {
    setError(false);
    setIsClearingNote(true);
    setTimeout(() => {
      setSelectedMaterials((prev) =>
        prev.map((material) =>
          material.newIndexId === indexId ? { ...material, material_notes: '' } : material
        )
      );
      setCurrentNote('');
      setIsClearingNote(false);
    }, 100);
  };
  // Clear service note and save empty value
  const handleClearServiceNote = (indexId) => {
    setError(false);
    setIsClearingNote(true);
    setTimeout(() => {
      setSelectedServices((prev) =>
        prev.map((service) =>
          serviceLineMatches(service, indexId) ? { ...service, service_notes: '' } : service
        )
      );
      setAdditionalSelectedServices((prev) =>
        prev.map((service) =>
          serviceLineMatches(service, indexId) ? { ...service, service_notes: '' } : service
        )
      );
      setCartService((prev) =>
        prev.map((service) =>
          serviceLineMatches(service, indexId) ? { ...service, service_notes: '' } : service
        )
      );
      setCurrentNote('');
      setIsClearingNote(false);
    }, 100);
  };

  const handleRfpSelect = (event, value) => {
    setSelectedRfp(value);
    // Sort RFP services alphanumerically by name
    const filteredRfpServices = value?.services?.filter(service => !isInCartService(service)) || [];
    const sortedRfpServices = [...filteredRfpServices].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
    setRfpServices(sortedRfpServices);
    setRfpProducts(value?.products?.filter(product => !isInCart(product)) || []);
    if (!empty(value)) {
      setOpenModal(true);
    }
    // Selecting a proposal is an edit in estimate form.
    // if (openEdit && !hasUnsavedChanges) {
    //   setHasUnsavedChanges(true);
    //   if (typeof onDataChange === 'function') {
    //     onDataChange();
    //   }
    // }
  };

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };
  const handleSendClientReq = async()=>{
    try {
      const response = await axios.post(`${REST_API_END_POINT}quotation/send-to-client`,{request_id:details.id ,client:details?.customer_id, client_approve:details?.client_approve ,userId:user.user_id})
      if(response.data.status ===1){

        enqueueSnackbar('Success', { variant: 'success' })
        setRefresh(true)
      }else{
        enqueueSnackbar('Failed', { variant: 'error' })
      }
    } catch (error) {
      console.log("error",error)
    }
  }


  // const addToCart = (item) => {
  //   // Extract project location from Formik's values
  //   const { address: projAddress = '', city: projCity = '', state: projState = '', zip: projZip = '' } = values?.community || {};
  //   const communityAddress = {
  //     id: 0,
  //     address: projAddress,
  //     city: projCity,
  //     state: projState,
  //     zip: projZip,
  //   };
  
  //   if (tabIndex === 0) {
  //     // Handle RFP services
  //     const serviceWithLocation = {
  //       ...item,
  //       location: [communityAddress], // Assign project location to the service
  //     };
  
  //     setCartService((prevServices) => [...prevServices, serviceWithLocation]);
  //   } else {
  //     // Handle RFP products
  //     let location = [
  //       {
  //         id: 0,
  //         address: '',
  //         city: '',
  //         state: '',
  //         zip: '',
  //       },
  //     ];
  
  //     // Use project location if available
  //     if (projAddress && projCity && projState && projZip) {
  //       location = [communityAddress];
  //     }
  
  //     const productWithLocation = {
  //       ...item,
  //       location,
  //     };
  
  //     setCart((prevProducts) => [...prevProducts, productWithLocation]);
  //   }
  
  //   // Close modal and reset RFP selection
  //   setOpenModal(false);
  //   setSelectedRfp(null);
  //   setFieldValue('rfp', null);
  // };

  const addToCart = (item) => {
    // Extract project/community address
    const { address: projAddress = '', city: projCity = '', state: projState = '', zip: projZip = '' } = values?.community || {};
    const communityAddress = { address: projAddress, city: projCity, state: projState, zip: projZip };

    const locationQuantity = item.location_quantity || 1; // Ensure a default value of 1

    if (tabIndex === 1) {
        // ✅ Adding to RFP Services
        const newService = assignDefaultLocation(cartService, item, allRfpServiceLocationSame, communityAddress, locationQuantity);
        setCartService([...cartService, newService]);

        if (allRfpServiceLocationSame) {
            setCartService((prevServices) =>
                prevServices.map((service) => ({
                    ...service,
                    location: Array.from({ length: locationQuantity }, () => ({ ...communityAddress })),
                }))
            );
        }
    } else {
      // ✅ Adding to RFP Products
      // Always start with a single location; the Qty Location toggle will control count later
      const baseLocation = {
        id: 0,
        address: communityAddress.address || '',
        city: communityAddress.city || '',
        state: communityAddress.state || '',
        zip: communityAddress.zip || '',
      };

      const newProduct = {
        ...item,
        is_single_card: true,
        allRfpProductsLocationSame: true,
        location: [baseLocation],
      };

      setCart([...cart, newProduct]);
    }

    // ✅ Close modal and reset form fields
    setOpenModal(false);
    setSelectedRfp(null);
    setFieldValue('rfp', null);
  };

  const assignDefaultLocation = (existingItems, newItem, allLocationsSame, communityAddress) => {
    let assignedLocation = [];
  
    if (allLocationsSame && existingItems.length > 0) {
      // Use the first item's location as the common location
      const commonLocation = existingItems[0]?.location?.[0] || {
        address: '',
        city: '',
        state: '',
        zip: '',
      };
      assignedLocation = [{ ...commonLocation }];
    } else if (
      communityAddress.address &&
      communityAddress.city &&
      communityAddress.state &&
      communityAddress.zip
    ) {
      // Use the community address as the default location
      assignedLocation = [
        {
          id: 0,
          address: communityAddress.address,
          city: communityAddress.city,
          state: communityAddress.state,
          zip: communityAddress.zip,
        },
      ];
    } else {
      // Default to an empty location
      assignedLocation = [
        {
          id: 0,
          address: '',
          city: '',
          state: '',
          zip: '',
        },
      ];
    }
  
    return {
      ...newItem,
      location: assignedLocation,
    };
  };

  console.log("######################Cart", cart);
  console.log("######################Cart Service", cartService);
  const isInCart = (item) => {
    return cart.some(cartItem => cartItem.product_id === item.product_id);
  };
  const isInCartService = (item) => {
    return cartService.some(cartItem => cartItem.labour_cost_service_id
      === item.labour_cost_service_id);
  };
  const closeModal = () => {
    setOpenModal(false);
    setFieldValue('rfp',null)
  };
  const handleDeleteRFPProduct = (productId) => {
    setCart(prevCart => prevCart.filter(item => item.product_id !== productId));
    // if (openEdit && !hasUnsavedChanges) {
    //   setHasUnsavedChanges(true);
    //   if (typeof onDataChange === 'function') {
    //     onDataChange();
    //   }
    // }
  };
  const handleDeleteRFPService = (productId) => {
    console.log("######################Cartde", productId);
    setCartService(prevCart => prevCart.filter(item => item.labour_cost_service_id !== productId));
    // if (openEdit && !hasUnsavedChanges) {
    //   setHasUnsavedChanges(true);
    //   if (typeof onDataChange === 'function') {
    //     onDataChange();
    //   }
    // }
  };

  const handleMaterial = (newValue) => {
    setSelectedMaterials((prevMaterials) => {
      const additionals = prevMaterials?.filter(item => item.isAdditionalProduct == true);
      const baseIndex = prevMaterials?.length || 0;
      const updatedNewValue = newValue.map((item, idx) => ({
        ...item,
        newIndexId: baseIndex + 1,
        quantity:item.quantity ?? 1,
      }));
      return [...updatedNewValue, ...additionals];
    });
    // if (openEdit && !hasUnsavedChanges) {
    //   setHasUnsavedChanges(true);
    //   if (typeof onDataChange === 'function') {
    //     onDataChange();
    //   }
    // }
  };

  const handleDeleteMaterial = (id, indexId) => {
    const updatedMaterials = selectedMaterials?.filter((data) => {
      if (data?.isAdditionalProduct) {
        return data?.newIndexId !== indexId;
      }
      return data?.id !== id;
    });
    
    setSelectedMaterials(updatedMaterials);
    // if (openEdit && !hasUnsavedChanges) {
    //   setHasUnsavedChanges(true);
    //   if (typeof onDataChange === 'function') {
    //     onDataChange();
    //   }
    // }
    };
    console.log('productRowsproductRowsproductRows==',productRows)
    // Product rows handlers for request_estimate
    const addNewRequestEstimateProductRow = () => {
      const newIndexCounter = indexCounter + productRowsIndexCounter + 1;
      const newProdIndexCounter = productRowsIndexCounter + 1;
      setProductRowsIndexCounter(newProdIndexCounter);
      
      const newProduct = {
        indexId: newIndexCounter,
        product_name: '',
        product_desc: '',
        is_product_row: 1,
        isNewlyAddedProductRow: true,
      };
      
      setProductRows((prevRows) => [...prevRows, newProduct]);
    };

    const addNewRequestEstimateServiceRow = (isFromEdit = false) => {
      const newIndexCounter = indexCounterService + serviceRowsIndexCounter + 1;
      console.log("######################New Index Counter",indexCounterService,serviceRowsIndexCounter,'==',newIndexCounter,);
      const newProdIndexCounter = serviceRowsIndexCounter + 1;
      console.log("######################New Product Index Counter",newProdIndexCounter);
      setServiceRowsIndexCounter(newProdIndexCounter);
      
      const newProduct = {
        indexId: isFromEdit ? newProdIndexCounter : newIndexCounter,
        product_index: isFromEdit ? newProdIndexCounter : newIndexCounter,
        service_name: '',
        service_desc: '',
        is_service_row: 1,
        facility_id:currentFacilityId,
        addedByUserType: userType,
      };
      
      setServiceRows((prevRows) => [...prevRows, newProduct]);
    };

    useEffect(()=>{
      // Only reset manual rows in final review; draft/in-queue rows are loaded from the API.
      if(details?.is_request_estimate == 1 && details?.estimate_job_status == 3){
        setProductRows([])
        setServiceRows([])
        setProductRowsIndexCounter(0)
        setServiceRowsIndexCounter(0)
      }
      // BACKUP: previous logic — also cleared rows when estimate_job_status was null/0 (draft), which prevented product rows and estimate service auto-populate from loading.
      // if(details?.is_request_estimate == 1 && (!details?.estimate_job_status || details?.estimate_job_status == 3)){
      //   setProductRows([])
      //   setServiceRows([])
      //   setProductRowsIndexCounter(0)
      //   setServiceRowsIndexCounter(0)
      // }
    },[details])

    const handleDeleteRequestEstimateProduct = async (indexId, backendId = null, isFromReview = false) => {
      // Remove the errors
      setRowErrors({});
      console.log("######################Delete Request Estimate Product",indexId,backendId,isFromReview);

      // If row has a backendId, delete from backend first
      if (backendId && id) {
        try {
          const response = await axios.post(`${REST_API_END_POINT}request/update-product-row-estimate`, {
            requestId: id,
            productRow: { backendId },
            action: 'delete',
            userId: user.user_id,
            userType:userType
          });
          
          if (response.data.status !== 1) {
            enqueueSnackbar('Failed to delete product row from server.', { variant: 'error' });
            console.error('Failed to delete product row:', response.data);
            return;
          }
          enqueueSnackbar('Product row deleted successfully!', { variant: 'success' });
        } catch (error) {
          console.error('Error deleting product row:', error);
          enqueueSnackbar('Error deleting product row.', { variant: 'error' });
          return;
        }
      }

      // Update frontend state using functional update to avoid stale closure issues
      setProductRows((prevRows) => {
        if (prevRows.length > 1) {
          const updatedRows = prevRows.filter((row) => {
            if (backendId && row.backendId) {
              return row.backendId !== backendId;
            }
            return row.indexId !== indexId;
          });
          // Reassign the indexId (Sl No) to the remaining rows
          const renumberedRows = updatedRows.map((row, idx) => ({
            ...row,
            indexId: isFromReview ? indexCounter + idx + 1 :idx + 1,  // Recalculate Sl No based on row order
          }));

          // Update counter after state update
          setTimeout(() => setProductRowsIndexCounter(renumberedRows.length), 0);
          return renumberedRows;
        } else {
          if(details?.is_request_estimate == 1 && details?.estimate_job_status == 3){
            setTimeout(() => setProductRowsIndexCounter(0), 0);
            return [];
          } else {
            setTimeout(() => setProductRowsIndexCounter(1), 0);
            return [{ indexId: 1, product_name: '', product_desc: '', is_product_row: 1, backendId: null }];
          }
          // BACKUP: delete last product row on draft used empty array when !estimate_job_status || estimate_job_status == 3
          // if(details?.is_request_estimate == 1 && (!details?.estimate_job_status || details?.estimate_job_status == 3)){
          //   setTimeout(() => setProductRowsIndexCounter(0), 0);
          //   return [];
          // } else {
          //   setTimeout(() => setProductRowsIndexCounter(1), 0);
          //   return [{ indexId: 1, product_name: '', product_desc: '', is_product_row: 1, backendId: null }];
          // }
        }
      });
    };

    const handleDeleteRequestEstimateService = async (indexId, backendId = null, isFromReview = false) => {
      // Remove the errors
      setRowErrors({});

      // If row has a backendId, delete from backend first
      if (backendId && id) {
        try {
          const response = await axios.post(`${REST_API_END_POINT}request/update-service-row-estimate`, {
            requestId: id,
            productRow: { backendId },
            action: 'delete',
            userId: user.user_id
          });
          
          if (response.data.status !== 1) {
            enqueueSnackbar('Failed to delete service row from server.', { variant: 'error' });
            console.error('Failed to delete service row:', response.data);
            return;
          }
          enqueueSnackbar('Service row deleted successfully!', { variant: 'success' });
        } catch (error) {
          console.error('Error deleting service row:', error);
          enqueueSnackbar('Error deleting service row.', { variant: 'error' });
          return;
        }
      }

      // Update frontend state using functional update to avoid stale closure issues
      setServiceRows((prevRows) => {
        if (prevRows.length > 1) {
          const updatedRows = prevRows.filter((row) => {
            if (backendId && row.backendId) {
              return row.backendId !== backendId;
            }
            return row.indexId !== indexId;
          });
          // Reassign the indexId (Sl No) to the remaining rows
          const renumberedRows = updatedRows.map((row, idx) => ({
            ...row,
            indexId: isFromReview ? indexCounterService + idx + 1 : idx + 1,  // Recalculate Sl No based on row order
          }));

          // Update counter after state update
          setTimeout(() => setServiceRowsIndexCounter(renumberedRows.length), 0);
          return renumberedRows;
        } else {
          if(details?.is_request_estimate == 1 && details?.estimate_job_status == 3){
            setTimeout(() => setServiceRowsIndexCounter(0), 0);
            return [];
          } else {
            setTimeout(() => setServiceRowsIndexCounter(1), 0);
            return [{ indexId: 1, service_name: '', service_desc: '', is_service_row: 1, backendId: null }];
          }
          // BACKUP: delete last service row on draft — same condition as product row backup above
          // if(details?.is_request_estimate == 1 && (!details?.estimate_job_status || details?.estimate_job_status == 3)){
          //   setTimeout(() => setServiceRowsIndexCounter(0), 0);
          //   return [];
          // } else {
          //   setTimeout(() => setServiceRowsIndexCounter(1), 0);
          //   return [{ indexId: 1, service_name: '', service_desc: '', is_service_row: 1, backendId: null }];
          // }
        }
      });

      setAdditionalSelectedServices((prev) => {
        const filtered = (prev || []).filter((s) => {
          if (backendId != null && (s.id == backendId || s.backendId == backendId)) {
            return false
          }
          const sIdx = Number(s?.newIndexId ?? s?.indexId ?? s?.product_index)
          if (Number.isFinite(sIdx) && sIdx === Number(indexId) && isQuotationWriteService(s)) {
            return false
          }
          return true
        })
        const sorted = sortServicesByProductIndex(filtered)
        return sorted.map((service, idx) => {
          const lineNum = idx + 1
          return {
            ...service,
            indexId: lineNum,
            newIndexId: lineNum,
            product_index: lineNum,
          }
        })
      });

      setAdditionalSelectedServices((prev) => {
        const filtered = (prev || []).filter((s) => {
          if (backendId != null && (s.id == backendId || s.backendId == backendId)) {
            return false
          }
          const sIdx = Number(s?.newIndexId ?? s?.indexId ?? s?.product_index)
          if (Number.isFinite(sIdx) && sIdx === Number(indexId) && isQuotationWriteService(s)) {
            return false
          }
          return true
        })
        const sorted = sortServicesByProductIndex(filtered)
        return sorted.map((service, idx) => {
          const lineNum = idx + 1
          return {
            ...service,
            indexId: lineNum,
            newIndexId: lineNum,
            product_index: lineNum,
          }
        })
      });
    };

    const handleRequestEstimateProductNameChange = (indexId, value) => {
      setProductRows((prevRows) =>
        prevRows.map((row) =>
          row.indexId === indexId ? { ...row, product_name: value, name: value } : row,
        ),
      )
      // productRows update above stays synchronous (cheap, drives this field's own display).
      // The mirrored selectedProducts write is what's expensive (feeds grouping useMemos + the
      // totals useEffect), so route it through the existing Product Name draft/debounce instead
      // of committing it on every keystroke.
      handleProductNameDraftChange(indexId, value)
    };

    const handleRequestEstimateServiceNameChange = (indexId, value) => {
      setServiceRows((prevRows) => 
        prevRows.map(row => 
          row.indexId === indexId ? { ...row, service_name: value } : row
        )
      );
    };

    const handleRequestEstimateProductDescChange = (indexId, value) => {
      setProductRows((prevRows) => 
        prevRows.map(row => 
          row.indexId === indexId ? { ...row, product_desc: value } : row
        )
      );
    };

    const handleRequestEstimateServiceDescChange = (indexId, value) => {
      setServiceRows((prevRows) => 
        prevRows.map(row => 
          row.indexId === indexId ? { ...row, service_desc: value } : row
        )
      );
    };

    // Store original value when field is focused
    const handleFieldFocus = (indexId, fieldType, value) => {
      const key = `${indexId}-${fieldType}`;
      originalValuesRef.current[key] = value || '';
    };

    // Check if value has changed from original
    const hasFieldChanged = (indexId, fieldType, currentValue) => {
      const key = `${indexId}-${fieldType}`;
      const originalValue = originalValuesRef.current[key] || '';
      return (currentValue || '') !== originalValue;
    };

    // Debounced auto-save trigger
    const triggerDebouncedAutoSave = (row, fieldType) => {
      // Clear any existing timer
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
      
      // Set new timer for 1.5 seconds after typing stops
      debounceTimerRef.current = setTimeout(() => {
        handleProductRowAutoSave(row, fieldType, true);
      }, 1500);
    };

    const triggerDebouncedAutoSaveService = (row, fieldType) => {
      // Clear any existing timer
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
      
      // Set new timer for 1.5 seconds after typing stops
      debounceTimerRef.current = setTimeout(() => {
        handleServiceRowAutoSave(row, fieldType, true);
      }, 1500);
    };
    const syncEstimateJobAfterRowSave = async () => {
      if (Number(details?.is_request_estimate) !== 1 || !id) return;
      try {
        await axios.post(`${REST_API}webservice/request/create-or-update-estimate-job`, {
          requestId: id,
          userId: user.user_id,
          requestPartnerId: details?.rt_partner_id,
          fromAutosave : true
        });
      } catch (error) {
        console.error('Estimate job sync after row save failed:', error);
      }
    };

    // Auto-save product row to backend on blur or after typing stops
    // fieldType: 'name' or 'desc' to show specific message
    // fromDebounce: true if called from debounce timer
    const handleProductRowAutoSave = async (row, fieldType = 'name', fromDebounce = false) => {
      // Clear debounce timer if called from blur
      if (!fromDebounce && debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
        debounceTimerRef.current = null;
      }

      // Only auto-save if this is an existing estimate (has an id) and in edit mode
      if (!id || !openEdit) return;
      
      // Don't auto-save if both name and description are empty
      if ((row.product_name || '').trim() === '' && (row.product_desc || '').trim() === '') {
        return;
      }

      // Check if there are actual changes
      const currentValue = fieldType === 'name' ? row.product_name : row.product_desc;
      if (!hasFieldChanged(row.indexId, fieldType, currentValue)) {
        return; // No changes, don't save
      }

      // Don't auto-save if already saving (use ref for synchronous check)
      if (autoSavingFieldRef.current) return;

      // Set ref first for synchronous checking, then state for UI update
      const savingField = { indexId: row.indexId, field: fieldType };
      autoSavingFieldRef.current = savingField;
      setAutoSavingField(savingField);

      try {
        const successMessage = fieldType === 'name' ? 'Product name auto saved' : 'Product description auto saved';

        if (!row.backendId) {
          // New row - create it in backend
          const response = await axios.post(`${REST_API_END_POINT}request/update-product-row-estimate`, {
            requestId: id,
            productRow: row,
            action: 'create',
            userId: user.user_id,
            userType:userType
          });
          
          if (response.data.status === 1 && response.data.data?.backendId) {
            // Update the row with the new backendId
            const newBackendId = response.data.data.backendId
            setProductRows(prevRows =>
              prevRows.map(r =>
                r.indexId === row.indexId ? { ...r, backendId: newBackendId } : r
              )
            );
            setSelectedProducts((prev) =>
              prev.map((p) =>
                p.indexId === row.indexId ? { ...p, backendId: newBackendId } : p,
              ),
            );
            enqueueSnackbar(successMessage, { variant: 'success' });
            await syncEstimateJobAfterRowSave();
          } else {
            console.error('Failed to auto-save new product row:', response.data);
          }
        } else {
          // Existing row - update it in backend
          const response = await axios.post(`${REST_API_END_POINT}request/update-product-row-estimate`, {
            requestId: id,
            productRow: row,
            action: 'update',
            userId: user.user_id,
            userType:userType
          });
          
          if (response.data.status === 1) {
            enqueueSnackbar(successMessage, { variant: 'success' });
            await syncEstimateJobAfterRowSave();
          } else {
            console.error('Failed to auto-save product row:', response.data);
          }
        }
      } catch (error) {
        console.error('Error auto-saving product row:', error);
        enqueueSnackbar('Error auto-saving product row.', { variant: 'error' });
      } finally {
        // Update original value to current value after save (success or fail)
        const currentValue = fieldType === 'name' ? row.product_name : row.product_desc;
        originalValuesRef.current[`${row.indexId}-${fieldType}`] = currentValue || '';
        autoSavingFieldRef.current = null;
        setAutoSavingField(null);
      }
    };

    const handleServiceRowAutoSave = async (row, fieldType = 'name', fromDebounce = false) => {
      // Clear debounce timer if called from blur
      if (!fromDebounce && debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
        debounceTimerRef.current = null;
      }

      // Only auto-save if this is an existing estimate (has an id) and in edit mode
      if (!id || !openEdit) return;
      
      // Don't auto-save if both name and description are empty
      if ((row.service_name || '').trim() === '' && (row.service_desc || '').trim() === '') {
        return;
      }

      // Check if there are actual changes
      const currentValue = fieldType === 'name' ? row.service_name : row.service_desc;
      if (!hasFieldChanged(row.indexId, fieldType, currentValue)) {
        return; // No changes, don't save
      }

      // Don't auto-save if already saving (use ref for synchronous check)
      if (autoSavingFieldRef.current) return;

      // Set ref first for synchronous checking, then state for UI update
      const savingField = { indexId: row.indexId, field: fieldType };
      autoSavingFieldRef.current = savingField;
      setAutoSavingField(savingField);

      try {
        const successMessage = fieldType === 'name' ? 'Service name auto saved' : 'Service description auto saved';

        if (!row.backendId) {
          // New row - create it in backend
          const response = await axios.post(`${REST_API_END_POINT}request/update-service-row-estimate`, {
            requestId: id,
            productRow: row,
            action: 'create',
            userId: user.user_id
          });
          
          if (response.data.status === 1 && response.data.data?.backendId) {
            // Update the row with the new backendId
            setServiceRows(prevRows =>
              prevRows.map(r =>
                r.indexId === row.indexId ? { ...r, backendId: response.data.data.backendId } : r
              )
            );
            enqueueSnackbar(successMessage, { variant: 'success' });
            await syncEstimateJobAfterRowSave();
          } else {
            console.error('Failed to auto-save new product row:', response.data);
          }
        } else {
          // Existing row - update it in backend
          const response = await axios.post(`${REST_API_END_POINT}request/update-service-row-estimate`, {
            requestId: id,
            productRow: row,
            action: 'update',
            userId: user.user_id
          });
          
          if (response.data.status === 1) {
            enqueueSnackbar(successMessage, { variant: 'success' });
            await syncEstimateJobAfterRowSave();
          } else {
            console.error('Failed to auto-save service row:', response.data);
          }
        }
      } catch (error) {
        console.error('Error auto-saving service row:', error);
        enqueueSnackbar('Error auto-saving service row.', { variant: 'error' });
      } finally {
        // Update original value to current value after save (success or fail)
        const currentValue = fieldType === 'name' ? row.service_name : row.service_desc;
        originalValuesRef.current[`${row.indexId}-${fieldType}`] = currentValue || '';
        autoSavingFieldRef.current = null;
        setAutoSavingField(null);
      }
    };

    const addNewProductRow = () => {
      const newIndexCounter = Math.max(...(selectedProducts || []).map((row) => row.indexId || 0), indexCounter, 0) + 1
      setIndexCounter(newIndexCounter + 1)
      const newProduct = {
        ...createEmptyQuotationProductRow(
          newIndexCounter,
          values?.community,
          values?.project_category?.id,
        ),
        isNewlyAddedProductRow: true,
        ...(details?.is_request_estimate == 1
          ? { is_product_row: 1, isAdditionalProduct: false, product_write: 1 }
          : {}),
        addedByUserType: userType,
      }
      setSelectedProducts((prevProducts) => [...prevProducts, newProduct])
      setFieldValue('products', [...(selectedProducts || []), newProduct])
    };
  
    // const addNewServiceRow = () => {
    //   const { address: projAddress = '', city: projCity = '', state: projState = '', zip: projZip = '' } = values?.community || {};
    //   // Auto-populate addresses from the selected Project
    //   const newAddresses = [{
    //     id: 0,
    //     address: projAddress,
    //     city: projCity,
    //     state: projState,
    //     zip: projZip
    //   }];
  
    //   setAdditionalSelectedServices((prevServices) => {
    //     return [
    //       ...prevServices,
    //       {  
    //         id:null,
    //         newIndexId: prevServices?.length + 1,
    //         name: '', 
    //         avatarUrl: null,
    //         quantity: 1, 
    //         cost: 0,
    //         markup: 0, 
    //         workflow: null,
    //         originalMarkup: 0, 
    //         service_type: null,
    //         total_cost:0,
    //         product_total:0,
    //         allLocationSame: true,
    //         isAdditionalProduct:true,
    //         addresses: newAddresses,
    //       }
    //     ]
    //   });
    // };

    const addNewServiceRow = () => {
      setAdditionalSelectedServices((prevServices) => {
        const maxId = prevServices.reduce(
          (max, item) => Math.max(max, Number(item.newIndexId) || 0),
          0,
        )
        const newIndexId = maxId + 1
        const newService = {
          ...createEmptyQuotationServiceRow(newIndexId, values?.community),
          isNewlyAddedServiceRow: true,
          addedByUserType: userType,
        }
        estimateServiceAutofillDoneRef.current = false
        const updated = [...prevServices, newService]
        setFieldValue('services', updated)
        setServiceIndexCounter((c) => Math.max(c, newIndexId))
        return updated
      })
    };
    
  
    // const addNewMaterialRow = () => {
    //   setSelectedMaterials((prevProducts) => {
    //   return [
    //   ...prevProducts,
    //   { 
    //     newIndexId: prevProducts?.length + 1,
    //     quantity: 1, 
    //     allLocationSame: true,
    //     isAdditionalProduct:true,
    //     description: '',
    //     finishedProductQty: 0,
    //     markUpCost: 0,
    //     markup: 0,
    //     material_types: 1,
    //     max_price: null,
    //     max_value: 10,
    //     meterial: 1,
    //     min_value: 1,
    //     name: '',
    //     partial: 0,
    //     partialProductQty: 0,
    //     pf_retail_markup: null,
    //     price: 0,
    //     recipe_id: null,
    //     retail_price: 0,
    //     special_price: 0,
    //     tags: '',
    //     tax: null,
    //     tax_category: 0,
    //     total_qty: 0,
    //     twilio_field_value_sid: null,
    //     unit: 4,
    //     unit_qty: 0,
    //     vendor_id: '',
    //     vpt_number: '',
    //     workflow: null,
    //   },
    //   ]});
    // };
    

    const addNewMaterialRow = () => {
      setSelectedMaterials((prevProducts) => {
        const maxId = prevProducts.reduce(
          (max, item) => Math.max(max, item.newIndexId || 0),
          0
        );
    
        return [
          ...prevProducts,
          {
            newIndexId: maxId + 1,
            quantity: 1,
            allLocationSame: true,
            isAdditionalProduct: true,
            description: '',
            finishedProductQty: 0,
            markUpCost: 0,
            product_retail_price:0,
            markup: 0,
            material_types: 1,
            max_price: null,
            max_value: 10,
            meterial: 1,
            min_value: 1,
            name: '',
            partial: 0,
            partialProductQty: 0,
            pf_retail_markup: null,
            price: 0,
            product_price:0,
            recipe_id: null,
            retail_price: 0,
            special_price: 0,
            tags: '',
            tax: null,
            tax_category: 0,
            total_qty: 0,
            twilio_field_value_sid: null,
            unit: 4,
            unit_qty: 0,
            vendor_id: '',
            vpt_number: '',
            workflow: null,
          }
        ];
      });
    };
    


  const VALUE = [
    { id: 0, value: 'Sl No.' },
    { id: 24, value: 'Mode' },
    { id: 22, value: 'Qb' },
    { id: 1, value: 'Products' },
    { id: 25, value: 'Description' },
    { id: 2, value: 'Note' },
    { id: 19, value: 'Attachments' },
    // { id: 3, value: 'Product formula cost (Material cost + Service cost with markup)' },
    { id: 3, value: 'Product Formula' },
    { id: 4, value: 'Product formula cost Each' },
    { id: 20, value: 'Markup (%)' },
    { id: 16, value: 'Split Markup' },
    { id: 5, value: markupType ? ((markupType == 2 && hasMarkupPermission) ? 'Retail Price Each' : null) : null },
    { id: 6, value: markupType ? ((markupType == 1 && hasMarkupPermission) ? 'Retail Price Each' : null) : null },
    // { id: 14, value: hasMarkupPermission ? 'SPMA' : null },
    // { id: 7, value: hasMarkupPermission ? 'Markup (%)' : null },
    // { id: 8, value: 'Unit' },
    { id: 9, value: 'Quantity' },
    { id: 10, value: 'Location' },
    // { id: 11, value: 'Discount' },
    { id: 11, value: 'Marketing Adjustment Type' },
    { id: 15, value: 'Marketing Adjustment' },
    { id: 12, value: 'Subtotal' },
    { id: 14, value: 'Product Total' },
    { id: 13, value: '' }
  ];

  const VIEW_QUOTATION_PRODUCT_TABLE_COL_SX = {
    productName: {
      minWidth: 220,
      width: 220,
      maxWidth: 220,
      verticalAlign: 'top',
      overflow: 'hidden',
    },
    productDesc: {
      minWidth: 240,
      width: 240,
      maxWidth: 240,
      verticalAlign: 'top',
      overflow: 'hidden',
    },
  };
  const getViewQuotationProductTableColSx = (colId) => {
    if (colId === 1) return VIEW_QUOTATION_PRODUCT_TABLE_COL_SX.productName;
    if (colId === 25) return VIEW_QUOTATION_PRODUCT_TABLE_COL_SX.productDesc;
    return undefined;
  };
  const getViewQuotationServiceTableColSx = (colId) => {
    if (colId === 1) return VIEW_QUOTATION_PRODUCT_TABLE_COL_SX.productName;
    if (colId === 11) return VIEW_QUOTATION_PRODUCT_TABLE_COL_SX.productDesc;
    return undefined;
  };
  
  const VALUEPreview = [
    { id: 0, value: 'Sl No.' },
    { id: 1, value: 'Products' },
    // { id: 2, value: 'Product formula cost (Material cost + Service cost with markup)' },
    { id: 3, value: markupType ? ((markupType == 2 && hasMarkupPermission) ? 'Retail Price Each' : null) : null },
    { id: 4, value: markupType ? ((markupType == 1 && hasMarkupPermission) ? 'Retail Price Each' : null) : null },
    { id: 14, value: hasMarkupPermission ? 'SPMA' : null },
    { id: 5, value: hasMarkupPermission ? 'Markup (%)' : null },
    // { id: 6, value: 'Unit' },
    { id: 7, value: 'Quantity' },
    // { id: 8, value: 'Discount' },
    { id: 11, value: 'Marketing Adjustment Type' },
    { id: 8, value: 'Marketing Adjustment' },
    { id: 9, value: 'Subtotal' },
    { id: 14, value: 'Product Total' },
    { id: 10, value: '' }
  ]

  const VALUE_SERVICES = [
    { id: 0, value: 'Sl No.' },
    { id: 24, value: 'Mode' },
    { id: 22, value: 'Qb' },
    { id: 1, value: 'Service Name' },
    { id: 11, value: 'Service Description' },
    { id: 2, value: 'Notes' },
    { id: 19, value: 'Attachments' },
    { id: 3, value: 'Markup (%)' },
    { id: 4, value: 'Cost (Hourly)' },
    { id: 5, value: 'Markup Cost (Hourly)' },
    { id: 6, value: 'Hours' },
    // { id: 7, value: 'Make As Task' },
    // { id: 8, value: 'Make Install Card' },
    { id: 7, value: 'Product Formula Cost'},
    { id: 8, value: 'Additional cost' },
    { id: 9, value: 'Total cost' },
    { id: 10, value: '' }
  ];
  const VALUE_MATERIAL=[
    {id: -1, value: 'Sl No.' },
    {id: 22, value: 'Qb' },
    {id: 0, value: 'Product'},
    {id: 10, value: 'Note'}, 
    {id: 9, value: 'Stock Type'},
    {id: 1, value: 'Unit Price'},
    {id: 2, value: 'Markup (%)'},
    {id: 3, value: 'Markup Cost (Unit)' },
    {id: 4, value: 'Quantity'},
    { id: 8, value: 'Marketing Adjustment Type' },
    { id: 9, value: 'Marketing Adjustment' },
    // {id: 5, value: 'Product Formula Cost'},
    {id: 6, value: 'Total'},
    {id: 7, value: '' }
  ]
  const VALUE_RFP_Product = [
    { id: -1, value: 'Sl No.' },
    { id: 22, value: 'Qb' },
    { id: 0, value: 'Name' },
    { id: 1, value: 'Mark Up (%)' },
    { id: 2, value: 'Cost ' },
    { id: 3, value: 'Retail Price Each ' },
    { id: 4, value: 'Unit' },
    { id: 5, value: 'Quantity' },
    // { id: 6, value: 'Product Formula Cost'},
    { id: 7, value: 'Total' },
    // { id: 8, value: 'Make As Task' },
    // { id: 9, value: 'Make Install Card' },
    { id: 10, value: 'Location' },
    { id: 11, value: '' }
  ];
  const handleChangeTab = (event, newValue) => {
    setCurrentTab(newValue)
    // Both Job Notes and Design Notes share jobNoteMembers as TO recipients
    if (newValue === 'Job Notes' || newValue === 'Design Notes') {
      fetchJobNoteMembers();
    }
    if (newValue === 'Job Notes') {
      clearJobNotesNew()
    }
    if (newValue === 'Design Notes') {
      clearDesignNotesNew()
    }
    // setRefresh(true)
  }
  const HandleClickmenu = () => {
    setAddClient(true)
  }
    
  const fetchTaxCategory = async () => {
    try{
        const response = await axios.post(`${REST_API_END_POINT}product/get-tax-category`)
        if(response.data.status === 1){
            setTaxCategories(response.data.taxResult);
        }else{
          setTaxCategories([])
        }
    }catch(error){
        console.log("Error - ",error);
        setTaxCategories([])
    }
  }

  const fetchAllAgreements = async () => {
    try {
      const response = await axios.post(`${REST_API_END_POINT}agreement/get-all-agreements`);
      if (response.data.status === 1 && Array.isArray(response.data.result)) {
        setAgreements(response.data.result); // Set only if it's an array
      } else {
        setAgreements([]); // Empty array if the result is not valid
      }
    } catch (error) {
      console.log(error, 'Error in fetching all agreements');
      setAgreements([]); // Ensure agreements is an empty array on error
    }
  };

  //add clients
  const fetchAllRequestClients = async () => {
    
    try {
      const res = await axios.post(`${REST_API}webservice/request/fetch-all-clients-request`, { requestId: id })
      
     await setAllClients(res.data.data)
    } catch (error) {
      console.log(error, 'Error in fetching all clients')
    }
  }
 
  // useEffect(() => {
  //   fetchAllRequestClients()
  // }, [addClient])

  const NewUserSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    description: Yup.string().required('Description is required'),
    //  avatarUrl: Yup.mixed().required('Image is required'),
    // skills:userType!=3 && Yup.array().min(1, 'Skill is required'),
    // workflow:userType!=3 && Yup.array().min(1, 'Workflow is required'),
    // start: Yup.mixed().required('Start Date is required'),
    // end: Yup.date()
    //   .nullable()
    //   .transform((value, originalValue) => {
    //     return originalValue ? new Date(originalValue * 1000) : null;
    //   })
    //   .when('start', (start, schema) => {
    //     return start
    //       ? schema.min(
    //         start,
    //         'Installation Date must be greater than the Start Date'
    //       )
    //       : schema;
    //   }),
    products:isAdminUser (userType) && Yup.array(), //.min(1, 'At least one product is required'), 
    // services:userType!=3 && Yup.array().min(1, 'At least one service is required'), 
    markup_type:userType!=3 && Yup.object().nullable().required('Please select the markup type'),
    // map_service:userType!=3 && Yup.object().nullable().required('Please select the map service'),
    project_type: userType != 3 && Yup.object().nullable().required('Job class is required'),
    map_service: Yup.mixed().when('project_category', {
      is: (project_category) => userType !== 3 && project_category?.id === 14 && values.project_type?.name == 'TS',
      then: Yup.object().nullable().required('Please select the map service'),
      otherwise: Yup.mixed().nullable(),
    }),
    // project_type:Yup.object().nullable().required('Job Type is required'),
    // project_category:Yup.object().nullable().required('Job Category is required'),
    // community:Yup.object().nullable().required('Project is required'),
  });
  //
  const LabelStyle = styled(Typography)(({ theme }) => ({
    ...theme.typography.subtitle2,
    // color: theme.palette.text.secondary,
    //   marginBottom: theme.spacing(1)
  }));
  const LabelStyleHead = styled(Typography)(({ theme }) => ({
    ...theme.typography.h5,
    // color: theme.palette.text.secondary,
  }))
  //delete official request 
  const handleDeleteRFQ = async () => {
    try {
      setIsLoading(true);
      const data = { request_id: id ,request:false,userId:userId}
      const res = await axios.post(`${REST_API}webservice/delete-request-estimate/id`, data)
      
      if (res.data.data == true) {
        enqueueSnackbar('Delete success', { variant: 'success' });
        // navigate(PATH_DASHBOARD.quotation.root)
        if(popupOn){
        closeView()
        setRenderCards(!renderCards)
        }else{
          navigate(`/dashboard/quick-bid/estimate`)
        }
      }
    } catch (error) {
      console.log(error, 'Error in deleting the request')
    } finally {
      setIsLoading(false);
    }

  }
  //fetch request details
  const fetchRequestDetails = async () => {
    try {
      setLoading(true)
      // BACKUP: Original API call - const res = await axios.post(`${REST_API}webservice/view-request`, { request_id: id,userId, userType });
      // NEW: Updated to use view-request-without-team-products API
      const res = await axios.post(`${REST_API}webservice/request/view-request-estimate-new`, { request_id: id,userId, userType ,isNotSplitOrder : isSplitOrder ? false : true});
      res.data;

      // const name = res.data?.data[0]?.name ;
      // console.log("tinnnnnnnnnnnnnnnnnnnnnnnnn",name);
      setProductAttached (res.data.attachments || [])
      setTeamMember(res.data.team)
      setAvatarUrl(res.data.attachments)
      setDetails(res.data?.data[0])


      // const setloc = localStorage.setItem('estimateProjectName',details?.name )
      
      // Job note members are now fetched separately when Job Notes tab is active
      // BACKUP: Removed skill and allProposals from here - now fetched via products API
      // setRfps(res.data.allProposals)
      setDesignersList(res.data.projectMembers)
      setMarkupType(res.data?.data[0]?.markup_type)
      setDesigns(res.data?.attachments)
      setCustomerData(res.data.customerData)
       setTaxAmount(res.data.customerData?.tax_amount || 0)
      // setSkill(res.data.skill)
      setWorkFlow(res.data.workflows)
      // Sort communities alphanumerically by name and store for sales-rep lookup
      const sortedCommunities = [...(res?.data?.community || [])].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
      setCommunities(sortedCommunities)
      setAllCommunities(sortedCommunities)
      setSalesRepCommunity(res.data?.data[0]?.community)
      // // BACKUP: Original products fetch - setAllproducts(res.data.products)
      // Products will now be fetched separately via get-products API when Edit button is clicked
      
      setClientApprove(res.data?.data[0]?.client_approve);
      setManagerApprovalRequired(res.data?.data[0]?.manager_approval_required ?? 0);
      // setSingleLocationCard(res.data?.data[0]?.is_single_card === 1);
      // BACKUP: Removed materials processing from here - now fetched via products API
      // setAllMaterials(res.data.materials)  15-01-25
      // const allMatData = Array.isArray(res.data.materials) 
      // ? res.data.materials.map((material) => ({
      //     ...material,
      //     markup: Number(material.retail_price || 0), 
      //   }))
      // : [];
      // setAllMaterials(allMatData?.filter(item=>item.isAdditionalProduct == 0))

      setAcceptedClients(res.data.requestAcceptedPartners)
      // setUpdates(res.data.updates)
      // setPayments(res.data.payments)
      setCustomTemplate(res.data.fieldTemplates)
      setQuestionnaireTemplate(res.data.QuestionTemplates)
      setSignAgreements(res.data.signAgrementData)
      setDataEmpty(res.data.allDataEmpty)
      setPortfolio(res.data.portfolio)
      setRefresh(false)
      setProposalData(res.data.requestProposals)
      // BACKUP: Removed labourCostServices and materials from here - now fetched via products API
      // setLabourCostServices(res.data.labourCostServices)
      // setFilteredServices(res.data.labourCostServices)
      setRequestServices(res.data.requestServices.filter(row => row.rfp === 0))
      setRfpServicesEdit(res.data.requestServices.filter(row => row.rfp === 1))
      // if(res.data?.data[0]?.is_location===1){
      //   setAllLocationSame(true)

      let currentInstallationProductData = res?.data?.products
      let otherInstallationProductData = res?.data?.otherInstallationProducts
      let combinedProducts = [...(currentInstallationProductData || []), ...(otherInstallationProductData || [])];
      // setAllproducts(combinedProducts)
      let incomingSplitMarkup = res?.data?.currentFacilitySplitManagementSettings?.find(setting => setting?.is_default)?.incoming_percentage
      setIncomingSplitMarkup(incomingSplitMarkup)
      setSplitManagementSettings(res?.data?.otherInstallationSplitManagementSettings)

      let filteredValue = res.data?.data[0].facility_type; // e.g. "2,3,4"

      const selectedData = String(filteredValue)  
        .split(",")                               
        .map(v => v.trim())                     
        .map(id => res?.data?.otherInstallationSplitManagementSettings?.find(s => s?.id == id)) 
        .filter(Boolean);                        
      
      setSelectedSplitOrderSettings(res?.data?.otherInstallationSplitManagementSettings);
      console.log('selectedData11212121212 1',selectedData)
      // }
      if(edit){
        // Open edit immediately — don't await product catalog; mount already calls fetchProducts()
        setOpenEdit(true)
      }
      // setTimeout(()=>{
      //   setLoading(false)
      // },2000)
      setIsSplitOrder(res.data?.data[0]?.is_split_order)
      
      // Initialize productRows from request data if it exists
      if (res.data?.data[0]?.is_request_estimate == 1 && res.data?.data[0]?.productRows && res.data?.data[0]?.estimate_job_status != 3) {
        // Map backend data to include backendId from the database 'id' field
        // Also deduplicate by backendId to prevent duplicate rows
        const seenBackendIds = new Set();
        const mappedRows = res.data.data[0].productRows
          .filter(r => {
            // Filter out duplicates based on backendId
            if (r.id || r.backendId) {
              const bid = r.id || r.backendId;
              if (seenBackendIds.has(bid)) return false;
              seenBackendIds.add(bid);
            }
            return true;
          })
          .map((r, idx) => ({
            ...r,
            indexId: idx + 1, // Always assign sequential indexId starting from 1
            backendId: r.id || r.backendId || null,
            is_product_row: 1
          }));
        setProductRows(mappedRows.length > 0 ? mappedRows : [{ indexId: 1, product_name: '', product_desc: '', is_product_row: 1, backendId: null }]);
        if (mappedRows && mappedRows.length > 0) {
          setProductRowsIndexCounter(mappedRows.length);
        }
      }
     
    } catch (error) {
      console.error('Error fetching request details:', error);
    }finally{
      setLoading(false)
    }
  };

  const handleJobLogUpdates = async (search = '') => {
    try {
      const res = await axios.post(`${REST_API}webservice/request/get-job-log-updates`, {
        request_id: id,
        userId,
        userType,
        search,
      });

      if (res.data.status === 1) {
        if (!search) {
          setUpdates(res.data.updates)
        }
        return res.data.updates || []
      }
      return []
    } catch (error) {
      console.error('Error fetching job log details:', error);
      if (search) {
        return []
      }
      throw error;
    }
  };

  const handleJobLogSearch = useCallback(async (search) => {
    return handleJobLogUpdates(search);
  }, [id, userId, userType]);

  useEffect(() => {
    if (currentTab === 'Job Log') {
      handleJobLogUpdates();
    }
  }, [currentTab]);
  // Shared TO recipients for Job Notes and Design Notes tabs
  const fetchJobNoteMembers = async () => {
    try {
      const res = await axios.post(`${REST_API}webservice/request/get-job-note-members`, {
        request_id: id,
        userId: user.user_id,
        userType: user.user_type,
      });
      if (res.data.status === 1) {
        setJobNoteMembers(res.data.jobNoteMembers || []);
      }
    } catch (error) {
      console.log('Error fetching job note members:', error);
    }
  };

  // NEW: Separate function to fetch products - only called when Edit button is clicked
  const fetchProducts = async () => {
    setIsLoadingProducts(true)
    try {
      const [productOnly,productsRes,materialOnly,groupsRes] = await Promise.all([
        axios.post(`${REST_API}webservice/request/get-products`, { isNotSplitOrder : isSplitOrder ? false : true,ProductOnly:true}),
        axios.post(`${REST_API}webservice/request/get-products`, {isNotSplitOrder : isSplitOrder ? false : true,noProduct:true,noMaterial:true}),
        axios.post(`${REST_API}webservice/view-request-materials`, {isNoAdditionalProduct:true,inHouse:true}),
        axios.post(`${REST_API}webservice/view-request-groups`, { request_id: id }),
      ])
      const groupsFromApi = groupsRes?.data?.customerOrderProductGroups || []
      setCustomerOrderProductGroups(groupsFromApi)

      const initialProductMarketing = {}
      const initialInstallMarketing = {}
      groupsFromApi.forEach((group) => {
        const gid = group?.id ?? group?.group_id
        if (gid == null) return
        const key = String(gid)
        initialProductMarketing[key] = {
          adjustment: Number(
            group.product_marketing_adjustment ??
              group.productMarketingAdjustment ??
              0,
          ) || '',
          adjValueType: parseGroupMarketingAdjValueTypeFromDb(
            group.product_marketing_adj_value_type ??
              group.productMarketingAdjValueType,
          ),
        }
        initialInstallMarketing[key] = {
          adjustment: Number(
            group.install_marketing_adjustment ??
              group.installMarketingAdjustment ??
              0,
          ) || '',
          adjValueType: parseGroupMarketingAdjValueTypeFromDb(
            group.install_marketing_adj_value_type ??
              group.installMarketingAdjValueType,
          ),
        }
      })
      setGroupProductMarketingValues((prev) => {
        const hasPrev = prev && Object.keys(prev).length > 0
        if (!hasPrev) return initialProductMarketing
        return { ...initialProductMarketing, ...prev }
      })
      setGroupInstallMarketingValues((prev) => {
        const hasPrev = prev && Object.keys(prev).length > 0
        if (!hasPrev) return initialInstallMarketing
        return { ...initialInstallMarketing, ...prev }
      })
      // const productsRes = await axios.post(`${REST_API}webservice/request/get-products`, { isNotSplitOrder : isSplitOrder ? false : true });
      let currentInstallationProductData = productOnly?.data?.products
      let otherInstallationProductData = productsRes?.data?.otherInstallationProducts
      let combinedProducts = [...(currentInstallationProductData || []), ...(otherInstallationProductData || [])];
      setAllproducts(combinedProducts)
      let incomingSplitMarkup = productsRes?.data?.currentFacilitySplitManagementSettings?.find(setting => setting?.is_default)?.incoming_percentage
      setIncomingSplitMarkup(incomingSplitMarkup)
      setSplitManagementSettings(productsRes?.data?.otherInstallationSplitManagementSettings)
                      
      
      setSelectedSplitOrderSettings(productsRes?.data?.otherInstallationSplitManagementSettings);
      
      // setAllproducts(productsRes.data.products);
      // NEW: Set labourCostServices and materials from products API
      // Sort labour cost services alphanumerically by name
      const sortedLabourCostServices = [...(productsRes.data.labourCostServices || [])].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
      setLabourCostServices(sortedLabourCostServices);
      setFilteredServices(sortedLabourCostServices);
      
      // NEW: Process materials data (moved from main fetchRequestDetails function)
      const allMatData = Array.isArray(materialOnly.data.materials) 
        ? materialOnly.data.materials.map((material) => ({
            ...material,
            markup: Number(material.retail_price || 0), 
          }))
        : [];
      const filteredMaterials = allMatData?.filter(item=>item.isAdditionalProduct == 0)
      // Sort materials alphanumerically by description (fallback to name)
      const sortedMaterials = [...(filteredMaterials || [])].sort((a, b) => {
        const aValue = a?.description || a?.name || '';
        const bValue = b?.description || b?.name || '';
        return alphanumericCompare(aValue, bValue);
      })
      setAllMaterials(sortedMaterials);
      
      // NEW: Set skill and allProposals from products API
      setSkill(productsRes.data.skill);
      // Sort proposals alphanumerically by description
      const sortedProposals = [...(productsRes.data.allProposals || [])].sort((a, b) => alphanumericCompare(a?.description || '', b?.description || ''))
      setRfps(sortedProposals);
      return {
        products: combinedProducts,
        groups: groupsFromApi,
        labourCostServices: sortedLabourCostServices,
      };
    } catch (productsError) {
      console.error('Error fetching products:', productsError);
      setAllproducts([]); // Set empty array as fallback
      setLabourCostServices([]);
      setFilteredServices([]);
      setAllMaterials([]);
      setSkill([]);
      setRfps([]);
      return { products: [], groups: [], labourCostServices: [] };
    } finally {
      setIsLoadingProducts(false)
    }
  };

console.log('materialssssssssss',materials )
  const fetchAllMapServices = async () => {
    setMapServicesLoading(true);
    try {
      const res = await axios.post(`${REST_API}webservice/route/fetch-routes-with-locations`,{ requestId : id })
      let data = res.data?.routeData
      if(data){
        const newData = data?.filter((i) => i.locations != null)
        if(newData){
          setMapServices(newData);
        }else{
          setMapServices([]);
        }
      }else{
        setMapServices([]);
      }
    } catch (error) {
      setMapServices([]);
      console.log(error, 'Error in fetching map services');
    }finally {
      setMapServicesLoading(false)
    }
  }

  const fetchAllClients = async () => {
    try {
      const res = await axios.post(`${REST_API}webservice/clients/getAllClients`, { userType, userId: userId,order:true ,From:"addSalesOrder",teamId: null})
      let data = res.data?.customer
      await setAllClientsEdit(data)
    } catch (error) {
      console.log(error, 'Error in fetching all clients', error)
    }
  }

  const fetchAllCommunityByClient = async (clientId) => {
    setIsCommunityLoading(true);
    try {
      clientId = clientId?.id
      const res = await axios.post(`${REST_API}webservice/rfq/get-community-by-client`, { clientId,From:"addSalesOrder",teamId: null,userType:userType,noAllCommunity:true})
      let data = res.data?.community
      // Sort communities alphanumerically by name
      const sortedCommunities = [...(data || [])].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
      await setCommunities(sortedCommunities)
    } catch (error) {
      console.log(error, 'Error in fetching all clients');
      setCommunities([]);
    } finally {
      setIsCommunityLoading(false)
    }
  }

  useEffect(() => {
    if(!id) return;
    if(id){
      fetchRequestDetails()
    }
    fetchTaxCategory()
    fetchAllAgreements()
    fetchAllMapServices()
    fetchAllClients()
    fetchAllCommunityByClient()
  }, [id,refresh])

  useEffect(() => {
    if(!id) return;
    try {
      axios.post(`${REST_API_END_POINT}project/get-specific-data-for-add-project`,{
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((response) => {
        if(response.data.status === 1){
          setProjectTypes(response.data.projectTypes)
          const category = response.data.projectCategories;
          const filteredCategory = category?.filter(item=>item.id == 14)
          setProjectCategories(filteredCategory)
          setAllEstimators(response.data.allEstimators)
        } else {
          setProjectTypes([])
          setProjectCategories([])
          setAllEstimators([])
        }
      }).catch((error) => {
        console.error(error);
        setProjectTypes([])
        setProjectCategories([])
        setAllEstimators([])
      })
      }
      catch (error) {
        console.error("Error fetching data:", error);
      }
  },[id, refresh])
  //rfq product detais
  const fetchOrderProductDetails = async () => {
    try {
      let orderId = details?.id;
      const [res, groupsRes] = await Promise.all([
        axios.post(`${REST_API}webservice/get-customer-order-product/${orderId}`),
        id
          ? axios.post(`${REST_API}webservice/view-request-groups`, { request_id: id })
          : Promise.resolve({ data: { customerOrderProductGroups: [] } }),
      ]);
      setInvoice(res.data.data);
      const groupsFromApi = groupsRes?.data?.customerOrderProductGroups || []
      // Always sync groups from API so design→estimate conversion doesn't keep a stale empty list
      setCustomerOrderProductGroups(groupsFromApi)
      if (groupsFromApi.length) {
        const initialProductMarketing = {}
        const initialInstallMarketing = {}
        groupsFromApi.forEach((group) => {
          const gid = group?.id ?? group?.group_id
          if (gid == null) return
          const key = String(gid)
          initialProductMarketing[key] = {
            adjustment: Number(
              group.product_marketing_adjustment ??
                group.productMarketingAdjustment ??
                0,
            ) || '',
            adjValueType: parseGroupMarketingAdjValueTypeFromDb(
              group.product_marketing_adj_value_type ??
                group.productMarketingAdjValueType,
            ),
          }
          initialInstallMarketing[key] = {
            adjustment: Number(
              group.install_marketing_adjustment ??
                group.installMarketingAdjustment ??
                0,
            ) || '',
            adjValueType: parseGroupMarketingAdjValueTypeFromDb(
              group.install_marketing_adj_value_type ??
                group.installMarketingAdjValueType,
            ),
          }
        })
        setGroupProductMarketingValues((prev) => {
          const hasPrev = prev && Object.keys(prev).length > 0
          if (!hasPrev) return initialProductMarketing
          return { ...initialProductMarketing, ...prev }
        })
        setGroupInstallMarketingValues((prev) => {
          const hasPrev = prev && Object.keys(prev).length > 0
          if (!hasPrev) return initialInstallMarketing
          return { ...initialInstallMarketing, ...prev }
        })
      }
      setTaxAmount(res?.data?.data?.tax_amount || 0)
      // Sort communities alphanumerically by name
      const sortedCommunities = [...(res.data.community || [])].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
      setCommunities(sortedCommunities)

      // Prefill request_estimate product rows from already submitted products (if any)
      // Only do this if productRows wasn't already set from the first API call
      if (details?.is_request_estimate == 1 && details?.estimate_job_status != 3) {
        const submittedProducts = res?.data?.data?.cust_product || [];
        const submittedServices = res?.data?.data?.jobcost_service || [];
        // Filter only products with is_product_row = 1 (manual product rows)
        const productRowProducts = submittedProducts.filter(prod => prod?.is_product_row == 1);
        const serviceRowServices = submittedServices.filter(service => service?.is_service_row == 1);
        if (productRowProducts.length > 0) {
          const mappedRows = productRowProducts.map((prod, idx) => ({
            indexId: prod?.product_index ?? (idx + 1),
            product_name: prod?.product_name || '',
            product_desc: prod?.product_desc || '',
            backendId: prod?.id || prod?.backendId || null,
            is_product_row: 1
          }));
          console.log('mappedRows===',mappedRows)
          // Only override if productRows is empty or has only default empty row
          // const hasExistingRows = productRows?.length > 0 && productRows.some(r => r.backendId || (r?.product_name || '').trim() !== '');
          // if (!hasExistingRows) {
          setProductRows(mappedRows);
          const maxIdx = Math.max(...mappedRows.map(r => r.indexId || 0), mappedRows.length);
          setProductRowsIndexCounter(maxIdx);
        }
        // }
        if (serviceRowServices.length > 0) {
          const mappedRows = serviceRowServices.map((service, idx) => ({
            indexId: service?.service_index ?? (idx + 1),
            service_name: service?.service_name || '',
            service_desc: service?.service_desc || '',
            backendId: service?.id || service?.backendId || null,
            is_service_row: 1,
            addedByUserType: service?.addedByUserType ?? service?.added_by_user_type ?? null,
          }));
          // const hasExistingRows = serviceRows?.length > 0 && serviceRows.some(r => r.backendId || (r?.service_name || '').trim() !== '');
          // if (!hasExistingRows) {
          setServiceRows(mappedRows);
          const maxIdx = Math.max(...mappedRows.map(r => r.indexId || 0), mappedRows.length);
          setServiceRowsIndexCounter(maxIdx);
        }       
      }
      // }

      const rfqCommunity = (res?.data?.community || [])?.find((com) => salesRepCommunity === com.id)
      console.log('rfqCommunity', rfqCommunity)
            // Sales reps dropdown: populate all sales reps for selected project
            const repOptions = getSalesRepOptionsFromCommunity(rfqCommunity);
            console.log('repOptions', repOptions)
            setSalesRepOptions(repOptions);
            // setAllSalesRepIds(rfqCommunity?.all_sales_rep_ids || rfqCommunity?.sales_rep_ids || '');
            if (repOptions.length > 0) {
              const selectedSalesRepId = res.data?.data[0]?.sales_rep_ids || details?.sales_rep_ids;
              setSalesRepName(repOptions?.find((rep) => String(rep.id) === String(selectedSalesRepId))?.name || '');
              setSalesRepId(repOptions?.find((rep) => String(rep.id) === String(selectedSalesRepId))?.id || null);
              console.log('selectedSalesRepId', selectedSalesRepId)
            } else {
              setSalesRepName('');
              setSalesRepId(null);
            }

      
      const rfqServicesData = res?.data?.data?.cust_product?.flatMap(product => {
        console.log('product1234', product)
        return product.services.map(service => ({
          ...service,
          productIndex: product.product_index,
          product_id: product.product_id,
          qtyData: product.quantity,
          locationQuantity: product.locationQuantity || 1,
          productName :product?.product_name
  
        }));
      });
      let labourInstallData =rfqServicesData?.filter(item =>item.labour_cost_service_id == 10)
      setLabourInstallService(labourInstallData)

      return { ...res.data, groups: groupsFromApi };
    } catch (error) {
      console.error('Error fetching request details:', error);
      throw error;
    }
  };
  const handleSendEmail = async () => {
    try {
      let orderId = details?.id;
       const res = await axios.post(`${REST_API}webservice/settings/send-mail`,{ id: orderId });
      
       if(res.data.status===1){
        enqueueSnackbar('Email send successfully', { variant: 'success' });
        setOpenInvoice(false)
       }
      return res.data;
    } catch (error) {
      console.error('Error fetching request details:', error);
      throw error;
    }
  };

  const handleSendInvoiceEmail = () => {
    if (!invoice || !details) {
      enqueueSnackbar('Invoice data not available', { variant: 'warning' });
      return;
    }
    const pageTypePrefix = isProposal ? 'proposal' : 'estimate';
    const groupedDesignOrderDisplayRows = serializeDesignOrderGroupedRowsForInvoice(
      buildGroupedDesignOrderDisplayRows({
        designOrderProducts: selectedProducts,
        customerOrderProductGroups,
        markupType,
        groupProductMarketingValues,
        groupInstallMarketingValues,
      }),
    );
    // Create invoice PDF object formatted for SendDesignsEmailModal
    const invoicePdfObject = {
      id: `invoice_${details.id}`,
      name: `${pageTypePrefix}_${details.name || details.id}_${moment().format('YYYY-MM-DD')}.pdf`,
      file_type: 'application/pdf',
      extension: 'pdf',
      url: null, // Will be generated on backend
      invoiceData: {
        invoice: invoice,
        details: details,
        invoiceDate: invoiceDate,
        subTotal: invoiceModalCustProductSubtotalForServices,
        groupedInvoiceProductTotal: invoiceModalProductTotalFromRows,
        groupedInvoiceInstallTotal: invoiceModalInstallTotalFromRows,
        cartService: cartService,
        additionalSelectedServices: invoiceModalAdditionalServices,
        invoiceSelectedServices: invoiceSelectedServices,
        labourInstallService: labourInstallService,
        customerOrderProductGroups,
        groupedDesignOrderDisplayRows,
        markupType,
        groupProductMarketingValues,
        groupInstallMarketingValues,
      }
    };
    
    setInvoicePdfData([invoicePdfObject]);
    setOpenInvoiceEmailModal(true);
  };

  const handleInvoiceEmailSent = () => {
    setInvoicePdfData(null);
  };
  const fetchRequestServicesDetails = async () => {
    try {
      let orderId = details?.id;
      const res = await axios.post(`${REST_API}webservice/get-request-services/${orderId}`);
      setInvoice(res.data.data);
      return res.data.data;
    } catch (error) {
      console.error('Error fetching request details:', error);
      throw error;
    }
  };

  const assignProjectAgain = (rfqCommunity, shouldCallAssignProject, shouldCallAssignProjectRFP, shouldCallAssignProjectProducts) => {
    console.log('New Value:', rfqCommunity);
    const { address, city, state, zip } = rfqCommunity;
    if (shouldCallAssignProjectProducts) {
      setSelectedProducts((prevProducts) =>
        prevProducts.map((product) => {
          const locations = product.location?.length
            ? product.location
            : [{ id: 0, address: '', city: '', state: '', zip: '' }];
          const updatedLocations = locations.map((loc) => ({
            ...loc,
            address: address ?? loc.address,
            city: city ?? loc.city,
            state: state ?? loc.state,
            zip: zip ?? loc.zip,
          }));

          return { ...product, location: updatedLocations };
        })
      );
    }
    if (shouldCallAssignProject) {
      setAdditionalSelectedServices((prevServices) =>
        prevServices.map((service) => {
          const updatedAddresses = service.addresses?.map((loc) => ({
            ...loc,
            address: address ?? loc.address,
            city: city ?? loc.city,
            state: state ?? loc.state,
            zip: zip ?? loc.zip,
          })) ?? []; // Ensures addresses is never undefined
  
          return { ...service, addresses: updatedAddresses };
        })
      );
    }
    if (shouldCallAssignProjectRFP) {
      setCartService((prevServices) =>
        prevServices.map((service) => {
          const updatedAddresses = service.addresses?.map((loc) => ({
            ...loc,
            address: address ?? loc.address,
            city: city ?? loc.city,
            state: state ?? loc.state,
            zip: zip ?? loc.zip,
          })) ?? []; 
  
          return { ...service, addresses: updatedAddresses };
        })
      );
    }
  };

  const ensureLabourCostServicesLoaded = async () => {
    if (labourCostServices?.length) return labourCostServices
    try {
      const loaded = await fetchLabourCostServicesForDropdown(axios, REST_API, {
        isNotSplitOrder: isSplitOrder ? false : true,
      })
      if (loaded.length) {
        const sorted = [...loaded].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
        setLabourCostServices(sorted)
        setFilteredServices(sorted)
      }
      return loaded
    } catch (error) {
      console.error('Error loading labour cost services:', error)
      return []
    }
  }

  const addingInitialdataRFQ = async () => {
    // setLoading(true)
    try {
      if (openEdit) {
        let servicesArray = details?.services?.split(',')?.map(Number);
        let workflowSet = details?.workflows?.split(',')?.map(Number);
        // Design→estimate opens edit immediately; catalog state may still be empty.
        // Resolve a fresh catalog list before hydrating so grouped lines keep group_id.
        let productsCatalog = allProducts
        if (!productsCatalog?.length) {
          const fetched = await fetchProducts()
          productsCatalog = fetched?.products || []
        }
        const newInvoiceData = await fetchOrderProductDetails(); 
        const invoiceData = newInvoiceData?.data
        const communityData = newInvoiceData?.community
        const groupsMetaById = new Map(
          (newInvoiceData?.groups || []).map((g) => [String(g?.id ?? g?.group_id), g]),
        )
        const rfqTaxCategory = taxCategories?.find(cat => invoiceData.tax_category === cat.id) || null
        setSelectedTaxCategory(rfqTaxCategory)
        // let rfqSkill = skills?.filter((row) => row.id == details?.services);
        // let rfqSkill = skills.filter(skill => servicesArray.includes(skill.id));
        // let rfqWorkFlow = workflow?.filter(skill => workflowSet?.includes(skill.id));
        let rfqProjectType = projectTypes?.find(type=>details.project_type === type.id)    
        let rfqSignAgreements = details?.sign_agreement ? details.sign_agreement.split(',').map(Number) : [];
        console.log('rfqSignAgreements++++++++',rfqSignAgreements)
      // Use String() match — live MySQL/mysql2 often returns customer_id as string; === fails then.
        // Also fall back to customerData fields when clients list has not loaded yet (design→estimate auto-opens edit).
        let rfqCustomerData =
          allClientsEdit?.find(
            (cat) =>
              cat?.id != null &&
              customerData?.customer_id != null &&
              String(cat.id) === String(customerData.customer_id),
          ) ||
          (customerData?.customer_id
            ? {
                id: customerData.customer_id,
                name: customerData.customer_name || customerData.name || '',
                phone: customerData.customer_phone || customerData.phone || '',
                address: customerData.customer_address || customerData.address || '',
              }
            : null)
        let rfqProjectcategory = projectCategories?.find(cat=>details.project_category === cat.id)   
        let rfqMarkupType = markupTypes?.find(cat=>details?.markup_type === cat.id)   
        let rfqMapServices = mapServices?.find(cat=>details?.map_service === cat.id)   
        let rfqCommunity = communityData?.find(com=>details.community === com.id)   

        // Sales reps dropdown: populate all sales reps for selected project (edit mode)
        if (rfqCommunity) {
          const repOptions = getSalesRepOptionsFromCommunity(rfqCommunity);
          setSalesRepOptions(repOptions);
          // setAllSalesRepIds(rfqCommunity?.all_sales_rep_ids || rfqCommunity?.sales_rep_ids || '');
          setAllSalesRepIds(details?.sales_rep_ids || '');
          if (repOptions.length > 0) {
            const selectedSalesRepId = details?.sales_rep_ids;
            setSalesRepName(repOptions?.find((rep) => String(rep.id) === String(selectedSalesRepId))?.name || '');
            setSalesRepId(repOptions?.find((rep) => String(rep.id) === String(selectedSalesRepId))?.id || null);
          } else {
            setSalesRepName('');
            setSalesRepId(null);
          }
        }
        
        // rfqProduct = invoiceData?.cust_product.filter((row) => {
        //   return allProducts.filter(data => data.id == row.product_id)
        // })
      let rfqProduct = invoiceData?.cust_product?.filter((row) => row.rfp === 0 && row.material===0)?.map((row) => {
        // Catalog match first when product_id exists — avoids write-only hydration hiding formula costs
        let match = productsCatalog?.length > 0 ? productsCatalog?.find(data => data.id == row.product_id) : null;
        const rowGroupId = row.group_id || row.customer_order_product_group_id || null
        const groupMeta = rowGroupId != null ? groupsMetaById.get(String(rowGroupId)) : null
        const resolvedGroupName =
          row.group_name || groupMeta?.group_name || groupMeta?.name || null
        const resolvedGroupDescription =
          row.group_description || groupMeta?.group_description || groupMeta?.description || null
        if (match) {
            return {
                ...match,
                indexId: row.product_index,
                product_total: row.product_total || 0,
                product_notes: row.product_notes,
                install_notes: row.install_notes,
                discount: row.discount,
                adjustment: row.adjustment,
                quantity: row.quantity,
                install_cost: row.install_cost,
                install_adjustment: row.install_adjustment,
                install_adj_value_type: row.install_adj_value_type,
                install_quantity: row.install_qty || row.install_quantity,
                expected_install_labor_cost_with_markup: row.expected_install_labor_cost_with_markup || match.expected_install_labor_cost_with_markup || match.install_labour_cost_with_markup || 0,
                location:row.location,
                allLocationSame:row.allLocationSame,
                locationQuantity:row.locationQuantity,
                markAdjType:row.markAdjType,
                fromMapServices : row.map_service == 1 ? true : false,
                is_single_card : row.is_single_card == 1 ? true : false,
                group_id: rowGroupId,
                group_name: resolvedGroupName,
                group_description: resolvedGroupDescription,
                group_catalog_anchor_index_id: row.group_catalog_anchor_index_id || null,
                group_product_quantity: row.group_product_quantity ?? row.locationQuantity ?? 1,
                group_install_quantity:
                  row.group_install_quantity ?? row.install_qty ?? row.install_quantity ?? 1,
                product_marketing_quantity: row.product_marketing_quantity ?? null,
                install_marketing_quantity: row.install_marketing_quantity ?? null,
                max_price_mi_id:row.materialInvId || null,
                adj_value_type: row.adj_value_type,
                sub_contract_markup : match?.markup,
                name : row.product_name || match?.name,
                description : row.product_desc || match?.description,
                productAttachments: row.attachments || row.productAttachments || [],
                backendId: row.id || null,
                // BACKUP: entryMode: row.is_product_row == 1 ? 'write' : 'choose',
                entryMode: row.is_product_row == 1 ? 'write' : 'choose',
                isAdditionalProduct: false,
                // BACKUP: is_product_row: row.is_product_row == 1 ? 1 : row.is_product_row || 0,
                is_product_row: row.product_id ? 0 : (row.is_product_row == 1 ? 1 : row.is_product_row || 0),
                product_write: row.product_write,
                // Hydrate after row fields so computed originals are not wiped by null DB originals
                ...hydrateSavedOrderLinePrices(row, match),
                ...(rowGroupId ? hydrateGroupedMemberMarketingFromRow(row) : {}),
                addedByUserType: row.addedByUserType ?? row.added_by_user_type ?? null,
                product_formula_cost_each: row.product_formula_cost_each ?? null,
                install_formula_cost_each: row.install_formula_cost_each ?? null,
            };
        }
        // Manual write rows — only when no catalog match
        // BACKUP: if (isSavedManualWriteProductRow(row)) { ... } ran before catalog match
        if (isSavedManualWriteProductRow(row)) {
            const rowRetail = row.product_retail_price ?? row.retail_price ?? 0
            const rowActualRetail = row.actual_retail_price || rowRetail || 0
            const rowWholesale = row.product_price ?? row.price ?? 0
            return {
              // BACKUP: id: row.product_id || row.id,
              id: row.product_id || null,
              indexId: row.product_index,
              product_name: row.product_name || '',
              product_desc: row.product_desc || '',
              name: row.product_name || '',
              description: row.product_desc || row.description || '',
              actual_retail_price: rowActualRetail,
              original_retail_price: rowRetail + (row?.adj_value_type ? -(Number(row.adjustment) || 0) : +(Number(row.adjustment) || 0)),
              original_actual_retail_price: rowActualRetail + (row?.adj_value_type ? -(Number(row.adjustment) || 0) : +(Number(row.adjustment) || 0)),
              original_product_retail_price: rowRetail + (row?.adj_value_type ? -(Number(row.adjustment) || 0) : +(Number(row.adjustment) || 0)),
              original_product_price: rowWholesale + (row?.adj_value_type ? -(Number(row.adjustment) || 0) : +(Number(row.adjustment) || 0)),
              original_price: rowWholesale + (row?.adj_value_type ? -(Number(row.adjustment) || 0) : +(Number(row.adjustment) || 0)),
              product_retail_price: rowRetail,
              retail_price: row.install_cost
                ? rowRetail + (row?.adj_value_type ? -(Number(row.adjustment) || 0) : +(Number(row.adjustment) || 0))
                : rowRetail,
              price: rowWholesale,
              product_price: rowWholesale,
              product_total: row.product_total || 0,
              product_notes: row.product_notes,
              install_notes: row.install_notes,
              discount: row.discount,
              adjustment: row.adjustment,
              quantity: row.quantity || row.product_qty || 1,
              install_cost: row.install_cost,
              install_adjustment: row.install_adjustment,
              install_adj_value_type: row.install_adj_value_type,
              install_quantity: row.install_qty || row.install_quantity,
              location: row.location,
              allLocationSame: row.allLocationSame,
              locationQuantity: row.locationQuantity || row.location_quantity || 1,
              markAdjType: row.markAdjType,
              fromMapServices: row.map_service == 1,
              is_single_card: row.is_single_card == 1,
              // BACKUP: is_product_row: 1,
              is_product_row: row.is_product_row == 1 ? 1 : 0,
              is_line_catalog: row.is_line_catalog ?? 0,
              max_price_mi_id: row.materialInvId || null,
              adj_value_type: row.adj_value_type,
              productAttachments: row.attachments || row.productAttachments || [],
              backendId: row.id || null,
              // BACKUP: entryMode: 'write',
              entryMode: row.is_product_row == 1 ? 'write' : 'choose',
              isAdditionalProduct: false,
              // BACKUP: isAdditionalProduct: true,
              // BACKUP: product_write: row.product_write ?? 1,
              product_write: row.product_write ?? 0,
              addedByUserType: row.addedByUserType ?? row.added_by_user_type ?? null,
              group_id: rowGroupId,
              group_name: resolvedGroupName,
              group_description: resolvedGroupDescription,
              group_catalog_anchor_index_id: row.group_catalog_anchor_index_id || null,
              group_product_quantity: row.group_product_quantity ?? row.locationQuantity ?? row.location_quantity ?? 1,
              group_install_quantity:
                row.group_install_quantity ?? row.install_qty ?? row.install_quantity ?? 1,
              product_marketing_quantity: row.product_marketing_quantity ?? null,
              install_marketing_quantity: row.install_marketing_quantity ?? null,
              ...hydrateSavedOrderLinePrices(row),
              ...(rowGroupId ? hydrateGroupedMemberMarketingFromRow(row) : {}),
              product_formula_cost_each: row.product_formula_cost_each ?? null,
              install_formula_cost_each: row.install_formula_cost_each ?? null,
            }
        }
        // BACKUP: duplicate catalog match block removed — handled above before write-only path
        if (row.product_id == null || row?.product_name) {
            const rowRetail = row.product_retail_price ?? row.retail_price ?? 0
            const rowActualRetail = row.actual_retail_price || rowRetail || 0
            const rowWholesale = row.product_price ?? row.price ?? 0
            return {
              // BACKUP: id: row.product_id || row.id,
              id: row.product_id || null,
              indexId: row.product_index,
              product_name: row.product_name || '',
              product_desc: row.product_desc || '',
              name: row.product_name || '',
              description: row.product_desc || row.description || '',
              actual_retail_price: rowActualRetail,
              original_retail_price: rowRetail + (row?.adj_value_type ? -(Number(row.adjustment) || 0) : +(Number(row.adjustment) || 0)),
              original_actual_retail_price: rowActualRetail + (row?.adj_value_type ? -(Number(row.adjustment) || 0) : +(Number(row.adjustment) || 0)),
              original_product_retail_price: rowRetail + (row?.adj_value_type ? -(Number(row.adjustment) || 0) : +(Number(row.adjustment) || 0)),
              original_product_price: rowWholesale + (row?.adj_value_type ? -(Number(row.adjustment) || 0) : +(Number(row.adjustment) || 0)),
              original_price: rowWholesale + (row?.adj_value_type ? -(Number(row.adjustment) || 0) : +(Number(row.adjustment) || 0)),
              product_retail_price: rowRetail,
              retail_price: row.install_cost
                ? rowRetail + (row?.adj_value_type ? -(Number(row.adjustment) || 0) : +(Number(row.adjustment) || 0))
                : rowRetail,
              price: rowWholesale,
              product_price: rowWholesale,
              product_total: row.product_total || 0,
              product_notes: row.product_notes,
              install_notes: row.install_notes,
              discount: row.discount,
              adjustment: row.adjustment,
              quantity: row.quantity || row.product_qty || 1,
              install_cost: row.install_cost,
              install_adjustment: row.install_adjustment,
              install_adj_value_type: row.install_adj_value_type,
              install_quantity: row.install_qty || row.install_quantity,
              location: row.location,
              allLocationSame: row.allLocationSame,
              locationQuantity: row.locationQuantity || row.location_quantity || 1,
              markAdjType: row.markAdjType,
              fromMapServices: row.map_service == 1,
              is_single_card: row.is_single_card == 1,
              // BACKUP: is_product_row: row.is_product_row || 0,
              is_line_catalog: row.is_line_catalog ?? 0,
              max_price_mi_id: row.materialInvId || null,
              adj_value_type: row.adj_value_type,
              productAttachments: row.attachments || row.productAttachments || [],
              backendId: row.id || null,
              // BACKUP: entryMode: row.is_product_row == 1 || row.product_write == 1 ? 'write' : 'choose',
              entryMode: row.is_product_row == 1 ? 'write' : 'choose',
              isAdditionalProduct: true,
              // BACKUP: is_product_row: row.is_product_row == 1 || row.product_write == 1 ? 1 : row.is_product_row || 0,
              is_product_row: row.is_product_row == 1 ? 1 : row.is_product_row || 0,
              product_write: row.product_write,
              addedByUserType: row.addedByUserType ?? row.added_by_user_type ?? null,
              group_id: rowGroupId,
              group_name: resolvedGroupName,
              group_description: resolvedGroupDescription,
              group_catalog_anchor_index_id: row.group_catalog_anchor_index_id || null,
              group_product_quantity: row.group_product_quantity ?? row.locationQuantity ?? row.location_quantity ?? 1,
              group_install_quantity:
                row.group_install_quantity ?? row.install_qty ?? row.install_quantity ?? 1,
              product_marketing_quantity: row.product_marketing_quantity ?? null,
              install_marketing_quantity: row.install_marketing_quantity ?? null,
              ...hydrateSavedOrderLinePrices(row),
              ...(rowGroupId ? hydrateGroupedMemberMarketingFromRow(row) : {}),
              product_formula_cost_each: row.product_formula_cost_each ?? null,
              install_formula_cost_each: row.install_formula_cost_each ?? null,
            }
        }
        return undefined;
      })
        .filter((item) => item !== undefined)
        // BACKUP: .filter(item => item !== undefined) only — empty orphan lines reappeared as Choose
        .filter((item) => {
          if (item?.fromMapServices) return true
          const hasName = Boolean((item.product_name || item.name || '').trim())
          if (!hasName && !item?.id) return false
          return true
        });
      console.log("####################RFQ",rfqProduct);
      let rfqSignAgreementsData = invoiceData?.sign_agreements?.filter(item => rfqSignAgreements.includes(item.id))
      console.log("rfqSignAgreementsData++++++++",rfqSignAgreementsData)
      console.log("invoiceData----",invoiceData);
      const highestIndexId = rfqProduct?.reduce((max, product) => {
        return typeof product.indexId === 'number' && product.indexId > max ? product.indexId : max;
      }, 0);

      setIndexCounter(highestIndexId);
      const highestIndexIdService = invoiceData?.jobcost_service?.reduce((max, product) => {
        return typeof product.product_index === 'number' && product.product_index > max ? product.product_index : max;
      }, 0);
      setIndexCounterService(highestIndexIdService);
      const filteredData = rfqProduct?.filter(item=>item?.fromMapServices == true)
      setSelectedMapserviceProducts(filteredData || [])
      setSelectedProducts(rfqProduct || [])
      // const serviceIdArray = details?.labour_cost_services?.split(',')?.map(Number);
      // const rfqServices = invoiceData?.cust_product?.map((row)=>
      //   labourCostServices?.find(data => data.id == row.id)
      // )
    //   const rfqServices = invoiceData?.cust_product?.map(product => {
    //     const productServices = product.services?.map(service => {
    //         const serviceData = labourCostServices.find(data => data.id === service.id);
    //         return serviceData;
    //     });
    
    //     // Return an object containing product details along with its services
    //     return productServices;
    // });
    let rfpProduct = invoiceData?.cust_product?.filter((row) => row.rfp === 1 )
    // let materials = invoiceData?.cust_product.filter((row) => row.material === 1 &&  row.rfp === 0 )

    let materials = invoiceData?.cust_product
        ?.filter(row => row.material === 1 && row.rfp === 0)
        ?.map((row, index) => ({
          ...row,
          newIndexId: index + 1,
          product_description : row.product_description || ''
        }));

    console.log('rfpProduct---', rfpProduct)

    let rfpProductUpdated = rfpProduct?.map(item => ({
      ...item,
      allRfpProductsLocationSame:item.allLocationSame == 1 ? true : false,
    }))
    console.log('rfpProduct---rfpProductUpdated', rfpProductUpdated)

    setSelectedMaterials(materials)
        setCart(rfpProductUpdated)
        const rfpServices = rfpServicesEdit?.filter(item => item?.recipe_id === null && item?.rfp === 1)?.map(serviceItem => ({
          ...serviceItem,
          location: [
            {
              address: serviceItem.address,
              city: serviceItem.city,
              state: serviceItem.state,
              zip: serviceItem.zip,
            }
          ],
        }));
        setCartService(rfpServices)
      const rfqServicesData =
        invoiceData?.cust_product?.flatMap((product) => {
          console.log('product--', product)
          return (product.services || []).map((service) => ({
            ...service,
            productIndex: product.product_index,
            product_id: product.product_id,
            qtyData: product.quantity,
            fromMapServices: product.map_service == 1 ? true : false,
            locationQuantity: product.locationQuantity || 1,
          }))
        }) ?? []
      console.log('##################rfqServiceData', rfqServicesData)
      await setSelectedServices(rfqServicesData)

      const servicesSource = await ensureLabourCostServicesLoaded()
      setFilteredServices(
        computeFilteredServicesForDropdown(servicesSource, rfqServicesData),
      )

      const additionalServices = requestServices?.filter(item => item?.recipe_id === null);
      // const additionalServicesData = additionalServices || [];
      // const additionalServicesData = additionalServices?.filter(dataa => dataa?.service_type != 44) || []
      // const additionalServicesData = sortServicesByProductIndex(
      //   additionalServices?.filter(shouldIncludeRequestServiceInTable) || [],
      const additionalServicesData = dedupeEstimateServicesByLine(
        sortServicesByProductIndex(
          additionalServices?.filter(shouldIncludeRequestServiceInTable) || [],
        ),
      )
      const usedLineIndices = new Set()
      const updatedServicesData = additionalServicesData?.map((serviceItem, index) => {
        let lineIndex = Number(serviceItem?.product_index)
        if (!lineIndex || lineIndex <= 0 || usedLineIndices.has(lineIndex)) {
          lineIndex = index + 1
          while (usedLineIndices.has(lineIndex)) {
            lineIndex += 1
          }
        }
        usedLineIndices.add(lineIndex)
        const isWrite = serviceItem?.is_service_row == 1 || serviceItem?.is_service_row === '1'
        return {
          ...serviceItem,
          backendId: serviceItem.id || null,
          request_service_id: serviceItem.id || null,
          newIndexId: lineIndex,
          indexId: lineIndex,
          product_index: lineIndex,
          productIndex: serviceItem?.product_index,
          productId: serviceItem.labour_cost_service_id || serviceItem.service_id || serviceItem.id,
          labour_cost_service_id:
            serviceItem.labour_cost_service_id || serviceItem.service_id || serviceItem.id,
          name: serviceItem.service_name || serviceItem.name,
          description: serviceItem.service_desc || serviceItem.description,
          serviceAttachments: serviceItem.attachments || serviceItem.serviceAttachments || [],
          entryMode: isWrite ? 'write' : 'choose',
          service_write: serviceItem.service_write,
          isAdditionalProduct: isWrite,
          addedByUserType: serviceItem.addedByUserType ?? serviceItem.added_by_user_type ?? null,
          addresses: [
            {
              address: serviceItem.address,
              city: serviceItem.city,
              state: serviceItem.state,
              zip: serviceItem.zip,
            }
          ]
        };
      });

      const estimateType44Services = updatedServicesData.filter(
        (s) => Number(s?.service_type) === 44 && !isQuotationWriteService(s),
      )
      const tableAdditionalServices = updatedServicesData.filter(
        (s) => Number(s?.service_type) !== 44 || isQuotationWriteService(s),
      )
      const hasLoadedEstimateWriteProducts = (rfqProduct || []).some(
        (p) =>
          isQuotationEstimateWriteProduct(p) &&
          Boolean((p.name || p.product_name || '').trim()),
      )
      // BACKUP: always set estimate catalog + estimators from saved services
      setEstimateCatalogServices(
        hasLoadedEstimateWriteProducts ? estimateType44Services : [],
      )
      setAdditionalSelectedServices(tableAdditionalServices)

      const matchedEstimators = matchEstimatorsFromDetails(details?.estimator_ids, allEstimators)
      if (hasLoadedEstimateWriteProducts && matchedEstimators.length > 0) {
        setSelectedEstimators(matchedEstimators)
        estimatorsHydratedFromDetailsRef.current = true
      } else if (
        hasLoadedEstimateWriteProducts &&
        estimateType44Services.length > 0 &&
        allEstimators?.length > 0 &&
        !details?.estimator_ids
      ) {
        // Match create-estimate autofill when service exists but estimators were not saved yet
        setSelectedEstimators(allEstimators)
        estimatorsHydratedFromDetailsRef.current = true
      } else if (
        hasLoadedEstimateWriteProducts &&
        details?.estimator_ids &&
        !allEstimators?.length
      ) {
        // allEstimators fetch still in flight — recovery useEffect will hydrate
      } else {
        setSelectedEstimators([])
        estimatorsHydratedFromDetailsRef.current = true
      }

      const productAttachmentsMap = {};
      const productLevelRequestAttachments = (productAttached || []).filter(
        (att) => att?.product_id != null,
      );
      (rfqProduct || []).forEach((p) => {
        const idx = p.indexId;
        const mappedByProductId = productLevelRequestAttachments.filter((att) => {
          const requestProductId = Number(att?.product_id);
          if (!Number.isFinite(requestProductId)) return false;
          const productBackendId = Number(p?.backendId);
          const productId = Number(p?.id || p?.product_id);
          return requestProductId === productBackendId || requestProductId === productId;
        });
        const raw = [...(p.productAttachments || p.attachments || []), ...mappedByProductId];
        if (idx != null && idx !== '' && Array.isArray(raw) && raw.length) {
          const key = String(idx)
          productAttachmentsMap[key] = raw.map((att) => ({
            url: att.url || att.file_url || att.name,
            name: att.name || att.file_url || att.url,
            file_type: att.file_type || att.fileType || 'application/octet-stream',
            extension: att.extension || (att.name || '').split('.').pop() || '',
            size: att.size || att.file_size || 0,
            product_index_id: key,
          }));
        }
      });
      if (Object.keys(productAttachmentsMap).length > 0) {
        setProductAttachments(productAttachmentsMap);
      }

      const serviceAttachmentsMap = {};
      (updatedServicesData || []).forEach((svc) => {
        const idx = svc?.newIndexId ?? svc?.indexId;
        const raw = svc.serviceAttachments || svc.attachments;
        if (idx != null && idx !== '' && Array.isArray(raw) && raw.length) {
          const key = String(idx)
          serviceAttachmentsMap[key] = raw.map((att) => ({
            url: att.url || att.file_url || att.name,
            name: att.name || att.file_url || att.url,
            file_type: att.file_type || att.fileType || 'application/octet-stream',
            extension: att.extension || (att.name || '').split('.').pop() || '',
            size: att.size || att.file_size || 0,
            service_index_id: key,
          }));
        }
      });
      // Always set (including {}) so we don't keep stale service attachments from a previous request/session.
      setServiceAttachments(serviceAttachmentsMap);

      
      const shouldCallAssignProject = (updatedServicesData ?? []).some((service) =>
        (service.addresses ?? []).some((loc) =>
          loc.address == null || loc.city == null || loc.state == null || loc.zip == null
        )
      );
      
      const shouldCallAssignProjectRFP = (rfpServices ?? []).some((service) =>
        (service.addresses ?? []).some((loc) =>
          loc.address == null || loc.city == null || loc.state == null || loc.zip == null
        )
      );
      
      const shouldCallAssignProjectProducts = (rfqProduct ?? []).some((product) =>
        !(product.location ?? []).length ||
        (product.location ?? []).some((loc) =>
          loc.address == null || loc.city == null || loc.state == null || loc.zip == null
        )
      );
      
      if(rfqCommunity && (shouldCallAssignProject || shouldCallAssignProjectRFP || shouldCallAssignProjectProducts)){
        assignProjectAgain(rfqCommunity, shouldCallAssignProject, shouldCallAssignProjectRFP, shouldCallAssignProjectProducts);
      }

      console.log("details++++",details)

        setCurrentRFQdata({
          name: details?.name,
          created_at: details?.created_at,
          description: details?.description,
          notes:details?.notes,
          po_number:details?.po_number,
          // skills: rfqSkill,
          // workflow: rfqWorkFlow,
          project_category:rfqProjectcategory,
          markup_type:rfqMarkupType || markupTypes[1] ||null,
          client:rfqCustomerData,
          community:rfqCommunity,
          project_type:rfqProjectType,
          sign_agreement:rfqSignAgreementsData,
          map_service: rfqMapServices,
          start:
            toDateOnlyUnix(details?.start) ??
            toDateOnlyUnix(details?.submission_deadline) ??
            localTodayDateOnlyUnix(),
          end:
            toDateOnlyUnix(details?.end) ??
            toDateOnlyUnix(details?.installation_end_date) ??
            toDateOnlyUnix(details?.participation_ends) ??
            localTodayDateOnlyUnix(),
          installation_start_date: details?.installation_start_date,
          installation_end_date: details?.installation_end_date,
          labour_cost:details?.labour_cost,
          budget:invoiceData?.budget || 0,
          products: rfqProduct || null,
          services: additionalServicesData || null,
          invoice_discount: invoiceData?.extra_discount,
          welcome_message: details?.welcome_message==1?true:false || null,
          total: invoiceData?.total,
          taxAmount: invoiceData?.taxAmount || 0,
          tax: invoiceData?.tax,
          draft: details?.status==1?true:false  || null,
          sub_total: invoiceData?.sub_total,
          order_id:invoiceData?.id,
          subject:details?.subject||null,
          email_content:details?.email_content||null,
          estimate_id:details?.estimate_id,
          customer_name:details?.customer_name,
          facility_type: details?.facility_type,
          show_install_price: details?.show_install_price ?? 1,
          sales_rep_names: details?.sales_rep_names,
          sales_rep_ids: details?.sales_rep_ids,
          all_sales_rep_names: details?.sales_rep_names,
          all_sales_rep_ids: details?.sales_rep_ids,
          bill_to: details?.bill_to || '',
          ship_to: details?.ship_to || '',
          rush_fee: details?.rush_fee,
          rush_fee_amount: details?.rush_fee_amount,
          // avatarUrl:details?.thumbnail||null
        });

        // Parse and set estimators from comma-separated string
        // if (details?.estimator_ids) {
        //   const estimatorIdArray = details.estimator_ids
        //     .split(',')
        //     .map(id => id.trim())
        //     .map(Number)
        //     .filter(id => !isNaN(id));
          
        //   const selectedEstimatorData = allEstimators?.filter(estimator =>
        //     estimatorIdArray.includes(estimator.id)
        //   ) || [];
          
        //   setSelectedEstimators(selectedEstimatorData);
        // } else {
        //   setSelectedEstimators([]);
        // BACKUP: estimatorIdArray.includes(estimator.id) — failed when id types differed (string vs number)
        if (!estimatorsHydratedFromDetailsRef.current) {
          const selectedEstimatorData = matchEstimatorsFromDetails(
            details?.estimator_ids,
            allEstimators,
          )
          if (selectedEstimatorData.length > 0) {
            setSelectedEstimators(selectedEstimatorData)
            estimatorsHydratedFromDetailsRef.current = true
          } else if (!details?.estimator_ids) {
            setSelectedEstimators([])
            estimatorsHydratedFromDetailsRef.current = true
          }
        }
      }
    } catch (error) {
      console.error('Error adding initial data for Sales Order:', error);
    }finally{
      // setTimeout(() => {
      //   setLoading(false)
      // }, 3000);
    }
  };

  const handleAllRfpServiceLocationSameChange = () => {
    
    if (!allRfpServiceLocationSame) {
      // Ensure there's at least one service and its location array is valid
      const commonAddress = cartService[0]?.location?.[0] || {
        address: '',
        city: '',
        state: '',
        zip: '',
      };
  
      console.log("Common Address being applied:", commonAddress);
  
      // Update all locations to use the commonAddress
      setCartService(prevProducts =>
        prevProducts.map(product => ({
          ...product,
          location: product.location ? product.location.map(() => ({ ...commonAddress })) : [{ ...commonAddress }],
        }))
      );
    }
  
    setAllRfpServiceLocationSame(!allRfpServiceLocationSame);
  };

  const handleAllRfpProductsLocationSameChange = (productIndex) => {
    setCart(prevProducts =>
      prevProducts.map((product, index) => {
        if (index === productIndex) {
          const isAllSame = !product.allRfpProductsLocationSame;

          // Keep a single base address; when "all same" is on, edits to first will mirror to others
          const baseAddress = product?.location?.[0] || {
            id: 0,
            address: '',
            city: '',
            state: '',
            zip: '',
          };

          console.log("Common Address being applied:", baseAddress);

          return {
            ...product,
            allRfpProductsLocationSame: isAllSame,
            location: product.location && product.location.length
              ? product.location.map((_, i) => ({ ...baseAddress, id: i }))
              : [{ ...baseAddress }],
          };
        }
        return product;
      })
    );
  };

  useEffect(() => {
    if(details){
      fetchOrderProductDetails();
      if(details?.is_rfp_service_location == 1){
        setAllRfpServiceLocationSame(true)
      }else{
        setAllRfpServiceLocationSame(false)
      }
      if(details?.is_rfp_product_location == 1){
        setAllRfpProductsLocationSame(true)
      }else{
        setAllRfpProductsLocationSame(false)
      }
      if (details?.is_request_estimate == 1 && details?.estimate_job_status != 3) {
        ensureLabourCostServicesLoaded()
      }
      // BACKUP: labour cost services were only loaded on openEdit (initEditForm), not when details first loaded for draft estimates
    }
  }, [details]);

  useEffect(() => {
    if (!openEdit || !details?.id) return
    let cancelled = false
    const initEditForm = async () => {
    setLoading(true)
      await ensureLabourCostServicesLoaded()
      if (!cancelled) {
        await addingInitialdataRFQ()
      }
      if (!cancelled) {
      setLoading(false)
      }
    }
    initEditForm()
    return () => {
      cancelled = true
    }
  }, [openEdit, details?.id])
  // Design→estimate navigates with location.state → auto-opens edit before getAllClients finishes
  // (live partners table is large, so this race is common there and rare locally).
  useEffect(() => {
    if (!openEdit || !customerData?.customer_id || !allClientsEdit?.length) return
    const matchedClient = allClientsEdit.find(
      (cat) => cat?.id != null && String(cat.id) === String(customerData.customer_id),
    )
    if (!matchedClient) return
    setCurrentRFQdata((prev) => {
      if (prev?.client?.id != null && String(prev.client.id) === String(matchedClient.id)) {
        // Already set to the list option (or equivalent id) — still upgrade object ref for Autocomplete
        if (prev.client === matchedClient) return prev
        return { ...prev, client: matchedClient }
      }
      return { ...prev, client: matchedClient }
    })
  }, [openEdit, allClientsEdit, customerData?.customer_id])

  // Hydrate estimators once allEstimators loads (addingInitialdataRFQ can run before that fetch completes)
  useEffect(() => {
    if (!openEdit) {
      estimatorsHydratedFromDetailsRef.current = false
      return
    }
    if (estimatorsHydratedFromDetailsRef.current || !details?.estimator_ids) return
    if (!allEstimators?.length) return
    const hasEstimateWriteProducts = (selectedProducts || []).some((p) =>
      isQuotationEstimateWriteProduct(p),
    )
    if (!hasEstimateWriteProducts) {
      setSelectedEstimators([])
      estimatorsHydratedFromDetailsRef.current = true
      return
    }

    const selectedEstimatorData = matchEstimatorsFromDetails(details.estimator_ids, allEstimators)
    if (selectedEstimatorData.length > 0) {
      setSelectedEstimators(selectedEstimatorData)
      estimatorsHydratedFromDetailsRef.current = true
    }
  }, [openEdit, details?.estimator_ids, allEstimators, selectedProducts])

  useEffect(() => {
    if (!openEdit || !labourCostServices?.length) return
    setFilteredServices(
      computeFilteredServicesForDropdown(labourCostServices, selectedServices),
    )
  }, [openEdit, labourCostServices, selectedServices])

  // const getTransactionTaxDetails = async (estimateDocNumber) => {
  //   try {
  //     if (!estimateDocNumber) return;
  //     const response = await axios.post(`${REST_API}webservice/request/get-qb-transaction-tax-details`, {
  //       estimate_id: estimateDocNumber
  //     });
  //     setTaxRateData(response?.data || {});
  //     console.log('getTransactionTaxDetails response: product_name', response);
  //   } catch (error) {
  //     fetchedTaxEstimateIdRef.current = null;
  //     console.log("error fetching transaction tax details:", error);
  //   }
  // };

  // const estimateDocNumber = details?.doc_number || details?.estimate_id || details?.id;

  // useEffect(() => {
  //   if (!estimateDocNumber) return;
  //   if (fetchedTaxEstimateIdRef.current === estimateDocNumber) return;
  //   fetchedTaxEstimateIdRef.current = estimateDocNumber;
  //   // getTransactionTaxDetails(estimateDocNumber);
  // }, [estimateDocNumber]);
  // The below useEffect is used for fetching the invoice details only.
  // Wait for view-request (`loading` / requestServices) then await product fetch before allowing print.
  useEffect(() => {
    if (!openInvoice) {
      setInvoicePreviewReady(false);
      return;
    }
    if (loading) {
      setInvoicePreviewReady(false);
      return;
    }

    let cancelled = false;
    setInvoicePreviewReady(false);
    (async () => {
      try {
        const invoiceResult = details ? await fetchOrderProductDetails() : null;
        if (cancelled) return;
        const invoiceData = invoiceResult?.data;

        const rfqServicesData = invoiceData?.cust_product?.flatMap((product) => {
          return (product.services || []).map((service) => ({
            ...service,
            productIndex: product.product_index,
            product_id: product.product_id,
            qtyData: product.quantity,
            locationQuantity: product.locationQuantity || 1,
          }));
        });
        const newrfqServicesData = rfqServicesData
          ?.filter((item) => {
            const newQty = parseFloat((item.prQty * item.qtyData * item.locationQuantity)?.toFixed(2));
            return newQty !== item.qty;
          })
          ?.map((item) => {
            const newQty = item.prQty * item.qtyData * item.locationQuantity;
            const quantityDifference = item.qty - newQty;
            return {
              ...item,
              quantity: quantityDifference,
              quantityDifference: quantityDifference,
              total_cost: item.unit_cost * quantityDifference,
            };
          });

        setInvoiceSelectedServices(newrfqServicesData || []);
        const rfpServices = rfpServicesEdit?.filter((item) => item?.recipe_id === null && item?.rfp === 1);
        setCartService(rfpServices);
        if (!cancelled) setInvoicePreviewReady(true);
      } catch (error) {
        console.error('Error loading invoice preview for print:', error);
        if (!cancelled) setInvoicePreviewReady(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [openInvoice, loading]);


  
  const invoiceDate = formatDateOnly(details?.created_at)

  //edit rfq
  // Same stage as Manager Approve/Reject buttons — edit stays visible but blocked
  const isManagerApproveRejectStage = !!(
    details &&
    details?.is_request_estimate == 1 &&
    Number(details?.estimate_job_status) === 3 &&
    (details?.quotation_status === 9 ||
      (details?.quotation_status === 3 &&
        (details?.send_for_manager_approval == 1 ||
          details?.manager_approval_required == 1))) &&
    details?.manager_approval_required == 1 &&
    details?.send_to_client == 0 &&
    details?.project_type != null
  );

  const handleEditClick = async () => {
    if (isManagerApproveRejectStage) {
      enqueueSnackbar('You cannot edit at this stage. Estimate is awaiting manager approval.', {
        variant: 'warning',
      });
      return;
    }
    // NEW: Fetch products when Edit button is clicked
    // if (!openEdit) { // Only fetch when opening edit mode (not closing)
    //   await fetchProducts(); // Wait for products to load
    // }
    if (typeof setOpenEdit === 'function') {
      setOpenEdit(!openEdit);
    }
  }

  const handleEditEstimateClick = async () => {
    if (Number(details?.quotation_status) === 12) {
      enqueueSnackbar('Cannot edit a voided estimate', { variant: 'error' });
      return;
    }
    setIsOpenEdit(true)
  }
  const handleDeleteMenu=()=>{
    setOpenDelete(!openDelete)
  }
  const handleVoidMenu = () => {
    setVoidReason('');
    setVoidReasonError('');
    setOpenVoid(!openVoid);
  }
  const handleVoidEstimate = async () => {
    if (!voidReason.trim()) {
      setVoidReasonError('Reason is required to void this estimate');
      return;
    }

    try {
      setLoadingVoid(true);
      const res = await axios.post(`${REST_API}webservice/quotation/void-estimate`, {
        request_id: Number(id),
        userId,
        reason: voidReason.trim(),
      });

      if (res.data.status === 1) {
        enqueueSnackbar(res.data.message || 'Estimate voided successfully', { variant: 'success' });
        setOpenVoid(false);
        setVoidReason('');
        setVoidReasonError('');
        setDetails((prev) => (prev ? { ...prev, quotation_status: 12, reason: voidReason.trim() } : prev));
        await fetchRequestDetails();
      } else {
        enqueueSnackbar(res.data.message || 'Failed to void estimate', { variant: 'error' });
      }
    } catch (error) {
      console.log(error, 'Error voiding estimate');
      enqueueSnackbar('Failed to void estimate', { variant: 'error' });
    } finally {
      setLoadingVoid(false);
    }
  };

  const handleReopenVoidEstimate = async () => {
    try {
      setLoadingReopenVoid(true);
      const res = await axios.post(`${REST_API}webservice/quotation/reopen-void-estimate`, {
        request_id: Number(id),
        userId,
      });

      if (res.data.status === 1) {
        enqueueSnackbar(res.data.message || 'Estimate reopened successfully', { variant: 'success' });
        setOpenReopenVoid(false);
        await fetchRequestDetails();
      } else {
        enqueueSnackbar(res.data.message || 'Failed to reopen estimate', { variant: 'error' });
        setOpenReopenVoid(false);
      }
    } catch (error) {
      console.log(error, 'Error reopening void estimate');
      enqueueSnackbar('Failed to reopen estimate', { variant: 'error' });
    } finally {
      setLoadingReopenVoid(false);
    }
  };

  const handleReopenVoidMenu = () => {
    setOpenReopenVoid(!openReopenVoid);
  };
  const handleReopen=()=>{
    setReopen(!reOpen)
  }
  const handleConvertToRFQ=()=>{
    setConvertRfq(!convertRfq)
  }
  const handleConvertToDesignOrder=()=>{
    setConvertDesignOrder(!convertDesignOrder)
  }

  // const handleProduct = (value) => {
  //   console.log("#################@@@@@@@@@@Value", value);
  
  //   // Extract community address from Formik's values
  //   const { address: projAddress = '', city: projCity = '', state: projState = '', zip: projZip = '' } = values?.community || {};
  //   const communityAddress = { address: projAddress, city: projCity, state: projState, zip: projZip };
  
  //   setSelectedProducts((prevProducts) => {
  //     const commonAddresses = allLocationSame && prevProducts.length > 0
  //       ? { ...prevProducts[0].location[0] }
  //       : null;
  
  //     const updatedProducts = value.map((product) => {
  //       const dataRetailPrice = product.product_retail_price || product.retail_price;
  //       const dataWholesalePrice = product.product_price || product.price || 0;
  
  //       // Check if the product already exists
  //       const existingProduct = prevProducts.find((p) =>
  //         (p.id === product.id || p.id === product.product_id) &&
  //         p.indexId !== undefined &&
  //         p.indexId === product.indexId
  //       );
  //       console.log("###############ExistingProduct", existingProduct);
  
  //       if (existingProduct) {
  //         // Update existing product's quantity and location
  //         const quantity = existingProduct.quantity;
  //         const locationQuantity = existingProduct.locationQuantity;
  //         const marketingAdjustment = Number(existingProduct?.adjustment);
  
  //         let location = { ...existingProduct.location[0] };
  
  //         // Use common address or project address if applicable
  //         if (allLocationSame && commonAddresses) {
  //           location = { ...commonAddresses };
  //         } else if (projAddress && projCity && projState && projZip) {
  //           location = { ...communityAddress };
  //         }
  
  //         const rowTotal = calculateTotal(
  //           markupType === 1 ? dataWholesalePrice : markupType === 2 ? dataRetailPrice : 0,
  //           product.dataQuantity,
  //           product.dataDiscount,
  //           quantity,
  //           locationQuantity,
  //           marketingAdjustment
  //         );
  
  //         return {
  //           ...existingProduct,
  //           quantity,
  //           rowTotal,
  //           location: [location],
  //         };
  //       } else {
  //         // Add a new product with default location
  //         let newAddress = {
  //           id: 0,
  //           address: '',
  //           city: '',
  //           state: '',
  //           zip: '',
  //         };
  
  //         // Assign location dynamically
  //         if (allLocationSame && commonAddresses) {
  //           newAddress = { ...commonAddresses };
  //         } else if (projAddress && projCity && projState && projZip) {
  //           newAddress = { ...communityAddress };
  //         }
  
  //         const newIndexCounter = indexCounter + 1;
  //         setIndexCounter(newIndexCounter);
  
  //         return {
  //           ...product,
  //           indexId: newIndexCounter,
  //           quantity: 1,
  //           locationQuantity: 1,
  //           discount: 0,
  //           adjustment: 0,
  //           markAdjType: 1,
  //           rowTotal: calculateTotal(
  //             markupType === 1 ? dataWholesalePrice : markupType === 2 ? dataRetailPrice : 0,
  //             product.dataQuantity,
  //             product.dataDiscount,
  //             1,
  //             1,
  //             0
  //           ),
  //           location: [newAddress],
  //         };
  //       }
  //     });

  //     // Merge products from selectedMapserviceProducts with fromMapServices = true into the value
  //     const allSelectedProducts = [
  //       ...updatedProducts,
  //       ...selectedMapserviceProducts?.filter(product => product?.fromMapServices == true)
  //     ];
  
  //     const productServices = allSelectedProducts?.reduce((services, product) => {
  //       if (product.services && product.services.length > 0) {
  //         return services.concat(
  //           product.services.map((service) => ({
  //             ...service,
  //             fromMapServices: product?.fromMapServices,
  //             productIndex: product.indexId,
  //           }))
  //         );
  //       }
  //       return services;
  //     }, []);
  
  //     setSelectedServices((prevServices) => {
  //       const filteredProductServices = productServices.filter((service) => {
  //         return !prevServices.some((existingService) => (
  //           existingService?.labour_cost_service_id === service?.id &&
  //           existingService?.recipe_id === service?.recipe_id &&
  //           existingService?.product_id === service?.product_id &&
  //           existingService?.productIndex === service?.productIndex
  //         ));
  //       });
  
  //       let updatedServices = prevServices.map((service) => ({
  //         ...service,
  //         quantity: service.quantity || 1,
  //         locationQuantity: service.locationQuantity || 1,
  //       }));
  
  //       updatedServices = updatedServices.filter((existingService) =>
  //         productServices.some((service) => (
  //           (existingService?.labour_cost_service_id === service?.id ||
  //             existingService?.id === service?.id) &&
  //           existingService?.recipe_id === service?.recipe_id &&
  //           existingService?.product_id === service?.product_id
  //         ))
  //       );
  
  //       const filteredProductServicesUnique = filteredProductServices.filter((service) => {
  //         return !updatedServices.some((existingService) => (
  //           (existingService?.labour_cost_service_id === service?.id ||
  //             existingService?.id === service?.id) &&
  //           existingService?.recipe_id === service?.recipe_id &&
  //           existingService?.product_id === service?.product_id &&
  //           existingService?.productIndex === service?.productIndex
  //         ));
  //       });
  
  //       return updatedServices.concat(filteredProductServicesUnique);
  //     });
  
  //     const filteredServices =
  //       productServices.length === 0
  //         ? labourCostServices
  //         : labourCostServices.filter(
  //             (service) => !productServices.find((selectedService) => selectedService.id === service.id)
  //           );
  //     setFilteredServices(filteredServices);
  
  //     let initialServicesCost = 0;
  //     if (updatedProducts.length > 0) {
  //       initialServicesCost = updatedProducts.reduce((total, data) => {
  //         return total + (data.quantity * parseFloat(data.expected_total_service_cost?.toFixed(2)));
  //       }, 0);
  //     }
  
  //     setInitialServiceCostInProductFormula(initialServicesCost);
  //     return allSelectedProducts;
  //   });
  // };

  const handleProduct = (value) => {
    // Extract community address from Formik's values
    const { address: projAddress = '', city: projCity = '', state: projState = '', zip: projZip = '' } = values?.community || {};
    const communityAddress = { address: projAddress, city: projCity, state: projState, zip: projZip };
  
    setSelectedProducts((prevProducts) => {
  
      // Determine common address if allLocationSame is enabled
      // const commonAddress = allLocationSame && prevProducts.length > 0
      //   ? { ...prevProducts[0].location[0] }
      //   : null;
      const commonAddress = null;
      
      const updatedProducts = value.map((product) => {
        const dataRetailPrice = product.product_retail_price || product.retail_price;
        const dataWholesalePrice = product.product_price || product.price || 0;
  
        // Check if the product already exists in the selected products
        const existingProduct = prevProducts.find((p) =>
          (p.id === product.id || p.id === product.product_id) &&
          p.indexId !== undefined &&
          p.indexId === product.indexId
        );
  
        console.log("###############ExistingProduct", existingProduct);
  
        if (existingProduct) {
          // Update existing product's quantity and location
          const quantity = existingProduct.quantity;
          const locationQuantity = existingProduct.locationQuantity;
          const marketingAdjustment = Number(existingProduct?.adjustment);
          let location = [...existingProduct.location];
          // Preserve existing address if it exists, otherwise assign dynamically

          if (allLocationSame && commonAddress) {
            // Overwrite all location with the "common" location (from the first product)
            location = [...commonAddress];
          } else {
              // Ensure at least one address object
              for (let i = location.length; i < 1; i++) {
                location.push({
                  id: i,
                  address: '',
                  city: '',
                  state: '',
                  zip: '',
              });
              }
          }
  
          const rowTotal = calculateTotal(
            markupType === 1 ? dataWholesalePrice : markupType === 2 ? dataRetailPrice : 0,
            product.dataQuantity,
            product.dataDiscount,
            quantity,
            locationQuantity,
            marketingAdjustment
          );
  
          return {
            ...existingProduct,
            quantity,
            rowTotal,
            location: location, // Ensure location is always an array
          };
        } else {
          // Add new product with default quantity and location
          const location = commonAddress || {
            id: 0,
            address: communityAddress.address || '',
            city: communityAddress.city || '',
            state: communityAddress.state || '',
            zip: communityAddress.zip || '',
          };
  
          const newIndexCounter = indexCounter + 1;
          setIndexCounter(newIndexCounter);
  
          return {
            ...product,
            indexId: newIndexCounter,
            quantity: 1,
            locationQuantity: 1,
            install_quantity: 1,
            discount: 0,
            allLocationSame: true,
            adjustment: 0,
            addedByUserType: userType,
            markAdjType: 2,
            rowTotal: calculateTotal(
              markupType === 1 ? dataWholesalePrice : markupType === 2 ? dataRetailPrice : 0,
              product.dataQuantity,
              product.dataDiscount,
              1,
              1,
              0
            ),
            location: [location],
            sub_contract_markup : product?.markup,
            product_formula_cost_each: getSingleProductFormulaCostEach(product),
            install_formula_cost_each:
              product?.install_formula_cost_each != null && product?.install_formula_cost_each !== ''
                ? Number(product.install_formula_cost_each)
                : Number(product?.expected_install_labor_cost_with_markup || 0),
            entryMode: 'choose',
          };
        }
      });
       // Reassign indexId starting from 1 for remaining products
    const resetIndexProducts = updatedProducts.map((product, idx) => ({
      ...product,
      indexId: idx + 1 // Reset the index to start from 1
    }));

    setSelectedProducts(resetIndexProducts);
      // Merge products from selectedMapserviceProducts with fromMapServices = true into the value
      const allSelectedProducts = [
        ...updatedProducts,
        ...selectedProducts?.filter((item) => isQuotationWriteRow(item)),
        ...selectedMapserviceProducts?.filter(product => product?.fromMapServices == true)
      ];
      const productServices = allSelectedProducts?.reduce((services, product) => {
        console.log("updatedProducts--product---------", product);
        if (product.services && product.services.length > 0) {
          return services.concat(
            product.services.map((service) => ({
              ...service,
              fromMapServices: product?.fromMapServices,
              productIndex: product.indexId,
              locationQuantity: 1,
            }))
          );
        }
        return services;
      }, []);
  
      setSelectedServices((prevServices) => {
        const filteredProductServices = productServices.filter((service) => {
          console.log("productServices-----service--", service);
          return !prevServices.some(
            (existingService) =>
              existingService?.labour_cost_service_id === service?.id &&
              existingService?.recipe_id === service?.recipe_id &&
              existingService?.product_id === service?.product_id &&
              existingService?.productIndex === service?.productIndex
          );
        });
  
        let updatedServices = prevServices.map((service) => ({
          ...service,
          quantity: service.quantity || 1,
          locationQuantity: service.locationQuantity || 1,
        }));
  
        updatedServices = updatedServices.filter((existingService) =>
          productServices.some(
            (service) =>
              (existingService?.labour_cost_service_id === service?.id ||
                existingService?.id === service?.id) &&
              existingService?.recipe_id === service?.recipe_id &&
              existingService?.product_id === service?.product_id &&
              existingService?.productIndex === service?.productIndex
          )
        );
  
        const filteredProductServicesUnique = filteredProductServices.filter((service) => {
          console.log("filteredProductServicesUnique--service---", service);
          return !updatedServices.some(
            (existingService) =>
              (existingService?.labour_cost_service_id === service?.id ||
                existingService?.id === service?.id) &&
              existingService?.recipe_id === service?.recipe_id &&
              existingService?.product_id === service?.product_id &&
              existingService?.productIndex === service?.productIndex
          );
        });
  
        return updatedServices.concat(filteredProductServicesUnique);
      });
  
      const filteredServices =
        productServices.length === 0
          ? labourCostServices
          : labourCostServices.filter(
              (service) =>
                !productServices.find(
                  (selectedService) => selectedService.id === service.id
                )
            );
      setFilteredServices(filteredServices);

      ///////////////////////for additional service filter
      const updatedAdditionalSelectedServices = additionalSelectedServices?.filter(
        (service) => !productServices.some(
          (selectedService) => selectedService.id === service.id
        )
      );
      
      // Now update the state
      setAdditionalSelectedServices(updatedAdditionalSelectedServices);
      setFieldValue('services', updatedAdditionalSelectedServices)
////////////////////////

  
      let initialServicesCost = 0;
      if (updatedProducts.length > 0) {
        initialServicesCost = updatedProducts.reduce((total, data) => {
          return (
            total +
            data.quantity *
              parseFloat(data.expected_total_service_cost?.toFixed(2))
          );
        }, 0);
      }
  
      setInitialServiceCostInProductFormula(initialServicesCost);
      
      // Calculate installation date based on highest lead_time of selected products
     const patch = getInstallEndPatchFromLead(
          values,
          getBaseUnixForLeadTime(values),
          resetIndexProducts
        );
        if (patch) setFieldValue(patch.field, patch.finalUnix);
      
      return allSelectedProducts;
    });
  };

  const rebuildProductServices = (productsList) => {
    const allSelectedProducts = [
      ...(productsList || []),
      ...(selectedMapserviceProducts || []).filter((product) => product?.fromMapServices === true),
    ]
    const productServices = allSelectedProducts?.reduce((services, product) => {
      if (product.services && product.services.length > 0) {
        return services.concat(
          product.services.map((service) => ({
            ...service,
            productIndex: product?.indexId,
            fromMapServices: product?.fromMapServices,
            quantity: service.quantity * product.quantity * product.locationQuantity,
            previousQty: service.quantity,
            qtyData: product.quantity,
            locationQuantity: product.locationQuantity,
          })),
        )
      }
      return services
    }, [])
    setSelectedServices(productServices)
    const filteredServicesList =
      productServices.length === 0
        ? labourCostServices
        : labourCostServices.filter(
            (service) => !productServices.find((selectedService) => selectedService.id === service.id),
          )
    setFilteredServices(filteredServicesList)
    const updatedAdditionalSelectedServices = additionalSelectedServices?.filter(
      (service) => !productServices.some((selectedService) => selectedService.id === service.id),
    )
    setAdditionalSelectedServices(updatedAdditionalSelectedServices)
    setFieldValue('services', updatedAdditionalSelectedServices)
    const patch = getInstallEndPatchFromLead(values, getBaseUnixForLeadTime(values), productsList)
    if (patch) setFieldValue(patch.field, patch.finalUnix)
  }

  const handleProductDescChange = (indexId, value) => {
    setSelectedProducts((prevProducts) =>
      prevProducts.map((product) => {
        if (product.indexId !== indexId) return product
        if (product.entryMode === 'choose' && product.id) {
          return {
            ...product,
            product_desc: value,
            description: value,
          }
        }
        if (isQuotationProductRowForValues(product)) {
          return { ...product, product_desc: value }
        }
        return product
      }),
    )
  }

  // Product Description typing is echoed here immediately, decoupled from `selectedProducts`.
  // Committing every keystroke into `selectedProducts` re-triggers the grouping useMemos and the
  // totals/pricing useEffect (both O(products)) on every character, which caused visible input lag.
  const [productDescDrafts, setProductDescDrafts] = useState({})
  const productDescDraftsRef = useRef({})
  const productDescTimersRef = useRef({})

  useEffect(() => {
    return () => {
      Object.values(productDescTimersRef.current).forEach((timerId) => clearTimeout(timerId))
    }
  }, [])

  const commitProductDescDraft = (indexId) => {
    const timerId = productDescTimersRef.current[indexId]
    if (timerId) {
      clearTimeout(timerId)
      delete productDescTimersRef.current[indexId]
    }
    if (!(indexId in productDescDraftsRef.current)) return
    const value = productDescDraftsRef.current[indexId]
    delete productDescDraftsRef.current[indexId]
    handleProductDescChange(indexId, value)
    setProductDescDrafts((prev) => {
      if (!(indexId in prev)) return prev
      const next = { ...prev }
      delete next[indexId]
      return next
    })
  }

  const handleProductDescDraftChange = (indexId, value) => {
    productDescDraftsRef.current[indexId] = value
    setProductDescDrafts((prev) => ({ ...prev, [indexId]: value }))
    const existingTimer = productDescTimersRef.current[indexId]
    if (existingTimer) clearTimeout(existingTimer)
    productDescTimersRef.current[indexId] = setTimeout(() => {
      commitProductDescDraft(indexId)
    }, 400)
  }

  const getProductDescDraftValue = (indexId, fallback) =>
    productDescDrafts[indexId] !== undefined ? productDescDrafts[indexId] : fallback

  // Same lag as Product Description: Product Name onChange previously wrote straight into
  // `selectedProducts` on every keystroke, re-triggering the grouping useMemos and the big
  // totals/pricing useEffect. Same draft/debounce echo pattern here.
  const [productNameDrafts, setProductNameDrafts] = useState({})
  const productNameDraftsRef = useRef({})
  const productNameTimersRef = useRef({})

  useEffect(() => {
    return () => {
      Object.values(productNameTimersRef.current).forEach((timerId) => clearTimeout(timerId))
    }
  }, [])

  const commitProductNameDraft = (indexId) => {
    const timerId = productNameTimersRef.current[indexId]
    if (timerId) {
      clearTimeout(timerId)
      delete productNameTimersRef.current[indexId]
    }
    if (!(indexId in productNameDraftsRef.current)) return
    const value = productNameDraftsRef.current[indexId]
    delete productNameDraftsRef.current[indexId]
    setSelectedProducts((prevProducts) =>
      prevProducts.map((product) =>
        product.indexId === indexId
          ? { ...product, name: value, product_name: value }
          : product,
      ),
    )
    setProductNameDrafts((prev) => {
      if (!(indexId in prev)) return prev
      const next = { ...prev }
      delete next[indexId]
      return next
    })
  }

  const handleProductNameDraftChange = (indexId, value) => {
    productNameDraftsRef.current[indexId] = value
    setProductNameDrafts((prev) => ({ ...prev, [indexId]: value }))
    const existingTimer = productNameTimersRef.current[indexId]
    if (existingTimer) clearTimeout(existingTimer)
    productNameTimersRef.current[indexId] = setTimeout(() => {
      commitProductNameDraft(indexId)
    }, 400)
  }

  const getProductNameDraftValue = (indexId, fallback) =>
    productNameDrafts[indexId] !== undefined ? productNameDrafts[indexId] : fallback

  // `indexId` gets renumbered on row delete (handleDeleteProduct) and drag reorder
  // (handleProductTableDragEnd), so a pending 400ms draft commit keyed by indexId could land on
  // a different row than the one the user typed into. Discard (not commit) pending drafts
  // whenever the indexId sequence itself changes; ordinary field edits (including our own
  // debounced commits) never touch indexId, so this never fires for normal typing.
  const prevProductIndexIdSequenceRef = useRef(null)
  useEffect(() => {
    const currentSequence = (selectedProducts || []).map((p) => p.indexId).join(',')
    if (
      prevProductIndexIdSequenceRef.current !== null &&
      prevProductIndexIdSequenceRef.current !== currentSequence
    ) {
      Object.values(productDescTimersRef.current).forEach((timerId) => clearTimeout(timerId))
      productDescTimersRef.current = {}
      productDescDraftsRef.current = {}
      setProductDescDrafts({})

      Object.values(productNameTimersRef.current).forEach((timerId) => clearTimeout(timerId))
      productNameTimersRef.current = {}
      productNameDraftsRef.current = {}
      setProductNameDrafts({})
    }
    prevProductIndexIdSequenceRef.current = currentSequence
  }, [selectedProducts])

  // Service Name: same pattern as Product Name — onChange previously wrote straight into
  // additionalSelectedServices (+ estimateCatalogServices via updateServiceLineInState) on every
  // keystroke, which is a totals-useEffect dependency. Route it through the shared draft hook.
  const serviceNameDraft = useKeyedDraftField((newIndexId, value) =>
    updateServiceLineInState(newIndexId, (service) => ({
      ...service,
      name: value,
      service_name: value,
    })),
  )

  // Service Description: same pattern, for the write-service-row description field. The row can
  // live in either estimateCatalogServices or additionalSelectedServices; rather than trust a
  // isEstimateCatalogServiceRow(data) snapshot captured at typing time (which could be stale by
  // the time the debounce/blur commit fires), the commit looks the row up in both lists at commit
  // time and only updates whichever one actually still contains it.
  const serviceDescDraft = useKeyedDraftField((newIndexId, text) => {
    setEstimateCatalogServices((prev) => {
      if (!(prev || []).some((s) => String(s.newIndexId) === String(newIndexId))) return prev
      return prev.map((s) =>
        String(s.newIndexId) === String(newIndexId)
          ? { ...s, service_desc: text, description: text }
          : s,
      )
    })
    setAdditionalSelectedServices((prev) => {
      if (!(prev || []).some((s) => s.newIndexId === newIndexId)) return prev
      return prev.map((s) =>
        s.newIndexId === newIndexId ? { ...s, service_desc: text, description: text } : s,
      )
    })
  })

  // newIndexId gets renumbered on service delete (handleDeleteService) and drag reorder
  // (handleServiceTableDragEnd/remapServiceIndexIds) — same stale-timer risk as product indexId.
  // Watch both service lists since a row's indexId renumbering can originate from either.
  const prevServiceIndexIdSequenceRef = useRef(null)
  useEffect(() => {
    const currentSequence =
      (additionalSelectedServices || []).map((s) => s.newIndexId).join(',') +
      '|' +
      (estimateCatalogServices || []).map((s) => s.newIndexId).join(',')
    if (
      prevServiceIndexIdSequenceRef.current !== null &&
      prevServiceIndexIdSequenceRef.current !== currentSequence
    ) {
      serviceNameDraft.clearAll()
      serviceDescDraft.clearAll()
    }
    prevServiceIndexIdSequenceRef.current = currentSequence
  }, [additionalSelectedServices, estimateCatalogServices])

  // Material Name: same lag pattern (setSelectedMaterials on every keystroke, a totals-useEffect
  // dependency). Unlike product/service rows, handleDeleteMaterial never renumbers newIndexId
  // and there is no material drag-reorder, so no invalidation guard is needed here.
  const materialNameDraft = useKeyedDraftField((newIndexId, value) =>
    setSelectedMaterials((prevMaterials) =>
      (prevMaterials || []).map((material) =>
        material.newIndexId === newIndexId
          ? { ...material, name: value, product_name: value }
          : material,
      ),
    ),
  )

  // Save-without-blur safety, shared by both save paths (onSubmit and buildDraftPayload): a
  // field can still have a pending draft (typed but not yet committed — commit only happens on
  // the 400ms debounce or blur) if save fires via Enter, submitForm(), or any other path that
  // doesn't blur the focused field first. Overlay those pending draft refs onto fresh copies of
  // the rows, synchronously — reading `*DraftsRef.current` only (never the draft *state*, which
  // is still batched/async at this point), never commitDraft()+setState. Mirrors the exact field
  // writes each live commit function makes, so the payload shape is unchanged.
  const buildDraftSafeCollections = () => {
    const selectedProductsForSave = (selectedProducts || []).map((product) => {
      let next = product
      if (product.indexId in productNameDraftsRef.current) {
        const nameValue = productNameDraftsRef.current[product.indexId]
        next = { ...next, name: nameValue, product_name: nameValue }
      }
      if (product.indexId in productDescDraftsRef.current) {
        const descValue = productDescDraftsRef.current[product.indexId]
        if (next.entryMode === 'choose' && next.id) {
          next = { ...next, product_desc: descValue, description: descValue }
        } else if (isQuotationProductRowForValues(next)) {
          next = { ...next, product_desc: descValue }
        }
      }
      return next
    })

    const applyPendingServiceDraftsForSave = (service) => {
      let next = service
      if (service.newIndexId in serviceNameDraft.draftsRef.current) {
        const nameValue = serviceNameDraft.draftsRef.current[service.newIndexId]
        next = { ...next, name: nameValue, service_name: nameValue }
      }
      if (service.newIndexId in serviceDescDraft.draftsRef.current) {
        const descValue = serviceDescDraft.draftsRef.current[service.newIndexId]
        next = { ...next, service_desc: descValue, description: descValue }
      }
      return next
    }
    const additionalSelectedServicesForSave = (additionalSelectedServices || []).map(
      applyPendingServiceDraftsForSave,
    )
    const estimateCatalogServicesForSave = (estimateCatalogServices || []).map(
      applyPendingServiceDraftsForSave,
    )

    const selectedMaterialsForSave = (selectedMaterials || []).map((material) => {
      if (!(material.newIndexId in materialNameDraft.draftsRef.current)) return material
      const value = materialNameDraft.draftsRef.current[material.newIndexId]
      return { ...material, name: value, product_name: value }
    })

    return {
      selectedProductsForSave,
      additionalSelectedServicesForSave,
      estimateCatalogServicesForSave,
      selectedMaterialsForSave,
    }
  }

  const applyCatalogToProductRow = (indexId, catalogProduct) => {
    const {
      address: projAddress = '',
      city: projCity = '',
      state: projState = '',
      zip: projZip = '',
    } = values?.community || {}
    const existingRow = (selectedProducts || []).find((p) => p.indexId === indexId)
    const catalogLine = {
      ...catalogProduct,
      indexId,
      entryMode: 'choose',
      isAdditionalProduct: false,
      is_product_row: 0,
      product_write:
        Number(existingRow?.product_write) === 1 || existingRow?.is_product_row == 1 ? 1 : 0,
      allLocationSame: true,
      quantity: catalogProduct.quantity || 1,
      locationQuantity: catalogProduct.locationQuantity || 1,
      discount: 0,
      location: [
        {
          id: 0,
          address: projAddress,
          city: projCity,
          state: projState,
          zip: projZip,
        },
      ],
      sub_contract_markup: catalogProduct?.markup,
      is_single_card: values.project_category?.id !== 14,
      addedByUserType: existingRow?.addedByUserType ?? userType,
      isNewlyAddedProductRow: existingRow?.isNewlyAddedProductRow,
    }
    const updated = (selectedProducts || []).map((p) => (p.indexId === indexId ? catalogLine : p))
    setSelectedProducts(updated)
    // rebuildProductServices(updated)
  }

  const handleRowEntryModeChange = (indexId, mode) => {
    const targetRow = selectedProducts.find((row) => row.indexId === indexId)
    if (targetRow && getProductToggleDisplayMode(targetRow) === mode) return

    setGroupSelectedProductIds((prev) =>
      (prev || []).filter((id) => Number(id) !== Number(indexId)),
    )

    setProductRowErrors((prev) => {
      const next = { ...prev }
      delete next[indexId]
      return next
    })
    setProductAttachments((prev) => {
      const next = { ...prev }
      delete next[indexId]
      delete next[String(indexId)]
      return next
    })
    setOpenProductAttachment((prev) => {
      const next = { ...prev }
      delete next[indexId]
      delete next[String(indexId)]
      return next
    })
    if (mode === 'choose') {
      const {
        address: projAddress = '',
        city: projCity = '',
        state: projState = '',
        zip: projZip = '',
      } = values?.community || {}
      setSelectedProducts((prev) =>
        prev.map((row) =>
          row.indexId === indexId
            ? {
                indexId,
                entryMode: 'choose',
                name: '',
                product_name: '',
                isAdditionalProduct: false,
                is_product_row: 0,
                product_write: 0,
                isNewlyAddedProductRow: row?.isNewlyAddedProductRow,
                quantity: 1,
                locationQuantity: 1,
                allLocationSame: true,
                location: [{ id: 0, address: projAddress, city: projCity, state: projState, zip: projZip }],
                is_single_card: values.project_category?.id !== 14,
                addedByUserType: row?.addedByUserType ?? userType,
              }
            : row,
        ),
      )
      return
    }
    setSelectedProducts((prev) =>
      prev.map((row) => {
        if (row.indexId !== indexId) return row
        const empty = createEmptyQuotationProductRow(
          indexId,
          values?.community,
          values?.project_category?.id,
        )
        if (details?.is_request_estimate == 1) {
          return {
            ...empty,
            is_product_row: 1,
            product_write: 1,
            isAdditionalProduct: false,
            isNewlyAddedProductRow: row?.isNewlyAddedProductRow,
            addedByUserType: row?.addedByUserType ?? userType,
          }
        }
        return {
          ...empty,
          isNewlyAddedProductRow: row?.isNewlyAddedProductRow,
          addedByUserType: row?.addedByUserType ?? userType,
        }
      }),
    )
  }

  const openCatalogPickerForRow = (indexId, existingCatalog = null) => {
    setCatalogPickerRowIndexId(indexId)
    if (existingCatalog?.id != null) {
      const base = (allProducts || []).find((p) => p.id === existingCatalog.id) || existingCatalog
      setCatalogPickerDraft({ ...base, quantity: existingCatalog.quantity ?? base.quantity ?? 1 })
    } else {
      setCatalogPickerDraft(null)
    }
    setCatalogPickerOpen(true)
  }

  const confirmCatalogPicker = () => {
    if (!catalogPickerDraft) {
      enqueueSnackbar('Please select a catalog product', { variant: 'warning' })
      return
    }
    const rowIndexId = catalogPickerRowIndexId
    const existingRow = selectedProducts.find((p) => p.indexId === rowIndexId)
    if (existingRow?.id && existingRow.id !== catalogPickerDraft.id) {
      setProductAttachments((prev) => {
        const next = { ...prev }
        delete next[rowIndexId]
        return next
      })
      setOpenProductAttachment((prev) => {
        const next = { ...prev }
        delete next[rowIndexId]
        return next
      })
    }
    applyCatalogToProductRow(rowIndexId, catalogPickerDraft)
    setCatalogPickerOpen(false)
    setCatalogPickerRowIndexId(null)
    setCatalogPickerDraft(null)
    setProductRowErrors((prev) => {
      const next = { ...prev }
      delete next[rowIndexId]
      return next
    })
  }

  const handleDuplicateSalesOrder = async () => {
    try {
      // 🚀 PROGRESS TRACKING: Show progress modal and make API call
      const requestData = {
        userId,
        request_id: id,
        processType: 'duplicate_estimate',
        userType,
        socketId: null // Will be set by the progress modal
      };

      setProgressHeading("Duplicating Sales Order");
      setProgressRequestData(requestData);
      setShowProgressModal(true);
      
      // Wait for socket connection to establish and stabilize
      await new Promise(resolve => setTimeout(resolve, 2000));
      
      // Additional wait if socket is not ready yet
      if (!socketReady) {
          console.log('[PROGRESS-MODAL] ⏳ Waiting for socket connection...');
          await new Promise(resolve => setTimeout(resolve, 1000));
      }
      
      const response = await axios.post(`${REST_API}webservice/duplicate-request`, requestData);

      if(response?.data?.status === 1){
      enqueueSnackbar(response?.data?.message, { variant: 'success' });
      // if(details?.is_request_estimate == 1){
      if(response?.data?.createJob){
        console.log('convert to job')
        await handleConvertToJob(false, response?.data?.request_id, false)
      }else{
        if(popupOn){
        closeView()
        localStorage.removeItem('salesOrderProjectId');
        localStorage.removeItem('salesOrderProjectName');
        localStorage.removeItem('isEditSalesOrder');
        localStorage.removeItem('salesOrderOpenPopup',);
        setRenderCards(!renderCards)
        onDataChange()
        setShowProgressModal(false);
      }else{
        navigate(PATH_DASHBOARD.official.root)
        setShowProgressModal(false);
      }
    }
      }
    } catch (error) {
      setShowProgressModal(false);
      console.error("Error duplicating sales order:", error);
      enqueueSnackbar('Error duplicating sales order:', { variant: 'error' });
    }
  };
  console.log("###############ExistingProduct111",selectedProducts);
console.log('selectedServices-------',selectedServices);

// const handleAllLocationSameChange = () => {
 
//   console.log("##################Alllll",allLocationSame);
//   if (!allLocationSame) {
//     const commonAddress = selectedProducts[0]?.location[0] || {
//       address: '',
//       city: '',
//       state: '',
//       zip: '',
//     };
//     console.log("##################Alllll",commonAddress);
//     setSelectedProducts(prevProducts =>
//       prevProducts.map(product => ({
//         ...product,
//         location: product.location.map(() => commonAddress),
//       }))
//     );
//   }
//   setAllLocationSame(!allLocationSame);
// };

  const handleAllLocationSameChange = (productIndex) => {
    setSelectedProducts(prevProducts =>
      prevProducts.map((product, index) => {
        if (index === productIndex) {
          console.log('productIndex--1---', index)
          console.log('productIndex--2---', productIndex)

          // Toggle allLocationSame flag
          const isAllSame = !product?.allLocationSame;
          // Get the first address of the selected product
          const commonAddress = product.location[0] || {
            address: '',
            city: '',
            state: '',
            zip: '',
          };

          return {
            ...product,
            allLocationSame: isAllSame,
            location: product.location.map(() => commonAddress),
          };
        }
        return product;
      })
    );
  };
  const handleDeleteProduct = (productId, indexId) => {
    const fileredProduct = selectedProducts.filter(data => !((data.id || data.product_id) === productId && data.indexId === indexId))
    const resetIndexProducts = fileredProduct.map((product, idx) => ({
      ...product,
      indexId: idx + 1 // Reset the index to start from 1
    }));

    setProductAttachments((prev) => {
      const next = {};
      fileredProduct.forEach((product, idx) => {
        const oldIndexId = String(product.indexId ?? '');
        const newIndexId = String(idx + 1);
        if (prev[oldIndexId]?.length) {
          next[newIndexId] = prev[oldIndexId].map((f) => ({
            ...f,
            product_index_id: newIndexId,
          }));
        }
      });
      return next;
    });
    const remapIdx = (prev) => {
      const next = {};
      fileredProduct.forEach((product, idx) => {
        const oldKey = String(product.indexId ?? '');
        const newKey = String(idx + 1);
        if (prev[oldKey] !== undefined) next[newKey] = prev[oldKey];
      });
      return next;
    };
    setOpenProductAttachment((prev) => remapIdx(prev));
    setAttachmentTabValue((prev) => remapIdx(prev));
    setSelectedUploadedImages((prev) => remapIdx(prev));
    setIsUploadingProduct((prev) => remapIdx(prev));

    setFieldValue('products', resetIndexProducts);
    setSelectedProducts(resetIndexProducts);
    // setFieldValue('products', fileredProduct);
    // setSelectedProducts(fileredProduct)
    const quantityFieldName = `quantity_${productId}`;
    const discountFieldName = `discount_${productId}`;
    setFieldValue(quantityFieldName, 1);
    setFieldValue(discountFieldName, 1);
    console.log('fileredProduct-------',fileredProduct);
    console.log('selectedServices-------',selectedServices);
    console.log("###############InitialserviceCost",initialServiceCostInProductFormula);
    const filteredServices = selectedServices?.filter(service => {
      // Check if there is any product in fileredProduct array which contains the service
      return fileredProduct?.some(product => (
          product?.recipe_id === service?.recipe_id &&
          product?.id === service?.product_id &&
          product?.indexId === service?.productIndex
      ));
  });
 

  setSelectedServices(filteredServices);
  
    setSelectedServices(filteredServices);
    let initialServicesCost=0
          if(fileredProduct.length>0){
            initialServicesCost = fileredProduct?.reduce((total, data, index) => {
              return total + ((data?.quantity)*(parseFloat(data?.expected_total_service_cost?.toFixed(2))));
            }, 0);
          }
    console.log('initialServiceCost In ProductFormula-----',initialServicesCost);
    setInitialServiceCostInProductFormula(initialServicesCost)
    
    // Recalculate installation date based on remaining products
     const patch = getInstallEndPatchFromLead(
        values,
        getBaseUnixForLeadTime(values),
        resetIndexProducts
      );
      if (patch) setFieldValue(patch.field, patch.finalUnix);

    const hasRemainingMeaningfulWriteRows =
      resetIndexProducts.some(
        (p) =>
          isQuotationEstimateWriteProduct(p) &&
          (Boolean(p?.id) || Boolean((p.name || p.product_name || '').trim())),
      ) ||
      // BACKUP: isQuotationWriteRow(p) &&
      (additionalSelectedServices || []).some(
        (s) =>
          isQuotationWriteService(s) &&
          (Boolean(s?.id) || Boolean((s.name || s.service_name || '').trim())),
      ) //||
      // (productRows || []).some(
      //   (r) =>
      //     Number(r?.is_product_row) === 1 &&
      //     Boolean((r?.product_name || '').trim()),
      // ) ||
      // (serviceRows || []).some(
      //   (r) =>
      //     Number(r?.is_service_row) === 1 &&
      //     Boolean((r?.service_name || '').trim()),
      // );
      console.log("hasRemainingMeaningfulWriteRows",hasRemainingMeaningfulWriteRows)
      console.log("hasRemainingMeaningfulWriteRows 2",resetIndexProducts)
      console.log("hasRemainingMeaningfulWriteRows 3",additionalSelectedServices)
      console.log("hasRemainingMeaningfulWriteRows 4",productRows)
      console.log("hasRemainingMeaningfulWriteRows 5",serviceRows)
      console.log("hasRemainingMeaningfulWriteRows 6",additionalSelectedServices)

    if (!hasRemainingMeaningfulWriteRows) {
      // clearEstimateCatalogAndEstimators()
      setEstimateCatalogServices([]);
      setSelectedEstimators([]);
      estimateServiceAutofillDoneRef.current = false;
      setAdditionalSelectedServices((prev) => {
        const next = (prev || []).filter((service) => !isEstimateCatalogServiceRow(service));
        if (next.length === (prev || []).length) return prev;
        setFieldValue('services', next);
        return next;
      });
      // const filteredServices = additionalSelectedServices?.filter(service => service.service_type != 44)
      // setAdditionalSelectedServices(filteredServices)
      // setFieldValue('services', filteredServices)
      // console.log("hasRemainingMeaningfulWriteRows 7",filteredServices)


    }

  }

  const handleDeleteInstallCost = (productId, indexId) => {
    const updatedProducts = (selectedProducts || []).map((product) => {
      if (Number(product?.indexId) !== Number(indexId)) return product
      const cleared = clearCatalogInstallCost(product)
      return {
        ...cleared,
        retail_price: cleared.actual_retail_price,
      }
    })

    setSelectedProducts(updatedProducts)
    setFieldValue('products', updatedProducts)
    setRefreshCalculation((v) => !v)
  }

  /** Remove every line item in a product group (same net effect as deleting each member). */
  const handleDeleteGroup = (groupId) => {
    const sid = String(groupId)
    const fileredProduct = (selectedProducts || []).filter((p) => String(p?.group_id) !== sid)
    const resetIndexProducts = fileredProduct.map((product, idx) => ({
      ...product,
      indexId: idx + 1,
    }))

    setProductAttachments((prev) => {
      const next = {}
      fileredProduct.forEach((product, idx) => {
        const oldIndexId = String(product.indexId ?? '')
        const newIndexId = String(idx + 1)
        if (prev[oldIndexId]?.length) {
          next[newIndexId] = prev[oldIndexId].map((f) => ({
            ...f,
            product_index_id: newIndexId,
          }))
        }
      })
      return next
    })
    const remapIdx = (prev) => {
      const next = {}
      fileredProduct.forEach((product, idx) => {
        const oldKey = String(product.indexId ?? '')
        const newKey = String(idx + 1)
        if (prev[oldKey] !== undefined) next[newKey] = prev[oldKey]
      })
      return next
    }
    setOpenProductAttachment((prev) => remapIdx(prev))
    setAttachmentTabValue((prev) => remapIdx(prev))
    setSelectedUploadedImages((prev) => remapIdx(prev))
    setIsUploadingProduct((prev) => remapIdx(prev))

    setOpenGroupedRows((prev) => {
      const next = { ...prev }
      delete next[groupId]
      delete next[sid]
      return next
    })
    setGroupProductMarketingValues((prev) => {
      const next = { ...prev }
      delete next[groupId]
      delete next[sid]
      return next
    })
    setGroupInstallMarketingValues((prev) => {
      const next = { ...prev }
      delete next[groupId]
      delete next[sid]
      return next
    })
    setGroupEditMode({})
    setGroupSelectedProductIds([])
    setCustomerOrderProductGroups((prev) =>
      (prev || []).filter((g) => String(g?.id ?? g?.group_id) !== sid),
    )

    setFieldValue('products', resetIndexProducts)
    setSelectedProducts(resetIndexProducts)

    const filteredServices = selectedServices?.filter((service) =>
      fileredProduct?.some(
        (product) =>
          product?.recipe_id === service?.recipe_id &&
          product?.id === service?.product_id &&
          product?.indexId === service?.productIndex,
      ),
    )
    setSelectedServices(filteredServices)

    let initialServicesCost = 0
    if (fileredProduct.length > 0) {
      initialServicesCost = fileredProduct?.reduce((total, data) => {
        return total + (data?.quantity || 0) * parseFloat(data?.expected_total_service_cost?.toFixed(2) || 0)
      }, 0)
    }
    setInitialServiceCostInProductFormula(initialServicesCost)

    const productsWithLeadTime = fileredProduct.filter((product) => product.lead_time && product.lead_time > 0)
    if (productsWithLeadTime.length > 0) {
      const highestLeadTime = Math.max(...productsWithLeadTime.map((product) => product.lead_time))
      setFieldValue('end', dateOnlyToUnix(moment().add(highestLeadTime, 'days')))
    } else {
      setFieldValue('end', localTodayDateOnlyUnix())
    }

    setRefreshCalculation((v) => !v)
  }

  /** Clear install pricing on every member of a group (group Install Price row delete). */
  const handleDeleteGroupInstall = (groupId) => {
    const sid = String(groupId)
    const updatedProducts = (selectedProducts || []).map((product) => {
      if (
        !isSameGroupId(
          product?.group_id ?? product?.customer_order_product_group_id,
          groupId,
        )
      ) {
        return product
      }
      const cleared = clearCatalogInstallCost(product)
      return {
        ...cleared,
        retail_price: cleared.actual_retail_price,
      }
    })

    setSelectedProducts(updatedProducts)
    setFieldValue('products', updatedProducts)

    setGroupInstallMarketingValues((prev) => {
      const next = { ...prev }
      delete next[groupId]
      delete next[sid]
      return next
    })
    setGroupInstallRetailDrafts((prev) => {
      const next = { ...prev }
      delete next[groupId]
      delete next[sid]
      return next
    })
    setCustomerOrderProductGroups((prev) =>
      (prev || []).map((g) => {
        if (String(g?.id ?? g?.group_id) !== sid) return g
        return {
          ...g,
          install_marketing_adjustment: 0,
          install_marketing_adj_value_type: true,
          installMarketingAdjustment: 0,
          installMarketingAdjValueType: true,
        }
      }),
    )
    delete prevGroupFormulaTotalsRef.current.install[sid]
    delete prevGroupFormulaTotalsRef.current.install[groupId]

    setRefreshCalculation((v) => !v)
  }

  useEffect(() => {
    const hasUnifiedWriteRows =
      (selectedProducts || []).some(
        (p) =>
          isQuotationEstimateWriteProduct(p) &&
          (Boolean(p?.id) || Boolean((p.name || p.product_name || '').trim())),
      ) ||
      // BACKUP: isQuotationWriteRow(p) &&
      (additionalSelectedServices || []).some(
        (s) =>
          isQuotationWriteService(s) &&
          (Boolean(s?.id) || Boolean((s.name || s.service_name || '').trim())),
      )
    if (hasUnifiedWriteRows) return
    if (details?.is_request_estimate != 1 || details?.estimate_job_status == 3) return
    if (!filteredServices?.length) return
    if ((productRows?.length > 0 || serviceRows?.length > 0) &&
        !additionalSelectedServices?.some(serv => serv?.service_type === 44 && serv?.status === 1) &&
        !(estimateCatalogServices || []).length
      ) {
    const allFilteredServices = filteredServices?.filter(
      (item) => item.service_type == 44 && item.status === 1,
    )
    const sortedServices = allFilteredServices?.sort((a, b) => a.id - b.id)
    const defaultEstimateService = sortedServices?.[0]
    if (!defaultEstimateService) return

    setAdditionalSelectedServices((prev) => {
      if (prev?.some((serv) => serv?.service_type === 44 && serv?.status === 1)) {
        return prev
      }
      const updatedServices = [
        {
          ...defaultEstimateService,
          newIndexId: indexCounterService + serviceRowsIndexCounter + 1,
          indexId: indexCounterService + serviceRowsIndexCounter + 1,
          product_index: indexCounterService + serviceRowsIndexCounter + 1,
          quantity: 1,
          note: '',
        },
      ]
      const finalServices = [...updatedServices, ...prev]
      setFieldValue('services', finalServices)
      if (finalServices?.length > 0) {
        // setSelectedEstimators(allEstimators || [])
      } else {
        setSelectedEstimators([])
      }
      const maxIndexId = Math.max(
        ...updatedServices.map((s) => s.product_index || s.indexId || 0),
        indexCounterService,
      )
      setServiceIndexCounter(maxIndexId)
      return finalServices
    })
  }
  }, [
    details?.is_request_estimate,
    details?.estimate_job_status,
    filteredServices,
    estimateCatalogServices,
    productRows,
    serviceRows,
    allEstimators,
    indexCounterService,
    serviceRowsIndexCounter,
  ])

  // useEffect(()=>{
  //   const hasUnifiedWriteRows =
  //     (selectedProducts || []).some(
  //       (p) =>
  //         isQuotationWriteRow(p) &&
  //         (Boolean(p?.id) || Boolean((p.name || p.product_name || '').trim())),
  //     ) ||
  //     (additionalSelectedServices || []).some(
  //       (s) =>
  //         isQuotationWriteService(s) &&
  //         (Boolean(s?.id) || Boolean((s.name || s.service_name || '').trim())),
  //     )
  //   if (hasUnifiedWriteRows) return
  //   if ((productRows?.length > 0 || serviceRows?.length > 0) &&
  //     !additionalSelectedServices?.some(serv => serv?.service_type === 44 && serv?.status === 1) &&
  //     !(estimateCatalogServices || []).length
  //   ) {
  //     console.log('fffffffffffffffff')
  //     const allFilteredServices = filteredServices?.filter(item => item.service_type == 44 && item.status === 1)
  //     // Sort the services based on their id (ascending order)
  //     const sortedServices = allFilteredServices?.sort((a, b) => a.id - b.id);
  //     // Map over the newly selected services and preserve existing properties
  //     const updatedServices = sortedServices?.map((service, index) => {
  //       if (index === 0) {
  //         return {
  //           ...service,
  //           newIndexId: indexCounterService + serviceRowsIndexCounter + 1,
  //           indexId: indexCounterService + serviceRowsIndexCounter + 1,
  //           product_index: indexCounterService + serviceRowsIndexCounter + 1,
  //           quantity: 1,
  //           note: '' // Initialize note as empty string
  //         }
  //       }
  //       return null; // Exclude other services by returning null or simply omit them
  //     })?.filter(service => service !== null) || [];
  //     console.log('indexindexindex==3',updatedServices)
  //     // Update the service index counter for new services
  //     if (updatedServices.length > 0) {
  //       const maxIndexId = Math.max(
  //         ...updatedServices.map(s => s.product_index || s.indexId ||0),
  //         indexCounterService
  //       );
  //       setServiceIndexCounter(maxIndexId);
  //     }
  //     // Update Formik's 'services' field
  //     const finalServices = [...updatedServices,...additionalSelectedServices];
  //     setFieldValue('services', finalServices);
  //     setAdditionalSelectedServices(finalServices);
  //     if(finalServices?.length > 0){
  //       setSelectedEstimators(allEstimators || [])
  //     }else{
  //       setSelectedEstimators([])
  //     }
  //   }
  // },[])
    
  // show install price in view declaration  
    const showInstallPriceInView = details?.show_install_price === 1;

  /** Same contract as ViewOfficialRequest: product rows isService:0, additional services isService:1 — required for editRequest to insert request_service_locations. */
  const buildCombinedAddressPayload = () => {
    const prodAddress = (selectedProducts || []).reduce((acc, product) => {
      return [
        ...acc,
        ...(product.location || []).map((address) => ({
          ...address,
          productId: product.id,
          productIndex: product.indexId,
          isService: 0,
        })),
      ];
    }, []);
    const serviceAddress = (additionalSelectedServices || []).reduce((acc, product) => {
      const locs = product.addresses?.length
        ? product.addresses
        : product.address || product.city || product.state || product.zip
          ? [
              {
                address: product.address || '',
                city: product.city || '',
                state: product.state || '',
                zip: product.zip || '',
              },
            ]
          : [];
      if (!locs.length) return acc;
      return [
        ...acc,
        ...locs.map((address) => ({
          ...address,
          productId: product.labour_cost_service_id || product.id,
          productIndex: product.indexId,
          newIndexId: product.newIndexId,
          isService: 1,
        })),
      ];
    }, []);
    return [...serviceAddress, ...prodAddress];
  };

    const currentRushFeePercentage = Number(data?.rush_fee_percentage) || 0;
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: currentRFQData.name || '',
      created_at: currentRFQData.created_at || null,
      po_number: currentRFQData.po_number || '',
      description: currentRFQData.description || '',
      notes:currentRFQData.notes || '',
      clients:currentRFQData.client || null,
      sales_rep_names: currentRFQData.sales_rep_names || '',
      sales_rep_ids: currentRFQData.sales_rep_ids || '',
      // skills: currentRFQData.skills || [],
      // workflow: currentRFQData.workflow || [],
      project_type:currentRFQData.project_type || null,
      sign_agreement:currentRFQData.sign_agreement || [],
      project_category:currentRFQData.project_category || null,
      community:currentRFQData.community || null,
      map_service:currentRFQData.map_service || null,
      start: toDateOnlyUnix(currentRFQData.start) ?? localTodayDateOnlyUnix(),
      end: toDateOnlyUnix(currentRFQData.end) ?? localTodayDateOnlyUnix(),
      installation_start_date: currentRFQData.installation_start_date || null,
      installation_end_date: currentRFQData.installation_end_date || null,
      // avatarUrl: currentRFQData.avatarUrl||'',
      products: currentRFQData.products || [],
      services: currentRFQData.services || [],
      markup_type:currentRFQData.markup_type || null,
      invoice_discount: currentRFQData.invoice_discount || '',
      welcome_message: currentRFQData.welcome_message || false,
      draft: currentRFQData.draft || false,
      total: currentRFQData.total || '',
      client_approve : (details?.is_request_estimate == 1 && details?.estimate_job_status == 3) ? true : clientApprove == 0 ? false : true,
      // Regular estimates (no job): never require manager approval.
      // Estimate jobs: respect saved value from EditEstimateJob (manual toggle only).
      // Previous (also auto-ON when total > limit):
      // manager_approval_required: (details?.is_request_estimate == 1 && details?.estimate_job_status == 3) ? true : (parseFloat(currentRFQData?.total || 0) > (Number(data?.manager_approval_amount) || 5000) ? true : managerApprovalRequired == 0 ? false : true),
      manager_approval_required: details?.is_request_estimate == 1
        ? (managerApprovalRequired == 0 ? false : true)
        : false,
      // is_single_card: singleLocationCard  ? true : false,
      show_install_price: currentRFQData.show_install_price ?? 1,
      rush_fee: currentRFQData.rush_fee || 0,
      rush_fee_amount: currentRFQData.rush_fee_amount || 0,
      labour_cost: currentRFQData.labour_cost || 0,
      budget: currentRFQData.budget || 0,
      tax: 0,
      order_id:currentRFQData.order_id||'',
      subject:currentRFQData.subject||'',
      email_content:currentRFQData.email_content||'',
      rfp:null,
      estimate_id:currentRFQData?.estimate_id,
      customer_name:currentRFQData?.customer_name,
      editReq:true,
      is_split:isSplitOrder ? { id: 1, label: 'Split' } : null,
      split_catalog_type: splitOrderCatalogTypes.find((type) => type.id === currentRFQData?.split_catalog_type) || splitOrderCatalogTypes.find((type) => type.id === 'all'),
      facility_type: typeof currentRFQData?.facility_type === 'string' && currentRFQData.facility_type
      ? currentRFQData.facility_type.split(',').map(id => 
          FacilityTypes.find(type => type.id == id.trim())
        ).filter(Boolean)
      : Array.isArray(currentRFQData?.facility_type) 
        ? currentRFQData.facility_type 
        : (isSplitOrder ? FacilityTypes?.filter(fac => fac.default) || [] : []) ,
      bill_to: currentRFQData.bill_to || '',
      ship_to: currentRFQData.ship_to || '',
    },
    validationSchema: NewUserSchema,
    onSubmit: async (values, { setSubmitting, resetForm, setErrors }) => {
      try {
        const isUpdateRequestFlow = updateRequestClickedRef.current;
        updateRequestClickedRef.current = false;
        setIsSubmitted(true);

        // Save-without-blur safety net: submit can fire via Enter, submitForm(), or any other
        // path that doesn't blur the focused field first, leaving the latest typed text only in
        // a draft ref. buildDraftSafeCollections() (shared with buildDraftPayload's Save-as-Draft
        // path) overlays those pending drafts synchronously before anything below reads these
        // arrays, for both validation and payload construction.
        const {
          selectedProductsForSave,
          additionalSelectedServicesForSave,
          estimateCatalogServicesForSave,
          selectedMaterialsForSave,
        } = buildDraftSafeCollections()

        // const hasEmptyProductRowName = productRows?.some(product => (product.product_name || '').trim() === '');
        // const hasEmptyProductName = selectedProductsForSave?.some(product => (product.name || product.product_name || '').trim() === '');
        const hasEmptyProductName = selectedProductsForSave?.some((product) => {
          if (isQuotationChooseEmptyRow(product)) return false
          if (isBlankEstimatePlaceholderRow(product)) return false
          return !(product.name || product.product_name || '').trim()
        })
        const hasEmptyServiceName = additionalSelectedServicesForSave?.some(
          (service) =>
            isQuotationWriteService(service) && !(service.name || service.service_name || '').trim(),
        );
        const hasEmptyMaterialName = selectedMaterialsForSave?.some(product => (product.name || product.product_name || '').trim() === '');

        let errors = {};
        // Validate product rows for empty product_name when description exists
        productRows.forEach((row) => {
          // if (!row.product_name.trim() && row.product_desc.trim()) {
          const rowName = (row.product_name || '').trim()
          const rowDesc = (row.product_desc || '').trim()
          if (!rowName && rowDesc) {
            errors[row.indexId] = 'Product name is required when description is provided';
          }
        });

        // If errors are found, set rowErrors and stop submission
        if (Object.keys(errors).length > 0) {
          setRowErrors(errors);  // Update rowErrors state
          enqueueSnackbar('Please fill in all required product names if a description is provided.', { variant: 'error' });
          return; // Stop form submission
        }

        if (
          (selectedProductsForSave || []).some(
            (product) => !product?.fromMapServices && isQuotationChooseEmptyRow(product),
          )
        ) {
          enqueueSnackbar('Please select a catalog product for each Choose row, or switch to Write.', { variant: 'error' })
          return
        }
        if (additionalSelectedServicesForSave?.some((s) => isQuotationChooseEmptyService(s))) {
          // enqueueSnackbar('Please select a service for each service row.', { variant: 'error' })
          enqueueSnackbar('Please select a catalog service for each Choose row, or switch to Write.', { variant: 'error' })
          return
        }
        const hasAnyProductRowFlag = (selectedProductsForSave || []).some((row) =>
          isQuotationEstimateWriteProduct(row),
        )
        // BACKUP: (selectedProductsForSave || []).some((row) => isQuotationWriteRow(row))
        const hasAnyServiceRowFlag =
          (additionalSelectedServicesForSave || []).some((row) => isQuotationWriteService(row)) ||
          (serviceRows || []).some((row) => (row?.service_name || '').trim() !== '')
        const effectiveIsRequestEstimate =
          Number(details?.is_request_estimate) === 1 || hasAnyProductRowFlag || hasAnyServiceRowFlag

        const hasEstimateCatalogSelected =
          (estimateCatalogServicesForSave || []).length > 0 ||
          (additionalSelectedServicesForSave || []).filter((item) => Number(item?.service_type) === 44).length > 0
        if((!effectiveIsRequestEstimate || (effectiveIsRequestEstimate && details?.estimate_job_status == 3 && productRows?.length <= 0 && !hasMeaningfulEstimateWriteRows)) && selectedProductsForSave?.length ==0 && additionalSelectedServicesForSave?.length == 0 && (estimateCatalogServicesForSave || []).length === 0 && userType !==3){
          enqueueSnackbar('Please add at least one product or service.', { variant: 'error' });
          return;
        }
        if (
          hasMeaningfulEstimateWriteRows &&
          !hasEstimateCatalogSelected &&
          userType !== 3
        ) {
          enqueueSnackbar('Please choose an estimate service.', { variant: 'error' });
          return;
        }
        if (
          hasMeaningfulEstimateWriteRows &&
          selectedEstimators?.length <= 0 &&
          userType !== 3 &&
          !isClient
        ) {
          enqueueSnackbar('Please choose atleast one estimator', {variant: 'error',})
          return;
        }
        // if (effectiveIsRequestEstimate && hasEmptyProductRowName && details?.estimate_job_status == 3) {
        // BACKUP: effectiveIsRequestEstimate && hasEmptyRequiredWriteProductName — skipped blank Write placeholders
        if (effectiveIsRequestEstimate && hasUnnamedWriteProductRow(selectedProductsForSave)) {
          enqueueSnackbar('Please fill in all required product names.', { variant: 'error' });
          return;
        }
        if (!effectiveIsRequestEstimate && hasEmptyProductName) {
          enqueueSnackbar('Please fill in all required product names.', { variant: 'error' });
          return;
        }
        if (!effectiveIsRequestEstimate && hasEmptyServiceName) {
          enqueueSnackbar('Please fill in all required service names.', { variant: 'error' });
          return;
        }
        if (!effectiveIsRequestEstimate && hasEmptyMaterialName) {
          enqueueSnackbar('Please fill in all required material names.', { variant: 'error' });
          return;
        }
        const hasInvalidProductName = selectedProductsForSave?.filter((item) => isQuotationWriteRow(item))?.some(product => {
          const newName = product.product_name || product.name;
          const trimmedName = newName.trim();
          if (trimmedName === '.') {
            enqueueSnackbar('Product name cannot be just a dot.', { variant: 'error' });
            return true;
          }
          if (trimmedName === '-') {
            enqueueSnackbar('Product name cannot be just a hyphen.', { variant: 'error' });
            return true;
          }
          // if (!/^[a-zA-Z0-9\s-]+$/.test(trimmedName)) {
          //   enqueueSnackbar('Product name can only contain letters, numbers, and hyphens.', { variant: 'error' });
          //   return true;
          // }
          if (/[:]/.test(trimmedName)) {
            enqueueSnackbar('Product name cannot contain colon (:).', { variant: 'error' });
            return true;
          }
          if (trimmedName[0] === '.') {
            enqueueSnackbar('Product name cannot start with a dot.', { variant: 'error' });
            return true;
          }
          if (trimmedName[0] === '-') {
            enqueueSnackbar('Product name cannot start with a hyphen.', { variant: 'error' });
            return true;
          }
          if (trimmedName === '') {
            enqueueSnackbar('Product name cannot be empty or just spaces.', { variant: 'error' });
            return true;
          }
          return false;
        });
        
        const hasInvalidServiceName = additionalSelectedServicesForSave
          ?.filter((item) => isQuotationWriteService(item))
          ?.some((product) => {
          const trimmedName = (product.name || product.service_name || '').trim();
          if (trimmedName === '.') {
            enqueueSnackbar('Service name cannot be just a dot.', { variant: 'error' });
            return true;
          }
          if (trimmedName === '-') {
            enqueueSnackbar('Service name cannot be just a hyphen.', { variant: 'error' });
            return true;
          }
          if (/[:]/.test(trimmedName)) {
            enqueueSnackbar('Service name cannot contain colon (:).', { variant: 'error' });
            return true;
          }                
          if (trimmedName[0] === '.') {
            enqueueSnackbar('Service name cannot start with a dot.', { variant: 'error' });
            return true;
          }
          if (trimmedName[0] === '-') {
            enqueueSnackbar('Service name cannot start with a hyphen.', { variant: 'error' });
            return true;
          }
          if (trimmedName === '') {
            enqueueSnackbar('Service name cannot be empty or just spaces.', { variant: 'error' });
            return true;
          }
          return false;
        });
        
        const hasInvalidMaterialName = selectedMaterialsForSave?.filter(item=>item?.isAdditionalProduct == true)?.some(product => {
          const newName = product.product_name || product.name;
          const trimmedName = newName.trim();
          if (trimmedName === '.') {
            enqueueSnackbar('Material name cannot be just a dot.', { variant: 'error' });
            return true;
          }
          if (trimmedName === '-') {
            enqueueSnackbar('Material name cannot be just a hyphen.', { variant: 'error' });
            return true;
          }
          if (/[:]/.test(trimmedName)) {
            enqueueSnackbar('Material name cannot contain colon (:).', { variant: 'error' });
            return true;
          }                
          if (trimmedName[0] === '.') {
            enqueueSnackbar('Material name cannot start with a dot.', { variant: 'error' });
            return true;
          }
          if (trimmedName[0] === '-') {
            enqueueSnackbar('Material name cannot start with a hyphen.', { variant: 'error' });
            return true;
          }
          if (trimmedName === '') {
            enqueueSnackbar('Material name cannot be empty or just spaces.', { variant: 'error' });
            return true;
          }
          return false;
        });
        
        if (hasInvalidProductName || hasInvalidServiceName || hasInvalidMaterialName) {
          // enqueueSnackbar('Product names must contain letters or numbers.', { variant: 'error' });
          return;
        }
        const clientsArray = values.clients ? [values.clients] : [];
        values.clientsData = clientsArray
        values.userName = user.first_name;
        values.bill_to = billToInputValue;
        values.ship_to = shipToInputValue;
        if (!values?.bill_to?.trim()) {
          values.bill_to = buildMultilineAddress(
            values?.clients?.name || values?.clients?.customer_name || '',
            values?.clients?.address || values?.clients?.customer_address || '',
            values?.clients?.city || values?.clients?.customer_city || '',
            values?.clients?.state || values?.clients?.customer_state || '',
            values?.clients?.zip || values?.clients?.customer_zipcode || values?.clients?.zip_code || '',
          );
        }
        if (!values?.ship_to?.trim()) {
          values.ship_to = buildMultilineAddress(
            values?.community?.name || '',
            values?.community?.address || '',
            values?.community?.city || '',
            values?.community?.state || '',
            values?.community?.zip || '',
          );
        }
        const request_id =id
        const allProductAttachmentUrls = Object.values(productAttachments)
          .flat()
          .map(attachmentFileKey)
          .filter(Boolean);
        const allServiceAttachmentUrls = Object.values(serviceAttachments)
          .flat()
          .map(attachmentFileKey)
          .filter(Boolean);
        const filteredAvatarUrl = avatarUrl.filter((file) => {
          const fileIdentifier = attachmentFileKey(file);
          return (
            fileIdentifier &&
            !allProductAttachmentUrls.includes(fileIdentifier) &&
            !allServiceAttachmentUrls.includes(fileIdentifier)
          );
        });
        values.avatarUrl = filteredAvatarUrl;
        values.productAttachments = productAttachments;
        values.serviceAttachments = serviceAttachments;

        values.project_category = values.project_type?.name == 'TS' ? (values.project_category || null) : null
        values.map_service = (values.project_type?.name == 'TS' && (values.project_category && values.project_category?.id == 14)) ? values.map_service : null

        // values.products = selectedProductsForSave
        // Add productRows for request_estimate
        let isHavingProductRows = false
        let isHavingServiceRows = false
        let isFromFinalReview = false
        if (details?.estimate_job_status == 3 && details?.is_request_estimate == 1) {
          isFromFinalReview = true
        }
        if (effectiveIsRequestEstimate) {
          // Legacy: merged productRows into products — unified in selectedProductsForSave with entryMode
          // values.products = [
          //   ...selectedProductsForSave,
          //   ...productRows?.filter((row) => row.product_name?.trim() !== '' && !selectedProductsForSave.some((selectedProductsForSave) => selectedProductsForSave.indexId === row?.indexId))
          // ] || [];
          // ALL-815 backup - previous submit without normalize:
          // values.products = (selectedProductsForSave || []).map((product) => { ...product, is_product_row, isAdditionalProduct })
          values.products = (selectedProductsForSave || []).map((product) => {
            const isWrite = isQuotationEstimateWriteProduct(product)
            const isWriteRow = effectiveIsRequestEstimate && isWrite
            
            const productWrite =
              Number(product?.product_write) === 1 || isWriteRow ? 1 : 0
            return {
              ...normalizeProductForSave(
                resolveGroupMemberMarketingForSave(product, markupType),
              ),
              is_product_row: isWrite ? 1 : 0,
              isAdditionalProduct: false,
              product_write: productWrite,
            }
          })
          isHavingProductRows = selectedProductsForSave?.some(
            (row) =>
              isQuotationEstimateWriteProduct(row) &&
              (row.product_name || row.name || '').trim() !== '',
          )
          // BACKUP: isQuotationWriteRow(row) &&
        } else {
          // ALL-815 backup - previous submit without normalize:
          // values.products = (selectedProductsForSave || []).map((product) => { ...product, is_product_row: 0, isAdditionalProduct: isWrite })
          values.products = (selectedProductsForSave || []).map((product) => {
            const isWrite = isQuotationWriteRow(product)
            return {
              ...normalizeProductForSave(
                resolveGroupMemberMarketingForSave(product, markupType),
              ),
              is_product_row: 0,
              isAdditionalProduct: isWrite,
            }
          })
        }
        // const allServices = [...selectedServices, ...additionalSelectedServicesForSave];
        const mapAdditionalForSubmit = (rows) =>
          (rows || [])
            .filter((service) => {
              if (isQuotationChooseEmptyService(service)) return false
              if (isEstimateCatalogServiceRow(service)) return false
              if (isQuotationWriteService(service)) {
                return (service.name || service.service_name || '').trim() !== ''
              }
              return Boolean(service.id || (service.name || '').trim())
            })
            .map((service) => {
              const lineIndex =
                Number(service?.product_index ?? service?.newIndexId ?? service?.indexId) || 0
              const isWrite = isQuotationWriteService(service)
              const isWriteRow = effectiveIsRequestEstimate && isWrite
              const serviceWrite =
                Number(service?.service_write) === 1 || isWriteRow ? 1 : 0
              const { qty, unitCost, lineTotal } = normalizeAdditionalServiceCostFields(service)
              return {
                ...service,
                quantity: qty,
                qty,
                unit_cost: unitCost,
                total: lineTotal,
                total_cost: unitCost,
                newIndexId: lineIndex,
                indexId: lineIndex,
                product_index: lineIndex,
                productIndex: lineIndex,
                is_service_row: effectiveIsRequestEstimate && isWrite ? 1 : 0,
                service_write: serviceWrite,
                isAdditionalProduct: effectiveIsRequestEstimate ? false : isWrite,
              }
            })

        let additionalServicesData = []
        const mappedAdditionalOnly = mapAdditionalForSubmit(additionalSelectedServicesForSave)
        const catalogServicesForPayload =
          effectiveIsRequestEstimate && hasMeaningfulEstimateWriteRows
            ? (estimateCatalogServicesForSave || []).map((s) => ({
              ...s,
              entryMode: 'choose',
              is_service_row: 0,
              isAdditionalProduct: false,
              labour_cost_service_id: s.labour_cost_service_id ?? s.id,
              newIndexId: s.newIndexId ?? s.indexId,
              indexId: s.indexId ?? s.newIndexId,
              product_index: s.product_index ?? s.newIndexId ?? s.indexId,
            }))
            : []
        // BACKUP: effectiveIsRequestEstimate ? (estimateCatalogServicesForSave || []).map(...) : []
        if(effectiveIsRequestEstimate){
          const isServiceRowAlreadyInAdditional = (serviceRow) =>
            (additionalSelectedServicesForSave || []).some((s) => {
              const sIdx = Number(s?.newIndexId ?? s?.indexId ?? s?.product_index)
              const rowIdx = Number(serviceRow?.indexId)
              if (Number.isFinite(sIdx) && Number.isFinite(rowIdx) && sIdx === rowIdx) {
                return true
              }
              const rowBackendId = serviceRow?.backendId ?? serviceRow?.id
              const sBackendId = s?.id ?? s?.backendId
              if (rowBackendId != null && sBackendId != null && rowBackendId == sBackendId) {
                return true
              }
              return false
            })
          const filteredServiceRows =
            (serviceRows || []).filter(
              (service) =>
                (service.service_name || '').trim() !== '' &&
                !isServiceRowAlreadyInAdditional(service),
            )
          const formattedServiceRows = filteredServiceRows.map((service) => ({
            ...service,
            qty: 1,
            quantity: 1,
            unit_cost: 0,
            total_cost: 0,
            markup: 0,
            jobcost_unit_cost: 0,
            jobcost_total_cost: 0,
            facility_id: currentFacilityId,
          }))
          additionalServicesData = [...mappedAdditionalOnly, ...formattedServiceRows]
          isHavingServiceRows =
            serviceRows?.some((row) => row.service_name?.trim() !== '') ||
            mappedAdditionalOnly.some(
              (s) => isQuotationWriteService(s) && (s.name || s.service_name || '').trim() !== '',
            ) ||
            (catalogServicesForPayload || []).length > 0
          values.serviceRows = mappedAdditionalOnly
            .filter((service) => isQuotationWriteService(service))
            .map((service) => ({
              ...service,
              service_name: service.service_name || service.name || '',
              service_desc: service.service_desc || service.description || '',
              qty: 1,
              quantity: 1,
              unit_cost: 0,
              total_cost: 0,
              markup: 0,
              jobcost_unit_cost: 0,
              jobcost_total_cost: 0,
              facility_id: currentFacilityId,
            }))
        }else{
          additionalServicesData = mappedAdditionalOnly
        }
        const dedupeServicesForPayload = (list) => {
          const seenBackendIds = new Set()
          const seenLineKeys = new Set()
          return (list || []).filter((s) => {
            const backendId = s?.id ?? s?.backendId
            if (backendId != null) {
              const key = String(backendId)
              if (seenBackendIds.has(key)) return false
              seenBackendIds.add(key)
              return true
            }
            const lineKey = String(s?.newIndexId ?? s?.indexId ?? s?.product_index ?? '')
            if (lineKey && seenLineKeys.has(lineKey)) return false
            if (lineKey) seenLineKeys.add(lineKey)
            return true
          })
        }
        const payloadAdditionalServices = dedupeServicesForPayload([
          ...additionalServicesData,
          ...catalogServicesForPayload,
        ])
        const hasSubmittedEstimateWriteRows =
          (values.products || []).some(
            (product) =>
              (Number(product?.is_product_row) === 1 ||
              Number(product?.product_write) === 1) &&
              // (Number(product?.product_write) === 0 && Number(product?.is_product_row) === 0) 
                Boolean((product?.product_name || product?.name || '').trim()),
          ) ||
          (payloadAdditionalServices || []).some(
            (service) =>
              (Number(service?.is_service_row) === 1 ||
              (Number(service?.service_write) === 1 ) &&
                // (Number(service?.service_write) === 0 && Number(service?.is_service_row) === 0) &&
                  Boolean((service?.service_name || service?.name || '').trim())),
          )
        const allServices = [
          ...selectedServices.map(s => ({ ...s, quantityDifference: 0 })),
          ...payloadAdditionalServices,
        ];
        // values.additionalSelectedServices = additionalSelectedServicesForSave
        values.additionalSelectedServices = payloadAdditionalServices
        const servicesIdArray = allServices?.map(service => service.id);
        values.services = servicesIdArray?.join(',')
        values.totalMarkup = totalMarkup
        values.selectedServices = allServices
        values['labour_cost'] = totalLabourCost;
        values.is_request_estimate = effectiveIsRequestEstimate ? 1 : 0
        
        const submitProductsForLead = selectedProducts?.length > 0 ? selectedProducts : values.products || [];
        const submitIsRushFeeAutoLocked = isInstallBeforeRequiredLead(values, submitProductsForLead);
        const submitCanOverrideRushFeeLock = !!explodedPermissions?.some((permission) =>
          ['Override Rush Fee Estimate'].includes(permission),
        );
        const submitIsRushFeeChecked =
          Number(values?.rush_fee) === 1 ||
          (!!submitIsRushFeeAutoLocked && !submitCanOverrideRushFeeLock);
        
        values.rush_fee_amount = calcRushFeeAmount({
          enabled: submitIsRushFeeChecked,
          subtotal: totalsum || 0,
          percentage: currentRushFeePercentage,
          storedAmount: details?.rush_fee_amount || 0,
          preferStored: false
        });

           const data = { values, userId, userType ,request_id, isHavingProductRows, isFromFinalReview, isHavingServiceRows, isUpdateRequestFlow,
             avalara_transaction_id:details?.avalara_transaction_id,
              avalara_code:details?.avalara_code,
              hasSubmittedEstimateWriteRows: hasSubmittedEstimateWriteRows,
            allLocationSame,
            rfpProducts: cart,
            all_sales_rep_ids: allSalesRepIds,
            collaborators: Array.isArray(collaborators) ? collaborators.map((c) => (typeof c === 'object' && c?.id != null ? c.id : c)).filter(Boolean).join(',') : (collaborators || ''),
            taxCategory : selectedTaxCategory?.id || null,
            allRfpServiceLocationSame : allRfpServiceLocationSame ,
            rfpServices: cartService,
            materials:selectedMaterialsForSave,
            produtFormulaMaterial:produtFormulaMaterial,
            isRequestEstimate: effectiveIsRequestEstimate,
            previous_request_estimate: details?.is_request_estimate,
            groupProductMarketingData: groupedProducts ? groupedProducts.map((group) => ({
              group_id: group.id,
              // Save-without-blur: use the pending draft if one exists for this group.
              group_name: getGroupNameForSave(group),
              group_description: getGroupDescForSave(group),
              quantity: group.groupQuantity || 1,
              adj_value_type: group.groupAdjValueType ?? true,
              adjustment: Number(group.groupAdjustment ?? 0),
              total_formula_each: Number((group.totalProductFormulaEach || 0).toFixed(2)),
              total_retail_each: Number((group.totalProductRetailEach || 0).toFixed(2)),
              adjusted_retail_each: Number((group.adjustedGroupRetailEach || 0).toFixed(2)),
              adjusted_subtotal: Number((group.adjustedGroupSubtotal || 0).toFixed(2)),
            })) : [],
            groupInstallMarketingData: groupedProducts ? groupedProducts.map((group) => ({
              group_id: group.id,
              group_name: getGroupNameForSave(group),
              group_description: getGroupDescForSave(group),
              quantity: group.groupInstallQuantity || 1,
              adj_value_type: group.groupInstallAdjValueType ?? true,
              adjustment: Number(group.groupInstallAdjustment ?? 0),
              total_formula_each: Number((group.totalInstallFormulaEach || 0).toFixed(2)),
              total_retail_each: Number((group.totalInstallRetailEach || 0).toFixed(2)),
              adjusted_retail_each: Number((group.adjustedGroupInstallRetailEach || 0).toFixed(2)),
              adjusted_subtotal: Number((group.adjustedGroupInstallSubtotal || 0).toFixed(2)),
            })) : [],
            address: buildCombinedAddressPayload(),
            estimate_qb_id : details?.estimate_id,
          }
          const isvalidationNotOk = selectedProductsForSave.find(product=>{
            if(product.location.length && product.location.some(obj =>
              [obj.address, obj.city, obj.state, obj.zip].some(value => (value === '' || value === null))
            )){
              return true
            }else{
              return false
            }
          })
          values.total=totalsum
          values.taxAmount = taxAmount
          values.budget=budget
          values.sub_total = rfqSubTotal
          console.log("######isvalidationNotOk",isvalidationNotOk);
          console.log("######totalAmount", values.total);
          console.log("######totalAmountbudget",values.budget);
          
          // Convert end date from string format to timestamp if needed
          if (values.end && isNaN(values.end)) {
            values.end = Math.floor(new Date(values.end).getTime() / 1000);
          }
          // Convert start date from string format to timestamp if needed
          if (values.start && isNaN(values.start)) {
            values.start = Math.floor(new Date(values.start).getTime() / 1000);
          }
          
          data.quotation=1
          // Regular estimates (no job): never send manager approval.
          // Estimate jobs: send the form value (from EditEstimateJob / saved DB).
          // data.manager_approval_required = values.manager_approval_required === true || values.manager_approval_required === 1
          data.manager_approval_required = (details?.is_request_estimate == 1 || values?.is_request_estimate == 1)
            ? (values.manager_approval_required === true || values.manager_approval_required === 1)
            : false
          // BACKUP: data.selectedEstimators=selectedEstimators
          data.selectedEstimators = hasMeaningfulEstimateWriteRows ? selectedEstimators : []
          data.customer_name= values.customer_name   //new one
          data.saveAsDraft = saveAsDraftRef.current
          data.is_draft = saveAsDraftRef.current
          saveAsDraftRef.current = false
          const isvalidationNotOkRfp = cart?.find(product => {
            console.log("Checking product:", product);
  
            if (product.location.length > 0 && product.location.some(obj =>
              [obj.address, obj.city, obj.state, obj.zip].some(value => (value === '' || value === null))
            )) {
              console.log("Validation failed for product:", product);
              return true;
            } else {
              console.log("Validation passed for product:", product);
              return false;
            }
          });
          if(isvalidationNotOk || isvalidationNotOkRfp){
            enqueueSnackbar('Please fill all the address fields', { variant: 'error' });
          }else{
            const requestData = {
              ...data,
              quotation: data?.quotation || 1,
              processType: 'update_estimate',
              socketId: null // Will be set by the progress modal
            };
            setProgressRequestData(requestData);
            setShowProgressModal(true);
            await new Promise(resolve => setTimeout(resolve, 2000));
            if (!socketReady) {
              console.log('[PROGRESS-MODAL] ⏳ Waiting for socket connection...');
              await new Promise(resolve => setTimeout(resolve, 1000));
            }
           await axios.post(`${REST_API}webservice/edit-request`, data)
            .then(async (res) => {
              console.log("######res",res);
              console.log("######effectiveIsRequestEstimate",effectiveIsRequestEstimate);
              console.log("######hasSubmittedEstimateWriteRows",hasSubmittedEstimateWriteRows);
              console.log("######productRows",productRows);
              console.log("######serviceRows",serviceRows);
              console.log("######hasMeaningfulEstimateWriteRows",hasMeaningfulEstimateWriteRows);
              console.log("######isUpdateRequestFlow",isUpdateRequestFlow);
            if(res.data.status == 1 && effectiveIsRequestEstimate){
              if(!hasSubmittedEstimateWriteRows){
                await axios.post(`${REST_API}webservice/request/delete-estimate-job-if-no-write-rows`, { requestId: request_id, userId })
              } else if(details?.estimate_job_status != 3 || (details?.estimate_job_status == 3 && (productRows?.length > 0 || serviceRows?.length > 0 || hasMeaningfulEstimateWriteRows || isUpdateRequestFlow))){
                if(res.data.checkProjectExist){
                  await handleConvertToJob(res.data.checkProjectExist, null, isUpdateRequestFlow)
                }else{
                  await handleConvertToJob(false, null, isUpdateRequestFlow)
                }
              }
            }
            else if(res.data.status == 1 && !effectiveIsRequestEstimate){
              if(!hasSubmittedEstimateWriteRows){
                await axios.post(`${REST_API}webservice/request/delete-estimate-job-if-no-write-rows`, { requestId: request_id, userId })
              }
            }
              
          setOpenEdit(false)
        
          setIsOpen(false)
          setCurrentRFQdata({}) // added on 3-01-2024
           resetForm();
            setSelectedProducts([])
            setSelectedMapserviceProducts([]);
            setSelectedTaxCategory(null);
            setSelectedServices([]);
            setAdditionalSelectedServices([])
            setEstimateCatalogServices([])
            setSelectedEstimators([])
            setFilteredServices([])
            // Reset product/service rows so fresh backendIds are always loaded from backend on next edit
            setProductRows([{ indexId: 1, product_name: '', product_desc: '', is_product_row: 1, backendId: null }]);
            setServiceRows([{ indexId: 1, service_name: '', service_desc: '', price: 0, retail_price: 0, is_service_row: 1, backendId: null, facility_id: currentFacilityId }]);
            setProductRowsIndexCounter(1);
            setServiceRowsIndexCounter(1);
            fetchRequestDetails()
            handleJobLogUpdates()
            // if(edit){
            //   navigate(`/dashboard/quick-bid`)
            // }
           enqueueSnackbar(data.saveAsDraft ? 'Draft saved' : 'Update success' , { variant: 'success' });
           // Close progress modal explicitly to ensure it closes in production
           setShowProgressModal(false);
           if (popupOn) {
             // If this save was triggered by the fullscreen close/back/cancel
             // (via saveTrigger on a NON-draft estimate), let the parent
             // dialog handle closing once the save completes, and avoid
             // bouncing back to the detail view inside the popup.
             if (autoCloseAfterNormalSaveRef.current && typeof closeAfterSave === 'function') {
               autoCloseAfterNormalSaveRef.current = false;
               closeAfterSave();
             } else if (typeof closeView === 'function') {
               // Regular popup save (e.g. top "Update Estimate" button) keeps
               // the existing behavior: close via closeView and refresh cards.
              //  closeView();
              setTimeout(() => {
                  setOpenInvoice(true);
                  }, 3000);
               setRenderCards(!renderCards);
             }
           } else {
            navigate(`/dashboard/quick-bid/view/${id}`)
           }
           if(edit){
            edit=false
            setOpenEdit(false)
          setIsOpen(false)
          }
         })
         .catch((errors)=>{
           console.log(errors,'error')
           // Close progress modal on error as well
           setShowProgressModal(false);
         })
        }
      } catch (error) {
        console.error(error);
        // Close progress modal on error
        setShowProgressModal(false);
      }
    }
  });

  // Dynamic split catalog types based on selected facilities
  const getSplitCatalogTypes = () => {
    const selectedFacilities = values?.facility_type || [];
    const hasOnlyCurrentFacility = selectedFacilities.length === 1 && 
      selectedFacilities.some(facility => Number(facility.id) === currentFacilityId);
    
    // If only current facility is selected, exclude Split Catalog option
    if (hasOnlyCurrentFacility) {
      return splitOrderCatalogTypes.filter(type => type.id !== 'split_catalog');
    }
    
    return splitOrderCatalogTypes;
  };

  const applyLeadTimeInstallPatch = (baseUnix, productsList) => {
    const products =
      productsList ??
      (selectedProducts?.length > 0 ? selectedProducts : values.products || []);
    const patch = getInstallEndPatchFromLead(values, baseUnix, products);
    if (patch) setFieldValue(patch.field, patch.finalUnix);
  };

  const applyInstallationFromStartAndLead = (newStartUnix) => {
    applyLeadTimeInstallPatch(getBaseUnixForLeadTime(values, newStartUnix));
  };

  // const handleEstimateCount = async () => {
  //   try {
  //     const response = await axios.post(`${REST_API}webservice/estimate/reduce-tabs-count`, {
  //       userId,
  //       estimate_id:id,
  //     });
      
  //   } catch (error) {
  //     console.error("Error reducing estimate count:", error);
  //   }
  // };

  // useEffect(() => {
  //   if(userType !==3){
  //     handleEstimateCount()
  //   }
  // }, [])
  

// useEffect(()=>{
//   // let currentUnix = moment(currentDate).unix()
//   //  let requestSubmitDeadline = details?.submission_deadline

//    if((user?.user_id == details?.partner_user_id)&& (details?.accept_status == 0)){
//     setReqAcceptClient(true)
//    }
  
// },[details])

const submissionDeadlineUnix = details?.submission_deadline;
const submissionDeadlineMoment = moment.unix(submissionDeadlineUnix);

const current = moment();

const daysLeft = submissionDeadlineMoment.diff(current, 'days');

const handleManagerAccept = async () => {
  try {
    setConfirmManagerAccept(false);
    const requestId = id;
    const userId = user.user_id;
    const res = await axios.post(`${REST_API}webservice/request/manager-approve-reject-quotation`, {
      requestId,
      userId,
      action: 'accept',
    });
    if (res.data.status === 1) {
      enqueueSnackbar(res.data.message || 'Estimate approved by manager.', { variant: 'success' });
      await fetchRequestDetails();
      // Refresh product list so activated estimate catalogs are available immediately
      await fetchProducts();
      if (typeof onDataChange === 'function') {
        onDataChange();
      }
      setRefresh(!refresh);
    } else {
      enqueueSnackbar(res.data.message || 'Failed to approve', { variant: 'error' });
    }
  } catch (err) {
    console.log(err, 'error in manager accept');
    enqueueSnackbar(err?.response?.data?.message || 'Failed to approve', { variant: 'error' });
  }
};

const handleUpdateEstimateHoldStatus = async (reasonToUse) => {
  if (holdSubmitInProgressRef.current) return
  holdSubmitInProgressRef.current = true
  setHoldEstimateLoading(true)
  let showedToast = false
  const showSuccess = (msg) => {
    if (showedToast) return
    showedToast = true
    enqueueSnackbar(msg || 'Estimate hold status updated', { variant: 'success' })
  }
  const showError = (msg) => {
    if (showedToast) return
    showedToast = true
    enqueueSnackbar(msg || 'Failed to update Estimate hold status', { variant: 'error' })
  }
  try {
    const data = {
      request_id: id,
      userId: user.user_id,
      reason: reasonToUse || ''
    }
    const res = await axios.post(`${REST_API}webservice/quotation/update-estimate-hold-status`, data)
    if (res.data && res.data.status == 1) {
      setOpenHoldEstimate(false)
      setHoldReason('')
      setHoldReasonError('')
      showSuccess(res.data.message)
      fetchRequestDetails()
      onDataChange()
      setOpenInvoice(false)
      setConfirmInvoice(false)
    } else {
      showError(res.data?.message)
    }
    setRefresh(!refresh)
  } catch (error) {
    console.log(error, 'error in updating Estimate hold status')
    showError(error.response?.data?.message)
  } finally {
    setHoldEstimateLoading(false)
    holdSubmitInProgressRef.current = false
  }
}

const handleAcceptorRejectInvoice=async(value)=>{
  try {
    if(value === 2 && reason === ''){
      enqueueSnackbar('Please fill rejected reason ',{variant:'warning'})
      return
    }
    else{
    if(value === 2) setRejectInvoiceLoading(true)
    let requestId = id
    let requestPartnerId = details?.rt_partner_id
    let acceptStatus = value
    let userId=user.user_id

    // Manager reject — estimate jobs only (no manager reject for regular estimates without a job)
    const isManagerEstimateReject =
      value === 2 &&
      userType != 3 &&
      details?.is_request_estimate == 1 &&
      Number(details?.estimate_job_status) === 3 &&
      details?.send_to_client == 0 &&
      (details?.manager_approval_required === true || details?.manager_approval_required === 1) &&
      (details?.quotation_status === 9 ||
        (details?.quotation_status === 3 && details?.send_for_manager_approval == 1));
    // Previous (also allowed regular estimates with no job):
    // const isManagerEstimateReject =
    //   value === 2 &&
    //   userType != 3 &&
    //   details?.send_to_client == 0 &&
    //   details?.manager_approval_required == 1 &&
    //   (details?.quotation_status === 9 ||
    //     (details?.quotation_status === 3 && details?.send_for_manager_approval == 1));
    if (isManagerEstimateReject) {
      try {
        const res = await axios.post(`${REST_API}webservice/request/manager-approve-reject-quotation`, {
          requestId,
          userId,
          action: 'reject',
          reason: reason || '',
          rejectFile: rejectFile || undefined,
        });
        if (res.data.status === 1) {
          setRejectInvoice(false);
          setRejectInvoiceLoading(false);
          setReason('');
          setRejectFile(null);
          enqueueSnackbar('Estimate rejected by manager', { variant: 'success' });
          fetchRequestDetails();
          if (typeof onDataChange === 'function') {
            onDataChange();
          }
          setRefresh(!refresh);
        } else {
          enqueueSnackbar(res.data.message || 'Failed to reject', { variant: 'error' });
          setRejectInvoiceLoading(false);
        }
      } catch (err) {
        console.log(err, 'error in manager reject');
        setRejectInvoiceLoading(false);
        enqueueSnackbar(err?.response?.data?.message || 'Failed to reject', { variant: 'error' });
      }
      return;
    }
  
    const data={requestId,requestPartnerId,acceptStatus,userId,reason}
    const res = await axios.post(`${REST_API}webservice/request/accept-or-reject-quotation`,data)
    
    if(res.data.status==1){
      setOpenInvoice(false)
      setConfirmInvoice(false)
      enqueueSnackbar( 'Estimate Approved', { variant: 'success' });
      fetchRequestDetails()
      if (typeof onDataChange === 'function') {
        onDataChange()
      }
    }else if(res.data.status==2){
      if (typeof onDataChange === 'function') {
        onDataChange()
      }
      setOpenInvoice(false)
      setRejectInvoice(false)
      setRejectInvoiceLoading(false)
      enqueueSnackbar('Estimate Rejected',{variant:'error'})
      setReason('')
      navigate(PATH_DASHBOARD.quotation.root)
    }
    else{
      setOpenInvoice(false)
      setConfirmInvoice(false)
      setRejectInvoiceLoading(false)
    }
    setRefresh(!refresh)
  }
  } catch (error) {
    console.log(error,'error in accepting Estimate')
    setRejectInvoiceLoading(false)
  }
}
const calculateServiceTotal = (price, quantity, discount, value, location = 1) => {

  const parsedQuantity = parseFloat(quantity ? quantity : value) || 0;
  const parsedDiscount = parseFloat(discount) || 0;
  const locationQuantity = parseFloat(location) || 1
  const subtotal = price * parsedQuantity * locationQuantity;

  if (discount) {
    const totalDiscount = subtotal - discount;
    return totalDiscount;
  } else {
    return subtotal;
  }
};

const normalizeAdditionalServiceCostFields = (service) => {
  const qty = Number(service?.quantity ?? service?.qty ?? 0)
  let unitCost = Number(service?.unit_cost) || 0
  if (!unitCost) {
    const storedLineTotal = Number(service?.total_cost ?? 0)
    const storedQty = Number(service?.qty ?? 0)
    if (storedLineTotal > 0 && storedQty > 0) {
      unitCost = storedLineTotal / storedQty
    } else {
      unitCost = Number(service?.total_cost ?? service?.cost ?? 0)
    }
  }
  const lineTotal = unitCost * qty
  return { qty, unitCost, lineTotal }
}
const handleReopeningRequest=async()=>{
  try {
    let requestId = id
    let userId=user.user_id
    const  data={requestId,userId}
    const res = await axios.post(`${REST_API}webservice/quotation/reopen`,data)
    if(res.data.status ==1){
      enqueueSnackbar('Estimate reopened successfully',{variant:"success"})
      setReopen(false)
      fetchRequestDetails()
    }else if(res.data.status ==0){
      enqueueSnackbar('Estimate reopened failed',{variant:"error"})
      setReopen(false)
    }
  } catch (error) {
    console.log(error,'Error in reopen')
  }
}

const handleConvertToJob = async (existingJob = false, newRequestId = null, isUpdateRequestFlowFlag = false) => {
  try {
    setCreateJob(true);
    if(existingJob){
      setIsUpdating(true);
    }
    let requestId = newRequestId ? newRequestId : id
    let requestPartnerId = details?.rt_partner_id
    // 🚀 PROGRESS TRACKING: Show progress modal and make API call
    const requestData = {
      requestId,
      requestPartnerId,
      userId,
      processType: 'estimate_job',
      socketId: null // Will be set by the progress modal
    };

    // If modal is already open (from previous operation), just update the data and continue
    if (showProgressModal) {
      setProgressRequestData(requestData);
      // Don't close and reopen modal, just continue with new data
    } else {
      // setProgressHeading("Creating Estimate Job");
      setProgressRequestData(requestData);
      setShowProgressModal(true);
    }

    // Wait for socket connection to establish and stabilize
    await new Promise(resolve => setTimeout(resolve, 2000));

    // Additional wait if socket is not ready yet
    if (!socketReady) {
        console.log('[PROGRESS-MODAL] ⏳ Waiting for socket connection...');
        await new Promise(resolve => setTimeout(resolve, 1000));
    }

    const data = { requestId, userId, requestPartnerId, isUpdateRequestFlow: isUpdateRequestFlowFlag }
    const res = await axios.post(`${REST_API}webservice/request/create-or-update-estimate-job`, data);

    if (res.data.status == 1) {
      setShowProgressModal(false);
      enqueueSnackbar(existingJob ? 'Estimate Job updated successfully' :'Estimate Job created successfully', { variant: 'success' });
      fetchRequestDetails()
      if(newRequestId){
        if(popupOn){
          closeView()
          localStorage.removeItem('salesOrderProjectId');
          localStorage.removeItem('salesOrderProjectName');
          localStorage.removeItem('isEditSalesOrder');
          localStorage.removeItem('salesOrderOpenPopup',);
          setRenderCards(!renderCards)
          onDataChange()
        }else{
          navigate(PATH_DASHBOARD.quotation.root)
        }
      }
    } else {
      setShowProgressModal(false);
      enqueueSnackbar(existingJob ? 'Failed to update estimate job' : 'Failed to create estimate job', { variant: 'error' });
      if(newRequestId){
        if(popupOn){
          closeView()
          localStorage.removeItem('salesOrderProjectId');
          localStorage.removeItem('salesOrderProjectName');
          localStorage.removeItem('isEditSalesOrder');
          localStorage.removeItem('salesOrderOpenPopup',);
          setRenderCards(!renderCards)
          onDataChange()
        }else{
          navigate(PATH_DASHBOARD.quotation.root)
        }
      }
    }
  } catch (error) {
    console.log(error, 'error in creating estimate job')
    setShowProgressModal(false);
  }finally{
    setCreateJob(false);

  }
}

const convertToRFQ=async()=>{
  try {
    let requestId = id
    let userId=user.user_id
    const  data={requestId,userId}
    
    // 🚀 PROGRESS TRACKING: Show progress modal and make API call
    const requestData = {
      requestId,
      userId,
      processType: 'convert_to_sales_order',
      socketId: null // Will be set by the progress modal
    };

    setProgressRequestData(requestData);
    setShowProgressModal(true);

    // Wait for socket connection to establish and stabilize
    await new Promise(resolve => setTimeout(resolve, 2000));

    // Additional wait if socket is not ready yet
    if (!socketReady) {
        console.log('[PROGRESS-MODAL] ⏳ Waiting for socket connection...');
        await new Promise(resolve => setTimeout(resolve, 1000));
    }

    const res = await axios.post(`${REST_API}webservice/quotation/convert-rfq`,data)
    if(res.data.status ==1){
      enqueueSnackbar('Estimate converted to Sales Order successfully',{variant:"success"})
      setReopen(false)
      setShowProgressModal(false)
      sessionStorage.setItem(`salesOrderSkipRibbonDismiss_${id}`, '1')
      // navigate(PATH_DASHBOARD.official.root)
      navigate(`/dashboard/official-request/view/${id}`,{state:true})
      if(popupOn){
        closeView()
      }
      // fetchQuotationDetails()
    }else if(res.data.status ==0){
      enqueueSnackbar('Estimate failed to convert',{variant:"error"})
      setReopen(false)
      setShowProgressModal(false)
    }
  } catch (error) {
    console.log(error,'Error in reopen')
    setShowProgressModal(false)
  }
}
const convertToDesignOrder=async()=>{
  try {
    let requestId = id
    let userId=user.user_id
    const requestData = {
      requestId,
      userId,
      socketId: null, // Will be set by the progress modal
      processType: 'design_order'
    };

    setProgressRequestData(requestData);
    setShowProgressModal(true);

    // Wait for socket connection to establish and stabilize
    await new Promise(resolve => setTimeout(resolve, 2000));

    // Additional wait if socket is not ready yet
    if (!socketReady) {
        console.log('[PROGRESS-MODAL] ⏳ Waiting for socket connection...');
        await new Promise(resolve => setTimeout(resolve, 1000));
    }

    const res = await axios.post(`${REST_API}webservice/quotation/convert-design-order`,requestData)
    if(res?.data?.status ==1){
      enqueueSnackbar('Estimate converted to Design Order successfully',{variant:"success"})
      setReopen(false)
      setShowProgressModal(false)
      const designOrderId = res?.data?.designOrderId
      // navigate(PATH_DASHBOARD.official.root)
      navigate(`/dashboard/design-order/view/${designOrderId}`,{state:{fromEstimate:true}})
      if(popupOn){
        closeView()
      }
      // fetchQuotationDetails()
    }else if(res.data.status ==0){
      enqueueSnackbar('Estimate failed to convert',{variant:"error"})
      setReopen(false)
      setShowProgressModal(false)
    }
  } catch (error) {
    console.log(error,'Error in reopen')
    setShowProgressModal(false)
  }
}
// const handleAcceptOrRejectRequest=async(value)=>{
//   try {
//     console.log(value)
//     let requestId = id
//     let requestPartnerId = details?.rt_partner_id
//     let acceptStatus = value
//     let userId=user.user_id
  
//     const data={requestId,requestPartnerId,acceptStatus,userId}
//     const res = await axios.post(`${REST_API_END_POINT}request/accept-or-reject-request`,data)
    
//     if(res.data.status ==1){
//       setReqAcceptClient(!reqAcceptClient)
//       setRequestAccept(false)
//       setRequestReject(false)
//       enqueueSnackbar(value === 1 ? 'Request Accepted' : 'Request Rejected', { variant: value === 1 ? 'success' : 'error' });
//       if(value==2){
//         navigate(PATH_DASHBOARD.official.root)
//       }
//     }
//     // setReqAcceptClient(false)
//     // setRequestAccept(false)
//     // setRequestReject(false)
//   } catch (error) {
//     console.log(error,'error in reject request')
//   }
 
// }

  const { errors, values, touched, handleSubmit, isSubmitting, setFieldValue, setFieldTouched, getFieldProps, resetForm } = formik;

  // Requested Name / Summary / PO Number / Notes / Subject / Email Content: rendered via
  // DraftTextField (defined above ViewofficialRequest) so their per-keystroke state lives in that
  // child, not in ViewQuotation — typing no longer re-renders this whole component. This ref is
  // the out-of-band channel the child writes every keystroke into (no setState), which Save /
  // Save-as-Draft / submit read synchronously — same guarantee the earlier per-field draft state
  // gave, just without owning the character-by-character state up here.
  const topLevelDraftsRef = useRef({})

  const updateTopLevelDraft = useCallback((fieldName, value) => {
    topLevelDraftsRef.current[fieldName] = value
  }, [])

  const commitTopLevelField = useCallback(
    (fieldName, value) => {
      topLevelDraftsRef.current[fieldName] = undefined
      return setFieldValue(fieldName, value)
    },
    [setFieldValue],
  )

  const markTopLevelFieldTouched = useCallback(
    (fieldName) => {
      setFieldTouched(fieldName, true)
    },
    [setFieldTouched],
  )

  // Live "required" validation for Requested Name / Summary — reacts to DraftTextField's own
  // local value immediately (no 400ms wait), matching what the Yup .required() rule enforces on
  // commit. Stable (empty deps) so it never breaks DraftTextField's React.memo bailout.
  const requiredNameError = useCallback(
    (value) => (!value.trim() ? 'Name is required' : null),
    [],
  )
  const requiredDescriptionError = useCallback(
    (value) => (!value.trim() ? 'Description is required' : null),
    [],
  )

  // `id` (request id) only changes when a genuinely different quotation is loaded (route change,
  // or popup mode switching idOfProject) — not on ordinary re-renders. DraftTextField's own
  // resetToken={id} prop already discards each field's in-flight local edit on that signal; this
  // is a belt-and-suspenders clear of the shared ref for the same transition.
  useEffect(() => {
    topLevelDraftsRef.current = {}
  }, [id])

  // Save-without-blur for these six: Formik's own validationSchema runs against `values` BEFORE
  // handleSubmit ever calls our onSubmit, so overlaying drafts inside onSubmit (as done for the
  // product/service/material arrays) is too late for name/description — Formik would validate
  // the still-stale (pre-commit) value and could reject a submit that just got a valid name typed
  // into it. Flush every pending draft into real Formik state first — setFieldValue's returned
  // Promise is awaited so the values Formik validates against are already current — then invoke
  // the real handleSubmit. Every entry point that can trigger a submit (native form submit/Enter,
  // handleUpdateRequest, the confirm-dialog's direct formik.handleSubmit() call) is routed through
  // this wrapper instead of calling handleSubmit directly.
  const flushTopLevelDrafts = () =>
    Promise.all(
      Object.entries(topLevelDraftsRef.current)
        .filter(([, value]) => value !== undefined)
        .map(([fieldName, value]) => commitTopLevelField(fieldName, value)),
    )
  const handleSubmitWithDraftFlush = async (e) => {
    if (e && typeof e.preventDefault === 'function') e.preventDefault()
    await flushTopLevelDrafts()
    handleSubmit(e)
  }

  const buildAddressLine = useCallback((addressParts = []) => {
    return addressParts
      .map((part) => (part == null ? '' : String(part).trim()))
      .filter(Boolean)
      .join(', ');
  }, []);

  const buildMultilineAddress = useCallback((name, address, city, state, zip) => {
    const line1 = (name == null ? '' : String(name).trim());
    const line2 = (address == null ? '' : String(address).trim());
    const line3 = buildAddressLine([city, state, zip]);
    return [line1, line2, line3].filter(Boolean).join('\n');
  }, [buildAddressLine]);

  const clientAddressForBillTo = useMemo(() => {
    return buildMultilineAddress(
      values?.clients?.name || values?.clients?.customer_name || '',
      values?.clients?.address || values?.clients?.customer_address || '',
      values?.clients?.city || values?.clients?.customer_city || '',
      values?.clients?.state || values?.clients?.customer_state || '',
      values?.clients?.zip || values?.clients?.customer_zipcode || values?.clients?.zip_code || '',
    );
  }, [buildMultilineAddress, values?.clients]);

  const projectAddressForShipTo = useMemo(() => {
    return buildMultilineAddress(
      values?.community?.name || '',
      values?.community?.address || '',
      values?.community?.city || '',
      values?.community?.state || '',
      values?.community?.zip || '',
    );
  }, [buildMultilineAddress, values?.community]);

  const [isBillToDirty, setIsBillToDirty] = useState(false);
  const [isShipToDirty, setIsShipToDirty] = useState(false);
  const [billToInputValue, setBillToInputValue] = useState('');
  const [shipToInputValue, setShipToInputValue] = useState('');

  useEffect(() => {
    setIsBillToDirty(false);
  }, [values?.clients?.id, details?.id]);

  useEffect(() => {
    setIsShipToDirty(false);
  }, [values?.community?.id, details?.id]);

  useEffect(() => {
    if (isBillToDirty) return;
    const nextValue = (values?.bill_to || '').trim()
      ? values.bill_to
      : (clientAddressForBillTo || '');
    setBillToInputValue(nextValue);
  }, [isBillToDirty, values?.bill_to, clientAddressForBillTo, values?.clients?.id, details?.id]);

  useEffect(() => {
    if (isShipToDirty) return;
    const nextValue = (values?.ship_to || '').trim()
      ? values.ship_to
      : (projectAddressForShipTo || '');
    setShipToInputValue(nextValue);
  }, [isShipToDirty, values?.ship_to, projectAddressForShipTo, values?.community?.id, details?.id]);

  const productsForLeadRaw =
    selectedProducts?.length > 0
      ? selectedProducts
      : (values.products?.length > 0 ? values.products : (invoice?.cust_product || []));
  const productsForLead = resolveProductsLeadTime(productsForLeadRaw, allProducts);
  const isRushFeeAutoLockedForEffect = isInstallBeforeRequiredLead(values, productsForLead);

  const canManuallyToggleRushFee = !!explodedPermissions?.some((permission) =>
    ['Manage Rush Fee Toggle Estimate'].includes(permission),
  );
  const canOverrideRushFeeLock = !!explodedPermissions?.some((permission) =>
    ['Override Rush Fee Estimate'].includes(permission),
  );
  const canControlRushFee = canManuallyToggleRushFee || canOverrideRushFeeLock;

  useEffect(() => {
    runRushFeeLeadSync({
      values,
      products: productsForLeadRaw,
      catalog: allProducts,
      canOverride: canOverrideRushFeeLock,
      setFieldValue,
      refs: rushFeeSyncRefs.current,
      enabled: openEdit,
      persistedOffWhileLocked:
        openEdit &&
        Number(details?.rush_fee ?? values?.rush_fee) === 0 &&
        isRushFeeAutoLockedForEffect,
    });
  }, [
    values?.end,
    values?.start,
    values?.installation_start_date,
    values?.installation_end_date,
    productsForLeadRaw,
    allProducts,
    isRushFeeAutoLockedForEffect,
    canOverrideRushFeeLock,
    setFieldValue,
    openEdit,
    details?.rush_fee,
  ]);

  const isRushFeeChecked =
    Number(values?.rush_fee) === 1 ||
    (!!isRushFeeAutoLockedForEffect && !canOverrideRushFeeLock);
  const rushFeeAccessDenied =
    !canControlRushFee && !isRushFeeAutoLockedForEffect && !isRushFeeChecked;
  const rushFeeSwitchDisabled = rushFeeAccessDenied;

  const remapProductIndexIds = useCallback(
    (indexIdMap, productsSnapshot) => {
      const remapKey = (oldKey) => {
        const mapped = indexIdMap[String(oldKey)]
        return mapped !== undefined ? String(mapped) : String(oldKey)
      }

      const remappedProducts = (productsSnapshot || []).map((product) => {
        const newId = indexIdMap[String(product.indexId)]
        if (newId === undefined) return product
        const anchorKey =
          product.group_catalog_anchor_index_id != null
            ? String(product.group_catalog_anchor_index_id)
            : null
        return {
          ...product,
          indexId: newId,
          product_index: newId,
          ...(anchorKey && indexIdMap[anchorKey] !== undefined
            ? { group_catalog_anchor_index_id: indexIdMap[anchorKey] }
            : {}),
        }
      })

      const remapKeyedState = (prev) => {
        const next = {}
        Object.keys(prev || {}).forEach((oldKey) => {
          const newKey = remapKey(oldKey)
          next[newKey] = prev[oldKey]
        })
        return next
      }

      setSelectedProducts(remappedProducts)
      setFieldValue('products', remappedProducts)

      setProductAttachments((prev) => {
        const next = {}
        Object.keys(prev || {}).forEach((oldKey) => {
          const newKey = remapKey(oldKey)
          next[newKey] = (prev[oldKey] || []).map((f) => ({
            ...f,
            product_index_id: newKey,
          }))
        })
        return next
      })

      setAttachmentTabValue(remapKeyedState)
      setSelectedUploadedImages(remapKeyedState)
      setOpenProductAttachment(remapKeyedState)
      setLocationStates(remapKeyedState)
      setOpenProductNote(remapKeyedState)
      setOpenInstallNote(remapKeyedState)

      setSelectedServices((prev) =>
        (prev || []).map((service) => ({
          ...service,
          productIndex:
            indexIdMap[String(service.productIndex)] ?? service.productIndex,
          indexId: indexIdMap[String(service.indexId)] ?? service.indexId,
          newIndexId:
            indexIdMap[String(service.newIndexId)] ?? service.newIndexId,
          product_index:
            indexIdMap[String(service.product_index)] ?? service.product_index,
        })),
      )

      setAdditionalSelectedServices((prev) =>
        (prev || []).map((service) => ({
          ...service,
          productIndex:
            indexIdMap[String(service.productIndex)] ?? service.productIndex,
          indexId: indexIdMap[String(service.indexId)] ?? service.indexId,
          newIndexId:
            indexIdMap[String(service.newIndexId)] ?? service.newIndexId,
          product_index:
            indexIdMap[String(service.product_index)] ?? service.product_index,
        })),
      )

      setSelectedMaterials((prev) =>
        (prev || []).map((material) => ({
          ...material,
          newIndexId:
            indexIdMap[String(material.newIndexId)] ?? material.newIndexId,
          product_index:
            indexIdMap[String(material.product_index)] ?? material.product_index,
        })),
      )

      const maxIndex =
        remappedProducts.length > 0
          ? Math.max(...remappedProducts.map((p) => Number(p.indexId) || 0))
          : 0
      setIndexCounter(maxIndex)

      return remappedProducts
    },
    [setFieldValue],
  )

  const getServiceLineKey = (service) =>
    String(service?.newIndexId ?? service?.indexId ?? service?.product_index ?? '')

  const remapServiceIndexIds = useCallback((indexIdMap) => {
    const remapKey = (oldKey) => {
      const mapped = indexIdMap[String(oldKey)]
      return mapped !== undefined ? String(mapped) : String(oldKey)
    }

    const remapKeyedState = (prev) => {
      const next = {}
      Object.keys(prev || {}).forEach((oldKey) => {
        const newKey = remapKey(oldKey)
        next[newKey] = prev[oldKey]
      })
      return next
    }

    setAdditionalSelectedServices((prev) =>
      (prev || []).map((service) => {
        const oldKey = getServiceLineKey(service)
        const newId = indexIdMap[oldKey]
        if (newId === undefined) return service
        return {
          ...service,
          newIndexId: newId,
          indexId: newId,
          product_index: newId,
          productIndex: newId,
        }
      }),
    )

    setServiceAttachments((prev) => {
      const next = {}
      Object.keys(prev || {}).forEach((oldKey) => {
        const newKey = remapKey(oldKey)
        next[newKey] = (prev[oldKey] || []).map((f) => ({
          ...f,
          service_index_id: newKey,
        }))
      })
      return next
    })

    setAttachmentTabValueService(remapKeyedState)
    setSelectedUploadedImagesService(remapKeyedState)
    setOpenServiceAttachment(remapKeyedState)
    setIsUploadingService(remapKeyedState)
    setOpenServiceNote(remapKeyedState)
  }, [])

  const updateServiceLineInState = useCallback(
    (newIndexId, mapFn) => {
      setEstimateCatalogServices((prev) =>
        (prev || []).map((service) =>
          service.newIndexId === newIndexId ? mapFn(service) : service,
        ),
      )
      setAdditionalSelectedServices((prev) => {
        const next = (prev || []).map((service) =>
          service.newIndexId === newIndexId ? mapFn(service) : service,
        )
        setFieldValue('services', next)
        return next
      })
    },
    [setFieldValue],
  )

  const handleServiceTableDragEnd = useCallback(
    (result) => {
      if (!result.destination || result.destination.index === result.source.index) {
        return
      }
      if (!openEdit) return

      const sorted = [...(additionalSelectedServices || [])]
        .filter((row) => !isEstimateCatalogServiceRow(row))
        .sort(
        (a, b) =>
          (Number(a?.newIndexId ?? a?.indexId ?? a?.product_index) || 0) -
          (Number(b?.newIndexId ?? b?.indexId ?? b?.product_index) || 0),
      )
      const [moved] = sorted.splice(result.source.index, 1)
      sorted.splice(result.destination.index, 0, moved)

      const indexIdMap = buildServiceIndexMapping(sorted)
      remapServiceIndexIds(indexIdMap)
    },
    [additionalSelectedServices, openEdit, remapServiceIndexIds],
  )

  const filteredLaborServiceOptions = useMemo(
    () =>
      (filteredServices || []).filter(
        (item) => item.status == 1 && Number(item.inhouse) !== 1,
      ),
    [filteredServices],
  )

  const applyCatalogToServiceRow = useCallback(
    (newIndexId, catalogService) => {
      setAdditionalSelectedServices((prev) => {
        const existingRow = (prev || []).find((s) => s.newIndexId === newIndexId)
        const catalogLine = {
          ...catalogService,
          newIndexId,
          indexId: newIndexId,
          product_index: newIndexId,
          entryMode: 'choose',
          isAdditionalProduct: false,
          is_service_row: 0,
          service_write:
            Number(existingRow?.service_write) === 1 || existingRow?.is_service_row == 1 ? 1 : 0,
          quantity: catalogService.quantity || 1,
          note: catalogService.note || '',
          name: catalogService.name || catalogService.service_name,
          service_name: catalogService.service_name || catalogService.name,
          addedByUserType: existingRow?.addedByUserType ?? userType,
          isNewlyAddedServiceRow: existingRow?.isNewlyAddedServiceRow,
        }
        const next = (prev || []).map((s) => (s.newIndexId === newIndexId ? catalogLine : s))
        setFieldValue('services', next)
        return next
      })
    },
    [setFieldValue],
  )

  const handleServiceRowEntryModeChange = useCallback(
    (newIndexId, mode) => {
      const targetRow = (additionalSelectedServices || []).find(
        (row) => row?.newIndexId === newIndexId,
      )
      if (targetRow && getServiceToggleDisplayMode(targetRow) === mode) return

      setServiceRowErrors((prev) => {
        const next = { ...prev }
        delete next[newIndexId]
        return next
      })
      if (mode === 'choose') {
        setAdditionalSelectedServices((prev) => {
          const next = (prev || []).map((row) =>
            row.newIndexId === newIndexId
              ? {
                  ...row,
                  newIndexId,
                  indexId: newIndexId,
                  product_index: newIndexId,
                  entryMode: 'choose',
                  name: '',
                  service_name: '',
                  id: null,
                  isAdditionalProduct: false,
                  is_service_row: 0,
                  service_write: 0,
                  isNewlyAddedServiceRow: row?.isNewlyAddedServiceRow,
                  addedByUserType: row?.addedByUserType ?? userType,
                  quantity: 1,
                }
              : row,
          )
          setFieldValue('services', next)
          return next
        })
        return
      }
      setAdditionalSelectedServices((prev) => {
        const next = (prev || []).map((row) =>
          row.newIndexId === newIndexId
            ? {
                ...createEmptyQuotationServiceRow(newIndexId, values?.community),
                is_service_row: details?.is_request_estimate == 1 ? 1 : 0,
                isAdditionalProduct: details?.is_request_estimate == 1 ? false : true,
                service_write:
                  details?.is_request_estimate == 1 ? 1 : (row?.service_write ?? 0),
                isNewlyAddedServiceRow: row?.isNewlyAddedServiceRow,
                addedByUserType: row?.addedByUserType ?? userType,
              }
            : row,
        )
        setFieldValue('services', next)
        return next
      })
    },
    [values?.community, setFieldValue, details?.is_request_estimate],
  )

  const openServicePickerForRow = useCallback(
    (newIndexId, existingService = null) => {
      setServicePickerRowNewIndexId(newIndexId)
      if (existingService?.id != null) {
        const base =
          (filteredServices || []).find((s) => s.id === existingService.id) || existingService
        setServicePickerDraft({ ...base, quantity: existingService.quantity ?? base.quantity ?? 1 })
      } else {
        setServicePickerDraft(null)
      }
      setServicePickerOpen(true)
    },
    [filteredServices],
  )

  const confirmServicePicker = useCallback(() => {
    if (!servicePickerDraft) {
      enqueueSnackbar('Please select a service', { variant: 'warning' })
      return
    }
    const rowNewIndexId = servicePickerRowNewIndexId
    const existingRow = additionalSelectedServices.find((s) => s.newIndexId === rowNewIndexId)
    if (existingRow?.id && existingRow.id !== servicePickerDraft.id) {
      setServiceAttachments((prev) => {
        const next = { ...prev }
        delete next[rowNewIndexId]
        return next
      })
      setOpenServiceAttachment((prev) => {
        const next = { ...prev }
        delete next[rowNewIndexId]
        return next
      })
    }
    applyCatalogToServiceRow(rowNewIndexId, servicePickerDraft)
    setServicePickerOpen(false)
    setServicePickerRowNewIndexId(null)
    setServicePickerDraft(null)
    setServiceRowErrors((prev) => {
      const next = { ...prev }
      delete next[rowNewIndexId]
      return next
    })
  }, [
    servicePickerDraft,
    servicePickerRowNewIndexId,
    additionalSelectedServices,
    applyCatalogToServiceRow,
    enqueueSnackbar,
  ])

  const handleProductRowsDragEnd = useCallback(
    (result, useReviewIndexOffset = false) => {
      if (!result.destination || result.destination.index === result.source.index) {
        return
      }
      const sorted = [...productRows]
      const [moved] = sorted.splice(result.source.index, 1)
      sorted.splice(result.destination.index, 0, moved)
      const indexIdMap = {}
      sorted.forEach((row, idx) => {
        indexIdMap[String(row.indexId)] = useReviewIndexOffset ? indexCounter + idx + 1 : idx + 1
      })
      const remappedRows = sorted.map((row) => ({
        ...row,
        indexId: indexIdMap[String(row.indexId)],
      }))
      setRowErrors((prev) => {
        const next = {}
        Object.keys(prev || {}).forEach((oldKey) => {
          const newKey = indexIdMap[oldKey]
          if (newKey !== undefined) next[newKey] = prev[oldKey]
        })
        return next
      })
      setProductRows(remappedRows)
      setProductRowsIndexCounter(remappedRows.length)
    },
    [productRows, indexCounter],
  )

  const handleServiceRowsDragEnd = useCallback(
    (result) => {
      if (!result.destination || result.destination.index === result.source.index) {
        return
      }
      const sorted = [...serviceRows]
      const [moved] = sorted.splice(result.source.index, 1)
      sorted.splice(result.destination.index, 0, moved)
      const indexIdMap = {}
      sorted.forEach((row, idx) => {
        indexIdMap[String(row.indexId)] = idx + 1
      })
      const remappedRows = sorted.map((row) => ({
        ...row,
        indexId: indexIdMap[String(row.indexId)],
      }))
      setRowErrors((prev) => {
        const next = {}
        Object.keys(prev || {}).forEach((oldKey) => {
          const newKey = indexIdMap[oldKey]
          if (newKey !== undefined) next[newKey] = prev[oldKey]
        })
        return next
      })
      setServiceRows(remappedRows)
      setServiceRowsIndexCounter(remappedRows.length)
    },
    [serviceRows],
  )

  // Negative marketing adjustment logic for manager approval (no Job type on quotation)
  const hasNegativeMarketingAdjustment = useMemo(
    () =>
      (selectedProducts || []).some(
        (p) => p?.adj_value_type === false || p?.install_adj_value_type === false,
      ) ||
      (additionalSelectedServices || []).some(
        (s) => s?.adj_value_type === false || s?.install_adj_value_type === false,
      ) ||
      (selectedMaterials || []).some((m) => m?.adj_value_type === false),
    [selectedProducts, additionalSelectedServices, selectedMaterials],
  );

  // Manager approval auto logic disabled for ViewQuotation.
  // Regular estimates (no job) must not enter manager flow; estimate jobs use EditEstimateJob toggle only.
  /* useEffect(() => {
    const managerApprovalLimit = Number(data?.manager_approval_amount) || 5000;
    if (hasNegativeMarketingAdjustment || parseFloat(grandTotal) > managerApprovalLimit) {
      if (!values.manager_approval_required) {
        setFieldValue('manager_approval_required', true);
      }
    } else {
      if (values.manager_approval_required) {
        setFieldValue('manager_approval_required', false);
      }
    }
  }, [hasNegativeMarketingAdjustment, grandTotal, setFieldValue, data?.manager_approval_amount]); */
  const currentProjectTypeId =
    values?.project_type?.id != null ? values.project_type.id : values?.project_type;

  const matchingProjectType =
    currentProjectTypeId != null
      ? projectTypes?.find((t) => String(t?.id) === String(currentProjectTypeId))
      : null;

  const isCurrentJobClassValid = Boolean(matchingProjectType);
  const isSingleJobClass = DOMAIN === 'la' && Array.isArray(projectTypes) && projectTypes.length === 1;
  const shouldHideJobClassDropdown = isSingleJobClass && isCurrentJobClassValid;

  // Keep invalid/deleted saved Job Class blank and normalize valid id -> full object.
  useEffect(() => {
    if (!Array.isArray(projectTypes)) return;
    if (currentProjectTypeId == null || currentProjectTypeId === '') return;

    if (!matchingProjectType) {
      setFieldValue('project_type', null);
      return;
    }

    if (
      values?.project_type == null ||
      typeof values.project_type !== 'object' ||
      values.project_type?.id == null ||
      String(values.project_type.id) !== String(matchingProjectType.id)
    ) {
      setFieldValue('project_type', matchingProjectType);
    }
  }, [
    projectTypes,
    currentProjectTypeId,
    matchingProjectType,
    setFieldValue,
    values?.project_type,
  ]);

  const showUpdateRequestAndSaveEstimateButtons =
    Number(details?.is_request_estimate) === 1 &&
    (
      (Number(details?.estimate_job_status) === 3 && Number(details?.quotation_status) === 3) ||
      (Number(details?.quotation_status) === 4 && Number(details?.quotation) !== 0) ||
      Number(details?.quotation_status) === 9
    );

    console.log("showUpdateRequestAndSaveEstimateButtons",showUpdateRequestAndSaveEstimateButtons)

  const hasEstimateWriteRows = useMemo(
    () =>
      (selectedProducts || []).some((product) => isQuotationEstimateWriteProduct(product)) ||
      // BACKUP: isQuotationWriteRow(product)
      (additionalSelectedServices || []).some((service) => isQuotationWriteService(service)),
    [selectedProducts, additionalSelectedServices],
  )

  const hasMeaningfulEstimateWriteRows = useMemo(
    () =>
      (selectedProducts || []).some(
        (p) =>
          isQuotationEstimateWriteProduct(p) &&
          (Boolean(p?.id) || Boolean((p.name || p.product_name || '').trim())),
      ) ||
      // BACKUP: isQuotationEstimateWriteProduct(p) only — missed normal-estimate write rows on edit
      (additionalSelectedServices || []).some(
        (s) =>
          isQuotationWriteService(s) &&
          (Boolean(s?.id) || Boolean((s.name || s.service_name || '').trim())),
      //   ) //||
      //   // (productRows || []).some(
      //   //   (r) =>
      //   //     Number(r?.is_product_row) === 1 &&
      //   //     Boolean((r?.product_name || '').trim()),
      //   // ) ||
      //   // (serviceRows || []).some(
      //   //   (r) =>
      //   //     Number(r?.is_service_row) === 1 &&
      //   //     Boolean((r?.service_name || '').trim()),
      //   // ),
      // [selectedProducts, additionalSelectedServices, productRows, serviceRows],
      ),
      [selectedProducts, additionalSelectedServices, productRows, serviceRows],
  )

  const showEstimateCatalogServicePickers = useMemo(() => {
    if (userType === 3 || isClient) return false
    // Non–request-estimate quotes: same estimate catalog UI when user adds write product/service rows.
    if (hasMeaningfulEstimateWriteRows) return true
    if (Number(details?.is_request_estimate) !== 1) return false
    if (!details?.estimate_job_status || Number(details?.estimate_job_status) !== 3) {
      return true
    }
    if (Number(details?.estimate_job_status) === 3 && hasMeaningfulEstimateWriteRows) {
      return true
    }
    if (
      hasMeaningfulEstimateWriteRows &&
      (
        Number(details?.quotation_status) === 9 ||
        (Number(details?.quotation_status) === 4 && Number(details?.quotation) !== 0)
      )
    ) {
      return true
    }
    return false
  }, [details, userType, isClient, hasMeaningfulEstimateWriteRows])

  /** Legacy in-queue productRows/serviceRows bulk picker — not when unified write rows use estimate pickers. */
  const showLegacyBulkServicesAutocomplete = useMemo(
    () =>
      (productRows?.length > 0 || serviceRows?.length > 0) &&
      !hasMeaningfulEstimateWriteRows,
    [productRows, serviceRows, hasMeaningfulEstimateWriteRows],
  )

  useEffect(() => {
    if (
      Number(details?.is_request_estimate) !== 1 &&
      !hasMeaningfulEstimateWriteRows
    ) {
      return
    }
    setAdditionalSelectedServices((prev) => {
      const nonCatalog = (prev || []).filter((s) => !isEstimateCatalogServiceRow(s))
      const merged = sortServicesByProductIndex([
        ...nonCatalog,
        ...(estimateCatalogServices || []),
      ])
      const prevKeys = (prev || [])
        .map((s) => `${s.newIndexId}-${s.id}-${s.service_type}`)
        .join('|')
      const mergedKeys = merged
        .map((s) => `${s.newIndexId}-${s.id}-${s.service_type}`)
        .join('|')
      if (prevKeys === mergedKeys) return prev
      return merged
    })
  }, [
    estimateCatalogServices,
    details?.is_request_estimate,
    hasMeaningfulEstimateWriteRows,
  ])

  const clearEstimateCatalogAndEstimators = useCallback(() => {
    setEstimateCatalogServices([])
    setSelectedEstimators([])
    estimateServiceAutofillDoneRef.current = false
    setAdditionalSelectedServices((prev) =>
      (prev || []).filter((s) => !isEstimateCatalogServiceRow(s)),
    )
  }, [])

  const filteredEstimateServiceOptions = useMemo(
    () =>
      [...(filteredServices || []).filter(
        (item) =>
          item.service_type == 44 &&
          item.status === 1 &&
          Number(item.inhouse) !== 1 &&
          !estimateCatalogServices.some(
            (selected) =>
              selected?.id === item?.id ||
              selected?.labour_cost_service_id === item?.id,
          ),
      )].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || '')),
    [filteredServices, estimateCatalogServices],
  )

  const applyEstimateCatalogServiceSelection = useCallback(
    (newValue, prevList = estimateCatalogServices || []) => {
      const maxFromAdditional = (additionalSelectedServices || []).reduce(
        (max, item) => Math.max(max, Number(item.newIndexId) || 0),
        0,
      )
      const maxFromEstimate = prevList.reduce(
        (max, item) =>
          Math.max(
            max,
            Number(item.newIndexId ?? item.indexId ?? item.product_index) || 0,
          ),
        0,
      )
      let nextId = Math.max(maxFromAdditional, maxFromEstimate, serviceIndexCounter, 0)
      const mapped = (newValue || []).map((service) => {
        const existing = prevList.find(
          (p) =>
            String(p.id) === String(service.id) ||
            String(p.labour_cost_service_id ?? p.id) ===
              String(service.labour_cost_service_id ?? service.id),
        )
        if (existing && (existing.newIndexId != null || existing.indexId != null)) {
          return {
            ...service,
            ...existing,
            name: service.name ?? existing.name,
            newIndexId: existing.newIndexId ?? existing.indexId,
            indexId: existing.indexId ?? existing.newIndexId,
            product_index: existing.product_index ?? existing.newIndexId,
            entryMode: 'choose',
            quantity: existing.quantity ?? 1,
          }
        }
        nextId += 1
        return {
          ...service,
          newIndexId: nextId,
          indexId: nextId,
          product_index: nextId,
          entryMode: 'choose',
          quantity: 1,
        }
      })
      return { mapped, nextId }
    },
    [additionalSelectedServices, estimateCatalogServices, serviceIndexCounter],
  )

  /** When all write product/service rows are removed, clear estimate catalog UI and type-44 lines. */
  useEffect(() => {
    if (loading && openEdit) return
    if (hasMeaningfulEstimateWriteRows) return

    const catalogKeysToRemove = new Set(
      (estimateCatalogServices || []).map((s) =>
        String(s.labour_cost_service_id ?? s.id),
      ),
    )

    // BACKUP: early returns on catalog rows blocked cleanup and, with estimateCatalogServices in deps,
    // setEstimateCatalogServices([]) caused an infinite re-render loop (page not responding).
    // if ((estimateCatalogServices || []).length > 0) return
    // if ((additionalSelectedServices || []).some((s) => isEstimateCatalogServiceRow(s))) return

    if ((estimateCatalogServices || []).length > 0) {
      setEstimateCatalogServices([])
      setSelectedEstimators([])
      estimateServiceAutofillDoneRef.current = false
    }

    setAdditionalSelectedServices((prev) => {
      const next = (prev || []).filter((s) => {
        if (!isEstimateCatalogServiceRow(s)) return true
        if (Number(details?.is_request_estimate) !== 1) return false
        if (catalogKeysToRemove.size === 0) return true
        const key = String(s.labour_cost_service_id ?? s.id)
        return !catalogKeysToRemove.has(key)
      })
      if (next.length === (prev || []).length) return prev
      return next
    })
  }, [hasMeaningfulEstimateWriteRows,details?.is_request_estimate, openEdit])
// }, [hasMeaningfulEstimateWriteRows, details?.is_request_estimate, loading, openEdit])

  useEffect(() => {
    const sectionVisible =
      showEstimateCatalogServicePickers &&
      hasMeaningfulEstimateWriteRows &&
      userType !== 3 &&
      !isClient
    if (!openEdit || loading) {
      estimateServiceAutofillDoneRef.current = false
      return
    }
    // BACKUP: also required showEstimateCatalogServicePickers — blocked autofill on edit when picker visibility lagged behind write rows.
    // const sectionVisible = hasMeaningfulEstimateWriteRows && userType !== 3 && !isClient
    if (!sectionVisible) {
      estimateServiceAutofillDoneRef.current = false
      return
    }
    if ((estimateCatalogServices || []).length > 0) {
      estimateServiceAutofillDoneRef.current = true
      return
    }
    if (estimateServiceAutofillDoneRef.current) return
    const firstOption = filteredEstimateServiceOptions?.[0]
    if (!firstOption) return

    const { mapped, nextId } = applyEstimateCatalogServiceSelection([firstOption], [])
    setServiceIndexCounter((c) => Math.max(c, nextId))
    setEstimateCatalogServices(mapped)
    if (mapped.length > 0) {
      setSelectedEstimators(allEstimators || [])
    }
    estimateServiceAutofillDoneRef.current = true
  }, [
    showEstimateCatalogServicePickers,
    // openEdit,
    // loading,
    hasMeaningfulEstimateWriteRows,
    userType,
    isClient,
    estimateCatalogServices,
    filteredEstimateServiceOptions,
    applyEstimateCatalogServiceSelection,
    allEstimators,
  ])

  // const collaboratorOptions = useMemo(() => {
  //   const availableTeamMembers = Array.isArray(teamMembersOptions) ? teamMembersOptions : [];
  //   let filteredMembers = availableTeamMembers;
  //   const communitySalesRepIds = getCommunitySalesRepIds(values.community);

  //   if (values.community && communitySalesRepIds.length > 0) {
  //     const allowedIds = new Set(communitySalesRepIds.map((id) => String(id)));
  //     filteredMembers = availableTeamMembers.filter((member) => {
  //       const memberId = member?.id ?? member?.user_id;
  //       return memberId != null && allowedIds.has(String(memberId));
  //     });
  //   }

  //   if (collaborators?.length) {
  //     const filteredIds = new Set(
  //       filteredMembers.map((member) => String(member?.id ?? member?.user_id))
  //     );
  //     const missingSelections = collaborators.filter((member) => {
  //       const memberId = member?.id ?? member?.user_id;
  //       return memberId != null && !filteredIds.has(String(memberId));
  //     });
  //     if (missingSelections.length) {
  //       filteredMembers = [...filteredMembers, ...missingSelections];
  //     }
  //   }

  //   return filteredMembers;
  // }, [teamMembersOptions, values.community, collaborators]);

  const collaboratorOptions = useMemo(() => {
    const availableTeamMembers = Array.isArray(teamMembersOptions) ? teamMembersOptions : [];
    let filteredMembers = availableTeamMembers;

    if (collaborators?.length) {
      const filteredIds = new Set(
        filteredMembers.map((member) => String(member?.id ?? member?.user_id))
      );
      const missingSelections = collaborators.filter((member) => {
        const memberId = member?.id ?? member?.user_id;
        return memberId != null && !filteredIds.has(String(memberId));
      });
      if (missingSelections.length) {
        filteredMembers = [...filteredMembers, ...missingSelections];
      }
    }

    return filteredMembers;
  }, [teamMembersOptions, collaborators]);

  // Central helper: mark this edit session as having unsaved changes,
  // and notify the parent popup exactly once.
  const markUnsavedChanges = useCallback(() => {
    if (!openEdit || hasUnsavedChanges) return;
    setHasUnsavedChanges(true);
    if (typeof onDataChange === 'function') {
      onDataChange();
    }
  }, [openEdit, hasUnsavedChanges, onDataChange]);

  // Fallback for native form change events (e.g. simple text inputs).
  const handleFormChange = () => {
    // markUnsavedChanges();
  };

  const buildDraftPayload = () => {
    const vals = { ...values };
    // Save-without-blur for the quotation-level fields: this path has no Formik validation gate
    // to worry about (Save as Draft allows incomplete data), so a direct overlay onto the local
    // `vals` copy is enough — no need for the flush-before-validate wrapper onSubmit needs.
    ;['name', 'description', 'po_number', 'notes', 'subject', 'email_content'].forEach((fieldName) => {
      const pending = topLevelDraftsRef.current[fieldName]
      if (pending !== undefined) vals[fieldName] = pending
    })

    // Save-without-blur safety net for the "Save as Draft" path — same overlay as onSubmit.
    const {
      selectedProductsForSave,
      additionalSelectedServicesForSave,
      estimateCatalogServicesForSave,
      selectedMaterialsForSave,
    } = buildDraftSafeCollections()
    // BACKUP: const isRequestEstimate = details?.is_request_estimate == 1;
    const isRequestEstimate = getEffectiveIsRequestEstimate(
      details,
      selectedProductsForSave,
      additionalSelectedServicesForSave,
      serviceRows,
    );
    vals.is_request_estimate = isRequestEstimate ? 1 : 0;
    vals.productAttachments = productAttachments;
    vals.serviceAttachments = serviceAttachments;
    const isFromFinalReview = details?.estimate_job_status == 3 && isRequestEstimate;
    const isHavingProductRows =
      isRequestEstimate &&
      selectedProductsForSave?.some(
        (row) =>
          isQuotationEstimateWriteProduct(row) &&
          (row.product_name || row.name || '').trim() !== '',
      )
    // BACKUP: isQuotationWriteRow(row) &&
    const mapAdditionalForDraft = (rows) =>
      (rows || [])
        .filter((service) => {
          if (isQuotationChooseEmptyService(service)) return false
          if (isEstimateCatalogServiceRow(service)) return false
          if (isQuotationWriteService(service)) {
            return (service.name || service.service_name || '').trim() !== ''
          }
          return Boolean(service.id || (service.name || '').trim())
        })
        .map((service) => {
          const lineIndex =
            Number(service?.product_index ?? service?.newIndexId ?? service?.indexId) || 0
          const isWrite = isQuotationWriteService(service)
          const { qty, unitCost, lineTotal } = normalizeAdditionalServiceCostFields(service)
          return {
            ...service,
            quantity: qty,
            qty,
            unit_cost: unitCost,
            total: lineTotal,
            total_cost: unitCost,
            newIndexId: lineIndex,
            indexId: lineIndex,
            product_index: lineIndex,
            productIndex: lineIndex,
            is_service_row: isRequestEstimate && isWrite ? 1 : 0,
            isAdditionalProduct: isRequestEstimate ? false : isWrite,
            labour_cost_service_id: service.labour_cost_service_id ?? service.id,
          }
        })
    const catalogServicesForDraft = hasMeaningfulEstimateWriteRows
      ? (estimateCatalogServicesForSave || []).map((s) => ({
      ...s,
      entryMode: 'choose',
      is_service_row: 0,
      isAdditionalProduct: false,
      labour_cost_service_id: s.labour_cost_service_id ?? s.id,
      newIndexId: s.newIndexId ?? s.indexId,
      indexId: s.indexId ?? s.newIndexId,
      product_index: s.product_index ?? s.newIndexId ?? s.indexId,
    }))
      : []
    // BACKUP: (estimateCatalogServicesForSave || []).map(...) always included
    const tableOnlyAdditional = (additionalSelectedServicesForSave || []).filter(
      (s) => !isEstimateCatalogServiceRow(s),
    )
    const mappedAdditionalOnly = mapAdditionalForDraft(tableOnlyAdditional)
    // BACKUP: dedupeServicesForDraft keyed only on s.id — conflated request_services.id with catalogue id
    const payloadAdditionalServices = dedupeEstimateServicesByLine([
      ...mappedAdditionalOnly,
      ...catalogServicesForDraft,
    ])
    const isHavingServiceRows =
      isRequestEstimate &&
      (serviceRows?.some((row) => row.service_name?.trim() !== '') ||
        mappedAdditionalOnly.some(
          (s) =>
            isQuotationWriteService(s) && (s.name || s.service_name || '').trim() !== '',
        ) ||
        catalogServicesForDraft.length > 0);
    if (isRequestEstimate) {
      // BACKUP: filter only isBlankEstimatePlaceholderRow — unnamed Write / empty Choose rows still persisted
      const draftProducts = (selectedProductsForSave || []).filter(shouldPersistDraftProduct)
      vals.products = draftProducts.map((product) => {
        // BACKUP: const isWrite = isQuotationWriteRow(product)
        const isWrite = isQuotationEstimateWriteProduct(product)
        const normalized = normalizeProductForSave(
          resolveGroupMemberMarketingForSave(product, markupType),
        )
        return {
          ...normalized,
          is_product_row: isWrite ? 1 : 0,
          product_write: isWrite ? 1 : 0,
          entryMode: isWrite ? 'write' : 'choose',
          isAdditionalProduct: false,
          // BACKUP: id left as customer_order_products row id from spread
          id: isWrite
            ? normalized.product_id || null
            : normalized.id ?? normalized.product_id ?? null,
          product_id: isWrite ? null : normalized.product_id ?? normalized.id ?? null,
        }
      });
    } else {
      vals.products = (selectedProductsForSave || []).map((product) => {
        const isWrite = isQuotationWriteRow(product)
        return {
          ...normalizeProductForSave(
            resolveGroupMemberMarketingForSave(product, markupType),
          ),
          is_product_row: 0,
          isAdditionalProduct: isWrite,
        }
      });
    }
    // const catalogServicesForDraft = (estimateCatalogServicesForSave || []).map((s) => ({
    //   ...s,
    //   entryMode: 'choose',
    //   is_service_row: 0,
    //   isAdditionalProduct: false,
    //   labour_cost_service_id: s.labour_cost_service_id ?? s.id,
    // }))
    // const allServices = [
    //   ...selectedServices.map(s => ({ ...s, quantityDifference: 0 })),
    //   ...additionalSelectedServicesForSave,
    //   ...catalogServicesForDraft,
    // ];
    // const servicesIdArray = allServices?.map(service => service.id);
    // vals.additionalSelectedServicesForSave = [...additionalSelectedServicesForSave, ...catalogServicesForDraft];
    const mergedDraftServices = [
      ...selectedServices.map((s) => ({ ...s, quantityDifference: 0 })),
      ...payloadAdditionalServices,
    ]
    // BACKUP: const allServices = mergedDraftServices (no dedupe — duplicate type-44 rows on each draft save)
    const allServices = dedupeEstimateServicesByLine(mergedDraftServices)
    const servicesIdArray = allServices?.map((service) => service.id);
    vals.additionalSelectedServices = payloadAdditionalServices;
    vals.services = servicesIdArray?.join(',') || '';
    vals.totalMarkup = totalMarkup;
    vals.selectedServices = allServices;
    vals.labour_cost = totalLabourCost;
    const clientsArray = vals.clients ? [vals.clients] : [];
    vals.clientsData = clientsArray
    vals.bill_to = billToInputValue;
    vals.ship_to = shipToInputValue;
    if (!vals?.bill_to?.trim()) {
      vals.bill_to = buildMultilineAddress(
        vals?.clients?.name || vals?.clients?.customer_name || '',
        vals?.clients?.address || vals?.clients?.customer_address || '',
        vals?.clients?.city || vals?.clients?.customer_city || '',
        vals?.clients?.state || vals?.clients?.customer_state || '',
        vals?.clients?.zip || vals?.clients?.customer_zipcode || vals?.clients?.zip_code || '',
      );
    }
    if (!vals?.ship_to?.trim()) {
      vals.ship_to = buildMultilineAddress(
        vals?.community?.name || '',
        vals?.community?.address || '',
        vals?.community?.city || '',
        vals?.community?.state || '',
        vals?.community?.zip || '',
      );
    }
    vals.total = totalsum;
    vals.taxAmount = taxAmount;
    vals.budget = budget;
    vals.sub_total = rfqSubTotal;
    
    const submitProductsForLead = selectedProducts?.length > 0 ? selectedProducts : vals.products || [];
    const submitIsRushFeeAutoLocked = isInstallBeforeRequiredLead(vals, submitProductsForLead);
    const submitCanOverrideRushFeeLock = !!explodedPermissions?.some((permission) =>
      ['Override Rush Fee Estimate'].includes(permission),
    );
    const submitIsRushFeeChecked =
      Number(vals?.rush_fee) === 1 ||
      (!!submitIsRushFeeAutoLocked && !submitCanOverrideRushFeeLock);
    
    vals.rush_fee_amount = calcRushFeeAmount({
      enabled: submitIsRushFeeChecked,
      subtotal: totalsum || 0,
      percentage: currentRushFeePercentage,
      storedAmount: details?.rush_fee_amount || 0,
      preferStored: false
    });
    
    vals.avatarUrl = avatarUrl;
    let startVal = values.start;
    let endVal = values.end;
    if (endVal && isNaN(endVal)) endVal = Math.floor(new Date(endVal).getTime() / 1000);
    if (startVal && isNaN(startVal)) startVal = Math.floor(new Date(startVal).getTime() / 1000);
    vals.start = startVal;
    vals.end = endVal;
    const data = {
      values: vals,
      avatarUrl: avatarUrl,
      userId,
      userType,
      request_id: id,
      isHavingProductRows,
      isHavingServiceRows,
      isFromFinalReview,
      avalara_transaction_id: details?.avalara_transaction_id,
      avalara_code: details?.avalara_code,
      allLocationSame,
      rfpProducts: cart,
      taxCategory: selectedTaxCategory?.id || null,
      allRfpServiceLocationSame,
      rfpServices: cartService,
      materials: selectedMaterialsForSave,
      produtFormulaMaterial: produtFormulaMaterial || [],
      groupProductMarketingData: groupedProducts ? groupedProducts.map((group) => ({
        group_id: group.id,
        // Save-without-blur: use the pending draft if one exists for this group.
        group_name: getGroupNameForSave(group),
        group_description: getGroupDescForSave(group),
        quantity: group.groupQuantity || 1,
        adj_value_type: group.groupAdjValueType ?? true,
        adjustment: Number(group.groupAdjustment ?? 0),
        total_formula_each: Number((group.totalProductFormulaEach || 0).toFixed(2)),
        total_retail_each: Number((group.totalProductRetailEach || 0).toFixed(2)),
        adjusted_retail_each: Number((group.adjustedGroupRetailEach || 0).toFixed(2)),
        adjusted_subtotal: Number((group.adjustedGroupSubtotal || 0).toFixed(2)),
      })) : [],
      groupInstallMarketingData: groupedProducts ? groupedProducts.map((group) => ({
        group_id: group.id,
        group_name: getGroupNameForSave(group),
        group_description: getGroupDescForSave(group),
        quantity: group.groupInstallQuantity || 1,
        adj_value_type: group.groupInstallAdjValueType ?? true,
        adjustment: Number(group.groupInstallAdjustment ?? 0),
        total_formula_each: Number((group.totalInstallFormulaEach || 0).toFixed(2)),
        total_retail_each: Number((group.totalInstallRetailEach || 0).toFixed(2)),
        adjusted_retail_each: Number((group.adjustedGroupInstallRetailEach || 0).toFixed(2)),
        adjusted_subtotal: Number((group.adjustedGroupInstallSubtotal || 0).toFixed(2)),
      })) : [],
      address: buildCombinedAddressPayload(),
      quotation: 1,
      collaborators: Array.isArray(collaborators) ? collaborators.map((c) => (typeof c === 'object' && c?.id != null ? c.id : c)).filter(Boolean).join(',') : (collaborators || ''),
      all_sales_rep_ids: allSalesRepIds,
      saveAsDraft: true,
      is_draft: true,
      draft_source: 1, // drafted from Estimate
      // Regular estimates (no job): never save manager approval on draft
      // manager_approval_required: values.manager_approval_required === true || values.manager_approval_required === 1,
      manager_approval_required: (details?.is_request_estimate == 1 || values?.is_request_estimate == 1)
        ? (values.manager_approval_required === true || values.manager_approval_required === 1)
        : false,
      // BACKUP: selectedEstimators,
      selectedEstimators: hasMeaningfulEstimateWriteRows ? selectedEstimators : [],
      customer_name: values.customer_name,
      clientsData: clientsArray,
      estimate_qb_id : details?.estimate_id,
    };
    return data;
  };

  const handleSaveDraft = async (e, stayOnPage = false) => {
    // "Save as Draft" always uses draft save (edit-request-draft), not full update.
    // No auto-save: Cancel / Back / Close do not call this; only the button does.
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    try {
      if (
        (selectedProducts || []).some(
          (product) => !product?.fromMapServices && isQuotationChooseEmptyRow(product),
        )
      ) {
        enqueueSnackbar('Please select a catalog product for each Choose row, or switch to Write.', { variant: 'error' })
        return
      }
      // Save-without-blur: check the pending-draft-aware name, not the possibly-stale
      // selectedProducts value, so a name just typed (not yet committed) isn't rejected.
      if (hasUnnamedWriteProductRow(buildDraftSafeCollections().selectedProductsForSave)) {
        enqueueSnackbar('Please fill in all required product names.', { variant: 'error' })
        return
      }
      const data = buildDraftPayload();
      const requestData = { ...data, processType: 'update_draft', quotation: data?.quotation || 1, socketId: null };
      setProgressRequestData(requestData);
      setShowProgressModal(true);
      await new Promise(resolve => setTimeout(resolve, 2000));
      if (!socketReady) await new Promise(resolve => setTimeout(resolve, 1000));
      await axios.post(`${REST_API}webservice/edit-request-draft`, data)
        .then(async (res) => {
          if (typeof setOpenEdit === 'function') {
            setOpenEdit(false);
          }
          setIsOpen(false);
          setCurrentRFQdata({});
          resetForm();
          setHasUnsavedChanges(false);
          setSelectedProducts([]);
          setSelectedMapserviceProducts([]);
          setSelectedTaxCategory(null);
          setSelectedServices([]);
          setAdditionalSelectedServices([]);
          setFilteredServices([]);
          fetchRequestDetails();
          enqueueSnackbar('Draft saved', { variant: 'success' });
          setShowProgressModal(false);
          if (popupOn) {
            // Popup mode
            if (!stayOnPage) {
              // If this save was triggered by the fullscreen "close" action,
              // the parent will close + trigger refresh via `closeAfterSave()` *after* this API finishes.
              if (!autoCloseSaveRef.current && typeof closeView === 'function') {
                closeView();
                setRenderCards((prev) => !prev);
              }
            }
            // stayOnPage === true → keep popup open on detail view (no navigation)
          } else {
            // Full-page mode
            if (!stayOnPage) {
              // Only navigate when explicitly requested (e.g. top "Save as Draft" button)
              navigate(`/dashboard/quick-bid/view/${id}`);
            }
            // stayOnPage === true → remain on current detail route, just exit edit mode
          }
          if (edit) {
            edit = false;
            if (typeof setOpenEdit === 'function') {
              setOpenEdit(false);
            }
            setIsOpen(false);
          }
        })
        .catch((err) => {
          console.log(err, 'error');
          setShowProgressModal(false);
          enqueueSnackbar('Failed to save draft', { variant: 'error' });
        });
    } catch (error) {
      console.error(error);
      setShowProgressModal(false);
    }
  };

  const handleUpdateRequest = async (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    updateRequestClickedRef.current = true;
    await handleSubmitWithDraftFlush();
  };

  // Auto-save on close disabled – only "Save as Draft" button saves.
  // useEffect(() => {
  //   if (saveTrigger && openEdit) {
  //     autoCloseSaveRef.current = true;
  //     const isDraftEstimate =
  //       details?.quotation_status === 1 ||
  //       details?.status === 1 ||
  //       details?.is_draft === 1;
  //     if (isDraftEstimate) {
  //       (async () => {
  //         await handleSaveDraft();
  //         if (typeof closeAfterSave === 'function') {
  //           closeAfterSave();
  //         }
  //       })().finally(() => {
  //         autoCloseSaveRef.current = false;
  //       });
  //     } else {
  //       autoCloseAfterNormalSaveRef.current = true;
  //       handleSubmit();
  //     }
  //   }
  // }, [saveTrigger]);  

  useEffect(() => {
    if (!openEdit || !id) return;
    const state = { editDraftOpen: true };
    window.history.pushState(state, '');
    const onPopState = () => {
      // Do not auto-save draft on browser back - only Save as Draft button triggers save
    };
    window.addEventListener('popstate', onPopState);
    return () => window.removeEventListener('popstate', onPopState);
  }, [openEdit, id]);

  useEffect(() => {
    if (!openEdit || !id) return;
    const t = setTimeout(() => {
      try {
        const payload = buildDraftPayload();
        latestEditDraftRef.current = payload;
        // Product rows are now auto-saved to backend, so no need to save to localStorage
      } catch (e) {}
    }, 500);
    return () => clearTimeout(t);
  }, [openEdit, id, values, selectedProducts, cart, cartService, selectedMaterials, avatarUrl, totalsum, taxAmount, budget, rfqSubTotal, totalLabourCost]);

  useEffect(() => {
    if (!openEdit || !id) return;
    const onBeforeUnload = () => {
      // Product rows are now auto-saved to backend, so no need to save to localStorage on unload
    };
    window.addEventListener('beforeunload', onBeforeUnload);
    return () => window.removeEventListener('beforeunload', onBeforeUnload);
  }, [openEdit, id]);

  const setValuesToPreview=()=>{
    setPreviewData(values)
  }

  // let  totalsum = 0
  // let DiscountTotal=0
  // let newTotalProductFormula1 = 0;
  // let newTotalWholesalePrice1 = 0;
  // let newTotalRetailPrice1 = 0;

  const calculateTotal = (price, quantity, discount,value,location=1, adjustment = 0 ,markAdjType=1,adj_value_type=true ) => {

    const parsedQuantity = parseFloat(quantity?quantity:value) || 1;
    const parsedDiscount = parseFloat(discount) || 0;
    const locationQuantity=parseFloat(location)||1
    const newPrice = parseFloat(price) || 0
    // let subtotal = price * parsedQuantity*locationQuantity;
    let SPMA = newPrice //+ ((newPrice * (adjustment ? Number(adjustment) : 0)) / 100)
    let subtotal = parseFloat(SPMA)?.toFixed(2) * parsedQuantity * locationQuantity;

    if(markAdjType ==2 || markAdjType ==3){
      SPMA = newPrice //+ (adjustment ? Number(adjustment) : 0)
      subtotal = parseFloat(SPMA)?.toFixed(2) * parsedQuantity * locationQuantity;
    }
    
    if (discount) {
      subtotal = subtotal - discount;
    }
    console.log('calculateTotal--subtotal-price---',price)
    console.log('calculateTotal--subtotal-SPMA---',SPMA)
    console.log('calculateTotal--subtotal-adjustment---',adjustment)
    console.log('calculateTotal--subtotal----',subtotal)
    // if (adjustment) {
    //   // subtotal = subtotal + ((subtotal * adjustment) / 100);
    //   subtotal = subtotal + (adj_value_type ? Number(adjustment) : -(Number(adjustment)))
    //   console.log('calculateTotal--subtotal', subtotal,adjustment,adj_value_type)
    // }
    return subtotal;
 };

  const handleRetailPriceChange = (indexId, rawValue, options = {}) => {
    const { isBlur = false } = options
    const limitedValue = limitDecimalInput(rawValue)
    const valueToApply = isBlur
      ? formatPriceToTwoDecimals(limitedValue)
      : limitedValue

    if (valueToApply === '' || valueToApply === '-') {
      if (isBlur) {
        setSelectedProducts((prevProducts) =>
          prevProducts.map((product) =>
            product.indexId === indexId
              ? { ...product, retail_price_draft: undefined }
              : product,
          ),
        )
      } else {
        setSelectedProducts((prevProducts) =>
          prevProducts.map((product) =>
            product.indexId === indexId
              ? { ...product, retail_price_draft: limitedValue }
              : product,
          ),
        )
      }
      return
    }

    if (!isBlur && Number.isNaN(parseFloat(valueToApply))) {
      setSelectedProducts((prevProducts) =>
        prevProducts.map((product) =>
          product.indexId === indexId
            ? { ...product, retail_price_draft: limitedValue }
            : product,
        ),
      )
      return
    }

    let adjustmentFieldToSync = null
    let adjustmentValueToSync = null

    setSelectedProducts((prevProducts) =>
      prevProducts.map((product) => {
        if (product.indexId !== indexId) return product

        const editResult = applyRetailPriceEdit(
          ensureCatalogBaselines(product),
          valueToApply,
          markupType,
          {
            hasNegativePermission: explodedPermissions?.some((permission) =>
              ['Allow Negative Marketing Adjustment Estimate'].includes(permission),
            ),
          },
        )

        if (!editResult) {
          return { ...product, retail_price_draft: limitedValue }
        }

        if (editResult.error) {
          if (!isBlur) {
            return { ...product, retail_price_draft: limitedValue }
          }
          enqueueSnackbar(editResult.error, { variant: 'error' })
          return { ...product, retail_price_draft: undefined }
        }

        const reconciled = reconcileCatalogMarketingPrices({
          ...product,
          ...editResult,
          adjustment_draft: undefined,
        })

        const priceForTotal =
          markupType === 1
            ? reconciled.price
            : reconciled.install_cost && parseFloat(reconciled.install_cost) > 0
            ? reconciled.retail_price
            : reconciled.actual_retail_price

        const total = calculateTotal(
          priceForTotal,
          Number(product.quantity),
          product.discount || 0,
          product.quantity,
          product.locationQuantity,
          reconciled.adjustment,
          product.markAdjType,
          reconciled.adj_value_type,
        )

        adjustmentFieldToSync = `adjustment_${product.product_id || product.id}`
        adjustmentValueToSync = Number(reconciled.adjustment)
          ? reconciled.adjustment
          : ''

        return {
          ...reconciled,
          retail_price_draft: isBlur ? undefined : limitedValue,
          ...(markupType === 1 ? { product_price: reconciled.price } : {}),
          product_total: total,
        }
      }),
    )

    if (adjustmentFieldToSync != null) {
      setFieldValue(adjustmentFieldToSync, adjustmentValueToSync)
    }
    setRefreshCalculation(!refreshCalculation)
  }

  const handleInstallPriceChange = (indexId, rawValue, options = {}) => {
    const { isBlur = false } = options
    const limitedValue = limitDecimalInput(rawValue)
    const valueToApply = isBlur
      ? formatPriceToTwoDecimals(limitedValue)
      : limitedValue

    if (valueToApply === '' || valueToApply === '-') {
      if (isBlur) {
        setSelectedProducts((prevProducts) =>
          prevProducts.map((product) =>
            product.indexId === indexId
              ? { ...product, install_price_draft: undefined }
              : product,
          ),
        )
      } else {
        setSelectedProducts((prevProducts) =>
          prevProducts.map((product) =>
            product.indexId === indexId
              ? { ...product, install_price_draft: limitedValue }
              : product,
          ),
        )
      }
      return
    }

    if (!isBlur && Number.isNaN(parseFloat(valueToApply))) {
      setSelectedProducts((prevProducts) =>
        prevProducts.map((product) =>
          product.indexId === indexId
            ? { ...product, install_price_draft: limitedValue }
            : product,
        ),
      )
      return
    }

    setSelectedProducts((prevProducts) =>
      prevProducts.map((product) => {
        if (product.indexId !== indexId) return product

        const editResult = applyInstallPriceEdit(
          ensureCatalogBaselines(product),
          valueToApply,
          {
            hasNegativePermission: explodedPermissions?.some((permission) =>
              [
                'Allow Negative Marketing Adjustment Sales Order',
                'Allow Negative Marketing Adjustment Estimate',
              ].includes(permission),
            ),
          },
        )

        if (!editResult) {
          return { ...product, install_price_draft: limitedValue }
        }

        if (editResult.error) {
          if (!isBlur) {
            return { ...product, install_price_draft: limitedValue }
          }
          enqueueSnackbar(editResult.error, { variant: 'error' })
          return { ...product, install_price_draft: undefined }
        }

        const normalized = normalizeProductForSave({
          ...product,
          ...editResult,
        })

        const total = calculateTotal(
          normalized.retail_price,
          Number(product.quantity),
          product.discount || 0,
          product.quantity,
          product.locationQuantity,
          normalized.adjustment,
          product.markAdjType,
          normalized.adj_value_type,
        )

        return {
          ...normalized,
          install_price_draft: isBlur ? undefined : limitedValue,
          install_adjustment_draft: undefined,
          product_total: total,
        }
      }),
    )
    setRefreshCalculation(!refreshCalculation)
  }

  const resolveInstallBaseline = (product) => {
    const baselined = ensureCatalogBaselines(product)
    return Number(baselined.original_install_cost) || Number(baselined.install_cost) || 0
  }

  const applyInstallAdjValueTypeUpdate = (product, newValue) => {
    const baselined = ensureCatalogBaselines(product)
    const baseInstall = resolveInstallBaseline(baselined)
    if (!baseInstall) {
      return {
        ...baselined,
        install_adj_value_type: newValue,
        install_price_draft: undefined,
      }
    }
    const adj = Number(baselined.install_adjustment) || 0
    const newInstallCost = computeInstallCostFromAdjustment(baseInstall, adj, newValue)
    return normalizeProductForSave({
      ...baselined,
      install_adj_value_type: newValue,
      install_cost: newInstallCost,
      original_install_cost: baselined.original_install_cost ?? baseInstall,
      retail_price: Number(
        (
          (Number(baselined.actual_retail_price) || 0) + newInstallCost
        ).toFixed(2),
      ),
      install_price_draft: undefined,
    })
  }

  const handleInstallAdjValueTypeChange = (indexId, data, newValue) => {
    const hasPermission = explodedPermissions?.some((permission) =>
      ['Allow Negative Marketing Adjustment Estimate'].includes(permission),
    )
    if (newValue === false) {
      const formulaEach = Number(data?.expected_install_labor_cost_with_markup || 0)
      const retailEachBase = Math.max(0, Number(data.install_cost || 0))
      if (retailEachBase <= formulaEach && !hasPermission) {
        enqueueSnackbar(
          'To apply a negative marketing adjustment, Install Price Each must be higher than the Install formula cost Each.',
          { variant: 'error' },
        )
        return
      }
    }
    const maxNegative = getMaxNegativeInstallAdjustment(data, hasPermission)
    const adjustment = Number(data.install_adjustment) || 0
    const formulaEach = Number(data?.expected_install_labor_cost_with_markup || 0)
    const baseInstall = Number(data?.original_install_cost) || Number(data?.install_cost) || 0
    const resultingInstallCost = computeInstallCostFromAdjustment(
      baseInstall,
      adjustment,
      newValue,
    )
    if (
      newValue === false &&
      !isInstallRetailPriceAllowed(resultingInstallCost, formulaEach, hasPermission)
    ) {
      if (hasPermission) {
        enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
      } else {
        enqueueSnackbar(
          `Negative Adjustment Amount cannot reduce below $${maxNegative.toFixed(2)} (Install Formula Limit)`,
          { variant: 'error' },
        )
      }
      return
    }
    if (Number(adjustment) >= maxNegative && newValue === false && hasPermission) {
      enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
      return
    }
    if (Number(adjustment) > maxNegative && newValue === false && !hasPermission) {
      enqueueSnackbar(
        `Negative Adjustment Amount cannot reduce below $${maxNegative.toFixed(2)} (Install Formula Limit)`,
        { variant: 'error' },
      )
      return
    }

    setSelectedProducts((prevProducts) =>
      prevProducts.map((product) =>
        product.indexId === indexId
          ? applyInstallAdjValueTypeUpdate(product, newValue)
          : product,
      ),
    )
    if (newValue === false) {
      // setFieldValue('manager_approval_required', true)
    }
    setRefreshCalculation((v) => !v)
  }

  const handleInstallAdjustmentChange = (indexId, data, newValue) => {
    const hasPermission = explodedPermissions?.some((permission) =>
      ['Allow Negative Marketing Adjustment Estimate'].includes(permission),
    )
    const maxNegative = getMaxNegativeInstallAdjustment(data, hasPermission)
    const isPositiveInstallAdj =
      data.install_adj_value_type !== false && data.install_adj_value_type !== 0
    const baseInstall =
      Number(data?.original_install_cost) || Number(data?.install_cost) || 0
    const formulaEach = Number(data?.expected_install_labor_cost_with_markup || 0)
    const adjNum = Number(newValue) || 0

    if (
      !isPositiveInstallAdj &&
      adjNum >= maxNegative &&
      hasPermission
    ) {
      enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
      return
    }
    if (
      !isPositiveInstallAdj &&
      adjNum > maxNegative &&
      !hasPermission
    ) {
      enqueueSnackbar(
        `Negative Adjustment Amount cannot reduce below $${maxNegative.toFixed(2)} (Install Formula Limit)`,
        { variant: 'error' },
      )
      return
    }

    const newInstallCost = baseInstall
      ? computeInstallCostFromAdjustment(baseInstall, newValue, isPositiveInstallAdj)
      : null

    if (
      baseInstall &&
      !isInstallRetailPriceAllowed(newInstallCost, formulaEach, hasPermission)
    ) {
      if (hasPermission) {
        enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
      } else {
        enqueueSnackbar(
          `Negative Adjustment Amount cannot reduce below $${maxNegative.toFixed(2)} (Install Formula Limit)`,
          { variant: 'error' },
        )
      }
      return
    }

    setSelectedProducts((prevProducts) =>
      prevProducts.map((product) => {
        if (product.indexId !== indexId) return product

        const baselined = ensureCatalogBaselines(product)
        const resolvedBase = resolveInstallBaseline(baselined)

        return normalizeProductForSave({
          ...baselined,
          install_adjustment: newValue,
          install_adjustment_draft: newValue,
          install_cost: newInstallCost,
          original_install_cost: baselined.original_install_cost ?? resolvedBase,
          retail_price: Number(
            (
              (Number(baselined.actual_retail_price) || 0) +
              (Number(newInstallCost) || 0)
            ).toFixed(2),
          ),
          install_price_draft: undefined,
        })
      }),
    )
    setRefreshCalculation((v) => !v)
  }

  const handleMarketingAdjustmentChange = (indexId, rawValue, options = {}) => {
    const { isBlur = false } = options
    const limitedValue = limitDecimalInput(rawValue)

    if (limitedValue === '' || limitedValue === '-') {
      if (isBlur) {
        setSelectedProducts((prevProducts) =>
          prevProducts.map((product) => {
            if (product.indexId !== indexId) return product
            const baselined = ensureCatalogBaselines(product)
            setFieldValue(
              `adjustment_${product.product_id || product.id}`,
              '',
            )
            return reconcileCatalogMarketingPrices({
              ...baselined,
              adjustment: 0,
              adjustment_draft: undefined,
              retail_price_edited: false,
            })
          }),
        )
        setRefreshCalculation(!refreshCalculation)
      } else {
        setSelectedProducts((prevProducts) =>
          prevProducts.map((product) => {
            if (product.indexId !== indexId) return product
            const baselined = ensureCatalogBaselines(product)
            return reconcileCatalogMarketingPrices({
              ...baselined,
              adjustment: '',
              adjustment_draft: '',
              retail_price_edited: false,
              retail_price_draft: undefined,
            })
          }),
        )
        setRefreshCalculation(!refreshCalculation)
      }
      return
    }

    if (!isBlur) {
      setSelectedProducts((prevProducts) =>
        prevProducts.map((product) => {
          if (product.indexId !== indexId) return product

          const hasPermission = explodedPermissions?.some((permission) =>
            ['Allow Negative Marketing Adjustment Estimate'].includes(
              permission,
            ),
          )
          const { maxNegative } = getMaxNegativeAdjustment(product, hasPermission)
          if (
            Number(limitedValue) >= maxNegative &&
            (product.adj_value_type === false || product.adj_value_type === 0) &&
            hasPermission
          ) {
            enqueueSnackbar('Retail value cannot be zero or less', {
              variant: 'error',
            })
            return product
          }
          if (
            Number(limitedValue) > maxNegative &&
            (product.adj_value_type === false || product.adj_value_type === 0) &&
            !hasPermission
          ) {
            enqueueSnackbar(
              `Negative Adjustment Amount cannot reduce total below Product Formula Cost. Max allowed: $${maxNegative.toFixed(2)}`,
              { variant: 'error' },
            )
            return product
          }

          const numAdjustment = Number(limitedValue) || 0
          const baselined = ensureCatalogBaselines(product)
          const reconciled = reconcileCatalogMarketingPrices({
            ...baselined,
            adjustment: limitedValue,
            retail_price_edited: numAdjustment !== 0,
          })

          return {
            ...reconciled,
            adjustment_draft: limitedValue,
            adjustment: limitedValue,
            retail_price_draft: undefined,
          }
        }),
      )
      setRefreshCalculation(!refreshCalculation)
      return
    }

    const normalizedValue = formatPriceToTwoDecimals(limitedValue)
    const numValue = Number(normalizedValue) || 0

    setSelectedProducts((prevProducts) =>
      prevProducts.map((product) => {
        if (product.indexId !== indexId) return product

        const hasPermission = explodedPermissions?.some((permission) =>
          ['Allow Negative Marketing Adjustment Estimate'].includes(
            permission,
          ),
        )
        const { maxNegative } = getMaxNegativeAdjustment(product, hasPermission)
        if (
          numValue >= maxNegative &&
          (product.adj_value_type === false || product.adj_value_type === 0) &&
          hasPermission
        ) {
          enqueueSnackbar('Retail value cannot be zero or less', {
            variant: 'error',
          })
          return { ...product, adjustment_draft: undefined }
        }
        if (
          numValue > maxNegative &&
          (product.adj_value_type === false || product.adj_value_type === 0) &&
          !hasPermission
        ) {
          enqueueSnackbar(
            `Negative Adjustment Amount cannot reduce total below Product Formula Cost. Max allowed: $${maxNegative.toFixed(2)}`,
            { variant: 'error' },
          )
          return { ...product, adjustment_draft: undefined }
        }

        const reconciled = reconcileCatalogMarketingPrices({
          ...ensureCatalogBaselines(product),
          adjustment: numValue,
          adj_value_type:
            numValue === 0 ? true : product.adj_value_type ?? true,
          retail_price_edited: numValue !== 0,
          adjustment_draft: undefined,
          retail_price_draft: undefined,
        })

        setFieldValue(
          `adjustment_${product.product_id || product.id}`,
          numValue ? normalizedValue : '',
        )

        return reconciled
      }),
    )
    setRefreshCalculation(!refreshCalculation)
  }

  const findCustProductRowForLineCatalog = (product) => {
    const rows = invoice?.cust_product
    if (!product || !Array.isArray(rows) || rows.length === 0) return null
    const byIndex =
      product.indexId != null
        ? rows.find((r) => Number(r?.product_index) === Number(product.indexId))
        : null
    if (byIndex) return byIndex
    if (product.backendId != null) {
      return (
        rows.find((r) => r?.id != null && String(r.id) === String(product.backendId)) ||
        null
      )
    }
    return null
  }

  const isProductLineCatalog = (product) => {
    if (!product) return false
    if (Number(product.is_line_catalog) === 1) return true
    const row = findCustProductRowForLineCatalog(product)
    return Number(row?.is_line_catalog) === 1
  }

  const getGroupProductCatalogRetailEach = (members, markupTypeVal) =>
    (members || []).reduce((sum, p) => {
      const baselined = ensureCatalogBaselines(p)
      if (markupTypeVal == 1) {
        return (
          sum +
          Number(baselined.original_price ?? baselined.price ?? baselined.product_price ?? 0)
        )
      }
      return (
        sum +
        Number(
          baselined.original_actual_retail_price ??
            baselined.original_retail_price ??
            baselined.actual_retail_price ??
            0,
        )
      )
    }, 0)

  const getGroupInstallCatalogRetailEach = (members) =>
    (members || []).reduce((sum, p) => {
      const baselined = ensureCatalogBaselines(p)
      return sum + Number(baselined.original_install_cost ?? baselined.install_cost ?? 0)
    }, 0)

  const getGroupMaxNegativeAdjustment = (group, hasPermission) => {
    const formulaEach = Number(group?.totalProductFormulaEach ?? 0)
    const retailEachBase = Number(group?.totalProductCatalogRetailEach ?? 0)
    let maxNegative = Math.max(0, retailEachBase - formulaEach)
    if (hasPermission) maxNegative = retailEachBase
    return { maxNegative, formulaEach, retailEachBase }
  }

  const getGroupMaxNegativeInstallAdjustment = (group, hasPermission) => {
    const formulaEach = Number(group?.totalInstallFormulaEach ?? 0)
    const retailEachBase = Number(group?.totalInstallCatalogRetailEach ?? 0)
    let maxNegative = Math.max(0, retailEachBase - formulaEach)
    if (hasPermission) maxNegative = retailEachBase
    return { maxNegative, formulaEach, retailEachBase }
  }

  const resolveGroupProductCatalogBaseline = (groupKey, group) =>
    Number(
      groupProductMarketingValues?.[groupKey]?.originalCatalogRetailEach ??
        group?.totalProductCatalogRetailEach ??
        0,
    )

  const resolveGroupInstallCatalogBaseline = (groupKey, group) =>
    Number(
      groupInstallMarketingValues?.[groupKey]?.originalInstallCatalogEach ??
        group?.totalInstallCatalogRetailEach ??
        0,
    )

  const formatGroupProductMarketingFromRetailEdit = (editResult, catalogBaseline) => {
    if (!editResult || editResult.error) return null
    const isBackToBaseline =
      Math.abs(Number(editResult.actual_retail_price ?? 0) - catalogBaseline) < 0.005 ||
      Number(editResult.adjustment) === 0
    return {
      adjustment: isBackToBaseline ? '' : editResult.adjustment,
      adjValueType: isBackToBaseline ? true : editResult.adj_value_type,
      adjustment_draft: undefined,
    }
  }

  const formatGroupInstallMarketingFromRetailEdit = (editResult, catalogBaseline) => {
    if (!editResult || editResult.error) return null
    const isBackToBaseline =
      Math.abs(Number(editResult.install_cost ?? 0) - catalogBaseline) < 0.005 ||
      Number(editResult.install_adjustment) === 0
    return {
      adjustment: isBackToBaseline ? '' : editResult.install_adjustment,
      adjValueType: isBackToBaseline ? true : editResult.install_adj_value_type,
      adjustment_draft: undefined,
    }
  }

  const buildGroupProductRetailEditPayload = (catalogBaseline, formulaEach) => ({
    original_actual_retail_price: catalogBaseline,
    original_retail_price: catalogBaseline,
    original_product_retail_price: catalogBaseline,
    original_price: catalogBaseline,
    expected_material_cost_with_markup: formulaEach,
    expected_service_cost_with_markup: 0,
  })

  const buildGroupInstallRetailEditPayload = (catalogBaseline, formulaEach) => ({
    original_install_cost: catalogBaseline,
    install_cost: catalogBaseline,
    expected_install_labor_cost_with_markup: formulaEach,
  })

  const resetGroupMembersToCatalogBaseline = (groupKey, markupTypeVal) => {
    setSelectedProducts((prevProducts) =>
      (prevProducts || []).map((product) => {
        if (String(product?.group_id) !== String(groupKey)) return product
        const baselined = ensureCatalogBaselines(product)
        const originalActual = Number(baselined.original_actual_retail_price ?? 0)
        const originalRetail = Number(baselined.original_retail_price ?? originalActual)
        const originalPrice = Number(baselined.original_price ?? baselined.price ?? 0)
        const originalInstall = Number(baselined.original_install_cost ?? baselined.install_cost ?? 0)
        return reconcileCatalogMarketingPrices({
          ...baselined,
          adjustment: 0,
          adj_value_type: true,
          install_adjustment: 0,
          install_adj_value_type: true,
          retail_price_edited: false,
          actual_retail_price: originalActual,
          retail_price: originalRetail,
          product_retail_price: originalActual,
          install_cost: originalInstall,
          ...(markupTypeVal === 1
            ? { price: originalPrice, product_price: originalPrice }
            : {}),
          retail_price_draft: undefined,
          adjustment_draft: undefined,
          install_price_draft: undefined,
          install_adjustment_draft: undefined,
        })
      }),
    )
  }

  const groupedProducts = React.useMemo(
    () =>
      computeGroupedProducts({
        selectedProducts,
        markupType,
        customerOrderProductGroups,
        groupProductMarketingValues,
        groupInstallMarketingValues,
        groupQuantityMode: GROUP_QUANTITY_MODE_SET_MULTIPLIER,
      }),
    [
      selectedProducts,
      customerOrderProductGroups,
      groupProductMarketingValues,
      groupInstallMarketingValues,
      markupType,
      refreshCalculation,
    ],
  )

  const groupedProductsMap = React.useMemo(() => {
    return new Map((groupedProducts || []).map((g) => [String(g.id), g]))
  }, [groupedProducts])

  useEffect(() => {
    if (!groupedProducts?.length) return

    setGroupProductMarketingValues((prev) => {
      let changed = false
      const next = { ...prev }
      groupedProducts.forEach((group) => {
        const key = String(group.id)
        const catalog = getGroupProductCatalogRetailEach(group.products, markupType)
        const current = next[key] || {}
        if (current.originalCatalogRetailEach == null && catalog > 0) {
          next[key] = { ...current, originalCatalogRetailEach: catalog }
          changed = true
        }
      })
      return changed ? next : prev
    })

    setGroupInstallMarketingValues((prev) => {
      let changed = false
      const next = { ...prev }
      groupedProducts.forEach((group) => {
        const key = String(group.id)
        const catalog = getGroupInstallCatalogRetailEach(group.products)
        const current = next[key] || {}
        if (current.originalInstallCatalogEach == null && catalog > 0) {
          next[key] = { ...current, originalInstallCatalogEach: catalog }
          changed = true
        }
      })
      return changed ? next : prev
    })
  }, [groupedProducts, markupType])

  useEffect(() => {
    if (!groupedProducts?.length) return

    const hasPermission = explodedPermissions?.some((permission) =>
      ['Allow Negative Marketing Adjustment Estimate'].includes(permission),
    )

    let productChanged = false
    let installChanged = false
    const nextProductMarketing = {}
    const nextInstallMarketing = {}

    groupedProducts.forEach((group) => {
      const key = String(group.id)
      const totalProductFormula = Number(group.totalProductFormulaEach || 0)
      const prevProductFormula = prevGroupFormulaTotalsRef.current.product[key]

      if (
        prevProductFormula !== undefined &&
        Math.abs(prevProductFormula - totalProductFormula) > 0.004
      ) {
        const catalogEach = Number(group.totalProductCatalogRetailEach || 0)
        const currentRetail = Number(group.adjustedGroupRetailEach ?? catalogEach)
        const editResult = applyRetailPriceEdit(
          buildGroupProductRetailEditPayload(catalogEach, totalProductFormula),
          String(currentRetail),
          markupType,
          { hasNegativePermission: hasPermission },
        )
        const marketingUpdate = formatGroupProductMarketingFromRetailEdit(
          editResult,
          catalogEach,
        )
        if (marketingUpdate) {
          nextProductMarketing[key] = marketingUpdate
          productChanged = true
        }
      }
      prevGroupFormulaTotalsRef.current.product[key] = totalProductFormula

      const totalInstallFormula = Number(group.totalInstallFormulaEach || 0)
      const prevInstallFormula = prevGroupFormulaTotalsRef.current.install[key]

      if (
        prevInstallFormula !== undefined &&
        Math.abs(prevInstallFormula - totalInstallFormula) > 0.004 &&
        Number(group.totalInstallCatalogRetailEach || 0) > 0
      ) {
        const catalogInstallEach = Number(group.totalInstallCatalogRetailEach || 0)
        const currentInstallRetail = Number(
          group.adjustedGroupInstallRetailEach ?? catalogInstallEach,
        )
        const editResult = applyInstallPriceEdit(
          buildGroupInstallRetailEditPayload(catalogInstallEach, totalInstallFormula),
          String(currentInstallRetail),
          { hasNegativePermission: hasPermission },
        )
        const marketingUpdate = formatGroupInstallMarketingFromRetailEdit(
          editResult,
          catalogInstallEach,
        )
        if (marketingUpdate) {
          nextInstallMarketing[key] = marketingUpdate
          installChanged = true
        }
      }
      prevGroupFormulaTotalsRef.current.install[key] = totalInstallFormula
    })

    if (productChanged) {
      setGroupProductMarketingValues((prev) => {
        const merged = { ...prev }
        Object.entries(nextProductMarketing).forEach(([key, value]) => {
          merged[key] = { ...(merged[key] || {}), ...value }
        })
        return merged
      })
    }
    if (installChanged) {
      setGroupInstallMarketingValues((prev) => {
        const merged = { ...prev }
        Object.entries(nextInstallMarketing).forEach(([key, value]) => {
          merged[key] = { ...(merged[key] || {}), ...value }
        })
        return merged
      })
    }
    if (productChanged || installChanged) {
      setRefreshCalculation((v) => !v)
    }
  }, [groupedProducts, explodedPermissions, markupType])

  const resolveProductGroupId = (product) =>
    product?.group_id ?? product?.customer_order_product_group_id ?? product?.groupId ?? null

  const getGroupMemberIndexIdsByProductIndexId = React.useCallback(
    (productIndexId) => {
      const numId = Number(productIndexId)
      if (Number.isNaN(numId)) return []

      for (const group of groupedProductsMap.values()) {
        const ids = (group?.products || [])
          .map((p) => Number(p.indexId))
          .filter((id) => !Number.isNaN(id))
        if (ids.includes(numId) && ids.length) return ids
      }

      const product = (selectedProducts || []).find((p) => Number(p?.indexId) === numId)
      const gid = resolveProductGroupId(product)
      if (gid == null || gid === '') return [numId]
      const group = groupedProductsMap.get(String(gid))
      if (group?.products?.length) {
        const ids = group.products
          .map((p) => Number(p.indexId))
          .filter((id) => !Number.isNaN(id))
        if (ids.length) return ids
      }
      const ids = (selectedProducts || [])
        .filter((p) => String(resolveProductGroupId(p) || '') === String(gid))
        .map((p) => Number(p.indexId))
        .filter((id) => !Number.isNaN(id))
      return ids.length ? ids : [numId]
    },
    [selectedProducts, groupedProductsMap],
  )

  const getProductAttachmentsList = React.useCallback(
    (productIndexId) => {
      const numId = Number(productIndexId)
      const memberIds = getGroupMemberIndexIdsByProductIndexId(numId)
      if (memberIds.length <= 1) {
        return productAttachments[numId] || productAttachments[String(numId)] || []
      }
      const seen = new Set()
      const merged = []
      memberIds.forEach((mid) => {
        const list = productAttachments[mid] || productAttachments[String(mid)] || []
        list.forEach((f, fileIdx) => {
          const key = attachmentFileKey(f) || `__group_att_${mid}_${fileIdx}`
          if (!seen.has(key)) {
            seen.add(key)
            merged.push(f)
          }
        })
      })
      return merged
    },
    [productAttachments, getGroupMemberIndexIdsByProductIndexId],
  )

  const getGroupAnchorIndexId = (group) => {
    const products = group?.products || []
    const explicit = products.find((p) => p?.group_catalog_anchor_index_id != null)
    if (explicit) {
      const aid = Number(explicit.group_catalog_anchor_index_id)
      if (!Number.isNaN(aid) && products.some((p) => Number(p.indexId) === aid)) {
        return aid
      }
    }
    const line = products.find((p) => isProductLineCatalog(p))
    if (line?.indexId != null) return line.indexId
    const ids = products
      .map((p) => Number(p.indexId))
      .filter((n) => !Number.isNaN(n))
    return ids.length ? Math.min(...ids) : null
  }

  const productTableBodyRenderOrder = React.useMemo(() => {
    const resolveProductGroupId = (product) =>
      product?.group_id ?? product?.customer_order_product_group_id ?? product?.groupId ?? null
    const sorted = [...(selectedProducts || [])].sort(
      (a, b) => (a?.indexId || 0) - (b?.indexId || 0),
    )
    const groupMemberIndexIds = new Set()
    ;(groupedProducts || []).forEach((g) => {
      ;(g.products || []).forEach((p) => {
        if (p?.indexId != null) groupMemberIndexIds.add(Number(p.indexId))
      })
    })
    const out = []
    const seenGroups = new Set()
    for (const p of sorted) {
      const gidRaw = resolveProductGroupId(p)
      if (!gidRaw) {
        out.push({ type: 'product', indexId: p.indexId })
        continue
      }
      const gid = String(gidRaw)
      if (seenGroups.has(gid)) continue
      const group = groupedProductsMap.get(gid)
      if (!group) continue
      const anchorId = getGroupAnchorIndexId(group)
      if (anchorId == null || Number(p.indexId) !== Number(anchorId)) continue
      seenGroups.add(gid)
      out.push({ type: 'group', groupId: gid })
    }
    return out.filter((item) => {
      if (item.type !== 'product') return true
      return !groupMemberIndexIds.has(Number(item.indexId))
    })
  }, [selectedProducts, groupedProductsMap, groupedProducts, invoice])

  const handleProductTableDragEnd = useCallback(
    async (result) => {
      if (!result.destination || result.destination.index === result.source.index) {
        return
      }
      if (!openEdit) return

      const renderOrder = [...productTableBodyRenderOrder]
      const [moved] = renderOrder.splice(result.source.index, 1)
      renderOrder.splice(result.destination.index, 0, moved)

      const orderedOldIds = []
      renderOrder.forEach((item) => {
        if (item.type === 'product') {
          orderedOldIds.push(item.indexId)
        } else if (item.type === 'group') {
          const group = groupedProductsMap.get(item.groupId)
          const groupProducts = [...(group?.products || [])].sort(
            (a, b) => (Number(a?.indexId) || 0) - (Number(b?.indexId) || 0),
          )
          groupProducts.forEach((p) => orderedOldIds.push(p.indexId))
        }
      })

      const orderedSet = new Set(orderedOldIds.map(String))
      ;(selectedProducts || []).forEach((p) => {
        if (p?.indexId != null && !orderedSet.has(String(p.indexId))) {
          orderedOldIds.push(p.indexId)
        }
      })

      const indexIdMap = {}
      orderedOldIds.forEach((oldId, idx) => {
        indexIdMap[String(oldId)] = idx + 1
      })

      remapProductIndexIds(indexIdMap, selectedProducts)

      if (id) {
        try {
          await axios.post(`${REST_API_END_POINT}request/reorder-estimate-products`, {
            requestId: id,
            indexMapping: indexIdMap,
            userId: user?.user_id,
          })
        } catch (error) {
          console.error('Error saving product order:', error)
          enqueueSnackbar('Failed to save product order', { variant: 'error' })
        }
      }
    },
    [
      productTableBodyRenderOrder,
      groupedProductsMap,
      selectedProducts,
      openEdit,
      id,
      user?.user_id,
      remapProductIndexIds,
      enqueueSnackbar,
    ],
  )

  const isVisibleValueColumn = React.useCallback(
    (val) => {
      if (!val || val.value === null) return false
      if (val.id === 20 && isSplitOrder) return false
      if (val.id === 16 && !isSplitOrder) return false
      return true
    },
    [isSplitOrder],
  )

  const visibleValueColumns = React.useMemo(
    () => (VALUE || []).filter((val) => isVisibleValueColumn(val)),
    [VALUE, isVisibleValueColumn],
  )

  /** Main product rows always render two TableCells for retail (id 5 + id 6); only one is in VALUE/visible list. */
  const groupedTableNeedsRetailPads = React.useMemo(
    () => !(visibleValueColumns || []).some((c) => c.id === 5 || c.id === 6),
    [visibleValueColumns],
  )

  const catalogSuffixForProductOption = React.useCallback((option) => {
    if (!option) return ''
    return option.isTrafficCatalog
      ? '(TC)'
      : option.inhouse === 5
        ? '(Client Owned Catalog)'
        : option.inhouse === 4
          ? '(In Stock Catalog)'
          : option.inhouse === 0
            ? '(Sub Contract)'
            : option.inhouse === 6
              ? '(Split Catalog)'
              : option.inhouse === 7
                ? '(Estimate Catalog)'
                : '(Production Catalog)'
  }, [])

  /** One chip per group in the product Autocomplete (group name), not every member line. */
  const productAutocompleteDisplayValue = React.useMemo(
    () =>
      collapseProductsForAutocompleteChips(
        (selectedProducts || []).filter(
          (item) => item?.fromMapServices != true && !item.isAdditionalProduct,
        ),
        customerOrderProductGroups,
      ),
    [selectedProducts, customerOrderProductGroups],
  )

  const expandAutocompleteValueToMainProducts = React.useCallback((newCollapsed, prevSelected) => {
    const prev = prevSelected || []
    const mainPrev = prev.filter((p) => p?.fromMapServices != true && !p?.isAdditionalProduct)
    const expanded = []
    for (const chip of newCollapsed || []) {
      if (chip?.isGroupAutocompleteChip || (chip?.group_id != null && chip?.group_id !== '')) {
        const gid = String(chip.group_id)
        mainPrev
          .filter((p) => String(p.group_id) === gid)
          .sort((a, b) => Number(a.indexId || 0) - Number(b.indexId || 0))
          .forEach((p) => expanded.push(p))
        continue
      }
      const existing =
        chip?.indexId != null ? mainPrev.find((p) => Number(p.indexId) === Number(chip.indexId)) : undefined
      if (existing) expanded.push(existing)
      else expanded.push(chip)
    }
    return expanded
  }, [])

  const handleGroupFieldChange = (groupId, field, value) => {
    setSelectedProducts((prev) =>
      (prev || []).map((product) => {
        if (!isSameGroupId(product.group_id, groupId)) return product
        if (field === 'name') return { ...product, group_name: value }
        if (field === 'description') return { ...product, group_description: value }
        return product
      }),
    )
    setCustomerOrderProductGroups((prev) =>
      (prev || []).map((g) => {
        if (String(g?.id ?? g?.group_id) !== String(groupId)) return g
        if (field === 'name') return { ...g, group_name: value, name: value }
        if (field === 'description') return { ...g, group_description: value, description: value }
        return g
      }),
    )
  }

  // group.id (from product.group_id) is a stable timestamp-based id assigned once at group
  // creation (see buildGroupFromSelection) — never renumbered by delete/reorder the way
  // product indexId is — so unlike the product-row fix, no extra invalidation guard is needed
  // here for stale timers landing on the wrong group.
  const groupNameDraft = useKeyedDraftField((groupId, value) =>
    handleGroupFieldChange(groupId, 'name', value),
  )
  const groupDescDraft = useKeyedDraftField((groupId, value) =>
    handleGroupFieldChange(groupId, 'description', value),
  )

  // Save-without-blur overlay for group fields, used by both save paths' group payload blocks
  // (groupProductMarketingData / groupInstallMarketingData). group.name/description come from
  // the groupedProducts memo, so unlike the arrays above there's nothing to pre-map — just read
  // the pending draft at the point group_name/group_description are pulled from `group`.
  const getGroupNameForSave = (group) =>
    group.id in groupNameDraft.draftsRef.current
      ? groupNameDraft.draftsRef.current[group.id]
      : group.name
  const getGroupDescForSave = (group) =>
    group.id in groupDescDraft.draftsRef.current
      ? groupDescDraft.draftsRef.current[group.id]
      : group.description

  const handleGroupQuantityChange = (groupId, value) => {
    let newValue = String(value ?? '')
    if (newValue.startsWith('-')) newValue = newValue.slice(1)
    newValue = newValue.replace(/[^0-9]/g, '')
    if (newValue === '' || Number(newValue) <= 0) newValue = 1
    else newValue = Number(newValue)

    setCustomerOrderProductGroups((prev) => {
      const list = prev || []
      const idx = list.findIndex((group) =>
        isSameGroupId(group?.id ?? group?.group_id, groupId),
      )
      const existingGroup = idx >= 0 ? list[idx] : null
      const existingProdQty = Number(
        existingGroup?.product_marketing_quantity ??
          existingGroup?.productMarketingQuantity ??
          0,
      )
      const existingInstQty = Number(
        existingGroup?.install_marketing_quantity ??
          existingGroup?.installMarketingQuantity ??
          0,
      )
      const hasManualInstallQty =
        Boolean(existingGroup?.install_qty_manually_set) ||
        (existingProdQty > 0 &&
          existingInstQty > 0 &&
          existingProdQty !== existingInstQty) ||
        (selectedProducts || []).some(
          (product) =>
            isSameGroupId(product.group_id, groupId) &&
            product?.manually_updated_install_quantity,
        )
      if (idx === -1) {
        return [
          ...list,
          {
            id: groupId,
            group_id: groupId,
            product_marketing_quantity: Number(newValue),
            ...(hasManualInstallQty
              ? {}
              : { install_marketing_quantity: Number(newValue) }),
          },
        ]
      }
      return list.map((group, groupIndex) =>
        groupIndex !== idx
          ? group
          : {
              ...group,
              product_marketing_quantity: Number(newValue),
              ...(hasManualInstallQty
                ? {}
                : { install_marketing_quantity: Number(newValue) }),
            },
      )
    })
    setRefreshCalculation((v) => !v)
  }

  const handleGroupInstallQuantityChange = (groupId, value) => {
    let newValue = String(value ?? '')
    if (newValue.startsWith('-')) newValue = newValue.slice(1)
    newValue = newValue.replace(/[^0-9]/g, '')
    if (newValue === '' || Number(newValue) <= 0) newValue = 1
    else newValue = Number(newValue)

    setCustomerOrderProductGroups((prev) => {
      const list = prev || []
      const idx = list.findIndex((group) =>
        isSameGroupId(group?.id ?? group?.group_id, groupId),
      )
      if (idx === -1) {
        return [
          ...list,
          {
            id: groupId,
            group_id: groupId,
            install_marketing_quantity: Number(newValue),
            install_qty_manually_set: true,
          },
        ]
      }
      return list.map((group, groupIndex) =>
        groupIndex !== idx
          ? group
          : {
              ...group,
              install_marketing_quantity: Number(newValue),
              install_qty_manually_set: true,
            },
      )
    })
    setRefreshCalculation((v) => !v)
  }

  const handleGroupMarketingTypeChange = (groupId, newValue) => {
    const hasPermission = explodedPermissions?.some((permission) =>
      ['Allow Negative Marketing Adjustment Estimate'].includes(permission),
    )
    const group = groupedProductsMap.get(String(groupId))
    if (!group) return

    if (newValue === false) {
      const { maxNegative, retailEachBase, formulaEach } = getGroupMaxNegativeAdjustment(
        group,
        hasPermission,
      )
      if (!hasPermission && retailEachBase <= formulaEach) {
        enqueueSnackbar(
          'To apply a negative marketing adjustment, Retail Price Each must be higher than the Product formula cost Each.',
          { variant: 'error' },
        )
        return
      }
      const currentAdjustment = Number(group?.groupAdjustment || 0)
      if (Number(currentAdjustment) >= maxNegative && hasPermission) {
        enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
        return
      }
      if (currentAdjustment > maxNegative && !hasPermission) {
        enqueueSnackbar(
          `Negative Adjustment Amount cannot reduce total below Product Formula Cost. Max allowed: $${Number(maxNegative).toFixed(2)}`,
          { variant: 'error' },
        )
        return
      }
    }
    setGroupProductMarketingValues((prev) => ({
      ...prev,
      [String(groupId)]: {
        ...(prev[String(groupId)] || {}),
        adjValueType: newValue,
      },
    }))
    setRefreshCalculation((v) => !v)
  }

  const handleGroupMarketingAdjustmentChange = (
    groupId,
    rawValue,
    groupAdjValueType,
    options = {},
  ) => {
    const { isBlur = false } = options
    const groupKey = String(groupId)
    const limitedValue = limitDecimalInput(rawValue)
    const group = groupedProductsMap.get(groupKey)
    if (!group) return

    const productMarketing = groupProductMarketingValues?.[groupKey] || {}
    const adjValueType =
      productMarketing.adjValueType ??
      groupAdjValueType ??
      group?.groupAdjValueType ??
      true
    const hasPermission = explodedPermissions?.some((permission) =>
      ['Allow Negative Marketing Adjustment Estimate'].includes(permission),
    )

    if (limitedValue === '' || limitedValue === '-') {
      if (isBlur) {
        setGroupProductMarketingValues((prev) => ({
          ...prev,
          [groupKey]: {
            ...(prev[groupKey] || {}),
            adjustment: 0,
            adjValueType: true,
            adjustment_draft: undefined,
          },
        }))
        setRefreshCalculation((v) => !v)
      } else {
        setGroupProductMarketingValues((prev) => ({
          ...prev,
          [groupKey]: {
            ...(prev[groupKey] || {}),
            adjustment_draft: '',
            adjustment: '',
            adjValueType,
          },
        }))
        setRefreshCalculation((v) => !v)
      }
      return
    }

    if (!isBlur) {
      const numAdjustment = Number(limitedValue) || 0
      const isNegative = adjValueType === false || Number(adjValueType) === 0
      if (isNegative) {
        const { maxNegative } = getGroupMaxNegativeAdjustment(group, hasPermission)
        if (numAdjustment >= maxNegative && hasPermission) {
          enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
          return
        }
        if (numAdjustment > maxNegative && !hasPermission) {
          enqueueSnackbar(
            `Negative Adjustment Amount cannot reduce total below Product Formula Cost. Max allowed: $${maxNegative.toFixed(2)}`,
            { variant: 'error' },
          )
          return
        }
      }
      setGroupProductMarketingValues((prev) => ({
        ...prev,
        [groupKey]: {
          ...(prev[groupKey] || {}),
          adjustment_draft: limitedValue,
          adjustment: limitedValue,
          adjValueType,
        },
      }))
      setRefreshCalculation((v) => !v)
      return
    }

    const normalizedValue = formatPriceToTwoDecimals(limitedValue)
    const numValue = Number(normalizedValue) || 0
    const isNegative = adjValueType === false || Number(adjValueType) === 0
    if (isNegative) {
      const { maxNegative } = getGroupMaxNegativeAdjustment(group, hasPermission)
      if (numValue >= maxNegative && hasPermission) {
        enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
        return
      }
      if (numValue > maxNegative && !hasPermission) {
        enqueueSnackbar(
          `Negative Adjustment Amount cannot reduce total below Product Formula Cost. Max allowed: $${maxNegative.toFixed(2)}`,
          { variant: 'error' },
        )
        return
      }
    }

    setGroupProductMarketingValues((prev) => ({
      ...prev,
      [groupKey]: {
        ...(prev[groupKey] || {}),
        adjustment: numValue,
        adjValueType: numValue === 0 ? true : adjValueType,
        adjustment_draft: undefined,
      },
    }))
    setRefreshCalculation((v) => !v)
  }

  const handleGroupInstallMarketingTypeChange = (groupId, newValue) => {
    const hasPermission = explodedPermissions?.some((permission) =>
      ['Allow Negative Marketing Adjustment Estimate'].includes(permission),
    )
    const group = groupedProductsMap.get(String(groupId))
    if (!group) return

    if (newValue === false) {
      const { maxNegative, retailEachBase, formulaEach } =
        getGroupMaxNegativeInstallAdjustment(group, hasPermission)
      if (!hasPermission && retailEachBase <= formulaEach) {
        enqueueSnackbar(
          'To apply a negative marketing adjustment, Install Price Each must be higher than the Install formula cost Each.',
          { variant: 'error' },
        )
        return
      }
      const currentAdjustment = Number(group?.groupInstallAdjustment || 0)
      if (Number(currentAdjustment) >= maxNegative && hasPermission) {
        enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
        return
      }
      if (currentAdjustment > maxNegative && !hasPermission) {
        enqueueSnackbar(
          `Negative Adjustment Amount cannot reduce total below Install Formula Cost. Max allowed: $${Number(maxNegative).toFixed(2)}`,
          { variant: 'error' },
        )
        return
      }
    }
    setGroupInstallMarketingValues((prev) => ({
      ...prev,
      [String(groupId)]: {
        ...(prev[String(groupId)] || {}),
        adjValueType: newValue,
      },
    }))
    setRefreshCalculation((v) => !v)
  }

  const handleGroupInstallMarketingAdjustmentChange = (
    groupId,
    rawValue,
    groupInstallAdjValueType,
    options = {},
  ) => {
    const { isBlur = false } = options
    const groupKey = String(groupId)
    const limitedValue = limitDecimalInput(rawValue)
    const group = groupedProductsMap.get(groupKey)
    if (!group) return

    const installMarketing = groupInstallMarketingValues?.[groupKey] || {}
    const adjValueType =
      installMarketing.adjValueType ??
      groupInstallAdjValueType ??
      group?.groupInstallAdjValueType ??
      true
    const hasPermission = explodedPermissions?.some((permission) =>
      ['Allow Negative Marketing Adjustment Estimate'].includes(permission),
    )

    if (limitedValue === '' || limitedValue === '-') {
      if (isBlur) {
        setGroupInstallMarketingValues((prev) => ({
          ...prev,
          [groupKey]: {
            ...(prev[groupKey] || {}),
            adjustment: 0,
            adjValueType: true,
            adjustment_draft: undefined,
          },
        }))
        setRefreshCalculation((v) => !v)
      } else {
        setGroupInstallMarketingValues((prev) => ({
          ...prev,
          [groupKey]: {
            ...(prev[groupKey] || {}),
            adjustment_draft: '',
            adjustment: '',
            adjValueType,
          },
        }))
        setRefreshCalculation((v) => !v)
      }
      return
    }

    if (!isBlur) {
      const numAdjustment = Number(limitedValue) || 0
      const isNegative = adjValueType === false || Number(adjValueType) === 0
      if (isNegative) {
        const { maxNegative } = getGroupMaxNegativeInstallAdjustment(group, hasPermission)
        if (numAdjustment >= maxNegative && hasPermission) {
          enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
          return
        }
        if (numAdjustment > maxNegative && !hasPermission) {
          enqueueSnackbar(
            `Negative Adjustment Amount cannot reduce total below Install Formula Cost. Max allowed: $${maxNegative.toFixed(2)}`,
            { variant: 'error' },
          )
          return
        }
      }
      setGroupInstallMarketingValues((prev) => ({
        ...prev,
        [groupKey]: {
          ...(prev[groupKey] || {}),
          adjustment_draft: limitedValue,
          adjustment: limitedValue,
          adjValueType,
        },
      }))
      setRefreshCalculation((v) => !v)
      return
    }

    const normalizedValue = formatPriceToTwoDecimals(limitedValue)
    const numValue = Number(normalizedValue) || 0
    const isNegative = adjValueType === false || Number(adjValueType) === 0
    if (isNegative) {
      const { maxNegative } = getGroupMaxNegativeInstallAdjustment(group, hasPermission)
      if (numValue >= maxNegative && hasPermission) {
        enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
        return
      }
      if (numValue > maxNegative && !hasPermission) {
        enqueueSnackbar(
          `Negative Adjustment Amount cannot reduce total below Install Formula Cost. Max allowed: $${maxNegative.toFixed(2)}`,
          { variant: 'error' },
        )
        return
      }
    }

    setGroupInstallMarketingValues((prev) => ({
      ...prev,
      [groupKey]: {
        ...(prev[groupKey] || {}),
        adjustment: numValue,
        adjValueType: numValue === 0 ? true : adjValueType,
        adjustment_draft: undefined,
      },
    }))
    setRefreshCalculation((v) => !v)
  }

  const getGroupProductSignedAdjustment = (group, groupId) => {
    const groupKey = String(groupId)
    const productMarketing = groupProductMarketingValues?.[groupKey] || {}
    const groupAdjValueType =
      productMarketing.adjValueType ?? group?.groupAdjValueType ?? true
    const groupAdjustment = resolveGroupProductMarketingAdjustment(
      productMarketing,
      group?.groupMeta || {},
    )
    return groupAdjValueType === false || Number(groupAdjValueType) === 0
      ? -groupAdjustment
      : groupAdjustment
  }

  const getGroupInstallSignedAdjustment = (group, groupId) => {
    const groupKey = String(groupId)
    const installMarketing = groupInstallMarketingValues?.[groupKey] || {}
    const groupInstallAdjValueType =
      installMarketing.adjValueType ?? group?.groupInstallAdjValueType ?? true
    const groupInstallAdjustment = resolveGroupInstallMarketingAdjustment(
      installMarketing,
      group?.groupMeta || {},
    )
    return groupInstallAdjValueType === false || Number(groupInstallAdjValueType) === 0
      ? -groupInstallAdjustment
      : groupInstallAdjustment
  }

  const handleGroupRetailPriceChange = (groupId, rawValue, options = {}) => {
    const { isBlur = false } = options
    const groupKey = String(groupId)
    const limitedValue = limitDecimalInput(rawValue)
    const valueToApply = isBlur
      ? formatPriceToTwoDecimals(limitedValue)
      : limitedValue

    if (valueToApply === '' || valueToApply === '-') {
      if (isBlur) {
        setGroupProductRetailDrafts((prev) => {
          const next = { ...prev }
          delete next[groupKey]
          return next
        })
      }
      return
    }

    const group = groupedProductsMap.get(groupKey)
    if (!group) return

    if (!isBlur && Number.isNaN(parseFloat(valueToApply))) {
      setGroupProductRetailDrafts((prev) => ({ ...prev, [groupKey]: limitedValue }))
      return
    }

    const catalogEach = resolveGroupProductCatalogBaseline(groupKey, group)
    const hasPermission = explodedPermissions?.some((permission) =>
      ['Allow Negative Marketing Adjustment Estimate'].includes(permission),
    )

    const editResult = applyRetailPriceEdit(
      buildGroupProductRetailEditPayload(
        catalogEach,
        Number(group.totalProductFormulaEach || 0),
      ),
      valueToApply,
      markupType,
      { hasNegativePermission: hasPermission },
    )

    if (!editResult) {
      if (!isBlur) {
        setGroupProductRetailDrafts((prev) => ({ ...prev, [groupKey]: limitedValue }))
      }
      return
    }

    if (editResult.error) {
      if (!isBlur) {
        setGroupProductRetailDrafts((prev) => ({ ...prev, [groupKey]: limitedValue }))
        return
      }
      enqueueSnackbar(editResult.error, { variant: 'error' })
      setGroupProductRetailDrafts((prev) => {
        const next = { ...prev }
        delete next[groupKey]
        return next
      })
      return
    }

    setGroupProductRetailDrafts((prev) => {
      const next = { ...prev }
      delete next[groupKey]
      return next
    })

    const marketingUpdate = formatGroupProductMarketingFromRetailEdit(
      editResult,
      catalogEach,
    )
    if (!marketingUpdate) return

    setGroupProductMarketingValues((prev) => ({
      ...prev,
      [groupKey]: {
        ...(prev[groupKey] || {}),
        originalCatalogRetailEach:
          prev[groupKey]?.originalCatalogRetailEach ?? catalogEach,
        ...marketingUpdate,
      },
    }))

    resetGroupMembersToCatalogBaseline(groupKey, markupType)
    setRefreshCalculation((v) => !v)
  }

  const handleGroupInstallRetailPriceChange = (groupId, rawValue, options = {}) => {
    const { isBlur = false } = options
    const groupKey = String(groupId)
    const limitedValue = limitDecimalInput(rawValue)
    const valueToApply = isBlur
      ? formatPriceToTwoDecimals(limitedValue)
      : limitedValue

    if (valueToApply === '' || valueToApply === '-') {
      if (isBlur) {
        setGroupInstallRetailDrafts((prev) => {
          const next = { ...prev }
          delete next[groupKey]
          return next
        })
      }
      return
    }

    const group = groupedProductsMap.get(groupKey)
    if (!group) return

    if (!isBlur && Number.isNaN(parseFloat(valueToApply))) {
      setGroupInstallRetailDrafts((prev) => ({ ...prev, [groupKey]: limitedValue }))
      return
    }

    const catalogInstallEach = resolveGroupInstallCatalogBaseline(groupKey, group)
    if (catalogInstallEach <= 0) return

    const hasPermission = explodedPermissions?.some((permission) =>
      [
        'Allow Negative Marketing Adjustment Sales Order',
        'Allow Negative Marketing Adjustment Estimate',
      ].includes(permission),
    )

    const editResult = applyInstallPriceEdit(
      buildGroupInstallRetailEditPayload(
        catalogInstallEach,
        Number(group.totalInstallFormulaEach || 0),
      ),
      valueToApply,
      { hasNegativePermission: hasPermission },
    )

    if (!editResult) {
      if (!isBlur) {
        setGroupInstallRetailDrafts((prev) => ({ ...prev, [groupKey]: limitedValue }))
      }
      return
    }

    if (editResult.error) {
      if (!isBlur) {
        setGroupInstallRetailDrafts((prev) => ({ ...prev, [groupKey]: limitedValue }))
        return
      }
      enqueueSnackbar(editResult.error, { variant: 'error' })
      setGroupInstallRetailDrafts((prev) => {
        const next = { ...prev }
        delete next[groupKey]
        return next
      })
      return
    }

    setGroupInstallRetailDrafts((prev) => {
      const next = { ...prev }
      delete next[groupKey]
      return next
    })

    const marketingUpdate = formatGroupInstallMarketingFromRetailEdit(
      editResult,
      catalogInstallEach,
    )
    if (!marketingUpdate) return

    setGroupInstallMarketingValues((prev) => ({
      ...prev,
      [groupKey]: {
        ...(prev[groupKey] || {}),
        originalInstallCatalogEach:
          prev[groupKey]?.originalInstallCatalogEach ?? catalogInstallEach,
        ...marketingUpdate,
      },
    }))

    resetGroupMembersToCatalogBaseline(groupKey, markupType)
    setRefreshCalculation((v) => !v)
  }

  const addToGroupOptions = React.useMemo(
    () =>
      getAddToGroupOptions({
        groupedProducts,
        customerOrderProductGroups,
        selectedProducts,
      }),
    [customerOrderProductGroups, groupedProducts, selectedProducts],
  )

  React.useEffect(() => {
    setGroupSelectedProductIds((prev) => {
      const isEditingGroup = Object.values(groupEditMode || {}).some(Boolean)
      const next = isEditingGroup
        ? (prev || []).filter((id) =>
            (selectedProducts || []).some(
              (product) =>
                Number(product?.indexId) === Number(id) &&
                isViewQuotationChooseCatalogRow(product),
            ),
          )
        : getValidUngroupedSelectionIds(selectedProducts, prev)
      if (
        next.length === (prev || []).length &&
        next.every((id, i) => Number(id) === Number(prev[i]))
      ) {
        return prev
      }
      return next
    })
  }, [selectedProducts, groupEditMode])

  const getCatalogSourceDropdownOptionsForModal = (inputValue = '') =>
    getCatalogSourceDropdownOptions({
      selectedProducts,
      groupSelectedProductIds,
      customCatalogGroupSources,
      customerOrderProductGroups,
      inputValue,
    })

  const resetGroupCatalogSourceModal = () => {
    setOpenGroupCatalogSourceModal(false)
    setGroupCatalogSourceIndexId(null)
    setGroupCatalogCustomSourceId(null)
    setShowGroupCatalogCreateForm(false)
    setGroupCatalogSourceInputValue('')
    setGroupCatalogCustomName('')
    setGroupCatalogCustomDescription('')
    setGroupCatalogCreateError('')
  }

  const buildGroupFromSelection = (selectedLineCatalogProduct, overrides = {}) => {
    // Client request: remove restriction that prevents grouping when there are no catalog ("choose") rows.
    // Fallback to any selected member as the anchor for group name/notes.
    const anchorProduct =
      selectedLineCatalogProduct ||
      (selectedProducts || []).find((p) => groupSelectedProductIds.includes(p.indexId)) ||
      (selectedProducts || [])[0] ||
      null

    if (!anchorProduct) {
      enqueueSnackbar('Grouping requires at least one selected product.', { variant: 'error' })
      return false
    }

    const derivedGroupName = (
      overrides.name ?? anchorProduct?.product_name ?? anchorProduct?.name ?? ''
    ).trim()
    const derivedGroupDescription = (
      overrides.description ?? anchorProduct?.product_desc ?? anchorProduct?.description ?? ''
    ).trim()

    if (!derivedGroupName) {
      enqueueSnackbar('Group name is required.', { variant: 'error' })
      return false
    }

    if (
      quotationGroupNameExists({
        name: derivedGroupName,
        customerOrderProductGroups,
        selectedProducts,
        customCatalogGroupSources,
      })
    ) {
      enqueueSnackbar('A group with this name already exists.', { variant: 'error' })
      return false
    }

    const newGroupId = Date.now()
    const anchorIndexId = anchorProduct?.indexId

    const nextProducts = (selectedProducts || []).map((product) => {
      if (!groupSelectedProductIds.includes(product.indexId)) return product
      const memberInstallQty = product.install_quantity || 1
      return {
        ...product,
        ...snapshotGroupMemberMarketing(product),
        group_id: newGroupId,
        group_name: derivedGroupName,
        group_description: derivedGroupDescription,
        group_catalog_anchor_index_id: anchorIndexId,
        group_product_quantity: product.locationQuantity ?? 1,
        group_install_quantity: memberInstallQty,
        manually_updated_install_quantity: Boolean(
          product.manually_updated_install_quantity &&
            Number(product.install_quantity || 0) !== Number(product.locationQuantity || 0),
        ),
        adjustment: 0,
        adj_value_type: true,
        install_adjustment: 0,
        install_adj_value_type: true,
      }
    })

    setSelectedProducts(nextProducts)
    setFieldValue('products', nextProducts)
    setCustomerOrderProductGroups((prev) => [
      ...(prev || []),
      {
        id: newGroupId,
        group_id: newGroupId,
        group_name: derivedGroupName,
        group_description: derivedGroupDescription,
        product_marketing_quantity: 1,
        install_marketing_quantity: 1,
      },
    ])
    setGroupSelectedProductIds([])
    resetGroupCatalogSourceModal()
    setRefreshCalculation((v) => !v)
    return true
  }

  const handleCancelGroupCatalogCreate = () => {
    setShowGroupCatalogCreateForm(false)
    setGroupCatalogCustomName('')
    setGroupCatalogCustomDescription('')
    setGroupCatalogCreateError('')
  }

  const handleCreateCustomCatalogGroup = () => {
    const name = groupCatalogCustomName.trim()
    const description = groupCatalogCustomDescription.trim()

    if (!name) {
      setGroupCatalogCreateError('Group name is required.')
      return
    }

    if (
      quotationGroupNameExists({
        name,
        customerOrderProductGroups,
        selectedProducts,
        customCatalogGroupSources,
      })
    ) {
      setGroupCatalogCreateError('A group with this name already exists.')
      return
    }

    const customSource = {
      id: `custom-${Date.now()}`,
      isCustomGroupSource: true,
      name,
      description,
    }

    const anchorProduct = getSelectedLineCatalogProducts(
      selectedProducts,
      groupSelectedProductIds,
    )[0]
    const success = buildGroupFromSelection(anchorProduct, { name, description })
    if (success) {
      setCustomCatalogGroupSources((prev) => [...prev, customSource])
    }
  }

  const toggleGroupProductSelection = (product) => {
    if (!product?.indexId || !isViewQuotationChooseCatalogRow(product)) return
    setGroupSelectedProductIds((prev) => {
      const alreadySelected = (prev || []).some((id) => Number(id) === Number(product.indexId))
      if (alreadySelected) {
        return (prev || []).filter((id) => Number(id) !== Number(product.indexId))
      }
      return [...(prev || []), product.indexId]
    })
  }

  const handleCreateGroupFromSelection = () => {
    if (groupSelectedProductIds.length < 2) return
    const selectedLineCatalogCount = getSelectedLineCatalogCount(
      selectedProducts,
      groupSelectedProductIds,
    )
    // Client request: remove restriction that blocks grouping when there are no catalog ("choose") rows.
    // if (selectedLineCatalogCount === 0) {
    //   enqueueSnackbar('A group must contain at least one catalog line item.', { variant: 'error' })
    //   return
    // }

    const selectedLineCatalogProducts = getCatalogSourceOptions({
      selectedProducts,
      groupSelectedProductIds,
    })
    if (selectedLineCatalogProducts.length >= 1) {
      setGroupCatalogSourceIndexId(null)
      setGroupCatalogCustomSourceId(null)
      setShowGroupCatalogCreateForm(false)
      setGroupCatalogSourceInputValue('')
      setGroupCatalogCustomName('')
      setGroupCatalogCustomDescription('')
      setGroupCatalogCreateError('')
      setOpenGroupCatalogSourceModal(true)
      return
    }

    buildGroupFromSelection(selectedLineCatalogProducts?.[0])
  }

  const resetGroupMarketingAdjustments = React.useCallback((groupId) => {
    const key = String(groupId)
    setGroupProductMarketingValues((prev) => {
      const next = { ...prev }
      delete next[groupId]
      delete next[key]
      return next
    })
    setGroupInstallMarketingValues((prev) => {
      const next = { ...prev }
      delete next[groupId]
      delete next[key]
      return next
    })
    delete prevGroupFormulaTotalsRef.current.product[key]
    delete prevGroupFormulaTotalsRef.current.install[key]
    setRefreshCalculation((v) => !v)
  }, [])

  const handleAddToExistingGroup = () => {
    if (!addToGroupId) return

    const groupMeta =
      (customerOrderProductGroups || []).find((g) => String(g?.id) === String(addToGroupId)) ||
      (groupedProducts || []).find((g) => String(g.id) === String(addToGroupId))
    const group = groupMeta
    if (!group) return

    resetGroupMarketingAdjustments(group.id)

    const nextProducts = (() => {
      const prev = selectedProducts || []
      const existingBeforeAdd = prev.filter(
        (p) => isSameGroupId(p.group_id, group.id) && !groupSelectedProductIds.includes(p.indexId),
      )
      const inheritedAnchor =
        existingBeforeAdd.find((p) => p?.group_catalog_anchor_index_id != null)
          ?.group_catalog_anchor_index_id ?? existingBeforeAdd[0]?.group_catalog_anchor_index_id

      let mapped = prev.map((product) => {
        if (!groupSelectedProductIds.includes(product.indexId)) return product
        const memberInstallQty = product.install_quantity || 1
        return withInheritedGroupNotes(
          {
            ...product,
            ...snapshotGroupMemberMarketing(product),
            group_id: group.id,
            group_name:
              getGroupNameForSave({ ...group, name: group.group_name || group.name }) || 'Group',
            group_description:
              getGroupDescForSave({ ...group, description: group.group_description || group.description }) || '',
            group_catalog_anchor_index_id:
              inheritedAnchor != null ? inheritedAnchor : product.group_catalog_anchor_index_id,
            group_product_quantity: product.locationQuantity ?? 1,
            group_install_quantity: memberInstallQty,
            adjustment: 0,
            adj_value_type: true,
            install_adjustment: 0,
            install_adj_value_type: true,
          },
          existingBeforeAdd,
        )
      })

      return mapped
    })()

    setSelectedProducts(nextProducts)
    setFieldValue('products', nextProducts)
    setOpenAddToGroupModal(false)
    setAddToGroupId('')
    setGroupSelectedProductIds([])
    setRefreshCalculation((v) => !v)
  }

  const handleGroupLineQuantityDraftChange = (productIndexId, field, value) => {
    const key = String(productIndexId)
    setGroupProductQuantityDrafts((prev) => ({
      ...prev,
      [key]: {
        ...(prev[key] || {}),
        [field]: normalizeGroupLineQuantity(value),
      },
    }))
  }

  const clearGroupLineQuantityDrafts = (products = []) => {
    setGroupProductQuantityDrafts((prev) => {
      const next = { ...prev }
      ;(products || []).forEach((product) => {
        delete next[String(product.indexId)]
      })
      return next
    })
  }

  const handleGroupEditClick = (group) => {
    setGroupEditMode({ [group.id]: true })
    setGroupSelectedProductIds(
      (group?.products || [])
        .filter((p) => isViewQuotationChooseCatalogRow(p))
        .map((p) => p.indexId),
    )
    clearGroupLineQuantityDrafts(group?.products)
  }

  const handleGroupCancelEditClick = (group) => {
    setGroupEditMode({})
    setGroupSelectedProductIds([])
    clearGroupLineQuantityDrafts(group?.products)
  }

  const handleGroupUpdateClick = (group) => {
    const productIdsInGroup = (group?.products || []).map((p) => p.indexId)
    const remainingIds = productIdsInGroup.filter((id) =>
      groupSelectedProductIds.includes(id),
    )
    if (remainingIds.length < 2) {
      enqueueSnackbar('A group must contain at least 2 products.', { variant: 'error' })
      return
    }
    // Client request: remove restriction that blocks grouping when there are no catalog ("choose") rows.
    // if (getSelectedLineCatalogCount(selectedProducts, remainingIds) === 0) {
    //   enqueueSnackbar('A group must contain at least one catalog line item.', { variant: 'error' })
    //   return
    // }
    const idsToRemove = productIdsInGroup.filter(
      (id) => !groupSelectedProductIds.includes(id),
    )
    const idsToAdd = groupSelectedProductIds.filter(
      (id) => !productIdsInGroup.includes(id),
    )
    if (idsToRemove.length > 0 || idsToAdd.length > 0) {
      resetGroupMarketingAdjustments(group.id)
      const nextProducts = (selectedProducts || []).map((p) => {
        if (idsToRemove.includes(p.indexId)) {
          const hasPermission = explodedPermissions?.some((permission) =>
            [
              'Allow Negative Marketing Adjustment Sales Order',
              'Allow Negative Marketing Adjustment Estimate',
            ].includes(permission),
          )
          return restoreUngroupedProductMarketing(p, markupType, {
            hasNegativePermission: hasPermission,
          })
        }
        if (idsToAdd.includes(p.indexId)) {
          const existingAnchor = (selectedProducts || []).find(
            (x) =>
              String(x.group_id) === String(group.id) &&
              x.group_catalog_anchor_index_id != null,
          )?.group_catalog_anchor_index_id
          const existingMembers = (selectedProducts || []).filter(
            (x) =>
              String(x.group_id) === String(group.id) && !idsToAdd.includes(x.indexId),
          )
          return withInheritedGroupNotes(
            {
              ...p,
              ...snapshotGroupMemberMarketing(p),
              group_id: group.id,
              // Save-without-blur: prefer the pending Group Name/Description draft (if one
              // exists for this group) over the possibly-stale group.name/group.description.
              group_name: getGroupNameForSave(group) || 'Group',
              group_description: getGroupDescForSave(group) || '',
              group_catalog_anchor_index_id:
                existingAnchor ?? p.group_catalog_anchor_index_id,
              adjustment: 0,
              adj_value_type: true,
              install_adjustment: 0,
              install_adj_value_type: true,
            },
            existingMembers,
          )
        }
        if (String(p.group_id) === String(group.id)) {
          return {
            ...p,
            ...ensureGroupMemberMarketingSnapshot(p),
            adjustment: 0,
            adj_value_type: true,
            install_adjustment: 0,
            install_adj_value_type: true,
          }
        }
        return p
      })
      setSelectedProducts(nextProducts)
      setFieldValue('products', nextProducts)
    }
    const groupProductIds = new Set(
      (group?.products || []).map((p) => String(p.indexId)),
    )
    const hasLineQuantityDrafts = Object.keys(groupProductQuantityDrafts || {}).some(
      (productIndexId) => groupProductIds.has(String(productIndexId)),
    )
    if (hasLineQuantityDrafts) {
      const withDrafts = (selectedProducts || []).map((product) => {
        if (!groupProductIds.has(String(product.indexId))) {
          return product
        }
        const draft = groupProductQuantityDrafts[String(product.indexId)]
        if (!draft) return product
        const prodQty =
          draft.group_product_quantity ?? product.group_product_quantity ?? 1
        const instQty =
          draft.group_install_quantity ?? product.group_install_quantity ?? 1
        return {
          ...product,
          group_product_quantity: prodQty,
          group_install_quantity: instQty,
        }
      })
      setSelectedProducts(withDrafts)
      setFieldValue('products', withDrafts)
      clearGroupLineQuantityDrafts(group?.products)
    }
    setGroupEditMode({})
    setGroupSelectedProductIds([])
  }

  const getLosingMoneyRowSx = (isLosingMoneyItem) =>
    isLosingMoneyItem
      ? {
          '& .MuiTableCell-root:not(:nth-of-type(4)):not(:nth-of-type(5)), & .MuiTableCell-root:not(:nth-of-type(4)):not(:nth-of-type(5)) .MuiInputBase-input, & .MuiTableCell-root:not(:nth-of-type(4)):not(:nth-of-type(5)) .MuiFormLabel-root':
            {
              color: `${theme.palette.error.main} !important`,
            },
        }
      : undefined

  const getGroupLosingMoneyFlags = (group) => {
    if (!group) {
      return { isGroupProductLosingMoney: false, isGroupInstallLosingMoney: false }
    }
    const groupKey = String(group.id)
    const productMarketing =
      groupProductMarketingValues?.[groupKey] ||
      groupProductMarketingValues?.[group.id] ||
      {}
    const installMarketing =
      groupInstallMarketingValues?.[groupKey] ||
      groupInstallMarketingValues?.[group.id] ||
      {}

    const groupAdjValueType =
      productMarketing.adjValueType ?? group.groupAdjValueType ?? true
    const groupInstallAdjValueType =
      installMarketing.adjValueType ?? group.groupInstallAdjValueType ?? true

    const isNegativeGroupProductAdjustmentMode =
      groupAdjValueType === false ||
      groupAdjValueType === 0 ||
      groupAdjValueType === '0' ||
      groupAdjValueType === 'false'
    const isNegativeGroupInstallAdjustmentMode =
      groupInstallAdjValueType === false ||
      groupInstallAdjValueType === 0 ||
      groupInstallAdjValueType === '0' ||
      groupInstallAdjValueType === 'false'

    const productFormulaEach = Number(group.totalProductFormulaEach ?? 0)
    const productRetailEach = Number(group.adjustedGroupRetailEach ?? 0)
    const installFormulaEach = Number(group.totalInstallFormulaEach ?? 0)
    const installRetailEach = Number(group.adjustedGroupInstallRetailEach ?? 0)

    return {
      isGroupProductLosingMoney:
        isNegativeGroupProductAdjustmentMode &&
        productRetailEach < productFormulaEach,
      isGroupInstallLosingMoney:
        isNegativeGroupInstallAdjustmentMode &&
        installRetailEach < installFormulaEach,
    }
  }

 let sum =0
 let taxAmountData = 0 ;
 let grandTotalData = 0;
 let totalJobcostSum = 0
 let newTaxSum = 0;
 useEffect(() => {
  try {
    console.log('selectedProducts-----', selectedProducts);
    // if(selectedProducts?.length > 0 || selectedServices?.length > 0 || additionalSelectedServices?.length > 0){
    const groupIdsForProductLineTotal = new Set()
    let selectedProductsTotalDiscount = selectedProducts?.reduce((total, data, index) => {
      const gidRaw =
        data?.group_id ?? data?.customer_order_product_group_id ?? data?.groupId ?? null
      if (gidRaw != null && String(gidRaw) !== '') {
        const gKey = String(gidRaw)
        if (groupIdsForProductLineTotal.has(gKey)) return total
        groupIdsForProductLineTotal.add(gKey)
        const group = groupedProductsMap.get(gKey)
        if (group) {
          return total + Number(group.adjustedGroupTotal || 0)
        }
      }

      let quantityFieldName = `quantity_${data.product_id ? data.product_id : data.id}`;
      let discountFieldName = `discount_${data.product_id ? data.product_id : data.id}`;
      const dataRetailPrice = data.product_retail_price || data.retail_price
      console.log('selectedProductsTotalDiscount--data----1234',data)
      console.log('selectedProductsTotalDiscount--dataRetailPrice----1234',dataRetailPrice)
      const dataWholesalePrice = data.product_price || data.price
      console.log('selectedProductsTotalDiscount--dataWholesalePrice----1234',dataWholesalePrice)
      // const dataQuantity = values[quantityFieldName]?values[quantityFieldName]:(data?.quantity||1)

      // const dataDiscount = values[discountFieldName]?values[discountFieldName]:(data?.discount||0);
      const dataQuantity = data?.quantity || 1

      const dataDiscount = data?.discount || 0;

      // Calculate product subtotal (same as Product Total calculation in table)
      const locQty = Number(data?.locationQuantity) || 1
      const productSubTotal =
        markupType == 1
          ? (Number(data?.price) || 0) * locQty
          : markupType == 2
          ? (Number(data?.actual_retail_price || data?.retail_price || 0)) * locQty
          : 0

      // Calculate install subtotal (same as Install Subtotal calculation in table)
      const installQty = Number(data?.install_quantity) || 1
      const installSubTotal =
        (Number(data?.install_cost) || 0) *
        installQty

      // Product Total is the sum of both subtotals minus discount (same as table calculation)
      const productTotal = Math.max(
        0,
        productSubTotal + installSubTotal - dataDiscount,
      )
      const fixedProductTotal = parseFloat(productTotal).toFixed(2);
      return total + parseFloat(fixedProductTotal);
    }, 0);

    const selectedProductsTotalDiscountForJobCost = selectedProducts?.reduce((total, data, index) => {
      const quantityFieldName = `quantity_${data.product_id || data.id}`;
      const discountFieldName = `discount_${data.product_id || data.id}`;
      const quantityVal = values[quantityFieldName] ? values[quantityFieldName] : 1
      const discountVal = values[discountFieldName] ? values[discountFieldName] : 0
      console.log("###############quantityVal", quantityVal)
      console.log("###############quantityValdata", data)
      // const productTotal = calculateTotal(data.expected_material_cost, data.quantity, discountVal);
      const productTotal = calculateTotal(parseFloat(data.expected_material_cost), data.quantity, 0, null, data.locationQuantity,data.adjustment,data.markAdjType,data.adj_value_type);
      console.log("###############product formula", productTotal)
      return total + productTotal;
    }, 0);
    // const allServices = [...selectedServices, ...additionalSelectedServices];
    const allServices = [
      // ...(selectedServices || []),
      ...(additionalSelectedServices || []),
      // ...(estimateCatalogServices || []),
    ];
    let selectedServicesCost = allServices?.reduce((total, service, index) => {
      // const quantityFieldName = `service_quantity_${index}`;
      // const quantityVal = values[quantityFieldName]?values[quantityFieldName]:1
      const quantityVal = service?.quantity ? Number(service?.quantity) : 0
      const serviceTotal = calculateServiceTotal(service.cost, quantityVal, 0);

      console.log("############SSSSSSSSSSSer", serviceTotal);

      // let selectedQuantity=selectedProducts.filter(product=>product.id===service.product_id)
      // console.log("############SSSSSSSSSSSer",selectedQuantity);
      // let quantity=selectedQuantity[0].quantity
      // return total + (serviceTotal*quantity);
      return total + serviceTotal;
    }, 0);
    // selectedServicesCost = selectedServicesCost - initialServiceCostInProductFormula
    console.log('allServices-----------', allServices);

    let selectedServicesTotalCost = allServices?.reduce((total, service, index) => {
      const quantityVal = service?.quantity ? Number(service?.quantity) : 0
      const costVal = getServiceHourlyCost(service)
      const serviceTotal = calculateServiceTotal(costVal, quantityVal, 0);
      // const roundedServiceTotal = Math.round(serviceTotal * 100) / 100;
      return total + serviceTotal;
    }, 0);
    let initialServicesCost =0
    //  selectedProducts?.reduce((total, data, index) => {
    //   const serviceTotal = (data?.quantity) * (parseFloat(data?.expected_total_service_cost?.toFixed(2))) * (data?.locationQuantity || 1) || 0;
    //   // const roundedServiceTotal = Math.round(serviceTotal * 100) / 100;
    //   return total + serviceTotal;
    // }, 0);

    const productMaterial = selectedProducts?.reduce((materials, product) => {
        if (product.materials && product.materials.length > 0) {
          return materials.concat(
            product.materials
              .map((material) => {
                console.log('materialsssssss',material)
                const price = parseFloat(material.max_unit_cost || 0);
                const quantity = parseFloat(material.quantity || 1);
                const retail_price = parseFloat(material.retail_price || 0);

                const subtotal = price * quantity;
                const markup = (subtotal * retail_price) / 100;
                const total = (subtotal + markup) * (product.locationQuantity || 1)

                console.log('✅ total, subtotal, markup:', total, subtotal, markup);
                console.log('✅ price, quantity, retail_price:', price, quantity, retail_price);

                return {
                  ...material,
                  totalCost: total.toFixed(2),
                };
              })
          );
        }
        return materials;
      }, []);

      setProductFormulaMaterial(productMaterial)

      const getTotalCostSum = (productMaterial) => {
        return productMaterial.reduce((sum, item) => {
                  console.log('itemmmmmm',item)
          // Only include if taxable == 0 (string or number)
          if (Number(item.taxable) !== 0) return sum;

          const cost = parseFloat(item.totalCost || 0);
          return sum + cost;
        }, 0).toFixed(2);
      };

      const totalCostSum = getTotalCostSum(productMaterial);
      // setTotalMinusMaterialTax(totalCostSum)
      console.log('🧾 Total cost sum of all materials:', totalCostSum);

    let selectedTaxServicesTotalCost = allServices?.reduce((total, service, index) => {
      // Skip non-taxable services
      if (service?.taxable === 0) return total;

      const quantityVal = service?.quantity ? Number(service?.quantity) : 0;
      const costVal = getServiceHourlyCost(service);
      const serviceTotal = calculateServiceTotal(costVal, quantityVal, 0);

      return total + serviceTotal;
    }, 0);

    // const productServices = selectedProducts?.reduce((services, product) => {
    //   if (product.services?.length > 0) {
    //     return services.concat(
    //       product.services.map((service) => {
    //         const cost = parseFloat(service.unit_cost ?? service.total_cost ?? 0);
    //         const quantity = parseFloat(service.quantity ?? 1);
    //         const retail_price = parseFloat(service.retail_price ?? 0);
    //         const locationQty = parseFloat(product.locationQuantity ?? 1);

    //         const subtotal = cost * quantity;
    //         const markup = (subtotal * retail_price) / 100;
    //         const total = (subtotal + markup) * locationQty;

    //         return {
    //           ...service,
    //           totalCost: total.toFixed(2),
    //         };
    //       })
    //     );
    //   }
    //   return services;
    // }, []);
    // console.log('productServicesproductServices', productServices)
    // const getTotalServiceCostSum = (services) => {
    //   return parseFloat(
    //     services.reduce((sum, item) => {
    //       console.log('itemservices', item);
    //       if (item.id !== 10) return sum;
    //       const cost = parseFloat(item.totalCost ?? 0);
    //       return sum + cost;
    //     }, 0).toFixed(2)
    //   );
    // };


    // const totalInstallServiceCostSum = getTotalServiceCostSum(productServices);

    // console.log("productServices ", productServices)

        const installCost = selectedProducts?.map((product) => {
      const retailPrice = parseFloat(product.install_cost  || 0);
      const locationQuantity = parseFloat(product.locationQuantity || 1);

      const total = retailPrice * locationQuantity;

      return {
        ...product,
        totalCost: total.toFixed(2),
      };
    });
        console.log('🧾 installCost', installCost);

    const getTotalInstallCostSum = (installCost = []) => {
      return installCost.reduce((sum, item) => {
        const cost = parseFloat(item.totalCost || 0);
        return sum + cost;
      }, 0).toFixed(2);
    };

    const totalInstallCostSum = getTotalInstallCostSum(installCost);
    console.log('🧾 Total cost production costtt', totalInstallCostSum);
    setInstallCost(totalInstallCostSum)

     console.log("selected serviceee old ",selectedServicesTotalCost)
    console.log("selected serviceee new ",selectedTaxServicesTotalCost)


    console.log("###################1111selectedServicesTotalCost-1", selectedServicesTotalCost);
    console.log("###################1111initialServicesCost-1", initialServicesCost);

    const roundToThreeDecimals = (num) => Math.round(num * 1000) / 1000;
    const roundToTwoDecimals = (num) => Math.round(num * 100) / 100;
    selectedServicesTotalCost = roundToThreeDecimals(selectedServicesTotalCost);
    selectedTaxServicesTotalCost = roundToTwoDecimals(selectedTaxServicesTotalCost);
    initialServicesCost = roundToThreeDecimals(initialServicesCost);

    console.log("###################1111selectedServicesTotalCost-2", selectedServicesTotalCost);
    console.log("###################1111initialServicesCost-2", initialServicesCost);
    const selectedServicesSubTotal = roundToTwoDecimals(selectedServicesTotalCost - initialServicesCost)
    const selectedNewTaxServicesSubTotal = roundToTwoDecimals(selectedTaxServicesTotalCost - initialServicesCost)
    setTotalLabourCost(selectedServicesSubTotal)
    setTotalProductLabourCost(selectedServicesSubTotal)
    // setTotalProductInstallCost(totalInstallServiceCostSum)
    console.log("###################1111selectedServicesSubTotal", selectedServicesSubTotal);

    const newSum = (selectedProductsTotalDiscount + selectedServicesTotalCost) - (values['invoice_discount'] ? values['invoice_discount'] : 0)
    // setRFQSubTotal(newSum)
    console.log("###################1selectedProductsTotalDiscount", selectedProductsTotalDiscount);
    const selectedRfpProduct = cart?.reduce((total, data, index) => {
      let markup = markupType ? (markupType === 1 ? data.WholesaleMarkup || data.product_markup : data.RetailMarkup || data.product_markup) : 0;

      let productTotal = parseFloat((data.product_price + data.product_price * markup / 100)?.toFixed(2)) * data.quantity * data.location_quantity;
      productTotal = parseFloat(productTotal.toFixed(2));  // Ensure two decimal places and parse back to float

      console.log("#####################ProductTotal", productTotal);
      return total + productTotal;
    }, 0);

    const selectedRfpProductJobCost = cart?.reduce((total, data, index) => {
      let productTotal = data.product_price * data.quantity * data.location_quantity;
      productTotal = parseFloat(productTotal.toFixed(2));  // Ensure two decimal places and parse back to float

      console.log("#####################ProductTotal", productTotal);
      return total + productTotal;
    }, 0);

    const selectedRfpServices = cartService?.reduce((total, data, index) => {
      let markup = data.originalMarkup;
      data.sellingPrice = data.sellingPrice || data.unit_cost;

      let productTotal = (data.sellingPrice + (data.sellingPrice * markup / 100)) * data.qty;
      productTotal = parseFloat(productTotal.toFixed(2));  // Ensure two decimal places and parse back to float

      console.log("#####################ProductTotal", productTotal);
      return total + productTotal;
    }, 0);
    const selectedNonTaxRfpServices = cartService?.reduce((total, data, index) => {
          if (data?.taxable === 0) return total;
      let markup = data.originalMarkup;
      data.sellingPrice = data.sellingPrice || data.unit_cost;

      let productTotal = (data.sellingPrice + (data.sellingPrice * markup / 100)) * data.qty;
      productTotal = parseFloat(productTotal.toFixed(2));  // Ensure two decimal places and parse back to float

      console.log("#####################ProductTotal", productTotal);
      return total + productTotal;
    }, 0);

    const selectedRfpServicesJobCost = cartService?.reduce((total, data, index) => {
      let markup = data.originalMarkup;
      data.sellingPrice = data.sellingPrice || data.unit_cost;

      let productTotal = data.sellingPrice * data.qty;
      productTotal = parseFloat(productTotal.toFixed(2));  // Ensure two decimal places and parse back to float

      console.log("#####################ProductTotal", productTotal);
      return total + productTotal;
    }, 0);
    const selectedMaterialCostJobCost = selectedMaterials?.reduce((total, data, index) => {
      let productTotal = (data.product_price||data.price) * (data.quantity||0) ;
      productTotal = parseFloat(productTotal.toFixed(2));  // Ensure two decimal places and parse back to float
      console.log("#####################ProductTotalewwww1",data);
      console.log("#####################ProductTotalewwww1", productTotal);
      return total + productTotal;
    }, 0);
    const selectedMaterialCost = selectedMaterials?.reduce((total, data, index) => {
      let markup =data?.product_markup || data?.markup || 0;
      let markUpCost = data.price + ((parseFloat(data.price) * parseFloat(markup || 0)) / 100)
      markUpCost = parseFloat(parseFloat(markUpCost).toFixed(2)) || 0;
      let adjustment = data.adj_value_type ? Number(data.adjustment || 0) : -Number(data.adjustment || 0);

      // markUpCost = markUpCost + (data.adj_value_type ? Number(data.adjustment || 0) : -Number(data.adjustment || 0));
      let productTotal = (markUpCost ? markUpCost + adjustment : data.product_retail_price + adjustment ) * (data.quantity||0) ;
      productTotal = parseFloat(productTotal.toFixed(2));  // Ensure two decimal places and parse back to float
      console.log("#####################ProductTotalewwww2",data);
      console.log("#####################ProductTotalewwww2",adjustment);
      console.log("#####################ProductTotalewwww2",markUpCost);
      
      return total + productTotal ;
    }, 0);


    const selectedNonTaxMaterialCost = selectedMaterials?.reduce((total, data, index) => {
      if (data?.taxable === 0) return total;
      let markUpCost = data.price + ((parseFloat(data.price) * parseFloat(data.product_markup || 0)) / 100)
      markUpCost = parseFloat(parseFloat(markUpCost).toFixed(2)) || 0;
      let productTotal = (markUpCost || data.product_retail_price) * (data.quantity||0) ;
      productTotal = parseFloat(productTotal.toFixed(2));  // Ensure two decimal places and parse back to float
      console.log("#####################ProductTotalewwww2",data);
      console.log("#####################ProductTotalewwww2",markUpCost);
      console.log("#####################ProductTotalewwww2", productTotal);
      return total + productTotal;
    }, 0);
    console.log("#####################Labour cost", selectedServicesSubTotal + selectedRfpServices);
    setTotalLabourCost(selectedServicesSubTotal + selectedRfpServices)
    // console.log("#####################ProductTotalewwww21selectedMaterialCost", selectedMaterialCost);
    // console.log("#####################ProductTotalewwww21selectedProductsTotalDiscount", selectedProductsTotalDiscount); 
    // console.log("#####################ProductTotalewwww21selectedServicesSubTotal", selectedServicesSubTotal); 
    // console.log("#####################ProductTotalewwww21selectedRfpServices", selectedRfpServices); 
    // console.log("#####################ProductTotalewwww21selectedMaterialCost", selectedMaterialCost); 
    // console.log("#####################ProductTotalewwww21selectedRfpProduct", selectedRfpProduct); 
    // console.log("#####################ProductTotalewwww21values['invoice_discount']", values['invoice_discount']); 
    sum = (selectedProductsTotalDiscount + selectedServicesSubTotal + selectedRfpServices+selectedMaterialCost + selectedRfpProduct) - (values['invoice_discount'] ? values['invoice_discount'] : 0)
    console.log("#####################ProductTotalewwww21", sum);
    newTaxSum = (selectedProductsTotalDiscount + selectedNewTaxServicesSubTotal + selectedNonTaxRfpServices+selectedNonTaxMaterialCost + selectedRfpProduct) - (values['invoice_discount'] ? values['invoice_discount'] : 0) - totalCostSum ;
    console.log('sumsumsum--values[invoice_discount]', values['invoice_discount'])
    console.log('sumsumsum--selectedRfpProduct', selectedRfpProduct)
    console.log('sumsumsum--selectedMaterialCost', selectedMaterialCost)
    console.log('sumsumsum--selectedRfpServices', selectedRfpServices)
    console.log('sumsumsum--selectedServicesSubTotal', selectedServicesSubTotal)
    console.log('sumsumsum--selectedProductsTotalDiscount', selectedProductsTotalDiscount)
    console.log('sumsumsum--sum', sum)
   taxAmountData = selectedTaxCategory
     ? (selectedTaxCategory.type === 1
         ? (sum * (selectedTaxCategory.value || 0) / 100)
         : (selectedTaxCategory.value || 0))
     : 0;

   const newTaxAmountData = selectedTaxCategory
     ? (selectedTaxCategory.type === 1
         ? (newTaxSum * (selectedTaxCategory.value || 0) / 100)
         : (selectedTaxCategory.value || 0))
     : 0;

   const taxAmountToFixed = parseFloat(parseFloat(newTaxAmountData).toFixed(2));

   console.log('taxAmounttttt old >', taxAmountData);
   console.log('taxAmounttttt new >', newTaxAmountData);

  //  if (!details?.avalara_code) {
  //    // Use the freshly calculated taxAmountData when Avalara is not used
  //    const localTax = parseFloat(taxAmount.toFixed(2)) || 0;
  //    grandTotalData = (parseFloat(sum) + localTax).toFixed(2);
  //    setTaxAmount(localTax);
  //  } else {
  //    // For Avalara, taxAmount is set from API elsewhere; add that to sum
  //    const avalaraTax = parseFloat(taxAmount) || 0;
  //    grandTotalData = (parseFloat(sum) + avalaraTax).toFixed(2);
  //  }
    const avalaraTax = parseFloat(taxAmount) || 0;
    
    // --- RUSH FEE CALCULATION ---
    const productsForLead =
      selectedProducts?.length > 0 ? selectedProducts : values.products || [];
    const isRushFeeAutoLocked = isInstallBeforeRequiredLead(values, productsForLead);
    
    const canManuallyToggleRushFee = !!explodedPermissions?.some((permission) =>
      ['Manage Rush Fee Toggle Estimate'].includes(permission),
    );
    const canOverrideRushFeeLock = !!explodedPermissions?.some((permission) =>
      ['Override Rush Fee Estimate'].includes(permission),
    );
    
    const isRushFeeChecked =
      Number(values?.rush_fee) === 1 ||
      (!!isRushFeeAutoLocked && !canOverrideRushFeeLock);
      
    const rushFeePercentage = Number(data?.rush_fee_percentage) || 0;
    const rushFeeAmount = calcRushFeeAmount({
      enabled: isRushFeeChecked,
      subtotal: sum || 0,
      percentage: rushFeePercentage,
      storedAmount: details?.rush_fee_amount || 0,
      preferStored: !openEdit,
    });
    values['rush_fee_amount'] = rushFeeAmount;
    
    grandTotalData = (parseFloat(sum) + avalaraTax + rushFeeAmount).toFixed(2);
    
    console.log("#####################selectedRfpServices", selectedRfpServices);
    setTotalSum(sum);
    console.log("SUMMMMMMMM",sum);
    console.log("SUMMMMMMMM",grandTotalData);
    
   // Update grand total as a number
   setGrandTotal(parseFloat(grandTotalData));

    let selectedProductsTotalProductFormula = selectedProducts?.reduce((total, data) => {
      let quantityFieldName = `quantity_${data.product_id ? data.product_id : data.id}`;
      let discountFieldName = `discount_${data.product_id ? data.product_id : data.id}`;
      const dataRetailPrice = data.product_retail_price || data.retail_price;
      const dataWholesalePrice = data.product_price || data.price;
      const dataQuantity = values[quantityFieldName] ? values[quantityFieldName] : (data?.quantity || 1);

      let newTotalProductFormula = parseFloat(data.expected_cost?.toFixed(2)) * data.quantity * data.locationQuantity;
      newTotalProductFormula = newTotalProductFormula ? Number(newTotalProductFormula) : 0;

      console.log('newTotalProductFormula--', newTotalProductFormula);

      return total + newTotalProductFormula;
    }, 0);
    console.log("###############jobcost", selectedRfpProductJobCost);
    selectedProductsTotalProductFormula = selectedProductsTotalProductFormula ? (Number(selectedProductsTotalProductFormula)) : 0

    setTotalProductFormula(selectedProductsTotalProductFormula)

    const groupIdsForWholesaleRollup = new Set()
    let selectedProductsTotalWholesalePrice = selectedProducts?.reduce((total, data, index) => {
      const gidRaw =
        data?.group_id ?? data?.customer_order_product_group_id ?? data?.groupId ?? null
      if (gidRaw != null && String(gidRaw) !== '') {
        const gKey = String(gidRaw)
        if (groupIdsForWholesaleRollup.has(gKey)) return total
        groupIdsForWholesaleRollup.add(gKey)
        const group = groupedProductsMap.get(gKey)
        if (group && markupType == 1) {
          const sub = Number(group.adjustedGroupSubtotal || 0)
          return total + sub
        }
        if (group && markupType != 1) return total
      }

      let quantityFieldName = `quantity_${data.product_id ? data.product_id : data.id}`;
      let discountFieldName = `discount_${data.product_id ? data.product_id : data.id}`;
      const dataRetailPrice = data.product_retail_price || data.retail_price
      const dataWholesalePrice = data.product_price || data.price
      const dataQuantity = values[quantityFieldName] ? values[quantityFieldName] : (data?.quantity || 1)

      let newTotalWholesalePrice = dataWholesalePrice * data.quantity * data.locationQuantity
      if(data?.adjustment){
        newTotalWholesalePrice = newTotalWholesalePrice ? newTotalWholesalePrice + ((newTotalWholesalePrice * Number(data?.adjustment)) / 100) : 0
      }
      newTotalWholesalePrice = newTotalWholesalePrice ? Number(newTotalWholesalePrice) : 0

      console.log('newTotalWholesalePrice--', newTotalWholesalePrice);

      return total + newTotalWholesalePrice;
    }, 0);
    selectedProductsTotalWholesalePrice = selectedProductsTotalWholesalePrice ? Number(selectedProductsTotalWholesalePrice) : 0

    let selectedServicesTotalWholesalePrice = selectedServices?.reduce((total, data, index) => {
      let newTotalWholesalePrice = (data?.unit_cost * data?.quantityDifference)?.toFixed(2)
      newTotalWholesalePrice = newTotalWholesalePrice ? Number(newTotalWholesalePrice) : 0
      return total + newTotalWholesalePrice;
    }, 0);
    selectedServicesTotalWholesalePrice = selectedServicesTotalWholesalePrice ? Number(selectedServicesTotalWholesalePrice) : 0

    let selectedAddlServicesTotalWholesalePrice = additionalSelectedServices?.reduce((total, data, index) => {
      let newTotalWholesalePrice = data?.total
      newTotalWholesalePrice = newTotalWholesalePrice ? Number(newTotalWholesalePrice) : 0
      return total + newTotalWholesalePrice;
    }, 0);
    selectedAddlServicesTotalWholesalePrice = selectedAddlServicesTotalWholesalePrice ? Number(selectedAddlServicesTotalWholesalePrice) : 0

    let selectedCartTotalWholesalePrice = cart?.reduce((total, data, index) => {
      let markup = markupType ? (markupType === 1 ? data.WholesaleMarkup || data.product_markup : data.RetailMarkup || data.product_markup) : 0;
      let newTotalWholesalePrice = (data.location_quantity * data.quantity * (data.product_price + (data.product_price * markup / 100))).toFixed(2)
      newTotalWholesalePrice = newTotalWholesalePrice ? Number(newTotalWholesalePrice) : 0
      return total + newTotalWholesalePrice;
    }, 0);

    selectedCartTotalWholesalePrice = selectedCartTotalWholesalePrice ? Number(selectedCartTotalWholesalePrice) : 0

    let selectedCartServicesTotalWholesalePrice = cartService?.reduce((total, data, index) => {
      let newTotalWholesalePrice = (data.qty * (data.sellingPrice + (data.sellingPrice * data.originalMarkup / 100)))?.toFixed(2)
      newTotalWholesalePrice = newTotalWholesalePrice ? Number(newTotalWholesalePrice) : 0
      return total + newTotalWholesalePrice;
    }, 0);
    selectedCartServicesTotalWholesalePrice = selectedCartServicesTotalWholesalePrice ? Number(selectedCartServicesTotalWholesalePrice) : 0
    
    let selectedMaterialsTotalWholesalePrice = selectedMaterials?.reduce((total, data, index) => {
      let newTotalWholesalePrice = ((data.markUpCost || 0) * (data.quantity||1))?.toFixed(2)
      newTotalWholesalePrice = newTotalWholesalePrice ? Number(newTotalWholesalePrice) : 0
      return total + newTotalWholesalePrice;
    }, 0);
    selectedMaterialsTotalWholesalePrice = selectedMaterialsTotalWholesalePrice ? Number(selectedMaterialsTotalWholesalePrice) : 0

    let newTotalWholesalePrice = selectedProductsTotalWholesalePrice + selectedServicesTotalWholesalePrice + selectedAddlServicesTotalWholesalePrice + selectedCartTotalWholesalePrice + selectedCartServicesTotalWholesalePrice + selectedMaterialsTotalWholesalePrice
    setTotalWholesalePrice(newTotalWholesalePrice)

    const groupIdsForRetailRollup = new Set()
    let selectedProductsTotalRetailPrice = selectedProducts?.reduce((total, data, index) => {
      const gidRaw =
        data?.group_id ?? data?.customer_order_product_group_id ?? data?.groupId ?? null
      if (gidRaw != null && String(gidRaw) !== '') {
        const gKey = String(gidRaw)
        if (groupIdsForRetailRollup.has(gKey)) return total
        groupIdsForRetailRollup.add(gKey)
        const group = groupedProductsMap.get(gKey)
        if (group && markupType == 2) {
          const sub = Number(group.adjustedGroupSubtotal || 0)
          return total + sub
        }
        if (group && markupType != 2) return total
      }

      let quantityFieldName = `quantity_${data.product_id ? data.product_id : data.id}`;
      let discountFieldName = `discount_${data.product_id ? data.product_id : data.id}`;
      const dataRetailPrice = data.product_retail_price || data.retail_price
      const dataWholesalePrice = data.product_price || data.price
      const dataQuantity = values[quantityFieldName] ? values[quantityFieldName] : (data?.quantity || 1)

      let newTotalRetailPrice = dataRetailPrice * data.quantity * data.locationQuantity
      if(data?.adjustment){
        newTotalRetailPrice = newTotalRetailPrice ? newTotalRetailPrice + ((newTotalRetailPrice * Number(data?.adjustment)) / 100) : 0
      }
      newTotalRetailPrice = newTotalRetailPrice ? Number(newTotalRetailPrice) : 0

      console.log('newTotalRetailPrice--', newTotalRetailPrice);

      return total + newTotalRetailPrice;
    }, 0);
    selectedProductsTotalRetailPrice = selectedProductsTotalRetailPrice ? Number(selectedProductsTotalRetailPrice) : 0

    let newTotalRetailPrice = selectedProductsTotalRetailPrice + selectedServicesTotalWholesalePrice + selectedAddlServicesTotalWholesalePrice + selectedCartTotalWholesalePrice + selectedCartServicesTotalWholesalePrice + selectedMaterialsTotalWholesalePrice
    setTotalRetailPrice(newTotalRetailPrice)

    //discount count
    let selectedProductDiscount = selectedProducts?.reduce((acc, data, index) => {
      // const discountFieldName = `discount_${data.product_id?data.product_id:data.id}`;
      // const discountVal = values[discountFieldName]?values[discountFieldName]:(data?.discount||0);
      const discountVal = data.discount ? data.discount : 0
      let productDiscount = +discountVal || 0;
      return acc + productDiscount;
    }, 0);
    const newDiscountTotal = selectedProductDiscount + (parseFloat(values['invoice_discount']) || 0);
    setDiscountTotal(selectedProductDiscount + (parseFloat(values['invoice_discount']) || 0));

    console.log("#############selectedProductsTotalProductFormula", selectedProductsTotalProductFormula);
    console.log("#############selectedTotalWholesalePrice", newTotalWholesalePrice);
    console.log("#############selectedTotalRetailPrice", newTotalRetailPrice);
    console.log("####################selectedMaterials", selectedMaterials);

    totalJobcostSum = (selectedProductsTotalDiscountForJobCost + selectedServicesCost +selectedMaterialCostJobCost+ selectedRfpProductJobCost + selectedRfpServicesJobCost);
    console.log('total job cost------- budget', totalJobcostSum);
    values['total'] = sum
    values['taxAmount'] = taxAmountData
    values['budget'] = totalJobcostSum
    console.log("################Budget", totalJobcostSum);
    setBudget(totalJobcostSum)
    let subTotal = markupType == 1 ? ((selectedProductsTotalWholesalePrice - newDiscountTotal + selectedRfpProduct+selectedMaterialCost))
      : (markupType == 2 ? ((selectedProductsTotalRetailPrice - newDiscountTotal + selectedRfpProduct)) : 0);
    console.log("################subTotal", subTotal);
    setRFQSubTotal(subTotal)
    // let selectedProductsTotalMarkupAmount = markupType == 1 ? ((selectedProductsTotalWholesalePrice - newDiscountTotal) - selectedProductsTotalProductFormula)
    //   : (markupType == 2 ? ((selectedProductsTotalRetailPrice - newDiscountTotal) - selectedProductsTotalProductFormula) : 0);
    // setTotalMarkupAmount(selectedProductsTotalMarkupAmount)
    let selectedProductsTotalMarkupAmount = sum - totalJobcostSum
    setTotalMarkupAmount(selectedProductsTotalMarkupAmount)


    let selectedProductsTotalMarkup = (selectedProductsTotalMarkupAmount / totalJobcostSum) * 100
    setTotalMarkupPercentage(selectedProductsTotalMarkup)

    console.log('selectedProductsTotalMarkup-------', selectedProductsTotalMarkup);

    // let selectedProductsTotalMarkup = markupType == 1 ? ((((selectedProductsTotalWholesalePrice - newDiscountTotal) - selectedProductsTotalProductFormula) / selectedProductsTotalProductFormula) * 100)
    //   : (markupType == 2 ? ((((selectedProductsTotalRetailPrice - newDiscountTotal) - selectedProductsTotalProductFormula) / selectedProductsTotalProductFormula) * 100) : 0);
    // setTotalMarkupPercentage(selectedProductsTotalMarkup)

    // console.log('selectedProductsTotalDiscount-------',selectedProductsTotalDiscount);
    // console.log('selectedProductsTotalDiscountForJobCost-------',selectedProductsTotalDiscountForJobCost);
    // console.log('selectedServicesCost-------', selectedServicesCost);
    // console.log('selectedServicesTotalCost-------',selectedServicesTotalCost);
    // console.log('selectedServicesSubTotal-------',selectedServicesSubTotal);
    // console.log('sum-------',sum);

    console.log('initialServiceCost In ProductFormula-----', initialServicesCost);
    setInitialServiceCostInProductFormula(initialServicesCost)
    // }else{
    //   console.log('eeeeeeeeeeeeeeeeee');
    // }
  } catch (error) {
    console.log('Error--------------', error);
  }
}, [currentRFQData, selectedTaxCategory, selectedProducts,selectedMaterials, selectedServices, additionalSelectedServices, estimateCatalogServices, values.markup_type, values.invoice_discount, values.rush_fee, refreshData, cartService, cart,refreshCalculation, groupedProductsMap, markupType, groupProductMarketingValues, groupInstallMarketingValues, data?.rush_fee_percentage, taxAmount])

console.log('additionalSelectedServices--',additionalSelectedServices);
////image functionality
const handleRemoveAll = () => {
  const removed = [...avatarUrl];
  setAvatarUrl([]);
  if (removed.length === 0) return;
  setProductAttachments((prev) =>
    removed.reduce((acc, f) => pruneAttachmentMapsByFile(acc, f), prev)
  );
  setServiceAttachments((prev) =>
    removed.reduce((acc, f) => pruneAttachmentMapsByFile(acc, f), prev)
  );
  setSelectedUploadedImages((prev) =>
    removed.reduce((acc, f) => pruneAttachmentMapsByFile(acc, f), prev)
  );
  setSelectedUploadedImagesService((prev) =>
    removed.reduce((acc, f) => pruneAttachmentMapsByFile(acc, f), prev)
  );
};

const handleRemove = (file) => {
  if (file?._productAttachment) {
    const productIndexId = file?.product_index_id
    if (productIndexId != null && String(productIndexId) !== '') {
      handleProductRemove(file, productIndexId)
      return
    }
  }
  if (file?._serviceAttachment) {
    const serviceIndexId = file?.service_index_id
    if (serviceIndexId != null && String(serviceIndexId) !== '') {
      handleServiceRemove(file, serviceIndexId)
      return
    }
  }

  setAvatarUrl((prev) => prev.filter((f) => !attachmentMatches(f, file)));
  setProductAttachments((prev) => pruneAttachmentMapsByFile(prev, file));
  setServiceAttachments((prev) => pruneAttachmentMapsByFile(prev, file));
  setSelectedUploadedImages((prev) => pruneAttachmentMapsByFile(prev, file));
  setSelectedUploadedImagesService((prev) => pruneAttachmentMapsByFile(prev, file));
};

///////
// const handleDrop = useCallback(
//       (acceptedFiles) => {
//         let permission =!explodedPermissions?.some((permission) => ['Upload Files Sales Order'].includes(permission))
//         if(permission &&  user?.added_by_client ==1){
//           return   enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
//         }
//         if (acceptedFiles && acceptedFiles.length > 0) {
//           setIsUploading(true);
//           const uploadPromises = acceptedFiles?.map((file) => {
//             return new Promise((resolve, reject) => {
//               const Filename = new Date().getTime() + file.name;
//               const StorageRef = imageref(storage, Filename);
//               const uploadTask = uploadBytesResumable(StorageRef, file);
  
//               uploadTask.on(
//                 'state_changed',
//                 (snapshot) => {
//                   const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
//                 },
//                 (error) => {
//                   console.error(error.message);
//                   setIsUploading(false);
//                   reject(error);
//                 },
//                 () => {
//                   getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
//                     resolve({
//                       url: downloadURL,
//                       file_type: file.type,
//                       extension: file.name.split('.').pop(),
//                       size: file.size
//                     });
//                   });
//                 }
//               );
//             });
//           });
  
//           Promise.all(uploadPromises)
//             .then((downloadURLs) => {
//               setAvatarUrl((prevAvatarUrls) => {
//                 const updatedFiles = downloadURLs.map((file) => ({
//                   url: file.url,
//                   file_type: file.file_type,
//                   extension: file.extension,
//                   size: file.size
//                 }));
//                 return [...prevAvatarUrls, ...updatedFiles]
//               });
//               setIsUploading(false);
//             })
//             .catch((error) => {
//               console.error(error.message);
//               setIsUploading(false);
//             });
//         }
//       },
//       [setFieldValue]
//     );

const handleDrop = useCallback(
  async (acceptedFiles) => {
    // ───── permission gate ─────
    const noPermission = !explodedPermissions?.some(
      (p) => p === 'Upload Files Sales Order'
    );
    if (noPermission && user?.added_by_client === 1) {
      enqueueSnackbar('Access Denied: You do not have sufficient permissions', {
        variant: 'error'
      });
      return;
    }
    // ──────────────────────────

    if (!acceptedFiles || acceptedFiles.length === 0) return;

    setIsUploading(true);

    try {
      const uploadPromises = acceptedFiles.map(async (file) => {
        const timestamp       = Date.now();
        const sanitizedName   = file.name.replace(/\s+/g, '_');
        const fileName        = `${timestamp}_${sanitizedName}`;
        const filePath        = `estimate/attachments/${fileName}`;   // 🔑 path

        // Upload to Supabase Storage
        const { error: uploadErr } = await supabase.storage
          .from('signwise-attachments')
          .upload(filePath, file);

        if (uploadErr) throw uploadErr;

        // Get the public URL
        const { data: urlData, error: urlErr } = supabase.storage
          .from('signwise-attachments')
          .getPublicUrl(filePath);

        if (urlErr || !urlData?.publicUrl) {
          throw new Error('Failed to generate public URL');
        }

        return {
          url:        urlData.publicUrl,
          file_type:  file.type,
          extension:  file.name.split('.').pop(),
          size:       file.size
        };
      });

      const uploadedFiles = await Promise.all(uploadPromises);

      if (!id) return;

      for (const fileData of uploadedFiles) {
        const res = await axios.post(`${REST_API_END_POINT}request/upload-designs`, {
          requestId: id,
          userId: user.user_id,
          uploaded: [fileData.url],
          type: fileData.file_type,
          size: fileData.size,
          extension: fileData.extension,
          attachmentType: 'design',
        });
        if (res.data?.status !== 1) {
          throw new Error(res.data?.message || 'Failed to save design/document');
        }
      }

      setAvatarUrl((prev) => [...prev, ...uploadedFiles]);
      if (currentTab === 'Job Log') {
        handleJobLogUpdates();
      }
      enqueueSnackbar('New design/document added!', { variant: 'success' });
    } catch (err) {
      console.error('Upload error:', err.message);
      enqueueSnackbar(err.response?.data?.message || 'Upload failed: ' + err.message, { variant: 'error' });
    } finally {
      setIsUploading(false);
    }
  },
  [explodedPermissions, user, id, currentTab, enqueueSnackbar, handleJobLogUpdates, setAvatarUrl, setIsUploading]
);

const handleRejectFileDrop = useCallback(
  async (acceptedFiles) => {
    if (!acceptedFiles || acceptedFiles.length === 0) return;

    const file = acceptedFiles[0];   // single file only
    setIsUploadingRejectFile(true);

    try {
      const timestamp = Date.now();
      // This removes all #, %, &, + and other dangerous URL characters
const sanitizedName = file.name.replace(/\s+/g, '_').replace(/[^a-zA-Z0-9.\-_]/g, '');;
      const fileName = `${timestamp}_${sanitizedName}`;
      const filePath = `estimate/rejected/${fileName}`;

      // Upload to Supabase Storage
      const { error: uploadError } = await supabase.storage
        .from('signwise-attachments')
        .upload(filePath, file);

      if (uploadError) throw uploadError;

      // Get public URL
      const { data: publicUrlData, error: urlError } = supabase.storage
        .from('signwise-attachments')
        .getPublicUrl(filePath);

      if (urlError || !publicUrlData?.publicUrl) {
        throw new Error('Failed to generate public URL');
      }

      // Save single reject file
      setRejectFile({
        url: publicUrlData.publicUrl,
        file_type: file.type,
        extension: file.name.split('.').pop(),
        size: file.size
      });
    } catch (err) {
      console.error('Upload error:', err.message);
      enqueueSnackbar('Upload failed: ' + err.message, { variant: 'error' });
    } finally {
      setIsUploadingRejectFile(false);
    }
  },
  [setRejectFile, setIsUploadingRejectFile, enqueueSnackbar]
);

  const handleOpenAttachment = (indexId, applyToGroup = false) => {
    const key = String(indexId)
    if (applyToGroup) {
      setGroupAttachmentTargets((prev) => ({
        ...prev,
        [key]: getGroupMemberIndexIdsByAnchor(indexId),
      }))
    } else {
      setGroupAttachmentTargets((prev) => ({ ...prev, [key]: undefined }))
    }
    setOpenProductAttachment((prev) => ({ ...prev, [indexId]: true }));
    setAttachmentTabValue((prev) => ({ ...prev, [indexId]: 0 }));
    const currentAttachments = getProductAttachmentsList(indexId);
    setSelectedUploadedImages((prev) => ({ ...prev, [String(indexId)]: [...currentAttachments] }));
  };

  const handleOpenGroupAttachment = (indexId) => {
    handleOpenAttachment(indexId)
  }

  const handleCloseAttachment = (indexId) => {
    setOpenProductAttachment((prev) => ({ ...prev, [indexId]: false }));
    setAttachmentTabValue((prev) => ({ ...prev, [indexId]: 0 }));
    setSelectedUploadedImages((prev) => ({ ...prev, [indexId]: [] }));
  };

  const handleAttachmentTabChange = (event, newValue, indexId) => {
    setAttachmentTabValue((prev) => ({ ...prev, [indexId]: newValue }));
  };

  const handleImageSelect = (file, indexId, isSelected) => {
    const key = String(indexId ?? '');
    setSelectedUploadedImages((prev) => {
      const current = prev[key] || prev[indexId] || [];
      if (isSelected) {
        if (current.some((f) => attachmentMatches(f, file))) return prev;
        return { ...prev, [key]: [...current, file] };
      }
      return { ...prev, [key]: current.filter((f) => !attachmentMatches(f, file)) };
    });
  };

  const handleAddSelectedImages = (indexId) => {
    const key = String(indexId ?? '');
    const selected = selectedUploadedImages[key] || selectedUploadedImages[indexId] || [];
    const memberIds = getGroupMemberIndexIdsByProductIndexId(indexId);
    const original = getProductAttachmentsList(indexId);
    const toLink = selected.filter((file) => !original.some((orig) => attachmentMatches(orig, file)));
    const toUnlink = original.filter((file) => !selected.some((sel) => attachmentMatches(sel, file)));

    if (toLink.length === 0 && toUnlink.length === 0) {
      setOpenProductAttachment((prev) => ({ ...prev, [indexId]: false }));
      return;
    }

    setProductAttachments((prev) => {
      const next = { ...prev };
      memberIds.forEach((mid) => {
        const tKey = String(mid);
        next[tKey] = selected.map((file) => ({ ...file, product_index_id: mid }));
      });
      return next;
    });
    setSelectedUploadedImages((prev) => {
      const next = { ...prev };
      memberIds.forEach((mid) => {
        next[String(mid)] = [];
        next[mid] = [];
      });
      return next;
    });
    setOpenProductAttachment((prev) => ({ ...prev, [indexId]: false }));
    enqueueSnackbar(
      memberIds.length > 1
        ? 'Product attachments updated for all products in the group'
        : 'Product attachments updated successfully',
      { variant: 'success' },
    );
  };

  const handleOpenServiceAttachment = (indexId) => {
    const key = String(indexId);
    setOpenServiceAttachment((prev) => ({ ...prev, [indexId]: true }));
    setAttachmentTabValueService((prev) => ({ ...prev, [indexId]: 0 }));
    const currentAttachments = serviceAttachments[key] || serviceAttachments[indexId] || [];
    setSelectedUploadedImagesService((prev) => ({ ...prev, [key]: [...currentAttachments] }));
  };

  const handleCloseServiceAttachment = (indexId) => {
    setOpenServiceAttachment((prev) => ({ ...prev, [indexId]: false }));
    setAttachmentTabValueService((prev) => ({ ...prev, [indexId]: 0 }));
    setSelectedUploadedImagesService((prev) => ({ ...prev, [indexId]: [] }));
  };

  const handleAttachmentTabChangeService = (event, newValue, indexId) => {
    setAttachmentTabValueService((prev) => ({ ...prev, [indexId]: newValue }));
  };

  const handleImageSelectService = (file, indexId, isSelected) => {
    const key = String(indexId ?? '');
    setSelectedUploadedImagesService((prev) => {
      const current = prev[key] || prev[indexId] || [];
      if (isSelected) {
        if (current.some((f) => attachmentMatches(f, file))) return prev;
        return { ...prev, [key]: [...current, file] };
      }
      return { ...prev, [key]: current.filter((f) => !attachmentMatches(f, file)) };
    });
  };

  const handleAddSelectedImagesService = (indexId) => {
    const key = String(indexId ?? '');
    const selected = selectedUploadedImagesService[key] || selectedUploadedImagesService[indexId] || [];
    const original = serviceAttachments[key] || serviceAttachments[indexId] || [];
    const toLink = selected.filter((file) => !original.some((orig) => attachmentMatches(orig, file)));
    const toUnlink = original.filter((file) => !selected.some((sel) => attachmentMatches(sel, file)));

    if (toLink.length === 0 && toUnlink.length === 0) {
      setOpenServiceAttachment((prev) => ({ ...prev, [indexId]: false }));
      return;
    }

    setServiceAttachments((prev) => ({
      ...prev,
      [key]: selected.map((file) => ({ ...file, service_index_id: indexId })),
    }));
    setSelectedUploadedImagesService((prev) => ({ ...prev, [key]: [], [indexId]: [] }));
    setOpenServiceAttachment((prev) => ({ ...prev, [indexId]: false }));
    enqueueSnackbar('Service attachments updated successfully', { variant: 'success' });
  };

  const handleProductDrop = useCallback(
    async (acceptedFiles, productIndexId) => {
      const noPermission = !explodedPermissions?.some(
        (p) => p === 'Upload Files Sales Order'
      );
      if (noPermission && user?.added_by_client === 1) {
        enqueueSnackbar('Access Denied: You do not have sufficient permissions', {
          variant: 'error',
        });
        return;
      }

      if (!acceptedFiles || acceptedFiles.length === 0) return;

      const pKey = String(productIndexId ?? '');
      setIsUploadingProduct((prev) => ({ ...prev, [pKey]: true }));

      try {
        const uploadPromises = acceptedFiles.map(async (file) => {
          const timestamp = Date.now();
          const sanitizedFileName = file.name.replace(/\s+/g, '_');
          const fileName = `${timestamp}_${sanitizedFileName}`;
          const filePath = `estimate/attachments/${fileName}`;

          const { error: uploadError } = await supabase.storage
            .from('signwise-attachments')
            .upload(filePath, file);

          if (uploadError) throw uploadError;

          const { data: publicUrlData, error: urlError } = supabase.storage
            .from('signwise-attachments')
            .getPublicUrl(filePath);

          if (urlError || !publicUrlData?.publicUrl) {
            throw new Error('Failed to generate public URL');
          }

          return {
            url: publicUrlData.publicUrl,
            file_type: file.type,
            extension: file.name.split('.').pop(),
            size: file.size,
            name: file.name,
            product_index_id: pKey,
          };
        });

        const uploadedFiles = await Promise.all(uploadPromises);
        const memberIds = getGroupMemberIndexIdsByProductIndexId(productIndexId)

        if (!id) return;

        for (const fileData of uploadedFiles) {
          const res = await axios.post(`${REST_API_END_POINT}request/upload-designs`, {
            requestId: id,
            userId: user.user_id,
            uploaded: [fileData.url],
            type: fileData.file_type,
            size: fileData.size,
            extension: fileData.extension,
            attachmentType: 'product',
          });
          if (res.data?.status !== 1) {
            throw new Error(res.data?.message || 'Failed to save attachment');
          }
        }

        setProductAttachments((prev) => {
          const next = { ...prev }
          memberIds.forEach((mid) => {
            const mKey = String(mid)
            const current = next[mKey] || []
            const existingKeys = current.map(attachmentFileKey)
            const newFiles = uploadedFiles
              .map((f) => ({ ...f, product_index_id: mid }))
              .filter((f) => !existingKeys.includes(attachmentFileKey(f)))
            next[mKey] = [...current, ...newFiles]
          })
          return next
        });
        if (currentTab === 'Job Log') {
          handleJobLogUpdates();
        }
        enqueueSnackbar(
          memberIds.length > 1
            ? `Attachment uploaded to all ${memberIds.length} products in the group`
            : 'Attachment uploaded successfully',
          { variant: 'success' },
        );
      } catch (error) {
        console.error('Error uploading product file:', error);
        enqueueSnackbar(error.response?.data?.message || 'Failed to upload file', { variant: 'error' });
      } finally {
        setIsUploadingProduct((prev) => ({ ...prev, [pKey]: false }));
      }
    },
    [explodedPermissions, user, id, currentTab, enqueueSnackbar, handleJobLogUpdates, getGroupMemberIndexIdsByProductIndexId]
  );

  const getDragTransferTypes = (dataTransfer) => {
    if (!dataTransfer?.types) return [];
    const { types } = dataTransfer;
    if (typeof types.includes === 'function') return [...types];
    const list = [];
    for (let i = 0; i < types.length; i += 1) {
      list.push(types[i]);
    }
    return list;
  };

  const isExternalFileDragEvent = (e) => {
    const types = getDragTransferTypes(e.dataTransfer);
    if (types.some((type) => String(type).toLowerCase().includes('react-beautiful-dnd'))) {
      return false;
    }
    return (
      types.includes('Files') ||
      types.includes('application/x-moz-file') ||
      Array.from(e.dataTransfer?.items || []).some((item) => item.kind === 'file')
    );
  };

  const handleProductIconDragOver = (e, productIndexId) => {
    if (!isExternalFileDragEvent(e)) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.dataTransfer) {
      e.dataTransfer.dropEffect = 'copy';
    }
    setProductAttachmentDragOver((prev) => ({ ...prev, [productIndexId]: true }));
  };

  const handleProductIconDragLeave = (e, productIndexId) => {
    e.preventDefault();
    e.stopPropagation();
    const related = e.relatedTarget;
    if (related && e.currentTarget.contains(related)) return;
    setProductAttachmentDragOver((prev) => ({ ...prev, [productIndexId]: false }));
  };

  const handleProductIconDrop = (e, productIndexId) => {
    e.preventDefault();
    e.stopPropagation();
    setProductAttachmentDragOver((prev) => ({ ...prev, [productIndexId]: false }));
    const files = Array.from(e.dataTransfer?.files || []);
    if (files.length > 0) {
      handleProductDrop(files, productIndexId);
    }
  };

  const handleProductRemove = (file, productIndexId) => {
    const memberIds = getGroupMemberIndexIdsByProductIndexId(productIndexId)
    if (!file) {
      setProductAttachments((prev) => {
        const next = { ...prev }
        memberIds.forEach((mid) => {
          next[String(mid)] = []
        })
        return next
      });
      return;
    }
    setProductAttachments((prev) => {
      const next = { ...prev }
      memberIds.forEach((mid) => {
        const tKey = String(mid)
        const current = next[tKey] || []
        next[tKey] = current.filter((f) => !attachmentMatches(f, file))
      })
      return next
    });
    setAvatarUrl((prev) => prev.filter((f) => !attachmentMatches(f, file)));
    setSelectedUploadedImages((prev) => {
      if (!file) {
        const next = { ...prev }
        memberIds.forEach((mid) => {
          next[String(mid)] = []
          next[mid] = []
        })
        return next
      }
      return pruneAttachmentMapsByFile(prev, file)
    });
  };

  const handleServiceDrop = useCallback(
    async (acceptedFiles, serviceIndexId) => {
      const noPermission = !explodedPermissions?.some(
        (p) => p === 'Upload Files Sales Order'
      );
      if (noPermission && user?.added_by_client === 1) {
        enqueueSnackbar('Access Denied: You do not have sufficient permissions', {
          variant: 'error',
        });
        return;
      }

      if (!acceptedFiles || acceptedFiles.length === 0) return;

      const sKey = String(serviceIndexId ?? '');
      setIsUploadingService((prev) => ({ ...prev, [sKey]: true }));

      try {
        const uploadPromises = acceptedFiles.map(async (file) => {
          const timestamp = Date.now();
          const sanitizedFileName = file.name.replace(/\s+/g, '_');
          const fileName = `${timestamp}_${sanitizedFileName}`;
          const filePath = `estimate/attachments/${fileName}`;

          const { error: uploadError } = await supabase.storage
            .from('signwise-attachments')
            .upload(filePath, file);

          if (uploadError) throw uploadError;

          const { data: publicUrlData, error: urlError } = supabase.storage
            .from('signwise-attachments')
            .getPublicUrl(filePath);

          if (urlError || !publicUrlData?.publicUrl) {
            throw new Error('Failed to generate public URL');
          }

          return {
            url: publicUrlData.publicUrl,
            file_type: file.type,
            extension: file.name.split('.').pop(),
            size: file.size,
            name: file.name,
            service_index_id: sKey,
          };
        });

        const uploadedFiles = await Promise.all(uploadPromises);

        if (!id) return;

        for (const fileData of uploadedFiles) {
          const res = await axios.post(`${REST_API_END_POINT}request/upload-designs`, {
            requestId: id,
            userId: user.user_id,
            uploaded: [fileData.url],
            type: fileData.file_type,
            size: fileData.size,
            extension: fileData.extension,
            attachmentType: 'service',
          });
          if (res.data?.status !== 1) {
            throw new Error(res.data?.message || 'Failed to save attachment');
          }
        }

        setServiceAttachments((prev) => {
          const key = sKey;
          const current = prev[key] || [];
          const existingKeys = current.map(attachmentFileKey);
          const newFiles = uploadedFiles.filter((f) => !existingKeys.includes(attachmentFileKey(f)));
          return {
            ...prev,
            [key]: [...current, ...newFiles],
          };
        });
        if (currentTab === 'Job Log') {
          handleJobLogUpdates();
        }
        enqueueSnackbar('Attachment uploaded successfully', { variant: 'success' });
      } catch (error) {
        console.error('Error uploading service file:', error);
        enqueueSnackbar(error.response?.data?.message || 'Failed to upload file', { variant: 'error' });
      } finally {
        setIsUploadingService((prev) => ({ ...prev, [sKey]: false }));
      }
    },
    [explodedPermissions, user, id, currentTab, enqueueSnackbar, handleJobLogUpdates]
  );

  const handleServiceIconDragOver = (e, serviceIndexId) => {
    if (!isExternalFileDragEvent(e)) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.dataTransfer) {
      e.dataTransfer.dropEffect = 'copy';
    }
    setServiceAttachmentDragOver((prev) => ({ ...prev, [serviceIndexId]: true }));
  };

  const handleServiceIconDragLeave = (e, serviceIndexId) => {
    e.preventDefault();
    e.stopPropagation();
    const related = e.relatedTarget;
    if (related && e.currentTarget.contains(related)) return;
    setServiceAttachmentDragOver((prev) => ({ ...prev, [serviceIndexId]: false }));
  };

  const handleServiceIconDrop = (e, serviceIndexId) => {
    e.preventDefault();
    e.stopPropagation();
    setServiceAttachmentDragOver((prev) => ({ ...prev, [serviceIndexId]: false }));
    const files = Array.from(e.dataTransfer?.files || []);
    if (files.length > 0) {
      handleServiceDrop(files, serviceIndexId);
    }
  };

  const handleServiceRemove = (file, serviceIndexId) => {
    const key = String(serviceIndexId ?? '');
    if (!file) {
      setServiceAttachments((prev) => ({ ...prev, [key]: [] }));
      return;
    }
    setServiceAttachments((prev) => {
      const current = prev[key] || [];
      const filtered = current.filter((f) => !attachmentMatches(f, file));
      return {
        ...prev,
        [key]: filtered,
      };
    });
    setAvatarUrl((prev) => prev.filter((f) => !attachmentMatches(f, file)));
    setSelectedUploadedImagesService((prev) => pruneAttachmentMapsByFile(prev, file));
  };

  const uploadDesignsDisplayFiles = useMemo(() => {
    const allProductAttachmentFiles = Object.values(productAttachments).flat()
    const allServiceAttachmentFiles = Object.values(serviceAttachments).flat()
    const productAttachmentKeys = new Set(
      allProductAttachmentFiles.map(attachmentFileKey).filter(Boolean),
    )
    const serviceAttachmentKeys = new Set(
      allServiceAttachmentFiles.map(attachmentFileKey).filter(Boolean),
    )
    const getAttachmentId = (file) =>
      file?.id ?? file?.ID ?? file?.attachment_id ?? file?.request_attachment_id ?? null
    const productAttachmentIds = new Set(
      allProductAttachmentFiles
        .map((file) => getAttachmentId(file))
        .filter((id) => id != null)
        .map(String),
    )

    const availableAvatarFiles = (avatarUrl || []).filter((file) => {
      const fileKey = attachmentFileKey(file)
      const attachmentId = getAttachmentId(file)
      if (attachmentId != null && productAttachmentIds.has(String(attachmentId))) {
        return false
      }
      if (file?.product_id != null && file.product_id !== '') {
        return false
      }
      return (
        (!fileKey || !productAttachmentKeys.has(fileKey)) &&
        (!fileKey || !serviceAttachmentKeys.has(fileKey))
      )
    })

    const mapProductAttachmentForDisplay = (file, product) => {
      const productIndexId = file.product_index_id ?? product?.indexId ?? product?.newIndexId
      if (!product) {
        return {
          ...file,
          url: file.url || file.name,
          name: file.name || file.url,
          location_ids: '',
          productNames: [],
          product_index_id: productIndexId,
          _productAttachment: true,
          _groupAttachment: false,
        }
      }
      const location_ids =
        product.location
          ?.map((loc) => loc.id || loc.request_location_id)
          .filter(Boolean)
          .join(',') || ''
      const productName = product.product_name || product.name || ''
      return {
        ...file,
        url: file.url || file.name,
        name: file.name || file.url,
        location_ids,
        productNames: productName
          ? [{ product_id: product.product_id || product.id, product_name: productName }]
          : [],
        product_index_id: productIndexId,
        _productAttachment: true,
        _groupAttachment: false,
      }
    }

    const mapGroupAttachmentForDisplay = (file, groupId, products) => {
      const group = groupedProductsMap.get(String(groupId))
      const groupName =
        group?.name ||
        products[0]?.group_name ||
        products[0]?.groupName ||
        'Group'
      const labelProduct = products[0]
      const productIndexId =
        file.product_index_id ?? labelProduct?.indexId ?? labelProduct?.newIndexId
      const location_ids =
        labelProduct?.location
            ?.map((loc) => loc.id || loc.request_location_id)
            .filter(Boolean)
          .join(',') || 'group'
        return {
          ...file,
          url: file.url || file.name,
          name: file.name || file.url,
        location_ids,
        productNames: [{ product_id: groupId, product_name: groupName }],
          product_index_id: productIndexId,
          _productAttachment: true,
        _groupAttachment: true,
      }
    }

    const productFilesByUrl = new Map()
    allProductAttachmentFiles.forEach((file) => {
      const fileKey = attachmentFileKey(file)
      if (!fileKey) return
      const product = (selectedProducts || []).find(
        (p) => Number(p?.indexId) === Number(file.product_index_id),
      )
      if (!productFilesByUrl.has(fileKey)) {
        productFilesByUrl.set(fileKey, { file, products: [] })
      }
      const entry = productFilesByUrl.get(fileKey)
      if (
        product &&
        !entry.products.some((p) => Number(p.indexId) === Number(product.indexId))
      ) {
        entry.products.push(product)
      }
    })

    const dedupedProductFiles = []
    productFilesByUrl.forEach(({ file, products }) => {
      const fileKey = attachmentFileKey(file)
      const filesForUrl = allProductAttachmentFiles
        .filter((f) => attachmentFileKey(f) === fileKey)
        .filter((f, i, arr) => arr.findIndex((x) => attachmentMatches(x, f)) === i)
      const groupIds = [
        ...new Set(
          products
            .map((p) => resolveProductGroupId(p))
            .filter((gid) => gid != null && gid !== ''),
        ),
      ]
      const isSameGroup =
        groupIds.length === 1 &&
        products.length > 0 &&
        products.every(
          (p) => String(resolveProductGroupId(p) || '') === String(groupIds[0]),
        )
      const shouldShowAsGroup =
        isSameGroup && filesForUrl.length > 1

      if (shouldShowAsGroup) {
        dedupedProductFiles.push(
          mapGroupAttachmentForDisplay(file, groupIds[0], products),
        )
        return
      }

      filesForUrl.forEach((attachmentFile) => {
        const product = (selectedProducts || []).find(
          (p) => Number(p?.indexId) === Number(attachmentFile.product_index_id),
        )
        const gid = resolveProductGroupId(product)
        if (
          gid != null &&
          gid !== '' &&
          filesForUrl.length === 1 &&
          isSameGroup
        ) {
          dedupedProductFiles.push(
            mapGroupAttachmentForDisplay(attachmentFile, gid, products),
          )
        } else {
          dedupedProductFiles.push(
            mapProductAttachmentForDisplay(attachmentFile, product),
          )
        }
      })
    })

    const serviceFiles = allServiceAttachmentFiles.map((file) => {
        const svc =
          additionalSelectedServices?.find(
          (s) =>
            String(s.newIndexId ?? s.indexId) === String(file.service_index_id),
        ) || null
      const serviceName = svc?.name || svc?.service_name || ''
      const serviceIndexId = file.service_index_id ?? svc?.newIndexId ?? svc?.indexId
      const fileUrl = file.url || file.name
        return {
          ...file,
          url: fileUrl,
          name: file.name || fileUrl,
          service_index_id: serviceIndexId,
          serviceNames: serviceName ? [{ service_name: serviceName }] : [],
          _serviceAttachment: true,
          _fileUrl: fileUrl,
      }
    })

    return [...availableAvatarFiles, ...dedupedProductFiles, ...serviceFiles]
  }, [
    productAttachments,
    serviceAttachments,
    avatarUrl,
    selectedProducts,
    groupedProductsMap,
    additionalSelectedServices,
  ])

  const renderProductAttachmentModalContent = (productIndexId) => (
    <Grid
      container
      spacing={3}
      sx={{
        justifyContent: 'center',
        width: '100%',
      }}
    >
      <Grid item xs={12}>
        <Typography variant="h5" sx={{ mb: 2 }}>
          Upload Attachment
        </Typography>
        <Tabs
          value={attachmentTabValue[productIndexId] || 0}
          onChange={(e, newValue) =>
            handleAttachmentTabChange(e, newValue, productIndexId)
          }
          sx={{ mb: 2 }}
        >
          <Tab label="Select from Uploaded" />
          <Tab label="Upload New" />
        </Tabs>

        {(attachmentTabValue[productIndexId] || 0) === 0 ? (
          <Box>
            {(() => {
              const allProductAttachmentFiles = Object.values(productAttachments).flat()
              const allServiceAttachmentFiles = Object.values(serviceAttachments).flat()
              const currentProductAttachments = getProductAttachmentsList(productIndexId)

              const availableAvatarFiles = (avatarUrl || []).filter((file) => {
                return (
                  !allProductAttachmentFiles.some((pfile) => attachmentMatches(pfile, file)) &&
                  !allServiceAttachmentFiles.some((sfile) => attachmentMatches(sfile, file))
                )
              })

              const enrichProductAttachment = (file) => {
                const product = (selectedProducts || []).find(
                  (p) => Number(p?.indexId) === Number(file.product_index_id),
                )
                if (product) {
                  return mapQuotationProductAttachmentForDisplay(
                    file,
                    product,
                    groupedProductsMap,
                  )
                }
                return {
                  ...file,
                  product_index_id: file.product_index_id ?? productIndexId,
                }
              }

              const allFiles = [
                ...availableAvatarFiles,
                ...allProductAttachmentFiles.map(enrichProductAttachment),
                ...currentProductAttachments.map(enrichProductAttachment),
              ]

              const allFilesUnique = (() => {
                const seen = []
                return allFiles.filter((file) => {
                  if (seen.some((f) => attachmentMatches(f, file))) return false
                  seen.push(file)
                  return true
                })
              })()

              if (allFilesUnique.length === 0) {
                return (
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ textAlign: 'center', py: 4 }}
                  >
                    No uploaded files available. Please upload files first.
                  </Typography>
                )
              }

              const groupMemberIds = getGroupMemberIndexIdsByProductIndexId(productIndexId)
              const groupSiblingIndexIdSet =
                groupMemberIds.length > 1
                  ? new Set(groupMemberIds.map(String))
                  : null

              const availableImages = allFilesUnique.filter((file) => {
                const isAddedToOtherProduct = Object.entries(productAttachments).some(
                  ([productId, attachments]) => {
                    if (String(productId) === String(productIndexId)) return false
                    if (groupSiblingIndexIdSet?.has(String(productId))) return false
                    return (
                      attachments &&
                      attachments.some((f) => attachmentMatches(f, file))
                    )
                  },
                )
                const isUsedOnService = Object.values(serviceAttachments).some(
                  (atts) => atts && atts.some((f) => attachmentMatches(f, file)),
                )
                return !isAddedToOtherProduct && !isUsedOnService
              })

              if (availableImages.length === 0) {
                return (
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ textAlign: 'center', py: 4 }}
                  >
                    All images are added to other products. No images left in the uploaded
                    files.
                  </Typography>
                )
              }
              const selectionKey = String(productIndexId)
              const rowSelection =
                selectedUploadedImages[selectionKey] ||
                selectedUploadedImages[productIndexId] ||
                []

              const original = getProductAttachmentsList(productIndexId)
              const toLink = rowSelection.filter((file) => !original.some((orig) => attachmentMatches(orig, file)))
              const toUnlink = original.filter((file) => !rowSelection.some((sel) => attachmentMatches(sel, file)))
              const hasChanges = toLink.length > 0 || toUnlink.length > 0

              return (
                <>
                  <Grid container spacing={2} sx={{ mb: 2 }}>
                    {availableImages.map((file, idx) => {
                      const isSelected = rowSelection.some((f) =>
                        attachmentMatches(f, file),
                      )
                      const isAlreadyAddedToCurrent = original.some((f) => attachmentMatches(f, file))
                      return (
                        <Grid item xs={6} sm={4} md={3} key={idx}>
                          <Card
                            sx={{
                              position: 'relative',
                              border:
                                isSelected ? '2px solid' : '1px solid',
                              borderColor:
                                isSelected
                                  ? 'primary.main'
                                  : 'divider',
                              cursor: 'pointer',
                              opacity: 1,
                            }}
                            onClick={() => {
                              handleImageSelect(file, productIndexId, !isSelected)
                            }}
                          >
                            <Box
                              sx={{
                                position: 'relative',
                                width: '100%',
                                paddingTop: '100%',
                                overflow: 'hidden',
                              }}
                            >
                              {(() => {
                                const url = file.url || file.name
                                const preview = file.preview || url
                                const fileExt = (
                                  file.extension || url.split('.').pop().split('?')[0]
                                ).toLowerCase()
                                const isOffice = [
                                  'doc',
                                  'docx',
                                  'xls',
                                  'xlsx',
                                  'ppt',
                                  'pptx',
                                ].includes(fileExt)
                                const isDesign = ['ai', 'psd', 'eps', 'dwg', 'dxf'].includes(
                                  fileExt,
                                )
                                const isPdf =
                                  file.file_type === 'application/pdf' || fileExt === 'pdf'

                                return isPdf || isOffice || isDesign ? (
                                  <IconButton
                                    onClick={(e) => {
                                      e.stopPropagation()
                                      setPdfLoading(true)
                                      setSelectedPDF(url)
                                      setOpenPDFModal(true)
                                      setUseOfficeViewer(true)
                                    }}
                                    aria-label="open file"
                                    sx={{
                                      position: 'absolute',
                                      top: 0,
                                      left: 0,
                                      width: '100%',
                                      height: '100%',
                                      p: 0,
                                      borderRadius: 0,
                                    }}
                                  >
                                    <Box
                                      component="iframe"
                                      src={
                                        isPdf
                                          ? url
                                          : isOffice
                                          ? `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
                                              url,
                                            )}`
                                          : `https://docs.google.com/gview?url=${encodeURIComponent(
                                              url,
                                            )}&embedded=true`
                                      }
                                      title="File Preview"
                                      frameBorder="0"
                                      // sandbox="allow-scripts allow-same-origin" before it was this caused pdf preview not working and fixed with below code, if any future issues came i have done only the pdf part that will only in me others i will be author
                                      sandbox={isPdf ? undefined : 'allow-scripts allow-same-origin'}
                                      sx={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover',
                                        pointerEvents: 'none',
                                      }}
                                    />
                                  </IconButton>
                                ) : (
                                  <Box
                                    component="img"
                                    src={preview}
                                    alt={file.name || 'Uploaded file'}
                                    sx={{
                                      position: 'absolute',
                                      top: 0,
                                      left: 0,
                                      width: '100%',
                                      height: '100%',
                                      objectFit: 'cover',
                                    }}
                                    onError={(e) => {
                                      if (preview !== url) {
                                        e.target.src = url
                                      }
                                    }}
                                  />
                                )
                              })()}
                              <AttachmentDownloadIconButton
                                file={file}
                                fileIndex={idx}
                                hidden={isClient || userType === 3}
                                sx={{
                                  position: 'absolute',
                                  top: 4,
                                  left: 4,
                                  zIndex: 2,
                                }}
                              />
                              <Checkbox
                                checked={isSelected}
                                sx={{
                                  position: 'absolute',
                                  top: 4,
                                  right: 4,
                                  zIndex: 3,
                                  bgcolor: 'rgba(255, 255, 255, 0.8)',
                                }}
                                onChange={(e) => {
                                  e.stopPropagation();
                                  handleImageSelect(file, productIndexId, e.target.checked);
                                }}
                              />
                              {isAlreadyAddedToCurrent && isSelected && (
                                <Chip
                                  label="Added"
                                  size="small"
                                  color="success"
                                  sx={{
                                    position: 'absolute',
                                    bottom: 4,
                                    left: 4,
                                  }}
                                />
                              )}
                            </Box>
                          </Card>
                        </Grid>
                      )
                    })}
                  </Grid>
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                    <AttachmentDownloadAllButton
                      files={rowSelection}
                      allFiles={availableImages}
                      onToggleSelectAll={(checked) => {
                        const key = String(productIndexId)
                        setSelectedUploadedImages((prev) => ({
                          ...prev,
                          [key]: checked ? [...availableImages] : [],
                          [productIndexId]: checked ? [...availableImages] : [],
                        }))
                      }}
                      label="Download Selected"
                      hidden={isClient || userType === 3}
                    />
                    <Button
                      variant="contained"
                      onClick={() => handleAddSelectedImages(productIndexId)}
                      disabled={!hasChanges}
                    >
                      Save Selection ({rowSelection.length})
                    </Button>
                  </Box>
                </>
              )
            })()}
          </Box>
        ) : (
          <UploadMultiFile
            showPreview
            multiple={true}
            maxSize={1024 * 1024 * 1024}
            files={getProductAttachmentsList(productIndexId).map((file) =>
              enrichQuotationAttachmentForDisplay(
                file,
                productIndexId,
                selectedProducts,
                groupedProductsMap,
              ),
            )}
            onDrop={(acceptedFiles) => handleProductDrop(acceptedFiles, productIndexId)}
            onRemove={(file) => handleProductRemove(file, productIndexId)}
            onRemoveAll={() => handleProductRemove(null, productIndexId)}
            isUploading={isUploadingProduct[productIndexId] || false}
            showProductLabels
          />
        )}
      </Grid>
    </Grid>
  )

const ACCOUNT_TABS = [
  {
    value: `${user.isVendor ? '' : isProposal ? 'Proposal ' : 'Estimate '}Details`,
    component: details ? (
      <ViewRequest
        teamMembers={teamMembers}
        fromQtuotation={true}
        clientDetails={invoice}
        products={invoice?.cust_product}
        fetchRequestDetails={fetchRequestDetails}
        user={user}
        designs={designs}
        setDesigns={setDesigns}
        details={details}
        isRequest={true}
        requestId={id}
        signAgreements={signAgreements}
        customTemplate={customTemplate}
        questionnaireTemplate={questionnaireTemplate}
        allDataEmpty={allDataEmpty}
        portfolio={portfolio}
        invoice={invoice}
        quotation={1}
        setRenderCards={setRenderCards}
        renderCards={renderCards}
        rfpServicesEdit={rfpServicesEdit}
        requestServices={requestServices}
        labourInstallService={labourInstallService}
        isEstimate={true}
        explodedPermissions={explodedPermissions}
        productsWithLocation={invoice?.cust_product_location}
        designersList={designersList}
        allTeamMembers={allTeamMembers}
        onlineUsers={onlineUsers}
        hasViewCostPermission={hasViewCostPermission}
        taxRateData={taxRateData}
        taxAmount={taxAmount}
      />
    ) : "",
  },
...((user.user_type === 3 || isAdminUser (user.user_type) || explodedPermissions?.some((permission) => ['View Estimate Client Message Board','Access Estimate Client Message Board'].includes(permission))) ? [
  {
    value: 'client message board',
    component: (
      <PublicMessageBoard
        products={invoice?.cust_product}
        requestDetails={details}
        requestId={id}
        acceptedClients={acceptedClients}
        accessPublicMessageBoard={accessPublicMessageBoard}

      />
    ),
  }
] : []),
  // ...(user.isVendor ? [] : [
  //   {
  //     value: 'change order',
  //     component: <RequestTabUpdates updates={updates?.length > 0 ? updates : []} />,
  //   },
  //   {
  //     value: 'payments',
  //     component: <PaymentRequest totalValue={invoice?.total} />,
  //   },
    {
      value: 'Locations and Notes',
      component: <Locations products={invoice?.cust_product} designs={designs} />,
    },
    ...(details?.design_order_id && user.isVendor
      ? []
      : [
          {
            value: 'Job Notes',
            component: (
              <Card sx={{ height: '72vh', display: 'flex' }}>
                <JobNoteWindow
                  products={invoice?.cust_product}
                  allUser={jobNoteMembers}
                  requestIdd={id}
                  designOrderId={details?.design_order_id || null}
                  requestDetails={details}
                  fromDesign={false}
                  isDesignOrder={false}
                  renderCards={renderCards}
                  setRenderCards={setRenderCards}
                  fetchRequestDetails={fetchRequestDetails}
                  details={details}
                  noteType="job"
                />
              </Card>
            ),
          },
          {
            value: 'Design Notes',
            component: (
              <Card sx={{ height: '72vh', display: 'flex' }}>
                <JobNoteWindow
                  products={invoice?.cust_product}
                  allUser={jobNoteMembers}
                  requestIdd={id}
                  designOrderId={details?.design_order_id || null}
                  requestDetails={details}
                  fromDesign={true}
                  isDesignOrder={false}
                  renderCards={renderCards}
                  setRenderCards={setRenderCards}
                  fetchRequestDetails={fetchRequestDetails}
                  details={details}
                  noteType="design"
                />
              </Card>
            ),
          },
        ]),
    ...(user.isVendor ? [] : [
      {
        // value: 'change order',
        value: 'Job Log',
        component: <RequestTabUpdates updates={updates?.length > 0 ? updates : []} details={details} searchable onSearchUpdates={handleJobLogSearch} />,
      },
    ]),
    ...(!details?.map_service ? [] : [
      {
        value: 'Route - Map Services',
        component: <RouteMap details={details} id={id} route_id={details?.map_service} />,
      },
    ]),
  // ...(userType === 3 ? (user.isVendor ? [
  //   {
  //     value: 'My Proposal',
  //     component: <Proposals setReloadData={() => setRefresh(!refresh)} acceptedClients={acceptedClients} proposalData={proposalData} />,
  //   },
  // ] : []) : [
  //   {
  //     value: 'Proposals',
  //     component: <Proposals setReloadData={() => setRefresh(!refresh)} acceptedClients={acceptedClients} proposalData={proposalData} />,
  //   },
  // ]),
];

const handleDeleteService = (servId, indexId) => {
  const lineIndex = Number(indexId)
  const matchesDeletedLine = (data) => {
    const rowIndex = Number(data?.newIndexId ?? data?.indexId ?? data?.product_index)
    if (data?.isAdditionalProduct) {
      return !Number.isFinite(lineIndex) || rowIndex !== lineIndex
    }
    if (!Number.isFinite(lineIndex)) {
      return data.id != servId
    }
    return !(data.id == servId && rowIndex === lineIndex)
  }
  const filtered = (additionalSelectedServices || []).filter(matchesDeletedLine)
  const sorted = sortServicesByProductIndex(filtered)
  const indexIdMap = buildServiceIndexMapping(sorted)
  const resettedIndexIds = sorted.map((service, idx) => {
    const lineNum = idx + 1
    return {
      ...service,
      indexId: lineNum,
      newIndexId: lineNum,
      product_index: lineNum,
    }
  })
  const deletedItems = (additionalSelectedServices || []).filter((s) => !matchesDeletedLine(s))
  const tableServices = resettedIndexIds.filter((s) => !isEstimateCatalogServiceRow(s))
  const remainingCatalog = resettedIndexIds.filter(isEstimateCatalogServiceRow)
  setEstimateCatalogServices(remainingCatalog)
  if (remainingCatalog.length === 0) {
    setSelectedEstimators([])
    // if (deletedItems.some(isEstimateCatalogServiceRow)) {
    //   estimateServiceAutofillDoneRef.current = true
    // }
  }
  setIndexCounterService(tableServices.length || 0)

  const matchesDeletedServiceRow = (row) => {
    const rowIndex = Number(row?.indexId)
    const rowBackendId = row?.backendId ?? row?.id
    if (
      deletedItems.some(
        (d) =>
          rowBackendId != null &&
          (d.id == rowBackendId || d.backendId == rowBackendId),
      )
    ) {
      return true
    }
    if (
      deletedItems.some((d) => {
        const dIdx = Number(d?.newIndexId ?? d?.indexId ?? d?.product_index)
        return Number.isFinite(dIdx) && rowIndex === dIdx
      })
    ) {
      return true
    }
    if (servId != null && servId !== '' && rowBackendId == servId) {
      return true
    }
    return Number.isFinite(lineIndex) && rowIndex === lineIndex
  }

  setServiceRows((prevRows) => {
    const remaining = (prevRows || []).filter((row) => !matchesDeletedServiceRow(row))
    const emptyRow = {
      indexId: 1,
      service_name: '',
      service_desc: '',
      price: 0,
      retail_price: 0,
      is_service_row: 1,
      backendId: null,
      facility_id: currentFacilityId,
    }
    if (remaining.length === 0 || remaining.every((r) => !(r.service_name || '').trim())) {
      setTimeout(() => setServiceRowsIndexCounter(1), 0)
      return [emptyRow]
    }
    const synced = remaining.map((row) => {
      const rowBackendId = row?.backendId ?? row?.id
      const match = tableServices.find(
        (s) =>
          rowBackendId != null &&
          (s.id == rowBackendId || s.backendId == rowBackendId),
      )
      if (match) {
        const lineNum = match.newIndexId ?? match.indexId
        return { ...row, indexId: lineNum }
      }
      return row
    })
    setTimeout(() => setServiceRowsIndexCounter(synced.length), 0)
    return synced
  })

  const remapKeyedByIndexMap = (prev) => {
    const next = {}
    Object.keys(prev || {}).forEach((oldKey) => {
      const mapped = indexIdMap[String(oldKey)]
      if (mapped !== undefined) {
        next[String(mapped)] = prev[oldKey]
      }
    })
    return next
  }

  setServiceAttachments((prev) => {
    const next = {}
    Object.keys(prev || {}).forEach((oldKey) => {
      const newKey = indexIdMap[String(oldKey)]
      if (newKey !== undefined && prev[oldKey]?.length) {
        next[String(newKey)] = prev[oldKey].map((f) => ({
          ...f,
          service_index_id: String(newKey),
        }))
      }
    })
    return next
  })
  setOpenServiceAttachment((prev) => remapKeyedByIndexMap(prev))
  setAttachmentTabValueService((prev) => remapKeyedByIndexMap(prev))
  setSelectedUploadedImagesService((prev) => remapKeyedByIndexMap(prev))
  setIsUploadingService((prev) => remapKeyedByIndexMap(prev))
  setOpenServiceNote((prev) => remapKeyedByIndexMap(prev))
  setServiceRowErrors((prev) => {
    const next = {}
    Object.keys(prev || {}).forEach((oldKey) => {
      const mapped = indexIdMap[String(oldKey)]
      if (mapped !== undefined) {
        next[mapped] = prev[oldKey]
      }
    })
    return next
  })

  setFieldValue('services', tableServices)
  setAdditionalSelectedServices(tableServices)
  if (openEdit && !hasUnsavedChanges) {
    setHasUnsavedChanges(true);
    if (typeof onDataChange === 'function') {
      onDataChange();
    }
  }
};
useEffect(()=>{
  if(selectedProducts.length<=0){
    setAllLocationSame(false)
  }
   },[selectedProducts])
const handleCancel = async (isEdit) =>{
  console.log("isEdit++++++++isEdit",isEdit)
  console.log("isEdit++++++++edit",edit)
  // setOpenEdit(false)
  // setIsOpen(false)
  setCurrentRFQdata({})
  // resetForm();
  setSelectedProducts([])
  setSelectedMapserviceProducts([]);
  setSelectedServices([]);
  setAdditionalSelectedServices([])
  setFilteredServices([])
  setProductAttachments({})
  setServiceAttachments({})
  fetchRequestDetails()
  setAllLocationSame(false)
  if(popupOn && !isEdit ){
    closeAfterSave()
  // setRenderCards(!renderCards)
  }
  if ((isEdit && edit) || (isEdit === undefined && edit)) {
    if(popupOn){
      closeView()
    }
      // else{
      //   navigate(`/dashboard/quick-bid`)
      // }
  } else if (isEdit && !edit) {
    if(popupOn){setIsOpen(false);}
    // else{
    //   navigate(`/dashboard/quick-bid`)
    // }
  }
  if(edit){
    edit=false
    if (typeof setOpenEdit === 'function') {
      setOpenEdit(false)
    }
  setIsOpen(false)
  }
  if(!popupOn && !isEdit){
    if (isFromProjects && location.state?.projectId) {
      navigate(`/dashboard/quick-bid/jobs/view-estimate-job/${location.state.projectId}`, {
        state: { currentTab: location.state?.currentTab },
      })
    } else if (isFromEstimateCalendar) {
      navigate(location.state?.fromPcb ? ROOTS_PCB : PATH_DASHBOARD.quotation.calendar, { replace: true })
    } else {
      navigate(PATH_DASHBOARD.quotation.root)
    }
  }
   if (typeof setOpenEdit === 'function') {
     setOpenEdit(false)
   }
  setIsOpen(false)
  setHasUnsavedChanges(false)
}

  // Design→estimate (write products): form opens before a job exists. Cancel must warn only in that case.
  const isCancelWithoutCreatingJobCase = () =>
    Number(details?.isFromDesignOrder) === 1 &&
    Number(details?.is_request_estimate) === 1 &&
    !details?.estimate_job_status

  const clearDesignConvertNavState = () => {
    if (location.state?.fromDesignConvert) {
      navigate(location.pathname, { replace: true, state: {} })
    }
  }

  const exitEstimateEditWithoutSave = () => {
    clearDesignConvertNavState()
    if (openEdit) {
      if (typeof setOpenEdit === 'function') {
        setOpenEdit(false)
      }
      setHasUnsavedChanges(false)
    } else {
      handleCancel()
    }
  }

  const handleCancelClick = () => {
    if (openEdit && isCancelWithoutCreatingJobCase()) {
      setOpenCancelNoJobConfirm(true)
      return
    }
    exitEstimateEditWithoutSave()
  }

  const confirmCancelWithoutJob = () => {
    setOpenCancelNoJobConfirm(false)
    exitEstimateEditWithoutSave()
  }

  useEffect(() => {
    if (!popupOn || !headerStepBackRef) {
      return undefined;
    }
    const openedAsEditIntent = isEditEstimate === true || isEditEstimate === 'true';
    headerStepBackRef.current = () => {
      if (openEdit) {
        if (isCancelWithoutCreatingJobCase()) {
          setOpenCancelNoJobConfirm(true);
          return true;
        }
        if (typeof setOpenEdit === 'function') {
          setOpenEdit(false);
        }
        setHasUnsavedChanges(false);
        return true;
      }
      if (openedAsEditIntent) {
        onExitEstimateEditMode?.();
        return true;
      }
      return false;
    };
    return () => {
      headerStepBackRef.current = () => false;
    };
  }, [popupOn, openEdit, isEditEstimate, onExitEstimateEditMode, headerStepBackRef, details?.isFromDesignOrder, details?.is_request_estimate, details?.estimate_job_status]);

// Filter selected products based on facility selection
const filterSelectedProductsByFacility = (selectedFacilities) => {
  if (!selectedFacilities || selectedFacilities.length === 0) {
    return [];
  }

  // Get selected facility IDs
  const selectedFacilityIds = selectedFacilities.map(facility => Number(facility.id));
  
  return selectedProducts.filter(product => {
    // If product has no facility_id (undefined/null), it belongs to Arizona (default)
    const productFacilityId = product.facility_id === undefined || product.facility_id === null ? 1 : Number(product.facility_id);
    
    // Keep product if its facility is in the selected facilities
    return selectedFacilityIds.includes(productFacilityId);
  });
};


// Filtered product options based on facility and other criteria
const filteredProductOptions = useMemo(() => {
  const filtered = (allProducts || []).filter((option) => {
    // Facility-based filtering for split orders
    if (isSplitOrder) {
      const selectedFacilities = values?.facility_type || [];
      if (selectedFacilities.length === 0) {
        // If no facility is chosen (empty array), return empty 
        return false;
      }
      
      // Get selected facility IDs
      const selectedIds = new Set(selectedFacilities.map(f => Number(f.id)));
      
      // Check if product's facility matches selected facilities
      const facilityMatch = selectedIds.has(Number(option.facility_id));
      if (!facilityMatch) return false;

      const splitCatalogType = values?.split_catalog_type;

      // For split orders, use split catalog type for filtering
      if (splitCatalogType) {
        // If "All" is selected, show all products regardless of inhouse value
        if (splitCatalogType?.id === 'all') {
          // For current facility, exclude inhouse === 6 (Split Catalog)
          if (Number(option.facility_id) === currentFacilityId) {
            return option.inhouse !== 6;
          }
          return true;
        }
        // Otherwise, filter based on the selected split catalog type
        if (splitCatalogType?.inhouse === 4) {
          return option.inhouse === 4;
        } else if (splitCatalogType?.inhouse === 5) {
          return option.inhouse === 5;
        } else if (splitCatalogType?.inhouse === 1) {
          return option.inhouse === 1;
        } else if (splitCatalogType?.inhouse === 6) {
          // Only show Split Catalog for other facilities, not current facility
          return option.inhouse === 6 && Number(option.facility_id) !== currentFacilityId;
        } else if (splitCatalogType?.isTrafficCatalog) {
          return option.isTrafficCatalog === 1;
        }
        return true; // Default to show all for split orders
      }

      // For current facility (facility_id matches currentFacilityId), show only inhouse == 1, 4, 5 (exclude 6)
      if (Number(option.facility_id) === currentFacilityId) {
        return (option.inhouse === 1 || option.inhouse === 5 || option.inhouse === 4);
      }
      
      // For other facilities, show inhouse == 1, 4, 5, 6
      return (option.inhouse === 1 || option.inhouse === 5 || option.inhouse === 4 || option.inhouse === 6);
    }else{
      const selectedFacilities = FacilityTypes.filter((f) => Number(f.id) === Number(currentFacilityId));
      if (selectedFacilities.length === 0) return false;
      const selectedIds = new Set(selectedFacilities.map((f) => Number(f.id)));
      const facilityMatch = selectedIds.has(Number(option.facility_id));
      if (!facilityMatch) return false;
    }

    // For normal orders, check split_catalog_type if it's set
    if (!isSplitOrder && values?.split_catalog_type) {
      const normalCatalogType = values.split_catalog_type;
      // If "All" is selected, show all products except split catalog
      if (normalCatalogType?.id === 'all') {
        return option.inhouse !== 6;
      }
      // Otherwise, filter based on the selected catalog type
      // Check isTrafficCatalog first before inhouse === 1 to avoid conflicts
      if (normalCatalogType?.isTrafficCatalog) {
        return option.isTrafficCatalog === 1;
      } else if (normalCatalogType?.inhouse === 4) {
        return option.inhouse === 4;
      } else if (normalCatalogType?.inhouse === 5) {
        return option.inhouse === 5;
      } else if (normalCatalogType?.inhouse === 1) {
        return option.inhouse === 1 && option.isTrafficCatalog !== 1; // Production Catalog (inhouse 1 but not traffic)
      } else if (normalCatalogType?.inhouse === 0) {
        return option.inhouse === 0; // Sub Contract
      } else if (normalCatalogType?.inhouse === 7) {
        return option.inhouse === 7; // Estimate Catalog
      }
      // If no match, exclude split catalog
      return option.inhouse !== 6;
    }

    // Default filtering for non-split orders
    return (option.inhouse === 1 || option.inhouse === 5 || option.inhouse === 4 || option.inhouse === 0);
  });

  // Sort in strict alphanumeric order based on description and name only (ignore suffix)
  return filtered.sort((a, b) => {
    const getSortKey = (option) => {
      const name = (option.name || '').trim();
      const description = (option.description || '').trim();
      // Sort by description first, then by name for strict alphanumeric order
      const sortString = `${name}`.trim();
      return sortString;
    };

    const keyA = getSortKey(a);
    const keyB = getSortKey(b);
    
    // Strict alphanumeric sort: case-insensitive with natural numeric ordering
    return keyA.localeCompare(keyB, undefined, { 
      numeric: true, 
      sensitivity: 'base' 
    });
  });
}, [allProducts, values?.facility_type, values?.split_catalog_type, isSplitOrder, currentFacilityId]);

console.log("values++++++++",values)
console.log('selectedProductsselectedProducts',selectedProducts)
const selectedProductsAdditionalCost = selectedProducts?.filter(item=>item?.isAdditionalProduct == true)
?.reduce((total, item) => total + (item.product_total || 0), 0)
?.toFixed(2)

// const selectedProductsAdditionalCost = useMemo(() => {
//   console.log('selectedProductsselectedProducts',selectedProducts)
//   return selectedProducts
//     ?.filter(item => item?.isAdditionalProduct)
//     ?.reduce((total, item) => total + (parseFloat(item.product_total) || 0), 0)
//     ?.toFixed(2);
// }, [selectedProducts]);

console.log("#123123######openServiceNote-------", openServiceNote);
console.log("#123123######selectedServices-------", selectedServices);
console.log("#123123######additionalSelectedServices-------", additionalSelectedServices);
// const selectedMaterialSubTotal = selectedMaterials //?.filter(item=>item?.isAdditionalProduct == true)
// ?.reduce((total, item) => total + ((item.markUpCost  || 0) * (item.quantity || 0)), 0)
// ?.toFixed(2)

const selectedMaterialSubTotal = selectedMaterials //?.filter(item=>item?.isAdditionalProduct == true)
?.reduce((total, item) => total + (((item.markUpCost + (item.adj_value_type ? Number(item.adjustment || 0) : -Number(item.adjustment || 0))) || 0) * (item.quantity || 0)), 0)
?.toFixed(2)

let totalMarkup = 0;
let totalServiceMarkup = 0;
let originaltotalMarkup = 0
  let originaltotalServiceMarkup=0
let totalAmount = 0;

// Ensure that 'values.sign_agreement' is either a string or an array before using it.
const selectedAgreements = agreements.filter(agreement => {
  // Check if 'values.sign_agreement' is a string or an array
  const selectedIds = Array.isArray(values.sign_agreement)
    ? values.sign_agreement
    : (values.sign_agreement || '').split(',').map(Number);

  return selectedIds.includes(agreement.id);
});

  const [pdfs, setPdfs] = useState([]);
  console.log('setPdfs', pdfs);
  useEffect(() => {
    if (invoice?.sign_agreements) {
      // Filter out sign agreements that have a valid PDF path
      const filteredPdfs = invoice.sign_agreements
        .filter(agr => agr.agreement_pdf_path || agr.attachment) // Check if either agreement_pdf_path or attachment is not null
        .map(agr => {
          let pdfPath = agr.agreement_pdf_path || agr.attachment;
          if (pdfPath && !pdfPath.startsWith('http')) {
            pdfPath = `${REST_API}${pdfPath}`;
          }

          // Assuming agr.image_paths is a comma-separated string of image URLs
          const imagePaths = agr.image_paths ? agr.image_paths.split(',') : [];

          return {
            name: agr.name,
            pdfPath: pdfPath,
            imagePaths: imagePaths // Store the image paths in the object
          };
        });

      setPdfs(filteredPdfs);
      setLoading(false);
    }
  }, [invoice]);

  const getProductGroupId = (product) => product?.group_id ?? product?.customer_order_product_group_id ?? product?.groupId ?? null;

  const getProductLineTotalExcludingInstall = (product) => {
    const quantity = Number(product?.quantity) || 1
    const locationQuantity = Number(product?.locationQuantity) || 1
    const installCost = Number(product?.install_cost) || 0
    let spma = Number(product?.product_retail_price || 0)
    if (Number(product?.material) === 1) {
      const adjustment = Number(product?.adjustment || 0)
      spma += Number(product?.adj_value_type) === 1 ? adjustment : -adjustment
    }
    if (installCost) {
      return (Number(product?.actual_retail_price) || 0) * (locationQuantity * quantity)
    }
    if (Number(product?.material) === 1) {
      return spma * locationQuantity
    }
    return spma * (locationQuantity * quantity)
  }

  const getProductDisplayTotal = (product) => {
    const quantity = Number(product?.quantity) || 1
    const locationQuantity = Number(product?.locationQuantity) || 1
    const installQty = Number(product?.install_qty ?? product?.install_quantity ?? 1) || 1
    const installCost = Number(product?.install_cost) || 0
    let spma = Number(product?.product_retail_price || 0)
    if (Number(product?.material) === 1) {
      const adjustment = Number(product?.adjustment || 0)
      spma += Number(product?.adj_value_type) === 1 ? adjustment : -adjustment
    }
    const productTotal = installCost
      ? (Number(product?.actual_retail_price) || 0) * (locationQuantity * quantity)
      : Number(product?.material) === 1
      ? spma * locationQuantity
      : spma * (locationQuantity * quantity)
    const installTotal = installCost * installQty
    return Number(productTotal || 0) + Number(installTotal || 0)
  }

  const groupedInvoiceDisplayRows = React.useMemo(() => {
    const sourceProducts =
      (selectedProducts?.length ? selectedProducts : invoice?.cust_product) || []
    const rows = buildGroupedDesignOrderDisplayRows({
      designOrderProducts: sourceProducts,
      customerOrderProductGroups,
      markupType,
      groupProductMarketingValues,
      groupInstallMarketingValues,
    })
    const isMaterialRow = (row) =>
      row?.__type === 'group'
        ? Number(row?.representative?.material) === 1
        : Number(row?.material) === 1
    return rows.sort((a, b) => Number(isMaterialRow(a)) - Number(isMaterialRow(b)))
  }, [
    selectedProducts,
    invoice?.cust_product,
    customerOrderProductGroups,
    markupType,
    groupProductMarketingValues,
    groupInstallMarketingValues,
  ])

  const getInvoiceModalNonGroupProductTotal = React.useCallback((val) => {
    const {
      markAdjType,
      material = 0,
      adjustment = 0,
      adj_value_type,
      actual_retail_price,
      product_retail_price,
      locationQuantity = 1,
      quantity = 1,
    } = val
    const basePrice =
      actual_retail_price !== 0 && actual_retail_price != null
        ? actual_retail_price
        : product_retail_price
    let SPMA = markAdjType === 2 || markAdjType === 3 ? basePrice : basePrice
    if (material === 1) {
      SPMA = Number(SPMA) + (Number(adj_value_type) === 1 ? Number(adjustment) : -Number(adjustment))
    }
    if (markAdjType === 1 && material === 0) {
      return SPMA * (locationQuantity * quantity)
    }
    return material === 1 ? SPMA * locationQuantity : SPMA * (locationQuantity * quantity)
  }, [])

  const invoiceModalProductTotalFromRows = React.useMemo(
    () =>
      (groupedInvoiceDisplayRows || []).reduce((sum, row) => {
        if (row?.__type === 'group') {
          const groupHasInstall = Boolean(row?.groupHasInstall)
          return (
            sum +
            (groupHasInstall ? Number(row?.groupProductOnlyTotal ?? 0) : Number(row?.totalValue ?? 0))
          )
        }
        return sum + getInvoiceModalNonGroupProductTotal(row)
      }, 0),
    [groupedInvoiceDisplayRows, getInvoiceModalNonGroupProductTotal],
  )

  const invoiceModalInstallTotalFromRows = React.useMemo(
    () =>
      (groupedInvoiceDisplayRows || []).reduce((sum, row) => {
        if (row?.__type === 'group') {
          return sum + Number(row?.groupInstallSubtotal ?? 0)
        }
        const installCost = parseFloat(row?.install_cost || 0)
        const qty = parseFloat(row?.install_qty ?? row?.install_quantity ?? 1) || 1
        if (installCost) return sum + installCost * qty
        return sum
      }, 0),
    [groupedInvoiceDisplayRows],
  )

  const invoiceModalCustProductSubtotalForServices = React.useMemo(
    () => invoiceModalProductTotalFromRows + invoiceModalInstallTotalFromRows,
    [invoiceModalProductTotalFromRows, invoiceModalInstallTotalFromRows],
  )

  const invoiceModalAdditionalServices = React.useMemo(() => {
    if (openEdit) {
      return sortServicesByProductIndex([
        ...(additionalSelectedServices || []),
        ...(estimateCatalogServices || []),
      ])
    }
    return sortServicesByProductIndex(
      (requestServices || []).filter((item) => item?.recipe_id === null),
    )
  }, [openEdit, additionalSelectedServices, estimateCatalogServices, requestServices])

  const displayAdditionalServicesForView = React.useMemo(
    () =>
      sortServicesByProductIndex([
        ...(additionalSelectedServices || []),
        ...(estimateCatalogServices || []),
      ]),
    [additionalSelectedServices, estimateCatalogServices],
  )

    const handleOpenProductFormula= async(id)=>{
    console.log("product formula ",selectedProducts);
    console.log("id........",id);
    setSelectedProductFormulaId(id);
    setOpenProductFormulaModal(true);
  }
  return (
    <Page title={COMPANY_NAME || "View Estimate: View | Sign Wise Solutions"}>
    
  {/* Transparent overlay loader for quotation status */}
  {!details?.quotation_status && (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        backdropFilter: 'blur(2px)',
        zIndex: 9999,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        gap: 2
      }}
    >
      <CircularProgress size={60} thickness={4} />
      <Typography variant="h6" color="primary" sx={{ fontWeight: 500 }}>
        Loading Estimate Details...
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Please wait while we fetch the estimate information
      </Typography>
    </Box>
  )}

  {createJob && (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        backdropFilter: 'blur(2px)',
        zIndex: 9999,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        gap: 2
      }}
    >
      <CircularProgress size={60} thickness={4} />
      <Typography variant="h6" color="primary" sx={{ fontWeight: 500 }}>
        {isUpdating ? 'Updating Estimate Job...' : 'Creating Estimate Job...'}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {isUpdating
          ? 'Please wait while we update the estimate information'
          : 'Please wait while we fetch the estimate information'}
      </Typography>
    </Box>
  )}

  {loading ?
    <Stack sx={{display:'flex',justifyContent:'center',alignItems:'center',alignContent:'center',mt:8}} >
      <LoadingScreen />
    </Stack>:

      <Container>
      
      
        <Button
          variant="outlined"
          type="submit"
          // onClick={()=>navigate(PATH_DASHBOARD.official.root)}
          onClick={() => {
            // No auto-save on Back – exit edit (with design-convert no-job confirm when needed).
            handleCancelClick();
          }}
          sx={{ alignItems: 'flex-end',mt:3 , mb: 4 }}
          startIcon={ // Use the startIcon prop to add an icon to the left
            <Stack>
              <KeyboardBackspaceOutlined/>
            </Stack>

          }
        >
          Back
        </Button>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >         
          <HeaderBreadcrumbs
            heading={details?.name}
          />
          {!openEdit && (
            <Stack marginBottom={5} flexDirection={'column'}>
              <Stack direction={'row'} alignItems={'center'} spacing={1}>
                {(user.isVendor===1 && proposalData && !proposalData?.length>0) &&( <Button 
                  size="small"
                  variant="contained"
                  disabled={explodedPermissions?.some(permission => ['Submit Proposal'].includes(permission)) ? false : true}
                  onClick={()=>setAddProposal(true)}
                  sx={{ height: 34 }}
                  startIcon={<Icon icon={plusFill} />}
                >
                Submit Proposal
                </Button>)}
                </Stack>
              {/* {(userType!=3) && details && details?.quotation !== 0  ?  */}
              
              {((userType!=3) && details && details?.quotation !== 0 || (userType ==3 && (details?.quotation_status == 2 || (details?.quotation_status == 9 && details?.send_to_client != 0)))) ? 
              <Stack>
                <Stack flexDirection={'row'} gap={2}>
                  {((details?.quotation_status !== 6 && details?.quotation_status !== 11 && details?.is_request_estimate == 0) || (details?.quotation_status !== 6 && details?.quotation_status !== 11 && details?.is_request_estimate == 1)) && empty(details?.installationStatus) && empty(projectEstimate) &&(
                    (details?.quotation_status == 3 && (details?.estimate_job_status == 2))  ? // details?.estimate_job_status == 3 || 
                      <>
                        {/* <Button
                          sx={{
                            backgroundColor: '#1ccaff',
                          }}
                          variant='contained'
                          onClick={()=>{(explodedPermissions?.some(permission => ['Edit Estimate'].includes(permission))) ? 
                            handleEditEstimateClick() : 
                            (enqueueSnackbar("Access Denied: You do not have sufficient permissions", { variant: 'error' }))
                          }}
                          startIcon={<Icon icon={ details?.is_create_estimate == 1 ? editFill : plusFill} width={20} height={20} />}
                        >
                          {details?.is_create_estimate == 1 ? 'Edit Estimate' : 'Create Estimate'}
                        </Button> */}
                      </>
                    :
                    (() => {
                      const draftSource = Number(details?.draft_source || 0);
                      const isEstimateDraft = details?.is_draft === 1 && draftSource === 1;
                      const isEstimateJobDraft = details?.is_draft === 1 && draftSource === 2;
                      const hideEditForCreateEstimateJob =
                        details?.is_create_estimate == 1 &&
                        details?.quotation_status != 3 &&
                        details?.estimate_job_status == 1 &&
                        empty(projectEstimate) &&
                        !isEstimateDraft;
                      const hideEdit =
                        isEstimateJobDraft ||
                        hideEditForCreateEstimateJob ||
                        Number(details?.quotation_status) === 12;
                      if (hideEdit) return '';
                      return (
                    <Tooltip title={
                      isLoadingProducts
                        ? "Loading products, services, materials and Proposals..."
                        : isManagerApproveRejectStage
                        ? "Cannot edit while awaiting manager approval"
                        : "Edit"
                    }>
                      <span>
                        <IconButton 
                         sx={{
                          backgroundColor: theme.palette.mode === 'light' ? "#BDBDBD" : theme.palette.divider,
                          opacity: isManagerApproveRejectStage ? 0.5 : 1,
                          '&:hover': {
                            backgroundColor: theme.palette.mode === 'light' ? "#858585" : theme.palette.divider
                          }
                        }}
                          onClick={()=>{
                            if (isManagerApproveRejectStage) {
                              enqueueSnackbar('You cannot edit at this stage. Estimate is awaiting manager approval.', { variant: 'warning' });
                              return;
                            }
                            (explodedPermissions?.some(permission => ['Edit Estimate'].includes(permission)))
                              ? handleEditClick()
                              : !empty(details?.installationStatus)
                              ? (enqueueSnackbar("Access Denied: Moved to Installation Phase", { variant: 'error' }))
                              : (enqueueSnackbar("Access Denied: You do not have sufficient permissions", { variant: 'error' }))
                          }}
                          disabled={isLoadingProducts}
                        >
                            {isLoadingProducts ? (
                              <CircularProgress size={24} sx={{ color: '#ffffff' }} />
                            ) : (
                              <Icon icon={editFill} width={24} height={24} color="#ffffff"/>
                            )}
                        </IconButton>
                      </span>
                    </Tooltip>
                      );
                    })()
                  )}
                      {((details?.quotation_status !== 6 && details?.quotation_status !== 11 && details?.is_request_estimate == 0) ||
                        (details?.quotation_status !== 6 && details?.quotation_status !== 11 && details?.is_request_estimate == 1)) &&
                        empty(details?.installationStatus) &&
                        (details?.quotation_status == 3 && details?.estimate_job_status == 2) ?
                        explodedPermissions?.some(permission => ['Create Request', 'Edit Request', 'Delete request'].includes(permission)) && (
                          <AnimatedButton
                            title={'Duplicate Estimate'}
                            onClick={() => {
                              setOpenDuplicate(true)
                              setSettingsAnchorEl(null)
                              // handleDuplicateSalesOrder()
                            }}
                          />
                        )
                        : ''
                      }

                  {empty(projectEstimate) && <Tooltip title="Delete">
                    <IconButton
                      sx={{
                        backgroundColor: theme.palette.mode === 'light' ? "#BDBDBD" : theme.palette.divider,
                        '&:hover': {
                          backgroundColor: theme.palette.mode === 'light' ? "#858585" : theme.palette.divider
                        }
                      }}
                       onClick={()=>{(explodedPermissions?.some(permission => ['Delete Estimate'].includes(permission))) ? handleDeleteMenu() : (enqueueSnackbar("Access Denied: You do not have sufficient permissions", { variant: 'error' }))}} >
                        <Icon icon={trash2Outline} width={24} height={24} color="#ffffff"/>
                    </IconButton>
                  </Tooltip> }

                  {Number(details?.quotation_status) !== 12 && explodedPermissions?.some(permission => ['Void Estimate'].includes(permission)) ? (
                    <Button
                      size="small"
                      variant="contained"
                      color="error"
                      onClick={handleVoidMenu}
                    >
                      Move to Void
                    </Button>
                  ) : ''}

                  {(details?.quotation_status == 6 || details?.quotation_status == 11) && empty(projectEstimate) &&(
                    <AnimatedButton title={'Reopen'} onClick={handleReopen} />
                  )}

                  {Number(details?.quotation_status) === 12 && explodedPermissions?.some(permission => ['Void Estimate'].includes(permission)) ? (
                    <AnimatedButton title={'Reopen'} onClick={handleReopenVoidMenu} />
                  ) : ''}
                  {(explodedPermissions?.some(permission => ['Create Estimate','Edit Estimate','Delete Estimate'].includes(permission)) && userType !==3) ? 
                    (details?.quotation_status ==4  && empty(projectEstimate) &&(
                      <AnimatedButton title={'Convert to Sales Order'} onClick={handleConvertToRFQ} />
                    )) : ''}

                  {Number(details?.quotation_status) !== 12 && details?.estimate_job_status !== 2 && explodedPermissions?.some(permission => ['Create Request','Edit Request','Delete request'].includes(permission)) ?   
                        <AnimatedButton title={'Duplicate Estimate'} onClick={() => {
                          setOpenDuplicate(true)
                          setSettingsAnchorEl(null)
                          // handleDuplicateSalesOrder()
                        }}
                        /> : ''
                   }
                  {(explodedPermissions?.some(permission => ['Create Estimate','Edit Estimate','Delete Estimate'].includes(permission)) && userType !==3) ?
                    (empty(projectEstimate) && (
                      details?.quotation_status == 4 ||
                      details?.quotation_status == 6 ||
                      details?.quotation_status == 11
                    ) && (
                      <AnimatedButton title={'Convert to Design Order'} onClick={handleConvertToDesignOrder} />
                    )) : ''}
                  {/* {details?.quotation_status ==4 &&(
                    <Tooltip title="Convert to RFQ">
                      <IconButton sx={{backgroundColor:theme.palette.divider}} onClick={handleConvertToRFQ} >
                          <Icon icon={plusFill} width={24} height={24} color="#ffffff"/>
                      </IconButton>
                    </Tooltip>
                  )} */}
                </Stack>
              </Stack>:""}
            </Stack>)}
        </Stack>
        {openEdit && (
          <FormikProvider value={formik}>
            <Form
              noValidate
              autoComplete="off"
              onSubmit={handleSubmitWithDraftFlush}
              // onChange={handleFormChange}
            >
              <Grid container spacing={3}>

                <Grid item xs={12} md={12}>
                  <Card sx={{ p: 3 }}>
                    <Stack spacing={3}>
                      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                        <Stack flexDirection={'column'}>
                          {/* <LabelStyle>Name</LabelStyle> */}
                          <DraftTextField
                            //   fullWidth
                            sx={{ width: 400 }}
                            label="Requested Name"
                            name="name"
                            fieldName="name"
                            externalValue={values.name || ''}
                            resetToken={id}
                            onDraftChange={updateTopLevelDraft}
                            onCommit={commitTopLevelField}
                            onBlurCommit={markTopLevelFieldTouched}
                            computeError={requiredNameError}
                            touched={Boolean(touched.name)}
                          />
                        </Stack>
                        <DraftTextField
                            sx={{ width: 400 }}
                            label="#PO Number"
                            name="po_number"
                            fieldName="po_number"
                            externalValue={values.po_number || ''}
                            resetToken={id}
                            onDraftChange={updateTopLevelDraft}
                            onCommit={commitTopLevelField}
                            onBlurCommit={markTopLevelFieldTouched}
                          />
                        <Box
                          component={MobileDatePicker}
                          disableFuture
                          label="Estimate Date"
                          value={estimateDatePickerMoment(values.created_at)}
                          onChange={(date) => {
                            setFieldValue('created_at', dateOnlyToUnix(date));
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              // Avoid false red when a UTC date-only value is "tomorrow"
                              // in a behind timezone; picking future dates stays blocked.
                              error={false}
                              sx={{ width: 400 }}
                            />
                          )}
                        />
                      </Stack>
                      {/* <LabelStyle>Description</LabelStyle> */}
                      <DraftTextField
                        fullWidth
                        multiline
                        minRows={3}
                        maxRows={7}
                        label="keep the summary brief and make it communicates"
                        name="description"
                        fieldName="description"
                        externalValue={values.description || ''}
                        resetToken={id}
                        onDraftChange={updateTopLevelDraft}
                        onCommit={commitTopLevelField}
                        onBlurCommit={markTopLevelFieldTouched}
                        computeError={requiredDescriptionError}
                        touched={Boolean(touched.description)}
                      />
                      {/* <LabelStyle>Upload Approved Design</LabelStyle> */}
                      {/* <UploadAvatar
                        accept="image/*"
                        file={values.avatarUrl}
                        maxSize={1024 * 1024 * 1024}
                        onDrop={handleDrop}
                        error={Boolean(touched.avatarUrl && errors.avatarUrl)}
                      /> */}
                         {/* <UploadMultiFile
                         showPreview
                        maxSize={1024 * 1024 * 1024}
                        accept="image/*"
                         files={avatarUrl}
                        onDrop={handleDrop}
                        onRemove={handleRemove}
                        onRemoveAll={handleRemoveAll}
                    // error={Boolean(touched.avatarUrl && errors.avatarUrl)}
                    /> */}
                      {/* <LabelStyle>Skills or services required</LabelStyle> */}


                    {/* {details?.is_request_estimate == 1 ? '' : <> */}
                      <LabelStyle>Upload Designs / Documents</LabelStyle>
                        <UploadMultiFile
                          showPreview
                          allowDownload
                          maxSize={1024 * 1024 * 1024}
                          files={uploadDesignsDisplayFiles}
                          onDrop={handleDrop}
                          onRemove={handleRemove}
                          onRemoveAll={handleRemoveAll}
                          isUploading={isUploading}
                          showProductLabels={true}
                        />
                    {/* </>} */}

                    {
                      userType !==3 ?
                     <>
                     {/* {details?.is_request_estimate == 1 ? '' : */}
                      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                        {/* <Autocomplete
                          multiple
                          fullWidth
                          id="combo-box-demo"
                          options={skills}
                          value={values.skills}
                          onChange={(event, newValue) => setFieldValue('skills', newValue)}
                          renderInput={(params) => (
                            <TextField {...params} label="Skills or services required" />
                          )}
                          getOptionLabel={(option) => option.name}
                        /> */}
                          <Autocomplete
                            sx={{ width: '50%' }}
                            id="combo-box-demo"
                            // disabled = {currentRFQData?.client?.id ? true : false}
                            // disabled={details?.checkProjectExist ? true : false}
                            options={allClientsEdit || []}
                            value={values.clients}
                            onChange={(event, newValue) => {
                              // if (newValue) {
                              //   setFieldValue('clients', newValue);
                              // } else {
                              //   setFieldValue('clients', null);
                              // }
                              if (newValue) {
                                setFieldValue('clients', newValue);
                                setFieldValue('community', null);
                                fetchAllCommunityByClient(newValue);
                              } else {
                                setFieldValue('clients', null);
                                setFieldValue('community', null);
                                setCommunities([]);
                              }
                              // Changing client is a meaningful edit.
                              // markUnsavedChanges(();
                            }}
                            isOptionEqualToValue={(option, value) =>
                              option?.id != null &&
                              value?.id != null &&
                              String(option.id) === String(value.id)
                            }

                            renderInput={(params) => (
                              <TextField required
                                {...params} label="Clients"
                                error={Boolean(touched.clients && errors.clients)}
                                helperText={touched.clients && errors.clients} />
                            )}
                            getOptionLabel={(option) => option?.name || ''}
                            renderOption={(props, option) => {
                              const { style, ...liProps } = props;
                              return (
                                <li
                                  {...liProps}
                                  style={{
                                    ...style,
                                    display: 'flex',
                                    alignItems: 'center',
                                  }}
                                >
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      width: 40,
                                      justifyContent: 'center',
                                    }}
                                  >
                                    {option?.syncWithQuickBook === 1 && (
                                      <img
                                        src={quickbookLogo}
                                        width="40px"
                                        height="20px"
                                        alt="QuickBooks"
                                      />
                                    )}
                                  </div>
                                  <span
                                    style={{
                                      flex: 1,
                                      minWidth: 0,
                                      display: 'block',
                                      whiteSpace: 'nowrap',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                    }}
                                  >
                                    {option?.name}
                                  </span>
                                </li>
                              );
                            }}
                          />

{isCommunityLoading ?
                              <Stack flexDirection={'row'} alignItems='center' justifyContent='center'>
                                <CircularProgress color="primary" variant="indeterminate" />
                                <Typography variant='body2'>Loading projects...</Typography>
                              </Stack> :
                          communities?.length > 0 ? (<Autocomplete
                            sx={{ width: '50%' }}
                            id="community"
                            options={
                              [...(communities || [])].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
                            }
                            value={values?.community}
                            onChange={(event, newValue) => {
                              if(newValue){
                              setFieldValue('community', newValue)
                              // Sales reps dropdown: populate all sales reps for selected project
                              const matchedCommunity = communities?.find(
                                (community) => community?.id === newValue?.id
                              );
                              setCollaborators([])
                              const repOptions = getSalesRepOptionsFromCommunity(matchedCommunity);
                              setSalesRepOptions(repOptions);
                              // Reset sales rep to null when project is changed
                              setSalesRepName('');
                              setSalesRepId(null);
                              setAllSalesRepIds('');

                              // Extract new community address
                             const { address: projAddress = '', city: projCity = '', state: projState = '', zip: projZip = '' } = newValue || {};
                             const communityAddress = {
                               id: 0,
                               address: projAddress,
                               city: projCity,
                               state: projState,
                               zip: projZip,
                             };
                         
                             // Update locations in `setSelectedProducts`
                             setSelectedProducts((prevProducts) =>
                               prevProducts.map((product) => {
                                if (product?.fromMapServices == true) {
                                  return product;
                                }else{
                                  // For split orders, ensure proper address population
                                  if (isSplitOrder) {
                                    // For split orders, create proper locations based on quantity
                                    const locationQuantity = product.locationQuantity || product.quantity || 1;
                                    const updatedAddresses = Array.from({ length: locationQuantity }, () => ({
                                      id: 0,
                                      address: projAddress,
                                      city: projCity,
                                      state: projState,
                                      zip: projZip,
                                    }));
                                    return { ...product,allLocationSame: 1, location: updatedAddresses };
                                  } else {
                                    // For normal orders, use existing logic
                                    const updatedAddresses = product.location?.map((loc) => ({
                                      ...loc,
                                      address: projAddress || loc.address,
                                      city: projCity || loc.city,
                                      state: projState || loc.state,
                                      zip: projZip || loc.zip,
                                    })) || [communityAddress];
                                    return { ...product, location: updatedAddresses };
                                  }
                                }
                               })
                             );
                         console.log("selectedProductsselectedProducts",selectedProducts)
                             // Update locations in `setCart`
                             setCart((prevCart) =>
                               prevCart.map((product) => {
                                 const updatedAddresses = product.location?.map((loc) => ({
                                   ...loc,
                                   address: projAddress || loc.address,
                                   city: projCity || loc.city,
                                   state: projState || loc.state,
                                   zip: projZip || loc.zip,
                                 })) || [communityAddress];
                                 return { ...product, location: updatedAddresses };
                               })
                             );
                              if(newValue.tax_category){
                              let taxCat = taxCategories?.find(cat => newValue.tax_category === cat.id)
                              setSelectedTaxCategory(taxCat)
                              }
                            } else {
                              
                              setFieldValue('community', null);
                              setSelectedTaxCategory(null);
                              setSalesRepName('');
                              setSalesRepId(null);
                              setSalesRepOptions([]);
                              setAllSalesRepIds('');
                            }
                            // Changing project/community is a user edit.
                            // markUnsavedChanges();();
                            }}
                            renderInput={(params) => (
                              <Tooltip
                                title={values.community ? formatProjectAddress(values.community) : ''}
                              >
                                <TextField required
                                  {...params} label="Project"
                                  error={Boolean(touched.community && errors.community)}
                                  helperText={touched.community && errors.community} />
                              </Tooltip>
                            )}
                            getOptionLabel={(option) => option.name}
                            renderOption={(props, option) => {
                              const { style, ...liProps } = props;
                              return (
                                <li
                                  {...liProps}
                                  style={{
                                    ...style,
                                    display: 'flex',
                                    alignItems: 'center',
                                  }}
                                >
                                  <Tooltip title={formatProjectAddress(option)}>
                                    <span
                                      style={{
                                        flex: 1,
                                        minWidth: 0,
                                        display: 'block',
                                      }}
                                    >
                                      <span
                                        style={{
                                          display: 'block',
                                          whiteSpace: 'nowrap',
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis',
                                        }}
                                      >
                                        {option?.name || ''}
                                      </span>
                                      {/* <span
                                        style={{
                                          display: 'block',
                                          fontSize: 12,
                                          color: '#6b7280',
                                          whiteSpace: 'nowrap',
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis',
                                        }}
                                      >
                                        {formatProjectAddress(option)}
                                      </span> */}
                                    </span>
                                  </Tooltip>
                                  <span style={{ display: 'none' }}>{option?.name || ''}</span>
                                </li>
                              );
                            }}
                          />) : (
                            <Stack sx={{ width: '50%' }} justifyContent={'center'}>
                              {values?.clients ?
                                <Typography sx={{ color: "red" }}>The selected client does not have any projects yet. Please create a new project for them!</Typography>
                                : <Typography sx={{ color: "red" }}>No client selected. Please choose a client from the list.</Typography>}
                            </Stack>
                          )
                        }
                    
                    </Stack>
                    {salesRepOptions?.length > 0 && (
                      <Stack sx={{ width: '100%' }}>
                        <Autocomplete
                          id="sales-rep"
                          options={salesRepOptions}
                          value={
                            salesRepOptions.find((opt) => {
                              if (salesRepId != null && opt?.id != null) {
                                return String(opt.id) === String(salesRepId);
                              }
                              return salesRepName && opt?.name === salesRepName;
                            }) || null
                          }
                          onChange={(event, newValue) => {
                            setSalesRepName(newValue?.name || '');
                            setSalesRepId(newValue?.id || null);
                            if (newValue?.id) setAllSalesRepIds(String(newValue.id)); else setAllSalesRepIds('');
                          }}
                          isOptionEqualToValue={(option, value) =>
                            (option?.id != null && value?.id != null && String(option.id) === String(value.id)) ||
                            option?.name === value?.name
                          }
                          getOptionLabel={(option) => option?.name || ''}
                          renderInput={(params) => (
                            <TextField {...params} label="Sales Rep" fullWidth />
                          )}
                        />
                      </Stack>
                    )}
                    {/* {(values.community?.id != null && values.community?.sales_rep_names != null)&& ( */}
                    <Stack sx={{ width: '100%' }}>
                      <Autocomplete
                        multiple
                        id="collaborators"
                        options={collaboratorOptions}
                        value={collaborators}
                        onChange={(event, newValue) => setCollaborators(newValue || [])}
                        loading={teamMembersLoading}
                        isOptionEqualToValue={(option, value) => (option?.id != null && value?.id != null && String(option.id) === String(value.id))}
                        getOptionLabel={(option) => {
                          if (!option) return '';
                          const name = option.name || [option.first_name, option.last_name].filter(Boolean).join(' ').trim();
                          return name || String(option.id || '');
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Collaborators"
                            fullWidth
                            placeholder="Select Collaborators"
                          />
                        )}
                      />
                    </Stack>
                    {/* )} */}
                    {/* } */}
                        {/* {communities && communities.length > 0 ? ( <Autocomplete
                          fullWidth
                          id="community"
                          options={communities}
                          value={values.community}
                          onChange={(event, newValue) => setFieldValue('community', newValue)}
                          renderInput={(params) => (
                            <TextField  required 
                            {...params} label="Project"
                            error={Boolean(touched.community && errors.community)}
                            helperText={touched.community && errors.community} />
                          )}
                          getOptionLabel={(option) => option.name}
                        />):
                          <Typography sx={{color:"red", width: '50%'}}>The client you have chosen does not have a project yet. Please create one for them! </Typography>
                        } */}
                      {/* </Stack>
                      
                      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}> */}
                         {/* <Autocomplete                        
                          fullWidth
                          id="combo-box-demo-type"
                          options={projectTypes}
                          value={values.project_type}
                          onChange={(event, newValue) => setFieldValue('project_type', newValue)}
                          renderInput={(params) => (
                            <TextField  required 
                            {...params} label="Job Type"
                            error={Boolean(touched.project_type && errors.project_type)}
                            helperText={touched.project_type && errors.project_type} />
                          )}
                          getOptionLabel={(option) =>option.name}

                        />
                         <Autocomplete
                         fullWidth
                          id="combo-box-demo-category"
                          options={projectCategories}
                          value={values.project_category}
                          onChange={(event, newValue) => setFieldValue('project_category', newValue)}
                          renderInput={(params) => (
                            <TextField  required 
                            {...params} label="Job Category"
                            error={Boolean(touched.project_category && errors.project_category)}
                            helperText={touched.project_category && errors.project_category} />
                          )}
                          getOptionLabel={(option) => option.name}

                        /> */}
                        {/* {details?.is_request_estimate == 1 ? '' :
                        <> */}
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                          {/* <Autocomplete                        
                            fullWidth
                            disabled
                            // sx={{ width: '50%' }}
                            id="combo-box-demo-type"
                            options={markupTypes}
                            value={values.markup_type}
                            onChange={(event, newValue) => {
                              setFieldValue('markup_type', newValue)
                              setMarkupType(newValue?.id)
                            }}
                            renderInput={(params) => (
                              <TextField  required 
                              {...params} label="Markup Type"
                              error={Boolean(touched.markup_type && errors.markup_type)}
                              helperText={touched.markup_type && errors.markup_type} />
                            )}
                            getOptionLabel={(option) => option.name}
                          /> */}
                          {shouldHideJobClassDropdown ? (
                            <TextField
                              fullWidth
                              sx={{ width: { xs: '100%', sm: '50%' } }}
                              id="combo-box-demo-type"
                              label="Job Class"
                              value={values.project_type?.name ?? ''}
                              required
                              InputProps={{ readOnly: true }}
                              error={Boolean(touched.project_type && errors.project_type)}
                              helperText={touched.project_type && errors.project_type}
                            />
                          ) : (
                            <Autocomplete                        
                              fullWidth
                              sx={{ width: {xs:'100%' ,sm:'50%'} }}
                              id="combo-box-demo-type"
                              options={projectTypes}
                              value={values.project_type}
                              onChange={(event, newValue) => {
                                setFieldValue('project_type', newValue)
                                if (newValue?.name !== 'TS') {
                                  setFieldValue('map_service', null)
                                  const filteredProducts = selectedProducts?.filter(product => product?.fromMapServices !== true);
                                  setSelectedProducts(filteredProducts);
                                }
                                // Job class change = edit.
                                // markUnsavedChanges();();
                              }}
                              renderInput={(params) => (
                                <TextField  required 
                                {...params} label="Job Class"
                                error={Boolean(touched.project_type && errors.project_type)}
                                helperText={touched.project_type && errors.project_type} />
                              )}
                              getOptionLabel={(option) =>option.name}
                            />
                          )}
                          <Autocomplete
                            sx={{ width: '50%' }}
                            multiple
                            id="sign-agreement"
                            options={agreements} // Array of agreements (full objects)
                            value={values.sign_agreement || []} // Ensure it's an array of full agreement objects
                            onChange={(event, newValue) => {
                              // Store the full selected objects in the form's field value
                              setFieldValue('sign_agreement', newValue || []); // No need to join IDs, just store the objects
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                required={false}
                                InputLabelProps={{
                                  ...params.InputLabelProps,
                                  required: false,
                                }}
                                label="Select Sign Agreements"
                                error={Boolean(touched.sign_agreement && errors.sign_agreement)}
                                helperText={touched.sign_agreement && errors.sign_agreement}
                              />
                            )}
                            isOptionEqualToValue={(option, value) => option.id === value.id} // Compare options by 'id'
                            getOptionLabel={(option) => option.name || ''} // Show 'name' of the agreement
                            filterOptions={(options, { inputValue }) => {
                              // Filter by name (case-insensitive)
                              return options.filter(option =>
                                option.name.toLowerCase().includes(inputValue.toLowerCase())
                              );
                            }}
                          />
                        </Stack>
                        {values?.project_type?.name == 'TS' ? 
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                          <Autocomplete
                            // fullWidth
                            sx={{ width: '50%' }}
                            id="combo-box-demo-category"
                            options={projectCategories}
                            value={values.project_category}
                            onChange={(event, newValue) => {
                              setFieldValue('project_category', newValue)
                              // Clear catalog type for Build Order
                              if (newValue?.name == 'Build Order' || newValue?.id == 15) {
                                setFieldValue('split_catalog_type', null)
                              }
                              if (values?.project_type?.name !== 'TS' || newValue?.id != 14) {
                                setFieldValue('map_service', null)
                                const filteredProducts = selectedProducts?.filter(product => product?.fromMapServices !== true);
                                setSelectedProducts(filteredProducts);
                                setSelectedMapserviceProducts([]);
                                setSelectedServices([]);
                              }
                              if(values.project_category?.id == 14){
                                setSelectedProducts([]);
                                setSelectedMapserviceProducts([]);
                                setSelectedServices([]);
                              }
                              // Job type change should mark form as dirty for draft.
                              // markUnsavedChanges();();
                            }}
                            renderInput={(params) => (
                              <TextField  
                              {...params} label="Job Type"
                              error={Boolean(touched.project_category && errors.project_category)}
                              helperText={touched.project_category && errors.project_category} />
                            )}
                            getOptionLabel={(option) => option.name}
                          />
                          {values.project_category?.id == 14 ? 
                          <Autocomplete
                            // fullWidth
                            sx={{ width: '50%' }}
                            id="combo-box-demo-type"
                            options={mapServices}
                            value={values.map_service}
                            onChange={(event, newValue) => {
                              setFieldValue('map_service', newValue)
                              if (newValue?.products) {
                                let newIndexCounter = indexCounter;
                                const updatedProductsWithLocations = newValue?.products?.map((product,index) => {
                                  const filteredData = allProducts?.find((i) => i.id === product.product_id);
                                  const associatedLocations = newValue?.locations
                                    .filter((location) => location?.route_product_id === product?.id)
                                    .map((location) => ({
                                      address: location.address,
                                      city: location.city,
                                      state: location.state,
                                      zip: location.zip,
                                      route_location_id: location.id,
                                    }));
                                    newIndexCounter += 1;
                                  return {
                                    ...product,
                                    ...filteredData,
                                    indexId: newIndexCounter, // `map_${index}`,
                                    fromMapServices:true,
                                    locationQuantity: product?.qty,
                                    location: associatedLocations,
                                    discount: 0,
                                    adjustment: 0,
                                    quantity: 1,
                                    markAdjType:2
                                  };
                                });
                                console.log('updatedProductsWithLocations-----------',updatedProductsWithLocations)
                                const mergedSelectedProducts = [
                                  ...selectedProducts.filter((product) => product?.fromMapServices !== true), // Keep existing products without fromMapServices
                                  ...updatedProductsWithLocations, // Add the new products from map services
                                ];
                                setSelectedMapserviceProducts(updatedProductsWithLocations);
                                setSelectedProducts(mergedSelectedProducts);
                                setIndexCounter(newIndexCounter);
                                const productServices = mergedSelectedProducts?.reduce((services, product) => {
                                  if (product.services && product.services.length > 0) {
                                    return services.concat(
                                      product.services.map((service) => ({
                                        ...service,
                                        fromMapServices:product?.fromMapServices || false,
                                        productIndex: product?.indexId,
                                        quantity: service.quantity * product.quantity * product.locationQuantity,
                                        previousQty: service.quantity,
                                        qtyData: product.quantity,
                                        locationQuantity: product.locationQuantity,
                                      }))
                                    );
                                  }
                                  return services;
                                }, []);
                                setSelectedServices(productServices);
                              }
                              // Selecting a route is a meaningful edit.
                              // markUnsavedChanges();();
                            }}
                            renderInput={(params) => (
                              <TextField required
                                {...params} label="Routes"
                                error={Boolean(touched.map_service && errors.map_service)}
                                helperText={touched.map_service && errors.map_service} />
                            )}
                            // getOptionLabel={(option) => option.name}
                            getOptionLabel={(option) => `${option.name} (${option.locations_count})`}
                          /> : '' }
                      </Stack> : '' }
                      {/* </>} */}
                      {/* <Stack>
                      <Autocomplete
                          multiple
                          fullWidth
                          id="combo-box-demo"
                          options={workflow}
                          value={values.workflow}
                          onChange={(event, newValue) => setFieldValue('workflow', newValue)}
                          renderInput={(params) => (
                            <TextField {...params} label="Workflow" />
                          )}
                          getOptionLabel={(option) => option.name}

                          />
                      </Stack> */}
                      {
                        isSplitOrder ? 
                          <Stack
                            direction={{ xs: 'column', sm: 'row' }}
                            spacing={{ xs: 3, sm: 2 }}
                          >
                            <Autocomplete
                              sx={{ width: '50%' }}
                              id="split-type-autocomplete"
                              options={[{ id: 1, label: 'Split' }]}
                              disabled={isSplitOrder}
                              value={values.is_split || null}
                              onChange={(event, newValue) => {
                                setFieldValue('is_split', newValue);
                                // Update isSplitOrder based on the form field value
                                setIsSplitOrder(!!newValue);

                                // If split order is enabled, set default facility
                                if (newValue) {
                                  const defaultFacility = FacilityTypes?.filter(fac => fac.default);
                                  setFieldValue('facility_type', defaultFacility || []);
                                } else {
                                  // If split order is disabled, clear facility_type
                                  setFieldValue('facility_type', []);
                                }
                                // Changing split type affects estimate.
                                // markUnsavedChanges();();
                              }}
                              getOptionLabel={(option) => option?.label ?? ''}
                              isOptionEqualToValue={(option, value) => option?.id === value?.id}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Choose Split Type"
                                  placeholder="Select split type"
                                  error={Boolean(touched.is_split && errors.is_split)}
                                  helperText={touched.is_split && errors.is_split}
                                />
                              )}
                            />

                            {
                              isSplitOrder ? (

                                <Autocomplete
                                  multiple
                                  disableCloseOnSelect
                                  filterSelectedOptions
                                  sx={{ width: '50%' }}
                                  id="combo-box-demo-type"
                                  options={FacilityTypes || []}
                                  value={values.facility_type || []}
                                  onChange={(event, newValue) => {
                                    setFieldValue('facility_type', newValue);
                                    let filteredVaue = newValue.find(v => !v.default)
                                    const selectedData = (Array.isArray(filteredVaue) ? filteredVaue : [filteredVaue]).map(v => {
                                      const id = typeof v === 'object' ? v?.id : v;
                                      return splitManagementSettings?.find(s => String(s?.id) === String(id));
                                    })
                                      .filter(Boolean);

                                    setSelectedSplitOrderSettings(selectedData)

                                    // Filter selected products based on new facility selection
                                    if (isSplitOrder && selectedProducts.length > 0) {
                                      const filteredProducts = filterSelectedProductsByFacility(newValue);
                                      setSelectedProducts(filteredProducts);
                                      setFieldValue('products', filteredProducts);
                                    }
                                  // Facility change modifies estimate contents.
                                  // markUnsavedChanges();();
                                  }}
                                  getOptionLabel={(option) => option?.label ?? ''}
                                  isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                  renderTags={(selected, getTagProps) =>
                                    selected.map((option, index) => (
                                      <Chip
                                        key={option?.id ?? option?.label ?? index}
                                        label={option?.label}
                                        size="small"
                                        color={option?.color}//"primary"
                                        variant="outlined"
                                        {...getTagProps({ index })} // handles delete icon
                                      />
                                    ))
                                  }
                                  renderInput={(params) => (
                                    <TextField
                                      required
                                      {...params}
                                      label="Choose Facility"
                                      placeholder="Select facilities"
                                      error={Boolean(touched.facility_type && errors.facility_type)}
                                      helperText={touched.facility_type && errors.facility_type}
                                    />
                                  )}
                                />
                              )
                                : ""
                            }

                          </Stack>
                          : ''
                      }
                      <>
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                        <Box
                        component={MobileDatePicker}
                        label="Start Date"
                        // minDate={moment()}
                        defaultValue={formatDateOnly(values.start)}
                        value={dateOnlyMoment(values.start)}
                          onChange={(date) => {
                       const newStartUnix = dateOnlyToUnix(date);
                       setFieldValue('start', newStartUnix);
                       applyInstallationFromStartAndLead(newStartUnix);
                     }}
                        renderInput={(params) => (
                        <TextField size="small" {...params} fullWidth />
                        )}
                        />

                          <Box
                            component={MobileDatePicker}
                            label="Installation Date"
                            minDate={values.start ? dateOnlyMoment(values.start) : moment()}
                            defaultValue={formatDateOnly(values.end)}
                            value={values.end ? dateOnlyMoment(values.end) : null}
                            onChange={(date) => {
                              const endUnix = dateOnlyToUnix(date);
                              const nextValues = {
                                ...values,
                                end: endUnix,
                                installation_start_date: null,
                                installation_end_date: null,
                              };
                              setFieldValue('end', endUnix);
                              setFieldValue('installation_start_date', null);
                              setFieldValue('installation_end_date', null);
                              runRushFeeLeadSync({
                                values: nextValues,
                                products: productsForLeadRaw,
                                catalog: allProducts,
                                canOverride: canOverrideRushFeeLock,
                                setFieldValue,
                                refs: rushFeeSyncRefs.current,
                                enabled: openEdit,
                              });
                            }}
                            renderInput={(params) => (
                            <TextField size="small" {...params} fullWidth 
                              error={Boolean(touched.end && errors.end)}
                              helperText={touched.end && errors.end}
                            />
                            )}
                          />
                        </Stack>
                        <Typography variant="body2" color="text.secondary" sx={{ mt: 2, mb: 1, fontStyle: 'italic' }}>
                          Choose either single installation date above OR installation date range below
                        </Typography>
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                          <Box
                            component={MobileDatePicker}
                            minDate={values.start ? dateOnlyMoment(values.start) : moment()}
                            label="Installation Start Date"
                            value={values.installation_start_date ? dateOnlyMoment(values.installation_start_date) : null}
                            onChange={(date) => {
                              const ux = dateOnlyToUnix(date);
                       setFieldValue('installation_start_date', ux);
                              setFieldValue('end', null);
                              applyLeadTimeInstallPatch(ux);
                            }}
                            renderInput={(params) => (
                              <TextField 
                                size="small" 
                                {...params} 
                                fullWidth
                                error={Boolean(touched.installation_start_date && errors.installation_start_date)}
                                helperText={touched.installation_start_date && errors.installation_start_date}
                              />
                            )}
                          />
                          <Box
                            component={MobileDatePicker}
                            minDate={values.installation_start_date ? dateOnlyMoment(values.installation_start_date) : moment()}
                            label="Installation End Date"
                            value={values.installation_end_date ? dateOnlyMoment(values.installation_end_date) : null}
                            onChange={(date) => {
                              const endUnix = dateOnlyToUnix(date);
                              const nextValues = {
                                ...values,
                                installation_end_date: endUnix,
                                end: null,
                              };
                              setFieldValue('installation_end_date', endUnix);
                              setFieldValue('end', null);
                              runRushFeeLeadSync({
                                values: nextValues,
                                products: productsForLeadRaw,
                                catalog: allProducts,
                                canOverride: canOverrideRushFeeLock,
                                setFieldValue,
                                refs: rushFeeSyncRefs.current,
                                enabled: openEdit,
                              });
                            }}
                            renderInput={(params) => (
                              <TextField 
                                size="small" 
                                {...params} 
                                fullWidth
                                error={Boolean(touched.installation_end_date && errors.installation_end_date)}
                                helperText={touched.installation_end_date && errors.installation_end_date}
                              />
                            )}
                          />
                        </Stack>
                      </>

                      {/* Legacy estimate-only product rows table — unified into selectedProducts with Mode toggle */}
                      {false && (details?.is_request_estimate == 1 && (!details?.estimate_job_status || details?.estimate_job_status != 3)) && (
                        <>
                          <LabelStyle>Products</LabelStyle>
                          <TableContainer component={Paper} sx={{ mt: 2 }}>
                            <Table>
                              <TableHead>
                                <TableRow>
                                  <TableCell padding="checkbox" sx={{ width: 40 }} />
                                  <TableCell align="center">Sl No</TableCell>
                                  <TableCell align="center">Product Name</TableCell>
                                  <TableCell align="center">Product Description</TableCell>
                                  <TableCell align="center"></TableCell>
                                </TableRow>
                              </TableHead>
                              <DragDropContext onDragEnd={(result) => handleProductRowsDragEnd(result, false)}>
                                <Droppable droppableId="view-quotation-estimate-product-rows">
                                  {(droppableProvided) => (
                              <TableBody
                                ref={droppableProvided.innerRef}
                                {...droppableProvided.droppableProps}
                              >
                                {productRows.map((row, index) => (
                                  <Draggable
                                    key={`estimate-product-row-${row.indexId}`}
                                    draggableId={`estimate-product-row-${row.indexId}`}
                                    index={index}
                                  >
                                    {(provided, snapshot) => (
                                  <TableRow
                                    key={row.indexId}
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    style={{
                                      ...provided.draggableProps.style,
                                      ...(snapshot.isDragging
                                        ? { backgroundColor: theme.palette.action.hover }
                                        : {}),
                                    }}
                                  >
                                    <TableCell
                                      padding="checkbox"
                                      {...provided.dragHandleProps}
                                      sx={{ width: 40, cursor: 'grab' }}
                                    >
                                      <DragIndicator fontSize="small" color="action" />
                                    </TableCell>
                                    <TableCell align="center">#{row.indexId}</TableCell>
                                    <TableCell align="center">
                                      <TextField
                                        fullWidth
                                        variant="outlined"
                                        value={row.product_name}
                                        onFocus={() => handleFieldFocus(row.indexId, 'name', row.product_name)}
                                        onChange={(e) => {
                                          handleRequestEstimateProductNameChange(row.indexId, e.target.value);
                                          const updatedRow = { ...row, product_name: e.target.value };
                                          triggerDebouncedAutoSave(updatedRow, 'name');
                                        }}
                                        onBlur={() => {
                                          commitProductNameDraft(row.indexId)
                                          handleProductRowAutoSave(row, 'name')
                                        }}
                                        placeholder="Product Name2"
                                        error={Boolean(rowErrors[row.indexId])}
                                        helperText={rowErrors[row.indexId]}
                                        InputProps={{
                                          endAdornment: autoSavingField?.indexId === row.indexId && autoSavingField?.field === 'name' ? (
                                            <InputAdornment position="end">
                                              <CircularProgress size={20} />
                                            </InputAdornment>
                                          ) : null
                                        }}
                                      />
                                    </TableCell>
                                    <TableCell align="center">
                                      <TextField
                                        fullWidth
                                        variant="outlined"
                                        value={row.product_desc}
                                        onFocus={() => handleFieldFocus(row.indexId, 'desc', row.product_desc)}
                                        onChange={(e) => {
                                          handleRequestEstimateProductDescChange(row.indexId, e.target.value);
                                          const updatedRow = { ...row, product_desc: e.target.value };
                                          triggerDebouncedAutoSave(updatedRow, 'desc');
                                        }}
                                        onBlur={() => handleProductRowAutoSave(row, 'desc')}
                                        placeholder="Product Description"
                                        multiline
                                        minRows={1}
                                        maxRows={3}
                                        InputProps={{
                                          endAdornment: autoSavingField?.indexId === row.indexId && autoSavingField?.field === 'desc' ? (
                                            <InputAdornment position="end">
                                              <CircularProgress size={20} />
                                            </InputAdornment>
                                          ) : null
                                        }}
                                      />
                                    </TableCell>
                                    <TableCell align="center">
                                        {/* {productRows.length > 1 && ( */}
                                          <IconButton 
                                            onClick={() => handleDeleteRequestEstimateProduct(row.indexId, row.backendId)}
                                            color="error"
                                          >
                                            <Delete />
                                          </IconButton>
                                        {/* )} */}
                                    </TableCell>
                                  </TableRow>
                                    )}
                                  </Draggable>
                                ))}
                                {droppableProvided.placeholder}
                              </TableBody>
                                  )}
                                </Droppable>
                              </DragDropContext>
                            </Table>
                          </TableContainer>
                          <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-start'}}>
                            <Button
                              variant="outlined"
                              startIcon={<Icon icon={plusFill} />}
                              onClick={addNewRequestEstimateProductRow}
                              sx={{
                                marginLeft: '20px'
                              }}
                            >
                              Add Row
                            </Button>
                          </Box>
                        </>
                      )}

                      {(
                      <>
                      <Divider />
                      <LabelStyleHead>Products</LabelStyleHead>
                      {/* Legacy multi-select product Autocomplete — per-row catalog picker via Choose mode */}
                      {/* {false && ( */}
                      <Stack direction={{ xs: 'column', sm: 'row' }} alignItems={'center'} spacing={{ xs: 3, sm: 2 }}>
                        <Autocomplete
                          key={`product-autocomplete-${isSplitOrder}-${values?.facility_type?.length || 0}-${filteredProductOptions?.length || 0}`}
                          sx={{ width: '50%' }}
                          multiple
                          disableCloseOnSelect
                          clearOnBlur={false}
                          id="combo-box-demo"
                          options={filteredProductOptions}
                          value={productAutocompleteDisplayValue}
                          onChange={(event, newValue) => {
                            const expanded = expandAutocompleteValueToMainProducts(newValue, selectedProducts)
                            const updated = expanded.map((item) => ({
                              ...item,
                              is_single_card: values.project_category?.id !== 14 ? true : false,
                            }))
                            handleProduct(updated)
                            setFieldValue('products', updated)
                          }}
                          renderInput={(params) => (
                            <TextField {...params} label="Select a product" />
                          )}
                          // getOptionLabel={(option) => option.product_name ? option.product_name : option.name}
                          renderOption={(props, option) => {
                              const { style, ...liProps } = props;
                              const description = option.description // option.name || option.name || '';
                              const Name =option.name
                              const suffix = catalogSuffixForProductOption(option)
                              return (
                                <li
                                  {...liProps}
                                  style={{
                                    ...style,
                                    display: 'flex',
                                    alignItems: 'center',
                                  }}
                                >
                                  <div style={{ display: 'flex', alignItems: 'center', width: 40, justifyContent: 'center' }}>
                                    {option?.syncWithQuickbooks === 1 && (
                                      <img
                                        src={quickbookLogo}
                                        width="40px"
                                        height="20px"
                                        // style={{ marginRight: 8 }}
                                        alt="QuickBooks"
                                      />
                                    )}
                                  </div>
                                  <Tooltip title={`${description} ${suffix}`}>
                                    <span style={{
                                      flex: 1,
                                      minWidth: 0,
                                      display: 'block',
                                      whiteSpace: 'nowrap',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      color: isSplitOrder ?  theme.palette[
                                        FacilityTypes.find(f => f.id === option?.facility_id)?.color || 'primary'
                                      ]?.main
                                    : 'inherit' 
                                    }}>
                                       {`${Name} ${suffix}`}
                                    </span>
                                  </Tooltip>
                                  <span style={{ display: 'none' }}>{option.name}</span>
                                </li>
                              );
                              }}
                              // isOptionEqualToValue={(option, value) => option.id === value.id}
                              isOptionEqualToValue={() => false}
                              // getOptionLabel={(option) => option.name ? option.name : ''}
                              getOptionLabel={(option) => {
                                if (option?.isGroupAutocompleteChip) {
                                  const name = getCatalogAutocompleteDisplayName(option)
                                  const suffix = catalogSuffixForProductOption(option)
                                  return `${name} ${suffix}`
                                }
                                const name = option.product_name || option.name || '';
                                const description = option.description || option.name || '';
                                const suffix = catalogSuffixForProductOption(option)
                                // return `${description} \u200B${name}`;
                                return `${description} ${suffix} \u200B${name}`;
                              }}
                              onInputChange={(event, newInputValue, reason) => {
                                // Track the latest input value for production builds
                                // This ensures filterOptions gets the latest inputValue even in optimized builds
                                productInputValueRef.current = newInputValue || '';
                                // Force re-render by clearing and setting input if needed
                                if (reason === 'input') {
                                  // Input changed, ensure component updates
                                }
                              }}
                              filterOptions={(options, { inputValue }) => {
                                // Always use ref value as primary source for production builds
                                // The inputValue parameter can be stale in production builds
                                const currentInput = productInputValueRef.current || (inputValue !== undefined && inputValue !== null ? inputValue : '');
                                const searchText = (currentInput || '').toString().trim().toLowerCase();
                                
                                // If no search text, return all options
                                if (!searchText) return options;
                                
                                // Filter options based on search text
                                return options.filter((option) => {
                                  const nameMatch = option.name?.toLowerCase().includes(searchText);
                                  const descMatch = option.description?.toLowerCase().includes(searchText);
                                  const tagsMatch = String(option.tags ?? '').toLowerCase().includes(searchText);
                                  const idMatch = String(option.id)?.includes(searchText);

                                  return nameMatch || descMatch || idMatch || tagsMatch;
                                });
                              }}
                            renderTags={(value, getTagProps) =>
                            value.map((option, index) => {
                                const name = getCatalogAutocompleteDisplayName(option)
                                const suffix = catalogSuffixForProductOption(option)
                                const tip = getCatalogAutocompleteTooltip(option, suffix)
                                return (
                                  <Tooltip
                                    key={
                                      option?.isGroupAutocompleteChip
                                        ? `grp-chip-${option.group_id}`
                                        : `prod-chip-${option.indexId ?? index}`
                                    }
                                    title={tip}
                                  >
                                    <Chip
                                      sx={{
                                        color: isSplitOrder
                                          ? theme.palette[
                                              FacilityTypes.find((f) => f.id === option?.facility_id)?.color ||
                                                'primary'
                                      ]?.main
                                          : 'inherit',
                                      }}
                                {...getTagProps({ index })} 
                                      label={`${name} ${suffix}`}
                              />
                             </Tooltip>
                                )
                              })}
                        />
                        {
                          isSplitOrder ? (
                            <Autocomplete
                              sx={{ width: '50%' }}
                              id="split-catalog-type"
                               options={getSplitCatalogTypes()}
                              value={values.split_catalog_type || splitOrderCatalogTypes.find((type) => type.id === 'all')}
                              onChange={(event, newValue) => {
                                const finalValue = newValue || splitOrderCatalogTypes.find((type) => type.id === 'all')
                                setFieldValue('split_catalog_type', finalValue)
                                console.log('Split catalog type changed:', finalValue)
                                    // markUnsavedChanges();();
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Choose Catalog Type"
                                  placeholder="Select catalog type"
                                  error={Boolean(touched.split_catalog_type && errors.split_catalog_type)}
                                  helperText={touched.split_catalog_type && errors.split_catalog_type}
                                />
                              )}
                            />
                          ) : (() => {
                            // Hide Catalog Type field when project category is Build Order (id 15)
                            const categoryId = values?.project_category?.id;
                            const isBuildOrder = categoryId === 15;
                            
                            // Don't show Catalog Type for Build Order
                            if (isBuildOrder) {
                              return null;
                            }
                            
                            // For normal orders: remove split_catalog, add sub_contract (keep production_catalog and estimate_catalog)
                            const filteredCatalogTypes = splitOrderCatalogTypes
                              .filter(type => type.id !== 'split_catalog')
                              .concat([{ id: 'sub_contract', label: 'Sub Contract', inhouse: 0, isTrafficCatalog: false }])
                              .sort((a, b) => {
                                // Keep "All" at the top, then sort rest alphabetically
                                if (a.id === 'all') return -1;
                                if (b.id === 'all') return 1;
                                return a.label.localeCompare(b.label);
                              });
                            
                            return (
                              <Autocomplete
                                sx={{ width: '50%' }}
                                id="normal-catalog-type"
                                options={filteredCatalogTypes}
                                value={values.split_catalog_type || splitOrderCatalogTypes.find((type) => type.id === 'all')}
                                onChange={(event, newValue) => {
                                  const finalValue = newValue || splitOrderCatalogTypes.find((type) => type.id === 'all')
                                  setFieldValue('split_catalog_type', finalValue)
                                  console.log('Normal catalog type changed:', finalValue)
                                // markUnsavedChanges();();
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label="Catalog Type"
                                    placeholder="Select catalog type"
                                    error={Boolean(touched.split_catalog_type && errors.split_catalog_type)}
                                    helperText={touched.split_catalog_type && errors.split_catalog_type}
                                  />
                                )}
                                getOptionLabel={(option) => option.label}
                              />
                            );
                          })()
                        }
                      </Stack>
                      {/* )} */}
                      <LabelStyle>Selected Products</LabelStyle>
                      {openEdit && (
                        <>
                          <QuotationGroupDialogs
                            openAddToGroupModal={openAddToGroupModal}
                            setOpenAddToGroupModal={setOpenAddToGroupModal}
                            addToGroupOptions={addToGroupOptions}
                            addToGroupId={addToGroupId}
                            setAddToGroupId={setAddToGroupId}
                            handleAddToExistingGroup={handleAddToExistingGroup}
                            groupSelectedProductIds={groupSelectedProductIds}
                            openGroupCatalogSourceModal={openGroupCatalogSourceModal}
                            resetGroupCatalogSourceModal={resetGroupCatalogSourceModal}
                            showGroupCatalogCreateForm={showGroupCatalogCreateForm}
                            groupCatalogCustomName={groupCatalogCustomName}
                            setGroupCatalogCustomName={setGroupCatalogCustomName}
                            groupCatalogCustomDescription={groupCatalogCustomDescription}
                            setGroupCatalogCustomDescription={setGroupCatalogCustomDescription}
                            groupCatalogCreateError={groupCatalogCreateError}
                            setGroupCatalogCreateError={setGroupCatalogCreateError}
                            getCatalogSourceDropdownOptions={getCatalogSourceDropdownOptionsForModal}
                            groupCatalogSourceInputValue={groupCatalogSourceInputValue}
                            setGroupCatalogSourceInputValue={setGroupCatalogSourceInputValue}
                            setGroupCatalogSourceIndexId={setGroupCatalogSourceIndexId}
                            setGroupCatalogCustomSourceId={setGroupCatalogCustomSourceId}
                            setShowGroupCatalogCreateForm={setShowGroupCatalogCreateForm}
                            groupCatalogCustomSourceId={groupCatalogCustomSourceId}
                            customCatalogGroupSources={customCatalogGroupSources}
                            groupCatalogSourceIndexId={groupCatalogSourceIndexId}
                            getSelectedLineCatalogProducts={(selectedIds) =>
                              getSelectedLineCatalogProducts(selectedProducts, selectedIds)
                            }
                            handleCancelGroupCatalogCreate={handleCancelGroupCatalogCreate}
                            handleCreateCustomCatalogGroup={handleCreateCustomCatalogGroup}
                            buildGroupFromSelection={buildGroupFromSelection}
                          />
                          <QuotationGroupActionBar
                            groupSelectedProductIds={groupSelectedProductIds}
                            groupEditMode={groupEditMode}
                            selectedProducts={selectedProducts}
                            handleCreateGroupFromSelection={handleCreateGroupFromSelection}
                            setOpenAddToGroupModal={setOpenAddToGroupModal}
                          />
                        </>
                      )}
                      <Scrollbar>
                        <TableContainer sx={{ minWidth: 500 }}>
                          <Table>
                            <TableHead>
                              <TableRow>
                                  {openEdit && (
                                    <TableCell padding="checkbox" sx={{ width: 40 }} />
                                  )}
                                  {openEdit && (
                                    <TableCell padding="checkbox" sx={{ width: 40 }} />
                                  )}
                                  {VALUE?.map((val) => (
                                    val.id === 10 ? (
                                      <Tooltip key={val.id} title="Product Formula Cost Per Unit * Quantity">
                                        <TableCell>{val.value}</TableCell>
                                      </Tooltip>
                                    ) : (val.id === 14 ? (
                                      <Tooltip key={val.id} title="Selling Price With Marketing Adjustment">
                                        <TableCell>{val.value}</TableCell>
                                      </Tooltip> )
                                     : val.id === 20 ? (
                                      // Markup column - only show for non-split orders
                                      !isSplitOrder ? (
                                        <TableCell key={val.id}>{val.value}</TableCell>
                                      ) : null
                                    ) : val.id === 16 ? (
                                      // Conditionally show Split Markup / Incoming Percentage column
                                      isSplitOrder ? (
                                        <TableCell key={val.id}>{val.value}</TableCell>
                                      ) : null
                                    ) : (
                                      <TableCell key={val.id} sx={getViewQuotationProductTableColSx(val.id)}>
                                        {val.value}
                                      </TableCell>
                                    ))
                                  ))}
                                {/* {VALUE?.map((val) => (
                                  <TableCell>{val.value}</TableCell>
                                ))} */}
                              </TableRow>
                            </TableHead>
                            <DragDropContext onDragEnd={handleProductTableDragEnd}>
                              <Droppable droppableId="view-quotation-product-rows">
                                {(droppableProvided) => (
                            <TableBody
                              ref={droppableProvided.innerRef}
                              {...droppableProvided.droppableProps}
                            >
                               {productTableBodyRenderOrder.map((bodyItem, index) => {
                                  // Sl No follows render order (groups + ungrouped products share one sequence).
                                  const displaySlNo = index + 1
                                  if (bodyItem.type === 'group') {
                                    const group = groupedProductsMap.get(bodyItem.groupId)
                                    if (!group) return null
                                    const anchorId = getGroupAnchorIndexId(group)
                                    const groupMemberProducts = (selectedProducts || []).filter(
                                      (p) =>
                                        String(resolveProductGroupId(p) || '') === String(group.id),
                                    )
                                    // Notes are edited against `selectedProducts`, so the anchor product
                                    // (used to show the Group Install Price note icon state) must also
                                    // come from `selectedProducts` to avoid stale `group.products` values.
                                    const anchorProduct =
                                      groupMemberProducts.find(
                                        (p) => Number(p?.indexId) === Number(anchorId),
                                      ) ||
                                      groupMemberProducts[0] ||
                                      (group.products || []).find(
                                        (p) => Number(p?.indexId) === Number(anchorId),
                                      ) ||
                                      (group.products || [])[0]
                                    const groupDisplayNote =
                                      groupMemberProducts.find(
                                        (p) =>
                                          p?.product_notes != null &&
                                          String(p.product_notes).trim() !== '',
                                      )?.product_notes || ''
                                    const groupInstallNotes = getGroupInstallNotesDisplay(
                                      groupMemberProducts.length
                                        ? groupMemberProducts
                                        : group.products || [],
                                    )
                                    const hasGroupInstallNotes = Boolean(
                                      groupInstallNotes && String(groupInstallNotes).trim(),
                                    )
                                    const isGroupOpen = openGroupedRows?.[group.id] === true
                                    const groupQty = Number(group.groupQuantity || 1)
                                    const groupFormulaEach = Number(group.totalProductFormulaEach || 0)
                                    const groupRetailEach = Number(group.adjustedGroupRetailEach || 0)
                                    const groupSubTotal = Number(group.adjustedGroupSubtotal || 0)
                                    const groupInstallSubtotal = Number(group.adjustedGroupInstallSubtotal || 0)
                                    const groupTotal = Number(group.adjustedGroupTotal || 0)
                                    const visibleColumnCount = visibleValueColumns.length
                                    const groupHasAnyQuickbooks = (group.products || []).some(
                                      (p) => Number(p?.syncWithQuickbooks) === 1,
                                    )
                                    const {
                                      isGroupProductLosingMoney,
                                      isGroupInstallLosingMoney,
                                    } = getGroupLosingMoneyFlags(group)
                                    const groupProductLosingMoneyRowSx = getLosingMoneyRowSx(
                                      isGroupProductLosingMoney,
                                    )
                                    const groupInstallLosingMoneyRowSx = getLosingMoneyRowSx(
                                      isGroupInstallLosingMoney,
                                    )
                                    return (
                                      <Draggable
                                        key={`group-${group.id}`}
                                        draggableId={`group-${group.id}`}
                                        index={index}
                                        isDragDisabled={!openEdit}
                                      >
                                        {(provided, snapshot) => (
                                      <React.Fragment key={`group-${group.id}`}>
                                        <TableRow
                                          ref={provided.innerRef}
                                          {...provided.draggableProps}
                                          onDragEnterCapture={(e) =>
                                            anchorId != null && handleProductIconDragOver(e, anchorId)
                                          }
                                          onDragOverCapture={(e) =>
                                            anchorId != null && handleProductIconDragOver(e, anchorId)
                                          }
                                          onDragLeave={(e) =>
                                            anchorId != null && handleProductIconDragLeave(e, anchorId)
                                          }
                                          onDropCapture={(e) =>
                                            anchorId != null && handleProductIconDrop(e, anchorId)
                                          }
                                          sx={{
                                            ...(groupProductLosingMoneyRowSx || groupInstallLosingMoneyRowSx),
                                            ...getGroupRowAlignSx(),
                                            ...(anchorId != null && productAttachmentDragOver[anchorId] && {
                                              backgroundColor: 'action.hover',
                                              outline: `2px dashed ${theme.palette.primary.main}`,
                                              outlineOffset: -2,
                                            }),
                                          }}
                                          style={{
                                            ...provided.draggableProps.style,
                                            ...(snapshot.isDragging
                                              ? { backgroundColor: theme.palette.action.hover }
                                              : {}),
                                          }}
                                        >
                                          {openEdit && (
                                            <TableCell
                                              padding="checkbox"
                                              {...provided.dragHandleProps}
                                              sx={{ width: 40, cursor: 'grab' }}
                                            >
                                              <DragIndicator fontSize="small" color="action" />
                                            </TableCell>
                                          )}
                                          {openEdit && <TableCell padding="checkbox" />}
                                          {visibleValueColumns?.map((val) => {
                                            if (val.id === 0) {
                                              return (
                                                <TableCell key={`g-${group.id}-c0`} sx={{ fontWeight: 700 }}>
                                                  <Stack direction="row" spacing={1} alignItems="center">
                                                   <IconButton
                                                      size="small"
                                                      sx={{ color: 'primary.main' }}
                                                      onClick={() =>
                                                        setOpenGroupedRows((prev) => ({
                                                          ...prev,
                                                          [group.id]: !(prev?.[group.id] === true),
                                                        }))
                                                      }
                                                    >
                                                      {isGroupOpen ? <Remove fontSize="medium" /> : <Add fontSize="medium" />}
                                                 </IconButton>
                                                    <span>#{displaySlNo}</span>
                                                  </Stack>
                                                </TableCell>
                                              )
                                            }
                                            if (val.id === 22) {
                                              return (
                                                <TableCell key={`g-${group.id}-c22`}>
                                                  <div
                                                    style={{
                                                      display: 'flex',
                                                      alignItems: 'center',
                                                      justifyContent: 'center',
                                                      width: 40,
                                                      height: 20,
                                                    }}
                                                  >
                                                    {groupHasAnyQuickbooks ? (
                                                      <img
                                                        src={quickbookLogo}
                                                        alt="QuickBooks"
                                                        style={{
                                                          width: '100%',
                                                          height: '100%',
                                                          objectFit: 'contain',
                                                        }}
                                                      />
                                                    ) : null}
                                                  </div>
                                                </TableCell>
                                              )
                                            }
                                            if (val.id === 1) {
                                              return (
                                                <TableCell
                                                  key={`g-${group.id}-c1`}
                                                  sx={{ fontWeight: 700, ...getViewQuotationProductTableColSx(1) }}
                                                >
                                                  <Box>
                                                    {groupEditMode?.[group.id] ? (
                                                      <TextField
                                                        variant="outlined"
                                                        size="small"
                                                        fullWidth
                                                        value={groupNameDraft.getValue(group.id, group.name || '')}
                                                        onChange={(e) =>
                                                          groupNameDraft.handleChange(group.id, e.target.value)
                                                        }
                                                        onBlur={() => groupNameDraft.commit(group.id)}
                                                      />
                                                    ) : (
                                                      <Typography sx={{ fontWeight: 700 }}>
                                                        {group.name || 'Group'}
                                                      </Typography>
                                                    )}
                                                    {groupDisplayNote ? (
                                                      <Typography
                                                        sx={{
                                                          color: isSplitOrder
                                                            ? theme.palette[
                                                                FacilityTypes.find(
                                                                  (f) =>
                                                                    f.id === anchorProduct?.facility_id,
                                                                )?.color || 'primary'
                                                              ]?.main
                                                            : theme.palette.error.main,
                                                          whiteSpace: 'pre-wrap',
                                                        }}
                                                      >
                                                        Note: {groupDisplayNote}
                                                      </Typography>
                                                    ) : null}
                                                  </Box>
                                                </TableCell>
                                              )
                                            }
                                            if (val.id === 25) {
                                              return (
                                                <TableCell
                                                  key={`g-${group.id}-c25`}
                                                  sx={getViewQuotationProductTableColSx(25)}
                                                >
                                                  {groupEditMode?.[group.id] ? (
                                                    <TextField
                                                      variant="outlined"
                                                      size="small"
                                                      fullWidth
                                                      multiline
                                                      value={groupDescDraft.getValue(group.id, group.description || '')}
                                                      placeholder="Description"
                                                      onChange={(e) =>
                                                        groupDescDraft.handleChange(group.id, e.target.value)
                                                      }
                                                      onBlur={() => groupDescDraft.commit(group.id)}
                                                    />
                                                  ) : (
                                                    <Typography
                                                      sx={{
                                                        whiteSpace: 'pre-wrap',
                                                        wordBreak: 'break-word',
                                                        color: 'inherit',
                                                      }}
                                                    >
                                                      {group.description || '-'}
                                                    </Typography>
                                                  )}
                                                </TableCell>
                                              )
                                            }
                                            if (val.id === 2) {
                                              return (
                                                <TableCell key={`g-${group.id}-c2`}>
                                                  <Stack direction="row" spacing={1} alignItems="center">
                                                    {anchorId != null ? (
                                                      <IconButton
                                                        size="small"
                                                        onClick={() =>
                                                          handleOpenGroupNote(
                                                            anchorId,
                                                            groupDisplayNote || '',
                                                          )
                                                        }
                                                      >
                                                        <NoteAdd
                                                          sx={{
                                                            color:
                                                              !groupDisplayNote
                                                                ? ''
                                                                : theme.palette.primary.main,
                                                          }}
                                                        />
                                                      </IconButton>
                                                    ) : null}
                                                    {/* <Typography variant="body2" color="text.secondary">
                                                      {group.products?.length || 0} items
                                                    </Typography> */}
                                                  </Stack>
                                                </TableCell>
                                              )
                                            }
                                            if (val.id === 19) {
                                              return (
                                                <TableCell key={`g-${group.id}-c19`}>
                                                  {anchorId != null ? (
                                                    <Tooltip title="Drop files on row or click to open attachments">
                                                      <IconButton
                                                        onClick={() =>
                                                          handleOpenGroupAttachment(anchorId)
                                                        }
                                                      >
                                                        {isUploadingProduct[String(anchorId)] ? (
                                                          <CircularProgress size={34} />
                                                        ) : (
                                                          <UploadFile
                                                            sx={{
                                                              color:
                                                                getProductAttachmentsList(anchorId).length === 0
                                                                  ? 'error.main'
                                                                  : theme.palette.primary.main,
                                                            }}
                                                          />
                                                        )}
                                                      </IconButton>
                                                    </Tooltip>
                                                  ) : (
                                                    '-'
                                                  )}
                                                </TableCell>
                                              )
                                            }
                                            if (val.id === 4) return <TableCell key={`g-${group.id}-c4`}>{Number(groupFormulaEach || 0).toFixed(2)}</TableCell>
                                            if (val.id === 20 || val.id === 16) return <TableCell key={`g-${group.id}-c${val.id}`}>-</TableCell>
                                            if (val.id === 5 || val.id === 6) {
                                              const isRetailIteration =
                                                (markupType == 2 && val.id === 5) || (markupType == 1 && val.id === 6)
                                              if (!isRetailIteration) return null
                                              return (
                                                <React.Fragment key={`g-${group.id}-retail-pair`}>
                                                  <TableCell key={`g-${group.id}-c5`}>
                                                    {hasMarkupPermission && markupType == 2
                                                      ? formatRetailPriceDisplay(groupRetailEach || 0)
                                                      : null}
                                                    {/* {hasMarkupPermission && markupType == 2 ? (
                                                      <TextField
                                                        required
                                                        fullWidth
                                                        type="number"
                                                        label={'Retail Price Each'}
                                                        disabled={values.project_category?.name == 'Time & Material' ? true : false}
                                                        sx={{ width: 120 }}
                                                        value={
                                                          groupProductRetailDrafts[group.id] != null &&
                                                          groupProductRetailDrafts[group.id] !== ''
                                                            ? limitDecimalInput(
                                                                groupProductRetailDrafts[group.id],
                                                              )
                                                            : formatRetailPriceDisplay(
                                                                groupRetailEach || 0,
                                                              )
                                                        }
                                                        onFocus={selectInputValue}
                                                        onClick={selectInputValue}
                                                        onKeyPress={(event) => {
                                                          if (event.key === '-') {
                                                            event.preventDefault()
                                                          }
                                                          if (event.key === 'e') {
                                                            event.preventDefault()
                                                          }
                                                        }}
                                                        inputProps={{ min: 0 }}
                                                        defaultValue={0}
                                                        onChange={(event) => {
                                                          handleGroupRetailPriceChange(
                                                            group.id,
                                                            event.target.value,
                                                          )
                                                        }}
                                                        onBlur={(event) => {
                                                          handleGroupRetailPriceChange(
                                                            group.id,
                                                            event.target.value,
                                                            { isBlur: true },
                                                          )
                                                        }}
                                                      />
                                                    ) : null} */}
                                                  </TableCell>
                                                  <TableCell key={`g-${group.id}-c6`}>
                                                    {hasMarkupPermission && markupType == 1
                                                      ? formatRetailPriceDisplay(groupRetailEach || 0)
                                                      : null}
                                                    {/* {hasMarkupPermission && markupType == 1 ? (
                                                      <TextField
                                                        required
                                                        fullWidth
                                                        type="number"
                                                        label={'Retail Price Each'}
                                                        disabled={values.project_category?.name == 'Time & Material' ? true : false}
                                                        sx={{ width: 120 }}
                                                        value={
                                                          groupProductRetailDrafts[group.id] != null &&
                                                          groupProductRetailDrafts[group.id] !== ''
                                                            ? limitDecimalInput(
                                                                groupProductRetailDrafts[group.id],
                                                              )
                                                            : formatRetailPriceDisplay(
                                                                groupRetailEach || 0,
                                                              )
                                                        }
                                                        onFocus={selectInputValue}
                                                        onClick={selectInputValue}
                                                        onKeyPress={(event) => {
                                                          if (event.key === '-') {
                                                            event.preventDefault()
                                                          }
                                                          if (event.key === 'e') {
                                                            event.preventDefault()
                                                          }
                                                        }}
                                                        inputProps={{ min: 0 }}
                                                        defaultValue={0}
                                                        onChange={(event) => {
                                                          handleGroupRetailPriceChange(
                                                            group.id,
                                                            event.target.value,
                                                          )
                                                        }}
                                                        onBlur={(event) => {
                                                          handleGroupRetailPriceChange(
                                                            group.id,
                                                            event.target.value,
                                                            { isBlur: true },
                                                          )
                                                        }}
                                                      />
                                                    ) : null} */}
                                                  </TableCell>
                                                </React.Fragment>
                                              )
                                            }
                                            if (val.id === 9) {
                                              return (
                                                <React.Fragment key={`g-${group.id}-c9-wrap`}>
                                                  {groupedTableNeedsRetailPads ? (
                                                    <>
                                                      <TableCell key={`g-${group.id}-c5-pad`} />
                                                      <TableCell key={`g-${group.id}-c6-pad`} />
                                                    </>
                                                  ) : null}
                                                  <TableCell key={`g-${group.id}-c9`}>
                                                    <TextField
                                                      type="number"
                                                      // size="small"
                                                      sx={{ minWidth: 84 }}
                                                      label="Qty"
                                                      InputLabelProps={{ shrink: true }}
                                                      value={groupQty}
                                                      onChange={(event) =>
                                                        handleGroupQuantityChange(group.id, event.target.value)
                                                      }
                                                    />
                                                  </TableCell>
                                                </React.Fragment>
                                              )
                                            }
                                            if (val.id === 10) {
                                              return (
                                                <TableCell key={`g-${group.id}-c10`}>
                                                  {anchorId != null ? (
                                                    <IconButton
                                                      size="small"
                                                      onClick={() =>
                                                        setLocationStates((prev) => ({
                                                          ...prev,
                                                          [anchorId]: true,
                                                        }))
                                                      }
                                                    >
                                                      <LocationOn
                                                        sx={{
                                                          color:
                                                            anchorProduct?.location?.some((obj) =>
                                                              [obj.address, obj.city, obj.state, obj.zip].some(
                                                                (value) => value === '' || value === null,
                                                              ),
                                                            )
                                                              ? ''
                                                              : theme.palette.primary.main,
                                                        }}
                                                      />
                                                    </IconButton>
                                                  ) : (
                                                    '-'
                                                  )}
                                                </TableCell>
                                              )
                                            }
                                            if (val.id === 11) {
                                              return (
                                                <TableCell key={`g-${group.id}-c11`}>
                                                  <Stack direction="row" spacing={1} alignItems="center">
                                                    <Remove
                                                      fontSize="small"
                                                      style={{ cursor: 'pointer' }}
                                                      onClick={() => handleGroupMarketingTypeChange(group.id, false)}
                                                    />
                                                    <Switch
                                                      checked={
                                                          !(
                                                            group.groupAdjValueType === false ||
                                                            Number(group.groupAdjValueType) === 0
                                                          )
                                                      }
                                                      onChange={(event) =>
                                                        handleGroupMarketingTypeChange(group.id, event.target.checked)
                                                      }
                                                    />
                                                    <Add
                                                      fontSize="small"
                                                      style={{ cursor: 'pointer' }}
                                                      onClick={() => handleGroupMarketingTypeChange(group.id, true)}
                                                    />
                                                  </Stack>
                                                </TableCell>
                                              )
                                            }
                                            if (val.id === 15) {
                                              const groupProductMarketing =
                                                groupProductMarketingValues?.[group.id] || {}
                                              const groupAdjustmentDisplay =
                                                getGroupProductMarketingAdjustmentDisplay(
                                                  groupProductMarketing,
                                                  group.groupAdjustment,
                                                )
                                              return (
                                                <TableCell key={`g-${group.id}-c15`}>
                                                  <TextField
                                                    type="number"
                                                    // size="small"
                                                    fullWidth
                                                    inputProps={{ min: 0 }}
                                                    label="$"
                                                    value={groupAdjustmentDisplay}
                                                    InputLabelProps={{
                                                      shrink: Boolean(
                                                        groupProductMarketing.adjustment_draft !==
                                                        undefined
                                                          ? groupProductMarketing.adjustment_draft !==
                                                            ''
                                                          : Number(group.groupAdjustment),
                                                      ),
                                                    }}
                                                    onWheel={(e) => e.target.blur()}
                                                    onBeforeInput={(e) => {
                                                      const nextValue = e.target.value
                                                      const adjValueType =
                                                        groupProductMarketingValues?.[group.id]?.adjValueType ??
                                                        group.groupAdjValueType ??
                                                        true
                                                      const isNegative =
                                                        adjValueType === false || Number(adjValueType) === 0
                                                      if (!isNegative) return
                                                      const hasPermission = explodedPermissions?.some((permission) =>
                                                        ['Allow Negative Marketing Adjustment Estimate'].includes(permission),
                                                      )
                                                      const { maxNegative } = getGroupMaxNegativeAdjustment(
                                                        group,
                                                        hasPermission,
                                                      )
                                                      if (Number(nextValue) >= maxNegative && hasPermission) {
                                                        e.preventDefault()
                                                        enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
                                                      } else if (Number(nextValue) > maxNegative && !hasPermission) {
                                                        e.preventDefault()
                                                        enqueueSnackbar(
                                                          `Negative Adjustment Amount cannot reduce total below Product Formula Cost. Max allowed: $${Number(maxNegative).toFixed(2)}`,
                                                          { variant: 'error' },
                                                        )
                                                      }
                                                    }}
                                                    onChange={(event) =>
                                                      handleGroupMarketingAdjustmentChange(
                                                        group.id,
                                                        event.target.value,
                                                        group.groupAdjValueType,
                                                      )
                                                    }
                                                    onBlur={(event) =>
                                                      handleGroupMarketingAdjustmentChange(
                                                        group.id,
                                                        event.target.value,
                                                        group.groupAdjValueType,
                                                        { isBlur: true },
                                                      )
                                                    }
                                                    onKeyDown={(event) => {
                                                      if (event.key === '-' || event.key === '+') {
                                                        event.preventDefault()
                                                      }
                                                    }}
                                                  />
                                                </TableCell>
                                              )
                                            }
                                            if (val.id === 12) {
                                              return (
                                                <TableCell key={`g-${group.id}-c${val.id}`}>
                                                  {fUSPrice(Number(groupSubTotal || 0).toFixed(2))}
                                                </TableCell>
                                              )
                                            }
                                            if (val.id === 14) {
                                              return (
                                                <TableCell key={`g-${group.id}-c14`}>
                                                  {Number(groupInstallSubtotal || 0) > 0
                                                    ? ''
                                                    : Number(groupTotal || 0).toFixed(2)}
                                                </TableCell>
                                              )
                                            }
                                            if (val.id === 13) {
                                              return (
                                                <TableCell
                                                  key={`g-${group.id}-c13`}
                                                  align="center"
                                                  sx={QUOTATION_ROW_DELETE_CELL_SX}
                                                >
                                                  {anchorProduct?.fromMapServices == true ? (
                                                    ''
                                                  ) : (
                                                    <Box sx={QUOTATION_ROW_ACTIONS_BOX_SX}>
                                                      <Box sx={QUOTATION_ROW_ACTIONS_LEADING_SLOT_SX}>
                                                        {openEdit ? (
                                                          <GroupEditActionButtons
                                                            isDesignTable={false}
                                                            isEditing={!!groupEditMode?.[group.id]}
                                                            onEdit={() => handleGroupEditClick(group)}
                                                            onUpdate={() => handleGroupUpdateClick(group)}
                                                            onCancel={() => handleGroupCancelEditClick(group)}
                                                          />
                                                        ) : null}
                                                      </Box>
                                                      <GroupDeleteIconButton
                                                        isDesignTable={false}
                                                        onClick={() => handleDeleteGroup(group.id)}
                                                      />
                                                    </Box>
                                                  )}
                                                </TableCell>
                                              )
                                            }
                                            return <TableCell key={`g-${group.id}-cx-${val.id}`}>-</TableCell>
                                          })}
                                        </TableRow>
                                        {Number(groupInstallSubtotal || 0) > 0 ? (
                                          <TableRow sx={{ ...(groupInstallLosingMoneyRowSx || groupProductLosingMoneyRowSx), ...getGroupRowAlignSx() }}>
                                            {openEdit && <TableCell padding="checkbox" />}
                                            {openEdit && <TableCell padding="checkbox" />}
                                            {visibleValueColumns?.map((val) => {
                                              if (val.id === 0 || val.id === 10) {
                                                return (
                                                  <TableCell key={`gi-${group.id}-c${val.id}`}>
                                                    -
                                                  </TableCell>
                                                )
                                              }
                                              if (val.id === 22) {
                                                return <TableCell key={`gi-${group.id}-c22`} />
                                              }
                                              if (val.id === 13) {
                                                return (
                                                  <TableCell
                                                    key={`gi-${group.id}-c13`}
                                                    align="center"
                                                    sx={QUOTATION_ROW_DELETE_CELL_SX}
                                                  >
                                                    <Box sx={QUOTATION_ROW_ACTIONS_BOX_SX}>
                                                      <Box sx={QUOTATION_ROW_ACTIONS_LEADING_SLOT_SX} />
                                                      <GroupDeleteIconButton
                                                        isDesignTable={false}
                                                        onClick={() => handleDeleteGroupInstall(group.id)}
                                                      />
                                                    </Box>
                                                  </TableCell>
                                                )
                                              }
                                              if (val.id === 1) {
                                                return (
                                                  <TableCell
                                                    key={`gi-${group.id}-c1`}
                                                    sx={{ fontWeight: 600 }}
                                                  >
                                                    <Typography
                                                      sx={
                                                        hasGroupInstallNotes
                                                          ? {
                                                              color: 'red',
                                                              whiteSpace: 'pre-wrap',
                                                              wordBreak: 'break-word',
                                                            }
                                                          : undefined
                                                      }
                                                    >
                                                      {hasGroupInstallNotes
                                                        ? groupInstallNotes
                                                        : 'Install Price'}
                                                    </Typography>
                                                  </TableCell>
                                                )
                                              }
                                              if (val.id === 2) {
                                                return (
                                                  <TableCell key={`gi-${group.id}-c2`}>
                                                    {anchorId != null ? (
                                                      <IconButton
                                                        size="small"
                                                        onClick={() =>
                                                          handleOpenGroupInstallNote(
                                                            anchorId,
                                                            groupInstallNotes ||
                                                              anchorProduct?.install_notes ||
                                                              '',
                                                          )
                                                        }
                                                      >
                                                        <NoteAdd
                                                          sx={{
                                                            color: hasGroupInstallNotes
                                                              ? theme.palette.primary.main
                                                              : '',
                                                          }}
                                                        />
                                                      </IconButton>
                                                    ) : (
                                                      '-'
                                                    )}
                                                  </TableCell>
                                                )
                                              }
                                              if (val.id === 19) return <TableCell key={`gi-${group.id}-c19`}>-</TableCell>
                                              if (val.id === 4) {
                                                const installFormulaEach = (group.products || []).reduce(
                                                  (sum, p) =>
                                                    sum +
                                                    Number(
                                                      p?.install_formula_cost_each != null &&
                                                        p?.install_formula_cost_each !== ''
                                                        ? p.install_formula_cost_each
                                                        : p?.expected_install_labor_cost_with_markup || 0,
                                                    ),
                                                  0,
                                                )
                                                return <TableCell key={`gi-${group.id}-c4`} sx={{ fontWeight: 600 }}>{installFormulaEach.toFixed(2)}</TableCell>
                                              }
                                              if (val.id === 20 || val.id === 16) return <TableCell key={`gi-${group.id}-c${val.id}`}>-</TableCell>
                                              if (val.id === 5 || val.id === 6) {
                                                const isRetailIteration =
                                                  (markupType == 2 && val.id === 5) || (markupType == 1 && val.id === 6)
                                                if (!isRetailIteration) return null
                                                const installRetailEach = Number(group.adjustedGroupInstallRetailEach || 0)
                                                return (
                                                  <React.Fragment key={`gi-${group.id}-retail-pair`}>
                                                    <TableCell key={`gi-${group.id}-c5`} sx={{ fontWeight: 600 }}>
                                                      {hasMarkupPermission && markupType == 2
                                                        ? formatRetailPriceDisplay(installRetailEach)
                                                        : null}
                                                      {/* {hasMarkupPermission && markupType == 2 ? (
                                                        <TextField
                                                          required
                                                          fullWidth
                                                          type="number"
                                                          label={'Install Price Each'}
                                                          sx={{ width: 120 }}
                                                          value={
                                                            groupInstallRetailDrafts[group.id] != null &&
                                                            groupInstallRetailDrafts[group.id] !== ''
                                                              ? limitDecimalInput(
                                                                  groupInstallRetailDrafts[group.id],
                                                                )
                                                              : formatRetailPriceDisplay(
                                                                  installRetailEach,
                                                                )
                                                          }
                                                          onFocus={selectInputValue}
                                                          onClick={selectInputValue}
                                                          onKeyPress={(event) => {
                                                            if (event.key === '-') {
                                                              event.preventDefault()
                                                            }
                                                            if (event.key === 'e') {
                                                              event.preventDefault()
                                                            }
                                                          }}
                                                          inputProps={{ min: 0 }}
                                                          defaultValue={0}
                                                          onChange={(event) => {
                                                            handleGroupInstallRetailPriceChange(
                                                              group.id,
                                                              event.target.value,
                                                            )
                                                          }}
                                                          onBlur={(event) => {
                                                            handleGroupInstallRetailPriceChange(
                                                              group.id,
                                                              event.target.value,
                                                              { isBlur: true },
                                                            )
                                                          }}
                                                        />
                                                      ) : null} */}
                                                    </TableCell>
                                                    <TableCell key={`gi-${group.id}-c6`} sx={{ fontWeight: 600 }}>
                                                      {hasMarkupPermission && markupType == 1
                                                        ? formatRetailPriceDisplay(installRetailEach)
                                                        : null}
                                                      {/* {hasMarkupPermission && markupType == 1 ? (
                                                        <TextField
                                                          required
                                                          fullWidth
                                                          type="number"
                                                          label={'Install Price Each'}
                                                          sx={{ width: 120 }}
                                                          value={
                                                            groupInstallRetailDrafts[group.id] != null &&
                                                            groupInstallRetailDrafts[group.id] !== ''
                                                              ? limitDecimalInput(
                                                                  groupInstallRetailDrafts[group.id],
                                                                )
                                                              : formatRetailPriceDisplay(
                                                                  installRetailEach,
                                                                )
                                                          }
                                                          onFocus={selectInputValue}
                                                          onClick={selectInputValue}
                                                          onKeyPress={(event) => {
                                                            if (event.key === '-') {
                                                              event.preventDefault()
                                                            }
                                                            if (event.key === 'e') {
                                                              event.preventDefault()
                                                            }
                                                          }}
                                                          inputProps={{ min: 0 }}
                                                          defaultValue={0}
                                                          onChange={(event) => {
                                                            handleGroupInstallRetailPriceChange(
                                                              group.id,
                                                              event.target.value,
                                                            )
                                                          }}
                                                          onBlur={(event) => {
                                                            handleGroupInstallRetailPriceChange(
                                                              group.id,
                                                              event.target.value,
                                                              { isBlur: true },
                                                            )
                                                          }}
                                                        />
                                                      ) : null} */}
                                                    </TableCell>
                                                  </React.Fragment>
                                                )
                                              }
                                              if (val.id === 9) {
                                                return (
                                                  <React.Fragment key={`gi-${group.id}-c9-wrap`}>
                                                    {groupedTableNeedsRetailPads ? (
                                                      <>
                                                        <TableCell key={`gi-${group.id}-c5-pad`} sx={{ fontWeight: 600 }} />
                                                        <TableCell key={`gi-${group.id}-c6-pad`} sx={{ fontWeight: 600 }} />
                                                      </>
                                                    ) : null}
                                                    <TableCell key={`gi-${group.id}-c9`} sx={{ fontWeight: 600 }}>
                                                      <TextField
                                                        type="number"
                                                        // size="small"
                                                        sx={{ minWidth: 84 }}
                                                        label="Qty"
                                                        InputLabelProps={{ shrink: true }}
                                                        value={Number(group.groupInstallQuantity || 1)}
                                                        onChange={(event) =>
                                                          handleGroupInstallQuantityChange(group.id, event.target.value)
                                                        }
                                                      />
                                                    </TableCell>
                                                  </React.Fragment>
                                                )
                                              }
                                              if (val.id === 11) {
                                                return (
                                                  <TableCell key={`gi-${group.id}-c11`}>
                                                    <Stack direction="row" spacing={1} alignItems="center">
                                                      <Remove
                                                        fontSize="small"
                                                        style={{ cursor: 'pointer' }}
                                                        onClick={() => handleGroupInstallMarketingTypeChange(group.id, false)}
                                                      />
                                                      <Switch
                                                        checked={
                                                          !(
                                                            group.groupInstallAdjValueType === false ||
                                                            Number(group.groupInstallAdjValueType) === 0
                                                          )
                                                        }
                                                        onChange={(event) =>
                                                          handleGroupInstallMarketingTypeChange(
                                                            group.id,
                                                            event.target.checked,
                                                          )
                                                        }
                                                      />
                                                      <Add
                                                        fontSize="small"
                                                        style={{ cursor: 'pointer' }}
                                                        onClick={() => handleGroupInstallMarketingTypeChange(group.id, true)}
                                                      />
                                                    </Stack>
                                                  </TableCell>
                                                )
                                              }
                                              if (val.id === 15) {
                                                const groupInstallMarketing =
                                                  groupInstallMarketingValues?.[group.id] || {}
                                                const groupInstallAdjustmentDisplay =
                                                  getGroupInstallMarketingAdjustmentDisplay(
                                                    groupInstallMarketing,
                                                    group.groupInstallAdjustment,
                                                  )
                                                return (
                                                  <TableCell key={`gi-${group.id}-c15`}>
                                                    <TextField
                                                      type="number"
                                                      // size="small"
                                                      fullWidth
                                                      inputProps={{ min: 0 }}
                                                      label="$"
                                                      value={groupInstallAdjustmentDisplay}
                                                      InputLabelProps={{
                                                        shrink: Boolean(
                                                          groupInstallMarketing.adjustment_draft !==
                                                          undefined
                                                            ? groupInstallMarketing.adjustment_draft !==
                                                              ''
                                                            : Number(group.groupInstallAdjustment),
                                                        ),
                                                      }}
                                                      onWheel={(e) => e.target.blur()}
                                                      onBeforeInput={(e) => {
                                                        const nextValue = e.target.value
                                                        const adjValueType =
                                                          groupInstallMarketingValues?.[group.id]?.adjValueType ??
                                                          group.groupInstallAdjValueType ??
                                                          true
                                                        const isNegative =
                                                          adjValueType === false || Number(adjValueType) === 0
                                                        if (!isNegative) return
                                                        const hasPermission = explodedPermissions?.some((permission) =>
                                                          ['Allow Negative Marketing Adjustment Estimate'].includes(permission),
                                                        )
                                                        const { maxNegative } = getGroupMaxNegativeInstallAdjustment(
                                                          group,
                                                          hasPermission,
                                                        )
                                                        if (Number(nextValue) >= maxNegative && hasPermission) {
                                                          e.preventDefault()
                                                          enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
                                                        } else if (Number(nextValue) > maxNegative && !hasPermission) {
                                                          e.preventDefault()
                                                          enqueueSnackbar(
                                                            `Negative Adjustment Amount cannot reduce total below Install Formula Cost. Max allowed: $${Number(maxNegative).toFixed(2)}`,
                                                            { variant: 'error' },
                                                          )
                                                        }
                                                      }}
                                                      onChange={(event) =>
                                                        handleGroupInstallMarketingAdjustmentChange(
                                                          group.id,
                                                          event.target.value,
                                                          group.groupInstallAdjValueType,
                                                        )
                                                      }
                                                      onBlur={(event) =>
                                                        handleGroupInstallMarketingAdjustmentChange(
                                                          group.id,
                                                          event.target.value,
                                                          group.groupInstallAdjValueType,
                                                          { isBlur: true },
                                                        )
                                                      }
                                                      onKeyDown={(event) => {
                                                        if (event.key === '-' || event.key === '+') {
                                                          event.preventDefault()
                                                        }
                                                      }}
                                                    />
                                                  </TableCell>
                                                )
                                              }
                                              if (val.id === 12) return <TableCell key={`gi-${group.id}-c12`} sx={{ fontWeight: 600 }}>{groupInstallSubtotal.toFixed(2)}</TableCell>
                                              if (val.id === 14) return <TableCell key={`gi-${group.id}-c14`} sx={{ fontWeight: 600 }}>{(groupSubTotal + groupInstallSubtotal).toFixed(2)}</TableCell>
                                              return <TableCell key={`gi-${group.id}-cx-${val.id}`}>-</TableCell>
                                            })}
                                          </TableRow>
                                        ) : null}
                                        <TableRow>
                                          <TableCell
                                            colSpan={
                                              (visibleColumnCount || VALUE?.length || 20) + (openEdit ? 2 : 0)
                                            }
                                            sx={{ p: 0, borderBottom: 0 }}
                                          >
                                            <Collapse in={isGroupOpen} timeout="auto" unmountOnExit>
                                              <Box sx={{ px: 2, py: 2 }}>
                                                <Table size="small">
                                                  <TableHead>
                                                    <TableRow>
                                                      <TableCell padding="checkbox" sx={{ width: 40 }} />
                                                      {VALUE?.map((val) =>
                                                        val.value === null ? null : val.id === 10 ? (
                                                          <Tooltip
                                                            key={`gnh-${group.id}-${val.id}`}
                                                            title="Product Formula Cost Per Unit * Quantity"
                                                          >
                                                            <TableCell sx={{ fontWeight: 600 }}>{val.value}</TableCell>
                                                          </Tooltip>
                                                        ) : val.id === 14 ? (
                                                          <Tooltip
                                                            key={`gnh-${group.id}-${val.id}`}
                                                            title="Selling Price With Marketing Adjustment"
                                                          >
                                                            <TableCell sx={{ fontWeight: 600 }}>{val.value}</TableCell>
                                                          </Tooltip>
                                                        ) : val.id === 20 ? (
                                                          !isSplitOrder ? (
                                                            <TableCell key={`gnh-${group.id}-${val.id}`} sx={{ fontWeight: 600 }}>
                                                              {val.value}
                                                            </TableCell>
                                                          ) : null
                                                        ) : val.id === 16 ? (
                                                          isSplitOrder ? (
                                                            <TableCell key={`gnh-${group.id}-${val.id}`} sx={{ fontWeight: 600 }}>
                                                              {val.value}
                                                            </TableCell>
                                                          ) : null
                                                        ) : (
                                                          <TableCell
                                                            key={`gnh-${group.id}-${val.id}`}
                                                            sx={{ fontWeight: 600, ...getViewQuotationProductTableColSx(val.id) }}
                                                          >
                                                            {val.value}
                                                          </TableCell>
                                                        ),
                                                      )}
                                                    </TableRow>
                                                  </TableHead>
                                                  <TableBody>
                                                    {(group.products || []).map((member, memberIdx) => {
                                                      const quantityDraft =
                                                        groupProductQuantityDrafts[String(member.indexId)] || {}
                                                      const productLocQty =
                                                        Number(
                                                          quantityDraft.group_product_quantity ??
                                                            getGroupMemberProductQty(member),
                                                        ) || 1
                                                      const installQty =
                                                        Number(
                                                          quantityDraft.group_install_quantity ??
                                                            getGroupMemberInstallQty(member),
                                                        ) || 1
                                                      const installRetailEach = Number(member?.install_cost) || 0
                                                      const retailEach =
                                                        markupType == 1
                                                          ? Number(member?.product_price || member?.price || 0)
                                                          : Number(
                                                              member?.actual_retail_price ||
                                                                member?.retail_price ||
                                                                member?.product_retail_price ||
                                                                0,
                                                            )
                                                      const productSubTotal = retailEach * productLocQty
                                                      const installSubTotal = installRetailEach * installQty
                                                      const discountAmount = Number(member?.discount || 0)
                                                      const cellProductTotal = Math.max(
                                                        0,
                                                        productSubTotal + installSubTotal - discountAmount,
                                                      )
                                                      const { isProductLosingMoney, isInstallLosingMoney } =
                                                        getNestedLineLosingMoneyFlags(member, markupType)
                                                      const nestedProductRowSx = getLosingMoneyRowSx(isProductLosingMoney)
                                                      const nestedInstallRowSx = getLosingMoneyRowSx(isInstallLosingMoney)

                                                      return (
                                                        <React.Fragment key={`group-member-${group.id}-${member.indexId}`}>
                                                          <TableRow
                                                            // onDragEnterCapture={(e) =>
                                                            //   handleProductIconDragOver(e, member.indexId)
                                                            // }
                                                            // onDragOverCapture={(e) =>
                                                            //   handleProductIconDragOver(e, member.indexId)
                                                            // }
                                                            // onDragLeave={(e) =>
                                                            //   handleProductIconDragLeave(e, member.indexId)
                                                            // }
                                                            // onDropCapture={(e) =>
                                                            //   handleProductIconDrop(e, member.indexId)
                                                            // }
                                                            sx={{
                                                              ...nestedProductRowSx,
                                                              ...(productAttachmentDragOver[member.indexId] && {
                                                                backgroundColor: 'action.hover',
                                                                outline: `2px dashed ${theme.palette.primary.main}`,
                                                                outlineOffset: -2,
                                                              }),
                                                            }}
                                                          >
                                                            <TableCell padding="checkbox">
                                                              {groupEditMode?.[group.id] &&
                                                              isViewQuotationChooseCatalogRow(member) ? (
                                                                <Checkbox
                                                                  checked={isIndexIdInList(
                                                                    groupSelectedProductIds,
                                                                    member.indexId,
                                                                  )}
                                                                  onChange={() =>
                                                                    toggleGroupProductSelection(member)
                                                                  }
                                                                />
                                                              ) : null}
                                                            </TableCell>
                                                            {VALUE?.map((val) => {
                                                              if (val.value === null) return null
                                                              if (val.id === 20 && isSplitOrder) return null
                                                              if (val.id === 16 && !isSplitOrder) return null
                                                              if (val.id === 0) {
                                                                return (
                                                                  <TableCell key={`gm-${group.id}-${member.indexId}-c0`}>
                                                                    {memberIdx + 1}
                                                                  </TableCell>
                                                                )
                                                              }
                                                              if (val.id === 24) {
                                                                return <TableCell key={`gm-${group.id}-${member.indexId}-c24`} />
                                                              }
                                                              if (val.id === 22) {
                                                                return (
                                                                  <TableCell key={`gm-${group.id}-${member.indexId}-c22`}>
                                                                    <div
                                                                      style={{
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        width: 40,
                                                                        height: 20,
                                                                      }}
                                                                    >
                                                                      {Number(member?.syncWithQuickbooks) === 1 ? (
                                                                        <img
                                                                          src={quickbookLogo}
                                                                          alt="QuickBooks"
                                                                          style={{
                                                                            width: '100%',
                                                                            height: '100%',
                                                                            objectFit: 'contain',
                                                                          }}
                                                                        />
                                                                      ) : null}
                                                                    </div>
                                                                  </TableCell>
                                                                )
                                                              }
                                                              if (val.id === 1) {
                                                                return (
                                                                  <TableCell
                                                                    key={`gm-${group.id}-${member.indexId}-c1`}
                                                                    sx={{
                                                                      ...VIEW_QUOTATION_PRODUCT_TABLE_COL_SX.productName,
                                                                      ...(isProductLosingMoney && {
                                                                        color: `${theme.palette.error.main} !important`,
                                                                      }),
                                                                    }}
                                                                  >
                                                                    {member.product_name || member.name || '-'}
                                                                  </TableCell>
                                                                )
                                                              }
                                                              if (val.id === 25) {
                                                                return (
                                                                  <TableCell
                                                                    key={`gm-${group.id}-${member.indexId}-c25`}
                                                                    sx={VIEW_QUOTATION_PRODUCT_TABLE_COL_SX.productDesc}
                                                                  >
                                                                    {member.product_desc || member.description || ''}
                                                                  </TableCell>
                                                                )
                                                              }
                                                              if (val.id === 2) {
                                                                return (
                                                                  <TableCell key={`gm-${group.id}-${member.indexId}-c2`}>
                                                                    <IconButton disabled size="small">
                                                                      <NoteAdd
                                                                        sx={{
                                                                          color:
                                                                            !member?.product_notes ||
                                                                            member?.product_notes === ''
                                                                              ? ''
                                                                              : theme.palette.primary.main,
                                                                        }}
                                                                      />
                                                                    </IconButton>
                                                                    {/* <IconButton
                                                                      onClick={() =>
                                                                        handleOpenNote(
                                                                          member.indexId,
                                                                          member.product_notes,
                                                                        )
                                                                      }
                                                                    >
                                                                      <NoteAdd
                                                                        sx={{
                                                                          color:
                                                                            !member?.product_notes ||
                                                                            member?.product_notes === ''
                                                                              ? ''
                                                                              : theme.palette.primary.main,
                                                                        }}
                                                                      />
                                                                    </IconButton> */}
                                                                  </TableCell>
                                                                )
                                                              }
                                                              if (val.id === 19) {
                                                                return (
                                                                  <TableCell key={`gm-${group.id}-${member.indexId}-c19`}>
                                                                    <IconButton disabled size="small">
                                                                      <UploadFile
                                                                        sx={{
                                                                          color:
                                                                            getProductAttachmentsList(
                                                                              anchorId,
                                                                            ).length === 0
                                                                              ? 'error.main'
                                                                              : theme.palette.primary.main,
                                                                        }}
                                                                      />
                                                                    </IconButton>
                                                                    {/* <Tooltip title="Drop files on row or click to open attachments">
                                                                      <IconButton
                                                                        onClick={() =>
                                                                          handleOpenAttachment(member.indexId)
                                                                        }
                                                                      >
                                                                        {isUploadingProduct[String(member.indexId)] ? (
                                                                          <CircularProgress size={34} />
                                                                        ) : (
                                                                          <UploadFile
                                                                            sx={{
                                                                              color:
                                                                                getProductAttachmentsList(
                                                                                  anchorId,
                                                                                ).length === 0
                                                                                  ? 'error.main'
                                                                                  : theme.palette.primary.main,
                                                                            }}
                                                                          />
                                                                        )}
                                                                      </IconButton>
                                                                    </Tooltip> */}
                                                                  </TableCell>
                                                                )
                                                              }
                                                              if (val.id === 3) {
                                                                return (
                                                                  <TableCell key={`gm-${group.id}-${member.indexId}-c3`}>
                                                                    {member.recipe_id ? (
                                                                      <IconButton disabled size="small">
                                                                        <span className="heroicons-solid--beaker" />
                                                                      </IconButton>
                                                                    ) : null}
                                                                    {/* {member.recipe_id ? (
                                                                      <Tooltip title="Product Formula">
                                                                        <IconButton
                                                                          onClick={() =>
                                                                            handleOpenProductFormula(
                                                                              member.recipe_id,
                                                                            )
                                                                          }
                                                                        >
                                                                          <span className="heroicons-solid--beaker" />
                                                                        </IconButton>
                                                                      </Tooltip>
                                                                    ) : null} */}
                                                                  </TableCell>
                                                                )
                                                              }
                                                              if (val.id === 4) {
                                                                return (
                                                                  <TableCell key={`gm-${group.id}-${member.indexId}-c4`}>
                                                                    {getSingleProductFormulaCostEach(member).toFixed(2)}
                                                                  </TableCell>
                                                                )
                                                              }
                                                              if (val.id === 20) {
                                                                return (
                                                                  <TableCell key={`gm-${group.id}-${member.indexId}-c20`}>
                                                                    {member.inhouse === 0
                                                                      ? member?.sub_contract_markup != null &&
                                                                        member?.sub_contract_markup !== ''
                                                                        ? `${Number(member.sub_contract_markup).toFixed(2)}`
                                                                        : '-'
                                                                      : '-'}
                                                                  </TableCell>
                                                                )
                                                              }
                                                              if (val.id === 16) {
                                                                return (
                                                                  <TableCell key={`gm-${group.id}-${member.indexId}-c16`}>
                                                                    {member.splitMarkup || 0}
                                                                  </TableCell>
                                                                )
                                                              }
                                                              if (val.id === 5) {
                                                                return (
                                                                  <TableCell key={`gm-${group.id}-${member.indexId}-c5`}>
                                                                    {hasMarkupPermission && markupType == 2
                                                                      ? retailEach.toFixed(2)
                                                                      : null}
                                                                  </TableCell>
                                                                )
                                                              }
                                                              if (val.id === 6) {
                                                                return (
                                                                  <TableCell key={`gm-${group.id}-${member.indexId}-c6`}>
                                                                    {hasMarkupPermission && markupType == 1
                                                                      ? retailEach.toFixed(2)
                                                                      : null}
                                                                  </TableCell>
                                                                )
                                                              }
                                                              if (val.id === 9) {
                                                                return (
                                                                  <TableCell
                                                                    key={`gm-${group.id}-${member.indexId}-c9`}
                                                                    align="center"
                                                                  >
                                                                    {Number(productLocQty)}
                                                                    {/* {groupEditMode?.[group.id] ? (
                                                                      <TextField
                                                                        type="number"
                                                                        size="small"
                                                                        value={productLocQty}
                                                                        label="Qty"
                                                                        onChange={(event) =>
                                                                          handleGroupLineQuantityDraftChange(
                                                                            member.indexId,
                                                                            'group_product_quantity',
                                                                            event.target.value,
                                                                          )
                                                                        }
                                                                        sx={{ width: 80 }}
                                                                      />
                                                                    ) : (
                                                                      Number(productLocQty)
                                                                    )} */}
                                                                  </TableCell>
                                                                )
                                                              }
                                                              if (val.id === 10) {
                                                                return (
                                                                  <TableCell
                                                                    key={`gm-${group.id}-${member.indexId}-c10`}
                                                                    align="center"
                                                                  >
                                                                    <Tooltip
                                                                      title={
                                                                        member?.location
                                                                          ?.map((loc) => loc.address)
                                                                          .filter(Boolean)
                                                                          .join(', ') || 'No locations'
                                                                      }
                                                                    >
                                                                      <LocationOn
                                                                        sx={{
                                                                          color: member?.location?.length
                                                                            ? theme.palette.primary.main
                                                                            : '',
                                                                        }}
                                                                      />
                                                                    </Tooltip>
                                                                  </TableCell>
                                                                )
                                                              }
                                                              if (val.id === 11) {
                                                                return (
                                                                  <TableCell key={`gm-${group.id}-${member.indexId}-c11`}>
                                                                    <Stack
                                                                      direction="row"
                                                                      spacing={1}
                                                                      alignItems="center"
                                                                      sx={{ color: 'text.secondary', opacity: 0.7 }}
                                                                    >
                                                                      <Remove fontSize="small" />
                                                                      <Switch
                                                                        checked={getNestedLineMarketingAdjValueType(
                                                                          member,
                                                                          markupType,
                                                                          'product',
                                                                        )}
                                                                        disabled
                                                                      />
                                                                      <Add fontSize="small" />
                                                                    </Stack>
                                                                  </TableCell>
                                                                )
                                                              }
                                                              if (val.id === 15) {
                                                                return (
                                                                  <TableCell
                                                                    key={`gm-${group.id}-${member.indexId}-c15`}
                                                                    align="center"
                                                                  >
                                                                    {formatNestedMarketingAdjustmentDisplay(
                                                                      getNestedLineMarketingAdjustmentValue(
                                                                        member,
                                                                        markupType,
                                                                        'product',
                                                                      ),
                                                                    )}
                                                                  </TableCell>
                                                                )
                                                              }
                                                              if (val.id === 12) {
                                                                return (
                                                                  <TableCell key={`gm-${group.id}-${member.indexId}-c12`}>
                                                                    ${fUSPrice(productSubTotal.toFixed(2))}
                                                                  </TableCell>
                                                                )
                                                              }
                                                              if (val.id === 14) {
                                                                return (
                                                                  <TableCell key={`gm-${group.id}-${member.indexId}-c14`}>
                                                                    {member?.install_cost
                                                                      ? ''
                                                                      : `$${fUSPrice(cellProductTotal.toFixed(2))}`}
                                                                  </TableCell>
                                                                )
                                                              }
                                                              if (val.id === 13) {
                                                                return (
                                                                  <TableCell key={`gm-${group.id}-${member.indexId}-c13`} />
                                                                )
                                                              }
                                                              return (
                                                                <TableCell key={`gm-${group.id}-${member.indexId}-cx-${val.id}`} />
                                                              )
                                                            })}
                                                          </TableRow>
                                                          {installRetailEach > 0 ? (
                                                            <TableRow sx={nestedInstallRowSx}>
                                                              <TableCell padding="checkbox" />
                                                              {VALUE?.map((val) => {
                                                                if (val.value === null) return null
                                                                if (val.id === 20 && isSplitOrder) return null
                                                                if (val.id === 16 && !isSplitOrder) return null
                                                                if (val.id === 0 || val.id === 24 || val.id === 22) {
                                                                  return (
                                                                    <TableCell key={`gmi-${group.id}-${member.indexId}-c${val.id}`} />
                                                                  )
                                                                }
                                                                if (val.id === 1) {
                                                                  return (
                                                                    <TableCell key={`gmi-${group.id}-${member.indexId}-c1`}>
                                                                      <Typography
                                                                        sx={
                                                                          hasGroupInstallNotes
                                                                            ? {
                                                                                color: 'red',
                                                                                whiteSpace: 'pre-wrap',
                                                                                wordBreak: 'break-word',
                                                                              }
                                                                            : undefined
                                                                        }
                                                                      >
                                                                        {hasGroupInstallNotes
                                                                          ? groupInstallNotes
                                                                          : 'Install Price'}
                                                                      </Typography>
                                                                    </TableCell>
                                                                  )
                                                                }
                                                                if (
                                                                  val.id === 25 ||
                                                                  val.id === 3 ||
                                                                  val.id === 19 ||
                                                                  val.id === 20 ||
                                                                  val.id === 16
                                                                ) {
                                                                  return (
                                                                    <TableCell key={`gmi-${group.id}-${member.indexId}-c${val.id}`} />
                                                                  )
                                                                }
                                                                if (val.id === 2) {
                                                                  return (
                                                                    <TableCell key={`gmi-${group.id}-${member.indexId}-c2`}>
                                                                      <IconButton disabled size="small">
                                                                        <NoteAdd
                                                                          sx={{
                                                                            color: hasGroupInstallNotes
                                                                              ? theme.palette.primary.main
                                                                              : '',
                                                                          }}
                                                                        />
                                                                      </IconButton>
                                                                      {/* <IconButton
                                                                        onClick={() =>
                                                                          handleOpenInstallNote(
                                                                            member.indexId,
                                                                            member.install_notes,
                                                                          )
                                                                        }
                                                                      >
                                                                        <NoteAdd
                                                                          sx={{
                                                                            color:
                                                                              !member?.install_notes ||
                                                                              member?.install_notes === ''
                                                                                ? ''
                                                                                : theme.palette.primary.main,
                                                                          }}
                                                                        />
                                                                      </IconButton> */}
                                                                    </TableCell>
                                                                  )
                                                                }
                                                                if (val.id === 4) {
                                                                  return (
                                                                    <TableCell key={`gmi-${group.id}-${member.indexId}-c4`}>
                                                                      {Number(
                                                                        member?.expected_install_labor_cost_with_markup ||
                                                                          0,
                                                                      ).toFixed(2)}
                                                                    </TableCell>
                                                                  )
                                                                }
                                                                if (val.id === 5) {
                                                                  return (
                                                                    <TableCell key={`gmi-${group.id}-${member.indexId}-c5`}>
                                                                      {hasMarkupPermission && markupType == 2
                                                                        ? installRetailEach.toFixed(2)
                                                                        : null}
                                                                    </TableCell>
                                                                  )
                                                                }
                                                                if (val.id === 6) {
                                                                  return (
                                                                    <TableCell key={`gmi-${group.id}-${member.indexId}-c6`}>
                                                                      {hasMarkupPermission && markupType == 1
                                                                        ? installRetailEach.toFixed(2)
                                                                        : null}
                                                                    </TableCell>
                                                                  )
                                                                }
                                                                if (val.id === 9) {
                                                                  return (
                                                                    <TableCell
                                                                      key={`gmi-${group.id}-${member.indexId}-c9`}
                                                                      align="center"
                                                                    >
                                                                      {installQty}
                                                                      {/* {groupEditMode?.[group.id] ? (
                                                                        <TextField
                                                                          type="number"
                                                                          size="small"
                                                                          value={installQty}
                                                                          label="Qty"
                                                                          onChange={(event) =>
                                                                            handleGroupLineQuantityDraftChange(
                                                                              member.indexId,
                                                                              'group_install_quantity',
                                                                              event.target.value,
                                                                            )
                                                                          }
                                                                          sx={{ width: 80 }}
                                                                        />
                                                                      ) : (
                                                                        installQty
                                                                      )} */}
                                                                    </TableCell>
                                                                  )
                                                                }
                                                                if (val.id === 10) {
                                                                  return (
                                                                    <TableCell
                                                                      key={`gmi-${group.id}-${member.indexId}-c10`}
                                                                      align="center"
                                                                    >
                                                                      -
                                                                    </TableCell>
                                                                  )
                                                                }
                                                                if (val.id === 11) {
                                                                  return (
                                                                    <TableCell key={`gmi-${group.id}-${member.indexId}-c11`}>
                                                                      <Stack
                                                                        direction="row"
                                                                        spacing={1}
                                                                        alignItems="center"
                                                                        sx={{ color: 'text.secondary', opacity: 0.7 }}
                                                                      >
                                                                        <Remove fontSize="small" />
                                                                        <Switch
                                                                          checked={getNestedLineMarketingAdjValueType(
                                                                            member,
                                                                            markupType,
                                                                            'install',
                                                                          )}
                                                                          disabled
                                                                        />
                                                                        <Add fontSize="small" />
                                                                      </Stack>
                                                                    </TableCell>
                                                                  )
                                                                }
                                                                if (val.id === 15) {
                                                                  return (
                                                                    <TableCell
                                                                      key={`gmi-${group.id}-${member.indexId}-c15`}
                                                                      align="center"
                                                                    >
                                                                      {formatNestedMarketingAdjustmentDisplay(
                                                                        getNestedLineMarketingAdjustmentValue(
                                                                          member,
                                                                          markupType,
                                                                          'install',
                                                                        ),
                                                                      )}
                                                                    </TableCell>
                                                                  )
                                                                }
                                                                if (val.id === 12) {
                                                                  return (
                                                                    <TableCell key={`gmi-${group.id}-${member.indexId}-c12`}>
                                                                      ${fUSPrice(installSubTotal.toFixed(2))}
                                                                    </TableCell>
                                                                  )
                                                                }
                                                                if (val.id === 14) {
                                                                  return (
                                                                    <TableCell key={`gmi-${group.id}-${member.indexId}-c14`}>
                                                                      ${fUSPrice(cellProductTotal.toFixed(2))}
                                                                    </TableCell>
                                                                  )
                                                                }
                                                                if (val.id === 13) {
                                                                  return (
                                                                    <TableCell key={`gmi-${group.id}-${member.indexId}-c13`} />
                                                                  )
                                                                }
                                                                return (
                                                                  <TableCell key={`gmi-${group.id}-${member.indexId}-cx-${val.id}`} />
                                                                )
                                                              })}
                                                            </TableRow>
                                                          ) : null}
                                                        </React.Fragment>
                                                      )
                                                    })}
                                                  </TableBody>
                                                </Table>
                                              </Box>
                                            </Collapse>
                                          </TableCell>
                                        </TableRow>
                                        <TableRow>
                                          <TableCell
                                            colSpan={
                                              (visibleColumnCount || VALUE?.length || 20) + (openEdit ? 2 : 0)
                                            }
                                          >
                                            <Box sx={{ borderBottom: (theme) => `solid 1px ${theme.palette.divider}` }} />
                                          </TableCell>
                                        </TableRow>
                                        {anchorId != null ? (
                                          <>
                                            <Modal
                                              open={openGroupProductNoteIndex === anchorId}
                                              handleClose={() => {
                                                setOpenGroupProductNoteIndex(null)
                                                setCurrentNote('')
                                              }}
                                            >
                                              <Grid container spacing={3} sx={{ justifyContent: 'center', width: '100%' }}>
                                                <Grid item xs={12}>
                                                  <Typography variant="h5" sx={{ mb: 2 }}>Note</Typography>
                                                  <TextField
                                                    fullWidth
                                                    multiline
                                                    rows={4}
                                                    size="medium"
                                                    value={currentNote}
                                                    onChange={handleNoteChange}
                                                    error={!currentNote.trim() && currentNote.length > 0}
                                                    inputProps={{ maxLength: MAX_CHARACTERS }}
                                                    helperText={
                                                      !currentNote.trim() && currentNote.length > 0
                                                        ? 'Note cannot be empty or contain only spaces'
                                                        : `${currentNote.length}/${MAX_CHARACTERS} characters`
                                                    }
                                                  />
                                                </Grid>
                                              </Grid>
                                              <Grid container justifyContent="center" alignItems="center">
                                                <Grid item xs={12} md={4}>
                                                  <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 1 }}>
                                                    <LoadingButton
                                                      variant="contained"
                                                      onClick={() => {
                                                        handleSaveNote(anchorId)
                                                        setOpenGroupProductNoteIndex(null)
                                                      }}
                                                      loading={isSavingNote}
                                                      disabled={!currentNote.trim()}
                                                    >
                                                      Save
                                                    </LoadingButton>
                                                    <LoadingButton
                                                      variant="outlined"
                                                      color="error"
                                                      onClick={() => {
                                                        handleClearNote(anchorId)
                                                        setOpenGroupProductNoteIndex(null)
                                                      }}
                                                      loading={isClearingNote}
                                                      disabled={!currentNote.trim()}
                                                    >
                                                      Clear
                                                    </LoadingButton>
                                                  </Box>
                                                </Grid>
                                              </Grid>
                                            </Modal>

                                            <Modal
                                              open={openGroupInstallNoteIndex === anchorId}
                                              handleClose={() => {
                                                setOpenGroupInstallNoteIndex(null)
                                                setCurrentNote('')
                                              }}
                                            >
                                              <Grid container spacing={3} sx={{ justifyContent: 'center', width: '100%' }}>
                                                <Grid item xs={12}>
                                                  <Typography variant="h5" sx={{ mb: 2 }}>Install Note</Typography>
                                                  <TextField
                                                    fullWidth
                                                    multiline
                                                    rows={4}
                                                    size="medium"
                                                    value={currentNote}
                                                    onChange={handleNoteChange}
                                                    error={!currentNote.trim() && currentNote.length > 0}
                                                    inputProps={{ maxLength: MAX_CHARACTERS }}
                                                    helperText={
                                                      !currentNote.trim() && currentNote.length > 0
                                                        ? 'Note cannot be empty or contain only spaces'
                                                        : `${currentNote.length}/${MAX_CHARACTERS} characters`
                                                    }
                                                  />
                                                </Grid>
                                              </Grid>
                                              <Grid container justifyContent="center" alignItems="center">
                                                <Grid item xs={12} md={4}>
                                                  <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 1 }}>
                                                    <LoadingButton
                                                      variant="contained"
                                                      onClick={() => {
                                                        handleSaveInstallNote(anchorId)
                                                        setOpenGroupInstallNoteIndex(null)
                                                      }}
                                                      loading={isSavingNote}
                                                      disabled={!currentNote.trim()}
                                                    >
                                                      Save
                                                    </LoadingButton>
                                                    <LoadingButton
                                                      variant="outlined"
                                                      color="error"
                                                      onClick={() => {
                                                        handleClearInstallNote(anchorId)
                                                        setOpenGroupInstallNoteIndex(null)
                                                      }}
                                                      loading={isClearingNote}
                                                      disabled={!currentNote.trim()}
                                                    >
                                                      Clear
                                                    </LoadingButton>
                                                  </Box>
                                                </Grid>
                                              </Grid>
                                            </Modal>

                                            <Modal
                                              open={openProductAttachment[anchorId] || false}
                                              handleClose={() => handleCloseAttachment(anchorId)}
                                            >
                                              {renderProductAttachmentModalContent(anchorId)}
                                            </Modal>
                                          </>
                                        ) : null}
                                      </React.Fragment>
                                        )}
                                      </Draggable>
                                    )
                                  }
                                  const data = selectedProducts.find((p) => p.indexId === bodyItem.indexId)
                                  if (!data) return null
                                  const quantityFieldName = `quantity_${data.product_id||data.id}`;
                                  const discountFieldName = `discount_${data.product_id||data.id}`;
                                  const adjustmentFieldName = `adjustment_${data.product_id || data.id}`;

                                  console.log('selectedProductsselectedProducts=data=====>',data);
                                
                                  let unitName = UNITS?.filter((item)=>item?.id==data?.unit)
                                  unitName = unitName[0]?.name
                                  let shortUnitName = ''
                                  if(unitName=='Square feet'){
                                    shortUnitName = 'Sq ft'
                                  }else if(unitName=='Lineal feet'){
                                    shortUnitName = 'Lin ft'
                                  }else if(unitName=='Square Inches'){
                                    shortUnitName ='Sq Inches'
                                  }else if(unitName=='Unit'){
                                    shortUnitName = 'Unit'
                                  }

                                  // Split order calculation logic
                                  let incomingPercentage = data?.incoming_split_percentage || incomingSplitMarkup || 0;
                                  if(isSplitOrder && data?.facility_id !== currentFacilityId){
                                    const splitSetting = selectedSplitOrderSettings?.find(setting => setting?.id == data?.facility_id);
                                    let outgoingPercentage = data?.split_percentage || splitSetting?.split_percentage || 0;
                                    if (!data.originalExpectedCost) {
                                     data.originalExpectedCost = Number(data?.expected_cost)
                                   }
                                   
                                   let amountWithOutgoingPercentage = data.originalExpectedCost * (outgoingPercentage / 100)
                                   data.expected_cost = parseFloat(data.originalExpectedCost + amountWithOutgoingPercentage)
                                   let amountWithIncomingPercentage = data.expected_cost * (incomingPercentage / 100)
                                   data['actual_retail_price'] =data.expected_cost + amountWithIncomingPercentage
                                   data['retail_price'] =data?.actual_retail_price + data?.install_cost
                                   data['incoming_split_percentage'] =incomingPercentage || 0
                                   data['split_percentage'] =outgoingPercentage || 0
                                   data['outgoing_split_percentage'] =outgoingPercentage || 0
                                   }


                                  // ALL-815 backup - previous catalog price reset without retail_price_edited guard:
                                  // if(data.inhouse !== 1 || (data.inhouse ==1 && data.isTrafficCatalog == 1)){
                                  if((data.inhouse !== 1 || (data.inhouse ==1 && data.isTrafficCatalog == 1)) && !data.retail_price_edited){
                                    let price = data.max_price ? data.max_price : data.actual_retail_price
                                    const installCost = parseFloat(data?.install_cost) || 0
                                    data['actual_retail_price'] = price
                                    const calculatedRetailPrice = installCost > 0 ? price + installCost : price
                                    data['retail_price'] = calculatedRetailPrice
                                  }

                                  if(data.adj_value_type == null){
                                    data.adj_value_type =true
                                   }
                                  if (data.install_adj_value_type == null) {
                                    data.install_adj_value_type = true
                                  }
                                  if (data.install_adjustment == null) {
                                    data.install_adjustment = 0
                                  }

                                  if (
                                    data.original_actual_retail_price == null &&
                                    data.original_product_retail_price == null
                                  ) {
                                    Object.assign(
                                      data,
                                      hydrateEstimateLineMarketingPrices(data),
                                    )
                                  }
                                  const signedProductAdj = getSignedMarketingAdjustment(data)
                                  const signedInstallAdj = getSignedInstallMarketingAdjustment(data)

                                  const dataPrice = data.price
                                  const dataretailPrice = data.product_retail_price||data.retail_price
                                  const dataActualRetail = data.original_actual_retail_price != null
                                    ? data.original_actual_retail_price + signedProductAdj
                                    : (data.actual_retail_price ?? data.retail_price ?? 0)
                                  const dataWholesalePrice = data.product_price||data.price
                                  const productCost = data.actual_retail_price ? data.actual_retail_price * data.locationQuantity : data.retail_price * data.locationQuantity
                                  // const dataQuantity = values[quantityFieldName]
                                  const dataQuantity = data.quantity||1
                                  console.log('data.discount--',data.discount);
                                  const dataDiscount = data.discount?data.discount:0
                                  console.log('markupTypemarkupTypemarkupType==',markupType)
                                  const rowTotal = calculateTotal(markupType == 1 ? dataWholesalePrice : (markupType == 2 ? (data.install_cost && parseFloat(data.install_cost) > 0 ? dataretailPrice : dataActualRetail) : 0), dataQuantity, dataDiscount, data.quantity, data.locationQuantity, Number(data?.adjustment),data.markAdjType,data.adj_value_type);
                                  // const rowTotal = calculateTotal(markupType == 1 ? dataWholesalePrice : (markupType == 2 ? (data.install_cost && parseFloat(data.install_cost) > 0 ? dataretailPrice : dataActualRetail) : 0), dataQuantity, dataDiscount, data.quantity, data.locationQuantity, Number(data?.adjustment),data.markAdjType,persentageSplit);
                                  const locQtyForLineTotal = Number(data?.locationQuantity) || 1
                                  const installQtyForLineTotal = Number(data?.install_quantity) || 1
                                  const discountForLineTotal =
                                    Number(values[discountFieldName]) || Number(dataDiscount) || 0
                                  const lineProductSubTotal =
                                    markupType == 1
                                      ? (Number(data?.price) || 0) * locQtyForLineTotal
                                      : markupType == 2
                                      ? (Number(data?.actual_retail_price || data?.retail_price || 0)) * locQtyForLineTotal
                                      : 0
                                  const lineInstallSubTotal =
                                    (Number(data?.install_cost) || 0) * installQtyForLineTotal
                                  const lineProductTotal = Math.max(
                                    0,
                                    lineProductSubTotal + lineInstallSubTotal - discountForLineTotal,
                                  )
                                  console.log('calculateTotal--rowTotal', rowTotal)
                                  console.log('lineProductTotal--', lineProductTotal)
                                  console.log('calculateTotal--dataretailPrice', dataretailPrice)
                                  console.log('calculateTotal--dataWholesalePrice', dataWholesalePrice)
                                  console.log('calculateTotal--markupType', markupType)
                                  // const markup = ((dataretailPrice - dataPrice) / dataPrice) * 100;
                                  const invoiceAmount = parseFloat(data?.expected_material_cost?.toFixed(2)) + parseFloat(data?.expected_total_service_cost?.toFixed(2))
                                  // let markup = markupType ? (invoiceAmount / rowTotal) : null

                                  let markup = markupType == 1 ? (((dataWholesalePrice - parseFloat(data.expected_cost?.toFixed(2))) / parseFloat(data.expected_cost?.toFixed(2))) * 100) 
                                                : (markupType == 2 ? (((dataretailPrice - parseFloat(data.expected_cost?.toFixed(2))) / parseFloat(data.expected_cost?.toFixed(2)))*100) : 0);
                                  markup = markup ? Number(markup) : 0
                                  data['markup'] = markup
                                  let markupData = data.product_markup?.toFixed(2) ||data.markup?.toFixed(2)
                                  markupData = Number(markupData) * data.quantity
                                  data['markup'] = markupData
                                  totalMarkup += Number(data.product_markup) || Number(data.markup) || 0
                                  data['markup_type'] = markupType
                                  data['totalMarkup'] = totalMarkup?.toFixed(2)
                                  let originalMarkup= markupType == 1 ? data.wholesaleMarkup :  markupType == 2 ? data.retailMarkup : 0
                                  originaltotalMarkup+=originalMarkup
                                  // values['totalMarkup'] = totalMarkup?.toFixed(2)
                                  productFormulaCost+=parseFloat(data.expected_cost?.toFixed(2))*data.quantity*data.locationQuantity

                                  const pfc = parseFloat(data.expected_cost?.toFixed(2)) * data.quantity*data.locationQuantity // total product formula cost
                                  const rtp = dataretailPrice * data.quantity*data.locationQuantity // total retail price
                                  const wsp = dataWholesalePrice * data.quantity*data.locationQuantity // total wholesale price
  
                                  const maxDiscount_wholesale = wsp - pfc
                                  const maxDiscount_retail = rtp - pfc

                                  // const maxDiscount_wholesale = (wsp - pfc) - DiscountTotal
                                  // const maxDiscount_retail = (rtp - pfc) - DiscountTotal

                                  console.log('maxDiscount_wholesale--',maxDiscount_wholesale);
                                  console.log('maxDiscount_retail--',maxDiscount_retail);
                                  console.log('DiscountTotal--',DiscountTotal);
                                  console.log('pfc--',pfc);
                                  console.log('rtp--',rtp);
                                  console.log('wsp--',wsp);
                                  data['product_total'] = lineProductTotal
                                  let SPMA = 0
                                  if(markupType){
                                    if(markupType == 1){
                                      if(data.markAdjType==2 || data.markAdjType==3) {
                                        SPMA = (Number(dataPrice) || 0) + (data.adjustment ? Number(data.adjustment) : 0)
                                      }else{

                                        SPMA = (Number(dataPrice) || 0) + (((dataPrice || 0) * (data.adjustment ? Number(data.adjustment) : 0)) / 100)
                                      }
                                    }else{
                                      if(data.markAdjType==2 || data.markAdjType==3) {
                                        SPMA = (Number(dataretailPrice) || 0) + (dataretailPrice ? Number(data.adjustment) : 0)
                                      }else{

                                        SPMA = (Number(dataretailPrice) || 0) + (((Number(dataretailPrice) || 0) * (dataretailPrice ? Number(data.adjustment) : 0)) / 100)
                                      }
                                    }
                                  }
                                  console.log('SPMA-----data.price-----',dataPrice)
                                  console.log('SPMA-----data.adjustment-----',data.adjustment)
                                  console.log('SPMA-----data.retail_price-----',dataretailPrice)
                                  console.log('SPMA-----SPMA-----',SPMA)
                                  SPMA = Number(SPMA)
                                  data['SPMA'] = SPMA?.toFixed(2)

                                  const productFormulaEach = getSingleProductFormulaCostEach(data)
                                  const hasNegativeRetailPermission =
                                    explodedPermissions?.some((permission) =>
                                      [
                                        'Allow Negative Marketing Adjustment Estimate',
                                      ].includes(permission),
                                    )
                                  const retailPriceMin = hasNegativeRetailPermission
                                    ? 0.01
                                    : Math.max(0.01, productFormulaEach)
                                  const productRetailEach = Math.max(
                                    0,
                                    Number(
                                      data?.actual_retail_price ??
                                        data?.retail_price ??
                                        data?.product_retail_price ??
                                        0,
                                    ),
                                  )
                                  const isNegativeProductAdjustmentMode =
                                    data?.adj_value_type === false ||
                                    data?.adj_value_type === 0 ||
                                    data?.adj_value_type === '0' ||
                                    data?.adj_value_type === 'false'
                                  const isProductLosingMoney =
                                    isNegativeProductAdjustmentMode &&
                                    productRetailEach < productFormulaEach

                                  const installFormulaEach = Number(
                                    data?.expected_install_labor_cost_with_markup ||
                                      0,
                                  )
                                  const installRetailEach = Math.max(
                                    0,
                                    Number(data?.install_cost || 0),
                                  )
                                  const isNegativeInstallAdjustmentMode =
                                    data?.install_adj_value_type === false ||
                                    data?.install_adj_value_type === 0 ||
                                    data?.install_adj_value_type === '0' ||
                                    data?.install_adj_value_type === 'false'
                                  const isInstallLosingMoney =
                                    installRetailEach > 0 &&
                                    isNegativeInstallAdjustmentMode &&
                                    installRetailEach < installFormulaEach

                                  const isLosingMoneyItem =
                                    isProductLosingMoney ||
                                    isInstallLosingMoney

                                  const losingMoneyRowSx = getLosingMoneyRowSx(isLosingMoneyItem)
                                  // BACKUP: const isWriteRow = isQuotationWriteRow(data) && data?.fromMapServices !== true
                                  const isWriteRow =
                                    isQuotationProductRowForValues(data) &&
                                    data?.fromMapServices !== true
                                  const hasCatalog = !isWriteRow && !isQuotationChooseEmptyRow(data)
                                  return (
                                    <Draggable
                                      key={`product-${data.indexId}`}
                                      draggableId={`product-${data.indexId}`}
                                      index={index}
                                      isDragDisabled={!openEdit}
                                    >
                                      {(provided, snapshot) => (
                                    <>
                                    {/* <TableRow key={index}> */}
                                    <TableRow
                                      key={`main-${data.indexId}`}
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                      onDragEnterCapture={(e) => handleProductIconDragOver(e, data.indexId)}
                                      onDragOverCapture={(e) => handleProductIconDragOver(e, data.indexId)}
                                      onDragLeave={(e) => handleProductIconDragLeave(e, data.indexId)}
                                      onDropCapture={(e) => handleProductIconDrop(e, data.indexId)}
                                      sx={{
                                        ...losingMoneyRowSx,
                                        ...(productAttachmentDragOver[data.indexId] && {
                                          backgroundColor: 'action.hover',
                                          outline: `2px dashed ${theme.palette.primary.main}`,
                                          outlineOffset: -2,
                                        }),
                                      }}
                                      style={{
                                        ...provided.draggableProps.style,
                                        ...(snapshot.isDragging
                                          ? { backgroundColor: theme.palette.action.hover }
                                          : {}),
                                      }}
                                    >
                                      {openEdit && (
                                        <TableCell
                                          padding="checkbox"
                                          {...provided.dragHandleProps}
                                          sx={{ width: 40, cursor: 'grab' }}
                                        >
                                          <DragIndicator fontSize="small" color="action" />
                                        </TableCell>
                                      )}
                                      {openEdit && (
                                        <TableCell padding="checkbox">
                                          {(() => {
                                            const productGid = resolveProductGroupId(data)
                                            const isAnyGroupInEditMode = Object.values(
                                              groupEditMode || {},
                                            ).some(Boolean)
                                            const isGroupRow = Boolean(productGid)
                                            const canSelectUngrouped =
                                              !isAnyGroupInEditMode && !isGroupRow
                                            const canSelectGrouped =
                                              isGroupRow && !!groupEditMode?.[productGid]
                                            const show =
                                              (canSelectUngrouped || canSelectGrouped) &&
                                              isViewQuotationChooseCatalogRow(data)
                                            if (!show) return null
                                            return (
                                              <Checkbox
                                                checked={isIndexIdInList(
                                                  groupSelectedProductIds,
                                                  data.indexId,
                                                )}
                                                onChange={() => toggleGroupProductSelection(data)}
                                              />
                                            )
                                          })()}
                                        </TableCell>
                                      )}
                                      <TableCell>#{displaySlNo}</TableCell>
                                      <TableCell align="center">
                                        {data?.fromMapServices ? (
                                          '-'
                                        ) : (() => {
                                          const toggleLocked = isRequestEstimateLockedProductToggle(
                                            data,
                                            details?.is_request_estimate,
                                            userType,
                                          )
                                          const toggleMode = toggleLocked
                                            ? getProductToggleDisplayModeFromProductWrite(data)
                                            : getProductToggleDisplayMode(data)
                                          return openEdit ? (
                                            <ProductLineEntryToggle
                                              mode={toggleMode}
                                              onChange={(mode) =>
                                                handleRowEntryModeChange(data.indexId, mode)
                                              }
                                              lockDisplay={toggleLocked}
                                              disabled={toggleLocked}
                                            />
                                          ) : toggleMode === 'choose' ? (
                                            'Choose'
                                          ) : (
                                            'Write'
                                          )
                                        })()}
                                      </TableCell>
                                      <TableCell>
                                        {isWriteRow ? (
                                          '-'
                                        ) : (
                                        <div
                                          style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            width: 40,
                                            height: 20,
                                          }}
                                        >
                                          {data?.syncWithQuickbooks === 1 && (
                                            <img
                                              src={quickbookLogo}
                                              alt="QuickBooks"
                                              style={{
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'contain',
                                              }}
                                            />
                                          )}
                                        </div>
                                        )}
                                      </TableCell> 
                                      <TableCell sx={VIEW_QUOTATION_PRODUCT_TABLE_COL_SX.productName}>
                                        {isQuotationChooseEmptyRow(data) ? (
                                          openEdit ? (
                                            <Button
                                              size="small"
                                              variant="outlined"
                                              color="primary"
                                              onClick={() => openCatalogPickerForRow(data.indexId)}
                                            >
                                              Select Product
                                            </Button>
                                          ) : (
                                            '-'
                                          )
                                        ) : isWriteRow ? (
                                        <TextField
                                          required
                                          fullWidth
                                          type="text"
                                          label={'Product Name'}
                                          sx={{ width: '100%' }}
                                          value={getProductNameDraftValue(
                                            data.indexId,
                                            data.product_name || data.name || '',
                                          )}
                                          disabled={!openEdit || data?.addedByUserType !== 18 && userType === 18}
                                          onChange={(event) => {
                                            let newValue = event.target.value
                                            handleProductNameDraftChange(data.indexId, newValue)
                                            if (isSubmitted) setIsSubmitted(false)
                                          }}
                                          onBlur={() => {
                                            const latestName =
                                              productNameDraftsRef.current[data.indexId] !== undefined
                                                ? productNameDraftsRef.current[data.indexId]
                                                : (data.product_name || data.name)
                                            commitProductNameDraft(data.indexId)
                                            if (details?.is_request_estimate == 1 && openEdit) {
                                              handleProductRowAutoSave(
                                                { ...data, product_name: latestName, product_desc: data.product_desc },
                                                'name',
                                              )
                                            }
                                          }}
                                          error={
                                            (isSubmitted &&
                                              !getProductNameDraftValue(
                                                data.indexId,
                                                data.name || data.product_name || '',
                                              ).trim()) ||
                                            Boolean(productRowErrors[data.indexId])
                                          }
                                          helperText={
                                            productRowErrors[data.indexId] ||
                                            (isSubmitted &&
                                            !getProductNameDraftValue(
                                              data.indexId,
                                              data.name || data.product_name || '',
                                            ).trim()
                                              ? 'Product Name is required'
                                              : '')
                                          }
                                        />
                                        ) : (
                                     <Box sx={{ maxWidth: '100%', overflow: 'hidden' }}>
                                       <Typography sx={{ wordBreak: 'break-word' }}>
                                        {data.product_name || data.name}
                                      </Typography>
                                      {/* <Typography sx={{color:isSplitOrder ? theme.palette[
                                        FacilityTypes.find(f => f.id === data?.facility_id)?.color || 'primary'
                                      ]?.main
                                    : (data.product_notes ? theme.palette.error.main : 'inherit'), wordBreak: 'break-word' }}>Note:{" "} {data.product_notes}  </Typography> */}
                                    {data.product_notes != null &&
                                      String(data.product_notes).trim() !== '' ? (
                                        <Typography
                                          sx={{
                                            color: isSplitOrder
                                              ? theme.palette[
                                                  FacilityTypes.find(
                                                    (f) => f.id === data?.facility_id,
                                                  )?.color || 'primary'
                                                ]?.main
                                              : theme.palette.error.main,
                                            whiteSpace: 'pre-wrap',
                                          }}
                                        >
                                          Note: {data.product_notes}
                                        </Typography>
                                      ) : null}
                                    </Box>)}
                                      </TableCell>
                                      <TableCell sx={VIEW_QUOTATION_PRODUCT_TABLE_COL_SX.productDesc}>
                                        {isQuotationChooseEmptyRow(data) ? (
                                          '-'
                                        ) : isWriteRow ? (
                                          <TextField
                                            fullWidth
                                            variant="outlined"
                                            sx={{ width: '100%' }}
                                            label="Product Description"
                                            value={getProductDescDraftValue(data.indexId, data.product_desc || '')}
                                            disabled={!openEdit || data?.addedByUserType !== 18 && userType === 18}
                                            onChange={(event) =>
                                              handleProductDescDraftChange(data.indexId, event.target.value)
                                            }
                                            onBlur={() => {
                                              const latestDesc =
                                                productDescDraftsRef.current[data.indexId] !== undefined
                                                  ? productDescDraftsRef.current[data.indexId]
                                                  : data.product_desc
                                              commitProductDescDraft(data.indexId)
                                              if (details?.is_request_estimate == 1 && openEdit) {
                                                handleProductRowAutoSave(
                                                  { ...data, product_name: data.product_name || data.name, product_desc: latestDesc },
                                                  'desc',
                                                )
                                              }
                                            }}
                                            placeholder="Description"
                                            multiline
                                            minRows={1}
                                            maxRows={2}
                                          />
                                        ) : hasCatalog ? (
                                          <TextField
                                            fullWidth
                                            variant="outlined"
                                            size="small"
                                            value={getProductDescDraftValue(
                                              data.indexId,
                                              data.description || data.product_desc || '',
                                            )}
                                            disabled={!openEdit}
                                            onChange={(event) =>
                                              handleProductDescDraftChange(data.indexId, event.target.value)
                                            }
                                            onBlur={() => commitProductDescDraft(data.indexId)}
                                            placeholder="Product Description"
                                            multiline
                                            minRows={2}
                                            maxRows={4}
                                            sx={{ width: '100%', minWidth: 0 }}
                                          />
                                        ) : (
                                          <Typography sx={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                            {data.description || data.product_desc || '-'}
                                          </Typography>
                                        )}
                                      </TableCell>
                                      <TableCell>
                                          <IconButton onClick={() => handleOpenNote(data.indexId, data.product_notes)}>
                                            <NoteAdd
                                              sx={{
                                                color: (!data?.product_notes || data?.product_notes === '') ? '' : theme.palette.primary.main,
                                              }}
                                            />
                                          </IconButton>
                                        </TableCell>
                                        <TableCell>
                                          <Tooltip title="Drop files on row or click to open attachments">
                                            <IconButton onClick={() => handleOpenAttachment(data.indexId)}>
                                              {isUploadingProduct[String(data.indexId)] ? (
                                                <CircularProgress size={34} />
                                              ) : (
                                                <UploadFile
                                                  sx={{
                                                    color:
                                                      getProductAttachmentsList(data.indexId).length === 0
                                                        ? 'error.main'
                                                        : theme.palette.primary.main,
                                                  }}
                                                />
                                              )}
                                            </IconButton>
                                          </Tooltip>
                                        </TableCell>
                                        <TableCell>
                                          {isWriteRow ? (
                                            '-'
                                          ) : isQuotationChooseEmptyRow(data) ? (
                                            '-'
                                          ) : canShowProductFormulaIcon(data, currentFacilityId) ? (
                                       <IconButton onClick={() => handleOpenProductFormula(data.recipe_id)}>
                                                                                 <span class="heroicons-solid--beaker"></span>
                                                                                  </IconButton>
                                          ) : '-'}
                                        </TableCell>
                                        <TableCell>
                                          {isWriteRow ? (
                                            '-'
                                          ) : isQuotationChooseEmptyRow(data) ? (
                                            '-'
                                          ) : (
                                            getSingleProductFormulaCostEach(data).toFixed(2)
                                          )}
                                        </TableCell>
                                        {/* <TableCell>
                                          {data?.isAdditionalProduct
                                            ? 'N/A'
                                            : (data.inhouse === 0
                                                ? data?.sub_contract_price?.toFixed(2) || '0.00'
                                                : Math.max(
                                                    0,
                                                    (data?.expected_material_cost_with_markup || 0) +
                                                      (data?.expected_service_cost_with_markup || 0) -
                                                      (data?.expected_install_labor_cost_with_markup || 0),
                                                  ).toFixed(2)
                                              )} 
                                        </TableCell> */}
                                      {/* Incoming Percentage column - only show when isSplitOrder is true */}
                                      {isSplitOrder ? (
                                        <TableCell align='center'>
                                          {isWriteRow || isQuotationChooseEmptyRow(data) ? '-' : (
                                            data?.facility_id != currentFacilityId ? 
                                              `${incomingPercentage || 0}%` : 
                                              '-'
                                          )}
                                        </TableCell>
                                      ) : (
                                        <TableCell align='center'>
                                          {isWriteRow || isQuotationChooseEmptyRow(data) ? '-' : (data.inhouse === 0 ? (data?.sub_contract_markup != null && data?.sub_contract_markup !== '' ? `${Number(data.sub_contract_markup).toFixed(2)}` : '0.00') : '-')}
                                        </TableCell>
                                      )}
                                      {/* <TableCell>{invoiceAmount}</TableCell> */}
                                      <Tooltip title={isSplitOrder && data?.facility_id != currentFacilityId ? `Product formula cost + (Product formula cost * incoming split markup (${incomingPercentage}) / 100)` : ""}>
                                      <TableCell>{isWriteRow || isQuotationChooseEmptyRow(data) ? '-' : (hasMarkupPermission && markupType == 2) ? (
                                      <>
                                        {/* ALL-815 backup - previous read-only retail display:
                                        Number(dataActualRetail)?.toFixed(2) */}
                                        <TextField
                                          required
                                          fullWidth
                                          type="number"
                                          label={'Retail Price Each'}
                                          disabled={values.project_category?.name == 'Time & Material' ? true : false}
                                          sx={{ width: 120 }}
                                          // value={dataretailPrice}
                                          value={
                                            data.retail_price_draft !== undefined
                                              ? limitDecimalInput(data.retail_price_draft)
                                              : formatRetailPriceDisplay(
                                                  roundMoneyValue(dataActualRetail) ?? 0,
                                                )
                                          }
                                          // onWheel={(e) => e.target.blur()}
                                          onFocus={selectInputValue}
                                          onClick={selectInputValue}
                                          onKeyPress={(event) => {
                                            // if (event.key === '0' && event.target.value === '') {
                                            //   event.preventDefault();
                                            // }
                                            if (event.key === '-') {
                                              event.preventDefault();
                                            }
                                            if (event.key === 'e') {
                                              event.preventDefault();
                                            }
                                          }}
                                          onKeyDown={(event) => {
                                            if (
                                              event.key === 'ArrowUp' ||
                                              event.key === 'ArrowDown'
                                            ) {
                                              event.preventDefault()
                                              const current =
                                                data.retail_price_draft !== undefined
                                                  ? data.retail_price_draft
                                                  : formatRetailPriceDisplay(
                                                      dataActualRetail ?? 0,
                                                    )
                                              handleRetailPriceChange(
                                                data.indexId,
                                                stepRetailPriceByArrow(
                                                  current,
                                                  event.key === 'ArrowUp'
                                                    ? 'up'
                                                    : 'down',
                                                  retailPriceMin,
                                                ),
                                                { isBlur: true },
                                              )
                                            }
                                          }}
                                          inputProps={{ min: retailPriceMin, step: 1 }}
                                          defaultValue={0}
                                          onChange={(event) => {
                                            const current =
                                              data.retail_price_draft !== undefined
                                                ? data.retail_price_draft
                                                : formatRetailPriceDisplay(
                                                    dataActualRetail ?? 0,
                                                  )
                                            handleRetailPriceChange(
                                              data.indexId,
                                              normalizeRetailArrowChange(
                                                current,
                                                event.target.value,
                                                retailPriceMin,
                                              ),
                                            )
                                          }}
                                          onBlur={(event) => {
                                            handleRetailPriceChange(
                                              data.indexId,
                                              event.target.value,
                                              { isBlur: true },
                                            )
                                          }}
                                          // error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                          // helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                        />
                                      </>
                                      ) : null}</TableCell>
                                      </Tooltip>
                                      <TableCell>{isWriteRow || isQuotationChooseEmptyRow(data) ? '-' : (hasMarkupPermission && markupType == 1) ? (
                                      <>
                                        {/* ALL-815 backup - previous read-only retail display: dataPrice?.toFixed(2) */}
                                        <TextField
                                          required
                                          fullWidth
                                          type="number"
                                          label={'Retail Price Each'}
                                          disabled={values.project_category?.name == 'Time & Material' ? true : false}
                                          sx={{ width: 120 }}
                                          // value={dataPrice}
                                          value={
                                            data.retail_price_draft !== undefined
                                              ? limitDecimalInput(data.retail_price_draft)
                                              : formatRetailPriceDisplay(roundMoneyValue(dataPrice) ?? 0)
                                          }
                                          // onWheel={(e) => e.target.blur()}
                                          onFocus={selectInputValue}
                                          onClick={selectInputValue}
                                          onKeyPress={(event) => {
                                            // if (event.key === '0' && event.target.value === '') {
                                            //   event.preventDefault();
                                            // }
                                            if (event.key === '-') {
                                              event.preventDefault();
                                            }
                                            if (event.key === 'e') {
                                              event.preventDefault();
                                            }
                                          }}
                                          onKeyDown={(event) => {
                                            if (
                                              event.key === 'ArrowUp' ||
                                              event.key === 'ArrowDown'
                                            ) {
                                              event.preventDefault()
                                              const current =
                                                data.retail_price_draft !== undefined
                                                  ? data.retail_price_draft
                                                  : formatRetailPriceDisplay(
                                                      dataPrice ?? 0,
                                                    )
                                              handleRetailPriceChange(
                                                data.indexId,
                                                stepRetailPriceByArrow(
                                                  current,
                                                  event.key === 'ArrowUp'
                                                    ? 'up'
                                                    : 'down',
                                                  retailPriceMin,
                                                ),
                                                { isBlur: true },
                                              )
                                            }
                                          }}
                                          inputProps={{ min: retailPriceMin, step: 1 }}
                                          defaultValue={0}
                                          onChange={(event) => {
                                            const current =
                                              data.retail_price_draft !== undefined
                                                ? data.retail_price_draft
                                                : formatRetailPriceDisplay(
                                                    dataPrice ?? 0,
                                                  )
                                            handleRetailPriceChange(
                                              data.indexId,
                                              normalizeRetailArrowChange(
                                                current,
                                                event.target.value,
                                                retailPriceMin,
                                              ),
                                            )
                                          }}
                                          onBlur={(event) => {
                                            handleRetailPriceChange(
                                              data.indexId,
                                              event.target.value,
                                              { isBlur: true },
                                            )
                                          }}
                                          // error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                          // helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                        />
                                      </>
                                      ) : null}</TableCell>
                                      {/* <TableCell>{hasMarkupPermission ? (data.SPMA || null) : null}</TableCell> */}
                                      {/* <TableCell>{hasMarkupPermission ? Number(markupData).toFixed(2) : null}</TableCell> */}
                                     
                                      {/* <TableCell> */}
                                        {/* previos */}
                                            {/* {(hasMarkupPermission && markupType == 1) ? data.wholesaleMarkup?.toFixed(2)
                                              : (hasMarkupPermission && markupType == 2) ? data.pf_retail_markup?.toFixed(2)
                                                : null} */}

                                                {/* //old */}
                                            {/* {(hasMarkupPermission && markupType == 1) ? data.wholesaleMarkup?.toFixed(2)
                                              : (hasMarkupPermission && markupType == 2) ? data.retailMarkup?.toFixed(2)
                                                : null} */}
                                          {/* </TableCell> */}
                                      {/* <TableCell>{shortUnitName}</TableCell> */}
                                      {/* <TableCell>
                                        <TextField
                                         type="number"
                                         sx={{width:85}}
                                         onKeyPress={(event) => {
                                          if (event.key === '0' && event.target.value === '') {
                                            event.preventDefault();
                                          }
                                          if (event.key === '.' ) {
                                            event.preventDefault();
                                          }
                                        }}
                                          fullWidth                                                                                
                                          label={shortUnitName}
                                          disabled={(data?.fromMapServices == true) ? true : shortUnitName == 'Unit' ? true : false}
                                          // {...getFieldProps(quantityFieldName)}
                                          defaultValue={data.quantity?data.quantity:1}
                                          value={data.quantity?data.quantity:1}
                                          
                                          onChange={(event) => {
                                           
                                            let newValue = event.target.value;
                                            if (newValue.startsWith('-')) {
                                              newValue = newValue.slice(1);
                                            }
                                            newValue = newValue.replace(/[^0-9]/g, '');
                                            if (newValue === '' || Number(newValue) <= 0) {
                                              newValue = 1;
                                            }
                                            else{
                                              newValue = Number(newValue);
                                            }
                                           
                                            setSelectedProducts(pv=>([...pv.map(p=>{
                                              // if(p.id===data.id){
                                              if (p.indexId === data.indexId) {
                                                let arrayAddr
                                                     
                                                const commonAddresses = (data?.allLocationSame && pv.length > 0) ? p.location[0] : null;
                                               
                                                if(data?.allLocationSame && commonAddresses){
                                                  arrayAddr = Array((newValue)).fill().map((_, i) => ({
                                                    ...commonAddresses,
                                                    id: i
                                                  }));
                                                
                                                }
                                                else{
                                                  arrayAddr = [...p.location]
                                                  console.log("Hifiiiiiiiiiiiiii Aff",arrayAddr);
                                                  if(p.location.length<=newValue){
                                                    arrayAddr.push(...[...Array((newValue)-p.location.length)].map((a,i)=>{
                                                      return {
                                                        id: p.location.length + i,
                                                        address: '',
                                                        city: '',
                                                        state: '',
                                                        zip: '',
                                                      }
                                                    }))
                                                  }else{
                                                    arrayAddr = arrayAddr.slice(0,-(p.location.length-(newValue)));
                                                  }
                                                }
                                               
                                                return {
                                                  ...p,
                                                  quantity:newValue,
                                                  // location: arrayAddr
                                                }
                                              }else{
                                                return p;
                                              }
                                            })]));
                                            console.log("###############SElected services",selectedServices);
                                            setSelectedServices(pv => ([...pv.map(service => {
                                              // if (service.product_id === data.id &&service.prQty) {
                                              if (service.productIndex === data.indexId && service.prQty) {
                                                  return {
                                                      ...service,
                                                      quantity: (service.prQty* (newValue)*(service?.locationQuantity||1)).toFixed(2),
                                                      qtyData: Number(newValue),
                                                  };
                                              } else {
                                                  return {...service,
                                                   
                                                  }
                                              }
                                          })]));
                                            //new chnage on 2-2-24
                                          //   if (newValue === '.') {
                                          //     event.preventDefault();
                                          //     return;
                                          //   }
                                          // if (newValue === '' || newValue <= 0) {
                                          //   event.preventDefault();
                                          //   return;
                                          // }
                                          //   if (newValue.startsWith('-')) {
                                          //     newValue = newValue.slice(1);
                                          //   }
                                            data['quantity'] = newValue || 1;
                                           
                                            setFieldValue(quantityFieldName, newValue);
                                          }}
                                          
                                          error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                          helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                        />
                                      </TableCell> */}
                                      <TableCell>
                                        {isWriteRow || isQuotationChooseEmptyRow(data) ? (
                                          '-'
                                        ) : (
                                        <TextField
                                         type="number"
                                         onKeyPress={(event) => {
                                          if (event.key === '0' && event.target.value === '') {
                                            event.preventDefault();
                                          }
                                          if (event.key === '.' ) {
                                            event.preventDefault();
                                          }
                                        }}
                                          fullWidth                                                                                
                                          label={"Qty"}
                                          disabled={(data?.fromMapServices == true) ? true : false}
                                          // {...getFieldProps(quantityFieldName)}
                                          defaultValue={data.locationQuantity?data.locationQuantity:1}
                                          value={data.locationQuantity?data.locationQuantity:1}
                                          onFocus={selectInputValue}
                                          onClick={selectInputValue}
                                          onChange={(event) => {
                                           
                                            let newValue = event.target.value;
                                            if (newValue.startsWith('-')) {
                                              newValue = newValue.slice(1);
                                            }
                                            newValue = newValue.replace(/[^0-9]/g, '');
                                            if (newValue === '' || Number(newValue) <= 0) {
                                              newValue = 1;
                                            }
                                            else{
                                              newValue = Number(newValue);
                                            }
                                            const newAddr = data?.is_single_card ? 1 : newValue
                                            setSelectedProducts(pv=>([...pv.map(p=>{
                                              // if(p.id===data.id){
                                              if (p.indexId === data.indexId) {
                                                
                                                let arrayAddr
                                                     
                                                const commonAddresses = (data?.allLocationSame && pv.length > 0) ? p.location[0] : null;
                                                console.log("Hifiiiiiiiiiiiiii Aff",commonAddresses);
                                                if(data?.allLocationSame && commonAddresses){
                                                  arrayAddr = Array(Number(newAddr)).fill().map((_, i) => ({ //1
                                                    ...commonAddresses,
                                                    id: i
                                                  }));
                                                
                                                }
                                                else{
                                                  arrayAddr = [...p.location]
                                                  console.log("Hifiiiiiiiiiiiiii Aff",arrayAddr);
                                                  if(p.location.length<=Number(newAddr)){
                                                    arrayAddr.push(...[...Array(Number(newAddr)-p.location.length)].map((a,i)=>{
                                                      return {
                                                        id: p.location.length + i,
                                                        address: '',
                                                        city: '',
                                                        state: '',
                                                        zip: '',
                                                      }
                                                    }))
                                                  }
                                                  else if (p.location.length > Number(newAddr)) {
                                                    arrayAddr = arrayAddr.slice(0, Number(newAddr));
                                                  }
                                                  else{
                                                    arrayAddr = arrayAddr.slice(0,-(p.location.length-Number(newAddr)));
                                                  }
                                                }
                                               
                                                return {
                                                  ...p,
                                                  // quantity:newValue,
                                                  locationQuantity:newValue,
                                                  location: arrayAddr,
                                                  install_quantity: p.manually_updated_install_quantity ?  p.install_quantity :Number(newValue) ,
                                                }
                                              }else{
                                                return p;
                                              }
                                            })]));
                                            setSelectedServices(pv => ([...pv.map(service => {
                                              // if (service.product_id === data.id &&service.prQty) {
                                              if (service.productIndex === data.indexId && service.prQty) {
                                                console.log("############service.qtyData",service.qtyData);
                                                console.log("############service.prQty",service.prQty);
                                                console.log("############service.newValue",newValue);
                                                  return {
                                                      ...service,
                                                      quantity: (newValue*(service.qtyData||1)*service.prQty).toFixed(2),
                                                      locationQuantity:newValue,
                                                  };
                                              } else {
                                                  return {...service,
                                                   
                                                  }
                                              }
                                          })]));
                                          // Location quantity change is an edit.
                                          // markUnsavedChanges();();
                                          }}
                                          
                                          error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                          helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                        />
                                        )}
                                      </TableCell>
                                      <TableCell>
                                        {isWriteRow || isQuotationChooseEmptyRow(data) ? (
                                          '-'
                                        ) : (
                                        <IconButton
                                          onClick={() => {
                                            setLocationStates({ ...locationStates, [data.indexId]: true });
                                          }}
                                        >
                                          <LocationOn sx={{ color: data.location.some(obj =>
                                            [obj.address, obj.city, obj.state, obj.zip].some(value => (value === '' || value === null))
                                          ) ? '' : theme.palette.primary.main }} />
                                        </IconButton>
                                        )}
                                      </TableCell>
                                      {/* <TableCell>{data.product_id||data.id}</TableCell> */}

                                      {/* <TableCell>
                                      <Autocomplete
  sx={{ width: 70 }}
  id="combo-box-demo"
  disableClearable
  options={marketingAdjustmentType || []}
  value={marketingAdjustmentType?.find((type) => type.id === data.markAdjType)} // Use value to set the correct selected option
  onChange={(event, newValue) => {
    setSelectedProducts((prevProducts) => {
      return prevProducts.map((product) => {
        if (product.indexId === data.indexId) {
          return {
            ...product,
            markAdjType: newValue?.id, // Set adjustment type or default to the first option
            // adjustment: 0,
          };
        }
        return product;
      });
    });
  }}
  renderInput={(params) => (
    <TextField
      {...params}
      required
      error={Boolean(touched.marketingAdjType && errors.marketingAdjType)}
      helperText={touched.marketingAdjType && errors.marketingAdjType}
      label="Select type"
    />
  )}
  getOptionLabel={(option) => (option.name ? option.name : '')}
/>

                                          </TableCell> */}


                                      {/* <TableCell> */}
                                        {/* <TextField
                                          type="number"
                                          label="Discount"
                                          value={Number(data.discount)}
                                          // {...getFieldProps(discountFieldName)}
                                          defaultValue={data.discount?data.discount:0}
                                          onChange={(event) => {
                                            let newValue = event.target.value;
                                            if (newValue.startsWith('-')) {
                                              newValue = newValue.slice(1);
                                            }
                                            if(markupType == 1){
                                              if (Number(newValue) > maxDiscount_wholesale) {
                                                newValue = maxDiscount_wholesale.toFixed(2);
                                              }
                                            }else if(markupType == 2){
                                              if (Number(newValue) > maxDiscount_retail) {
                                                newValue = maxDiscount_retail.toFixed(2);
                                              }
                                            }else{
                                              newValue = 0;
                                            }
                                            if (newValue === '-0.00') {
                                              newValue = 0;
                                            }
                                            setRefreshData(!refreshData)
                                            data['discount'] = newValue
                                            setFieldValue(discountFieldName, newValue);
                                          }}
                                          error={Boolean(touched[discountFieldName] && errors[discountFieldName])}
                                          helperText={touched[discountFieldName] && errors[discountFieldName]}
                                          inputProps={{ max: markupType == 1 ? maxDiscount_wholesale : markupType == 2 ? maxDiscount_retail : 0, min: 0 }}
                                        /> */}

                                        


                                         {/* <TextField
                                            type="number"
                                            // label="(%)"
                                            label={
                                              data.markAdjType === 2 ? "$" : data.markAdjType === 3 ? "¢" : "%"
                                            }
                                            value={Number(data.adjustment) || null}
                                            // defaultValue={data?.adjustment ? Number(data?.adjustment) : 0}
                                            onChange={(event) => {
                                              let newValue = event.target.value;
                                              // if (newValue.startsWith('-')) {
                                              //   newValue = newValue.slice(1);
                                              // }
                                              // if (newValue === '-0.00') {
                                              //   newValue = 0;
                                              // }
                                                  // Allow only two decimal places
                                                  if (newValue.includes('.')) {
                                                    const parts = newValue.split('.');
                                                    if (parts[1].length > 2) {
                                                      newValue = `${parts[0]}.${parts[1].slice(0, 2)}`;
                                                    }
                                                  }
                                              setRefreshData(!refreshData)
                                              data['adjustment'] = newValue
                                              setFieldValue(adjustmentFieldName, newValue);
                                            }}
                                            onKeyDown={(event) => {
                                              if (event.key === '-' || event.key === '+') {
                                                event.preventDefault();
                                              }
                                            }}
                                            error={Boolean(touched[adjustmentFieldName] && errors[adjustmentFieldName])}
                                            helperText={touched[adjustmentFieldName] && errors[adjustmentFieldName]}
                                          />
                                      </TableCell> */}
                                      {/* <TableCell>
                                          {rowTotal.toFixed(2)}
                                      </TableCell> */}


                                       {/* //maketting adjustment */}
                                       <TableCell>
                                         {isWriteRow || isQuotationChooseEmptyRow(data) ? '-' : (
                                                <Stack direction="row" spacing={1} alignItems="center">
                                                  <Remove 
                                                    fontSize="small" 
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => {
                                                      const hasPermission =  explodedPermissions?.some((permission) =>
                                                        ['Allow Negative Marketing Adjustment Estimate'].includes(permission),
                                                      )
                                                      // if(!hasPermission) {
                                                      //   return enqueueSnackbar('Access Denied : You do not have Suffient Permission', { variant: 'error' })
                                                      // }
                                                      const { maxNegative } = getMaxNegativeAdjustment(data, hasPermission);
                                                      const formulaEach = getSingleProductFormulaCostEach(data)
                                                      const retailEachBase = Math.max(
                                                        0,
                                                        Number(
                                                          data.original_actual_retail_price ??
                                                            data.original_retail_price ??
                                                            data.actual_retail_price ??
                                                            data.retail_price ??
                                                            data.product_retail_price ??
                                                            0,
                                                        ),
                                                      )
                                                      if (retailEachBase <= formulaEach && !hasPermission) {
                                                        return enqueueSnackbar(
                                                          'To apply a negative marketing adjustment, Retail Price Each must be higher than the Product formula cost Each.',
                                                          { variant: 'error' },
                                                        )
                                                      }
                                                      const adjustment = Number(data.adjustment) || 0;
                                                      if (Number(adjustment) >= maxNegative && hasPermission) {
                                                        return enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
                                                      } else if (adjustment > maxNegative && !hasPermission) {
                                                        return enqueueSnackbar(
                                                          `Negative Adjustment Amount cannot reduce total below Product Formula Cost. Max allowed: $${maxNegative.toFixed(2)}`,
                                                          { variant: 'error' }
                                                        );
                                                      }
                                                      const newValue = false
                                                      setSelectedProducts(
                                                        (prevProducts) =>
                                                          prevProducts.map(
                                                            (product) => {
                                                              if (
                                                                product.indexId ===
                                                                data.indexId
                                                              ) {
                                                                return applyProductAdjValueTypeChange(product, newValue)
                                                              }
                                                              return product
                                                            },
                                                          ),
                                                      )
                                                      data['adj_value_type'] = newValue
                                                      // setFieldValue('manager_approval_required', true)
                                                    }}
                                                  />
                                                  <FormControlLabel
                                                    control={
                                                      <Switch
                                                        checked={data.adj_value_type}
                                                        onChange={(event) => {
                                                          const newValue = event.target.checked
                                                          const hasPermission =  explodedPermissions?.some((permission) =>
                                                            ['Allow Negative Marketing Adjustment Estimate'].includes(permission),
                                                          )
                                                          // if(!hasPermission && newValue === false) {
                                                          //   return enqueueSnackbar('Access Denied : You do not have Suffient Permission', { variant: 'error' })
                                                          // }
                                                          const { maxNegative } = getMaxNegativeAdjustment(data, hasPermission);
                                                          if (newValue === false) {
                                                            const formulaEach = getSingleProductFormulaCostEach(data)
                                                            const retailEachBase = Math.max(
                                                              0,
                                                              Number(
                                                                data.original_actual_retail_price ??
                                                                  data.original_retail_price ??
                                                                  data.actual_retail_price ??
                                                                  data.retail_price ??
                                                                  data.product_retail_price ??
                                                                  0,
                                                              ),
                                                            )
                                                            if (retailEachBase <= formulaEach && !hasPermission) {
                                                              return enqueueSnackbar(
                                                                'To apply a negative marketing adjustment, Retail Price Each must be higher than the Product formula cost Each.',
                                                                { variant: 'error' },
                                                              )
                                                            }
                                                          }
                                                          const adjustment = Number(data.adjustment) || 0;
                                                          if (Number(adjustment) >= maxNegative && newValue === false && hasPermission) {
                                                            return enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
                                                          } else if (adjustment > maxNegative && newValue === false && !hasPermission) {
                                                            return enqueueSnackbar(
                                                              `Negative Adjustment Amount cannot reduce total below Product Formula Cost. Max allowed: $${maxNegative}`,
                                                              { variant: 'error' }
                                                            );
                                                          }
                                                          setSelectedProducts(
                                                            (prevProducts) =>
                                                              prevProducts.map(
                                                                (product) => {
                                                                  if (
                                                                    product.indexId ===
                                                                    data.indexId
                                                                  ) {
                                                                    return applyProductAdjValueTypeChange(product, newValue)
                                                                  }
                                                                  return product
                                                                },
                                                              ),
                                                          )
                                                          data['adj_value_type'] = newValue
                                                          if (newValue === false) {
                                                            // setFieldValue('manager_approval_required', true)
                                                          }
                                                        }}
                                                      />
                                                    }
                                                    label=""
                                                  />
                                                  <Add 
                                                    fontSize="small" 
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => {
                                                      const newValue = true
                                                      setSelectedProducts(
                                                        (prevProducts) =>
                                                          prevProducts.map(
                                                            (product) => {
                                                              if (
                                                                product.indexId ===
                                                                data.indexId
                                                              ) {
                                                                return applyProductAdjValueTypeChange(product, newValue)
                                                              }
                                                              return product
                                                            },
                                                          ),
                                                      )
                                                      data['adj_value_type'] = newValue
                                                    }}
                                                  />
                                                </Stack>
                                         )}
                                              </TableCell>
                                            <TableCell>
                                               {isWriteRow || isQuotationChooseEmptyRow(data) ? '-' : (
                                               <TextField
                                                  type="number"
                                                  inputProps={{ min: 0 }}
                                                  label='$'
                                                  value={
                                                    data.adjustment_draft !== undefined
                                                      ? limitDecimalInput(
                                                          data.adjustment_draft,
                                                        )
                                                      : Number(data.adjustment) || ''
                                                  }
                                                  InputLabelProps={{
                                                    shrink: Boolean(
                                                      data.adjustment_draft !== undefined
                                                        ? data.adjustment_draft !== ''
                                                        : Number(data.adjustment),
                                                    ),
                                                  }}
                                                  onWheel={(e) => e.target.blur()}
                                                  onBeforeInput={(e) => {
                                                    const inputElement = e.target;
                                                    const nextValue = inputElement.value; 
                                                const hasPermission = explodedPermissions?.some((permission) => ['Allow Negative Marketing Adjustment Estimate'].includes(permission));
                                                    const {maxNegative} = getMaxNegativeAdjustment(data, hasPermission);
                                                    if (Number(nextValue) >= maxNegative && (data.adj_value_type === false || data.adj_value_type === 0) && hasPermission) {
                                                      e.preventDefault();
                                                      enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
                                                    } else if (Number(nextValue) > maxNegative && (data.adj_value_type === false || data.adj_value_type === 0) && !hasPermission) {
                                                      e.preventDefault();
                                                      enqueueSnackbar(
                                                        `Negative Adjustment Amount cannot reduce total below Product Formula Cost. Max allowed: $${maxNegative.toFixed(2)}`,
                                                        { variant: "error" }
                                                      );
                                                    }
                                                  }}
                                                  onChange={(event) => {
                                                    handleMarketingAdjustmentChange(
                                                      data.indexId,
                                                      event.target.value,
                                                    )
                                                  }}
                                                  onBlur={(event) => {
                                                    handleMarketingAdjustmentChange(
                                                      data.indexId,
                                                      event.target.value,
                                                      { isBlur: true },
                                                    )
                                                  }}
                                                  onKeyDown={(event) => {
                                                    if (
                                                      event.key === '-' ||
                                                      event.key === '+'
                                                    ) {
                                                      event.preventDefault()
                                                    }
                                                    // Prevent arrow down key when value is 0 or would go negative
                                                    if (event.key === 'ArrowDown') {
                                                      const inputValue = event.target.value
                                                      const currentValue = parseFloat(inputValue) || 0
                                                      const step = parseFloat(event.target.step) || 1
                                                      if (currentValue - step < 0) {
                                                        event.preventDefault()
                                                      }
                                                    }
                                                  }}
                                                  error={Boolean(
                                                    touched[
                                                      adjustmentFieldName
                                                    ] &&
                                                      errors[
                                                        adjustmentFieldName
                                                      ],
                                                  )}
                                                  helperText={
                                                    touched[
                                                      adjustmentFieldName
                                                    ] &&
                                                    errors[adjustmentFieldName]
                                                  }
                                                />
                                               )}
                                              </TableCell>

                                      <TableCell>
                                        {isWriteRow || isQuotationChooseEmptyRow(data) ? '-' : `${fUSPrice(productCost.toFixed(2))}`}
                                        {/* {data?.adj_value_type ? (productCost + Number(data.adjustment)).toFixed(2) : (productCost - Number(data.adjustment)).toFixed(2)} */}
                                      </TableCell>
                                      <TableCell>
                                        {isWriteRow || isQuotationChooseEmptyRow(data) ? '-' : (
                                          data?.install_cost ? '' :
                                            `${fUSPrice(lineProductTotal.toFixed(2))}`
                                        )}
                                      </TableCell>
                                      <TableCell >
                                        {(data?.fromMapServices == true) ? '' : openEdit ? (
                                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                            {!isWriteRow && !isQuotationChooseEmptyRow(data) && data?.id ? (
                                              <Tooltip title="Change catalog product">
                                                <IconButton
                                                  size="small"
                                                  color="success"
                                                  onClick={() => openCatalogPickerForRow(data.indexId, data)}
                                                >
                                                  <SwapHorizontalCircleOutlined fontSize="small" />
                                                </IconButton>
                                              </Tooltip>
                                            ) : (
                                              <Box sx={{ width: 32 }} />
                                            )}
                                            <IconButton onClick={() => handleDeleteProduct(data.id||data.product_id, data.indexId)} color="error"
                                            //  disabled={data?.addedByUserType !== 18 && userType === 18}
                                             >
                                            <Delete />
                                          </IconButton>
                                          </Box>
                                        ) : (
                                          <IconButton onClick={() => handleDeleteProduct(data.id||data.product_id, data.indexId)} color="error"
                                          //  disabled={data?.addedByUserType !== 18 && userType === 18}
                                           >
                                            <Delete />
                                          </IconButton>
                                        )}
                                      </TableCell>
                                    </TableRow>
                                    {
                                      data?.install_cost ?
                                        <TableRow key={`summary-${data.indexId}`} sx={losingMoneyRowSx}>
                                           {openEdit && (
                                            <TableCell padding="checkbox" sx={{ width: 40 }} />
                                          )}
                                          {openEdit && (
                                            <TableCell padding="checkbox" sx={{ width: 40 }} />
                                          )}
                                          <TableCell>—</TableCell>
                                          <TableCell />
                                          <TableCell />
                                          <TableCell sx={VIEW_QUOTATION_PRODUCT_TABLE_COL_SX.productName}>
                                            <Typography sx={{ color: data?.install_notes ? 'red' : (isSplitOrder ? theme.palette[
                                        FacilityTypes.find(f => f.id === data?.facility_id)?.color || 'primary'
                                      ]?.main : 'inherit'), whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                              {data?.install_notes ? data?.install_notes : `Install Price`}
                                            </Typography>
                                          </TableCell>
                                          <TableCell sx={VIEW_QUOTATION_PRODUCT_TABLE_COL_SX.productDesc} />
                                          <TableCell align='center'>
                                            <IconButton onClick={() => handleOpenInstallNote(data.indexId, data.install_notes)}>
                                              <NoteAdd
                                                sx={{
                                                  color: (!data?.install_notes || data?.install_notes === '') ? '' : theme.palette.primary.main,
                                                }}
                                              />
                                            </IconButton>
                                          </TableCell>
                                          <TableCell />
                                          <TableCell align='center'>-</TableCell>
                                          <TableCell>{
                                            data?.install_formula_cost_each != null && data?.install_formula_cost_each !== ''
                                              ? Number(data.install_formula_cost_each).toFixed(2)
                                              : (data?.expected_install_labor_cost_with_markup?.toFixed(2) || 0)
                                          }</TableCell>
                                          {/* Incoming Percentage column for Install Price - only show when isSplitOrder is true */}
                                          {isSplitOrder ? (
                                            <TableCell align='center'>-</TableCell>
                                          ) : (
                                            <TableCell align='center'>-</TableCell>
                                          )}
                                          <TableCell>
                                            {(() => {
                                              const installFormulaEach = Number(
                                                data?.expected_install_labor_cost_with_markup ||
                                                  0,
                                              )
                                              const hasNegativeInstallPermission =
                                                explodedPermissions?.some(
                                                  (permission) =>
                                                    [
                                                      'Allow Negative Marketing Adjustment Sales Order',
                                                      'Allow Negative Marketing Adjustment Estimate',
                                                    ].includes(permission),
                                                )
                                              const installPriceMin =
                                                hasNegativeInstallPermission
                                                  ? 0.01
                                                  : Math.max(
                                                      0.01,
                                                      installFormulaEach,
                                                    )
                                              const dataInstallCost = getDisplayedInstallPrice(data)
                                              return (
                                            <TextField
                                              required
                                              fullWidth
                                              type="number"
                                              label={'Install Price Each'}
                                              sx={{ width: 120 }}
                                              value={
                                                data.install_price_draft !== undefined
                                                  ? limitDecimalInput(
                                                      data.install_price_draft,
                                                    )
                                                  : formatRetailPriceDisplay(
                                                      dataInstallCost,
                                                    )
                                              }
                                              onFocus={selectInputValue}
                                              onClick={selectInputValue}
                                              onKeyPress={(event) => {
                                                if (event.key === '-') {
                                                  event.preventDefault();
                                                }
                                                if (event.key === 'e') {
                                                  event.preventDefault();
                                                }
                                              }}
                                              onKeyDown={(event) => {
                                                if (
                                                  event.key === 'ArrowUp' ||
                                                  event.key === 'ArrowDown'
                                                ) {
                                                  event.preventDefault()
                                                  const current =
                                                    data.install_price_draft !== undefined
                                                      ? data.install_price_draft
                                                      : formatRetailPriceDisplay(
                                                          dataInstallCost,
                                                        )
                                                  handleInstallPriceChange(
                                                    data.indexId,
                                                    stepRetailPriceByArrow(
                                                      current,
                                                      event.key === 'ArrowUp'
                                                        ? 'up'
                                                        : 'down',
                                                      installPriceMin,
                                                    ),
                                                    { isBlur: true },
                                                  )
                                                }
                                              }}
                                              inputProps={{
                                                min: installPriceMin,
                                                step: 1,
                                              }}
                                              defaultValue={0}
                                              onChange={(event) => {
                                                const current =
                                                  data.install_price_draft !== undefined
                                                    ? data.install_price_draft
                                                    : formatRetailPriceDisplay(
                                                        dataInstallCost,
                                                      )
                                                handleInstallPriceChange(
                                                  data.indexId,
                                                  normalizeRetailArrowChange(
                                                    current,
                                                    event.target.value,
                                                    installPriceMin,
                                                  ),
                                                )
                                              }}
                                              onBlur={(event) => {
                                                handleInstallPriceChange(
                                                  data.indexId,
                                                  event.target.value,
                                                  { isBlur: true },
                                                )
                                              }}
                                            />
                                              )
                                            })()}
                                          </TableCell>
                                          {/* <TableCell align='center'></TableCell> */}
                                          <TableCell align='center'></TableCell>
                                          <TableCell align='center'>
                                            <TextField
                                              required
                                              fullWidth
                                              type="number"
                                              label={'Qty'}
                                              // sx={{ width: 85 }}
                                              value={Number(data.install_quantity || 1)}
                                              defaultValue={1}
                                              onFocus={selectInputValue}
                                              onClick={selectInputValue}
                                              onKeyPress={(event) => {
                                                if (
                                                  event.key === '0' &&
                                                  event.target.value === ''
                                                ) {
                                                  event.preventDefault()
                                                }
                                                if (event.key === '-') {
                                                  event.preventDefault()
                                                }
                                                if (event.key === '.') {
                                                  event.preventDefault()
                                                }
                                              }}
                                              onChange={(event) => {
                                                let newValue = event.target.value
                                                if (newValue !== '0' && newValue !== '') {
                                                  setSelectedProducts((prevProducts) =>
                                                    prevProducts.map((p) => {
                                                      if (p.indexId !== data.indexId) return p
                                                      return {
                                                        ...p,
                                                        install_quantity: Number(newValue),
                                                        manually_updated_install_quantity: true,
                                                      }
                                                    }),
                                                  )
                                                  data['install_quantity'] = Number(newValue)
                                                  setRefreshCalculation(!refreshCalculation)
                                                }
                                              }}
                                            />
                                          </TableCell>
                                          <TableCell align='center'></TableCell>
                                          {/* Marketing adjustment for Install Price (separate from product marketing adjustment) */}
                                          <TableCell>
                                            <Stack direction="row" spacing={1} alignItems="center">
                                              <Remove
                                                fontSize="small"
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => {
                                                  const hasPermission =
                                                    explodedPermissions?.some((permission) =>
                                                      ['Allow Negative Marketing Adjustment Estimate'].includes(permission),
                                                    )
                                                  // if (!hasPermission) {
                                                  //   return enqueueSnackbar(
                                                  //     'Access Denied : You do not have Suffient Permission',
                                                  //     { variant: 'error' },
                                                  //   )
                                                  // }
                                                  const formulaEach = Number(
                                                    data?.expected_install_labor_cost_with_markup || 0,
                                                  )
                                                  const retailEachBase = Math.max(
                                                    0,
                                                    Number(data.install_cost || 0),
                                                  )
                                                  if (retailEachBase <= formulaEach && !hasPermission) {
                                                    return enqueueSnackbar(
                                                      'To apply a negative marketing adjustment, Install Price Each must be higher than the Install formula cost Each.',
                                                      { variant: 'error' },
                                                    )
                                                  }
                                                  const maxNegative = getMaxNegativeInstallAdjustment(data, hasPermission)
                                                  const adjustment = Number(data.install_adjustment) || 0
                                                  if (Number(adjustment) >= maxNegative && hasPermission) {
                                                    return enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
                                                  } else if (Number(adjustment) > maxNegative && !hasPermission) {
                                                    return enqueueSnackbar(
                                                      `Negative Adjustment Amount cannot reduce below $${maxNegative.toFixed(2)} (Install Formula Limit)`,
                                                      { variant: 'error' },
                                                    )
                                                  }

                                                  const newValue = false
                                                  setSelectedProducts((prevProducts) =>
                                                    prevProducts.map((product) => {
                                                      if (product.indexId !== data.indexId) return product

                                                      return applyInstallAdjValueTypeChange(product, newValue)
                                                    }),
                                                  )
                                                  data['install_adj_value_type'] = newValue
                                                  setFieldValue('manager_approval_required', true)
                                                  setRefreshCalculation(!refreshCalculation)
                                                }}
                                              />
                                              <FormControlLabel
                                                control={
                                                  <Switch
                                                    checked={data.install_adj_value_type}
                                                    onChange={(event) => {
                                                      const newValue = event.target.checked
                                                      const hasPermission =
                                                        explodedPermissions?.some((permission) =>
                                                          ['Allow Negative Marketing Adjustment Estimate'].includes(permission),
                                                        )
                                                      // if (!hasPermission && newValue === false) {
                                                      //   return enqueueSnackbar(
                                                      //     'Access Denied : You do not have Suffient Permission',
                                                      //     { variant: 'error' },
                                                      //   )
                                                      // }
                                                      const maxNegative = getMaxNegativeInstallAdjustment(data, hasPermission)
                                                      if (newValue === false) {
                                                        const formulaEach = Number(
                                                          data?.expected_install_labor_cost_with_markup || 0,
                                                        )
                                                        const retailEachBase = Math.max(
                                                          0,
                                                          Number(data.install_cost || 0),
                                                        )
                                                        if (retailEachBase <= formulaEach && !hasPermission) {
                                                          return enqueueSnackbar(
                                                            'To apply a negative marketing adjustment, Install Price Each must be higher than the Install formula cost Each.',
                                                            { variant: 'error' },
                                                          )
                                                        }
                                                      }
                                                      const adjustment = Number(data.install_adjustment) || 0
                                                      if (Number(adjustment) >= maxNegative && newValue === false && hasPermission) {
                                                        return enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
                                                      } else if (Number(adjustment) > maxNegative && newValue === false && !hasPermission) {
                                                        return enqueueSnackbar(
                                                          `Negative Adjustment Amount cannot reduce below $${maxNegative.toFixed(2)} (Install Formula Limit)`,
                                                          { variant: 'error' },
                                                        )
                                                      }

                                                      setSelectedProducts((prevProducts) =>
                                                        prevProducts.map((product) => {
                                                          if (product.indexId !== data.indexId) return product

                                                          return applyInstallAdjValueTypeChange(product, newValue)
                                                        }),
                                                      )
                                                      data['install_adj_value_type'] = newValue
                                                      if (newValue === false) {
                                                        setFieldValue('manager_approval_required', true)
                                                      }
                                                      setRefreshCalculation(!refreshCalculation)
                                                    }}
                                                  />
                                                }
                                                label=""
                                              />
                                              <Add
                                                fontSize="small"
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => {
                                                  const newValue = true
                                                  setSelectedProducts((prevProducts) =>
                                                    prevProducts.map((product) => {
                                                      if (product.indexId !== data.indexId) return product

                                                      return applyInstallAdjValueTypeChange(product, newValue)
                                                    }),
                                                  )
                                                  data['install_adj_value_type'] = newValue
                                                  setRefreshCalculation(!refreshCalculation)
                                                }}
                                              />
                                            </Stack>
                                          </TableCell>
                                          <TableCell>
                                            <TextField
                                              type="number"
                                              inputProps={{ min: 0 }}
                                              label="$"
                                              InputLabelProps={{
                                                shrink: Boolean(
                                                  data.install_adjustment_draft !== undefined
                                                    ? data.install_adjustment_draft !== ''
                                                    : Number(data.install_adjustment),
                                                ),
                                              }}
                                              value={
                                                data.install_adjustment_draft !== undefined
                                                  ? limitDecimalInput(
                                                      data.install_adjustment_draft,
                                                    )
                                                  : Number(data.install_adjustment) || ''
                                              }
                                              onWheel={(e) => e.target.blur()}
                                              onBeforeInput={(e) => {
                                                // const char = e.data
                                                // const nextValue = e.target.value + char
                                                const inputElement = e.target;
                                                const nextValue = inputElement.value; 
                                                const hasPermission = explodedPermissions?.some((permission) => ['Allow Negative Marketing Adjustment Estimate'].includes(permission));
                                                const maxNegative = getMaxNegativeInstallAdjustment(data, hasPermission)
                                                if (Number(nextValue) >= maxNegative && data.install_adj_value_type === false && hasPermission) {
                                                  e.preventDefault()
                                                  enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
                                                } else if (
                                                  Number(nextValue) > maxNegative &&
                                                  data.install_adj_value_type === false &&
                                                  !hasPermission
                                                ) {
                                                  e.preventDefault()
                                                  enqueueSnackbar(
                                                    `Negative Adjustment Amount cannot reduce below $${maxNegative.toFixed(2)} (Install Formula Limit)`,
                                                    { variant: 'error' },
                                                  )
                                                }
                                              }}
                                              onChange={(event) => {
                                                let newValue = event.target.value
                                                const numValue = parseFloat(newValue) || 0
                                                if (numValue < 0) {
                                                  newValue = 0
                                                } else {
                                                  newValue = String(numValue)
                                                }

                                                if (newValue.includes('.')) {
                                                  const parts = newValue.split('.')
                                                  if (parts[1].length > 2) {
                                                    newValue = `${parts[0]}.${parts[1].slice(0, 2)}`
                                                  }
                                                }

                                                handleInstallAdjustmentChange(
                                                  data.indexId,
                                                  data,
                                                  newValue,
                                                )
                                              }}
                                              onKeyDown={(event) => {
                                                if (event.key === '-' || event.key === '+') {
                                                  event.preventDefault()
                                                }
                                                if (event.key === 'ArrowDown') {
                                                  const inputValue = event.target.value
                                                  const currentValue = parseFloat(inputValue) || 0
                                                  const step = parseFloat(event.target.step) || 1
                                                  if (currentValue - step < 0) {
                                                    event.preventDefault()
                                                  }
                                                }
                                              }}
                                            />
                                          </TableCell>
                                          <TableCell>
                                            ${fUSPrice((
                                            parseFloat(data?.install_cost || 0) *
                                            Number(data?.install_quantity) || 1
                                          ).toFixed(2))}
                                          </TableCell>
                                          <TableCell>
                                               {(() => {
                                                  const locQty = Number(data?.locationQuantity) || 1
                                                  const installQty = Number(data?.install_quantity) || 1
                                                  const discount = Number(values[discountFieldName]) || 0

                                                  // Use the exact same calculation as the product subtotal column
                                                  const productSubTotal =
                                                    markupType == 1
                                                      ? (Number(data?.price) || 0) * locQty
                                                      : markupType == 2
                                                      ? (Number(data?.actual_retail_price || data?.retail_price || 0)) * locQty
                                                      : 0

                                                  // Use the exact same calculation as the install subtotal column
                                                  const installSubTotal =
                                                    (Number(data?.install_cost) || 0) *
                                                    installQty

                                                  // Product Total is the sum of both subtotals minus discount
                                                  const total = Math.max(
                                                    0,
                                                    productSubTotal + installSubTotal - discount,
                                                  )
                                                  return fUSPrice(total.toFixed(2))
                                                })()}
                                          </TableCell>
                                          <TableCell align="center">
                                            <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
                                              <Box sx={{ width: 32 }} />
                                              <IconButton
                                              // disabled={data?.addedByUserType !== 18 && userType === 18}
                                                color="error"
                                                onClick={() => handleDeleteInstallCost(data.id || data.product_id, data.indexId)}
                                              >
                                                <Delete />
                                              </IconButton>
                                            </Box>
                                          </TableCell>
                                        </TableRow> :
                                        ''
                                    }
                                    <TableRow>
                                      <TableCell colSpan={15} sx={{ padding: 0 }}>
                                        <Divider />
                                      </TableCell>
                                    </TableRow>
                                    <Modal
                                      open={locationStates[data.indexId]}
                                      handleClose={() => {
                                        setLocationStates({ ...locationStates, [data.indexId]: false });
                                      }}
                                    >
                                      <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent={'space-between'} alignItems={'center'}>
                                       {((data?.fromMapServices != true) 
                                      //  && index === 0
                                      ) && <FormControlLabel
                                                  control={
                                                    <Switch
                                                      checked={data?.allLocationSame}
                                                      onChange={()=>handleAllLocationSameChange(index)}
                                                    />
                                                  }
                                                  label="All Locations Same"
                                                />}
                                            {
                                              values.project_category?.id !== 14 ?
                                          <Box sx={{ display: 'flex', flexDirection: 'column',width:'50%', alignItems: 'center', mt: 2 }}>
                                                {/* <Typography variant="subtitle2">Qty Location Settings</Typography> */}
                                              <LabelStyle sx={{fontSize:'16px'}}>Qty Location Settings</LabelStyle>
                                                <Box display="flex" alignItems="center" gap={1} mt={1}>
                                                    <Typography variant="subtitle2">Multiple</Typography>
                                                    {
                                                      console.log("data?.is_single_card",data?.is_single_card)
                                                    }
                                                    {/* <LabelStyle>Multiple</LabelStyle> */}
                                                      <Switch
                                                          color="primary"
                                                          checked={Boolean(data?.is_single_card)}
                                                          onChange={(event) => {
                                                            const checked = event.target.checked;
                                                            setSelectedProducts((prev) =>
                                                              prev.map((p) => {
                                                                if (p.indexId !== data.indexId) return p;
                                                            
                                                                const count = Number(p.locationQuantity || 1);
                                                            
                                                                if (checked) {
                                                                  return {
                                                                    ...p,
                                                                    is_single_card: true,
                                                                    location: p.location?.length
                                                                      ? [p.location[0]]
                                                                      : [
                                                                          {
                                                                            id: 0,
                                                                            address: '',
                                                                            city: '',
                                                                            state: '',
                                                                            zip: '',
                                                                          },
                                                                        ],
                                                                  };
                                                                } else {
                                                                  const allSame = p.allLocationSame;
                                                                  const firstAddress = p.location?.[0];
                                                                  let arrayAddr = [];
                                                            
                                                                  if (allSame && firstAddress) {
                                                                    arrayAddr = Array(count)
                                                                      .fill()
                                                                      .map((_, i) => ({
                                                                        ...firstAddress,
                                                                        id: i,
                                                                        req_loc_id: p.location[i]?.req_loc_id ?? null,
                                                                      }));
                                                                  } else {
                                                                    arrayAddr = [...p.location];
                                                                    if (arrayAddr.length < count) {
                                                                      arrayAddr.push(
                                                                        ...Array(count - arrayAddr.length)
                                                                          .fill()
                                                                          .map((_, i) => ({
                                                                            id: arrayAddr.length + i,
                                                                            address: '',
                                                                            city: '',
                                                                            state: '',
                                                                            zip: '',
                                                                          }))
                                                                      );
                                                                    } else if (arrayAddr.length > count) {
                                                                      arrayAddr = arrayAddr.slice(0, count);
                                                                    }
                                                                  }
                                                            
                                                                  return {
                                                                    ...p,
                                                                    is_single_card: false,
                                                                    location: arrayAddr,
                                                                  };
                                                                }
                                                              })
                                                            );
                                                          }}
                                                        />
                                                      {/* <LabelStyle>Single</LabelStyle> */}
                                                      <Typography variant="subtitle2">Single</Typography>
                                                </Box>
                                          </Box>:''
                                          }
                                          </Stack>
                                        <Grid
                                          container
                                          spacing={3}
                                          sx={{ justifyContent: 'center', width: '100%' }}
                                          >
                                          {data.location.map((addr, i) => (
                                          <Grid item xs={12}>
                                            <Typography variant="h5" sx={{ mb: 2 }}>
                                              Location {data?.fromMapServices == true ? i+1 : i+1}
                                            </Typography>

                                            <Stack
                                              direction={{ xs: 'column', sm: 'row' }}
                                              spacing={{ xs: 3, sm: 2 }}
                                              sx={{ mb: 2 }}
                                            >
                                              <TextField
                                                fullWidth
                                                label="Address"
                                                size="small"
                                                value={data.location[i].address || ''}
                                                disabled={(data?.fromMapServices == true && data.location[i].address) ? true : (i !== 0 && data?.allLocationSame)?true:false}
                                                // onChange={(event)=>{
                                                //   let arrayAddr = [...data.location]
                                                //   arrayAddr[i].address = event.target.value;
                                                //   setSelectedProducts(pv=>([...pv.map(p=>{
                                                //     // if(p.id===data.id){
                                                //     if (p.indexId === data.indexId) {
                                                //       return {
                                                //         ...p,
                                                //         location: arrayAddr
                                                //       }
                                                //     }else{
                                                //       return p;
                                                //     }
                                                //   })]))
                                                // }}
                                                onChange={(event) => {
                                                  setSelectedProducts((prevProducts) =>
                                                    prevProducts.map((p) => {
                                                      if (p.indexId === data.indexId) {
                                                        let updatedLocations = [...p.location];
                                                        if (p.allLocationSame) {
                                                          updatedLocations = updatedLocations.map(() => ({
                                                            ...updatedLocations[0], 
                                                            address: event.target.value, 
                                                          }));
                                                        } else {
                                                          updatedLocations[i] = {
                                                            ...updatedLocations[i], 
                                                            address: event.target.value,
                                                          };
                                                        }
                                                        return {
                                                          ...p,
                                                          location: updatedLocations,
                                                        };
                                                      }
                                                      return p;
                                                    })
                                                  );
                                                  // markUnsavedChanges();();
                                                }}
                                              />
                                            </Stack>

                                            <Stack
                                              direction={{ xs: 'column', sm: 'row' }}
                                              spacing={{ xs: 3, sm: 2 }}
                                              sx={{ mb: 2 }}
                                            >
                                              <TextField
                                                fullWidth
                                                label="City"
                                                size="small"
                                                value={data.location[i].city || ''}
                                                disabled={(data?.fromMapServices == true && data.location[i].city) ? true : (i !== 0 && data?.allLocationSame)?true:false}
                                                // onChange={(event)=>{
                                                //   let arrayAddr = [...data.location]
                                                //   arrayAddr[i].city = event.target.value;
                                                //   setSelectedProducts(pv=>([...pv.map(p=>{
                                                //     // if(p.id===data.id){
                                                //     if (p.indexId === data.indexId) {
                                                //       return {
                                                //         ...p,
                                                //         location: arrayAddr
                                                //       }
                                                //     }else{
                                                //       return p;
                                                //     }
                                                //   })]))
                                                // }}
                                                onChange={(event) => {
                                                  setSelectedProducts((prevProducts) =>
                                                    prevProducts.map((p) => {
                                                      if (p.indexId === data.indexId) {
                                                        let updatedLocations = [...p.location];
                                                        if (p.allLocationSame) {
                                                          updatedLocations = updatedLocations.map(() => ({
                                                            ...updatedLocations[0], 
                                                            city: event.target.value, 
                                                          }));
                                                        } else {
                                                          updatedLocations[i] = {
                                                            ...updatedLocations[i], 
                                                            city: event.target.value,
                                                          };
                                                        }
                                                        return {
                                                          ...p,
                                                          location: updatedLocations,
                                                        };
                                                      }
                                                      return p;
                                                    })
                                                  );
                                                  // markUnsavedChanges();();
                                                }}
                                              />
                                              <TextField
                                                fullWidth
                                                label="State"
                                                size="small"
                                                value={data.location[i].state || ''}
                                                disabled={(data?.fromMapServices == true && data.location[i].state) ? true : (i !== 0 && data?.allLocationSame)?true:false}
                                                // onChange={(event)=>{
                                                //   let arrayAddr = [...data.location]
                                                //   arrayAddr[i].state = event.target.value;
                                                //   setSelectedProducts(pv=>([...pv.map(p=>{
                                                //     // if(p.id===data.id){
                                                //     if (p.indexId === data.indexId) {
                                                //       return {
                                                //         ...p,
                                                //         location: arrayAddr
                                                //       }
                                                //     }else{
                                                //       return p;
                                                //     }
                                                //   })]))
                                                // }}
                                                onChange={(event) => {
                                                  setSelectedProducts((prevProducts) =>
                                                    prevProducts.map((p) => {
                                                      if (p.indexId === data.indexId) {
                                                        let updatedLocations = [...p.location];
                                                        if (p.allLocationSame) {
                                                          updatedLocations = updatedLocations.map(() => ({
                                                            ...updatedLocations[0], 
                                                            state: event.target.value, 
                                                          }));
                                                        } else {
                                                          updatedLocations[i] = {
                                                            ...updatedLocations[i], 
                                                            state: event.target.value,
                                                          };
                                                        }
                                                        return {
                                                          ...p,
                                                          location: updatedLocations,
                                                        };
                                                      }
                                                      return p;
                                                    })
                                                  );
                                                  // markUnsavedChanges();();
                                                }}
                                              />
                                              <TextField
                                                fullWidth
                                                label="Zip / Postal Code"
                                                size="small"
                                                value={data.location[i].zip || ''}
                                                disabled={(data?.fromMapServices == true && data.location[i].zip) ? true : (i !== 0 && data?.allLocationSame)?true:false}
                                                // onChange={(event)=>{
                                                //   let arrayAddr = [...data.location]
                                                //   arrayAddr[i].zip = event.target.value;
                                                //   setSelectedProducts(pv=>([...pv.map(p=>{
                                                //     // if(p.id===data.id){
                                                //     if (p.indexId === data.indexId) {
                                                //       return {
                                                //         ...p,
                                                //         location: arrayAddr
                                                //       }
                                                //     }else{
                                                //       return p;
                                                //     }
                                                //   })]))
                                                // }}
                                                onChange={(event) => {
                                                  setSelectedProducts((prevProducts) =>
                                                    prevProducts.map((p) => {
                                                      if (p.indexId === data.indexId) {
                                                        let updatedLocations = [...p.location];
                                                        if (p.allLocationSame) {
                                                          updatedLocations = updatedLocations.map(() => ({
                                                            ...updatedLocations[0], 
                                                            zip: event.target.value, 
                                                          }));
                                                        } else {
                                                          updatedLocations[i] = {
                                                            ...updatedLocations[i], 
                                                            zip: event.target.value,
                                                          };
                                                        }
                                                        return {
                                                          ...p,
                                                          location: updatedLocations,
                                                        };
                                                      }
                                                      return p;
                                                    })
                                                  );
                                                  // markUnsavedChanges();();
                                                }}
                                              />
                                            </Stack>
                                          </Grid>
                                            ))}
                                        </Grid>

                                        <Grid container justifyContent="center" alignItems="center">
                                          <Grid item xs={12} md={4}>
                                          {(data?.fromMapServices == true) ? true : // (i !== 0 && data?.allLocationSame) ? true : 
                                            <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 1 }}>
                                              <LoadingButton variant="contained" onClick={() => {
                                                setIsSaving(true)
                                                setTimeout(() => {
                                                  setIsSaving(false)
                                                  setLocationStates(false)
                                                },100)
                                              }} loading={isSaving}>
                                                {' Save '}
                                              </LoadingButton>
                                            </Box>}
                                          </Grid>
                                        </Grid> 
                                  </Modal>
                                  <Modal
                                        open={openProductNote[data.indexId] || false}
                                        handleClose={() => handleCloseNote(data.indexId)}
                                      >
                                        <Grid
                                          container
                                          spacing={3}
                                          sx={{ justifyContent: 'center', width: '100%' }}
                                        >
                                            <Grid item xs={12}>
                                              <Typography variant="h5" sx={{ mb: 2 }}>
                                                Note
                                              </Typography>

                                              <Stack
                                                direction={{ xs: 'column', sm: 'row' }}
                                                spacing={{ xs: 3, sm: 2 }}
                                                sx={{ mb: 2 }}
                                              >
                                                <TextField
                                                  fullWidth
                                                  multiline
                                                  rows={4}
                                                  size="medium"
                                                  value={currentNote}
                                                  onChange={handleNoteChange}
                                                  error={!currentNote.trim() && currentNote.length > 0}
                                                  inputProps={{ maxLength: MAX_CHARACTERS }}
                                                  helperText={
                                                    !currentNote.trim() && currentNote.length > 0
                                                      ? 'Note cannot be empty or contain only spaces'
                                                      : `${currentNote.length}/${MAX_CHARACTERS} characters`
                                                  }
                                                  InputProps={{
                                                    sx: {
                                                      color: 'error.main',
                                                    }
                                                  }}
                                                />
                                              </Stack>
                                            </Grid>
                                        </Grid>

                                        <Grid container justifyContent="center" alignItems="center">
                                          <Grid item xs={12} md={4}>
                                            <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 1 }}>
                                              <LoadingButton
                                                variant="contained"
                                                onClick={() => handleSaveNote(data.indexId)}
                                                loading={isSavingNote}
                                                disabled={!currentNote.trim()}>
                                                Save
                                              </LoadingButton>
                                              <LoadingButton
                                                variant="outlined"
                                                color="error"
                                                onClick={() => handleClearNote(data.indexId)}
                                                loading={isClearingNote}
                                                disabled={!currentNote.trim()}>
                                                Clear
                                              </LoadingButton>
                                            </Box>
                                          </Grid>
                                        </Grid>
                                      </Modal>
                                      <Modal
                                        open={openProductAttachment[data.indexId] || false}
                                        handleClose={() => handleCloseAttachment(data.indexId)}
                                      >
                                        {renderProductAttachmentModalContent(data.indexId)}
                                      </Modal>
                                      <Modal
                                        open={openInstallNote[data.indexId] || false}
                                        handleClose={() => handleCloseInstallNote(data.indexId)}
                                      >
                                        <Grid
                                          container
                                          spacing={3}
                                          sx={{ justifyContent: 'center', width: '100%' }}
                                        >
                                            <Grid item xs={12}>
                                              <Typography variant="h5" sx={{ mb: 2 }}>
                                                Install Note
                                              </Typography>

                                              <Stack
                                                direction={{ xs: 'column', sm: 'row' }}
                                                spacing={{ xs: 3, sm: 2 }}
                                                sx={{ mb: 2 }}
                                              >
                                                <TextField
                                                  fullWidth
                                                  multiline
                                                  rows={4}
                                                  size="medium"
                                                  value={currentNote}
                                                  onChange={handleNoteChange}
                                                  error={!currentNote.trim() && currentNote.length > 0}
                                                  inputProps={{ maxLength: MAX_CHARACTERS }}
                                                  helperText={
                                                    !currentNote.trim() && currentNote.length > 0
                                                      ? 'Note cannot be empty or contain only spaces'
                                                      : `${currentNote.length}/${MAX_CHARACTERS} characters`
                                                  }
                                                  InputProps={{
                                                    sx: {
                                                      color: 'error.main',
                                                    }
                                                  }}
                                                />
                                              </Stack>
                                            </Grid>
                                        </Grid>

                                        <Grid container justifyContent="center" alignItems="center">
                                          <Grid item xs={12} md={4}>
                                            <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 1 }}>
                                              <LoadingButton
                                                variant="contained"
                                                onClick={() => handleSaveInstallNote(data.indexId)}
                                                loading={isSavingNote}
                                                disabled={!currentNote.trim()}>
                                                Save
                                              </LoadingButton>
                                              <LoadingButton
                                                variant="outlined"
                                                color="error"
                                                onClick={() => handleClearInstallNote(data.indexId)}
                                                loading={isClearingNote}
                                                disabled={!currentNote.trim()}>
                                                Clear
                                              </LoadingButton>
                                            </Box>
                                          </Grid>
                                        </Grid>
                                      </Modal>
                                  </>
                                      )}
                                    </Draggable>
                                  );
                                })} 
                                {droppableProvided.placeholder}
                                
                                {/* Service Note Modal for selectedServices */}
                                {selectedServices?.map((data, index) => (
                                  <Modal
                                    key={`service-note-${data.indexId || data.id}`}
                                    open={openServiceNote[data.indexId || data.id] || false}
                                    handleClose={() => handleCloseServiceNote(data.indexId || data.id)}
                                  >
                                    <Grid
                                      container
                                      spacing={3}
                                      sx={{ justifyContent: 'center', width: '100%' }}
                                    >
                                      <Grid item xs={12}>
                                        <Typography variant="h5" sx={{ mb: 2, }}>
                                          Service Note
                                        </Typography>

                                        <Stack
                                          direction={{ xs: 'column', sm: 'row' }}
                                          spacing={{ xs: 3, sm: 2 }}
                                          sx={{ mb: 2 }}
                                        >
                                          <TextField
                                            fullWidth
                                            multiline
                                            rows={4}
                                            size="medium"
                                            value={currentNote}
                                            onChange={handleServiceNoteChange}
                                            error={!currentNote.trim() && currentNote.length > 0}
                                            inputProps={{ maxLength: MAX_CHARACTERS }}
                                            helperText={
                                              !currentNote.trim() && currentNote.length > 0
                                                ? 'Note cannot be empty or contain only spaces'
                                                : `${currentNote.length}/${MAX_CHARACTERS} characters`
                                            }
                                            InputProps={{
                                              sx: {
                                                color: 'error.main',
                                              }
                                            }}
                                          />
                                        </Stack>
                                      </Grid>
                                    </Grid>

                                    <Grid container justifyContent="center" alignItems="center">
                                      <Grid item xs={12} md={4}>
                                        <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 1 }}>
                                          <LoadingButton
                                            variant="contained"
                                            onClick={() => handleSaveServiceNote(data.newIndexId ?? data.indexId)}
                                            loading={isSavingNote}
                                            disabled={!currentNote.trim()}>
                                            Save
                                          </LoadingButton>
                                          <LoadingButton
                                            variant="outlined"
                                            color="error"
                                            onClick={() => handleClearServiceNote(data.newIndexId ?? data.indexId)}
                                            loading={isClearingNote}
                                            disabled={!currentNote.trim()}>
                                            Clear
                                          </LoadingButton>
                                        </Box>
                                      </Grid>
                                    </Grid>
                                  </Modal>
                                ))}

                                {/* Service Note Modal for additionalSelectedServices */}
                                {additionalSelectedServices?.map((data, index) => (
                                  <Modal
                                    key={`additional-service-note-${ data.newIndexId  ||data.indexId || index}`}
                                    open={openServiceNote[  data.newIndexId ||data.indexId  || index] || false}
                                    handleClose={() => handleCloseServiceNote( data.newIndexId ||data.indexId || index)}
                                  >
                                    <Grid
                                      container
                                      spacing={3}
                                      sx={{ justifyContent: 'center', width: '100%' }}
                                    >
                                      <Grid item xs={12}>
                                        <Typography variant="h5" sx={{ mb: 2, }}>
                                          Service Note
                                        </Typography>

                                        <Stack
                                          direction={{ xs: 'column', sm: 'row' }}
                                          spacing={{ xs: 3, sm: 2 }}
                                          sx={{ mb: 2 }}
                                        >
                                          <TextField
                                            fullWidth
                                            multiline
                                            rows={4}
                                            size="medium"
                                            value={currentNote}
                                            onChange={handleServiceNoteChange}
                                            error={!currentNote.trim() && currentNote.length > 0}
                                            inputProps={{ maxLength: MAX_CHARACTERS }}
                                            helperText={
                                              !currentNote.trim() && currentNote.length > 0
                                                ? 'Note cannot be empty or contain only spaces'
                                                : `${currentNote.length}/${MAX_CHARACTERS} characters`
                                            }
                                            InputProps={{
                                              sx: {
                                                color: 'error.main',
                                              }
                                            }}
                                          />
                                        </Stack>
                                      </Grid>
                                    </Grid>

                                    <Grid container justifyContent="center" alignItems="center">
                                      <Grid item xs={12} md={4}>
                                        <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 1 }}>
                                          <LoadingButton
                                            variant="contained"
                                            onClick={() => handleSaveServiceNote(data.newIndexId ?? data.indexId)}
                                            loading={isSavingNote}
                                            disabled={!currentNote.trim()}>
                                            Save
                                          </LoadingButton>
                                          <LoadingButton
                                            variant="outlined"
                                            color="error"
                                            onClick={() => handleClearServiceNote(data.newIndexId ?? data.indexId)}
                                            loading={isClearingNote}
                                            disabled={!currentNote.trim()}>
                                            Clear
                                          </LoadingButton>
                                        </Box>
                                      </Grid>
                                    </Grid>
                                  </Modal>
                                ))}

                                {additionalSelectedServices?.map((data, index) => {
                                  const svcKey = String(data.newIndexId ?? data.indexId ?? '');
                                  return (
                                    <Modal
                                      key={`additional-service-attachment-${svcKey}-${index}`}
                                      open={openServiceAttachment[svcKey] || false}
                                      handleClose={() => handleCloseServiceAttachment(svcKey)}
                                    >
                                      <Grid
                                        container
                                        spacing={3}
                                        sx={{
                                          justifyContent: 'center',
                                          width: '100%',
                                        }}
                                      >
                                        <Grid item xs={12}>
                                          <Typography variant="h5" sx={{ mb: 2 }}>
                                            Upload Attachment
                                          </Typography>
                                          <Tabs
                                            value={attachmentTabValueService[svcKey] || 0}
                                            onChange={(e, newValue) =>
                                              handleAttachmentTabChangeService(e, newValue, svcKey)
                                            }
                                            sx={{ mb: 2 }}
                                          >
                                            <Tab label="Select from Uploaded" />
                                            <Tab label="Upload New" />
                                          </Tabs>

                                          {(attachmentTabValueService[svcKey] || 0) === 0 ? (
                                            <Box>
                                              {(() => {
                                                const allProductAttachmentFiles = Object.values(productAttachments).flat()
                                                const allServiceAttachmentFiles = Object.values(serviceAttachments).flat()
                                                const currentServiceAttachments =
                                                  serviceAttachments[String(svcKey)] ||
                                                  serviceAttachments[svcKey] ||
                                                  []

                                                const availableAvatarFiles = (avatarUrl || []).filter((file) => {
                                                  return (
                                                    !allProductAttachmentFiles.some((pfile) =>
                                                      attachmentMatches(pfile, file),
                                                    ) &&
                                                    !allServiceAttachmentFiles.some((sfile) =>
                                                      attachmentMatches(sfile, file),
                                                    )
                                                  )
                                                })

                                                const allFiles = [
                                                  ...availableAvatarFiles,
                                                  ...allProductAttachmentFiles,
                                                  ...allServiceAttachmentFiles,
                                                  ...currentServiceAttachments,
                                                ]

                                                const allFilesUnique = (() => {
                                                  const seen = []
                                                  return allFiles.filter((file) => {
                                                    if (seen.some((f) => attachmentMatches(f, file))) return false
                                                    seen.push(file)
                                                    return true
                                                  })
                                                })()

                                                if (allFilesUnique.length === 0) {
                                                  return (
                                                    <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', py: 4 }}>
                                                      No uploaded files available. Please upload files first.
                                                    </Typography>
                                                  )
                                                }

                                                const availableImages = allFilesUnique.filter((file) => {
                                                  const isAddedToOtherProduct = Object.entries(productAttachments).some(
                                                    ([, attachments]) =>
                                                      attachments &&
                                                      attachments.some((f) => attachmentMatches(f, file)),
                                                  )
                                                  const isAddedToOtherService = Object.entries(serviceAttachments).some(
                                                    ([serviceId, attachments]) =>
                                                      String(serviceId) !== String(svcKey) &&
                                                      attachments &&
                                                      attachments.some((f) => attachmentMatches(f, file)),
                                                  )
                                                  return !isAddedToOtherProduct && !isAddedToOtherService
                                                })

                                                if (availableImages.length === 0) {
                                                  return (
                                                    <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', py: 4 }}>
                                                      All files are already linked to other items. No files left in uploaded list.
                                                    </Typography>
                                                  );
                                                }

                                                const svcSelectionKey = String(svcKey);
                                                const rowSelectionService =
                                                  selectedUploadedImagesService[svcSelectionKey] ||
                                                  selectedUploadedImagesService[svcKey] ||
                                                  [];
                                                const originalService = serviceAttachments[svcSelectionKey] || serviceAttachments[svcKey] || [];
                                                const toLinkService = rowSelectionService.filter(
                                                  (file) => !originalService.some((orig) => attachmentMatches(orig, file)),
                                                );
                                                const toUnlinkService = originalService.filter(
                                                  (file) => !rowSelectionService.some((sel) => attachmentMatches(sel, file)),
                                                );
                                                const hasServiceChanges = toLinkService.length > 0 || toUnlinkService.length > 0;

                                                return (
                                                  <>
                                                    <Grid container spacing={2} sx={{ mb: 2 }}>
                                                      {availableImages.map((file, idx) => {
                                                        const isSelected = rowSelectionService.some((f) => attachmentMatches(f, file));
                                                        const isAlreadyAddedToCurrent = originalService.some((f) => attachmentMatches(f, file));
                                                        return (
                                                          <Grid item xs={6} sm={4} md={3} key={idx}>
                                                            <Card
                                                              sx={{
                                                                position: 'relative',
                                                                border: isSelected ? '2px solid' : '1px solid',
                                                                borderColor: isSelected ? 'primary.main' : 'divider',
                                                                cursor: 'pointer',
                                                                opacity: 1,
                                                              }}
                                                              onClick={() => {
                                                                handleImageSelectService(file, svcKey, !isSelected);
                                                              }}
                                                            >
                                                              <Box
                                                                sx={{
                                                                  position: 'relative',
                                                                  width: '100%',
                                                                  paddingTop: '100%',
                                                                  overflow: 'hidden',
                                                                }}
                                                              >
                                                                {(() => {
                                                                  const url = file.url || file.name;
                                                                  const preview = file.preview || url;
                                                                  const fileExt = (file.extension || url.split('.').pop().split('?')[0]).toLowerCase();
                                                                  const isOffice = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'].includes(fileExt);
                                                                  const isDesign = ['ai', 'psd', 'eps', 'dwg', 'dxf'].includes(fileExt);
                                                                  const isPdf = file.file_type === 'application/pdf' || fileExt === 'pdf';

                                                                  return isPdf || isOffice || isDesign ? (
                                                                    <IconButton
                                                                      onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        setPdfLoading(true);
                                                                        setSelectedPDF(url);
                                                                        setOpenPDFModal(true);
                                                                        setUseOfficeViewer(true);
                                                                      }}
                                                                      aria-label="open file"
                                                                      sx={{
                                                                        position: 'absolute',
                                                                        top: 0,
                                                                        left: 0,
                                                                        width: '100%',
                                                                        height: '100%',
                                                                        p: 0,
                                                                        borderRadius: 0,
                                                                      }}
                                                                    >
                                                                      <Box
                                                                        component="iframe"
                                                                        src={isPdf ? url : isOffice ? `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(url)}` : `https://docs.google.com/gview?url=${encodeURIComponent(url)}&embedded=true`}
                                                                        title="File Preview"
                                                                        frameBorder="0"
                                                                        // sandbox="allow-scripts allow-same-origin" before it was this caused pdf preview not working and fixed with below code, if any future issues came i have done only the pdf part that will only in me others i will be author
                                                                        sandbox={isPdf ? undefined : 'allow-scripts allow-same-origin'}
                                                                        sx={{
                                                                          position: 'absolute',
                                                                          top: 0,
                                                                          left: 0,
                                                                          width: '100%',
                                                                          height: '100%',
                                                                          objectFit: 'cover',
                                                                          pointerEvents: 'none',
                                                                        }}
                                                                      />
                                                                    </IconButton>
                                                                  ) : (
                                                                    <Box
                                                                      component="img"
                                                                      src={preview}
                                                                      alt={file.name || 'Uploaded file'}
                                                                      sx={{
                                                                        position: 'absolute',
                                                                        top: 0,
                                                                        left: 0,
                                                                        width: '100%',
                                                                        height: '100%',
                                                                        objectFit: 'cover',
                                                                      }}
                                                                      onError={(e) => {
                                                                        if (preview !== url) {
                                                                          e.target.src = url;
                                                                        }
                                                                      }}
                                                                    />
                                                                  );
                                                                })()}
                                                                <AttachmentDownloadIconButton
                                                                  file={file}
                                                                  fileIndex={idx}
                                                                  hidden={isClient || userType === 3}
                                                                  sx={{
                                                                    position: 'absolute',
                                                                    top: 4,
                                                                    left: 4,
                                                                    zIndex: 2,
                                                                  }}
                                                                />
                                                                <Checkbox
                                                                  checked={isSelected}
                                                                  sx={{
                                                                    position: 'absolute',
                                                                    top: 4,
                                                                    right: 4,
                                                                    zIndex: 3,
                                                                    bgcolor: 'rgba(255, 255, 255, 0.8)',
                                                                  }}
                                                                  onChange={(e) => {
                                                                    e.stopPropagation();
                                                                    handleImageSelectService(file, svcKey, e.target.checked);
                                                                  }}
                                                                />
                                                                {isAlreadyAddedToCurrent && isSelected && (
                                                                  <Chip
                                                                    label="Added"
                                                                    size="small"
                                                                    color="success"
                                                                    sx={{
                                                                      position: 'absolute',
                                                                      bottom: 4,
                                                                      left: 4,
                                                                    }}
                                                                  />
                                                                )}
                                                              </Box>
                                                            </Card>
                                                          </Grid>
                                                        );
                                                      })}
                                                    </Grid>
                                                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                                                      <AttachmentDownloadAllButton
                                                        files={rowSelectionService}
                                                        allFiles={availableImages}
                                                        onToggleSelectAll={(checked) => {
                                                          const key = String(svcKey)
                                                          setSelectedUploadedImagesService((prev) => ({
                                                            ...prev,
                                                            [key]: checked ? [...availableImages] : [],
                                                            [svcKey]: checked ? [...availableImages] : [],
                                                          }))
                                                        }}
                                                        label="Download Selected"
                                                        hidden={isClient || userType === 3}
                                                      />
                                                      <Button
                                                        variant="contained"
                                                        onClick={() => handleAddSelectedImagesService(svcKey)}
                                                        disabled={!hasServiceChanges}
                                                      >
                                                        Save Selection ({rowSelectionService.length})
                                                      </Button>
                                                    </Box>
                                                  </>
                                                );
                                              })()}
                                            </Box>
                                          ) : (
                                            <UploadMultiFile
                                              showPreview
                                              multiple={true}
                                              maxSize={1024 * 1024 * 1024}
                                              // accept="image/*,application/pdf"
                                              files={serviceAttachments[svcKey] || []}
                                              onDrop={(acceptedFiles) => handleServiceDrop(acceptedFiles, svcKey)}
                                              onRemove={(file) => handleServiceRemove(file, svcKey)}
                                              onRemoveAll={() => handleServiceRemove(null, svcKey)}
                                              isUploading={isUploadingService[svcKey] || false}
                                            />
                                          )}
                                        </Grid>
                                      </Grid>
                                    </Modal>
                                  );
                                })}

                                {/* Service Note Modal for cartService */}
                                {cartService?.map((data, index) => (
                                  <Modal
                                    key={`cart-service-note-${data.id}`}
                                    open={openServiceNote[data.id] || false}
                                    handleClose={() => handleCloseServiceNote(data.id)}
                                  >
                                    <Grid
                                      container
                                      spacing={3}
                                      sx={{ justifyContent: 'center', width: '100%' }}
                                    >
                                      <Grid item xs={12}>
                                        <Typography variant="h5" sx={{ mb: 2, }}>
                                          Service Note
                                        </Typography>

                                        <Stack
                                          direction={{ xs: 'column', sm: 'row' }}
                                          spacing={{ xs: 3, sm: 2 }}
                                          sx={{ mb: 2 }}
                                        >
                                          <TextField
                                            fullWidth
                                            multiline
                                            rows={4}
                                            size="medium"
                                            value={currentNote}
                                            onChange={handleServiceNoteChange}
                                            error={!currentNote.trim() && currentNote.length > 0}
                                            inputProps={{ maxLength: MAX_CHARACTERS }}
                                            helperText={
                                              !currentNote.trim() && currentNote.length > 0
                                                ? 'Note cannot be empty or contain only spaces'
                                                : `${currentNote.length}/${MAX_CHARACTERS} characters`
                                            }
                                            InputProps={{
                                              sx: {
                                                color: 'error.main',
                                              }
                                            }}
                                          />
                                        </Stack>
                                      </Grid>
                                    </Grid>

                                    <Grid container justifyContent="center" alignItems="center">
                                      <Grid item xs={12} md={4}>
                                        <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 1 }}>
                                          <LoadingButton
                                            variant="contained"
                                            onClick={() => handleSaveServiceNote(data.newIndexId ?? data.indexId)}
                                            loading={isSavingNote}
                                            disabled={!currentNote.trim()}>
                                            Save
                                          </LoadingButton>
                                          <LoadingButton
                                            variant="outlined"
                                            color="error"
                                            onClick={() => handleClearServiceNote(data.newIndexId ?? data.indexId)}
                                            loading={isClearingNote}
                                            disabled={!currentNote.trim()}>
                                            Clear
                                          </LoadingButton>
                                        </Box>
                                      </Grid>
                                    </Grid>
                                  </Modal>
                                ))}
                            </TableBody>
                                )}
                              </Droppable>
                            </DragDropContext>
                          </Table>
                        </TableContainer>
                        {(selectedProducts || [])
                          .filter((p) => p?.group_id)
                          .map((row) => {
                            const live =
                              selectedProducts.find((p) => p.indexId === row.indexId) || row
                            const productIndex = selectedProducts.findIndex(
                              (p) => p.indexId === row.indexId,
                            )
                            if (productIndex < 0) return null
                            return (
                              <ViewQuotationGroupedProductLocationModal
                                key={`grouped-product-loc-${row.indexId}`}
                                data={live}
                                productIndex={productIndex}
                                open={Boolean(locationStates[row.indexId])}
                                onClose={() => {
                                  setLocationStates((prev) => {
                                    const base = prev && typeof prev === 'object' ? { ...prev } : {}
                                    base[row.indexId] = false
                                    return base
                                  })
                                }}
                                values={values}
                                setSelectedProducts={setSelectedProducts}
                                handleAllLocationSameChange={handleAllLocationSameChange}
                                setIsSaving={setIsSaving}
                                isSaving={isSaving}
                                LabelStyle={LabelStyle}
                              />
                            )
                          })}
                      </Scrollbar>
                      {openEdit && (
                        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-start' }}>
                          <Button
                            variant="outlined"
                            startIcon={<Icon icon={plusFill} />}
                            onClick={addNewProductRow}
                            sx={{ marginLeft: '20px' }}
                          >
                            Add Row
                          </Button>
                        </Box>
                      )}
                      <Dialog
                        open={catalogPickerOpen}
                        onClose={() => {
                          setCatalogPickerOpen(false)
                          setCatalogPickerRowIndexId(null)
                          setCatalogPickerDraft(null)
                        }}
                        maxWidth="md"
                        fullWidth
                        disableScrollLock
                      >
                        <DialogTitle>
                          {selectedProducts.find((r) => r.indexId === catalogPickerRowIndexId)?.id
                            ? 'Change Catalog Product'
                            : 'Select Catalog Product'}
                        </DialogTitle>
                        <DialogContent>
                          <Stack spacing={2} sx={{ mt: 1 }}>
                            <Autocomplete
                              options={filteredProductOptions}
                              value={catalogPickerDraft}
                              onChange={(event, newValue) => setCatalogPickerDraft(newValue)}
                              isOptionEqualToValue={(option, value) => option?.id === value?.id}
                              renderInput={(params) => (
                                <TextField {...params} required label="Select a product" />
                              )}
                              renderOption={(props, option) => {
                                const { style, ...liProps } = props
                                const suffix = getCatalogProductSuffix(option)
                                return (
                                  <li {...liProps} style={{ ...style, display: 'flex', alignItems: 'center' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', width: 40, justifyContent: 'center' }}>
                                      {option?.syncWithQuickbooks === 1 && (
                                        <img src={quickbookLogo} width="40px" height="20px" alt="QuickBooks" />
                                      )}
                                    </div>
                                    <Tooltip title={`${option.description || ''} ${suffix}`}>
                                      <span style={{ flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                        {`${option?.name || ''} ${suffix}`}
                                      </span>
                                    </Tooltip>
                                  </li>
                                )
                              }}
                              getOptionLabel={(option) => option?.name || ''}
                            />
                            {(() => {
                              const categoryId = values?.project_category?.id
                              const isBuildOrder = categoryId === 15
                              if (isBuildOrder) return null
                              const filteredCatalogTypes = splitOrderCatalogTypes
                                .filter((type) => type.id !== 'split_catalog')
                                .concat([{ id: 'sub_contract', label: 'Sub Contract', inhouse: 0, isTrafficCatalog: false }])
                                .sort((a, b) => {
                                  if (a.id === 'all') return -1
                                  if (b.id === 'all') return 1
                                  return a.label.localeCompare(b.label)
                                })
                              return (
                                <Autocomplete
                                  options={filteredCatalogTypes}
                                  value={values.split_catalog_type || splitOrderCatalogTypes.find((type) => type.id === 'all')}
                                  onChange={(event, newValue) => {
                                    setFieldValue('split_catalog_type', newValue || splitOrderCatalogTypes.find((type) => type.id === 'all'))
                                  }}
                                  renderInput={(params) => (
                                    <TextField {...params} label="Catalog Type" placeholder="Select catalog type" />
                                  )}
                                  getOptionLabel={(option) => option.label}
                                />
                              )
                            })()}
                          </Stack>
                        </DialogContent>
                        <DialogActions>
                          <Button
                            onClick={() => {
                              setCatalogPickerOpen(false)
                              setCatalogPickerRowIndexId(null)
                              setCatalogPickerDraft(null)
                            }}
                          >
                            Cancel
                          </Button>
                          <Button variant="contained" onClick={confirmCatalogPicker}>
                            Confirm
                          </Button>
                        </DialogActions>
                      </Dialog>
                      </>
                      )}
                      {/* <Stack sx={{ justifyContent: 'space-between', alignItems: 'center', display:'flex', flexDirection:'row' }}>
                        <Button
                          variant="outlined"
                          startIcon={
                            <Stack>
                              {' '}
                              <Add />{' '}
                            </Stack>
                          }
                          onClick={() => {
                            addNewProductRow()
                            // setMarkupType(1)
                          }}
                        >
                          Add Product Row
                        </Button>
                        <Typography variant="h6">
                          Total Additional Product Cost:{' '}
                          {selectedProductsAdditionalCost}
                        </Typography>
                      </Stack> */}

                      {/* {(details?.is_request_estimate == 1 && (!details?.estimate_job_status || details?.estimate_job_status == 3)) ? (
                        <>{(productRows?.length > 0) ?
                          <>
                          <LabelStyle>Additional Products</LabelStyle>
                          <TableContainer component={Paper} sx={{ mt: 2 }}>
                            <Table>
                              <TableHead>
                                <TableRow>
                                  <TableCell padding="checkbox" sx={{ width: 40 }} />
                                  <TableCell align="center">Sl No</TableCell>
                                  <TableCell align="center">Product Name</TableCell>
                                  <TableCell align="center">Product Description</TableCell>
                                  <TableCell align="center"></TableCell>
                                </TableRow>
                              </TableHead>
                              <DragDropContext onDragEnd={(result) => handleProductRowsDragEnd(result, true)}>
                                <Droppable droppableId="view-quotation-estimate-additional-product-rows">
                                  {(droppableProvided) => (
                              <TableBody
                                ref={droppableProvided.innerRef}
                                {...droppableProvided.droppableProps}
                              >
                                {productRows?.map((row, index) => (
                                  <Draggable
                                    key={`additional-product-row-${row.indexId}`}
                                    draggableId={`additional-product-row-${row.indexId}`}
                                    index={index}
                                  >
                                    {(provided, snapshot) => (
                                  <TableRow
                                    key={row.indexId}
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    style={{
                                      ...provided.draggableProps.style,
                                      ...(snapshot.isDragging
                                        ? { backgroundColor: theme.palette.action.hover }
                                        : {}),
                                    }}
                                  >
                                    <TableCell
                                      padding="checkbox"
                                      {...provided.dragHandleProps}
                                      sx={{ width: 40, cursor: 'grab' }}
                                    >
                                      <DragIndicator fontSize="small" color="action" />
                                    </TableCell>
                                    <TableCell align="center">#{row.indexId}</TableCell>
                                    <TableCell align="center">
                                      <TextField
                                        fullWidth
                                        variant="outlined"
                                        value={row.product_name}
                                        onFocus={() => handleFieldFocus(row.indexId, 'name', row.product_name)}
                                        onChange={(e) => {
                                          handleRequestEstimateProductNameChange(row.indexId, e.target.value);
                                          const updatedRow = { ...row, product_name: e.target.value };
                                          // triggerDebouncedAutoSave(updatedRow, 'name');
                                        }}
                                        // onBlur={() => handleProductRowAutoSave(row, 'name')}
                                        onBlur={() => commitProductNameDraft(row.indexId)}
                                        placeholder="Product Name"
                                        error={Boolean(rowErrors[row.indexId])}
                                        helperText={rowErrors[row.indexId]}
                                        InputProps={{
                                          endAdornment: autoSavingField?.indexId === row.indexId && autoSavingField?.field === 'name' ? (
                                            <InputAdornment position="end">
                                              <CircularProgress size={20} />
                                            </InputAdornment>
                                          ) : null
                                        }}
                                      />
                                    </TableCell>
                                    <TableCell align="center">
                                      <TextField
                                        fullWidth
                                        variant="outlined"
                                        value={row.product_desc}
                                        onFocus={() => handleFieldFocus(row.indexId, 'desc', row.product_desc)}
                                        onChange={(e) => {
                                          handleRequestEstimateProductDescChange(row.indexId, e.target.value);
                                          const updatedRow = { ...row, product_desc: e.target.value };
                                          // triggerDebouncedAutoSave(updatedRow, 'desc');
                                        }}
                                        // onBlur={() => handleProductRowAutoSave(row, 'desc')}
                                        placeholder="Product Description"
                                        multiline
                                        minRows={1}
                                        maxRows={3}
                                        InputProps={{
                                          endAdornment: autoSavingField?.indexId === row.indexId && autoSavingField?.field === 'desc' ? (
                                            <InputAdornment position="end">
                                              <CircularProgress size={20} />
                                            </InputAdornment>
                                          ) : null
                                        }}
                                      />
                                    </TableCell>
                                    <TableCell align="center">
                                        {/* {productRows.length > 1 && ( */}
                                          {/* <IconButton 
                                            onClick={() => handleDeleteRequestEstimateProduct(row.indexId, row.backendId,true)}
                                            color="error"
                                          >
                                            <Delete />
                                          </IconButton> */}
                                        {/* )} */}
                                    {/* </TableCell> */}
                                  {/* </TableRow> */}
                                    {/* )} */}
                                  {/* </Draggable>
                                ))}
                                {droppableProvided.placeholder}
                              </TableBody>
                                  )}
                                </Droppable>
                              </DragDropContext>
                            </Table>
                          </TableContainer>
                          </> : ''}
                          <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-start'}}>
                            <Button
                              variant="outlined"
                              startIcon={<Icon icon={plusFill} />}
                              onClick={addNewRequestEstimateProductRow}
                              sx={{
                                marginLeft: '20px'
                              }}
                            >
                              Add Row */}
                            {/* </Button>
                          </Box>
                        </>
                      ) : ''} */} 
                      <Divider />
                      <Stack direction='row'>
                        <LabelStyleHead>Services</LabelStyleHead>
                        {showServices ? <Remove sx={{color:theme.palette.primary.main}} onClick={(e)=>{setShowServices(false)}} /> : <Add sx={{color:theme.palette.primary.main}} onClick={(e)=>{setShowServices(true)}} />}
                      </Stack>
                      {showServices && <>
                        {/* {showEstimateCatalogServicePickers ? (
                      hasMeaningfulEstimateWriteRows && userType !== 3 && !isClient ? ( */}
                      {hasMeaningfulEstimateWriteRows && userType !== 3 && !isClient ? (
                      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }} sx={{ mb: 2 }}>
                        <Autocomplete
                          fullWidth
                          multiple
                          id="estimate-service-autocomplete"
                          options={filteredEstimateServiceOptions}
                          value={estimateCatalogServices}
                          isOptionEqualToValue={(option, value) => option?.id === value?.id}
                          onChange={(event, newValue) => {
                            const { mapped, nextId } =
                              applyEstimateCatalogServiceSelection(newValue)
                            setServiceIndexCounter((c) => Math.max(c, nextId))
                            setEstimateCatalogServices(mapped)
                            if ((newValue || []).length > 0) {
                              setSelectedEstimators(allEstimators || [])
                            } else {
                              setSelectedEstimators([])
                              estimateServiceAutofillDoneRef.current = true
                            }
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              required={hasMeaningfulEstimateWriteRows}
                              error={Boolean(touched.services && errors.services)}
                              helperText={touched.services && errors.services}
                              label="Select services"
                            />
                          )}
                          getOptionLabel={(option) =>
                            option?.name
                              ? `${option.name} (${getLabourCostServiceTabLabel(option.inhouse)})`
                              : ''
                          }
                        />
                        <Autocomplete
                          fullWidth
                          multiple
                          id="estimate-estimator-autocomplete"
                          options={[...(allEstimators || [])].sort((a, b) =>
                            alphanumericCompare(a?.name || '', b?.name || ''),
                          )}
                          value={selectedEstimators}
                          onChange={(event, newValue) => {
                            setSelectedEstimators(newValue || [])
                          }}
                          isOptionEqualToValue={(option, value) => option.id === value.id}
                          getOptionLabel={(option) => option.name || ''}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              required={hasMeaningfulEstimateWriteRows}
                              label="Choose Estimator"
                              error={Boolean(touched.services && errors.services)}
                              helperText={touched.services && errors.services}
                            />
                          )}
                        />
                      </Stack>
                      ) : null}
                      {/* BACKUP: nested under showEstimateCatalogServicePickers — write-service-only rows did not show pickers on edit */}
                      {/* {showEstimateCatalogServicePickers && hasMeaningfulEstimateWriteRows ? (
                      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                        <Autocomplete
                          // sx={{ width: 400 }}
                          fullWidth
                          multiple
                          id="combo-box-demo"
                          options={
                            filteredServices?.filter(item => 
                              item.service_type == 44 &&
                              item.status === 1 && 
                              Number(item.inhouse) !== 1 &&
                              !additionalSelectedServices.some(selectedService => 
                                Number(selectedService?.service_type) === 44 &&
                                !selectedService?.isAdditionalProduct &&
                                (
                                  selectedService?.id === item?.id ||
                                  selectedService?.labour_cost_service_id === item?.id
                                )
                              )
                            ) || []
                          }
                          value={additionalSelectedServices?.filter(
                            (item) =>
                              !item.isAdditionalProduct &&
                              Number(item?.service_type) === 44,
                          )}
                          // value={values.services}
                          onChange={(event, newValue) => {
                            const newIndexCounter = indexCounterService + 1;
                            setIndexCounterService(newIndexCounter);
                            setAdditionalSelectedServices((prevServices) => {
                              const additionals = prevServices?.filter(item => item.isAdditionalProduct === true || item.isAdditionalProduct === 1);
                              const nonEstimateCatalogServices = prevServices?.filter(
                                (item) =>
                                  !item?.isAdditionalProduct &&
                                  Number(item?.service_type) !== 44,
                              ) || [];
                              
                              // Map over the newly selected services and preserve existing properties
                              const updatedServices = newValue?.map((service) => {
                                // Check if the service already exists in the previous selected services
                                const existingService = prevServices.find(
                                  (p) => p?.id === service?.id && p?.newIndexId === service?.newIndexId
                                );

                                if (existingService) {
                                  // If service already exists, preserve all existing properties including notes
                                  return {
                                    ...existingService,
                                    quantity: existingService.quantity ?? 1
                                  };
                                } else {
                                  const nextLineId = serviceIndexCounter + newValue.indexOf(service) + 1;
                                  // If it's a new service, create it with default values
                                  return {
                                    ...service,
                                    newIndexId: nextLineId,
                                    indexId: nextLineId,
                                    product_index: nextLineId,
                                    productIndex: nextLineId,
                                    quantity: 1,
                                    entryMode: 'choose',
                                    note: '' // Initialize note as empty string
                                  };
                                }
                              }) || [];

                              // Update the service index counter for new services
                              if (updatedServices.length > 0) {
                                const maxIndexId = Math.max(
                                  ...updatedServices.map(s => s.newIndexId || 0),
                                  serviceIndexCounter
                                );
                                setServiceIndexCounter(maxIndexId);
                              }

                              // Update Formik's 'services' field
                              setFieldValue('services', updatedServices);
                              const finalServices = [
                                ...updatedServices,
                                ...nonEstimateCatalogServices,
                                ...additionals,
                              ];
                              return finalServices;
                            });
                            if(newValue.length > 0){
                              setSelectedEstimators(allEstimators || [])
                            }else{
                              setSelectedEstimators([])
                            }
                            // markUnsavedChanges();();
                          }}
                          renderInput={(params) => (
                            <TextField {...params} required 
                            error={Boolean(touched.services && errors.services)}
                            helperText={touched.services && errors.services} 
                            label={details?.is_request_estimate == 1 ? "Select services" : "Select additional services"} />
                          )}
                          getOptionLabel={(option) =>
                            option?.name || option?.service_name
                              ? `${option.name || option.service_name} (${getLabourCostServiceTabLabel(option.inhouse)})`
                              : ''
                          }
                          renderOption={(props, option) => {
                            const { style, ...liProps } = props;
                            const suffix = getLabourCostServiceTabLabel(option.inhouse);
                            const label = `${option.name} (${suffix})`;

                          return (
                            <li
                              {...liProps}
                            style={{
                                  ...style,
                                  display: 'flex',
                                  alignItems: 'center',
                                }}
                              >
                                 <div style={{ display: 'flex', alignItems: 'center', width: 40, justifyContent: 'center' }}>
                                    {option?.syncWithQuickbooks === 1 && (
                                      <img
                                        src={quickbookLogo}
                                        width="40px"
                                        height="20px"
                                        // style={{ marginRight: 8 }}
                                        alt="QuickBooks"
                                      />
                                    )}
                                  </div>
                                <Tooltip title={label}>
                                  <span
                                    style={{
                                      flex: 1,
                                      minWidth: 0,
                                      display: 'block',
                                      whiteSpace: 'nowrap',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                    }}
                                  >
                                    {label}
                                  </span>
                                </Tooltip>
                              </li>
                            );
                          }}
                          filterOptions={(options, state) => {
                            const searchText = state.inputValue.toLowerCase();
                            return options.filter(
                              (option) =>
                                option.name.toLowerCase().includes(searchText) ||
                                (option.description && option.description.toLowerCase().includes(searchText)) // Include description in search
                            );
                          }}
                        />
                        <Autocomplete
                          // sx={{ width: 400 }} 
                          fullWidth
                          multiple
                          id="combo-box-demo"
                          options={allEstimators || []}
                          value={selectedEstimators}
                          onChange={(event, newValue) => {
                            setSelectedEstimators(newValue);
                            // Changing estimator is part of the edit.
                            // markUnsavedChanges();();
                          }}
                          isOptionEqualToValue={(option, value) => option.id === value.id}
                          getOptionLabel={(option) => option.name || ''}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              required
                              label="Choose Estimator"
                              error={Boolean(touched.services && errors.services)}
                              helperText={touched.services && errors.services}
                            />
                          )}
                        />
                      </Stack>
                        // )) : showLegacyBulkServicesAutocomplete ? (
                        //   <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                        //    <Autocomplete
                        //      sx={{ width: 400 }}
                        //      multiple
                        //      id="combo-box-demo"
                        //      options={
                        //        ((productRows?.length > 0 || serviceRows?.length > 0) ? 
                        //          (
                        //            filteredServices?.filter(item => 
                        //              item.status === 1 &&
                        //              Number(item.inhouse) !== 1
                        //              // && 
                        //              // !additionalSelectedServices.some(selectedService => 
                        //              //   selectedService?.id === item?.id || selectedService?.labour_cost_service_id === item?.id
                        //              // )
                        //            )
                        //          ) : (
                        //            filteredServices?.filter(item => 
                        //              item.service_type != 44 &&
                        //              item.status === 1 &&
                        //              Number(item.inhouse) !== 1
                        //              // && 
                        //              // !additionalSelectedServices.some(selectedService => 
                        //              //   selectedService?.id === item?.id || selectedService?.labour_cost_service_id === item?.id
                        //              // )
                        //            )
                        //          )
                        //        ) || []
                        //      }
                        //      // value={additionalSelectedServices?.filter(item=>!item.isAdditionalProduct)}
                        //      value={
                        //        (productRows?.length > 0 || serviceRows?.length > 0)
                        //          ? additionalSelectedServices?.filter(item => !item.isAdditionalProduct)
                        //          : additionalSelectedServices?.filter(item => !item.isAdditionalProduct && item.service_type !== 44)
                        //      }
                        //      // value={values.services}
                        //      onChange={(event, newValue) => {
                        //        const newIndexCounter = indexCounterService + 1;
                        //        setIndexCounterService(newIndexCounter);
                        //        setAdditionalSelectedServices((prevServices) => {
                        //          // Keep the services with service_type 44, which are not shown in the input field but should be included in the final array
                        //          // const servicesWith44 = [] || prevServices?.filter(item => item.service_type === 44);
                        //          const servicesWith44 = [] || prevServices?.filter(item => item.service_type === 44);
                        //          const additionals = prevServices?.filter(item => item.isAdditionalProduct === true || item.isAdditionalProduct === 1);
                                 
                        //          // Map over the newly selected services and preserve existing properties
                        //          const updatedServices = newValue?.map((service) => {
                        //            // Check if the service already exists in the previous selected services
                        //            const existingService = prevServices.find(
                        //              (p) => p?.id === service?.id && p?.newIndexId === service?.newIndexId
                        //            );
   
                        //            if (existingService) {
                        //              // If service already exists, preserve all existing properties including notes
                        //              return {
                        //                ...existingService,
                        //                quantity: existingService.quantity ?? 1
                        //              };
                        //            } else {
                        //              // If it's a new service, create it with default values
                        //              return {
                        //                ...service,
                        //                newIndexId: serviceIndexCounter + newValue.indexOf(service) + 1,
                        //                indexId: indexCounterService + 1,
                        //                quantity: 1,
                        //                note: '' // Initialize note as empty string
                        //              };
                        //            }
                        //          }) || [];
   
                        //          // Update the service index counter for new services
                        //          if (updatedServices.length > 0) {
                        //            const maxIndexId = Math.max(
                        //              ...updatedServices.map(s => s.newIndexId || 0),
                        //              serviceIndexCounter
                        //            );
                        //            setServiceIndexCounter(maxIndexId);
                        //          }
                        //          // Update Formik's 'services' field
                        //          setFieldValue('services', updatedServices);
                        //          const finalServices = [...updatedServices, ...additionals, ...servicesWith44];
                        //          return finalServices;
                        //        });
                        //        if(serviceRows?.length > 0){
                        //          // Reassign the indexId (Sl No) to the remaining rows
                        //          const renumberedRows = serviceRows?.map((row, idx) => ({
                        //            ...row,
                        //            indexId: newIndexCounter + idx + 1,  // Recalculate Sl No based on row order
                        //          }));
                             
                        //          // Update counter after state update
                        //          setTimeout(() => setServiceRowsIndexCounter(renumberedRows.length), 0);
                        //          setServiceRows(renumberedRows);
                        //        }
                        //        // markUnsavedChanges();();
                        //      }}
                        //      renderInput={(params) => (
                        //        <TextField {...params} required 
                        //        error={Boolean(touched.services && errors.services)}
                        //        helperText={touched.services && errors.services} 
                        //        label={details?.is_request_estimate == 1 ? "Select services" : "Select additional services"} />
                        //      )}
                        //      getOptionLabel={(option) =>
                        //        option?.name
                        //          ? `${option.name || option.service_name} (${getLabourCostServiceTabLabel(option.inhouse)})`
                        //          : ''
                        //      }
                        //      renderOption={(props, option) => {
                        //        const { style, ...liProps } = props;
                        //        const suffix = getLabourCostServiceTabLabel(option.inhouse);
                        //        const label = `${option.name} (${suffix})`;
   
                        //      return (
                        //        <li
                        //          {...liProps}
                        //        style={{
                        //              ...style,
                        //              display: 'flex',
                        //              alignItems: 'center',
                        //            }}
                        //          >
                        //             <div style={{ display: 'flex', alignItems: 'center', width: 40, justifyContent: 'center' }}>
                        //                {option?.syncWithQuickbooks === 1 && (
                        //                  <img
                        //                    src={quickbookLogo}
                        //                    width="40px"
                        //                    height="20px"
                        //                    // style={{ marginRight: 8 }}
                        //                    alt="QuickBooks"
                        //                  />
                        //                )}
                        //              </div>
                        //            <Tooltip title={label}>
                        //              <span
                        //                style={{
                        //                  flex: 1,
                        //                  minWidth: 0,
                        //                  display: 'block',
                        //                  whiteSpace: 'nowrap',
                        //                  overflow: 'hidden',
                        //                  textOverflow: 'ellipsis',
                        //                }}
                        //              >
                        //                {label}
                        //              </span>
                        //            </Tooltip>
                        //          </li>
                        //        );
                        //      }}
                        //      filterOptions={(options, state) => {
                        //        const searchText = state.inputValue.toLowerCase();
                        //        return options.filter(
                        //          (option) =>
                        //            option.name.toLowerCase().includes(searchText) ||
                        //            (option.description && option.description.toLowerCase().includes(searchText)) // Include description in search
                        //        );
                        //      }}
                        //    />
                        //    {(details?.is_request_estimate == 1 && (productRows?.length > 0 || serviceRows?.length > 0)) ? 
                        //      <Autocomplete
                        //        sx={{ width: 400 }}
                        //        // fullWidth
                        //        multiple
                        //        id="combo-box-demo"
                        //        options={allEstimators || []}
                        //        value={selectedEstimators}
                        //        disabled={true}
                        //        onChange={(event, newValue) => {
                        //          setSelectedEstimators(newValue);
                        //        }}
                        //        isOptionEqualToValue={(option, value) => option.id === value.id}
                        //        getOptionLabel={(option) => option.name || ''}
                        //        renderInput={(params) => (
                        //          <TextField
                        //            {...params}
                        //            required
                        //            label="Choose Estimator"
                        //            error={Boolean(touched.services && errors.services)}
                        //            helperText={touched.services && errors.services}
                        //          />
                        //        )}
                        //      /> : ''}
                        //  </Stack>
                        //  ) : null}
                      ) : null} */}
                      {/* LEGACY showLegacyBulkServicesAutocomplete: "Select additional services" bulk dropdown — not shown.
                          Not request estimate + no write rows: no service picker above the table (nothing needed). */}
                        <LabelStyle>Selected services</LabelStyle>
                        <Scrollbar>
                          <TableContainer sx={{ minWidth: 500 }}>
                            <Table>
                              <TableHead>
                                <TableRow>
                                  {openEdit && (
                                    <TableCell padding="checkbox" sx={{ width: 40 }} />
                                  )}
                                  {VALUE_SERVICES?.map((val,index) => (
                                    <TableCell key={val.id} sx={getViewQuotationServiceTableColSx(val.id)}>{val.value}</TableCell>
                                  ))}
                                </TableRow>
                              </TableHead>
                            
                              <DragDropContext onDragEnd={handleServiceTableDragEnd}>
                                <Droppable droppableId="view-quotation-service-rows" isDropDisabled={!openEdit}>
                                  {(droppableProvided) => (
                              <TableBody
                                ref={droppableProvided.innerRef}
                                {...droppableProvided.droppableProps}
                              >
                                {console.log('selectedServices1----',selectedServices)}
                                {/* {selectedServices?.map((data, index) => {
                                  const quantityFieldName = `service_quantity_${index}`;
                                  const dataCost = getServiceHourlyCost(data)
                                  const total = dataCost * data.quantity
                                  totalAmount += total
                                  data['totalAmount'] = totalAmount?.toFixed(2)
                                  const markup = dataCost / total
                                  data['markup'] = markup?.toFixed(2)
                                  totalServiceMarkup += markup
                                  data['total'] = total?.toFixed(2)
                                  data['totalServiceMarkup'] = totalServiceMarkup?.toFixed(2)
                                  let originalMarkup=data.originalMarkup||0
                                  originaltotalServiceMarkup+=originalMarkup
                                  // values['totalServiceMarkup'] = totalServiceMarkup?.toFixed(2)
                                  console.log("############WWWWW",originalMarkup);

                                  let qtyData = data.qtyData || 1
                                  console.log("############qtyData", qtyData);
                                  const previousQty = data.prQty*qtyData * (data.locationQuantity||1);
                                  const newQty = (data.prQty * qtyData * (data.locationQuantity || 1))?.toFixed(2)
                                  console.log("############newQty", newQty);
                                  const quantityDifference = Number(data.quantity) - newQty;
                                  data['quantityDifference'] = quantityDifference
                                  return (
                                    <>
                                      <TableRow key={index}>
                                      <TableCell>#{data?.productIndex}</TableCell>
                                      <TableCell>{data.name}</TableCell>
                                      <TableCell>{originalMarkup?.toFixed(2)}</TableCell>
                                      <TableCell>{data.cost}</TableCell>
                                      <TableCell>{dataCost}</TableCell>
                                      <TableCell>
                                      <TextField
                                        type="number"
                                        // sx={{ width: 400 }}
                                        sx={{ minWidth: '80px' }}
                                        label={'Hours'}
                                        disabled={data?.fromMapServices ? true : false}
                                        // {...getFieldProps(quantityFieldName)}
                                        value={Number(data.quantity)}
                                        defaultValue={data.quantity ? Number(data.quantity) : 1}
                                        onChange={(event) => {
                                          let newValue = event.target.value;
                                          const newData = { ...data, quantity: newValue || 1 };
                                          if (newValue.startsWith('-')) {
                                            newValue = newValue.slice(1);
                                          }
                                          if (newValue < previousQty) {
                                            setShowWarning(prev => {
                                              const newWarnings = [...prev];
                                              newWarnings[index] = true;
                                              return newWarnings;
                                            });
                                            console.log('data?.prQty---', data?.prQty);
                                            data['quantity'] = previousQty;
                                            setFieldValue(quantityFieldName, previousQty);
                                          } else {
                                            setShowWarning(prev => {
                                              const newWarnings = [...prev];
                                              newWarnings[index] = false;
                                              return newWarnings;
                                            });
                                            data['quantity'] = newValue || 1;
                                            setFieldValue(quantityFieldName, newValue);
                                          }
                                          
                                          const updatedServices = [...selectedServices];
                                        updatedServices[index] = newData;
                                        updatedServices[index] = newData;
                                       
                                          updatedServices[index] = newData;
                                       
                                          setSelectedServices(updatedServices);
                                        }}
                                        inputProps={{ min: data.prQty }}
                                        error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                        helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                      />
                                      {showWarning[index] && (
                                        <Typography color="error" variant='body2'>
                                          Cannot reduce the added hours in the product formula. If you need to reduce, change it in the product formula.
                                        </Typography>
                                      )}
                                      </TableCell>
                                      <TableCell>N/A</TableCell>
                                      <TableCell>N/A</TableCell>
                                      <TableCell>{(data.cost*quantityDifference?.toFixed(2))?.toFixed(2)}</TableCell>
                                      <TableCell>{(data.unit_cost * quantityDifference?.toFixed(2))?.toFixed(2)}</TableCell>
                                      <TableCell>{total?.toFixed(2)}</TableCell>
                                      <TableCell></TableCell>
                                      <TableCell align='right'>
                                        <IconButton onClick={() => handleDeleteService(data.id)}>
                                          <Delete />
                                        </IconButton>
                                      </TableCell>
                                    </TableRow>
                                    </>
                                  );
                                })} */}
                                {[...(additionalSelectedServices || [])]
                                  .sort(
                                    (a, b) =>
                                      (Number(a?.newIndexId ?? a?.indexId ?? a?.product_index) || 0) -
                                      (Number(b?.newIndexId ?? b?.indexId ?? b?.product_index) || 0),
                                  )
                                  .map((data, index) => {
                                  const quantityFieldName = `service_quantity_${index}`;
                                  const dataQuantity = data?.quantity ? data?.quantity : 0;
                                  const dataCost = getServiceHourlyCost(data)
                                  const total = dataCost * dataQuantity
                                  const markup = dataCost / Number(total)
                                  data['markup'] = markup ? markup?.toFixed(2) : 0.00
                                  data['quantity'] = dataQuantity
                                  totalServiceMarkup += markup
                                  data['total'] = total ? total?.toFixed(2) : 0.00
                                  data['totalServiceMarkup'] = totalServiceMarkup?.toFixed(2)
                                  let originalMarkup=data.originalMarkup||0
                                    originaltotalServiceMarkup+=originalMarkup
                                  // values['totalServiceMarkup'] = totalServiceMarkup?.toFixed(2)
                                  console.log('total---',total);
                                  console.log('data--serv1---',data);
                                  const quantityDifference = Number(data.quantity)
                                  data['quantityDifference'] = quantityDifference
                                  const serviceAttKey = String(data.newIndexId ?? data.indexId ?? '')
                                  const serviceLineKey = getServiceLineKey(data)
                                  const isWriteServiceRow = isQuotationWriteService(data)
                                  return (
                                    <Draggable
                                      key={`service-${serviceLineKey}-${index}`}
                                      draggableId={`service-${serviceLineKey}-${index}`}
                                      index={index}
                                      isDragDisabled={!openEdit || isEstimateCatalogServiceRow(data)}
                                    >
                                      {(provided, snapshot) => (
                                    <>
                                      <TableRow
                                        key={index}
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        onDragEnterCapture={(e) => handleServiceIconDragOver(e, serviceAttKey)}
                                        onDragOverCapture={(e) => handleServiceIconDragOver(e, serviceAttKey)}
                                        onDragLeave={(e) => handleServiceIconDragLeave(e, serviceAttKey)}
                                        onDropCapture={(e) => handleServiceIconDrop(e, serviceAttKey)}
                                        sx={{
                                          ...(serviceAttachmentDragOver[serviceAttKey] && {
                                            backgroundColor: 'action.hover',
                                            outline: `2px dashed ${theme.palette.primary.main}`,
                                            outlineOffset: -2,
                                          }),
                                        }}
                                        style={{
                                          ...provided.draggableProps.style,
                                          ...(snapshot.isDragging
                                            ? { backgroundColor: theme.palette.action.hover }
                                            : {}),
                                        }}
                                      >
                                      {openEdit && (
                                        <TableCell
                                          padding="checkbox"
                                          {...provided.dragHandleProps}
                                          sx={{ width: 40, cursor: 'grab' }}
                                        >
                                          <DragIndicator fontSize="small" color="action" />
                                        </TableCell>
                                      )}
                                      <TableCell>{index + 1}</TableCell>
                                      <TableCell align="center">
                                        {data?.fromMapServices ? (
                                          '-'
                                        ) : (() => {
                                          const serviceRowIndex =
                                            data.newIndexId ?? data.indexId ?? data.product_index
                                          const toggleLocked = isRequestEstimateLockedServiceToggle(
                                            data,
                                            details?.is_request_estimate,
                                            userType,
                                          )
                                          const toggleMode = getServiceToggleDisplayMode(data)
                                          return openEdit ? (
                                            <ProductLineEntryToggle
                                              mode={toggleMode}
                                              onChange={(mode) =>
                                                handleServiceRowEntryModeChange(serviceRowIndex, mode)
                                              }
                                              lockDisplay={toggleLocked}
                                              disabled={toggleLocked}
                                            />
                                          ) : toggleMode === 'choose' ? (
                                            'Choose'
                                          ) : (
                                            'Write'
                                          )
                                        })()}
                                      </TableCell>
                                      <TableCell>
                                        {isWriteServiceRow ? (
                                          '-'
                                        ) : (
                                        <div
                                          style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            width: 40,
                                            height: 20,
                                          }}
                                        >
                                          {data?.syncWithQuickbooks === 1 && (
                                            <img
                                              src={quickbookLogo}
                                              alt="QuickBooks"
                                              style={{
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'contain',
                                              }}
                                            />
                                          )}
                                        </div>
                                        )}
                                      </TableCell>
                                      <TableCell sx={VIEW_QUOTATION_PRODUCT_TABLE_COL_SX.productName}>
                                        {isQuotationChooseEmptyService(data) ? (
                                          openEdit ? (
                                            <Button
                                              size="small"
                                              variant="outlined"
                                              color="primary"
                                              onClick={() => openServicePickerForRow(data.newIndexId)}
                                            >
                                              Select Service
                                            </Button>
                                          ) : (
                                            '-'
                                          )
                                        ) : isWriteServiceRow ? (
                                          <TextField
                                            required
                                            fullWidth
                                            type="text"
                                            label={'Service Name'}
                                            sx={{ width: '100%' }}
                                            value={serviceNameDraft.getValue(
                                              data.newIndexId,
                                              data.name || data.service_name || '',
                                            )}
                                            disabled={!openEdit || data?.addedByUserType !== 18 && userType === 18}
                                            onChange={(event) => {
                                              const newValue = event.target.value
                                              estimateServiceAutofillDoneRef.current = false
                                              serviceNameDraft.handleChange(data.newIndexId, newValue)
                                              if (isSubmitted) setIsSubmitted(false)
                                              markUnsavedChanges()
                                            }}
                                            onBlur={() => serviceNameDraft.commit(data.newIndexId)}
                                            error={
                                              (isSubmitted &&
                                                !serviceNameDraft
                                                  .getValue(data.newIndexId, data.name || data.service_name || '')
                                                  .trim()) ||
                                              Boolean(serviceRowErrors[data.newIndexId])
                                            }
                                            helperText={
                                              serviceRowErrors[data.newIndexId] ||
                                              (isSubmitted &&
                                              !serviceNameDraft
                                                .getValue(data.newIndexId, data.name || data.service_name || '')
                                                .trim()
                                                ? 'Service Name is required'
                                                : '')
                                            }
                                          />
                                        ) : (
                                         <Box>
                                            <Typography sx={{ color: 'inherit', whiteSpace: 'pre-wrap' }}>
                                              {data.name || data.service_name}
                                            </Typography>
                                            {data.service_notes ? (
                                              <Typography sx={{ color: 'red', whiteSpace: 'pre-wrap' }}>
                                                Note: {data.service_notes}
                                              </Typography>
                                            ) : (
                                              ''
                                            )}
                                         </Box>
                                        )}
                                      </TableCell>
                                      {/* <TableCell sx={VIEW_QUOTATION_PRODUCT_TABLE_COL_SX.productDesc}>
                                        {isQuotationChooseEmptyService(data) ? (
                                          '-'
                                        ) : isWriteServiceRow ? (
                                          <TextField
                                            fullWidth
                                            type="text"
                                            label={'Service Description'}
                                            sx={{ width: '100%' }}
                                            value={data.service_desc || data.description || ''}
                                            disabled={!openEdit || data?.addedByUserType !== 18 && userType === 18}
                                            onChange={(event) => {
                                              const newValue = event.target.value
                                              updateServiceLineInState(data.newIndexId, (service) => ({
                                                ...service,
                                                service_desc: newValue,
                                                description: newValue,
                                              }))
                                              data.service_desc = newValue || ''
                                              data.description = newValue || ''
                                              markUnsavedChanges()
                                            }}
                                          />
                                        ) : (
                                          <Typography sx={{ whiteSpace: 'pre-wrap' }}>
                                            {data.service_desc || data.description || '-'}
                                          </Typography>
                                        )}
                                          </TableCell> */}
                                            <TableCell sx={VIEW_QUOTATION_PRODUCT_TABLE_COL_SX.productDesc}>
                                              {isQuotationChooseEmptyService(data) ? (
                                                '-'
                                              ) : isQuotationWriteService(data) ? (
                                                <TextField
                                                  fullWidth
                                                  type="text"
                                                  label="Service Description"
                                                  sx={{ width: '100%' }}
                                                  value={serviceDescDraft.getValue(
                                                    data.newIndexId,
                                                    data.service_desc || data.description || '',
                                                  )}
                                                  onChange={(event) => {
                                                    serviceDescDraft.handleChange(data.newIndexId, event.target.value)
                                                    markUnsavedChanges()
                                                  }}
                                                  onBlur={() => serviceDescDraft.commit(data.newIndexId)}
                                                />
                                              ) : (
                                                <TextField
                                                  fullWidth
                                                  type="text"
                                                  label="Service Description"
                                                  sx={{ width: '100%' }}
                                                  value={serviceDescDraft.getValue(
                                                    data.newIndexId,
                                                    data.service_desc || data.description || '',
                                                  )}
                                                  onChange={(event) => {
                                                    serviceDescDraft.handleChange(data.newIndexId, event.target.value)
                                                    markUnsavedChanges()
                                                  }}
                                                  onBlur={() => serviceDescDraft.commit(data.newIndexId)}
                                                />
                                              )}
                                            </TableCell>
                                      <TableCell>
                                        <IconButton onClick={() => handleOpenServiceNote(data.newIndexId || data.indexId, data.service_notes)}>
                                          <NoteAdd
                                            sx={{
                                              color: (!data?.service_notes || data?.service_notes === '') ? '' : theme.palette.primary.main,
                                            }}
                                          />
                                        </IconButton>
                                      </TableCell>
                                      <TableCell>
                                        <Tooltip title="Drop files on row or click to open attachments">
                                          <IconButton
                                            onClick={() =>
                                              handleOpenServiceAttachment(serviceAttKey)
                                            }
                                          >
                                            {isUploadingService[serviceAttKey] ? (
                                              <CircularProgress size={34} />
                                            ) : (
                                              <UploadFile
                                                sx={{
                                                  color:
                                                    !serviceAttachments[serviceAttKey] ||
                                                    serviceAttachments[serviceAttKey]?.length === 0
                                                      ? 'error.main'
                                                      : theme.palette.primary.main,
                                                }}
                                              />
                                            )}
                                          </IconButton>
                                        </Tooltip>
                                      </TableCell>
                                      <TableCell>
                                        {isWriteServiceRow || isQuotationChooseEmptyService(data)
                                          ? '-'
                                          : originalMarkup
                                            ? originalMarkup?.toFixed(2)
                                            : '0.00'}
                                      </TableCell>
                                      <TableCell>
                                        {isWriteServiceRow || isQuotationChooseEmptyService(data) ? '-' : data.cost}
                                      </TableCell>
                                      <TableCell>
                                        {isWriteServiceRow || isQuotationChooseEmptyService(data) ? (
                                          '-'
                                        ) : openEdit ? (
                                          <TextField
                                            required
                                            fullWidth
                                            type="number"
                                            label={'Hourly Cost'}
                                            // disabled={values.project_category?.name == 'Time & Material'}
                                            disabled
                                            sx={{ width: 85 }}
                                            value={dataCost}
                                            onFocus={selectInputValue}
                                            onClick={selectInputValue}
                                            onKeyPress={(event) => {
                                              if (event.key === '-') {
                                                event.preventDefault()
                                              }
                                              if (event.key === 'e') {
                                                event.preventDefault()
                                              }
                                            }}
                                            inputProps={{ min: 0 }}
                                            defaultValue={0}
                                            onChange={(event) => {
                                              const newValue = event.target.value
                                              if (newValue !== '') {
                                                updateServiceLineInState(data.newIndexId, (p) => ({
                                                  ...p,
                                                  total_cost: newValue,
                                                  unit_cost: newValue,
                                                }))
                                                data.total_cost = newValue || 0
                                                data.unit_cost = newValue || 0
                                                markUnsavedChanges()
                                              }
                                            }}
                                          />
                                        ) : (
                                          dataCost
                                        )}
                                      </TableCell>
                                      <TableCell>
                                        {isWriteServiceRow || isQuotationChooseEmptyService(data) ? (
                                          '-'
                                        ) : (
                                          <TextField
                                            type="number"
                                            sx={{ minWidth: '80px' }}
                                            label={'Hours'}
                                            {...getFieldProps(quantityFieldName)}
                                            value={Number(data?.quantity) || 0}
                                            defaultValue={1}
                                            disabled={!openEdit}
                                            onFocus={selectInputValue}
                                            onClick={selectInputValue}
                                            onKeyPress={(event) => {
                                              if (event.key === '-') {
                                                event.preventDefault()
                                              }
                                            }}
                                            onChange={(event) => {
                                              const newValue = event.target.value || 0
                                              const qty = Number(newValue) || 0
                                              updateServiceLineInState(data.newIndexId, (s) => {
                                                const { unitCost, lineTotal } = normalizeAdditionalServiceCostFields({
                                                  ...s,
                                                  quantity: qty,
                                                })
                                                return {
                                                  ...s,
                                                  quantity: qty,
                                                  qty,
                                                  unit_cost: unitCost,
                                                  total: lineTotal,
                                                  total_cost: unitCost,
                                                }
                                              })
                                              setFieldValue(quantityFieldName, newValue)
                                              markUnsavedChanges()
                                            }}
                                            onWheel={(e) => e.target.blur()}
                                            onKeyDown={(event) => {
                                              if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
                                                const newValue = event.target.value || 0
                                                if (newValue < 1 && event.key === 'ArrowDown') {
                                                  event.preventDefault()
                                              }
                                            }
                                          }}
                                          error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                          helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                        />
                                        )}
                                      </TableCell>
                                      {/* <TableCell>
                                        {data?.is_dos == 1 ? 'N/A' : (
                                        <Switch
                                          checked={data.makeAsTask === 1}
                                          onChange={(e) => {
                                            const newValue = e.target.checked ? 1 : 0;
                                            setAdditionalSelectedServices((prevServices) =>
                                              prevServices.map((service) =>
                                                service.newIndexId === data.newIndexId
                                                  ? { ...service, makeAsTask: newValue }
                                                  : service
                                              )
                                            );
                                            data['makeAsTask'] = newValue;
                                          }}
                                          color="primary"
                                        />)}
                                      </TableCell>
                                      <TableCell>
                                        {data?.is_dos == 1 ? 'N/A' : (
                                        <Switch
                                          checked={data.makeInstallCard === 1}
                                          onChange={(e) => {
                                            const newValue = e.target.checked ? 1 : 0;
                                            setAdditionalSelectedServices((prevServices) =>
                                              prevServices.map((service) =>
                                                service.newIndexId === data.newIndexId
                                                  ? { ...service, makeInstallCard: newValue }
                                                  : service
                                              )
                                            );
                                            data['makeInstallCard'] = newValue;
                                          }}
                                          color="primary"
                                        />)}
                                      </TableCell> */}
                                      <TableCell>
                                        {isWriteServiceRow || isQuotationChooseEmptyService(data)
                                          ? '-'
                                          : (data.cost * quantityDifference?.toFixed(2))?.toFixed(2)}
                                      </TableCell>
                                      <TableCell>
                                       {(isWriteServiceRow || isQuotationChooseEmptyService(data) ? '-' : total ? total?.toFixed(2) : '0.00')}
                                      </TableCell>
                                      <TableCell>
                                        ${fUSPrice(isWriteServiceRow || isQuotationChooseEmptyService(data) ? '-' : total ? total?.toFixed(2) : '0.00')}
                                      </TableCell>
                                      <TableCell align="right">
                                        {openEdit ? (
                                          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 0.5 }}>
                                            {!isQuotationWriteService(data) && !isQuotationChooseEmptyService(data) && data?.service_type!== 44 && data?.id ? (
                                              <Tooltip title="Change catalog service">
                                                <IconButton
                                                  size="small"
                                                  color="success"
                                                  onClick={() => openServicePickerForRow(data.newIndexId, data)}
                                                >
                                                  <SwapHorizontalCircleOutlined fontSize="small" />
                                                </IconButton>
                                              </Tooltip>
                                            ) : (
                                              <Box sx={{ width: 32 }} />
                                            )}
                                            <IconButton onClick={() => handleDeleteService(data.id, data.newIndexId)} color="error"
                                            //  disabled={data?.addedByUserType !== 18 && userType === 18}
                                              >
                                              <Delete />
                                            </IconButton>
                                          </Box>
                                        ) : (
                                          <IconButton onClick={() => handleDeleteService(data.id, data.newIndexId)} color="error"
                                          //  disabled={data?.addedByUserType !== 18 && userType === 18}
                                          >
                                            <Delete />
                                          </IconButton>
                                        )}
                                      </TableCell>
                                    </TableRow>
                                    </>
                                      )}
                                    </Draggable>
                                  );
                                })}
                                {droppableProvided.placeholder}
                                {/* <TableRow>
                                    <TableCell colSpan={8}>
                                      <Typography variant="h6" align="right">
                                        Total Additional Cost: {totalProductLabourCost.toFixed(2)}
                                      </Typography>
                                    </TableCell>
                                  </TableRow> */}
                              </TableBody>
                                  )}
                                </Droppable>
                              </DragDropContext>
                            </Table>
                          </TableContainer>
                        </Scrollbar>
                        {openEdit && (
                          <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-start' }}>
                            <Button
                              variant="outlined"
                              startIcon={<Icon icon={plusFill} />}
                              onClick={addNewServiceRow}
                              sx={{ marginLeft: '20px' }}
                            >
                              Add Row
                            </Button>
                          </Box>
                        )}
                        <Dialog
                          open={servicePickerOpen}
                          onClose={() => {
                            setServicePickerOpen(false)
                            setServicePickerRowNewIndexId(null)
                            setServicePickerDraft(null)
                          }}
                          maxWidth="md"
                          fullWidth
                          disableScrollLock
                        >
                          <DialogTitle>
                            {additionalSelectedServices.find((r) => r.newIndexId === servicePickerRowNewIndexId)?.id
                              ? 'Change Service'
                              : 'Select Service'}
                          </DialogTitle>
                          <DialogContent>
                            <Stack spacing={2} sx={{ mt: 1 }}>
                              <Autocomplete
                                options={filteredLaborServiceOptions}
                                value={servicePickerDraft}
                                onChange={(event, newValue) => setServicePickerDraft(newValue)}
                                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                renderInput={(params) => (
                                  <TextField {...params} required label="Select a service" />
                                )}
                                getOptionLabel={(option) =>
                                  option?.name
                                    ? `${option.name} (${getLabourCostServiceTabLabel(option.inhouse)})`
                                    : ''
                                }
                              />
                            </Stack>
                          </DialogContent>
                          <DialogActions>
                            <Button
                              onClick={() => {
                                setServicePickerOpen(false)
                                setServicePickerRowNewIndexId(null)
                                setServicePickerDraft(null)
                              }}
                            >
                              Cancel
                            </Button>
                            <Button variant="contained" onClick={confirmServicePicker}>
                              Confirm
                            </Button>
                          </DialogActions>
                        </Dialog>
                        <Stack sx={{ justifyContent: 'flex-end', alignItems: 'flex-end', display:'flex', flexDirection:'column' }}>
                          {/* <Button
                            variant="outlined"
                            startIcon={
                              <Stack>
                                {' '}
                                <Add />{' '}
                              </Stack>
                            }
                            onClick={() => {
                              addNewServiceRow()
                              // setMarkupType(1)
                            }}
                          >
                            Add Service Row
                          </Button> */}
                          <Typography variant="h6">
                            {details?.is_request_estimate == 1 ? `Total Service Cost: ` : `Total Additional Service Cost: `}
                           ${fUSPrice(totalProductLabourCost?.toFixed(2))}
                          </Typography>
                          {/* <Typography variant="h6">
                              Total Product Labor Cost:{' '}
                              {Number(totalProductInstallCost || 0).toFixed(2)}
                            </Typography> */}
                        </Stack>
                        {(details?.is_request_estimate == 1 && (!details?.estimate_job_status || details?.estimate_job_status == 3)) ? (
                        <>
                        {/* {(serviceRows?.length > 0) ? */}
                        {false ?
                          <>
                          <LabelStyle>Services</LabelStyle>
                          <TableContainer component={Paper} sx={{ mt: 2 }}>
                            <Table>
                              <TableHead>
                                <TableRow>
                                  <TableCell padding="checkbox" sx={{ width: 40 }} />
                                  <TableCell align="center">Sl No</TableCell>
                                  <TableCell align="center">Service Name</TableCell>
                                  <TableCell align="center">Service Description</TableCell>
                                  <TableCell align="center"></TableCell>
                                </TableRow>
                              </TableHead>
                              <DragDropContext onDragEnd={handleServiceRowsDragEnd}>
                                <Droppable droppableId="view-quotation-review-service-rows">
                                  {(droppableProvided) => (
                              <TableBody
                                ref={droppableProvided.innerRef}
                                {...droppableProvided.droppableProps}
                              >
                                {serviceRows?.map((row, index) => (
                                  <Draggable
                                    key={`review-service-row-${row.indexId}`}
                                    draggableId={`review-service-row-${row.indexId}`}
                                    index={index}
                                  >
                                    {(provided, snapshot) => (
                                  <TableRow
                                    key={row.indexId}
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    style={{
                                      ...provided.draggableProps.style,
                                      ...(snapshot.isDragging
                                        ? { backgroundColor: theme.palette.action.hover }
                                        : {}),
                                    }}
                                  >
                                    <TableCell
                                      padding="checkbox"
                                      {...provided.dragHandleProps}
                                      sx={{ width: 40, cursor: 'grab' }}
                                    >
                                      <DragIndicator fontSize="small" color="action" />
                                    </TableCell>
                                    <TableCell align="center">#{row.indexId}</TableCell>
                                    <TableCell align="center">
                                      <TextField
                                        fullWidth
                                        variant="outlined"
                                        value={row.service_name}
                                        onFocus={() => handleFieldFocus(row.indexId, 'name', row.service_name)}
                                        onChange={(e) => {
                                          handleRequestEstimateServiceNameChange(row.indexId, e.target.value);
                                          const updatedRow = { ...row, service_name: e.target.value };
                                          // triggerDebouncedAutoSaveService(updatedRow, 'name');
                                        }}
                                        // onBlur={() => handleServiceRowAutoSave(row, 'name')}
                                        placeholder="Service Name"
                                        error={Boolean(rowErrors[row.indexId])}
                                        helperText={rowErrors[row.indexId]}
                                        InputProps={{
                                          endAdornment: autoSavingField?.indexId === row.indexId && autoSavingField?.field === 'name' ? (
                                            <InputAdornment position="end">
                                              <CircularProgress size={20} />
                                            </InputAdornment>
                                          ) : null
                                        }}
                                      />
                                    </TableCell>
                                    <TableCell align="center">
                                      <TextField
                                        fullWidth
                                        variant="outlined"
                                        value={row.service_desc}
                                        onFocus={() => handleFieldFocus(row.indexId, 'desc', row.service_desc)}
                                        onChange={(e) => {
                                          handleRequestEstimateServiceDescChange(row.indexId, e.target.value);
                                          const updatedRow = { ...row,service_desc: e.target.value };
                                          triggerDebouncedAutoSave(updatedRow, 'desc');
                                        }}
                                        onBlur={() => handleServiceRowAutoSave(row, 'desc')}
                                        placeholder="Service Description"
                                        multiline
                                        minRows={1}
                                        maxRows={3}
                                        InputProps={{
                                          endAdornment: autoSavingField?.indexId === row.indexId && autoSavingField?.field === 'desc' ? (
                                            <InputAdornment position="end">
                                              <CircularProgress size={20} />
                                            </InputAdornment>
                                          ) : null
                                        }}
                                      />
                                    </TableCell>
                                    <TableCell align="center">
                                        {/* {productRows.length > 1 && ( */}
                                          <IconButton 
                                            onClick={() => handleDeleteRequestEstimateService(row.indexId, row.backendId, true)}
                                            color="error"
                                          >
                                            <Delete />
                                          </IconButton>
                                        {/* )} */}
                                    </TableCell>
                                  </TableRow>
                                    )}
                                  </Draggable>
                                ))}
                                {droppableProvided.placeholder}
                              </TableBody>
                                  )}
                                </Droppable>
                              </DragDropContext>
                            </Table>
                          </TableContainer>
                          </>
                        : ''}
                          <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-start'}}>
                            {/* <Button
                              variant="outlined"
                              startIcon={<Icon icon={plusFill} />}
                              onClick={()=> addNewRequestEstimateServiceRow()}
                              sx={{
                                marginLeft: '20px'
                              }}
                            >
                              Add Row
                            </Button> */}
                          </Box>
                        </>
                      ) : ''}

                      {/* {(details?.is_request_estimate == 1 && (!details?.estimate_job_status || details?.estimate_job_status != 3)) ? '' : ( */}
                      <>
                        {(values?.project_type?.name == 'TS' && values?.project_category?.id == 14) ? '' :
                          <>
                          <LabelStyleHead>Proposals</LabelStyleHead>
                          <Autocomplete
                            options={rfps}
                            // getOptionLabel={(option) => option.description}
                            getOptionLabel={(option) =>
                            option && option.description
                              ? `${option.description} ( ${option.vendor_name || ''})`
                              : ''
                            }
                            value={values.rfp}
                            onChange={(event, value) => {handleRfpSelect(event, value)
                              setFieldValue('rfp',value)
                            }}
                            renderInput={(params) => <TextField {...params} label="Select Proposal" />}
                            filterOptions={(options, { inputValue }) =>
                              options.filter((option) => {
                                const searchText = inputValue.toLowerCase();
                                return (
                                  option.name?.toLowerCase().includes(searchText) ||
                                  option.description?.toLowerCase().includes(searchText)
                                  // option.description?.toLowerCase().includes(searchText)
                                );
                              })
                            }

                          />
                          {/* Modal for RFP Selection */}
                          <Modal open={openModal} handleClose={closeModal}>
                            <Box sx={{ position: 'relative', p: 3, bgcolor: 'background.paper', boxShadow: 24 }}>

                              <Tabs value={tabIndex}
                                variant="fullWidth"
                                sx={{
                                  marginBottom: 4

                                }}
                                onChange={handleTabChange}>
                                <Tab label="Products" sx={{ width: '50%', minWidth: 0 }} />
                                <Tab label="Services" sx={{ width: '50%', minWidth: 0 }} />
                                <Tab label="Materials" sx={{ width: '50%', minWidth: 0 }} />
                              </Tabs>
                              {/* {tabIndex === 0 && (
                                <div>
                                  {rfpServices.map((service) => (
                                    <Box key={service.id} sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                                      <Typography>{service.name}</Typography>
                                      <Typography>${service.sellingPrice}</Typography>
                                      <Button onClick={() => addToCart(service)}>Add</Button>
                                    </Box>
                                  ))}
                                </div>
                              )}
                              {tabIndex === 1 && (
                                <div>
                                  {rfpProducts.map((product) => (
                                    <Box key={product.id} sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                                      <Typography>{product.product_name}</Typography>
                                      <Typography>${product.product_price}</Typography>
                                      <Button onClick={() => addToCart(product)}>Add</Button>
                                    </Box>
                                  ))}
                                </div>
                              )} */}
                              {tabIndex === 0 && (
                                <TableContainer sx={{ minWidth: 500 }}>
                                  <Table>
                                  <TableHead>
                                    <TableCell align='center'>Name</TableCell>
                                    <TableCell align='center'>Unit Cost</TableCell>
                                    <TableCell align='center'>Unit</TableCell>
                                    <TableCell align='center'>Qty</TableCell>
                                    <TableCell align='center'>Total Cost</TableCell>
                                    <TableCell align='center'></TableCell>
                                  </TableHead>
                                  {rfpProducts?.filter((product)=>product.material == 0 ).map((product) => {
                                    let unitName = UNITS?.filter((item) => item?.id == product?.unit)
                                    unitName = unitName[0]?.name
                                    let shortUnitName = ''
                                    if (unitName == 'Square feet') {
                                      shortUnitName = 'Sq ft'
                                    } else if (unitName == 'Lineal feet') {
                                      shortUnitName = 'Lin ft'
                                    } else if (unitName == 'Square Inches') {
                                      shortUnitName = 'Sq Inches'
                                    } else if (unitName == 'Unit') {
                                      shortUnitName = 'Unit'
                                    }
                                    return(
                                    // <Box key={product.id} sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                                      <TableRow key={product.id}>
                                        <TableCell align='center'>{product.product_name}</TableCell>
                                        <TableCell align='center'>${product.product_price}</TableCell>
                                        <TableCell align='center'>{product.quantity} {shortUnitName}</TableCell>
                                        <TableCell align='center'>{product.location_quantity}</TableCell>
                                        <TableCell align='center'>${(product.location_quantity*product.quantity * ((product.product_price).toFixed(2) || 0)).toFixed(2)}</TableCell>
                                        <TableCell align='center'><Button onClick={() => addToCart(product)}>Add</Button></TableCell>
                                      </TableRow>
                                    // </Box>
                                  )})}
                                  </Table>
                                </TableContainer>
                              )}
                                {tabIndex === 1 && (
                                  <TableContainer sx={{ minWidth: 500 }}>
                                  <Table>
                                  <TableHead>
                                    <TableCell align='center'>Name</TableCell>
                                    <TableCell align='center'>Unit Cost</TableCell>
                                    <TableCell align='center'>Hours</TableCell>
                                    <TableCell align='center'>Total Cost</TableCell>
                                    <TableCell align='center'></TableCell>
                                  </TableHead>
                                  {rfpServices.map((service) => (
                                    // <Box key={service.id} sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                                      <TableRow key={service.id}>
                                        <TableCell align='center'>{service.name}</TableCell>
                                        <TableCell align='center'>${service.sellingPrice}</TableCell>
                                        <TableCell align='center'>{service.quantity}</TableCell>
                                        <TableCell align='center'>${service.total_cost}</TableCell>
                                        <TableCell align='center'><Button onClick={() => addToCart(service)}>Add</Button></TableCell>
                                      </TableRow>
                                    // </Box>
                                  ))}
                                  </Table>
                                  </TableContainer>
                              )}
                              {tabIndex === 2 && (
                                <TableContainer sx={{ minWidth: 500 }}>
                                  <Table>
                                  <TableHead>
                                    <TableCell align='center'>Name</TableCell>
                                    <TableCell align='center'>Unit Cost</TableCell>
                                    <TableCell align='center'>Unit</TableCell>
                                    <TableCell align='center'>Qty</TableCell>
                                    <TableCell align='center'>Total Cost</TableCell>
                                    <TableCell align='center'></TableCell>
                                  </TableHead>
                                  {rfpProducts.filter((product)=>product.material == 1).map((product) => {
                                    let unitName = UNITS?.filter((item) => item?.id == product?.unit)
                                    unitName = unitName[0]?.name
                                    let shortUnitName = ''
                                    if (unitName == 'Square feet') {
                                      shortUnitName = 'Sq ft'
                                    } else if (unitName == 'Lineal feet') {
                                      shortUnitName = 'Lin ft'
                                    } else if (unitName == 'Square Inches') {
                                      shortUnitName = 'Sq Inches'
                                    } else if (unitName == 'Unit') {
                                      shortUnitName = 'Unit'
                                    }
                                    return(
                                    // <Box key={product.id} sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                                      <TableRow key={product.id}>
                                        <TableCell align='center'>{product.product_name}</TableCell>
                                        <TableCell align='center'>${product.product_price}</TableCell>
                                        <TableCell align='center'>{product.quantity} {shortUnitName}</TableCell>
                                        <TableCell align='center'>{product.location_quantity}</TableCell>
                                        <TableCell align='center'>${(product.location_quantity*product.quantity * ((product.product_price).toFixed(2) || 0)).toFixed(2)}</TableCell>
                                        <TableCell align='center'><Button onClick={() => addToCart(product)}>Add</Button></TableCell>
                                      </TableRow>
                                    // </Box>
                                  )})}
                                  </Table>
                                </TableContainer>
                              )}
                            </Box>
                          </Modal>
                          <Scrollbar>
                            <TableContainer sx={{ minWidth: 500 }}>
                              <Table>
                                <TableHead>
                                  <TableRow>
                                    {VALUE_RFP_Product?.map((val,index) => (

                                      <TableCell key={val.id}>{val.value}</TableCell>

                                    ))}
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {cart?.filter((item)=>item.material == 0)?.map((data, index) => {
                                    let unitName = UNITS?.filter((item) => item?.id == data?.unit)
                                    unitName = unitName[0]?.name
                                    let shortUnitName = ''
                                    if (unitName == 'Square feet') {
                                      shortUnitName = 'Sq ft'
                                    } else if (unitName == 'Lineal feet') {
                                      shortUnitName = 'Lin ft'
                                    } else if (unitName == 'Square Inches') {
                                      shortUnitName = 'Sq Inches'
                                    } else if (unitName == 'Unit') {
                                      shortUnitName = 'Unit'
                                    }
                                    // let markup = markupType ? markupType === 1 ? data.WholesaleMarkup || data.product_markup : data.RetailMarkup || data.product_markup : 0
                                    let markup = parseFloat(Number(data?.markup)) || 0
                                    data.product_markup = markup
                                    return (
                                      <>
                                        <TableRow key={data.id}>
                                          <TableCell>{index + 1}</TableCell>
                                          <TableCell>
                                            <div
                                              style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: 40,
                                                height: 20,
                                              }}
                                            >
                                              {data?.syncWithQuickbooks === 1 && (
                                                <img
                                                  src={quickbookLogo}
                                                  alt="QuickBooks"
                                                  style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'contain',
                                                  }}
                                                />
                                              )}
                                            </div>
                                          </TableCell>
                                          <TableCell>{data.name || data.product_name}</TableCell>
                                          {/* <TableCell>{invoiceAmount}</TableCell> */}
                                          <TableCell>
                                            {markup?.toFixed(2) || 0.00}
                                          </TableCell>
                                          <TableCell>
                                            {data.product_price?.toFixed(2) || 0}
                                          </TableCell>
                                          <TableCell>
                                            {(data.product_price + (data.product_price * markup / 100)).toFixed(2) || 0.00}
                                          </TableCell>
                                          <TableCell>
                                            {data.quantity} {shortUnitName}
                                          </TableCell>
                                          <TableCell>
                                            {data.location_quantity}
                                          </TableCell>
                                         
                                          {/* <TableCell>
                                            {(data.product_price * data.quantity * data.location_quantity)?.toFixed(2)||0}
                                          </TableCell> */}
                                          <TableCell>
                                            {(data.location_quantity * data.quantity * ((data.product_price + (data.product_price * markup / 100))?.toFixed(2) || 0)).toFixed(2)}
                                          </TableCell>
                                          {/* <TableCell>N/A</TableCell>
                                          <TableCell>N/A</TableCell> */}
                                          <TableCell>
                                            <IconButton
                                              onClick={() => {
                                                setRfpLocationStates({ ...rfpLocationStates, [data.product_id]: true });
                                              }}
                                            >
                                              <LocationOn sx={{
                                                color: data && data.location && data.location.some(obj =>
                                                  [obj.address, obj.city, obj.state, obj.zip].some(value => (value === '' || value === null))
                                                ) ? '' : theme.palette.primary.main
                                              }} />
                                            </IconButton>
                                          </TableCell>
                                          <TableCell >
                                            <IconButton onClick={() => handleDeleteRFPProduct(data.product_id)}>
                                              <Delete />
                                            </IconButton>
                                          </TableCell>
                                        </TableRow>
                                        <Modal
                                          open={rfpLocationStates[data.product_id]}
                                          handleClose={() => {
                                            setRfpLocationStates({ ...rfpLocationStates, [data.product_id]: false });
                                          }}
                                        >
                                          <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent={'space-between'} alignItems={'center'} width={'100%'}>
                                          {/* {index === 0 &&  */}
                                          <FormControlLabel
                                            control={
                                              <Switch
                                                checked={data?.allRfpProductsLocationSame}
                                                onChange={()=>handleAllRfpProductsLocationSameChange(index) }
                                              />
                                            }
                                            label="All Locations Same"
                                          />
                                          {/* } */}
                                          <Box sx={{ display: 'flex', flexDirection: 'column', width: '50%', alignItems: 'center', mt: 2 }}>
                                            <LabelStyle>Qty Location Settings</LabelStyle>
                                            <Box display="flex" alignItems="center" gap={1} mt={1}>
                                              <Typography variant="subtitle2">Multiple</Typography>
                                              <Switch
                                                color="primary"
                                                checked={data?.is_single_card}
                                                onChange={(event) => {
                                                  const checked = event.target.checked;

                                                  setCart((prevCart) =>
                                                    prevCart.map((p) => {
                                                      if (p.product_id !== data.product_id) return p;

                                                      const count = Number(p.location_quantity || 1);

                                                      if (checked) {
                                                        // Single: always exactly one location
                                                        const first = p.location?.[0] || {
                                                          id: 0,
                                                          address: '',
                                                          city: '',
                                                          state: '',
                                                          zip: '',
                                                        };

                                                        return {
                                                          ...p,
                                                          is_single_card: true,
                                                          location: [first],
                                                        };
                                                      } else {
                                                        // Multiple: create `location_quantity` locations from first
                                                        const first = p.location?.[0] || {
                                                          id: 0,
                                                          address: '',
                                                          city: '',
                                                          state: '',
                                                          zip: '',
                                                        };

                                                        const arrayLoc = Array(count)
                                                          .fill()
                                                          .map((_, i) => ({
                                                            ...first,
                                                            id: i,
                                                          }));

                                                        return {
                                                          ...p,
                                                          is_single_card: false,
                                                          location: arrayLoc,
                                                        };
                                                      }
                                                    })
                                                  );
                                                }}
                                              />
                                              <Typography variant="subtitle2">Single</Typography>
                                            </Box>
                                          </Box>
                                          </Stack>

                                          <Grid
                                            container
                                            spacing={3}
                                            sx={{ justifyContent: 'center', width: '100%' }}
                                          >

                                            {data?.location?.map((addr, i) => (
                                              <Grid item xs={12}>
                                                {/* Side Heading */}
                                                <Typography variant="h5" sx={{ mb: 2 }}>
                                                  Location {i+1}
                                                </Typography>

                                                {/* Address Fields */}

                                                <Stack
                                                  direction={{ xs: 'column', sm: 'row' }}
                                                  spacing={{ xs: 3, sm: 2 }}
                                                  sx={{ mb: 2 }}
                                                >
                                                  <TextField
                                                    fullWidth
                                                    label="Address"
                                                    size="small"
                                                    value={data.location[i].address || ''}

                                                    // onChange={(event) => {
                                                    //   let arrayAddr = [...data.location]
                                                    //   arrayAddr[i].address = event.target.value;
                                                    //   setCart(pv => ([...pv.map(p => {


                                                    //     if (p.product_id === data.product_id) {
                                                    //       return {
                                                    //         ...p,
                                                    //         addresses: arrayAddr
                                                    //       }
                                                    //     }
                                                    //     else {
                                                    //       return {
                                                    //         ...p
                                                    //       }
                                                    //     }

                                                    //   })]))
                                                    // }}
                                                    disabled={
                                                      i !== 0 &&
                                                      data?.allRfpProductsLocationSame
                                                        ? true
                                                        : false
                                                    }
                                                    onChange={(event) => {
                                                      setCart((prevProducts) =>
                                                        prevProducts.map((p) => {
                                                          if (p.product_id === data.product_id) {
                                                            let updatedAddresses = [...p.location];
                                                            if (p.allRfpProductsLocationSame) {
                                                              updatedAddresses = updatedAddresses.map(() => ({
                                                                ...updatedAddresses[0],
                                                                address: event.target.value,
                                                              }));
                                                            } else {
                                                              updatedAddresses[i] = {
                                                                ...updatedAddresses[i],
                                                                address: event.target.value,
                                                              };
                                                            }
                                                            return {
                                                              ...p,
                                                              location: updatedAddresses,
                                                            };
                                                          }
                                                          return p;
                                                        })
                                                      );
                                                      // markUnsavedChanges();();
                                                    }}
                                                  />
                                                </Stack>

                                                {/* City, State, Zip Fields */}
                                                <Stack
                                                  direction={{ xs: 'column', sm: 'row' }}
                                                  spacing={{ xs: 3, sm: 2 }}
                                                  sx={{ mb: 2 }}
                                                >
                                                  <TextField
                                                    fullWidth
                                                    label="City"
                                                    size="small"
                                                    value={data.location[i].city || ''}

                                                    // onChange={(event) => {
                                                    //   let arrayAddr = [...data.location]
                                                    //   arrayAddr[i].city = event.target.value;
                                                    //   setCart(pv => ([...pv.map(p => {


                                                    //     if (p.product_id === data.product_id) {
                                                    //       return {
                                                    //         ...p,
                                                    //         addresses: arrayAddr
                                                    //       }
                                                    //     }
                                                    //     else {
                                                    //       return {
                                                    //         ...p
                                                    //       }
                                                    //     }

                                                    //   })]))
                                                    // }}
                                                    disabled={
                                                      i !== 0 &&
                                                      data?.allRfpProductsLocationSame
                                                        ? true
                                                        : false
                                                    }
                                                    onChange={(event) => {
                                                      setCart((prevProducts) =>
                                                        prevProducts.map((p) => {
                                                          if (p.product_id === data.product_id) {
                                                            let updatedAddresses = [...p.location];
                                                            if (p.allRfpProductsLocationSame) {
                                                              updatedAddresses = updatedAddresses.map(() => ({
                                                                ...updatedAddresses[0],
                                                                city: event.target.value,
                                                              }));
                                                            } else {
                                                              updatedAddresses[i] = {
                                                                ...updatedAddresses[i],
                                                                city: event.target.value,
                                                              };
                                                            }
                                                            return {
                                                              ...p,
                                                              location: updatedAddresses,
                                                            };
                                                          }
                                                          return p;
                                                        })
                                                      );
                                                      // markUnsavedChanges();();
                                                    }}
                                                  />
                                                  <TextField
                                                    fullWidth
                                                    label="State"
                                                    size="small"
                                                    value={data.location[i].state || ''}

                                                    // onChange={(event) => {
                                                    //   let arrayAddr = [...data.location]
                                                    //   arrayAddr[i].state = event.target.value;
                                                    //   setCart(pv => ([...pv.map(p => {

                                                    //     if (p.product_id === data.product_id) {
                                                    //       return {
                                                    //         ...p,
                                                    //         addresses: arrayAddr
                                                    //       }
                                                    //     }
                                                    //     else {
                                                    //       return {
                                                    //         ...p
                                                    //       }
                                                    //     }

                                                    //   })]))
                                                    // }}
                                                    disabled={
                                                      i !== 0 &&
                                                      data?.allRfpProductsLocationSame
                                                        ? true
                                                        : false
                                                    }
                                                    onChange={(event) => {
                                                      setCart((prevProducts) =>
                                                        prevProducts.map((p) => {
                                                          if (p.product_id === data.product_id) {
                                                            let updatedAddresses = [...p.location];
                                                            if (p.allRfpProductsLocationSame) {
                                                              updatedAddresses = updatedAddresses.map(() => ({
                                                                ...updatedAddresses[0],
                                                                state: event.target.value,
                                                              }));
                                                            } else {
                                                              updatedAddresses[i] = {
                                                                ...updatedAddresses[i],
                                                                state: event.target.value,
                                                              };
                                                            }
                                                            return {
                                                              ...p,
                                                              location: updatedAddresses,
                                                            };
                                                          }
                                                          return p;
                                                        })
                                                      );
                                                      // markUnsavedChanges();();
                                                    }}
                                                  />
                                                  <TextField
                                                    fullWidth
                                                    label="Zip / Postal Code"
                                                    size="small"
                                                    value={data.location[i].zip || ''}

                                                    // onChange={(event) => {
                                                    //   let arrayAddr = [...data.location]
                                                    //   arrayAddr[i].zip = event.target.value;
                                                    //   setCart(pv => ([...pv.map(p => {


                                                    //     if (p.product_id === data.product_id) {
                                                    //       return {
                                                    //         ...p,
                                                    //         addresses: arrayAddr
                                                    //       }
                                                    //     }
                                                    //     else {
                                                    //       return {
                                                    //         ...p
                                                    //       }
                                                    //     }

                                                    //   })]))
                                                    // }}
                                                    disabled={
                                                      i !== 0 &&
                                                      data?.allRfpProductsLocationSame
                                                        ? true
                                                        : false
                                                    }
                                                    onChange={(event) => {
                                                      setCart((prevProducts) =>
                                                        prevProducts.map((p) => {
                                                          if (p.product_id === data.product_id) {
                                                            let updatedAddresses = [...p.location];
                                                            if (p.allRfpProductsLocationSame) {
                                                              updatedAddresses = updatedAddresses.map(() => ({
                                                                ...updatedAddresses[0],
                                                                zip: event.target.value,
                                                              }));
                                                            } else {
                                                              updatedAddresses[i] = {
                                                                ...updatedAddresses[i],
                                                                zip: event.target.value,
                                                              };
                                                            }
                                                            return {
                                                              ...p,
                                                              location: updatedAddresses,
                                                            };
                                                          }
                                                          return p;
                                                        })
                                                      );
                                                      // markUnsavedChanges();();
                                                    }}
                                                  />
                                                </Stack>
                                              </Grid>
                                            ))}
                                          </Grid>


                                          <Grid container justifyContent="center" alignItems="center">
                                            <Grid item xs={12} md={4}>
                                              <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 1 }}>
                                                <LoadingButton variant="contained" onClick={() => {
                                                  setIsSaving(true)
                                                  setTimeout(() => {
                                                    setIsSaving(false)
                                                    setRfpLocationStates(false)
                                                  }, 100)
                                                }} loading={isSaving}>
                                                  {' Save '}
                                                </LoadingButton>

                                              </Box>
                                            </Grid>
                                          </Grid>
                                        </Modal>
                                      </>
                                    );
                                  })}
                                </TableBody>
                                {
                                  cartService?.length > 0 ?
                                    <Typography variant='subtitle2' sx={{ fontWeight: 500 }}>Services</Typography>
                                    : ''
                                }
                                <TableBody>
                                  {cartService?.map((data, index) => {
                                    data.sellingPrice = data.sellingPrice || data.unit_cost
                                    data.originalMarkup = data.originalMarkup || data.product_markup || data.markup

                                    return (
                                      <>
                                        <TableRow key={data.id}>
                                          <TableCell>{index + 1}</TableCell>
                                          <TableCell>
                                            <div
                                              style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: 40,
                                                height: 20,
                                              }}
                                            >
                                              {data?.syncWithQuickbooks === 1 && (
                                                <img
                                                  src={quickbookLogo}
                                                  alt="QuickBooks"
                                                  style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'contain',
                                                  }}
                                                />
                                              )}
                                            </div>
                                          </TableCell>
                                          <TableCell>{data?.service_notes ? <Typography sx={{ color: 'red', whiteSpace: 'pre-wrap' }}>{data.service_notes}</Typography> : (data.name || data.product_name)}</TableCell>
                                          {/* <TableCell>
                                            <IconButton onClick={() => handleOpenServiceNote(data.id, data.service_notes)}>
                                              <NoteAdd
                                                sx={{
                                                  color: (!data?.service_notes || data?.service_notes === '') ? '' : theme.palette.primary.main,
                                                }}
                                              />
                                            </IconButton>
                                          </TableCell> */}
                                          {/* <TableCell>{invoiceAmount}</TableCell> */}
                                          <TableCell>
                                            {data.originalMarkup?.toFixed(2)}
                                          </TableCell>
                                          <TableCell>
                                            {data.sellingPrice?.toFixed(2)}
                                          </TableCell>
                                          <TableCell>
                                            {((data.sellingPrice + (data.sellingPrice * data.originalMarkup / 100)))?.toFixed(2)}
                                          </TableCell>
                                          <TableCell>
                                            {data.qty} Hours
                                          </TableCell>
                                          <TableCell>-</TableCell>
                                          {/* <TableCell>
                                            {(data.qty*data.sellingPrice).toFixed(2)||0}
                                          </TableCell> */}
                                          <TableCell>
                                            {(data.qty * (data.sellingPrice + (data.sellingPrice * data.originalMarkup / 100)))?.toFixed(2)}
                                          </TableCell>
                                          {/* <TableCell>
                                            <Switch
                                              checked={data.makeAsTask === 1}
                                              onChange={(e) => {
                                                const newValue = e.target.checked ? 1 : 0;
                                                setCartService((prevServices) =>
                                                  prevServices.map((service) =>
                                                    service.id === data.id
                                                      ? { ...service, makeAsTask: newValue }
                                                      : service
                                                  )
                                                );
                                                data['makeAsTask'] = newValue;
                                              }}
                                              color="primary"
                                            />
                                          </TableCell>
                                          <TableCell>
                                            <Switch
                                              checked={data.makeInstallCard === 1}
                                              onChange={(e) => {
                                                const newValue = e.target.checked ? 1 : 0;
                                                setCartService((prevServices) =>
                                                  prevServices.map((service) =>
                                                    service.id === data.id
                                                      ? { ...service, makeInstallCard: newValue }
                                                      : service
                                                  )
                                                );
                                                data['makeInstallCard'] = newValue;
                                              }}
                                              color="primary"
                                            />
                                          </TableCell> */}
                                          <TableCell>
                                            <IconButton
                                              onClick={() => {
                                                setRfpServiceLocationStates({ ...rfpServiceLocationStates, [data.id]: true });
                                              }}
                                            >
                                              <LocationOn sx={{
                                                color: data && data.location && data.location.some(obj =>
                                                  [obj.address, obj.city, obj.state, obj.zip].some(value => (value === '' || value === null))
                                                ) ? '' : theme.palette.primary.main
                                              }} />
                                            </IconButton>
                                          </TableCell>

                                          <TableCell >
                                            <IconButton onClick={() => handleDeleteRFPService(data.labour_cost_service_id)}>
                                              <Delete />
                                            </IconButton>
                                          </TableCell>
                                        </TableRow>
                                        <Modal
                                          open={rfpServiceLocationStates[data.id]}
                                          handleClose={() => {
                                            setRfpServiceLocationStates({ ...rfpServiceLocationStates, [data.id]: false });
                                          }}
                                        >
                                            {index === 0 && <FormControlLabel
                                          control={
                                            <Switch
                                              checked={allRfpServiceLocationSame}
                                              onChange={handleAllRfpServiceLocationSameChange}
                                            />
                                          }
                                          label="All Locations Same"
                                        />}

                                          <Grid
                                            container
                                            spacing={3}
                                            sx={{ justifyContent: 'center', width: '100%' }}
                                          >

                                            {data?.location?.map((addr, i) => (
                                              <Grid item xs={12}>
                                                {/* Side Heading */}
                                                <Typography variant="h5" sx={{ mb: 2 }}>
                                                  Location
                                                </Typography>

                                                {/* Address Fields */}

                                                <Stack
                                                  direction={{ xs: 'column', sm: 'row' }}
                                                  spacing={{ xs: 3, sm: 2 }}
                                                  sx={{ mb: 2 }}
                                                >
                                                  <TextField
                                                    fullWidth
                                                    label="Address"
                                                    size="small"
                                                    value={data.location[i].address || ''}
                                                    disabled={index !== 0 && allRfpServiceLocationSame ? true : false}
                                                    // onChange={(event) => {
                                                    //   let arrayAddr = [...data.location]
                                                    //   arrayAddr[i].address = event.target.value;
                                                    //   setCartService(pv => ([...pv.map(p => {


                                                    //     if (p.id === data.id) {
                                                    //       return {
                                                    //         ...p,
                                                    //         location: arrayAddr
                                                    //       }
                                                    //     }
                                                    //     else {
                                                    //       return {
                                                    //         ...p
                                                    //       }
                                                    //     }

                                                    //   })]))
                                                    // }}
                                                    onChange={(event) => {
                                                      const updatedValue = event.target.value;
                                                    
                                                      setCartService((prevServices) =>
                                                        prevServices.map((service) => {
                                                          let updatedLocations = [...service.location];
                                                    
                                                          if (allRfpServiceLocationSame) {
                                                            // Apply the new value to all services in cartService
                                                            return {
                                                              ...service,
                                                              location: updatedLocations.map(loc => ({
                                                                ...loc,
                                                                address: updatedValue, // Update address field, same logic applies for others
                                                              })),
                                                            };
                                                          } else {
                                                            // Update only the specific service
                                                            if (service.id === data.id) {
                                                              updatedLocations[i].address = updatedValue;
                                                            }
                                                            return {
                                                              ...service,
                                                              location: updatedLocations,
                                                            };
                                                          }
                                                        })
                                                      );
                                                      // markUnsavedChanges();();
                                                    }}                                                    
                                                  />
                                                </Stack>

                                                {/* City, State, Zip Fields */}
                                                <Stack
                                                  direction={{ xs: 'column', sm: 'row' }}
                                                  spacing={{ xs: 3, sm: 2 }}
                                                  sx={{ mb: 2 }}
                                                >
                                                  <TextField
                                                    fullWidth
                                                    label="City"
                                                    size="small"
                                                    value={data.location[i].city || ''}
                                                    disabled={index !== 0 && allRfpServiceLocationSame ? true : false}
                                                    // onChange={(event) => {
                                                    //   let arrayAddr = [...data.location]
                                                    //   arrayAddr[i].city = event.target.value;
                                                    //   setCartService(pv => ([...pv.map(p => {


                                                    //     if (p.id === data.id) {
                                                    //       return {
                                                    //         ...p,
                                                    //         location: arrayAddr
                                                    //       }
                                                    //     }
                                                    //     else {
                                                    //       return {
                                                    //         ...p
                                                    //       }
                                                    //     }

                                                    //   })]))
                                                    // }}
                                                    onChange={(event) => {
                                                      const updatedValue = event.target.value;
                                                    
                                                      setCartService((prevServices) =>
                                                        prevServices.map((service) => {
                                                          let updatedLocations = [...service.location];
                                                    
                                                          if (allRfpServiceLocationSame) {
                                                            // Apply the new value to all services in cartService
                                                            return {
                                                              ...service,
                                                              location: updatedLocations.map(loc => ({
                                                                ...loc,
                                                                city: updatedValue, // Update city field, same logic applies for others
                                                              })),
                                                            };
                                                          } else {
                                                            // Update only the specific service
                                                            if (service.id === data.id) {
                                                              updatedLocations[i].city = updatedValue;
                                                            }
                                                            return {
                                                              ...service,
                                                              location: updatedLocations,
                                                            };
                                                          }
                                                        })
                                                      );
                                                      // markUnsavedChanges();();
                                                    }}                                                    
                                                  />
                                                  <TextField
                                                    fullWidth
                                                    label="State"
                                                    size="small"
                                                    value={data.location[i].state || ''}
                                                    disabled={index !== 0 && allRfpServiceLocationSame ? true : false}
                                                    // onChange={(event) => {
                                                    //   let arrayAddr = [...data.location]
                                                    //   arrayAddr[i].state = event.target.value;
                                                    //   setCartService(pv => ([...pv.map(p => {

                                                    //     if (p.id === data.id) {
                                                    //       return {
                                                    //         ...p,
                                                    //         location: arrayAddr
                                                    //       }
                                                    //     }
                                                    //     else {
                                                    //       return {
                                                    //         ...p
                                                    //       }
                                                    //     }

                                                    //   })]))
                                                    // }}
                                                    onChange={(event) => {
                                                      const updatedValue = event.target.value;
                                                    
                                                      setCartService((prevServices) =>
                                                        prevServices.map((service) => {
                                                          let updatedLocations = [...service.location];
                                                    
                                                          if (allRfpServiceLocationSame) {
                                                            // Apply the new value to all services in cartService
                                                            return {
                                                              ...service,
                                                              location: updatedLocations.map(loc => ({
                                                                ...loc,
                                                                state: updatedValue, // Update state field, same logic applies for others
                                                              })),
                                                            };
                                                          } else {
                                                            // Update only the specific service
                                                            if (service.id === data.id) {
                                                              updatedLocations[i].state = updatedValue;
                                                            }
                                                            return {
                                                              ...service,
                                                              location: updatedLocations,
                                                            };
                                                          }
                                                        })
                                                      );
                                                      // markUnsavedChanges();();
                                                    }}                                                    
                                                  />
                                                  <TextField
                                                    fullWidth
                                                    label="Zip / Postal Code"
                                                    size="small"
                                                    value={data.location[i].zip || ''}
                                                    disabled={index !== 0 && allRfpServiceLocationSame ? true : false}
                                                    // onChange={(event) => {
                                                    //   let arrayAddr = [...data.location]
                                                    //   arrayAddr[i].zip = event.target.value;
                                                    //   setCartService(pv => ([...pv.map(p => {


                                                    //     if (p.id === data.id) {
                                                    //       return {
                                                    //         ...p,
                                                    //         location: arrayAddr
                                                    //       }
                                                    //     }
                                                    //     else {
                                                    //       return {
                                                    //         ...p
                                                    //       }
                                                    //     }

                                                    //   })]))
                                                    // }}
                                                    onChange={(event) => {
                                                      const updatedValue = event.target.value;
                                                    
                                                      setCartService((prevServices) =>
                                                        prevServices.map((service) => {
                                                          let updatedLocations = [...service.location];
                                                    
                                                          if (allRfpServiceLocationSame) {
                                                            // Apply the new value to all services in cartService
                                                            return {
                                                              ...service,
                                                              location: updatedLocations.map(loc => ({
                                                                ...loc,
                                                                zip: updatedValue, // Update ZIP field, same logic applies for others
                                                              })),
                                                            };
                                                          } else {
                                                            // Update only the specific service
                                                            if (service.id === data.id) {
                                                              updatedLocations[i].zip = updatedValue;
                                                            }
                                                            return {
                                                              ...service,
                                                              location: updatedLocations,
                                                            };
                                                          }
                                                        })
                                                      );
                                                      // markUnsavedChanges();();
                                                    }}                                                    
                                                  />
                                                </Stack>
                                              </Grid>
                                            ))}
                                          </Grid>

                                          {index !== 0 && allRfpServiceLocationSame ? '' :
                                          <Grid container justifyContent="center" alignItems="center">
                                            <Grid item xs={12} md={4}>
                                              <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 1 }}>
                                                <LoadingButton variant="contained" onClick={() => {
                                                  setIsSaving(true)
                                                  setTimeout(() => {
                                                    setIsSaving(false)
                                                    setRfpServiceLocationStates(false)
                                                  }, 100)
                                                }} loading={isSaving}>
                                                  {' Save '}
                                                </LoadingButton>

                                              </Box>
                                            </Grid>
                                          </Grid>}
                                        </Modal>
                                      </>
                                    );
                                  })}
                                </TableBody>
                                 {cart?.filter((item)=>item.material == 1).length > 0 ?
                                  <Typography variant='subtitle2' sx={{fontWeight:500}}>Materials</Typography>
                                  :''}
                                <TableBody>
                                  {cart?.filter((item)=>item.material == 1)?.map((data, index) => {
                                    let unitName = UNITS?.filter((item) => item?.id == data?.unit)
                                    unitName = unitName[0]?.name
                                    let shortUnitName = ''
                                    if (unitName == 'Square feet') {
                                      shortUnitName = 'Sq ft'
                                    } else if (unitName == 'Lineal feet') {
                                      shortUnitName = 'Lin ft'
                                    } else if (unitName == 'Square Inches') {
                                      shortUnitName = 'Sq Inches'
                                    } else if (unitName == 'Unit') {
                                      shortUnitName = 'Unit'
                                    }
                                    // let markup = markupType ? markupType === 1 ? data.WholesaleMarkup || data.product_markup : data.RetailMarkup || data.product_markup : 0
                                    let markup = parseFloat(Number(data?.markup)) || 0
                                    data.product_markup = markup
                                    return (
                                      <>
                                        <TableRow key={data.id}>
                                          <TableCell>{index + 1}</TableCell>
                                          <TableCell>
                                            <div
                                              style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: 40,
                                                height: 20,
                                              }}
                                            >
                                              {data?.syncWithQuickbooks === 1 && (
                                                <img
                                                  src={quickbookLogo}
                                                  alt="QuickBooks"
                                                  style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'contain',
                                                  }}
                                                />
                                              )}
                                            </div>
                                          </TableCell>
                                          <TableCell>{data.name || data.product_name}</TableCell>
                                          {/* <TableCell>{invoiceAmount}</TableCell> */}
                                          <TableCell>
                                            {markup?.toFixed(2) || 0.00}
                                          </TableCell>
                                          <TableCell>
                                            {data.product_price?.toFixed(2) || 0}
                                          </TableCell>
                                          <TableCell>
                                            {(data.product_price + (data.product_price * markup / 100)).toFixed(2) || 0.00}
                                          </TableCell>
                                          <TableCell>
                                            {data.quantity} {shortUnitName}
                                          </TableCell>
                                          <TableCell>
                                            {data.location_quantity}
                                          </TableCell>
                                         
                                          {/* <TableCell>
                                            {(data.product_price * data.quantity * data.location_quantity)?.toFixed(2)||0}
                                          </TableCell> */}
                                          <TableCell>
                                            {(data.location_quantity * data.quantity * ((data.product_price + (data.product_price * markup / 100))?.toFixed(2) || 0)).toFixed(2)}
                                          </TableCell>
                                          {/* <TableCell>N/A</TableCell>
                                          <TableCell>N/A</TableCell> */}
                                          <TableCell>
                                            <IconButton
                                              onClick={() => {
                                                setRfpLocationStates({ ...rfpLocationStates, [data.product_id]: true });
                                              }}
                                            >
                                              <LocationOn sx={{
                                                color: data && data.location && data.location.some(obj =>
                                                  [obj.address, obj.city, obj.state, obj.zip].some(value => (value === '' || value === null))
                                                ) ? '' : theme.palette.primary.main
                                              }} />
                                            </IconButton>
                                          </TableCell>
                                          <TableCell >
                                            <IconButton onClick={() => handleDeleteRFPProduct(data.product_id)}>
                                              <Delete />
                                            </IconButton>
                                          </TableCell>
                                        </TableRow>
                                        <Modal
                                          open={rfpLocationStates[data.product_id]}
                                          handleClose={() => {
                                            setRfpLocationStates({ ...rfpLocationStates, [data.product_id]: false });
                                          }}
                                        >
                                          {/* {index === 0 &&  */}
                                          <FormControlLabel
                                            control={
                                              <Switch
                                                checked={data?.allRfpProductsLocationSame}
                                                onChange={()=>handleAllRfpProductsLocationSameChange(index) }
                                              />
                                            }
                                            label="All Locations Same"
                                          />
                                          {/* } */}

                                          <Grid
                                            container
                                            spacing={3}
                                            sx={{ justifyContent: 'center', width: '100%' }}
                                          >

                                            {data?.location?.map((addr, i) => (
                                              <Grid item xs={12}>
                                                {/* Side Heading */}
                                                <Typography variant="h5" sx={{ mb: 2 }}>
                                                  Location {i+1}
                                                </Typography>

                                                {/* Address Fields */}

                                                <Stack
                                                  direction={{ xs: 'column', sm: 'row' }}
                                                  spacing={{ xs: 3, sm: 2 }}
                                                  sx={{ mb: 2 }}
                                                >
                                                  <TextField
                                                    fullWidth
                                                    label="Address"
                                                    size="small"
                                                    value={data.location[i].address || ''}

                                                    // onChange={(event) => {
                                                    //   let arrayAddr = [...data.location]
                                                    //   arrayAddr[i].address = event.target.value;
                                                    //   setCart(pv => ([...pv.map(p => {


                                                    //     if (p.product_id === data.product_id) {
                                                    //       return {
                                                    //         ...p,
                                                    //         addresses: arrayAddr
                                                    //       }
                                                    //     }
                                                    //     else {
                                                    //       return {
                                                    //         ...p
                                                    //       }
                                                    //     }

                                                    //   })]))
                                                    // }}
                                                    disabled={
                                                      i !== 0 &&
                                                      data?.allRfpProductsLocationSame
                                                        ? true
                                                        : false
                                                    }
                                                    onChange={(event) => {
                                                      setCart((prevProducts) =>
                                                        prevProducts.map((p) => {
                                                          if (p.product_id === data.product_id) {
                                                            let updatedAddresses = [...p.location];
                                                            if (p.allRfpProductsLocationSame) {
                                                              updatedAddresses = updatedAddresses.map(() => ({
                                                                ...updatedAddresses[0],
                                                                address: event.target.value,
                                                              }));
                                                            } else {
                                                              updatedAddresses[i] = {
                                                                ...updatedAddresses[i],
                                                                address: event.target.value,
                                                              };
                                                            }
                                                            return {
                                                              ...p,
                                                              location: updatedAddresses,
                                                            };
                                                          }
                                                          return p;
                                                        })
                                                      );
                                                    }}
                                                  />
                                                </Stack>

                                                {/* City, State, Zip Fields */}
                                                <Stack
                                                  direction={{ xs: 'column', sm: 'row' }}
                                                  spacing={{ xs: 3, sm: 2 }}
                                                  sx={{ mb: 2 }}
                                                >
                                                  <TextField
                                                    fullWidth
                                                    label="City"
                                                    size="small"
                                                    value={data.location[i].city || ''}

                                                    // onChange={(event) => {
                                                    //   let arrayAddr = [...data.location]
                                                    //   arrayAddr[i].city = event.target.value;
                                                    //   setCart(pv => ([...pv.map(p => {


                                                    //     if (p.product_id === data.product_id) {
                                                    //       return {
                                                    //         ...p,
                                                    //         addresses: arrayAddr
                                                    //       }
                                                    //     }
                                                    //     else {
                                                    //       return {
                                                    //         ...p
                                                    //       }
                                                    //     }

                                                    //   })]))
                                                    // }}
                                                    disabled={
                                                      i !== 0 &&
                                                      data?.allRfpProductsLocationSame
                                                        ? true
                                                        : false
                                                    }
                                                    onChange={(event) => {
                                                      setCart((prevProducts) =>
                                                        prevProducts.map((p) => {
                                                          if (p.product_id === data.product_id) {
                                                            let updatedAddresses = [...p.location];
                                                            if (p.allRfpProductsLocationSame) {
                                                              updatedAddresses = updatedAddresses.map(() => ({
                                                                ...updatedAddresses[0],
                                                                city: event.target.value,
                                                              }));
                                                            } else {
                                                              updatedAddresses[i] = {
                                                                ...updatedAddresses[i],
                                                                city: event.target.value,
                                                              };
                                                            }
                                                            return {
                                                              ...p,
                                                              location: updatedAddresses,
                                                            };
                                                          }
                                                          return p;
                                                        })
                                                      );
                                                    }}
                                                  />
                                                  <TextField
                                                    fullWidth
                                                    label="State"
                                                    size="small"
                                                    value={data.location[i].state || ''}

                                                    // onChange={(event) => {
                                                    //   let arrayAddr = [...data.location]
                                                    //   arrayAddr[i].state = event.target.value;
                                                    //   setCart(pv => ([...pv.map(p => {

                                                    //     if (p.product_id === data.product_id) {
                                                    //       return {
                                                    //         ...p,
                                                    //         addresses: arrayAddr
                                                    //       }
                                                    //     }
                                                    //     else {
                                                    //       return {
                                                    //         ...p
                                                    //       }
                                                    //     }

                                                    //   })]))
                                                    // }}
                                                    disabled={
                                                      i !== 0 &&
                                                      data?.allRfpProductsLocationSame
                                                        ? true
                                                        : false
                                                    }
                                                    onChange={(event) => {
                                                      setCart((prevProducts) =>
                                                        prevProducts.map((p) => {
                                                          if (p.product_id === data.product_id) {
                                                            let updatedAddresses = [...p.location];
                                                            if (p.allRfpProductsLocationSame) {
                                                              updatedAddresses = updatedAddresses.map(() => ({
                                                                ...updatedAddresses[0],
                                                                state: event.target.value,
                                                              }));
                                                            } else {
                                                              updatedAddresses[i] = {
                                                                ...updatedAddresses[i],
                                                                state: event.target.value,
                                                              };
                                                            }
                                                            return {
                                                              ...p,
                                                              location: updatedAddresses,
                                                            };
                                                          }
                                                          return p;
                                                        })
                                                      );
                                                    }}
                                                  />
                                                  <TextField
                                                    fullWidth
                                                    label="Zip / Postal Code"
                                                    size="small"
                                                    value={data.location[i].zip || ''}

                                                    // onChange={(event) => {
                                                    //   let arrayAddr = [...data.location]
                                                    //   arrayAddr[i].zip = event.target.value;
                                                    //   setCart(pv => ([...pv.map(p => {


                                                    //     if (p.product_id === data.product_id) {
                                                    //       return {
                                                    //         ...p,
                                                    //         addresses: arrayAddr
                                                    //       }
                                                    //     }
                                                    //     else {
                                                    //       return {
                                                    //         ...p
                                                    //       }
                                                    //     }

                                                    //   })]))
                                                    // }}
                                                    disabled={
                                                      i !== 0 &&
                                                      data?.allRfpProductsLocationSame
                                                        ? true
                                                        : false
                                                    }
                                                    onChange={(event) => {
                                                      setCart((prevProducts) =>
                                                        prevProducts.map((p) => {
                                                          if (p.product_id === data.product_id) {
                                                            let updatedAddresses = [...p.location];
                                                            if (p.allRfpProductsLocationSame) {
                                                              updatedAddresses = updatedAddresses.map(() => ({
                                                                ...updatedAddresses[0],
                                                                zip: event.target.value,
                                                              }));
                                                            } else {
                                                              updatedAddresses[i] = {
                                                                ...updatedAddresses[i],
                                                                zip: event.target.value,
                                                              };
                                                            }
                                                            return {
                                                              ...p,
                                                              location: updatedAddresses,
                                                            };
                                                          }
                                                          return p;
                                                        })
                                                      );
                                                    }}
                                                  />
                                                </Stack>
                                              </Grid>
                                            ))}
                                          </Grid>


                                          <Grid container justifyContent="center" alignItems="center">
                                            <Grid item xs={12} md={4}>
                                              <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 1 }}>
                                                <LoadingButton variant="contained" onClick={() => {
                                                  setIsSaving(true)
                                                  setTimeout(() => {
                                                    setIsSaving(false)
                                                    setRfpLocationStates(false)
                                                  }, 100)
                                                }} loading={isSaving}>
                                                  {' Save '}
                                                </LoadingButton>

                                              </Box>
                                            </Grid>
                                          </Grid>
                                        </Modal>
                                      </>
                                    );
                                  })}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Scrollbar>
                          </>
                        }
                          <LabelStyleHead>Materials</LabelStyleHead>
                          {/* <Typography></Typography> */}
                          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                            {/* <Autocomplete
                              sx={{ width: 400 }}
                              multiple
                              id="combo-box-demo"
                              // options={materials || []}
                              // options={materials?.filter((option) => !selectedMaterials?.some(selected => selected.product_id === option.id)) || []}
                              options={
                                materials?.filter((option) => {
                                  // Exclude selected materials
                                  const isSelected = selectedMaterials?.some((selected) => selected.product_id === option.id);
                                  const isServiceOnly = values.project_category?.name === 'Service only';
                                  // Filter materials: show only inhouse = 1 unless it's 'Service only'
                                  const shouldInclude = isServiceOnly || option.inhouse === 1;
                                  return !isSelected && shouldInclude;
                                }) || []
                              }
                              value={selectedMaterials?.filter(item => !item?.isAdditionalProduct)}
                              onChange={(event, newValue) => {
                                handleMaterial(newValue);
                              }}
                              renderInput={(params) => (
                                <TextField {...params} label="Materials" variant="outlined" />
                              )}
                              // getOptionLabel={(option) => option.name ? option.name : option.product_name ? option.product_name : ''}
                              // getOptionLabel={(option) => {
                              //   const name = option.name || option.product_name || '';
                              //   const ownershipLabel = option.inhouse === 1 ? ' (Inhouse)' : ' (Client owned)';
                              //   return name + ownershipLabel;
                              // }}
                              getOptionLabel={(option) => {
                                console.log('optionssssssssss',option)
                                const name = option.name || option.product_name || '';
                                const description = option.description ||option.product_description || '';
                                return `${description} \u200B${name}`;
                              }}
                              isOptionEqualToValue={(option, value) => option.id === value.id}
                              renderOption={(props, option) => {
                                const description = option.description || '';
                                return (
                                  <li {...props}>
                                  <Tooltip title={description}>
                                    <span style={{
                                      display: 'inline-block',
                                      whiteSpace: 'nowrap',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      maxWidth: '300px'
                                    }}>
                                      {description}
                                    </span>
                                  </Tooltip>
                                  <span style={{ display: 'none' }}>{option.name}</span>
                                </li>
                                );
                              }}
                              filterOptions={(options, { inputValue }) =>
                                options.filter((option) => {
                                  console.log("Name:", option.name, "Description:", option.description);
                                  const searchText = inputValue.toLowerCase();
                                  return (
                                    option.name?.toLowerCase().includes(searchText) ||
                                    option.description?.toLowerCase().includes(searchText)
                                    // option.description?.toLowerCase().includes(searchText)
                                  );
                                })
                              }
                              renderTags={(value, getTagProps) =>
                                value.map((option, index) => {
                                  const suffix = option.inhouse === 1 ? '(Inhouse)' : '(Client owned)';
                                  const tooltipText = `${option.description  || ''} ${suffix}`;
                                  return(
                                       <Tooltip
                                        key={index}
                                        title={tooltipText}
                                      >
                                  <Chip
                                    {...getTagProps({ index })}
                                    label={option.description || ''}
                                  />
                                  </Tooltip>
                                )})
                              } /> */}
                              <Autocomplete
                                sx={{ width: 400 }}
                                multiple
                                id="combo-box-materials"
                                options={materials?.filter(option => {
                                  const isServiceOnly = values.project_category?.name === 'Service only';
                                  return isServiceOnly || option.inhouse === 1;
                                }) || []}
                                value={(selectedMaterials || []).filter(item => !item.isAdditionalProduct)}
                                // onChange={(event, newValue, reason, details) => {
                                //   if (reason === 'removeOption') {
                                //     const updated = selectedMaterials.filter(item =>
                                //       item.product_id !== details.option.product_id ||
                                //       item.stock_type !== details.option.stock_type ||
                                //       (item.stock_type === 2 && item.convertion_unit !== details.option.convertion_unit)
                                //     );
                                //     setSelectedMaterials(updated);
                                //     setPendingAutocompleteMaterials(updated);
                                //     setFieldValue('additionalMaterials', updated);
                                //     handleMaterial(updated);
                                //     return;
                                //   }

                                //   const lastSelected = newValue[newValue.length - 1];

                                //   if (!lastSelected) return;

                                //   // Prevent multiple partial stock selection for the same product
                                //   if (selectedMaterials.some(item =>
                                //     item.product_id === lastSelected.product_id && item.stock_type === 2
                                //   )) {
                                //     enqueueSnackbar('Partial stock already selected for this product', { variant: 'error' });
                                //     return;
                                //   }

                                //   handleMaterialStockCheck(lastSelected); // Open dialog for stock type selection
                                // }}
                                onChange={(event, newValue, reason, details) => {
  if (!newValue) return;

  // 🔹 Handle Clear All (via big 'X')
  if (reason === 'clear') {
    const onlyAdditional = selectedMaterials.filter(item => item.isAdditionalProduct === true);
    setSelectedMaterials(onlyAdditional);
    setPendingAutocompleteMaterials(onlyAdditional);
    setFieldValue('additionalMaterials', onlyAdditional);
    handleMaterial(onlyAdditional);
    // markUnsavedChanges();();
    return;
  }

  // 🔹 Handle individual remove
  if (reason === 'removeOption') {
    const updated = selectedMaterials.filter(item =>
      item.product_id !== details.option.product_id ||
      item.stock_type !== details.option.stock_type ||
      (item.stock_type === 2 && item.convertion_unit !== details.option.convertion_unit)
    );
    const additional = selectedMaterials.filter(item => item.isAdditionalProduct);
    const finalList = [...updated, ...additional];
    setSelectedMaterials(finalList);
    setPendingAutocompleteMaterials(updated);
    setFieldValue('additionalMaterials', finalList);
    handleMaterial(finalList);
    // markUnsavedChanges();();
    return;
  }

  // 🔹 Add new item
  const lastSelected = newValue[newValue.length - 1];
  if (!lastSelected) return;

  const alreadySelected = selectedMaterials.some(
    item =>
      (item.product_id || item.id) === (lastSelected.product_id || lastSelected.id) &&
      item.stock_type === lastSelected.stock_type &&
      (item.stock_type === 1 || item.convertion_unit === lastSelected.convertion_unit)
  );

  if (alreadySelected) {
    enqueueSnackbar('Material Already Added', { variant: 'error' });
    return;
  }

  handleMaterialStockCheck(lastSelected); // Show dialog
  // markUnsavedChanges();();
}}

                                getOptionLabel={(option) => {
                                const name = option.name || option.product_name || '';
                                const description = option.description || option.product_description || '';
                                const tags = option.tags || ''; 
                                const ownership = option.inhouse === 1 ? ' (Inhouse)' : ' (Client owned)';
                                return `${description}${ownership}${tags} \u200B${name}`;
                              }}
                                isOptionEqualToValue={(option, value) =>
                                  option.product_id === value.product_id &&
                                  option.stock_type === value.stock_type &&
                                  option.convertion_unit === value.convertion_unit
                                }
                                renderOption={(props, option) => {
                                  const { style, ...liProps } = props;
                                  const description = option.description || option.product_description ||option.name|| option.product_name || '';
                                  const ownership = option.inhouse === 1 ? ' (Inhouse)' : ' (Client owned)';
                                  // const stockLabel = option.stock_type === 1
                                  //   ? 'Finished'
                                  //   : `Partial - ${UNITS.find(u => u.id === option.convertion_unit)?.name || 'Unit'}`;
                                  // const fullText = `${description} ${ownership} [${stockLabel}]`;
                                  const fullText = `${description} ${ownership}`;
                                  return (
                                    <li
                                      {...liProps}
                                      style={{
                                        ...style,
                                        display: 'flex',
                                        alignItems: 'center',
                                      }}
                                    >
                                      <div style={{ display: 'flex', alignItems: 'center', width: 40, justifyContent: 'center' }}>
                                        {option?.syncWithQuickbooks === 1 && (
                                          <img
                                            src={quickbookLogo}
                                            width="40px"
                                            height="20px"
                                            // style={{ marginRight: 8 }}
                                            alt="QuickBooks"
                                          />
                                        )}
                                      </div>
                                      <Tooltip title={fullText}>
                                        <span style={{
                                          flex: 1,
                                          minWidth: 0,
                                          display: 'block',
                                          whiteSpace: 'nowrap',
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis',
                                        }}>
                                          {fullText}
                                        </span>
                                      </Tooltip>
                                    </li>
                                  );
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label="Materials"
                                    error={Boolean(touched.additionalMaterials && errors.additionalMaterials)}
                                    helperText={touched.additionalMaterials && errors.additionalMaterials}
                                  />
                                )}
                                renderTags={(value, getTagProps) =>
                                  value.map((option, index) => {
                                    const suffix = option.inhouse === 1 ? '(Inhouse)' : '(Client owned)';
                                    const stockLabel = option.stock_type === 1
                                      ? 'Finished'
                                      : `Partial - ${UNITS.find(u => u.id === option.convertion_unit)?.name || 'Unit'}`;
                                    const tooltipText = `${option.description || option.name || option.product_name || ''} ${suffix} [${stockLabel}]`;
                                    return (
                                      <Tooltip
                                        key={index}
                                        title={tooltipText}
                                      >
                                        <Chip
                                          {...getTagProps({ index })}
                                          label={`${option.description ||option.name|| option.product_name || ''} ${suffix} [${stockLabel}]`}
                                        />
                                      </Tooltip>
                                    );
                                  })
                                }
                              />

                          </Stack>
                          <LabelStyle>Selected Materials</LabelStyle>
                          <Scrollbar>
                            <TableContainer sx={{ minWidth: 500 }}>
                              <Table>
                                <TableHead>
                                  <TableRow>
                                    {VALUE_MATERIAL?.map((val,index) => (
                                      val.id === 3 ? (
                                        <Tooltip key={val.id} title="Unit Price + ((Unit Price * Markup)/100)">
                                          <TableCell key={val.id}>{val.value}</TableCell>
                                        </Tooltip>
                                      ) : val.id === 5 ? (
                                        <Tooltip key={val.id} title="Unit Price * Quantity">
                                          <TableCell key={val.id}>{val.value}</TableCell>
                                        </Tooltip>
                                      ) : val.id === 6 ? (
                                        <Tooltip key={val.id} title="Markup Cost * Quantity">
                                          <TableCell key={val.id}>{val.value}</TableCell>
                                        </Tooltip>
                                      ) : <TableCell key={val.id}>{val.value}</TableCell>
                                    ))}
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {selectedMaterials?.map((data, index) => {
                                  console.log('dataselectedMaterials', data)
                                 let unitName ='';
                                if(data?.stock_type===1){
                                unitName = UNITS?.filter((item) => item?.id == data?.unit)
                                }else{
                                unitName = UNITS?.filter((item) => item?.id == data?.convertion_unit)
                                }
                                    console.log('unitName11111111111', unitName)
                                    // unitName = unitName[0]?.name
                                    let shortUnitName = unitName[0]?.short_name
                                    // if (unitName == 'Square feet') {
                                    //   shortUnitName = 'Sq ft'
                                    // } else if (unitName == 'Linear feet') {
                                    //   shortUnitName = 'Lin ft'
                                    // } else if (unitName == 'Square Inches') {
                                    //   shortUnitName = 'Sq Inches'
                                    // } else if (unitName == 'Unit') {
                                    //   shortUnitName = 'Unit'
                                    // }else{
                                    //   shortUnitName = unitName
                                    // }
                                    // data.price = data.price ? data.price : data.product_price 
                                    data.price = data.product_price ? data.product_price : data.price 
                                    data.product_id = data.product_id ? data.product_id : data.id
                                    // data.markup =  data.markup ? data.markup : data.product_markup
                                    data.markup = data?.product_markup ||  data.markup 
                                    const markUpCost = data.price + ((parseFloat(data.price) * parseFloat(data.markup || 0)) / 100)
                                    data['markUpCost'] = parseFloat(parseFloat(markUpCost).toFixed(2)) || 0;
                                    if(data.adj_value_type == null){
                                      data['adj_value_type'] =true
                                     }
                                     const adjustmentFieldName = `adjustment_${index}`;
                                    const isNegativeMaterialAdjustmentMode =
                                      data?.adj_value_type === false ||
                                      data?.adj_value_type === 0 ||
                                      data?.adj_value_type === '0' ||
                                      data?.adj_value_type === 'false'
                                    const materialAdjustmentValue =
                                      Number(data?.adjustment) || 0
                                    const adjustedMarkupCostEach =
                                      Number(data?.markUpCost || 0) +
                                      (isNegativeMaterialAdjustmentMode
                                        ? -materialAdjustmentValue
                                        : materialAdjustmentValue)
                                    const materialFormulaEach =
                                      Number(data?.price) || 0
                                    const isLosingMoneyItem =
                                      isNegativeMaterialAdjustmentMode &&
                                      adjustedMarkupCostEach < materialFormulaEach

                                    const losingMoneyRowSx = isLosingMoneyItem
                                      ? {
                                          '& .MuiTableCell-root:not(:nth-of-type(4)), & .MuiTableCell-root:not(:nth-of-type(4)) .MuiInputBase-input, & .MuiTableCell-root:not(:nth-of-type(4)) .MuiFormLabel-root':
                                            {
                                              color: `${theme.palette.error.main} !important`,
                                            },
                                        }
                                      : undefined
                                    return (
                                      <>
                                        <TableRow key={data?.newIndexId || index} sx={losingMoneyRowSx}>
                                          <TableCell>{index + 1}</TableCell>
                                          <TableCell>
                                            <div
                                              style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: 40,
                                                height: 20,
                                              }}
                                            >
                                              {data?.syncWithQuickbooks === 1 && (
                                                <img
                                                  src={quickbookLogo}
                                                  alt="QuickBooks"
                                                  style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'contain',
                                                  }}
                                                />
                                              )}
                                            </div>
                                          </TableCell>
                                         <TableCell>{data?.isAdditionalProduct ?
                                            <TextField
                                              required
                                              fullWidth
                                              type="text"
                                              label={'Material Name'}
                                              sx={{ width: 85 }}
                                              value={materialNameDraft.getValue(
                                                data.newIndexId,
                                                data.name || data.product_name || '',
                                              )}
                                              onChange={(event) => {
                                                let newValue = event.target.value
                                                materialNameDraft.handleChange(data.newIndexId, newValue)
                                                if (isSubmitted)
                                                  setIsSubmitted(false)
                                               // markUnsavedChanges();();
                                              }}
                                              onBlur={() => materialNameDraft.commit(data.newIndexId)}
                                              error={
                                                isSubmitted &&
                                                !materialNameDraft
                                                  .getValue(data.newIndexId, data.name || data.product_name || '')
                                                  .trim()
                                              }
                                              helperText={
                                                isSubmitted &&
                                                !materialNameDraft
                                                  .getValue(data.newIndexId, data.name || data.product_name || '')
                                                  .trim()
                                                  ? 'Material Name is required'
                                                  : ''
                                              }
                                            />
                                            : (
                                              // (data.name || data.product_name)
                                            <Box>
                                              <Typography sx={{color:"inherit"}}>{data.name || data.product_name}</Typography>
                                                <Typography 
                                                sx={{ color: data.material_notes ? theme.palette.error.main : 'inherit' }}
                                              > Note:{" "}
                                               {data.material_notes && data.material_notes.trim() !== '' ? data.material_notes : ""}
                                              </Typography>
                                            </Box>
                                             )}
                                             {/* {data?.isAdditionalProduct ? '' : data.inhouse==1 ? ' (Inhouse)' : ' (Client owned)'} */}
                                             </TableCell>
                                            <TableCell>
                                              <IconButton onClick={() => handleOpenMaterialNote(data.newIndexId, data.material_notes)}>
                                                <NoteAdd
                                                  sx={{
                                                    color: (!data?.material_notes || data?.material_notes === '') ? '' : theme.palette.primary.main,
                                                  }}
                                                />
                                              </IconButton>
                                            </TableCell>
  
                                           <TableCell>{data.stock_type===1 ?"Finished":"Partial"}
                                          </TableCell>
                                         <TableCell>{data?.isAdditionalProduct ?
                                            <TextField
                                              required
                                              fullWidth
                                              type="number"
                                              label={'Unit Price'}
                                              disabled={values.project_category?.name == 'Time & Material' ? true : false}
                                              sx={{ width: 85 }}
                                              value={roundMoneyValue(data.price)}
                                              // onWheel={(e) => e.target.blur()}
                                              onKeyPress={(event) => {
                                                // if (event.key === '0' && event.target.value === '') {
                                                //   event.preventDefault();
                                                // }
                                                if (event.key === '-') {
                                                  event.preventDefault();
                                                }
                                                if (event.key === 'e') {
                                                  event.preventDefault();
                                                }
                                              }}
                                              inputProps={{ min: 0 }}
                                              defaultValue={0}
                                              onFocus={selectInputValue}
                                              onClick={selectInputValue}
                                              onChange={(event) => {
                                                let newValue = event.target.value
                                                if (newValue !== '') {
                                                  setAdditionalSelectedServices((pv) => [
                                                      ...pv.map((p) => {
                                                        if ( p.newIndexId === data.newIndexId ) {
                                                          return {
                                                            ...p,
                                                            price: Number(newValue),
                                                          }
                                                        } else {
                                                          return p
                                                        }
                                                      }),
                                                    ],
                                                  )
                                                  data['price'] =  Number(newValue || 0)
                                                }
                                                // markUnsavedChanges();();
                                              }}
                                              // error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                              // helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                            />
                                          : roundMoneyValue(data.price).toFixed(2)}</TableCell>
                                        <TableCell>
                                          <TextField
                                            required
                                            fullWidth
                                            type="number"
                                            label="Markup"
                                            value={Number(data.markup) || 0}
                                            inputProps={{ min: 0 }}
                                            onFocus={selectInputValue}
                                            onClick={selectInputValue}
                                            onKeyPress={(event) => {
                                              if (event.key === '-' || event.key === 'e') {
                                                event.preventDefault();
                                              }
                                            }}
                                            onChange={(event) => {
                                              let newValue = event.target.value;

                                              // Prevent negative values and invalid inputs
                                              if (newValue.startsWith('-') || /^0[0-9]+$/.test(newValue)) {
                                                newValue = '0';
                                              }

                                              setSelectedMaterials((prevMaterials) =>
                                                prevMaterials.map((p) => {
                                                  const isMatchingProduct = data.isAdditionalProduct
                                                    ? p.newIndexId === data.newIndexId
                                                    : (p.product_id || p.id) === (data.product_id || data.id) &&
                                                      p.stock_type === data.stock_type &&
                                                      (p.stock_type === 1 || p.convertion_unit === data.convertion_unit) &&
                                                      (p.newIndexId === data.newIndexId || (!data.isAdditionalProduct && p.id === data.id));

                                                  const isNegativeMode =
                                                    p?.adj_value_type === false ||
                                                    p?.adj_value_type === 0 ||
                                                    p?.adj_value_type === '0' ||
                                                    p?.adj_value_type === 'false';

                                                  return isMatchingProduct
                                                    ? (isNegativeMode
                                                        ? {
                                                            ...p,
                                                            markup: newValue === '' ? 0 : Number(newValue),
                                                            product_markup: newValue === '' ? 0 : Number(newValue),
                                                            adj_value_type: true,
                                                            adjustment: 0,
                                                          }
                                                        : {
                                                            ...p,
                                                            markup: newValue === '' ? 0 : Number(newValue),
                                                            product_markup: newValue === '' ? 0 : Number(newValue),
                                                          })
                                                    : p;
                                                }),
                                              );
                                              data['markup'] = newValue === '' ? 0 : Number(newValue);
                                              data['product_markup'] = newValue === '' ? 0 : Number(newValue);
                                              const isNegativeMode =
                                                data?.adj_value_type === false ||
                                                data?.adj_value_type === 0 ||
                                                data?.adj_value_type === '0' ||
                                                data?.adj_value_type === 'false';
                                              if (isNegativeMode) {
                                                data['adj_value_type'] = true;
                                                data['adjustment'] = 0;
                                                setFieldValue(adjustmentFieldName, 0);
                                              }
                                              // markUnsavedChanges();();
                                            }}
                                            onWheel={(e) => e.target.blur()}
                                          />
                                        </TableCell>

                                         {/* <TableCell>{data.markUpCost || 0}</TableCell> */}
                                         <TableCell>{(data.markUpCost + (data.adj_value_type ? Number(data.adjustment || 0) : -Number(data.adjustment || 0))).toFixed(2) || 0}</TableCell>
                                            <TableCell>
                                              <TextField
                                                required
                                                fullWidth
                                                type='number'
                                                label={shortUnitName || 'Quantity'}
                                                value={Number(data.quantity) || 0}
                                                defaultValue={1}
                                                onFocus={selectInputValue}
                                                onClick={selectInputValue}
                                                onKeyPress={(event) => {
                                                  if (event.target.value === '') {
                                                    event.preventDefault();
                                                  }
                                                  if (event.key === '-' || event.key === 'e') {
                                                    event.preventDefault();
                                                  }
                                                }}
                                                onChange={(event) => {
                                                  const newValue = Number(event.target.value) || 0;

                                                  setSelectedMaterials((prevMaterials) =>
                                                    prevMaterials.map((p) => {
                                                      const isMatchingProduct = data.isAdditionalProduct
                                                        ? p.newIndexId === data.newIndexId
                                                        : (p.product_id || p.id) === (data.product_id || data.id) &&
                                                          p.stock_type === data.stock_type &&
                                                          (p.stock_type === 1 || p.convertion_unit === data.convertion_unit) &&
                                                          (p.newIndexId === data.newIndexId || (!data.isAdditionalProduct && p.id === data.id));

                                                      if (isMatchingProduct) {
                                                        return {
                                                          ...p,
                                                          quantity: newValue,
                                                        };
                                                      }
                                                      return p;
                                                    }),
                                                  );
                                                  // markUnsavedChanges();();
                                                }}
                                                onWheel={(e) => e.target.blur()}
                                                onKeyDown={(event) => {
                                                  if (event.key === 'ArrowDown' && Number(event.target.value) <= 1) {
                                                    event.preventDefault();
                                                  }
                                                }}
                                              />
                                            </TableCell>
                                          <TableCell>
                                            <Stack direction="row" spacing={1} alignItems="center">
                                              <Remove
                                                fontSize="small"
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => {
                                                  const hasPermission = explodedPermissions?.some((permission) =>
                                                    ['Allow Negative Marketing Adjustment Estimate'].includes(permission),
                                                  )
                                                  // if (!hasPermission) {
                                                  //   return enqueueSnackbar('Access Denied : You do not have Suffient Permission', { variant: 'error' })
                                                  // }
                                                  // const formulaEach = Number(data.markUpCost)
                                                  // const retailEachBase = Number(data.price)
                                                  const formulaEach = Number(data.price)
                                                  const retailEachBase = Number(data.markUpCost)
                                                  if (retailEachBase <= formulaEach && !hasPermission) {
                                                    return enqueueSnackbar(
                                                      'To apply a negative marketing adjustment, Markup Cost Each must be higher than Unit Price.',
                                                      { variant: 'error' },
                                                    )
                                                  }
                                                  const maxNegative = getMaterialMaxNegativeAdjustment(data, hasPermission);
                                                  const adjustment = Number(data?.adjustment) || 0;
                                                  // console.log('aaaaaaaaaaaaaa', data?.adjustment);
                                                  // console.log('aaaaaaaaaaaaaa', adjustment);
                                                  // console.log('aaaaaaaaaaaaaa', maxNegative);

                                                  if (Number(adjustment) >= maxNegative && hasPermission) {
                                                    return enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
                                                  } else if (Number(adjustment) > maxNegative && !hasPermission) {
                                                    return enqueueSnackbar(
                                                      `Negative Adjustment Amount cannot reduce total below Product Unit Price. Max allowed: $${maxNegative}`,
                                                      { variant: 'error' }
                                                    );
                                                  }
                                                  const newValue = false
                                                  setSelectedMaterials((prevMaterials) =>
                                                    prevMaterials.map((p) => {
                                                      if (prevMaterials.newIndexId === data.newIndexId) {
                                                        return {
                                                          ...p,
                                                          adj_value_type: newValue,
                                                        };
                                                      }
                                                      return p;
                                                    }),
                                                  )
                                                  data['adj_value_type'] = newValue
                                                  // setFieldValue('manager_approval_required', true)
                                                  // markUnsavedChanges();
                                                }}
                                              />
                                              <FormControlLabel
                                                control={
                                                  <Switch
                                                    checked={data.adj_value_type}
                                                    onChange={(event) => {
                                                      const newValue = event.target.checked
                                                      const hasPermission = explodedPermissions?.some((permission) =>
                                                        ['Allow Negative Marketing Adjustment Estimate'].includes(permission),
                                                      )
                                                      // if (!hasPermission && newValue === false) {
                                                      //   return enqueueSnackbar('Access Denied : You do not have Suffient Permission', { variant: 'error' })
                                                      // }
                                                      const maxNegative = getMaterialMaxNegativeAdjustment(data, hasPermission);
                                                      if (newValue === false) {
                                                        const formulaEach = Number(data?.price)
                                                        const retailEachBase = Number(data.markUpCost)
                                                        if (retailEachBase <= formulaEach && !hasPermission) {
                                                          return enqueueSnackbar(
                                                            'To apply a negative marketing adjustment, Markup Cost Each must be higher than Unit Price.',
                                                            { variant: 'error' },
                                                          )
                                                        }
                                                      }
                                                      const adjustment = Number(data.adjustment) || 0;
                                                      if (Number(adjustment) >= maxNegative && newValue === false && hasPermission) {
                                                        return enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
                                                      } else if (Number(adjustment) > maxNegative && newValue === false && !hasPermission) {
                                                        return enqueueSnackbar(
                                                          `Negative Adjustment Amount cannot reduce total below Product Unit Price. Max allowed: $${maxNegative}`,
                                                          { variant: 'error' }
                                                        );
                                                      }

                                                      setSelectedMaterials((prevMaterials) =>
                                                        prevMaterials.map((p) => {
                                                          if (prevMaterials.newIndexId === data.newIndexId) {
                                                            return {
                                                              ...p,
                                                              adj_value_type: newValue,
                                                            };
                                                          }
                                                          return p;
                                                        }),
                                                      )
                                                      data['adj_value_type'] = newValue
                                                      if (newValue === false) {
                                                        // setFieldValue('manager_approval_required', true)
                                                      }
                                                      // markUnsavedChanges();
                                                    }}
                                                  />
                                                }
                                                label=""
                                              />
                                              <Add
                                                fontSize="small"
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => {
                                                  const newValue = true
                                                  setSelectedMaterials(
                                                    (prevProducts) =>
                                                      prevProducts.map(
                                                        (product) => {
                                                          if (
                                                            product.newIndexId ===
                                                            data.newIndexId
                                                          ) {
                                                            return {
                                                              ...product,
                                                              adj_value_type: newValue,
                                                            }
                                                          }
                                                          return product
                                                        },
                                                      ),
                                                  )
                                                  data['adj_value_type'] = newValue
                                                  // markUnsavedChanges();
                                                }}
                                              />
                                            </Stack>
                                          </TableCell>
                                          <TableCell>
                                            <TextField
                                              type="number"
                                              inputProps={{ min: 0 }}
                                              // label={
                                              //   data.markAdjType === 2
                                              //     ? '$'
                                              //     : data.markAdjType === 3
                                              //     ? '¢'
                                              //     : '%'
                                              // }
                                              label='$'
                                              InputLabelProps={{ shrink:data.adjustment!=null ? true : false }}
                                              value={data.adjustment ?
                                                Number(data.adjustment) ||
                                                null : ''
                                              }
                                              onWheel={(e) => e.target.blur()}
                                              // onBeforeInput={(e) => {
                                              //   // const char = e.data; // next typed character
                                              //   // const nextValue = e.target.value + char;
                                              //   const inputElement = e.target;
                                              //   const nextValue = inputElement.value;

                                              //   const maxNegative = getMaterialMaxNegativeAdjustment(data);
                                              //   console.log('getMaxNegativeAdjustment1-maxNegative--maxNegative1',maxNegative);
                                              //   console.log('getMaxNegativeAdjustment1-maxNegative--nextValue',nextValue);


                                              //   if (Number(nextValue) > maxNegative && (data.adj_value_type === false || data.adj_value_type === 0)) {
                                              //     e.preventDefault(); // ← stops the key BEFORE appearing
                                              //     enqueueSnackbar(
                                              //       `1 Negative Adjustment Amount cannot reduce total below Product Unit Price. Max allowed: $${maxNegative.toFixed(2)}`,
                                              //       { variant: "error" }
                                              //     );
                                              //   }
                                              // }}
                                              onBeforeInput={(e) => {
                                                // const char = e.data; // next typed character
                                                // const nextValue = e.target.value + char;
                                                const inputElement = e.target;
                                                const nextValue = inputElement.value; 
                                            const hasPermission = explodedPermissions?.some((permission) => ['Allow Negative Marketing Adjustment Estimate'].includes(permission));
                                                const maxNegative = getMaterialMaxNegativeAdjustment(data, hasPermission);
                                                if (Number(nextValue) >= maxNegative && (data.adj_value_type === false || data.adj_value_type === 0) && hasPermission) {
                                                  e.preventDefault();
                                                  enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
                                                } else if (Number(nextValue) > maxNegative && (data.adj_value_type === false || data.adj_value_type === 0) && !hasPermission) {
                                                  e.preventDefault(); // ← stops the key BEFORE appearing
                                                  enqueueSnackbar(
                                                    `Negative Adjustment Amount cannot reduce total below Product Formula Cost. Max allowed: $${maxNegative}`,
                                                    { variant: "error" }
                                                  );
                                                }
                                              }}

                                              onChange={(event) => {
                                                let newValue = event.target.value
                                                const hasPermission = explodedPermissions?.some((permission) => ['Allow Negative Marketing Adjustment Estimate'].includes(permission));
                                                const maxNegative = getMaterialMaxNegativeAdjustment(data, hasPermission);
                                                if (Number(newValue) >= maxNegative && (data.adj_value_type === false || data.adj_value_type === 0) && hasPermission) {
                                                  enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
                                                  return;
                                                } else if (Number(newValue) > maxNegative && (data.adj_value_type === false || data.adj_value_type === 0) && !hasPermission) {
                                                  enqueueSnackbar(
                                                    `Negative Adjustment Amount cannot reduce total below Product Unit Price. Max allowed: $${maxNegative}`,
                                                    { variant: 'error' }
                                                  );

                                                  return;
                                                }
                                                console.log('getMaxNegativeAdjustment1-maxNegative--adj_value_type2', data.adj_value_type);
                                                const numValue = parseFloat(newValue) || 0
                                                if (numValue < 0) {
                                                  newValue = 0
                                                } else {
                                                  newValue = String(numValue)
                                                }
                                                // Allow only two decimal places
                                                if (
                                                  newValue.includes('.')
                                                ) {
                                                  const parts =
                                                    newValue.split('.')
                                                  if (parts[1].length > 2) {
                                                    newValue = `${parts[0]
                                                      }.${parts[1].slice(
                                                        0,
                                                        2,
                                                      )}`
                                                  }
                                                }
                                                data['adjustment'] =
                                                  newValue
                                                setFieldValue(
                                                  adjustmentFieldName,
                                                  newValue,
                                                );
                                                setRefreshCalculation(!refreshCalculation)
                                                // markUnsavedChanges();
                                              }}
                                              onKeyDown={(event) => {
                                                if (
                                                  event.key === '-' ||
                                                  event.key === '+'
                                                ) {
                                                  event.preventDefault()
                                                }
                                                // Prevent arrow down key when value is 0 or would go negative
                                                if (event.key === 'ArrowDown') {
                                                  const inputValue = event.target.value
                                                  const currentValue = parseFloat(inputValue) || 0
                                                  const step = parseFloat(event.target.step) || 1
                                                  if (currentValue - step < 0) {
                                                    event.preventDefault()
                                                  }
                                                }
                                              }}
                                              error={Boolean(
                                                touched[
                                                adjustmentFieldName
                                                ] &&
                                                errors[
                                                adjustmentFieldName
                                                ],
                                              )}
                                              helperText={
                                                touched[
                                                adjustmentFieldName
                                                ] &&
                                                errors[adjustmentFieldName]
                                              }
                                            />
                                          </TableCell>
                                         {/* <TableCell>{(data.price*(data.quantity||0))?.toFixed(2)}</TableCell>
                                         <TableCell>{((data.markUpCost || 0) * (data.quantity||0))?.toFixed(2)}</TableCell> */}
                                          <TableCell>
                                            {(
                                              (data.markUpCost + (data.adj_value_type ? Number(data.adjustment || 0) : -Number(data.adjustment || 0))) * (data.quantity || 0)
                                            )?.toFixed(2)}
                                          </TableCell>
                                          <TableCell >
                                            <IconButton onClick={() => handleDeleteMaterial(data.id, data.newIndexId)}>
                                              <Delete />
                                            </IconButton>
                                          </TableCell>
                                        </TableRow>
                                        <Modal
  open={openMaterialNote[data.newIndexId] || false}
  handleClose={() => handleCloseMaterialNote(data.newIndexId)}
>
  <Grid container spacing={3} sx={{ justifyContent: 'center', width: '100%' }}>
    <Grid item xs={12}>
      <Typography variant="h5" sx={{ mb: 2 }}>Note</Typography>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }} sx={{ mb: 2 }}>
        <TextField
          fullWidth
          multiline
          rows={4}
          size="medium"
          value={currentNote}
          onChange={handleNoteChange}
          sx={{
            '& .MuiInputBase-input': {
              color: 'red',
            },
          }}
          error={!currentNote.trim() && currentNote.length > 0}
          inputProps={{ maxLength: MAX_CHARACTERS }}
          helperText={
            !currentNote.trim() && currentNote.length > 0
              ? 'Note cannot be empty or contain only spaces'
              : `${currentNote.length}/${MAX_CHARACTERS} characters`
          }
        />
      </Stack>
    </Grid>
  </Grid>
  <Grid container justifyContent="center" alignItems="center">
    <Grid item xs={12} md={4}>
      <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 1 }}>
        <LoadingButton
          variant="contained"
          onClick={() => handleSaveMaterialNote(data.newIndexId)}
          loading={isSavingNote}
          disabled={!currentNote.trim()}
        >
          Save
        </LoadingButton>
        <LoadingButton
          variant="outlined"
          color="error"
          onClick={() => handleClearMaterialNote(data.newIndexId)}
          loading={isClearingNote}
          disabled={!currentNote.trim()}
        >
          Clear
        </LoadingButton>
      </Box>
    </Grid>
  </Grid>
</Modal>
                                      </>
                                    );
                                  })}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Scrollbar>
                          <Stack sx={{ justifyContent: 'flex-end', alignItems: 'center', display:'flex', flexDirection:'row' }}>
                            {/* <Button
                              variant="outlined"
                              startIcon={
                                <Stack>
                                  {' '}
                                  <Add />{' '}
                                </Stack>
                              }
                              onClick={() => {
                                addNewMaterialRow()
                                // setMarkupType(1)
                              }}
                            >
                              Add Material Row
                            </Button> */}
                            <Typography variant="h6">
                              Total Additional Material Cost:{' '}
                              ${fUSPrice(selectedMaterialSubTotal)}
                            </Typography>
                          </Stack>
                      </>
                      {/* )} */}
                        <Divider />
                        <DraftTextField
                        fullWidth
                        multiline
                        minRows={3}
                        maxRows={7}
                        label="Notes"
                        name="notes"
                        fieldName="notes"
                        externalValue={values.notes || ''}
                        resetToken={id}
                        onDraftChange={updateTopLevelDraft}
                        onCommit={commitTopLevelField}
                        onBlurCommit={markTopLevelFieldTouched}
                        charCounterMax={MAX_CHARACTERS}
                        inputProps={{
                          maxLength: MAX_CHARACTERS,
                        }}
                        InputProps={{
                          sx: {
                            color: 'error.main',
                          }
                        }}
                      />
                      </> }
                      {/* Discount hidden — restore when needed
                      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }} justifyContent={'space-between'}>
                        <TextField
                          fullWidth
                          // sx={{ width: 400 }}
                          type='number'
                          onKeyPress={(event) => {
                            if (event.key === '-') {
                              event.preventDefault();
                            }
                          }}
                          onChange={(event) => {
                            let newValue = event.target.value
                            let data = 0
                            if(markupType === 1){
                              data = totalWholesalePrice - budget
                            }else if(markupType === 2){
                              data = totalRetailPrice - budget
                            }
                            console.log("extradiscount---data",data)
                            console.log("extradiscount---totalWholesalePrice",totalWholesalePrice)
                            console.log("extradiscount---totalRetailPrice",totalRetailPrice)
                            console.log("extradiscount---budget",budget)
                            if (Number(newValue) > data) {
                              newValue = data?.toFixed(2);
                            }
                            if (newValue === '-0.00') {
                              newValue = 0;
                            }
                            console.log('newValue-2-------',newValue);
                            setFieldValue('invoice_discount', newValue)
                            // markUnsavedChanges();();
                          }}
                          label={hasDiscountPermission ? "Discount (Access Denied)" : "Discount"}
                          disabled = {hasDiscountPermission}
                          value={values.invoice_discount}
                          // {...getFieldProps('invoice_discount')}
                          error={Boolean(touched.invoice_discount && errors.invoice_discount)}
                          helperText={touched.invoice_discount && errors.invoice_discount}
                          inputProps={{ max: (markupType === 1) ? totalWholesalePrice - budget : ((markupType === 2) ? totalRetailPrice - budget : 0) , min: 0 }}
                        />
                      */}
                        {/* <Autocomplete
                          // sx={{ width: 400 }}
                          fullWidth
                          id="combo-box-demo"
                          disabled={true}
                          options={taxCategories || []}
                          value={selectedTaxCategory || null}
                          onChange={(event, newValue) => {
                            setSelectedTaxCategory(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField {...params} label="Tax category" />
                          )}
                          getOptionLabel={(option) => option.name ? option.name : ''}
                        /> */}
                      {/* </Stack> */}
                      <Stack direction={{ xs: 'column', sm: 'row' }} alignItems={'flex-start'} spacing={{ xs: 2, sm: 2 }} sx={{ mb: 2 }}>
                        <TextField
                          fullWidth
                          multiline
                          minRows={3}
                          maxRows={7}
                          label="Bill To"
                          placeholder="Enter billing address"
                          name="bill_to"
                          value={billToInputValue || ''}
                          onChange={(event) => {
                            const nextValue = event.target.value;
                            setIsBillToDirty(true);
                            setBillToInputValue(nextValue);
                            setFieldValue('bill_to', nextValue, false);
                          }}
                          onBlur={(event) => setFieldValue('bill_to', event.target.value, false)}
                        />
                        <TextField
                          fullWidth
                          multiline
                          minRows={3}
                          maxRows={7}
                          label="Ship To"
                          placeholder="Enter shipping address"
                          name="ship_to"
                          value={shipToInputValue || ''}
                          onChange={(event) => {
                            const nextValue = event.target.value;
                            setIsShipToDirty(true);
                            setShipToInputValue(nextValue);
                            setFieldValue('ship_to', nextValue, false);
                          }}
                          onBlur={(event) => setFieldValue('ship_to', event.target.value, false)}
                        />
                      </Stack>
                      <Typography sx={{ color: theme.palette.error.main }}>**All values in the software are rounded to two decimal places in accordance with standard US calculation practices.</Typography>
                      <Stack direction={{ xs: 'column', sm: 'row' }} alignItems={'center'} spacing={{ xs: 3, sm: 2 }}>
                        <Stack>
                          {/* <TextField
                            sx={{ width: 400 }}
                            type='number'
                            onChange={(event, newValue) => setFieldValue('invoice_discount', newValue)}
                            label="Extra Discount"
                            {...getFieldProps('invoice_discount')}
                            error={Boolean(touched.invoice_discount && errors.invoice_discount)}
                            helperText={touched.invoice_discount && errors.invoice_discount}
                          /> */}

                          {/* <Typography sx={{ color: 'text.secondary' }}>Sub Total: {rfqSubTotal ? rfqSubTotal?.toFixed(2) : 0}</Typography>
                          <Typography sx={{ color: 'text.secondary' }}>Service cost in Product Formula: {initialServiceCostInProductFormula ? initialServiceCostInProductFormula?.toFixed(2) : 0}</Typography>
                          <Typography sx={{ color: 'text.secondary' }}>Total ({rfqSubTotal?.toFixed(2)} - {initialServiceCostInProductFormula?.toFixed(2)}): {totalsum ? totalsum?.toFixed(2) : 0}</Typography> */}
                            <Typography >
                              Sub Total: {totalsum ? fUSPrice(totalsum) : fUSPrice(0)}
                            </Typography>
                            {isRushFeeChecked && (
                              <Typography>
                                Rush Fee: {fUSPrice(calcRushFeeAmount({
                                  enabled: true,
                                  subtotal: totalsum > 0 ? totalsum : (invoice?.sub_total || 0),
                                  percentage: Number(data?.rush_fee_percentage) || 0,
                                  storedAmount: values?.rush_fee_amount || details?.rush_fee_amount,
                                  preferStored: !openEdit
                                }))}
                              </Typography>
                            )}
                            {/* <Typography >
                              Tax: {parseFloat(taxAmount).toFixed(2) || 0.00}
                            </Typography> */}
                             <Box display="flex" alignItems="center" gap={1}>
                                 <Typography>
                                   Tax: {parseFloat(taxAmount).toFixed(2) || '0.00'}
                                 </Typography>
                                  {/* {
                                details?.avalara_code ? ( */}
                              <>
                                 <img
                                   src={AVALARALOGO}
                                   width="20px"
                                   height="12px"
                                   style={{ marginTop: '2px' }} // Adjust for alignment if needed
                                   alt="Avalara logo"
                                 />
                                  <Typography sx={{ marginTop: '8px',color:"#fd6400",fontSize:"12px"}}>
                                                Synced with Avalara
                                   </Typography>
                                  </>
{/* // ):""} */}
                               </Box>

                            <Typography sx={{ color: theme.palette.mode === 'light' ? '#FFAF00' : 'yellow' }}>
                              Grand Total: {fUSPrice(grandTotal  || 0)}
                            </Typography>
                          {/* <Typography sx={{ color: 'yellow' }}>Grand Total : {totalsum ? totalsum?.toFixed(2) : 0}</Typography>  */}
                          {/* <Typography sx={{ color: 'yellow' }}>Total Product Formula Cost: {budget ? budget?.toFixed(2) : 0}</Typography>  */}
                          {/* Discount hidden — restore when needed
                          <Typography >Total Discount: {DiscountTotal ? DiscountTotal?.toFixed(2) : 0.00}</Typography>
                          */}

                          {/* <Tooltip title="Sub Total - Total Product Formula Cost">
                            <Typography sx={{ cursor:'pointer' }}>Total Markup Amount: {totalMarkupAmount ? totalMarkupAmount?.toFixed(2) : 0}</Typography>
                          </Tooltip> */}

                          {/* <Tooltip title="(Total Markup Amount / Total Product Formula Cost) * 100">
                            <Typography sx={{cursor:'pointer' }}>Total Markup Percentage: {totalMarkupPercentage ? totalMarkupPercentage?.toFixed(2) : 0}</Typography>
                          </Tooltip> */}

                          {/* <Typography sx={{ color: 'text.secondary' }}>Total Product Markup: {(originaltotalMarkup/selectedProducts.length)?.toFixed(2)}</Typography> */}
                         {/* { showServices ?<Typography sx={{ color: 'text.secondary' }}>Total Service Markup: {(originaltotalServiceMarkup/(selectedServices.length+additionalSelectedServices.length))?.toFixed(2)}</Typography>:""} */}
                        </Stack> 
                        <Stack direction={'column'} display={'flex'} justifyContent={'center'}>                    
                        <FormControlLabel
                           onChange={() => {                                           
                          // Toggle the value of welcome_message using setCurrentRFQdata
                            setCurrentRFQdata((prevData) => ({
                              ...prevData,
                              welcome_message: !prevData.welcome_message,
                            }));
                            // markUnsavedChanges();();
                          }}
                          control={<Switch  {...getFieldProps('welcome_message')} color="primary" 
                          checked={values.welcome_message == 1}
                          />}         
                          labelPlacement="end"
                          label="Use Custom Welcome Message"
                          sx={{ mt: 6 ,mb:2}}
                        />
                        {/* {((!details?.estimate_job_status || details?.estimate_job_status != 3)) ? '' : (details?.is_draft === 1 && details?.quotation_status === 1) ? '' : */}
                        {(details?.is_draft === 1 && details?.quotation_status === 1) ? '' :
                        <FormControlLabel
                          control={
                            <Switch
                            {...getFieldProps('client_approve')}
                              color="primary"
                              checked={values.client_approve}
                              onChange={(event) => setFieldValue('client_approve', event.target.checked)}
                            />
                          }
                          labelPlacement="end"
                          label="Enable for Client Approval"
                          sx={{ mt: 0 }}
                        />}
                        {/* Manager approval toggle hidden — regular estimates have no manager flow;
                            estimate jobs use EditEstimateJob toggle only. */}
                        {/* {(details?.is_draft === 1 && details?.quotation_status === 1)  ? '' :
                          <FormControlLabel
                            control={
                              <Switch
                                {...getFieldProps('manager_approval_required')}
                                color="primary"
                                checked={values.manager_approval_required}
                                onChange={(event) => {
                                  setFieldValue('manager_approval_required', event.target.checked);
                                }}
                              />
                            }
                            labelPlacement="end"
                            label="Enable for Manager approval"
                            sx={{ mt: 0 }}
                          />
                        } */}
                         <FormControlLabel
                          control={
                            <Switch
                            {...getFieldProps('show_install_price')}
                              color="primary"
                              checked={values.show_install_price == 0 ? false : true}
                              onChange={(event) => setFieldValue('show_install_price', event.target.checked ? 1 : 0)}
                            />
                          }
                          labelPlacement="end"
                          label="Show Install Price"
                          sx={{ mt: 2 }}
                        />
                        <FormControlLabel
                          control={
                            <Switch
                              color="primary"
                              checked={isRushFeeChecked}
                              disabled={rushFeeSwitchDisabled}
                              onChange={(event) => {
                                if (rushFeeSwitchDisabled) return;
                                if (isRushFeeAutoLockedForEffect && !canOverrideRushFeeLock) return;
                                const turningOff = !event.target.checked;
                                markRushFeeUserToggled(rushFeeSyncRefs.current, {
                                  turnedOn: event.target.checked,
                                  declinedWhileLocked: turningOff && isRushFeeAutoLockedForEffect && canOverrideRushFeeLock,
                                });
                                setFieldValue('rush_fee', event.target.checked ? 1 : 0);
                              }}
                            />
                          }
                          labelPlacement="end"
                          // label={`Rush Fee (${Number(data?.rush_fee_percentage) || 0}%)`}
                          label={
                            rushFeeAccessDenied
                              ? 'Rush Fee (Access Denied)'
                              : 'Rush Fee'
                          }
                          sx={{ mt: 2 }}
                        />
                        </Stack>  
                      </Stack>
                      {values.welcome_message == true &&(
                        <>
                      <Stack>
                        <LabelStyle>Subject</LabelStyle>
                          <DraftTextField
                            //   fullWidth
                            type='text'
                            sx={{ width: 400 }}
                            name="subject"
                            fieldName="subject"
                            externalValue={values.subject || ''}
                            resetToken={id}
                            onDraftChange={updateTopLevelDraft}
                            onCommit={commitTopLevelField}
                            onBlurCommit={markTopLevelFieldTouched}
                          />
                      </Stack>
                      <LabelStyle>Email Content</LabelStyle>
                      <DraftTextField
                        fullWidth
                        multiline
                        minRows={3}
                        maxRows={7}
                        label="Email Content"
                        name="email_content"
                        fieldName="email_content"
                        externalValue={values.email_content || ''}
                        resetToken={id}
                        onDraftChange={updateTopLevelDraft}
                        onCommit={commitTopLevelField}
                        onBlurCommit={markTopLevelFieldTouched}
                      />
                      </>
                      )}
                      {/* <LabelStyle>Request state</LabelStyle>
                      <Typography>While in draft mode, clients you add to request tasks won't be notified</Typography>
                      <FormControlLabel
                       onChange={() => {                     
                       
                        setCurrentRFQdata((prevData) => ({
                          ...prevData,
                          draft: !prevData.draft,
                        }));
                      }}
                        control={<Switch {...getFieldProps('draft')} color="primary" checked={values.draft} />}
                        labelPlacement="end"
                        label="Draft"
                        sx={{ mt: 5 }}
                      /> */}
                     </>
                  :""   }
                      <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                        {true ? ( // showUpdateRequestAndSaveEstimateButtons
                          <>
                          {
                            hasEstimateWriteRows ?
                            <Button variant="contained" onClick={() => setOpenUpdateRequestConfirm(true)}>
                              Update Request
                            </Button>
                            : ""
                          }
                            {!hasEstimateWriteRows && (
                              <LoadingButton
                                variant="contained"
                                loading={isSubmitting}
                                disabled={!!autoSavingField}
                                onClick={() => setOpenSaveEstimateConfirm(true)}
                              >
                                Save Estimate
                              </LoadingButton>
                            )}
                          </>
                        ) : (
                          <LoadingButton type="submit" variant="contained" loading={isSubmitting} disabled={!!autoSavingField}>
                            Update Estimate
                          </LoadingButton>
                        )}
                        <LoadingButton
                          type="button"
                          variant="outlined"
                          loading={isSubmitting}
                          onClick={handleSaveDraft}
                          disabled={!!autoSavingField}
                        >
                          Save as Draft
                        </LoadingButton>
                        {/* <Button variant="outlined"  onClick={() =>{
                          setOpenPreview(!openPreview),
                          setValuesToPreview() }}>
                          Preview
                        </Button> */}
                        <Button
                          variant="outlined"
                          disabled={!!autoSavingField}
                          onClick={() => {
                            // No auto-save on Cancel – exit edit (with design-convert no-job confirm when needed).
                            handleCancelClick();
                          }}
                        >
                          Cancel
                        </Button>
                        <Dialog
                          open={openUpdateRequestConfirm}
                          onClose={() => setOpenUpdateRequestConfirm(false)}
                          aria-labelledby="update-request-confirm-title"
                          aria-describedby="update-request-confirm-description"
                        >
                          <DialogTitle id="update-request-confirm-title">
                            Confirm Update Request
                          </DialogTitle>
                          <DialogContent>
                            <DialogContentText id="update-request-confirm-description">
                            Are you sure you want to update this request? This will Reopens the Job.
                            </DialogContentText>
                          </DialogContent>
                          <DialogActions>
                            <Button onClick={() => setOpenUpdateRequestConfirm(false)}>
                              Cancel
                            </Button>
                            <LoadingButton
                              variant="contained"
                              loading={isSubmitting}
                              onClick={() => {
                                setOpenUpdateRequestConfirm(false);
                                handleUpdateRequest();
                              }}
                            >
                              Confirm
                            </LoadingButton>
                          </DialogActions>
                        </Dialog>
                        <Dialog
  open={openSaveEstimateConfirm}
  onClose={() => setOpenSaveEstimateConfirm(false)}
  aria-labelledby="save-estimate-confirm-title"
  aria-describedby="save-estimate-confirm-description"
>
  <DialogTitle id="save-estimate-confirm-title">
    Confirm Save Estimate
  </DialogTitle>
  <DialogContent>
    <DialogContentText id="save-estimate-confirm-description">
      Are you sure you want to save this estimate?
      This will not Reopen the Job.
    </DialogContentText>
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setOpenSaveEstimateConfirm(false)}>
      Cancel
    </Button>
    <LoadingButton
      variant="contained"
      loading={isSubmitting}
      onClick={() => {
        setOpenSaveEstimateConfirm(false);
        handleSubmitWithDraftFlush();

      }}
    >
      Confirm
    </LoadingButton>
  </DialogActions>
</Dialog>

                      </Box>
                    </Stack>
                  </Card>
                </Grid>
              </Grid>
            <DialogAnimate open={openPDFModal} onClose={() => setOpenPDFModal(false)}>
              <Card
                sx={{
                  p: 3,
                  maxWidth: 768,
                  margin: 'auto',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <div style={{ width: '90%', display: 'flex', justifyContent: 'flex-end', marginBottom: '15px', marginLeft: '25px' }}>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => {
                      const fileExt = selectedPDF?.split('/').pop()?.split('?')[0]?.split('.').pop()?.toLowerCase();
                      const isOfficeFile = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'csv'].includes(fileExt);
                      const isDesign = ['ai', 'psd', 'eps', 'dwg', 'dxf', 'tif', 'tiff', 'bmp'].includes(fileExt);

                      // Get user data from localStorage (same as UploadMultiFile)
                      const user = JSON.parse(localStorage.getItem('user'));
                      const isClient = user?.isClient;
                      const userType = isClient ? 3 : user?.user_type;

                      if (isClient || userType === 3) {
                        const newWindow = window.open('', '_blank');
                        let viewerUrl = selectedPDF;
                        if (isOfficeFile) {
                          viewerUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(selectedPDF)}`;
                        } else if (isDesign || fileExt === 'pdf') {
                          viewerUrl = `https://docs.google.com/gview?url=${encodeURIComponent(selectedPDF)}&embedded=true&toolbar=0&navpanes=0&scrollbar=0`;
                        }

                        newWindow.document.write(`
                          <html>
                            <head>
                              <title>File Viewer</title>
                              <style>
                                body { margin: 0; padding: 0; overflow: hidden; }
                                iframe { width: 100vw; height: 100vh; border: none; }
                              </style>
                            </head>
                            <body>
                              <iframe src="${viewerUrl}" title="File Viewer" sandbox="allow-scripts allow-same-origin"></iframe>
                            </body>
                          </html>
                        `);
                        newWindow.document.close();
                      } else {
                        if (isOfficeFile) {
                          window.open(`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(selectedPDF)}`, '_blank');
                        } else if (isDesign) {
                          window.open(`https://docs.google.com/gview?url=${encodeURIComponent(selectedPDF)}&embedded=true`, '_blank');
                        } else {
                          window.open(selectedPDF, '_blank');
                        }
                      }
                    }}
                    disabled={!selectedPDF}
                    startIcon={<Icon icon={filePdfIcon} width={20} height={20} />}
                    sx={{
                      fontSize: '14px',
                    }}
                  >
                    {(() => {
                      const fileExt = selectedPDF?.split('/').pop()?.split('?')[0]?.split('.').pop()?.toLowerCase();
                      if (fileExt === 'pdf') return 'View PDF';
                      if (['jpg', 'jpeg', 'png', 'gif', 'svg', 'webp'].includes(fileExt)) return 'View Image';
                      return 'View File';
                    })()}

                  </Button>
                </div>
                {pdfLoading && (
                  <Skeleton variant="rectangular" width="100%" height={500} />
                )}
                {(() => {
                  if (!selectedPDF) return null;
                  const fileExt = selectedPDF.split('/').pop()?.split('?')[0]?.split('.').pop()?.toLowerCase();
                  const isOfficeFile = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'csv'].includes(fileExt);
                  const isGoogleViewFile = ['ai', 'psd', 'eps', 'dwg', 'dxf', 'pdf', 'tif', 'tiff', 'bmp'].includes(fileExt);
                  const isImage = ['jpg', 'jpeg', 'png', 'gif', 'svg', 'webp'].includes(fileExt);

                  if (isImage) {
                    return (
                      <img
                        src={selectedPDF}
                        alt="Preview"
                        style={{ maxWidth: '100%', maxHeight: '500px', objectFit: 'contain', display: pdfLoading ? 'none' : 'block' }}
                        onLoad={() => setPdfLoading(false)}
                      />
                    );
                  }

                  let src = selectedPDF;
                  if (isOfficeFile) {
                    src = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(selectedPDF)}`;
                  } else if (isGoogleViewFile) {
                    src = `https://docs.google.com/gview?url=${encodeURIComponent(selectedPDF)}&embedded=true&toolbar=0&navpanes=0&scrollbar=0`;
                  }

                  return (
                    <iframe
                      src={src}
                      title="Selected File"
                      width="100%"
                      height="500px"
                      frameBorder="0"
                      sandbox="allow-scripts allow-same-origin"
                      style={{ display: pdfLoading ? 'none' : 'block' }}
                      onLoad={() => setPdfLoading(false)}
                      onError={() => {
                        setPdfLoading(false);
                      }}
                    />
                  );
                })()}

              </Card>
            </DialogAnimate>
            </Form>
          </FormikProvider>
        )}
        {!openEdit && (
          <>
            <Stack direction={'row'} display={'flex'} alignItems={'center'}  spacing={{ xs: 3, sm: 2 }} sx={{overflow:'scroll',overflowY:'hidden',scrollbarWidth:'none',pt:2}}>
              {/* <Typography  fontSize={'1.09rem'} variant="overline" sx={{ color: 'text.secondary', }}>RFQ</Typography> */}
             {details?.id && invoice?.total !==0 && !user.isVendor && ( 
           
           (details?.quotation_status === 2 || (details?.quotation_status === 9 && details?.send_to_client != 0)) ? (
              <Badge badgeContent={'1'} color={'warning'}>
                <AnimatedButton title={isProposal ? 'PROPOSAL' : 'ESTIMATE'} onClick={() => {
                  let permission =!explodedPermissions?.some((permission) => ['View Billing /Download/ Invoices Estimate'].includes(permission))
                  if(permission &&  user?.added_by_client ==1){
                    return   enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
                  }
                  setOpenInvoice(!openInvoice)}} />
              </Badge>
            ) : (
              <AnimatedButton title={isProposal ? 'PROPOSAL' : 'ESTIMATE'} onClick={() => {
                let permission =!explodedPermissions?.some((permission) => ['View Billing /Download/ Invoices Estimate'].includes(permission))
                if(permission &&  user?.added_by_client ==1){
                  return   enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
                }
                setOpenInvoice(!openInvoice)}} /> 
            )
            
              )}
              <Typography fontWeight={'0.09rem'} variant="overline" >
                <Label
                  sx={{ p: '12px' }}
                  variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                  color={getStatusColorAndLabel(details?.quotation_status,details?.quotation,details?.estimate_job_status, details?.hold, details?.manager_approval_required, details?.send_to_client, details?.send_for_manager_approval, details?.is_request_estimate,details).color} >
                  {getStatusColorAndLabel(details?.quotation_status,details?.quotation,details?.estimate_job_status, details?.hold, details?.manager_approval_required, details?.send_to_client, details?.send_for_manager_approval, details?.is_request_estimate,details).label}
                </Label>
              </Typography>
              {(() => {
                const status = details?.quotation_status;
                if (status !== 6 && status !== 11) return null;

                const hasManagerReject = !!details?.manager_reject_reason || !!details?.manager_reject_file;
                const displayReason = hasManagerReject
                  ? (details?.manager_reject_reason || details?.reason || '')
                  : (details?.reason || '');
                const displayRejectFile = hasManagerReject
                  ? (details?.manager_reject_file || details?.reject_file || null)
                  : (details?.reject_file || null);
                const displayRejectFileType = hasManagerReject
                  ? (details?.manager_reject_file_type || details?.reject_file_type || null)
                  : (details?.reject_file_type || null);

                if (!displayReason && !displayRejectFile) return null;

                return (
                  <>
                    {displayReason && (
                      <Typography variant="subtitle2" color={'error'}>
                        Reason :{displayReason}
                      </Typography>
                    )}
                    {/* {displayRejectFile && (
                      displayRejectFileType === 'application/pdf' ? (
                        <Button
                          size="small"
                          variant="outlined"
                          color="primary"
                          sx={{ mt: 0.5 }}
                          onClick={() => window.open(displayRejectFile, '_blank')}
                        >
                          View Attached File (PDF)
                        </Button>
                      ) : (
                        <Box
                          component="img"
                          src={displayRejectFile}
                          onClick={() => window.open(displayRejectFile, '_blank')}
                          sx={{
                            mt: 0.5,
                            width: 120,
                            height: 120,
                            borderRadius: 1,
                            border: '1px solid #ccc',
                            cursor: 'pointer',
                            objectFit: 'cover'
                          }}
                        />
                      )
                    )} */}
                  </>
                );
              })()}
              {
                (((details?.is_request_estimate == 1 && details?.hold == 0 && ((details?.estimate_job_status == 3 && details?.quotation_status == 3) || (!details?.estimate_job_status && details?.quotation_status == 2))) ||
                  (details?.is_request_estimate == 0 && details?.quotation_status != 4 && 
                    (details?.estimate_job_status == 3 || !details?.estimate_job_status)) ||
                  details?.quotation_status == 10) &&
                  details?.send_to_client == 0 &&
                  userType != 3 &&
                  !isClient &&
                  accessForSendEstimateToClient &&
                  !(details?.is_draft === 1 && details?.quotation_status === 1) &&
                  // Hide for any manager-approval items and for rejected/manager-rejected estimates
                  details?.manager_approval_required != 1 &&
                  details?.quotation_status !== 6 &&
                  details?.quotation_status !== 11 &&
                  details?.project_type !== null &&
                  Number(details?.quotation_status) !== 12) ?
                <Button variant='contained' onClick={handleSendClientReq}>
                  Send To Client
                </Button> : ''
              }
                {/* Send to Manager when send_for_manager_approval is 1 and manager_approval_required is 1 */}

                {/* Manager Approve/Reject — estimate jobs only (is_request_estimate=1 & job completed).
                    Regular estimates (no job) never show manager approval buttons.
                    Previous also allowed: (details?.is_request_estimate != 1 || Number(details?.estimate_job_status) === 3) */}
                {userType != 3 &&
                  (details?.is_request_estimate == 1 || details?.is_request_estimate == 0) &&
                  Number(details?.estimate_job_status) === 3 &&
                  (details?.quotation_status === 9 ||
                    (details?.quotation_status === 3 &&
                      (details?.send_for_manager_approval == 1 ||
                        details?.manager_approval_required == 1))) &&
                  details?.manager_approval_required == 1 &&
                  details?.send_to_client == 0 &&
                  details?.project_type != null ?
                  <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 2}}>
                    {details?.hold === 0 && (
                      <>
                    <Button type="button" size="small" variant="contained"
                      // disabled={!canEstimateManagerApprove}
                      onClick={() => {
                        if (!canEstimateManagerApprove) {
                          enqueueSnackbar("Access Denied: You do not have sufficient permissions", { variant: 'error' });
                          return;
                        }
                        setConfirmManagerAccept(true);
                      }}
                    >
                      Manager Approve
                    </Button>
                    <Button type="button" size="small" variant="outlined"
                      // disabled={!canEstimateManagerReject}
                      onClick={() => {
                        if (!canEstimateManagerReject) {
                          enqueueSnackbar("Access Denied: You do not have sufficient permissions", { variant: 'error' });
                          return;
                        }
                        setRejectInvoice(true);
                      }}
                      sx={{ color: theme.palette.error.main }} >
                      Manager Reject
                    </Button>
                    </>
                    )}
                  </Box> : null}
                {/* Client Approve/Reject when sent to client (quotation_status 2 or 9, send_to_client 1) and client approval is enabled. */}
                {((userType == 3 || accessForApproveEstimateForClient) &&
                  details?.send_to_client != 0 &&
                  details?.client_approve == 1 &&
                  (details?.quotation_status === 2 || details?.quotation_status === 9) &&
                  details?.project_type != null) ?
                  <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 2}}>
                    {details?.hold === 0 && (
                      <>
                      <Button type="button" variant="contained"
                      onClick={() => setConfirmInvoice(true)}
                    // onClick={()=>handleAcceptorRejectInvoice(1)}
                    >
                      Approve
                    </Button>
                    <Button size="small" variant="outlined"
                      onClick={() => setRejectInvoice(true)}
                      //  onClick={()=>handleAcceptorRejectInvoice(2)}
                      sx={{ color: theme.palette.error.main }} >
                      Reject
                    </Button>
                    <Button
                      onClick={() => setOpenHoldEstimate(true)}
                      sx={{
                        borderRadius: 20,
                        backgroundColor: theme.palette.warning.main,
                        color: 'black',
                        boxShadow: 'none',
                        '&:hover': {
                          backgroundColor: theme.palette.warning.dark,
                          boxShadow: 'none',
                        },
                      }}
                      variant="contained"
                    >
                      {details?.hold === 0 ? 'Hold' : 'Release from Hold'}
                    </Button>
                    </>
                    )}
                  </Box> : null}
            </Stack>
           

            <Grid container spacing={3}>

              <Grid sx={{ mt: 3 }} item xs={12} md={12}>
                <Stack spacing={3}>
                  <Stack spacing={5}>
                    <Tabs
                      value={currentTab}
                      scrollButtons="auto"
                      variant="scrollable"
                      allowScrollButtonsMobile
                      onChange={handleChangeTab}
                    >
                      {ACCOUNT_TABS.map((tab) => (
                        <Tab
                          disableRipple
                          key={tab.value}
                          label={
                            <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.75 }}>
                              {capitalCase(tab.value)}
                              {tab.value === 'Design Notes' && designNotesHasNew && (
                                <SalesOrderNewBadgeList>NEW</SalesOrderNewBadgeList>
                              )}
                              {tab.value === 'Job Notes' && jobNotesHasNew && (
                                <SalesOrderNewBadgeList>NEW</SalesOrderNewBadgeList>
                              )}
                            </Box>
                          }
                          value={tab.value}
                          sx={{
                              fontWeight:500
                            }}
                        />
                      ))}
                    </Tabs>

                    {ACCOUNT_TABS.map((tab) => {
                      const isMatched = tab.value === currentTab
                      return isMatched && <Box key={tab.value}>{tab.component}</Box>
                    })}
                  </Stack>
                </Stack>
              </Grid>
             
            </Grid>
          </>)}

        {/* adding client modal  */} 
        <AddClients 
        request_id={id}
         setIsOpen={setIsOpen}
         setAllClients={setAllClients} 
         allClients={allClients?.filter(a=>!a.isVendor)}
          addClient={addClient} 
          setAddClient={setAddClient} />
        <AddClients 
          isVendor
          request_id={id}
          setIsOpen={setIsOpen}
          setAllClients={setAllClients} 
          allClients={allClients?.filter(a=>a.isVendor)}
          addClient={addVendor}
          setAddClient={setAddVendor} />
        <AddProposal
          request_id={id}
          setIsOpen={setIsOpen}
          setReloadData={()=>setRefresh(!refresh)}
          addProposal={addProposal}
          setAddProposal={setAddProposal} />
        <SendDesignsEmailModal
          open={openInvoiceEmailModal}
          onClose={() => setOpenInvoiceEmailModal(false)}
          selectedDesigns={invoicePdfData || []}
          designOrderId={details?.id}
          invoice={invoice}
          quotationId={id}
          details={details}
          userId={user?.user_id}                                                
          userType={user?.user_type}
          onSuccess={handleInvoiceEmailSent}
          pageType="quotation"
          pdfs={pdfs}
          REST_API={REST_API}
          loading={loading}
          hasViewCostPermission={hasViewCostPermission}
        />
        <Modal modalTitle="Print Sign Agreements" open={openSignAgreements} handleClose={handleCloseSignAgreements}>
            <InvoicePdfPreviewPage
              invoice={invoice}
            />
        </Modal>
        {/* invoice modal */}
        <Modal modalTitle={isProposal
                              ? 'Proposal Details' : 'Estimate Details'} open={openInvoice === true} handleClose={() => {setOpenInvoice(false),(setIsOpenModal && setIsOpenModal(false)),setRefresh(true)}}>
          <Stack direction={{ xs: 'column', sm: 'row', md: 'column' }}
            spacing={{ xs: 3, sm: 2 }}>
            <Stack direction="row" justifyContent={'flex-end'} alignItems="center" spacing={1}>
              {(userType == 3 || isClient) || projectEstimate == true ? '' :
                <Tooltip title={isProposal
                  ? 'Send Proposal PDF via Email' : 'Send Estimate PDF via Email'}>
                  <IconButton
                    onClick={handleSendInvoiceEmail}
                    color="primary"
                    sx={{
                      backgroundColor: (theme) => theme.palette.primary.main,
                      color: (theme) => theme.palette.primary.contrastText,
                      '&:hover': {
                        backgroundColor: (theme) => theme.palette.primary.dark,
                      },
                    }}
                  >
                    <Icon icon={emailFillIcon} width={24} height={24} />
                  </IconButton>
                </Tooltip>
              }
              {/* {invoice?.sign_agreements?.length > 0 && (
                <Tooltip title="Print Sign Agreements">
                    <IconButton
                      onClick={handleSignAgreements}
                      color="primary"
                      sx={{
                        backgroundColor: (theme) => theme.palette.primary.main,
                        color: (theme) => theme.palette.primary.contrastText,
                        '&:hover': {
                          backgroundColor: (theme) => theme.palette.primary.dark,
                        },
                      }}>
                      <Icon icon={signAgreementIcon} width={24} height={24} />
                    </IconButton>
                </Tooltip>
              )} */              }
            <Box sx={{ ml: 4, position: 'relative', zIndex: 10 }}>
            <AnimatedButton
              title={invoicePreviewReady ? 'Print' : 'Loading...'}
              startIcon={invoicePreviewReady ? <Print /> : <CircularProgress size={14} color="inherit" />}
              size="small"
              onClick={() => {
                if (!invoicePreviewReady) return;
                handlePrintEstimate();
              }}
            />
            </Box>
{details?.quotation_status===4 && SEND_EMAIL && <Button onClick={handleSendEmail}>Send Email</Button>}
            <div style={{ display: "none" }}>
    <EstimateOrderInvoicePage
      invoiceDate={invoiceDate}
      openInvoice={openInvoice}
      details={details}
      invoice={invoice}
      subTotal={invoiceModalCustProductSubtotalForServices}
      groupedInvoiceProductTotal={invoiceModalProductTotalFromRows}
      groupedInvoiceInstallTotal={invoiceModalInstallTotalFromRows}
      ref={componentRef}
      additionalSelectedServices={invoiceModalAdditionalServices}
      cartService={cartService}
      invoiceSelectedServices={invoiceSelectedServices}
      data={data}
      labourInstallService={labourInstallService}
      userType={userType}
      hasViewCostPermission={hasViewCostPermission}
      customerOrderProductGroups={customerOrderProductGroups}
      estimateProducts={selectedProducts}
      markupType={markupType}
      groupProductMarketingValues={groupProductMarketingValues}
      groupInstallMarketingValues={groupInstallMarketingValues}
      rushFeeEnabled={details?.rush_fee}
      rushFeeAmount={details?.rush_fee_amount}
      rushFeePercentage={Number(data?.rush_fee_percentage) || 0}
    />
    {/* <EstimateOrderInvoicePage
      invoiceDate={invoiceDate}
      openInvoice={openInvoice}
      details={details}
      invoice={invoice}
      subTotal={invoiceModalCustProductSubtotalForServices}
      ref={componentRef}
      additionalSelectedServices={additionalSelectedServices}
      cartService={cartService}
      invoiceSelectedServices={invoiceSelectedServices}
      data={data}
      labourInstallService={labourInstallService}
      userType={userType}
    /> */}
  </div>

            </Stack>
            </Stack>
          {!invoicePreviewReady ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 240, width: '100%' }}>
              <CircularProgress />
            </Box>
          ) : (
          <>
          <Grid container spacing={3} >

            <Grid item xs={12} sm={6} sx={{ mb: 5 }}>
              <Grid item xs={12} sm={6} sx={{ mb: 5 }}>
            <Box component="img" alt="logo" src={COMPANY_LOGO} sx={{ height: 98 }} />
          </Grid>
              <Typography variant="body2">{COMPANY_NAME}</Typography>
              <Typography variant="body2">{data?.company_website ? data?.company_website : ''}</Typography>
              <Typography variant="body2">
                {data?.address}, {data?.city}, {data?.state}, {data?.zipcode}
              </Typography>
              {/* <Typography variant="body2">Telephone: +15208362947</Typography> */}
              <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
                <Typography variant="body2" sx={{ textTransform: 'uppercase', }}>Telephone: {(data?.phone_country_code || data?.phone) ? `+${data?.phone_country_code}${data?.phone}` : '951-682-9660'}</Typography>
                <Typography variant="body2" sx={{ textTransform: 'uppercase' }}>|</Typography>
                <Typography variant="body2" sx={{ textTransform: 'uppercase' }}>{data?.company_fax_number ? `Fax: ${data?.company_fax_number}` : ''}</Typography>
              </Box>
              <Typography variant="body2" sx={{ textTransform: 'uppercase' }}>{data?.company_mail}</Typography>
            </Grid>
            <Grid item xs={12} sm={6} sx={{ mb: 5 }}>

              <Typography variant="body2">
                Order date: {invoiceDate}
              </Typography>
              {/* <Stack sx={{display:'flex',flexDirection:'row'}}> */}
              {/* <Typography variant="body2">Order status:</Typography> */}
              <Label
                variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                color={getStatusColorAndLabel(details?.quotation_status,details?.quotation,details?.estimate_job_status, details?.hold, details?.manager_approval_required, details?.send_to_client, details?.send_for_manager_approval, details?.is_request_estimate,details).color} >
                {getStatusColorAndLabel(details?.quotation_status,details?.quotation,details?.estimate_job_status, details?.hold, details?.manager_approval_required, details?.send_to_client, details?.send_for_manager_approval, details?.is_request_estimate,details).label}
              </Label>
              {/* </Stack> */}
              <Typography variant="body2">Job Name: {details?.name}</Typography>
              <Typography variant="body2">Project Name: {details?.community_name || ''}</Typography>
              <Typography variant="body2">Order ID: #{details?.doc_number}</Typography>
              <Box sx={{ gap : 0.5, mt:2, alignItems:'flex-start'}}>
                <Typography variant="body2" sx={{ fontWeight: 'bold' }}>To,</Typography>
                {/* <Box sx={{ ml: 2 }}> */}
                  <Typography variant="body2">Customer: {invoice?.customer_name || ''}</Typography>
                  <Typography variant="body2">Address: {invoice?.customer_address || ''}</Typography>
                  <Typography variant="body2">Phone: {invoice?.customer_phone || ''}</Typography>
                {/* </Box> */}
              </Box>
            </Grid>
          </Grid>
          <Grid container spacing={2}>

            <Scrollbar>
            {invoice?.cust_product?.length > 0 ?
            <>
              <Typography variant='h6'>Products</Typography>
              <TableContainer sx={{ minWidth: 420, mt:3 }}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Sl No.</TableCell>
                      {/* <TableCell></TableCell> */}
                        <TableCell>PRODUCT & NOTE</TableCell>
                        {/* {invoice?.cust_product?.some(item => item.product_notes) && <TableCell>SKU</TableCell>} */}
                        <TableCell align="center">SKU</TableCell>
                        {/* {(details?.is_split_order && details?.origin_facility_id == currentFacilityId && userType != 3) ? <TableCell>WHOLESALE PRICE</TableCell> : ''}
                        {(details?.is_split_order && details?.origin_facility_id == currentFacilityId && userType != 3) ? <TableCell>SPLIT MARKUP</TableCell> : ''} */}
                        <TableCell>QTY</TableCell>
                        {canViewCosts && <TableCell align="center">UNIT PRICE EACH</TableCell>}
                        {/* <TableCell align="center">MARKETING ADJUSTMENT</TableCell> */}
                        {canViewCosts && <TableCell>TOTAL</TableCell>}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {groupedInvoiceDisplayRows?.map((row, i) => {
                      if (row?.__type === 'group') {
                        const representative = row?.representative || {}
                        const facility = FacilityTypes?.find((f) => f.id == representative?.facility_id)
                        const facilityColor = theme.palette[facility?.color]?.main || 'inherit'
                        const members = row?.members || []
                        const groupName = getCustomerOrderProductGroupDisplayName({
                          groupMeta: row?.groupMeta,
                          representative,
                          members,
                          groupId: row?.groupId,
                        })
                        const groupDescription = row?.groupMeta?.group_description || representative?.group_description || '-'
                        const groupProductDisplayQty = Number(row?.groupProductDisplayQty ?? 1) || 1
                        const groupInstallDisplayQty = Number(row?.groupInstallDisplayQty ?? 1) || 1
                        const groupInstallSubtotal = Number(row?.groupInstallSubtotal ?? 0)
                        const groupHasInstall = Boolean(row?.groupHasInstall)
                        const displayGroupTotal = groupHasInstall ? Number(row?.groupProductOnlyTotal ?? 0) : Number(row?.totalValue || 0)
                        const unitEach = Number(row?.adjustedGroupRetailEach ?? 0)
                        const groupInstallUnitEach = Number(row?.adjustedGroupInstallRetailEach ?? 0)
                        const groupInstallNotes = getGroupInstallNotesDisplay(members)
                        const groupDisplayName = groupName
                        const groupDisplayNote =
                          members.find(
                            (m) =>
                              m?.product_notes != null &&
                              String(m.product_notes).trim() !== '',
                          )?.product_notes || ''

                        return (
                          <React.Fragment key={`group-${row?.groupId}`}>
                            <TableRow>
                              <TableCell>{i + 1}</TableCell>
                              <TableCell width={'25%'} sx={{ flexWrap: 'wrap', overflow: 'hidden' }}>
                                <Typography variant='subtitle2' sx={{ fontWeight: 'bold', mb: 1, wordBreak: 'break-word', overflowWrap: 'break-word', color: groupDisplayNote ? 'error.main' : 'inherit' }}>
                                  {groupDisplayNote || groupDisplayName}
                                </Typography>
                                {/* <Typography variant='subtitle2' sx={{ mb: 1, wordBreak: 'break-word', overflowWrap: 'break-word', color: facilityColor }}>
                                  {groupDescription}
                                </Typography> */}
                              </TableCell>
                              <TableCell align="center" sx={{ color: facilityColor }}>-</TableCell>
                              <TableCell align="center" sx={{ color: facilityColor }}>
                                {groupProductDisplayQty}
                              </TableCell>
                              {canViewCosts && <TableCell align="center" sx={{ color: facilityColor }}>
                                ${unitEach.toFixed(2)}
                              </TableCell>}
                              {canViewCosts && <TableCell sx={{ color: facilityColor }}>
                                ${displayGroupTotal.toFixed(2)}
                              </TableCell>}
                            </TableRow>
                            {groupHasInstall && showInstallPriceInView && (
                              <TableRow>
                                <TableCell>-</TableCell>
                                <TableCell sx={{ pl: 4 }}>
                                  <Typography sx={{ color: 'inherit', whiteSpace: 'pre-wrap' }}>
                                    Install Price
                                  </Typography>
                                  <Typography sx={{ color: groupInstallNotes ? 'red' : 'inherit', whiteSpace: 'pre-wrap' }}>
                                    Note : {groupInstallNotes}
                                  </Typography>
                                </TableCell>
                                <TableCell align="center">-</TableCell>
                                <TableCell>{groupInstallDisplayQty}</TableCell>
                                {canViewCosts && <TableCell align="center">${groupInstallUnitEach.toFixed(2)}</TableCell>}
                                {canViewCosts && <TableCell>${groupInstallSubtotal.toFixed(2)}</TableCell>}
                              </TableRow>
                            )}
                            <TableRow>
                              <TableCell colSpan={canViewCosts ? 6 : 4}>
                                <Box sx={{ borderBottom: (theme) => `solid 1px ${theme.palette.divider}` }} />
                              </TableCell>
                            </TableRow>
                          </React.Fragment>
                        )
                      }

                      const val = row;
                      const invoiceProductDisplayName = getInvoiceProductDisplayName(val)
                      const { vid,facility_id,split_percentage,wholesale_price, product_name,product_notes,material_notes,vpt_number, product_price,product_retail_price, adjustment,
                        quantity,locationQuantity,actual_retail_price,install_cost,install_qty,install_quantity,install_notes, product_total, discount,unit,unit_qty, material, rfp,markAdjType,adj_value_type,
                        services = [], product_index, quickbookId
                      } = val
                      const lineInstallQty = Number(install_qty ?? install_quantity ?? 1) || 1

                      // Get labor install
                      const labourService = services?.find(service => service.labour_cost_service_id === 10);
                      const minusAmountLabourInstall = (labourService?.service_original_cost * labourService?.prQty) || 0;
                      const labourQty = (labourService?.prQty || 0) * locationQuantity;
                      const labourRate = labourService?.service_original_cost || 0;
                      const labourTotal = labourQty * labourRate;
                      const labourInitial = (labourService?.prQty || 0) * labourRate;
                      
                      // Unit name logic
                      let unitData = UNITS?.filter((item) => item?.id == unit)
                      let shortUnitName = unitData[0]?.short_name || 'Unit'
                      let unitName = unitData[0]?.name
                      
                      //  subTotal += product_total    
                      let SPMA = 0
                      if(markAdjType==2 || markAdjType==3) {
                        SPMA = (actual_retail_price || product_retail_price || 0) //+ (adjustment ? Number(adjustment) : 0)
                      }else{
                        SPMA = (actual_retail_price || product_retail_price || 0) //+ (((product_retail_price || 0) * (adjustment ? Number(adjustment) : 0)) / 100)

                      }
                      SPMA = parseFloat(SPMA)?.toFixed(2)   
                      if(material==1){
                        let newSPMA = Number(SPMA) + (adj_value_type==1 ? Number(adjustment) : -Number(adjustment));
                        SPMA = newSPMA
                        console.log('SPMA-material==1',SPMA);
                        console.log('SPMA-material==1',newSPMA);
                        console.log('SPMA-material==1',adj_value_type);
                        console.log('SPMA-material==1',adjustment);

                      }
                      return (
                        <React.Fragment key={vid}>
                          {/* Product Row */}
                          <TableRow
                          //  sx={{
                          //   borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                          // }}
                          >
                            <TableCell>{i+1}</TableCell>
                               {/* <TableCell align="center">
                              {renderTaxIndicator(findMatchingTaxItem(quickbookId, product_name))}
                            </TableCell> */}
                            <TableCell width={'25%'} sx={{ flexWrap: 'wrap', overflow: 'hidden' }}>
                              {(material === 1
                                ? (material_notes && material_notes.trim() !== '' ? material_notes : invoiceProductDisplayName)
                                : (product_notes ? product_notes : invoiceProductDisplayName)) && (
                                <Typography
                                  variant={(material === 1 ? material_notes : product_notes) ? 'body2' : 'subtitle2'}
                                  sx={{
                                    fontWeight: 'bold',
                                    wordBreak: 'break-word',
                                    overflowWrap: 'break-word',
                                    color: (material === 1 ? material_notes : product_notes) ? theme.palette.error.main : 'inherit'
                                  }}
                                >
                                  {(material === 1
                                    ? (material_notes || invoiceProductDisplayName)
                                    : (product_notes || invoiceProductDisplayName))}
                                </Typography>
                              )}
                              {(material === 1 && rfp == 0 && details?.job_category_name != 'Time & Material') ?
                                <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}>(Addl. Material)</Typography>
                                : null}
                              {(material === 1 && rfp === 1 && details?.job_category_name != 'Time & Material') ?
                                <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}>(Rfp. Material)</Typography>
                                : null}
                            </TableCell>
                         
                            {/* {invoice?.cust_product?.some(item => item.product_notes) ? <TableCell>{product_notes ? vpt_number : ''}</TableCell> : ''} */}
                            {/* <TableCell align="center">{material === 1 ? '1' : quantity} ({shortUnitName})</TableCell> */}
                            <TableCell align="center">{vpt_number ? vpt_number : '-'}</TableCell>
                            {/* <TableCell>${(SPMA ? SPMA - (labourInitial || 0) : 0)?.toFixed(2)}</TableCell> */}
                            {/* {(details?.is_split_order && details?.origin_facility_id == currentFacilityId && userType != 3) ? 
                              <TableCell align="center">
                                {details?.is_split_order && facility_id != currentFacilityId ? `$${wholesale_price || 0}` : '-'}
                              </TableCell>
                              :''
                              }
                            {(details?.is_split_order && details?.origin_facility_id == currentFacilityId && userType != 3) ? 
                              <TableCell align="center">
                                {details?.is_split_order && facility_id != currentFacilityId ? `${incomingSplitMarkup || 0}%` : '-'}
                              </TableCell>
                              :''
                              } */}
                            {/* <Tooltip title={
                              details?.is_split_order && facility_id != currentFacilityId 
                                ? `Product formula cost + (Product formula cost  * incoming split markup (${incomingSplitMarkup || 0}) / 100)` 
                                : ""
                            }> */}
                            <TableCell>{locationQuantity}</TableCell>
                            {canViewCosts && <TableCell align="center">${(Number(SPMA) || 0).toFixed(2)}</TableCell>}
                            {/* </Tooltip> */}
                            {/* <TableCell>{locationQuantity}</TableCell> */}
                            {/* {markAdjType==1?
                              // <TableCell>${product_total ? (product_total - labourTotal)?.toFixed(2) : 0.00}</TableCell>
                              <TableCell>${product_total ? product_total?.toFixed(2) : 0.00}</TableCell>
                            :
                              // <TableCell>${((SPMA * (locationQuantity * quantity)) - labourTotal)?.toFixed(2)}</TableCell>
                              <TableCell>${(SPMA * (locationQuantity * quantity))?.toFixed(2)}</TableCell>
                            } */}
                            {/* <TableCell align="center">{adjustment ? `${adj_value_type ? `+${adjustment}` : `-${adjustment}`}` : '-'}</TableCell> */}
                            {canViewCosts && (markAdjType==1?
                              // <TableCell>${product_total ? product_total?.toFixed(2) : 0.00}</TableCell>
                              <TableCell>${
                                install_cost ?
                                ((actual_retail_price * (locationQuantity * quantity)) || 0).toFixed(2) :
                                material === 1 ?
                                ((SPMA * locationQuantity ) || 0).toFixed(2) :
                                ((SPMA * (locationQuantity * quantity)) || 0).toFixed(2)
                                // (((SPMA * (locationQuantity * quantity)) + (adj_value_type ?  +adjustment : -adjustment)) || 0).toFixed(2)
                                }</TableCell>
                            :
                              // <TableCell>${((SPMA * (locationQuantity * quantity)) - labourTotal)?.toFixed(2)}</TableCell>
                              <TableCell>${
                                install_cost ?
                                ((actual_retail_price * (locationQuantity * quantity)) || 0).toFixed(2) :
                                material === 1 ?
                                ((SPMA * locationQuantity ) || 0).toFixed(2) :
                                ((SPMA * (locationQuantity * quantity)) || 0).toFixed(2)
                                }</TableCell>
                            )}
                          </TableRow>
                          {/* Labor Install Row (if exists) */}
                          {/* {labourService && (
                            <TableRow>
                              <TableCell sx={{ pl: 4 }}>{labourService?.name}</TableCell>
                              <TableCell align="center">N/A</TableCell>
                              <TableCell>${labourRate?.toFixed(2)}</TableCell>
                              <TableCell>{labourQty?.toFixed(2)}</TableCell>
                              <TableCell>${labourTotal?.toFixed(2)}</TableCell>
                            </TableRow>
                          )} */}
                          {install_cost && showInstallPriceInView ? (
                            <TableRow>
                              <TableCell>-</TableCell>
                              {/* <TableCell align="center">
                                {renderTaxIndicator(findMatchingInstallTaxItem())}
                              </TableCell> */}
                              <TableCell sx={{ pl: 4 }}>
                                <Typography sx={{ color: install_notes ? 'red' : 'inherit', whiteSpace: 'pre-wrap' }}>
                                  {install_notes || 'Install Price'}
                                </Typography>
                              </TableCell>
                            
                              {/* {invoice?.cust_product?.some(item => item.product_notes) ? <TableCell>-</TableCell> : ''} */}
                              <TableCell align="center">-</TableCell>
                            {/* {(details?.is_split_order && details?.origin_facility_id == currentFacilityId && userType != 3) ?
                              <TableCell align="center">
                                {details?.is_split_order && facility_id != currentFacilityId ? '-' : '-'}
                              </TableCell>
                              : ''
                            }
                            {(details?.is_split_order && details?.origin_facility_id == currentFacilityId && userType != 3) ?
                              <TableCell align="center">
                                {details?.is_split_order && facility_id != currentFacilityId ? '-' : '-'}
                              </TableCell>
                              : ''
                            } */}
                              <TableCell>{lineInstallQty}</TableCell>
                              {canViewCosts && <TableCell align="center">${install_cost || 0}</TableCell>}
                              {/* <TableCell>-</TableCell> */}
                              {canViewCosts && <TableCell>
                                {/* ${((install_cost || 0) * (locationQuantity || 1) * (quantity || 1)).toFixed(2)} */}
                                ${((install_cost || 0) * lineInstallQty).toFixed(2)}
                              </TableCell>}

                            </TableRow>
                          ):''}
                          <TableRow>
                            <TableCell colSpan={canViewCosts ? 7 : 5}>
                              <Box sx={{ borderBottom: (theme) => `solid 1px ${theme.palette.divider}` }} />
                            </TableCell>
                          </TableRow>
                        </React.Fragment>
                      )
                    }
                    )}

                    {/* <RowResultStyle>
                      <TableCell colSpan={3} />
                      <TableCell align="center">
                        <Typography variant="overline">Subtotal</Typography>
                      </TableCell>
                      <TableCell align="center" width={10}>
                        <Typography variant="overline">{subTotal ? subTotal?.toFixed(2) : 0.00}</Typography>
                      </TableCell>
                    </RowResultStyle>
                    <RowResultStyle>
                      <TableCell colSpan={3} />
                      <TableCell align="center">
                        <Typography variant="overline">Additional Labor Cost</Typography>
                      </TableCell>
                      <TableCell align="center" width={10}>
                        <Typography variant="overline">{details ? details?.labour_cost?.toFixed(2) : 0.00}</Typography>
                      </TableCell>
                    </RowResultStyle>
                    <RowResultStyle>
                      <TableCell colSpan={3} />
                      <TableCell align="center">
                        <Typography variant="overline">Extra Discount</Typography>
                      </TableCell>
                      <TableCell align="center" width={10}>
                        <Typography variant="overline">{invoice?.extra_discount ? invoice?.extra_discount?.toFixed(2) : 0.00}</Typography>
                      </TableCell>

                    </RowResultStyle>
                    <RowResultStyle>
                      <TableCell colSpan={3} />
                      <TableCell align="center">
                        <Typography variant="subtitle1">Total</Typography>
                      </TableCell>
                      <TableCell align="center" width={10}>
                        <Typography variant="subtitle1">{invoice?.total ? invoice?.total?.toFixed(2) : 0.00}</Typography>
                      </TableCell>

                    </RowResultStyle> */}

                  </TableBody>
                </Table>
              </TableContainer>
            </> : ''}
              {/*below for labour Install */}

              {/* <Typography variant='h6' sx={{ mt: 2 }}>{(labourInstallService?.length > 0 ) ? ((details?.job_category_name != 'Service only' && details?.job_category_name != 'Time & Material') ? "Services(Labor Install)" : 'Services(Labor Install)') : ""}</Typography>
              <TableContainer sx={{ minWidth: 420, mt: 3 }}>
                <Table>
                  {(labourInstallService?.length > 0 ) &&
                    <TableHead>
                      <TableRow>
                        <TableCell colSpan={2}>NAME</TableCell>
                        <TableCell>COST (HOURLY)</TableCell>
                        <TableCell>HOURS</TableCell>
                        <TableCell>TOTAL COST</TableCell>
                      </TableRow>
                    </TableHead>}
                  <TableBody>
                  
                  {labourInstallService?.map((ser) => {
                      console.log('invoiceSelectedServices--@@ 1', ser);
                      return (
                        <TableRow sx={{
                          borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                        }}>
                          <TableCell colSpan={2}>{ser?.name}-({ser.productName})</TableCell>
                          <TableCell>{formatServiceHourlyCost(ser)}</TableCell>
                          <TableCell>{ser ? ser?.quantity?.toFixed(2) : 0}</TableCell>
                          <TableCell>{ser ? ser?.total_cost?.toFixed(2) : 0}</TableCell>
                        </TableRow>
                      )
                    })}
                    </TableBody>
                    </Table>
              </TableContainer> */}

              {/*above  for labour Install */}

              {/* <Typography variant='h6' sx={{ mt:2 }}>{(additionalSelectedServices?.length > 0) ? "Additional Services" : ""}</Typography> */}
              <TableContainer sx={{ minWidth: 420, mt:3 }}>
                <Table>
                {(invoiceModalAdditionalServices?.length > 0|| cartService?.length > 0 || invoiceSelectedServices?.length > 0) && 
                  <TableHead>
                    <TableRow>
                      <TableCell>Sl No.</TableCell>
                      {/* <TableCell align="center"></TableCell> */}
                      <TableCell colSpan={2}>ADDITIONAL SERVICES</TableCell>
                      <TableCell>COST (HOURLY)</TableCell>
                      <TableCell>HOURS</TableCell>
                      <TableCell>TOTAL COST</TableCell>
                    </TableRow>
                  </TableHead>}
                  <TableBody>
                      {(() => {
                          let serviceIndex = 1;
                          return (
                            <>
                      {openInvoice && invoiceSelectedServices?.map((ser) => {
                        console.log('invoiceSelectedServices--@@', ser);
                        return (
                          <TableRow sx={{
                            borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                          }}>
                            <TableCell>{serviceIndex++}</TableCell>
                              {/* <TableCell align="center">
                              {renderTaxIndicator(findMatchingServiceTaxItem(ser))}
                            </TableCell> */}
                            <TableCell colSpan={2}>{ser?.service_notes ? 
                                      <Stack direction={'column'}>
                                        {/* <Typography variant='body2' sx={{textDecoration: 'underline', mt: 1, color: 'error.main' }}>Service Note : </Typography>  */}
                                        <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word' ,color: 'error.main', whiteSpace: 'pre-wrap'}}>{ser.service_notes}</Typography> 
                                      </Stack>
                                      : ser?.service_name || ser?.name}</TableCell>                         
                            {canViewCosts && <TableCell>${formatServiceHourlyCost(ser)}</TableCell>}
                            <TableCell>{ser ? ser?.quantity?.toFixed(2) : 0}</TableCell>
                            {canViewCosts && <TableCell>${ser ? ser?.total_cost?.toFixed(2) : 0}</TableCell>}
                          </TableRow>
                        )
                      })}
                      {openInvoice && invoiceModalAdditionalServices?.map((ser) => {
                        console.log('additionalSelectedServices--',ser);
                        return(
                        <TableRow sx={{
                          borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                        }}>
                          <TableCell>{serviceIndex++}</TableCell>
                             {/* <TableCell align="center">
                            {renderTaxIndicator(findMatchingServiceTaxItem(ser))}
                          </TableCell> */}
<TableCell colSpan={2}>{ser?.service_notes ? 
                                      <Stack direction={'column'}>
                                        {/* <Typography variant='body2' sx={{textDecoration: 'underline', mt: 1, color: 'error.main' }}>Service Note : </Typography>  */}
                                        <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word' ,color: 'error.main', whiteSpace: 'pre-wrap'}}> {ser.service_notes}</Typography> 
                                      </Stack>
                                      : ser?.service_name || ser?.name }</TableCell>                      
                          {canViewCosts && <TableCell>${formatServiceHourlyCost(ser)}</TableCell>}
                            <TableCell>{ser ? ser?.quantity?.toFixed(2) : 0}</TableCell>
                            {canViewCosts && <TableCell>${ser ? ser?.total_cost?.toFixed(2) : 0}</TableCell>}
                        </TableRow>
                      )
                    }
                    )}
                      {openInvoice && cartService?.map((ser) => {
                        console.log('cartService--', ser);
                        ser.sellingPrice = ser.sellingPrice || ser.unit_cost
                        ser.originalMarkup = ser.originalMarkup || ser.product_markup || ser.markup
                        return (
                          <TableRow sx={{
                            borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                          }}>
                            <TableCell>{serviceIndex++}</TableCell>
                              {/* <TableCell align="center">
                              {renderTaxIndicator(findMatchingServiceTaxItem(ser))}
                            </TableCell> */}
                            <TableCell colSpan={2}>{ser?.service_notes ? 
                                      <Stack direction={'column'}>
                                        {/* <Typography variant='body2' sx={{textDecoration: 'underline', mt: 1, color: 'error.main' }}>Service Note : </Typography>  */}
                                        <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word' ,color: 'error.main', whiteSpace: 'pre-wrap'}}>{ser.service_notes}</Typography> 
                                      </Stack>
                                      : ser?.service_name || ser?.name }</TableCell>
                            {canViewCosts && <TableCell> ${((ser.sellingPrice + (ser.sellingPrice * ser.originalMarkup / 100)))?.toFixed(2)}</TableCell>}
                            <TableCell>{ser ? ser?.qty?.toFixed(2) : 0}</TableCell>
                        
                            {canViewCosts && <TableCell> ${(ser.qty * (ser.sellingPrice + (ser.sellingPrice * ser.originalMarkup / 100)))?.toFixed(2)}</TableCell>}
                          </TableRow>
                        )
                      }
                      )}

                      </>
                          )
                        })()}
                    {canViewCosts && <>
                    <RowResultStyle>
                        <TableCell colSpan={4} />
                        <TableCell align="right">
                          <Typography variant="overline">Product Total</Typography>
                        </TableCell>
                        <TableCell align="left" width={10}>
                          <Typography variant="overline">
                            ${invoiceModalProductTotalFromRows.toFixed(2)}
                        </Typography>
                      </TableCell>
                    </RowResultStyle>

                    {((labourInstallService?.length > 0) ||
                        invoiceModalAdditionalServices?.some(
                          x => x.labour_cost_service_id === 10 && (x.total_cost || 0) > 0
                        )||
                        invoiceModalInstallTotalFromRows > 0
                      ) &&
                    <RowResultStyle>
                      <TableCell colSpan={4} />
                      <TableCell align="right">
                        <Typography variant="overline">Install Total</Typography>
                      </TableCell>
                      <TableCell align="left" width={10}>
                        {/* <Typography variant="overline">
                            ${invoice?.cust_product?.reduce((sum, val) => {
                              const labourService = val?.services?.find(s => s.labour_cost_service_id === 10);
                              return sum + (labourService?.service_original_cost || 0) * (labourService?.prQty || 0) * (val?.locationQuantity || 1);
                            }, 0)?.toFixed(2)}
                        </Typography> */}
                        <Typography variant="overline">
                          ${(
                            // (invoice?.cust_product?.reduce((sum, val) => {
                            //   const labourService = val?.services?.find(
                            //     s => s.labour_cost_service_id === 10
                            //   );
                            //   return (
                            //     sum +
                            //     (labourService?.service_original_cost || 0) *
                            //     (labourService?.prQty || 0) *
                            //     (val?.locationQuantity || 1)
                            //   );
                            // }, 0) || 0) +
                            (invoiceModalInstallTotalFromRows || 0) +
                            (invoiceModalAdditionalServices?.reduce(
                              (s, x) =>
                                x.labour_cost_service_id === 10 ? s + (x.total_cost || 0) : s,
                              0
                            ) || 0)
                          ).toFixed(2)}
                        </Typography>
                      </TableCell>
                    </RowResultStyle>
                    }

                    <RowResultStyle>
                      <TableCell colSpan={4} />
                      <TableCell align="right">
                        {/* <Typography variant="overline">{details?.job_category_name != 'Service only' ? 'Additional Labor Cost' : 'Labor Cost'}</Typography> */}
                        {/* <Typography variant="overline">{(details?.job_category_name != 'Service only' && details?.job_category_name != 'Time & Material') ? 'Additional Services' : 'Services'}</Typography> */}
                        <Typography variant="overline">{(details?.job_category_name != 'Service only') ? 'Additional Services Total' : 'Services Total'}</Typography>
                      </TableCell>
                      <TableCell align="left" width={10}>
                        {/* <Typography variant="overline">${details ? details?.labour_cost?.toFixed(2) : 0.00}</Typography> */}
                        <Typography variant="overline">
                          ${Number(
                            (invoiceSelectedServices?.reduce(
                              (s, x) => s + Number(x.total_cost || 0),
                              0,
                            ) || 0) +
                            (invoiceModalAdditionalServices?.reduce(
                              (s, x) => s + Number(x.total_cost || 0),
                              0,
                            ) || 0) +
                            (cartService?.reduce((s, x) => {
                              const sp = Number(x.sellingPrice || x.unit_cost || 0);
                              const markup = Number(x.originalMarkup || x.product_markup || 0);
                              const final = sp + (sp * markup / 100);
                              return s + Number(x.qty || 0) * final;
                            }, 0) || 0),
                          ).toFixed(2)}
                        </Typography>
                      </TableCell>
                    </RowResultStyle>

                    <RowResultStyle>
                      <TableCell colSpan={4} />
                      <TableCell align="right">
                        <Typography variant="overline">Subtotal</Typography>
                      </TableCell>
                      <TableCell align="left" width={10}>
                        <Typography variant="overline">
                          ${fUSPrice(
                            (invoiceModalCustProductSubtotalForServices || 0) +
                            (invoiceSelectedServices?.reduce((s, x) => s + (x.total_cost || 0), 0) || 0) +
                            (invoiceModalAdditionalServices?.reduce((s, x) => s + (x.total_cost || 0), 0) || 0) +
                            (cartService?.reduce((s, x) => {
                              const sp = x.sellingPrice || x.unit_cost || 0;
                              const markup = x.originalMarkup || x.product_markup || 0;
                              const final = sp + (sp * markup / 100);
                              return s + ((x.qty || 0) * final);
                            }, 0) || 0) 
                            // (invoice?.cust_product?.reduce((sum, val) => {
                            //   const labourService = val?.services?.find(
                            //     s => s.labour_cost_service_id === 10
                            //   );
                            //   return (
                            //     sum +
                            //     (labourService?.service_original_cost || 0) *
                            //       (labourService?.prQty || 0) *
                            //       (val?.locationQuantity || 1)
                            //   )
                            // }, 0) || 0)
                          )}
                        </Typography>
                      </TableCell>
                    </RowResultStyle>

                    {/* Discount hidden — restore when needed
                    {invoice?.extra_discount > 0 && (
                    <RowResultStyle>
                      <TableCell colSpan={4} />
                      <TableCell align="right">
                        <Typography variant="overline">Discount</Typography>
                      </TableCell>
                      <TableCell align="left" width={10}>
                        <Typography variant="overline">${invoice ? invoice?.extra_discount?.toFixed(2) : 0.00}</Typography>
                      </TableCell>
                    </RowResultStyle>
                    )}
                    */}
                    
                    {invoice?.tax_amount > 0 && (
                    <RowResultStyle>
                      <TableCell colSpan={4} />
                      <TableCell align="right">
                        <Typography variant="overline">Tax</Typography>
                      </TableCell>
                      <TableCell align="left" width={10}>
                        <Typography variant="overline">${invoice ? invoice?.tax_amount?.toFixed(2) : 0.00}</Typography>
                      </TableCell>
                    </RowResultStyle>
                    )}
{/* //estimateinvoice */}
                    {(() => {
                      const isInvoiceRushFeeOn = isRushFeeOn({
                        rushFee: details?.rush_fee,
                        rushFeeAmount: details?.rush_fee_amount || values?.rush_fee_amount,
                        rushFeeEnabled: Number(details?.rush_fee) === 1,
                      });
                      if (!isInvoiceRushFeeOn) return null;
                      const rushFeePct = Number(data?.rush_fee_percentage) || 0;
                      const rushFeeAmount = calcRushFeeAmount({
                        enabled: isInvoiceRushFeeOn,
                        subtotal: invoiceModalCustProductSubtotalForServices || invoice?.total,
                        percentage: rushFeePct,
                        storedAmount: values?.rush_fee_amount || details?.rush_fee_amount,
                        preferStored: !openEdit,
                      });
                      return (
                        <RowResultStyle>
                          <TableCell colSpan={4} />
                          <TableCell align="right">
                            <Typography variant="overline">Rush Fee</Typography>
                          </TableCell>
                          <TableCell align="left" width={10}>
                            <Typography variant="overline">${fUSPrice(rushFeeAmount)}</Typography>
                          </TableCell>
                        </RowResultStyle>
                      );
                    })()}
                    <RowResultStyle>
                      <TableCell colSpan={4} />
                      <TableCell align="right">
                        <Typography variant="subtitle1">Total</Typography>
                      </TableCell>
                      <TableCell align="left" width={10}>
                        <Typography variant="subtitle1">${fUSPrice(
                          (invoice?.total ?? 0) + 
                          (() => {
                            const isInvoiceRushFeeOn = isRushFeeOn({
                              rushFee: details?.rush_fee,
                              rushFeeAmount: values?.rush_fee_amount || details?.rush_fee_amount,
                              rushFeeEnabled: Number(values?.rush_fee) === 1,
                            });
                            return calcRushFeeAmount({
                              enabled: isInvoiceRushFeeOn,
                              subtotal: invoiceModalCustProductSubtotalForServices || invoice?.total,
                              percentage: Number(data?.rush_fee_percentage) || 0,
                              storedAmount: values?.rush_fee_amount || details?.rush_fee_amount,
                              preferStored: !openEdit,
                            });
                          })()
                        )}</Typography>
                      </TableCell>
                    </RowResultStyle>
                    </>}

                  </TableBody>
                </Table>
              </TableContainer>
              {/* Send to Manager in Modal */}

              {/* Manager Approve/Reject in Estimate Details popup — estimate jobs only (job completed).
                  Previous also allowed regular estimates: (details?.is_request_estimate != 1 || Number(details?.estimate_job_status) === 3) */}
              {(userType != 3 &&
                details?.is_request_estimate == 1 &&
                Number(details?.estimate_job_status) === 3 &&
                (details?.quotation_status === 9 ||
                  (details?.quotation_status === 3 &&
                    (details?.send_for_manager_approval == 1 ||
                      details?.manager_approval_required == 1))) &&
                details?.manager_approval_required == 1 &&
                details?.send_to_client == 0 &&
                details?.project_type != null) ? (
                <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                  {details?.hold === 0 && (
                    <>
                  <Button
                    type="button"
                    size="small"
                    variant="contained"
                    disabled={!canEstimateManagerApprove}
                    onClick={() => {
                      if (!canEstimateManagerApprove) {
                        enqueueSnackbar("Access Denied: You do not have sufficient permissions", { variant: 'error' });
                        return;
                      }
                      setConfirmManagerAccept(true);
                    }}
                  >
                    Manager Approve
                  </Button>
                  <Button
                    type="button"
                    size="small"
                    variant="outlined"
                    disabled={!canEstimateManagerReject}
                    onClick={() => {
                      if (!canEstimateManagerReject) {
                        enqueueSnackbar("Access Denied: You do not have sufficient permissions", { variant: 'error' });
                        return;
                      }
                      setRejectInvoice(true);
                    }}
                    sx={{ color: theme.palette.error.main }}
                  >
                    Manager Reject
                  </Button>
                  </>
                  )}
                </Box>
              ) : null}
              {((userType ==3 || accessForApproveEstimateForClient) && details?.send_to_client != 0 && details?.client_approve == 1 && (details?.quotation_status === 2 || details?.quotation_status === 9) && details?.project_type!=null) ? (
              <Box sx={{ mt: 3,  display: 'flex', justifyContent: 'flex-end',gap:1 }}>
                  {details?.hold === 0 && (
                    <>
                      <Button type="submit" variant="contained" 
                       onClick={()=>setConfirmInvoice(true)}
                       >                 
                       Approve
                      </Button>
                      <Button size="small" variant="outlined"
                       onClick={()=>setRejectInvoice(true)}
                       sx={{color:theme.palette.error.main}} >
                        Reject
                      </Button>
                    </>
                  )}
                  <Button
                    onClick={() => setOpenHoldEstimate(true)}
                    sx={{
                      borderRadius: 20,
                      backgroundColor: theme.palette.warning.main,
                      color: 'black',
                      boxShadow: 'none',
                      '&:hover': {
                        backgroundColor: theme.palette.warning.dark,
                        boxShadow: 'none',
                      },
                    }}
                    variant="contained"
                  >
                    {details?.hold === 0 ? 'Hold' : 'Release from Hold'}
                  </Button>
                </Box>
              ) : null}
                {/* {(userType ==3&&details?.status!=4&&details?.onboard_complete==0) && 
                <Box sx={{ mt: 3,  display: 'flex', justifyContent: 'flex-end',gap:1 }}>
                  <Button type="submit" variant="contained" 
                   onClick={()=> navigate(PATH_DASHBOARD.official.process,{state:{requestId:id}})}
                  // onClick={()=>handleAcceptorRejectInvoice(1)}
                   >                 
                   Proceed to Workflow
                  </Button>
                 
                </Box>} */}
            </Scrollbar>
                      
          </Grid>
          </>
          )}
        </Modal>
        {/* delete popup */}
        <ConfirmationPopup 
        open={openDelete}
        loading={isLoading}
        handleClick={handleDeleteRFQ}
         handleClose={()=>{setOpenDelete(!openDelete),setIsOpen(false)}}
         message={'You want to delete this Estimate '}
        />

        <ConfirmationPopup
          open={openCancelNoJobConfirm}
          handleClick={confirmCancelWithoutJob}
          handleClose={() => setOpenCancelNoJobConfirm(false)}
          message={'Are you sure you want to cancel? This estimate will not appear in Estimate Job.'}
        />
        <ConfirmationPopup
          open={openVoid}
          handleClick={handleVoidEstimate}
          handleClose={() => {
            setOpenVoid(false);
            setVoidReason('');
            setVoidReasonError('');
          }}
          message={'You want to void this Estimate?'}
          warningMessage={'The estimate will remain in SignWise with a Void status. Linked estimate job operations will be locked until reopened.'}
          loading={loadingVoid}
          showReasonField
          reasonRequired
          reasonLabel="Reason for void"
          reasonValue={voidReason}
          reasonError={voidReasonError}
          onReasonChange={(value) => {
            setVoidReason(value);
            if (voidReasonError) setVoidReasonError('');
          }}
        />

        <ConfirmationPopup
          open={openReopenVoid}
          handleClick={handleReopenVoidEstimate}
          handleClose={() => setOpenReopenVoid(false)}
          message={'You want to reopen this voided estimate? It will be restored to its previous workflow status.'}
          loading={loadingReopenVoid}
        />

          <ConfirmationPopup
            open={openDuplicate}
            loading={isLoading} // ✅ only passed here
            handleClick={async () => {
              setIsLoading(true);
              await handleDuplicateSalesOrder();
              setIsLoading(false);
            }}
            handleClose={() => { setOpenDuplicate(false) }}
            message={'You want to duplicate this Estimate ?'}
          />
       
        {/* Accept request invoice */}
        <ConfirmationPopup 
        open={confirmInvoice}
        handleClick={()=>handleAcceptorRejectInvoice(1)}
         handleClose={()=>setConfirmInvoice(false)}
         message={'You want to Approve this Estimate '}
        />
        {/* Manager accept estimate */}
        <ConfirmationPopup
          open={confirmManagerAccept}
          handleClick={() => handleManagerAccept()}
          handleClose={() => setConfirmManagerAccept(false)}
          message={'Do you want to Approve ?'}
        />
        {/* reject request invoice */}
         {/* <ConfirmationPopup 
        open={invoiceReject}
        handleClick={()=>handleAcceptorRejectInvoice(2)}
         handleClose={()=>setRejectInvoice(false)}
         message={'You want to reject this invoice '}
        /> */}
        {/* Reopen rejected request  */}
        <ConfirmationPopup
         open={reOpen}
          handleClick={()=>handleReopeningRequest()}
        handleClose={()=>setReopen(false)}
        message={'You want to reopen this Estimate '}
        />
        <ConfirmationPopup
         open={convertRfq}
         loading={isLoading} // ✅ only passed here
        handleClick={async () => {
          setIsLoading(true);
          await convertToRFQ();
          setIsLoading(false);
        }}
        handleClose={()=>setConvertRfq(false)}
        message={'This Estimate will be converted and moved to Sales Order page '}
        />
        <ConfirmationPopup
         open={convertDesignOrder}
        handleClick={async () => {
          setConvertDesignOrder(false); // Close confirmation popup first
          await convertToDesignOrder(); // Then show progress modal
        }}
        handleClose={()=>setConvertDesignOrder(false)}
        message={'This Estimate will be converted and moved to Design Order page '}
        />

           <ViewProductFormulaModal
                  open={openProductFormulaModal}
                  onClose={() => setOpenProductFormulaModal(false)}
                  formulaId={selectedProductFormulaId}
                  user={user}
                  explodedPermissions={explodedPermissions}
                  onRecipeUpdated={(updatedRecipe) => {
                    fetchProducts();
                    
                    if (updatedRecipe && selectedProducts) {
                      setSelectedProducts(prevProducts => 
                        prevProducts.map(p => 
                          p.recipe_id === updatedRecipe.id 
                            ? { 
                                ...p, 
                                expected_material_cost_with_markup: updatedRecipe.expected_material_cost_with_markup,
                                expected_service_cost_with_markup: updatedRecipe.expected_service_cost_with_markup,
                                expected_install_labor_cost_with_markup: updatedRecipe.expected_install_labor_cost_with_markup,
                                expected_cost_with_markup: updatedRecipe.expected_cost_with_markup
                              } 
                            : p
                        )
                      );
                      setRefreshCalculation((v) => !v)
                    }
                  }}
                />
         {/* Preview Modal */}
        {openPreview && (
          <Modal
            open={openPreview}
            handleClose={() => {
              setOpenPreview(false);
            }}
            modalTitle={'Preview'}
          >
         
            <Grid container sx={{ justifyContent: 'center' }} spacing={3}>
              <Grid item xs={12} md={12}>
                <Stack
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                  }}
                  spacing={2}
                >
                   <Stack
                    direction={{ xs: 'column', md: 'row' }}
                    display="flex"
                    justifyContent="space-between"
                  >
                    <Typography variant="subtitle2">
                      <span style={{ color:theme.palette.primary.darker }}>Name: </span>
                      {previewData?.name}
                    </Typography>
                   
                    <Typography variant="subtitle2">
                    <span style={{ color:theme.palette.primary.darker }}>Use custom welcome message: </span>
                    {previewData.welcome_message==null?'No':previewData.welcome_message==false?'No':'Yes'}
                    </Typography>
                  </Stack>
                    <Stack>
                    <Typography variant="subtitle2" style={{ color:theme.palette.primary.darker }}>
                      Description:
                    </Typography>
                    <Typography variant="subtitle2" style={{ overflowWrap: 'break-word', wordWrap: 'break-word', wordBreak: 'break-word' }}>
                      {previewData?.description}
                    </Typography>
                    </Stack> 
                  <Stack
                    direction={{ xs: 'column', md: 'row' }}
                    display="flex"
                    justifyContent="space-between"
                  >
                    {/* <Typography variant="subtitle2">
                      <span style={{ color:theme.palette.primary.darker,
                        overflowWrap: 'break-word', wordWrap: 'break-word',
                         wordBreak: 'break-word' }}>Skills or services required:</span> <br/>
                          <List>
                           {previewData?.skills?.map((val, index) => (
                           <ListItem sx={{ listStyleType: 'disc', paddingLeft: '20px' }} key={index}>
                           <ListItemText primary={val.name} />
                           </ListItem>
                                   ))}
                                </List>
                    </Typography> */}
                    {/* <Typography variant="subtitle2">
                      <span style={{ color:theme.palette.primary.darker }}>Workflows: </span> <br/>                                           
                      <List>
                           {previewData?.workflow?.map((val, index) => (
                           <ListItem sx={{ listStyleType: 'dics', paddingLeft: '20px' }} key={index}>
                           <ListItemText primary={val.name} />
                           </ListItem>
                                   ))}
                                </List>
                    </Typography> */}
                  </Stack>
                  <Stack
                    direction={{ xs: 'column', md: 'row' }} 
                    display="flex"
                    justifyContent="space-between"                 
                  >
                    <Typography variant="subtitle2">
                      <span style={{ color:theme.palette.primary.darker }}>Job Class: </span> 
                      {previewData?.project_type?.name}
                    </Typography>
                    <Typography variant="subtitle2">
                      <span style={{ color:theme.palette.primary.darker,}}>Job Types: </span> 
                      {previewData?.project_category?.name}
                    </Typography>                
                  </Stack>

                  <Stack
                    direction={{ xs: 'column', md: 'row' }} 
                    display="flex"
                    justifyContent="space-between"                 
                  >
                    <Typography variant="subtitle2">
                      <span style={{ color:theme.palette.primary.darker }}>Project: </span>                      
                      {previewData?.community?.name}
                    </Typography>
                    <Typography variant="subtitle2">
                      <span style={{ color:theme.palette.primary.darker,}}>Markup Type: </span> 
                      {previewData?.markup_type?.name}
                    </Typography>                
                  </Stack>
                               
                  <Stack
                    direction={{ xs: 'column', md: 'row' }}
                    display="flex"
                    justifyContent="space-between"
                  >
                    <Typography variant="subtitle2">
                      <span style={{ color:theme.palette.primary.darker }}>Start Date: </span>
                      {formatDateOnly(previewData.start)}
                    </Typography>
                    <Typography variant="subtitle2">
                      <span style={{ color:theme.palette.primary.darker }}>Installation Date: </span>
                      {previewData.end ? formatDateOnly(previewData.end) : 'Not set'}
                    </Typography>
                    {previewData.installation_start_date && (
                      <Typography variant="subtitle2">
                        <span style={{ color:theme.palette.primary.darker }}>Installation Start: </span>
                        {formatDateOnly(previewData.installation_start_date)}
                      </Typography>
                    )}
                    {previewData.installation_end_date && (
                      <Typography variant="subtitle2">
                        <span style={{ color:theme.palette.primary.darker }}>Installation End: </span>
                        {formatDateOnly(previewData.installation_end_date)}
                      </Typography>
                    )}
                  </Stack>  
                  <LabelStyle>Products</LabelStyle>            
                  <Scrollbar>
                        <TableContainer sx={{ minWidth: 500 }}>
                          <Table>
                            <TableHead>
                              <TableRow>
                                {/* {VALUEPreview?.map((val) => (
                                  <TableCell>{val.value}</TableCell>
                                ))} */}
                                {VALUEPreview?.filter((val) => canViewCosts || ![3, 4, 5, 8, 9, 11, 14].includes(val.id))?.map((val) => (
                                  val.id === 14 ? (
                                    <Tooltip key={val.id} title="Selling Price With Marketing Adjustment">
                                      <TableCell>{val.value}</TableCell>
                                    </Tooltip>
                                  )
                                  : (
                                  <TableCell key={val.id}>{val.value}</TableCell>
                                  )
                                ))}
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {productTableBodyRenderOrder.map((bodyItem, index) => {
                                const displaySlNo = index + 1
                                if (bodyItem.type === 'group') {
                                  const group = groupedProductsMap.get(bodyItem.groupId)
                                  if (!group) return null
                                  const groupMemberProducts = (selectedProducts || []).filter(
                                    (p) =>
                                      String(resolveProductGroupId(p) || '') === String(group.id),
                                  )
                                  const groupDisplayNote =
                                    groupMemberProducts.find(
                                      (p) =>
                                        p?.product_notes != null &&
                                        String(p.product_notes).trim() !== '',
                                    )?.product_notes || ''
                                  const groupRetailEach = Number(group.adjustedGroupRetailEach || 0)
                                  const groupSubTotal = Number(group.adjustedGroupSubtotal || 0)
                                  return (
                                    <TableRow key={`preview-group-${group.id}`}>
                                      <TableCell>#{displaySlNo}</TableCell>
                                      <TableCell sx={{ fontWeight: 700 }}>
                                        <Box>
                                          <Typography sx={{ fontWeight: 700 }}>
                                            {group.name || 'Group'}
                                          </Typography>
                                          {groupDisplayNote ? (
                                            <Typography
                                              sx={{
                                                color: theme.palette.error.main,
                                                whiteSpace: 'pre-wrap',
                                              }}
                                            >
                                              Note: {groupDisplayNote}
                                            </Typography>
                                          ) : null}
                                        </Box>
                                      </TableCell>
                                      {canViewCosts && (
                                        <TableCell>
                                          {hasMarkupPermission && markupType == 2 ? groupRetailEach.toFixed(2) : null}
                                        </TableCell>
                                      )}
                                      {canViewCosts && (
                                        <TableCell>
                                          {hasMarkupPermission && markupType == 1 ? groupRetailEach.toFixed(2) : null}
                                        </TableCell>
                                      )}
                                      {canViewCosts && <TableCell />}
                                      {canViewCosts && <TableCell />}
                                      <TableCell>{Number(group.groupQuantity || 1)}</TableCell>
                                      <TableCell align="center">-</TableCell>
                                      {canViewCosts && <TableCell>-</TableCell>}
                                      {canViewCosts && <TableCell>{groupSubTotal.toFixed(2)}</TableCell>}
                                    </TableRow>
                                  )
                                }
                                const data = selectedProducts.find((p) => p.indexId === bodyItem.indexId)
                                if (!data) return null
                                const quantityFieldName = `quantity_${data.product_id||data.id}`;
                                const discountFieldName = `discount_${data.product_id||data.id}`;
                                let unitName = UNITS?.filter((item)=>item?.id==data?.unit)
                                unitName = unitName[0]?.name
                                let shortUnitName = ''
                                if(unitName=='Square feet'){
                                  shortUnitName =  'Sq ft'
                                }else if(unitName=='Lineal feet'){
                                  shortUnitName = 'Lin ft'
                                }else if(unitName=='Square Inches'){
                                  shortUnitName = 'Sq Inches'
                                }else if(unitName=='Unit'){
                                  shortUnitName = 'Unit'
                                }
                                const dataPrice = data.actual_retail_price || data.product_price||data.price
                                const dataWholesalePrice = data.product_price||data.price
                                const dataQuantity = values[quantityFieldName]
                                const dataDiscount = data.discount?data.discount:values[discountFieldName]
                                const dataretailPrice = data.product_retail_price||data.retail_price
                                // const markup = ((dataretailPrice - dataPrice) / dataPrice) * 100;
                                const rowTotal = calculateTotal(markupType == 1 ? dataPrice : (markupType == 2 ? dataretailPrice : 0), dataQuantity, dataDiscount,data.quantity,data.locationQuantity, Number(data?.adjustment),data.adj_value_type);
                                const invoiceAmount = parseFloat(data?.expected_material_cost?.toFixed(2)) + parseFloat(data?.expected_total_service_cost?.toFixed(2))
                                let markup = markupType ? (invoiceAmount / rowTotal) : null
                                markup = markup ? Number(markup) : 0
                                // data['markup'] = Math.round(markup)
                                console.log("###########Discount",data);
                                return (                             
                                 <TableRow key={`preview-product-${data.indexId}`}>
                                    <TableCell>#{displaySlNo}</TableCell>
                                    <TableCell>{data.product_name||data.name}</TableCell>
                                    {/* <TableCell>{invoiceAmount}</TableCell> */}
                                    {canViewCosts && <TableCell>{(hasMarkupPermission && markupType == 2) ? dataretailPrice : null}</TableCell>}
                                    {canViewCosts && <TableCell>{(hasMarkupPermission && markupType == 1) ? dataPrice : null}</TableCell>}
                                    {canViewCosts && <TableCell>{hasMarkupPermission ? (data?.SPMA || null) : null}</TableCell>}
                                    {canViewCosts && <TableCell>
                                      {/* {hasMarkupPermission ? (data.markup ? data.markup?.toFixed(2) : 0) : null} */}
                                            {(hasMarkupPermission && markupType == 1) ? data.wholesaleMarkup
                                              : (hasMarkupPermission && markupType == 2) ? data.retailMarkup
                                                : null}
                                          </TableCell>}
                                    {/* <TableCell>{shortUnitName}</TableCell> */}
                                    <TableCell>
                                  <TextField required
                                    fullWidth
                                    type='  '
                                    sx={{width:85}}
                                    disabled
                                    label={shortUnitName}
                                    value={Number(data.quantity)}
                                    defaultValue={1}
                                  />
                                </TableCell>
                                    <TableCell>
                                      <TextField required
                                        fullWidth
                                        type='number'
                                        disabled
                                        sx={{width:85}}
                                        label={'Qty'}                                    
                                        value={Number(data.locationQuantity)}
                                        defaultValue={1}                                                                                                              
                                      />
                                    </TableCell>                                 
                                    {/* <TableCell>{data.id}</TableCell> */}
                                    {canViewCosts && <TableCell align="center">
                                      {/* <TextField
                                        disabled
                                        type="number"
                                        label="Discount"
                                        defaultValue={0}   
                                        value={Number(data.discount)?.toFixed(2)}                                  
                                        // {...getFieldProps(discountFieldName)}
                                      /> */}
                                      {/* {Number(data.discount)?.toFixed(2)} */}
                                      {data?.adjustment ? Number(data?.adjustment)?.toFixed(2) : 0}
                                    </TableCell>}
                                    {canViewCosts && <TableCell>
                                      {rowTotal?.toFixed(2)}
                                    </TableCell>}                               
                                  </TableRow>                                                        
                                );
                              })}
                  
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Scrollbar>
                      <LabelStyle>Services</LabelStyle>
                      <Scrollbar>
                        <TableContainer sx={{ minWidth: 500 }}>
                          <Table>
                            <TableHead>
                              <TableRow>
                                {VALUE_SERVICES?.filter((val) => canViewCosts || ![3, 4, 5, 7, 8, 9].includes(val.id))?.map((val) => (
                                  <TableCell>{val.value}</TableCell>
                                ))}
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {selectedServices?.map((data, index) => {
                                const dataCost = getServiceHourlyCost(data)
                                let originalMarkup=data.originalMarkup||0
                                let markup=data.markup||0
                                const total = dataCost * data.quantity
                                data['total'] = total?.toFixed(2)
                                console.log("###########data total",data);
                                let qtyData = data.qtyData || 1
                                console.log("############qtyData", qtyData);
                                const newQty = (data.prQty * qtyData * data.locationQuantity || 1)?.toFixed(2)
                                console.log("############newQty", newQty);
                                const quantityDifference = Number(data.quantity) - newQty;
                                data['quantityDifference'] = quantityDifference
                                return (
                                  <>
                                    <TableRow key={index}>
                                    <TableCell>#{index + 1}</TableCell>
                                    <TableCell>{data.name}</TableCell>
                                    <TableCell>
                                      <IconButton onClick={() => handleOpenServiceNote(data.indexId, data.service_notes)}>
                                        <NoteAdd
                                          sx={{
                                            color: (!data?.service_notes || data?.service_notes === '') ? '' : theme.palette.primary.main,
                                          }}
                                        />
                                      </IconButton>
                                    </TableCell>
                                    {canViewCosts && <TableCell>{originalMarkup?.toFixed(2)}</TableCell>}
                                    {canViewCosts && <TableCell>{data.cost}</TableCell>}
                                    {canViewCosts && <TableCell>{dataCost}</TableCell>}
                                    <TableCell>{data.quantity}</TableCell>
                                    {canViewCosts && <TableCell>{(data.cost*quantityDifference?.toFixed(2))?.toFixed(2)}</TableCell>}
                                    {canViewCosts && <TableCell>{(data.unit_cost * quantityDifference?.toFixed(2))?.toFixed(2)}</TableCell>}
                                    ${fUSPrice(canViewCosts && <TableCell>{data.total}</TableCell>)}
                                    <TableCell></TableCell>
                                    <TableCell align='right'>
                                    </TableCell>
                                  </TableRow>
                                  </>
                                );
                              })}
                              {displayAdditionalServicesForView?.map((data, index) => {
                                const dataCost = getServiceHourlyCost(data)
                                const total = dataCost *(data?.quantity || 1)
                                data['total'] = total ? total?.toFixed(2) : 0.00
                                let originalMarkup=data.originalMarkup||0
                                console.log("###########data total",data);
                                return (                             
                                 <TableRow key={data.id}>
                                    <TableCell></TableCell>
                                    <TableCell>{data.name || data.service_name}</TableCell>
                                    <TableCell>
                                      <IconButton onClick={() => handleOpenServiceNote(data.newIndexId || data.indexId, data.service_notes)}>
                                        <NoteAdd
                                          sx={{
                                            color: (!data?.service_notes || data?.service_notes === '') ? '' : theme.palette.primary.main,
                                          }}
                                        />
                                      </IconButton>
                                    </TableCell>
                                    {canViewCosts && <TableCell>{originalMarkup?.toFixed(2)}</TableCell>}
                                    {canViewCosts && <TableCell>{data.cost}</TableCell>}
                                    {canViewCosts && <TableCell>{formatServiceHourlyCost(data)}</TableCell>}
                                    <TableCell>{data?.quantity || 1}</TableCell>
                                    {canViewCosts && <TableCell>{data.total}</TableCell>}
                                    <TableCell></TableCell>
                                  </TableRow>                                                        
                                );
                              })}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Scrollbar>
                      <Divider />
                      <Stack>
                    <Typography variant="subtitle2" style={{ color:theme.palette.primary.darker }}>
                     Notes:
                    </Typography>
                    <Typography variant="subtitle2" sx={{ overflowWrap: 'break-word', wordWrap: 'break-word', wordBreak: 'break-word',color:'error.main' }}>
                    <Scrollbar
                                  sx={{
                                    maxHeight: 200,
                                    '& .simplebar-content': {
                                      maxHeight: 200,
                                      display: 'flex',
                                      flexDirection: 'column',
                                    },
                                  }}
                                >{previewData?.notes}</Scrollbar>
                    
                    </Typography>
                    </Stack> 
                      <Stack
                    direction={{ xs: 'column', md: 'row' }}
                    display="flex"
                    justifyContent="space-between"
                  >
                    {/* <Typography variant="subtitle2">
                      <span style={{ color:theme.palette.primary.darker }}>Total Price: </span>
                      {totalsum < 0 ? 0 : totalsum?.toFixed(2)}
                    </Typography> */}

                    <Typography variant="subtitle2">
                      <span style={{ color: theme.palette.primary.darker }}>Grand Total: </span>
                      {canViewCosts ? (grandTotal ? (grandTotal < 0 ? 0.00 : parseFloat(grandTotal)?.toFixed(2)) : 0.00) : '—'}
                    </Typography>
                    
                    {/* <Tooltip title="Sub Total - Total Product Formula Cost">
                      <Typography variant="subtitle2" sx={{ cursor:'pointer'}}>
                        <span style={{ color:theme.palette.primary.darker }}>Total Markup Amount: </span>
                        {totalMarkupAmount ? totalMarkupAmount?.toFixed(2) : 0}
                      </Typography>
                    </Tooltip>

                    <Tooltip title="(Total Markup Amount / Total Product Formula Cost) * 100">
                      <Typography variant="subtitle2" sx={{ cursor:'pointer'}}>
                        <span style={{ color:theme.palette.primary.darker }}>Total Markup Percentage: </span>
                        {totalMarkupPercentage ? totalMarkupPercentage?.toFixed(2) : 0}
                      </Typography>
                    </Tooltip> */}

                    {/* <Typography variant="subtitle2">
                      <span style={{ color:theme.palette.primary.darker }}>Total Service Markup: </span>
                      {totalServiceMarkup ? totalServiceMarkup?.toFixed(2) : 0}
                    </Typography> */}
                    {/* Discount hidden — restore when needed
                    <Typography variant="subtitle2">
                      <span style={{ color:theme.palette.primary.darker }}>Total Discount: </span>
                      {canViewCosts ? (DiscountTotal ? DiscountTotal?.toFixed(2) : 0.00) : '—'}
                    </Typography>
                    */}
                  </Stack>    
                  <Stack
                    direction={{ xs: 'column', md: 'row' }}
                    display="flex"
                    justifyContent="space-between"
                  >            
                    <Typography variant="subtitle2">
                    <Label
                      variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                      color={getStatusColorAndLabel(previewData?.quotation_status ?? details?.quotation_status, previewData?.quotation ?? details?.quotation, previewData?.estimate_job_status ?? details?.estimate_job_status, previewData?.hold ?? details?.hold, previewData?.manager_approval_required ?? details?.manager_approval_required, previewData?.send_to_client ?? details?.send_to_client, previewData?.send_for_manager_approval ?? details?.send_for_manager_approval, previewData?.is_request_estimate ?? details?.is_request_estimate, details).color} >
                       {getStatusColorAndLabel(previewData?.quotation_status ?? details?.quotation_status, previewData?.quotation ?? details?.quotation, previewData?.estimate_job_status ?? details?.estimate_job_status, previewData?.hold ?? details?.hold, previewData?.manager_approval_required ?? details?.manager_approval_required, previewData?.send_to_client ?? details?.send_to_client, previewData?.send_for_manager_approval ?? details?.send_for_manager_approval, previewData?.is_request_estimate ?? details?.is_request_estimate, details).label}
                   </Label>
                    </Typography>
                    {(() => {
                      const base = (previewData && Object.keys(previewData).length > 0) ? previewData : details;
                      const status = base?.quotation_status ?? details?.quotation_status;
                      if (status !== 6 && status !== 11) return null;

                      const hasManagerReject = !!base?.manager_reject_reason || !!base?.manager_reject_file;
                      const displayReason = hasManagerReject
                        ? (base?.manager_reject_reason || base?.reason || '')
                        : (base?.reason || '');
                      const displayRejectFile = hasManagerReject
                        ? (base?.manager_reject_file || base?.reject_file || null)
                        : (base?.reject_file || null);
                      const displayRejectFileType = hasManagerReject
                        ? (base?.manager_reject_file_type || base?.reject_file_type || null)
                        : (base?.reject_file_type || null);

                      if (!displayReason && !displayRejectFile) return null;

                      return (
                        <>
                          {displayReason && (
                            <Typography variant="subtitle2" color={'error'}>
                              Reason :{displayReason}
                            </Typography>
                          )}
                          {/* {displayRejectFile && (
                            displayRejectFileType === 'application/pdf' ? (
                              <Button
                                size="small"
                                variant="outlined"
                                color="primary"
                                sx={{ mt: 0.5 }}
                                onClick={() => window.open(displayRejectFile, '_blank')}
                              >
                                View Attached File (PDF)
                              </Button>
                            ) : (
                              <Box
                                component="img"
                                src={displayRejectFile}
                                onClick={() => window.open(displayRejectFile, '_blank')}
                                sx={{
                                  mt: 0.5,
                                  width: 120,
                                  height: 120,
                                  borderRadius: 1,
                                  border: '1px solid #ccc',
                                  cursor: 'pointer',
                                  objectFit: 'cover'
                                }}
                              />
                            )
                          )} */}
                        </>
                      );
                    })()}
                  </Stack>

                </Stack>
              </Grid>
            </Grid>
          </Modal>
        )}
         {/* reject request invoice */}
        { invoiceReject==true &&<Dialog
        open={invoiceReject}
         onClose={()=>{setRejectInvoice(false)}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        BackdropComponent={Backdrop}
        BackdropProps={{ invisible: true }}
      >
        <DialogTitle id="alert-dialog-title">
          {"Are you sure ?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            You want to reject this Estimate 
          </DialogContentText>
          <TextField
            sx={{
              width: '100%',
              mt: 2,
              bgcolor: 'rgba(255,255,255,0.02)',
              borderRadius: 1,
              input: { color: '#fff' },
              '& .MuiInputLabel-root': { color: 'grey.400' }
            }}
            label="Reason For Rejection"
            type="text"
            fullWidth
            multiline
            minRows={3}
            maxRows={7}
            onInput={(event)=>setReason(event.target.value)}
          />
          <UploadMultiFile
            showPreview
            files={rejectFile ? [rejectFile] : []}
            // accept="image/*,application/pdf"
            maxSize={1024 * 1024 * 1024}
            multiple={false}
            onDrop={handleRejectFileDrop}
            onRemove={() => setRejectFile(null)}
            onRemoveAll={() => setRejectFile(null)}
            isUploading={isUploadingRejectFile}
            sx={{ mt: 2 }}
          />
        </DialogContent>
        <DialogActions>
          <LoadingButton size="small" variant="contained"
            loading={rejectInvoiceLoading}
            loadingIndicator={<CircularProgress size={20} sx={{ color: theme.palette.error.main }} />}
          onClick={()=>handleAcceptorRejectInvoice(2)}
            sx={{ color: theme.palette.background.paper }}
          disabled={rejectInvoiceLoading || isUploadingRejectFile}>
            {rejectInvoiceLoading ? 'Rejecting...' : 'OK'}
          </LoadingButton>

          <Button size="small" variant="outlined"
          onClick={()=>{setRejectInvoice(false); setReason(''); setRejectFile(null);}}
            disabled={rejectInvoiceLoading}
           sx={{color:theme.palette.error.main}}
           >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>}
       {/* hold estimate */}
        {openHoldEstimate && (
        <Dialog
        open={openHoldEstimate}
        onClose={() => {
          setOpenHoldEstimate(false);
          setHoldReason('');
          setHoldReasonError('');
        }}
        aria-labelledby="hold-dialog-title"
        aria-describedby="hold-dialog-description"
        BackdropComponent={Backdrop}
        BackdropProps={{ invisible: true }}
      >
        <DialogTitle id="hold-dialog-title">
          {details?.hold === 1 ? 'Remove from Hold?' : 'Move to Hold?'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="hold-dialog-description">
            {details?.hold === 1
              ? 'You want to move this Estimate from Hold.'
              : 'You want to move this Estimate to Hold.'}
          </DialogContentText>
          {(details?.hold === 0) ? (
            <TextField
              sx={{ width: 400 }}
              label="Reason"
              type="text"
              multiline
              minRows={3}
              maxRows={7}
              value={holdReason}
              onChange={(e) => {
                setHoldReason(e.target.value);
                if (holdReasonError) setHoldReasonError('');
              }}
              error={Boolean(holdReasonError)}
              helperText={holdReasonError}
            />
          ) : ''}
        </DialogContent>
        <DialogActions>
          <Button
            type="button"
            size="small"
            variant="contained"
            onClick={async (e) => {
              e.preventDefault();
              e.stopPropagation();
              if ((details?.hold === 0) && !holdReason.trim()) {
                setHoldReasonError('Reason is required to put this Estimate on Hold');
                return;
              }
              await handleUpdateEstimateHoldStatus(details?.hold === 1 ? '' : holdReason);
            }}
            disabled={holdEstimateLoading}
          >
            {holdEstimateLoading ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              'OK'
            )}
          </Button>
          <Button
            size="small"
            variant="outlined"
            onClick={() => {
              setOpenHoldEstimate(false);
              setHoldReason('');
              setHoldReasonError('');
            }}
            sx={{ color: theme.palette.error.main }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
        )}
       {/* reject request invoice */}
                    <Dialog open={openDialog} >
                <DialogTitle>Select Stock Type</DialogTitle>
                <DialogContent>
                  <RadioGroup
                    value={String(stockType)}
                    onChange={(e) => {
                      const val = e.target.value;
                      setStockType(val === '1' ? 1 : 2);
                      if (val === '1') setConvertionUnit(0);
                    }}
                  >
                    <FormControlLabel value="1" control={<Radio />} label="Finished Product" />
                    <FormControlLabel value="2" control={<Radio />} label="Partial Finished Product" />
                  </RadioGroup>
            
                  {stockType === 2 && (
                    partialProducts.length > 0 ? (
                      <>
                        <Typography>Select Conversion Unit</Typography>
                        <RadioGroup
                          value={convertionUnit}
                          onChange={(e) => setConvertionUnit(Number(e.target.value))}
                        >
                          {UNITS
                            .filter(u => partialProducts.some(p => p.partial_unit === u.id))
                            .map(u => (
                              <FormControlLabel
                                key={u.id}
                                value={u.id}
                                control={<Radio />}
                                label={u.name}
                              />
                            ))}
                        </RadioGroup>
                      </>
                    ) : (
                      <Typography color="error">No partial stock found</Typography>
                    )
                  )}
                </DialogContent>
                <DialogActions>
                  <Button onClick={closeDialog} color="error">Cancel</Button>
                  <Button
                    onClick={handleSubmitPopUp}
                    disabled={stockType === 2 && partialProducts.length === 0}
                    variant="contained"
                  >
                    Add Material
                  </Button>
                </DialogActions>
              </Dialog>
        </Container>}
      {/* Progress Modal */}
      {/* <RequestProgressModal
        open={showProgressModal}
        onClose={() => setShowProgressModal(false)}
        requestData={progressRequestData}
        onSocketReady={setSocketReady}
        heading={progressRequestData?.processType === 'update_draft' ? `Saving estimate as draft` : (progressRequestData?.processType === 'update_estimate' ? `Updating Estimate` : (progressRequestData?.processType === 'estimate_job' ? `Estimate Job` : (progressRequestData?.processType === 'duplicate_estimate' ? `Duplicating Estimate` : (progressRequestData?.processType === 'design_order' ? `Converting Estimate to Design Order` : `Converting Estimate to Sales Order`))))}
      /> */}

        <RequestProgressModal
          open={showProgressModal}
          onClose={() => setShowProgressModal(false)}
          requestData={progressRequestData}
          heading={'Estimate'}
          message="We're processing your request. Please wait..."
        />
      <Dialog fullScreen open={isOpenEdit}  TransitionComponent={Transition}>
        <AppBar position="relative" mb={1}>
          <Toolbar sx={{ minHeight: '48px !important', py: 0.5 }}>
            <Typography variant="subtitle1" sx={{ flex: 1, ml: 1, fontSize: '1rem' }}>
              {details?.is_create_estimate == 1 ? 'Edit Estimate' : 'Create Estimate'}
            </Typography>
              <Close onClick={() => setIsOpenEdit(false)} sx={{fontSize:'1.8rem',cursor:'pointer'}}/>
          </Toolbar>
        </AppBar>
        <EditEstimateJob 
          setIsOpenEdit={setIsOpenEdit} 
          estimateId={id} 
          isEditEstimateJob={true} 
          setRefreshRFQData={setRefresh} 
          refreshRFQData={refresh} 
          setRenderCards={setRenderCards}
          renderCards={renderCards}
          setJustSubmittedEstimate={setJustSubmittedEstimate}
        />
      </Dialog>
    </Page>
  )
}

const PrintFunction = forwardRef(({userType, invoiceDate, details, additionalSelectedServices,invoice, openInvoice,cartService,invoiceSelectedServices, data,labourInstallService, customerOrderProductGroups }, ref) => {
  const theme = useTheme();
  const {COMPANY_LOGO,COMPANY_NAME} = useCompanyProfile()
  const showInstallPriceInView = details?.show_install_price === 1;

  const getProductGroupId = (product) => product?.group_id ?? product?.customer_order_product_group_id ?? product?.groupId ?? null;

  const getProductLineTotalExcludingInstall = (product) => {
    const quantity = Number(product?.quantity) || 1
    const locationQuantity = Number(product?.locationQuantity) || 1
    const installCost = Number(product?.install_cost) || 0
    let spma = Number(product?.product_retail_price || 0)
    if (Number(product?.material) === 1) {
      const adjustment = Number(product?.adjustment || 0)
      spma += Number(product?.adj_value_type) === 1 ? adjustment : -adjustment
    }
    if (installCost) {
      return (Number(product?.actual_retail_price) || 0) * (locationQuantity * quantity)
    }
    if (Number(product?.material) === 1) {
      return spma * locationQuantity
    }
    return spma * (locationQuantity * quantity)
  }

  const getProductDisplayTotal = (product) => {
    const quantity = Number(product?.quantity) || 1
    const locationQuantity = Number(product?.locationQuantity) || 1
    const installQty = Number(product?.install_qty ?? product?.install_quantity ?? 1) || 1
    const installCost = Number(product?.install_cost) || 0
    let spma = Number(product?.product_retail_price || 0)
    if (Number(product?.material) === 1) {
      const adjustment = Number(product?.adjustment || 0)
      spma += Number(product?.adj_value_type) === 1 ? adjustment : -adjustment
    }
    const productTotal = installCost
      ? (Number(product?.actual_retail_price) || 0) * (locationQuantity * quantity)
      : Number(product?.material) === 1
      ? spma * locationQuantity
      : spma * (locationQuantity * quantity)
    const installTotal = installCost * installQty
    return Number(productTotal || 0) + Number(installTotal || 0)
  }

  const groupedInvoiceDisplayRows = React.useMemo(() => {
    const source = invoice?.cust_product || []
    const groupMetaById = new Map(
      (customerOrderProductGroups || []).map((g) => [
        String(g?.id ?? g?.group_id),
        g,
      ]),
    )
    const out = []
    const seenGroups = new Set()
    const printMarkupType =
      markupTypes?.find((cat) => details?.markup_type === cat?.id)?.id ?? 2

    source.forEach((product) => {
      const rawGroupId = getProductGroupId(product)
      if (!rawGroupId) {
        out.push(product)
        return
      }
      const groupId = String(rawGroupId)
      if (seenGroups.has(groupId)) return
      seenGroups.add(groupId)
      const members = source.filter((item) => String(getProductGroupId(item) || '') === groupId)
      const representative = members?.[0] || product
      const groupMeta = groupMetaById.get(groupId) || {}
      const metaProdQty = groupMeta.product_marketing_quantity ?? groupMeta.productMarketingQuantity
      const groupProductDisplayQty = Math.max(
        1,
        Number(
          representative?.locationQuantity ??
            metaProdQty ??
            1,
        ) || 1,
      )
      const memberInstallQtySum = members.reduce((sum, m) => {
        if (!(Number(m?.install_cost) > 0)) return sum
        return sum + (Number(m?.install_qty ?? m?.install_quantity ?? 1) || 1)
      }, 0)
      const metaInstQty = groupMeta.install_marketing_quantity ?? groupMeta.installMarketingQuantity
      const groupInstallDisplayQty = Math.max(
        1,
        Number(
          representative?.install_quantity ??
            representative?.install_qty ??
            metaInstQty ??
            (memberInstallQtySum || 1) ??
            1,
        ) || 1,
      )

      const totalProductRetailEach = members.reduce(
        (sum, p) =>
          sum +
          Number(
            printMarkupType == 2
              ? p?.actual_retail_price || p?.retail_price || p?.product_retail_price || 0
              : printMarkupType == 1
                ? p?.product_price || p?.price || p?.wholesale_price || 0
                : p?.actual_retail_price || p?.product_retail_price || p?.retail_price || 0,
          ),
        0,
      )
      const totalInstallRetailEach = members.reduce(
        (sum, p) => sum + Number(p?.install_cost || 0),
        0,
      )

      const groupQuantity = groupProductDisplayQty
      const groupInstallQuantity = groupInstallDisplayQty

      const groupAdjustment = Number(
        groupMeta.product_marketing_adjustment ?? groupMeta.productMarketingAdjustment ?? 0,
      )
      const groupAdjValueType =
        groupMeta.product_marketing_adj_value_type ??
        groupMeta.productMarketingAdjValueType ??
        representative?.adj_value_type ??
        true
      const groupInstallAdjustment = Number(
        groupMeta.install_marketing_adjustment ?? groupMeta.installMarketingAdjustment ?? 0,
      )
      const groupInstallAdjValueType =
        groupMeta.install_marketing_adj_value_type ??
        groupMeta.installMarketingAdjValueType ??
        representative?.install_adj_value_type ??
        true

      const productSignedAdj =
        groupAdjValueType === false || Number(groupAdjValueType) === 0
          ? -groupAdjustment
          : groupAdjustment
      const installSignedAdj =
        groupInstallAdjValueType === false || Number(groupInstallAdjValueType) === 0
          ? -groupInstallAdjustment
          : groupInstallAdjustment

      const adjustedGroupRetailEach = totalProductRetailEach + productSignedAdj
      const adjustedGroupInstallRetailEach = totalInstallRetailEach + installSignedAdj
      const adjustedGroupSubtotal = adjustedGroupRetailEach * groupQuantity
      const adjustedGroupInstallSubtotal = adjustedGroupInstallRetailEach * groupInstallQuantity
      const adjustedGroupTotal = Math.max(0, adjustedGroupSubtotal + adjustedGroupInstallSubtotal)

      out.push({
        __type: 'group',
        groupId,
        representative,
        members,
        groupMeta,
        groupProductDisplayQty,
        groupInstallDisplayQty,
        groupInstallSubtotal: adjustedGroupInstallSubtotal,
        totalValue: adjustedGroupTotal,
        groupProductOnlyTotal: adjustedGroupSubtotal,
        adjustedGroupSubtotal,
        adjustedGroupInstallSubtotal,
        adjustedGroupTotal,
        groupAdjustment,
        groupInstallAdjustment,
      })
    })
    const isMaterialRow = (row) =>
      row?.__type === 'group'
        ? Number(row?.representative?.material) === 1
        : Number(row?.material) === 1
    return out.sort((a, b) => Number(isMaterialRow(a)) - Number(isMaterialRow(b)))
  }, [invoice?.cust_product, customerOrderProductGroups, details?.markup_type])

  const getPrintInvoiceNonGroupProductTotal = React.useCallback((val) => {
    const {
      markAdjType,
      material = 0,
      adjustment = 0,
      adj_value_type,
      actual_retail_price,
      product_retail_price,
      locationQuantity = 1,
      quantity = 1,
    } = val
    const basePrice =
      actual_retail_price !== 0 && actual_retail_price != null
        ? actual_retail_price
        : product_retail_price
    let SPMA = markAdjType === 2 || markAdjType === 3 ? basePrice : basePrice
    if (material === 1) {
      SPMA = Number(SPMA) + (Number(adj_value_type) === 1 ? Number(adjustment) : -Number(adjustment))
    }
    if (markAdjType === 1 && material === 0) {
      return SPMA * (locationQuantity * quantity)
    }
    return material === 1 ? SPMA * locationQuantity : SPMA * (locationQuantity * quantity)
  }, [])

  const printInvoiceProductTotalFromRows = React.useMemo(
    () =>
      (groupedInvoiceDisplayRows || []).reduce((sum, row) => {
        if (row?.__type === 'group') {
          const groupInstallSubtotal = Number(row?.groupInstallSubtotal ?? 0)
          const groupHasInstall = groupInstallSubtotal > 0
          return (
            sum +
            (groupHasInstall ? Number(row?.groupProductOnlyTotal ?? 0) : Number(row?.totalValue ?? 0))
          )
        }
        return sum + getPrintInvoiceNonGroupProductTotal(row)
      }, 0),
    [groupedInvoiceDisplayRows, getPrintInvoiceNonGroupProductTotal],
  )

  const printInvoiceInstallTotalFromRows = React.useMemo(
    () =>
      (groupedInvoiceDisplayRows || []).reduce((sum, row) => {
        if (row?.__type === 'group') {
          return sum + Number(row?.groupInstallSubtotal ?? 0)
        }
        const installCost = parseFloat(row?.install_cost || 0)
        const qty = parseFloat(row?.install_qty ?? row?.install_quantity ?? 1) || 1
        if (installCost) return sum + installCost * qty
        return sum
      }, 0),
    [groupedInvoiceDisplayRows],
  )

  const printInvoiceCustProductSubtotalForServices = React.useMemo(
    () => printInvoiceProductTotalFromRows + printInvoiceInstallTotalFromRows,
    [printInvoiceProductTotalFromRows, printInvoiceInstallTotalFromRows],
  )

  return (
    <Stack ref={ref}>
      <Grid container spacing={3} sx={{ position: 'relative' }}>
      <Box sx={{ display: 'flex', justifyContent: 'center', position: 'absolute', top: 0, left: 0, right: 0 }}>
        <Typography variant="h1" className="quotation-heading-print">Estimate</Typography>
      </Box>
      <Grid item xs={12} sm={6} sx={{ mb: 5, display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
          <Box component="img" alt="logo" id="logoImage" src={COMPANY_LOGO} sx={{ height: 98, alignSelf: 'flex-start' }} />
        </Grid>
        <Grid item xs={12} sm={6} sx={{ mb: 5, display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
          {/* <Typography variant="h1">Invoice from:</Typography> */}
          <Typography variant="h3">{COMPANY_NAME}</Typography>
          <Typography variant="h3">www.{COMPANY_NAME}.com</Typography>
          <Typography variant="h4">
            {data?.address}<br /> {data?.city}<br /> {data?.state}, {data?.zipcode}
          </Typography>
          {/* <Typography variant="h4">Telephone: +15208362947</Typography> */}
          <Typography variant="h4">Telephone: {data?.phone ? `+${data?.phone_country_code}${data?.phone}` : ''}</Typography>
        </Grid>
      </Grid>

      <Grid container spacing={2}>
      {/* <Grid id="right" item xs={12} sm={6} >
        <Box sx={{ mb: 5, display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
          <Typography variant="h3">Order date: {invoiceDate}</Typography>
          
          <Typography variant="h3">Title: {details?.name}</Typography>
          <Typography variant="h3">Order ID: {details?.id}</Typography>
          <Typography variant="h3" sx={{ marginTop: '20px' }}>To: {invoice?.customer_name}</Typography>
          <Typography variant="h3">Phone: {invoice?.customer_phone}</Typography>
          </Box>
        </Grid> */}

        <Grid id="total1"  item xs={12} sm={6} >
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>        
        <Box id="order" style={{ display: 'flex', alignItems: 'center',justifyContent:'space-between'  }}>
          <Typography id="discount1" variant="h5" style={{ textAlign:'left'}}>Order date:</Typography>
          <Typography variant="h5">{invoiceDate}</Typography>
        </Box>
        <Box id="title" style={{ display: 'flex', alignItems: 'center',justifyContent:'space-between' }}>
          <Typography id="discount1" variant="h5" style={{ textAlign:'left'}}>Job Name:</Typography>
              <Typography variant="h5"
                style={{
                  maxWidth: '200px',
                  wordBreak: 'break-word',
                  whiteSpace: 'normal',
                  textAlign: 'left',
                }}>{details?.name}</Typography>
        </Box>
        <Box id="title" style={{ display: 'flex', alignItems: 'center',justifyContent:'space-between' }}>
          <Typography id="discount1" variant="h5" style={{ textAlign:'left'}}>Project Name:</Typography>
          <Typography variant="h5"
                style={{
                  maxWidth: '200px',
                  wordBreak: 'break-word',
                  whiteSpace: 'normal',
                  textAlign: 'left',
                }}
          >{details?.community_name || ''}</Typography>
        </Box>
        <Box id="orderID" style={{ display: 'flex', alignItems: 'center',justifyContent:'space-between'  }}>
          <Typography id="discount" variant="h5" style={{ textAlign:'left'}}>Order ID:</Typography>
          <Typography variant="h5">#{details?.doc_number}</Typography>
        </Box>
        <Box id="to" style={{ display: 'flex', alignItems: 'center',justifyContent:'space-between' }}>
          <Typography id="totalmain1" variant="h5" >To:</Typography>
          <Typography variant="h5" style={{textAlign:'right'}}>{invoice?.customer_name}</Typography>
        </Box>
        <Box id="to" style={{ display: 'flex', alignItems: 'center',justifyContent:'space-between' }}>
          <Typography id="totalmain1" variant="h5" >Address:</Typography>
              <Typography variant="h5" style={{
                textAlign: 'right', ml: 2, maxWidth: '200px',
                wordBreak: 'break-word',
                whiteSpace: 'normal',
              }}>{invoice?.customer_address}</Typography>
        </Box>
        <Box style={{ display: 'flex', alignItems: 'center',justifyContent:'space-between' }}>
          <Typography id="totalmain1" variant="h4" >Phone:</Typography>
          <Typography variant="h4" style={{textAlign:'right'}}>{invoice?.customer_phone}</Typography>
        </Box>
            
          </Box>
        </Grid>

        <Scrollbar>
            {invoice?.cust_product?.length > 0 ?
              <TableContainer sx={{ minWidth: 420,marginTop:1 }}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>PRODUCT & NOTE</TableCell>
                      {/* {invoice?.cust_product?.some(item => item.product_notes) && <TableCell>SKU</TableCell>} */}
                      <TableCell align="center">SKU</TableCell>
                      {/* {(details?.is_split_order && details?.origin_facility_id == currentFacilityId && userType != 3) ? <TableCell>Wholesale Price</TableCell> : ''}
                      {(details?.is_split_order && details?.origin_facility_id == currentFacilityId && userType != 3) ? <TableCell>Split Markup</TableCell> : ''} */}
                      <TableCell>QTY</TableCell>
                      <TableCell>UNIT PRICE EACH</TableCell>
                      {/* <TableCell>MARKETTING ADJUSTMENT</TableCell> */}
                      <TableCell>TOTAL</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                  {groupedInvoiceDisplayRows?.map((row) => {
                    if (row?.__type === 'group') {
                      const representative = row?.representative || {}
                      const groupName = getCustomerOrderProductGroupDisplayName({
                        groupMeta: row?.groupMeta,
                        representative,
                        members: row?.members,
                        groupId: row?.groupId,
                      })
                      const groupDescription = row?.groupMeta?.group_description || representative?.group_description || '-'
                      const groupProductDisplayQty = Number(row?.groupProductDisplayQty ?? 1) || 1
                      const groupInstallDisplayQty = Number(row?.groupInstallDisplayQty ?? 1) || 1
                      const groupInstallSubtotal = Number(row?.groupInstallSubtotal ?? 0)
                      const groupHasInstall = groupInstallSubtotal > 0
                      const displayGroupTotal = groupHasInstall ? Number(row?.groupProductOnlyTotal ?? 0) : Number(row?.totalValue || 0)
                      const unitEach = groupProductDisplayQty > 0 ? displayGroupTotal / groupProductDisplayQty : 0
                      const groupInstallUnitEach = groupInstallDisplayQty > 0 ? groupInstallSubtotal / groupInstallDisplayQty : 0
                      const groupInstallNotes = getGroupInstallNotesDisplay(row?.members)
                      const members = row?.members || []
                      const groupDisplayName = groupName
                      const groupDisplayNote =
                        members.find(
                          (m) =>
                            m?.product_notes != null &&
                            String(m.product_notes).trim() !== '',
                        )?.product_notes || ''
                      
                      return (
                        <React.Fragment key={`group-${row?.groupId}`}>
                          <TableRow>
                            <TableCell width={'25%'} sx={{ flexWrap: 'wrap', overflow: 'hidden' }}>
                              <Typography variant='subtitle2' sx={{ fontWeight: 'bold', mb: 1, wordBreak: 'break-word', overflowWrap: 'break-word', color: groupDisplayNote ? 'error.main' : 'inherit' }}>
                                {groupDisplayNote || groupDisplayName}
                              </Typography>
                              <Typography variant='subtitle2' sx={{ mb: 1, wordBreak: 'break-word', overflowWrap: 'break-word' }}>
                                {groupDescription}
                              </Typography>
                            </TableCell>
                            <TableCell align="center">-</TableCell>
                            <TableCell>{groupProductDisplayQty}</TableCell>
                            <TableCell>${Number(unitEach || 0).toFixed(2)}</TableCell>
                            <TableCell>${Number(displayGroupTotal || 0).toFixed(2)}</TableCell>
                          </TableRow>
                          {groupHasInstall && showInstallPriceInView ? (
                            <TableRow>
                              <TableCell sx={{ pl: 4 }}>
                                <Typography sx={{ color: groupInstallNotes ? 'error.main' : 'inherit', whiteSpace: 'pre-wrap' }}>
                                  {groupInstallNotes || 'Install Price'}
                                </Typography>
                              </TableCell>
                              <TableCell align="center">-</TableCell>
                              <TableCell>{groupInstallDisplayQty}</TableCell>
                              <TableCell>${Number(groupInstallUnitEach || 0).toFixed(2)}</TableCell>
                              <TableCell>${Number(groupInstallSubtotal || 0).toFixed(2)}</TableCell>
                            </TableRow>
                          ) : null}
                        </React.Fragment>
                      )
                    }

              const val = row;
              const { vid,split_percentage,facility_id,wholesale_price, incoming_split_percentage, product_name,product_notes,vpt_number,locationQuantity,actual_retail_price,install_cost,install_qty,install_quantity,install_notes,install_total, adjustment, material,rfp,unit_qty, product_price,product_retail_price, quantity, product_total, discount,unit,markAdjType,adj_value_type,services = [] } = val;
              const lineInstallQty = Number(install_qty ?? install_quantity ?? 1) || 1;
             
                // Get labor install
                const labourService = services?.find(service => service.labour_cost_service_id === 10);
                const minusAmountLabourInstall = (labourService?.service_original_cost * labourService?.prQty) || 0;
                const labourQty = (labourService?.prQty || 0) * locationQuantity;
                const labourRate = labourService?.service_original_cost || 0;
                const labourTotal = labourQty * labourRate;
                const labourInitial = (labourService?.prQty || 0) * labourRate;

              // Unit name logic
              let unitData = UNITS?.filter((item) => item?.id == unit)
              let shortUnitName = unitData[0]?.short_name || 'Unit'
              let unitName = unitData[0]?.name
              let SPMA = 0
              if(markAdjType==2 || markAdjType==3){
                SPMA = (product_retail_price || 0) //+ (adj_value_type ?  +adjustment : -adjustment) //(adjustment ? Number(adjustment) : 0)

              }else{
                SPMA = (product_retail_price || 0)// + (((product_retail_price || 0) * (adjustment ? Number(adjustment) : 0)) / 100)
              }
              SPMA = parseFloat(SPMA)?.toFixed(2)    
              return (
                <React.Fragment key={vid}>
                  {/* Product Row */}
                  <TableRow
                  //  sx={{
                  //   borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                  // }}
                  >
                    <TableCell width={'25%'} sx={{ flexWrap: 'wrap', overflow: 'hidden' }}>
                      {product_notes ? 
                       <Typography variant='body2' sx={{ fontWeight: 'bold', wordBreak: 'break-word', overflowWrap: 'break-word'}}>{product_notes}</Typography> 
                      : 
                      <Typography variant='subtitle2' sx={{ fontWeight: 'bold', wordBreak: 'break-word', overflowWrap: 'break-word' }}>{product_name}</Typography>
                      
                      }
                      {(material === 1 && rfp==0 && details?.job_category_name != 'Time & Material') ? 
                        <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}>(Addl. Material)</Typography> 
                      : null}
                      {(material === 1 && rfp==1 && details?.job_category_name != 'Time & Material') ? 
                        <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}>(Material)</Typography> 
                      : null}
                    </TableCell>
                    {/* {invoice?.cust_product?.some(item => item.product_notes) ? <TableCell>{product_notes ? vpt_number : ''}</TableCell> : ''} */}
                    {/* <TableCell align="center">{material === 1 ? '1' : quantity} ({shortUnitName})</TableCell> */}
                    <TableCell align="center">{vpt_number ? vpt_number : '-'} </TableCell>
                    {/* Outgoing Percentage column - only show when isSplitOrder is true */}
                    {/* {(details?.is_split_order && details?.origin_facility_id == currentFacilityId && userType != 3) ? 
                      <TableCell align="center">
                        {details?.is_split_order && facility_id != currentFacilityId ? `${wholesale_price || 0}%` : '-'}
                      </TableCell>
                      :''
                    } */}
                    {/* Incoming Percentage column - only show when isSplitOrder is true */}
                    {/* {(details?.is_split_order && details?.origin_facility_id == currentFacilityId && userType != 3) ? 
                      <TableCell align="center">
                        {details?.is_split_order && facility_id != currentFacilityId ? `${incoming_split_percentage || 0}%` : '-'}
                      </TableCell>
                      :''
                    } */}
                    {/* <TableCell>${(SPMA ? SPMA - (labourInitial || 0) : 0)?.toFixed(2)}</TableCell> */}
                    {/* <TableCell>${(Number(SPMA) || 0).toFixed(2)}</TableCell> */}
                    <TableCell>{locationQuantity}</TableCell>
                    <TableCell>${(Number(actual_retail_price) || (Number(SPMA) || 0)).toFixed(2)}</TableCell>
                    {/* <TableCell>{locationQuantity}</TableCell> */}
                    {/* {markAdjType==1?
                      // <TableCell>${product_total ? (product_total - labourTotal)?.toFixed(2) : 0.00}</TableCell>
                      <TableCell>${product_total ? product_total?.toFixed(2) : 0.00}</TableCell>
                    :
                      // <TableCell>${((SPMA * (locationQuantity * quantity)) - labourTotal)?.toFixed(2)}</TableCell>
                    <TableCell>${(SPMA * (locationQuantity * quantity))?.toFixed(2)}</TableCell>
                    } */}
                    {/* <TableCell>{adjustment ? `${adj_value_type ? `+${adjustment}` : `-${adjustment}`}` : '-'}</TableCell> */}
                    {markAdjType==1?                                                            // <TableCell>${product_total ? product_total?.toFixed(2) : 0.00}</TableCell>
                    <TableCell>${
                      install_cost ?
                      ((actual_retail_price * (locationQuantity * quantity)) || 0).toFixed(2) :
                      material === 1 ?
                      ((SPMA * locationQuantity ) || 0).toFixed(2) :
                      ((SPMA * (locationQuantity * quantity)) || 0).toFixed(2)
                      // (((SPMA * (locationQuantity * quantity)) + (adj_value_type ?  +adjustment : -adjustment)) || 0).toFixed(2)
                      }</TableCell>
                  :
                    // <TableCell>${((SPMA * (locationQuantity * quantity)) - labourTotal)?.toFixed(2)}</TableCell>
                    <TableCell>${
                      install_cost ?
                      ((actual_retail_price * (locationQuantity * quantity)) || 0).toFixed(2) :
                      material === 1 ?
                      ((SPMA * locationQuantity ) || 0).toFixed(2) :
                      ((SPMA * (locationQuantity * quantity)) || 0).toFixed(2)
                      // (((SPMA * (locationQuantity * quantity)) + (adj_value_type ?  +adjustment : -adjustment)) || 0).toFixed(2)
                      }</TableCell>
                  }
                  </TableRow>
                  {/* Labor Install Row (if exists) */}
                  {/* {labourService && (
                    <TableRow>
                      <TableCell sx={{ pl: 4 }}>{labourService?.name}</TableCell>
                      <TableCell align="center">N/A</TableCell>
                      <TableCell>${labourRate?.toFixed(2)}</TableCell>
                      <TableCell>{labourQty?.toFixed(2)}</TableCell>
                      <TableCell>${labourTotal?.toFixed(2)}</TableCell>
                    </TableRow>
                  )} */}
                  {install_cost && showInstallPriceInView ? (
                    <TableRow>
                      <TableCell sx={{ pl: 4 }}>
                        <Typography sx={{ color: install_notes ? 'error.main' : 'inherit', whiteSpace: 'pre-wrap' }}>
                          {install_notes || 'Install Price'}
                        </Typography>
                      </TableCell>
                      {invoice?.cust_product?.some(item => item.product_notes) ? <TableCell>-</TableCell> : ''}
                      <TableCell align="center">-</TableCell>
                      {/* Outgoing Percentage column for Install Price - only show when isSplitOrder is true */}
                            {/* {(details?.is_split_order && details?.origin_facility_id == currentFacilityId && userType != 3) ?
                              <TableCell align="center">
                                {details?.is_split_order && facility_id != currentFacilityId ? '-' : '-'}
                              </TableCell>
                              : ''
                            } */}
                      {/* Incoming Percentage column for Install Price - only show when isSplitOrder is true */}
                            {/* {(details?.is_split_order && details?.origin_facility_id == currentFacilityId && userType != 3) ?
                              <TableCell align="center">
                                {details?.is_split_order && facility_id != currentFacilityId ? '-' : '-'}
                              </TableCell>
                              : ''
                            } */}
                      <TableCell>{lineInstallQty}</TableCell>
                      <TableCell>${install_cost || 0}</TableCell>
                      {/* <TableCell>-</TableCell> */}
                      <TableCell>
                        {/* ${((install_cost || 0) * (locationQuantity || 1) * (quantity || 1)).toFixed(2)} */}
                        ${((install_cost || 0) * lineInstallQty).toFixed(2)}
                      </TableCell>

                    </TableRow>
                  ):''}
                  {/* <TableRow>
                    <TableCell colSpan={5}>
                      <Box sx={{ borderBottom: (theme) => `solid 1px ${theme.palette.divider}` }} />
                    </TableCell>
                  </TableRow> */}
                </React.Fragment>
                )
              }
              )}

                    {/* <RowResultStyle>
                      <TableCell colSpan={3} />
                      <TableCell align="center">
                        <Typography variant="h3">Subtotal</Typography>
                      </TableCell>
                      <TableCell align="center" width={10}>
                        <Typography variant="h3">{subTotal}</Typography>
                      </TableCell>

                    </RowResultStyle> */}
                    {/* <RowResultStyle>
                      <TableCell colSpan={3} />
                      <TableCell align="center">
                        <Typography variant="h3">Extra Discount</Typography>
                      </TableCell>
                      <TableCell align="center" width={10}>
                        <Typography variant="h3">{invoice?.extra_discount}</Typography>
                      </TableCell>

                    </RowResultStyle> */}
                  
                    {/* <RowResultStyle>
                      <TableCell colSpan={3} />
                      <TableCell align="center">
                        <Typography variant="h3">Total</Typography>
                      </TableCell>
                      <TableCell align="center" width={10}>
                        <Typography variant="h3">{invoice?.total}</Typography>
                      </TableCell>

                    </RowResultStyle> */}

                  </TableBody>
                </Table>
              </TableContainer>
            :''}
              {/*below for labour Install */}

                                {/* <TableContainer sx={{ minWidth: 420, mt: 3 }}>
                                  <Table>
                                    {(labourInstallService?.length > 0 ) &&
                                      <TableHead>
                                        <TableRow>
                                          <TableCell colSpan={2}>Services(Labor Install) NAME</TableCell>
                                          <TableCell>COST (HOURLY)</TableCell>
                                          <TableCell>HOURS</TableCell>
                                          <TableCell>TOTAL COST</TableCell>
                                        </TableRow>
                                      </TableHead>}
                                    <TableBody>
                                    
                                    {labourInstallService?.map((ser) => {
                                        console.log('invoiceSelectedServices--@@ 1', ser);
                                        return (
                                          <TableRow sx={{
                                            borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                                          }}>
                                            <TableCell colSpan={2}>{ser?.name}-({ser.productName})</TableCell>
                                            <TableCell>{formatServiceHourlyCost(ser)}</TableCell>
                                            <TableCell>{ser ? ser?.quantity?.toFixed(2) : 0}</TableCell>
                                            <TableCell>{ser ? ser?.total_cost?.toFixed(2) : 0}</TableCell>
                                          </TableRow>
                                        )
                                      })}
                                      </TableBody>
                                      </Table>
                                      </TableContainer> */}
              
              {/*above  for labour Install */}

              {/* {(additionalSelectedServices?.length > 0 || invoiceSelectedServices?.length > 0 || cartService?.length > 0) && <Typography variant='h4' sx={{ mt:2 }}>Additional Services</Typography>} */}
              <TableContainer sx={{ minWidth: 420, mt:3 }}>
                <Table>
                {(additionalSelectedServices?.length > 0 || invoiceSelectedServices?.length > 0 || cartService?.length > 0) && 
                  <TableHead>
                    <TableRow>
                      <TableCell>ADDITIONAL SERVICES</TableCell>
                      <TableCell>UNIT COST</TableCell>
                      <TableCell>HOURS</TableCell>
                      <TableCell>TOTAL COST</TableCell>
                    </TableRow>
                  </TableHead>}
                  <TableBody>
                  {openInvoice && invoiceSelectedServices?.map((ser) => {
                  return (
                    <TableRow sx={{
                      borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                    }}>
                      <TableCell>{ser?.service_notes ? 
                                      <Stack direction={'column'}>
                                        {/* <Typography variant='body2' sx={{textDecoration: 'underline', mt: 1, color: 'error.main' }}>Service Note : </Typography>  */}
                                        <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word' ,color: 'error.main', whiteSpace: 'pre-wrap'}}>{ser.service_notes}</Typography> 
                                      </Stack>
                                      : ser?.name}</TableCell>
                      <TableCell>${formatServiceHourlyCost(ser)}</TableCell>
                      <TableCell>{ser ? ser?.quantity?.toFixed(2) : 0}</TableCell>
                      <TableCell>${ser ? ser?.total_cost?.toFixed(2) : 0}</TableCell>
                    </TableRow>
                  )
                }
                )}
                      {openInvoice && sortServicesByProductIndex(additionalSelectedServices)?.map((ser) => {
                        console.log('additionalSelectedServices--',ser);
                        return(
                        <TableRow sx={{
                          borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                        }}>
                          <TableCell>{ser?.service_notes ? 
                                      <Stack direction={'column'}>
                                        {/* <Typography variant='body2' sx={{textDecoration: 'underline', mt: 1, color: 'error.main' }}>Service Note : </Typography>  */}
                                        <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word' ,color: 'error.main', whiteSpace: 'pre-wrap'}}>{ser.service_notes}</Typography> 
                                      </Stack>
                                      : ser?.service_name || ser?.name }</TableCell>
                          <TableCell>${formatServiceHourlyCost(ser)}</TableCell>
                          <TableCell>{ser ? ser?.quantity?.toFixed(2) : 0}</TableCell>
                          <TableCell>${ser ? ser?.total_cost?.toFixed(2) : 0}</TableCell>
                        </TableRow>
                      )
                    }
                    )}
{openInvoice && cartService?.map((ser) => {
                  console.log('cartService--', ser);
                  ser.sellingPrice = ser.sellingPrice || ser.unit_cost
                  ser.originalMarkup = ser.originalMarkup || ser.product_markup || ser.markup
                  return (
                    <TableRow sx={{
                      borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                    }}>
                      <TableCell>{ser?.service_notes ? 
                                      <Stack direction={'column'}>
                                        {/* <Typography variant='body2' sx={{textDecoration: 'underline', mt: 1, color: 'error.main' }}>Service Note : </Typography>  */}
                                        <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word' ,color: 'error.main', whiteSpace: 'pre-wrap'}}>{ser.service_notes}</Typography> 
                                      </Stack>
                                      : ser?.service_name || ser?.name }</TableCell>
                      <TableCell> ${((ser.sellingPrice + (ser.sellingPrice * ser.originalMarkup / 100)))?.toFixed(2)}</TableCell>
                      <TableCell>{ser ? ser?.qty?.toFixed(2) : 0}</TableCell>
                      <TableCell> ${(ser.qty * (ser.sellingPrice + (ser.sellingPrice * ser.originalMarkup / 100)))?.toFixed(2)}</TableCell>
                    </TableRow>
                  )
                }
                )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Scrollbar>

      <Grid id="total"  item xs={12} sm={6} >
      <Box sx={{ mb: 5, display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
        
        <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Typography id="subtotal" variant="h3" style={{ textAlign: 'left', margin: '4px', padding: 0 }}>Product Total</Typography>
          <Typography variant="h3" style={{ textAlign: 'right', margin: '4px', padding: 0 }}>
            ${printInvoiceProductTotalFromRows.toFixed(2)}
          </Typography>
        </Box>
        {/* {(labourInstallService?.length > 0) &&
          <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography id="subtotal" variant="h2" style={{ textAlign: 'left', margin: '4px', padding: 0 }}>Install Total</Typography>
            <Typography variant="h2" style={{ textAlign: 'right', margin: '4px', padding: 0 }}>
              ${invoice?.cust_product?.reduce((sum, val) => {
                const labourService = val?.services?.find(s => s.labour_cost_service_id === 10);
                return sum + (labourService?.service_original_cost || 0) * (labourService?.prQty || 0) * (val?.locationQuantity || 1);
              }, 0)?.toFixed(2)}
            </Typography>
          </Box>
        } */}
        {(labourInstallService?.length > 0 || 
          additionalSelectedServices?.some(
            x => x.labour_cost_service_id === 10 && (x.total_cost || 0) > 0
          )||
            printInvoiceInstallTotalFromRows > 0
        ) &&
          <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography id="subtotal" variant="h3" style={{ textAlign: 'left', margin: '4px', padding: 0,width: '300px', }}>Install Total</Typography>
            {/* <Typography variant="h2" style={{ textAlign: 'right', margin: '4px', padding: 0 }}>
              ${invoice?.cust_product?.reduce((sum, val) => {
                const labourService = val?.services?.find(s => s.labour_cost_service_id === 10);
                return sum + (labourService?.service_original_cost || 0) * (labourService?.prQty || 0) * (val?.locationQuantity || 1);
              }, 0)?.toFixed(2)}
            </Typography> */}
            <Typography variant="h3" style={{ textAlign: 'right', margin: '4px', padding: 0 }}>
                ${(
                    // (invoice?.cust_product?.reduce((sum, val) => {
                    //   const labourService = val?.services?.find(
                    //     s => s.labour_cost_service_id === 10
                    //   );
                    //   return (
                    //     sum +
                    //     (labourService?.service_original_cost || 0) *
                    //       (labourService?.prQty || 0) *
                    //       (val?.locationQuantity || 1)
                    //   );
                    // }, 0) || 0) +
                    (printInvoiceInstallTotalFromRows || 0) +
                    (additionalSelectedServices?.reduce(
                      (s, x) =>
                        x.labour_cost_service_id === 10 ? s + (x.total_cost || 0) : s,
                      0
                    ) || 0)
                  ).toFixed(2)}
              </Typography>
          </Box>
        }
        
        <Box style={{ display: 'flex', alignItems: 'center',justifyContent:'space-between'  }}>
          <Typography id="discount" variant="h3" style={{ textAlign: 'left', margin: '4px', padding: 0 }}> Additional Services Total</Typography>
          <Typography variant="h3" style={{ textAlign: 'right', margin: '4px', padding: 0 }}>
            ${(
              (invoiceSelectedServices?.reduce((s, x) => s + (x.total_cost || 0), 0) || 0) +
              (additionalSelectedServices?.reduce((s, x) => s + (x.total_cost || 0), 0) || 0) +
              (cartService?.reduce((s, x) => {
                const sp = x.sellingPrice || x.unit_cost || 0;
                const markup = x.originalMarkup || x.product_markup || 0;
                const final = sp + (sp * markup / 100);
                return s + ((x.qty || 0) * final);
              }, 0) || 0)
            )?.toFixed(2)}
          </Typography>
        </Box>

        <Box style={{ display: 'flex', alignItems: 'center',justifyContent:'space-between' }}>
          <Typography id="subtotal" variant="h3" style={{ textAlign: 'left', margin: '4px', padding: 0 }}>Subtotal</Typography>
          <Typography variant="h3" style={{ textAlign: 'right', margin: '4px', padding: 0 }}>
            ${fUSPrice(
              (printInvoiceCustProductSubtotalForServices || 0) +
              // (invoiceSelectedServices?.reduce((s, x) => s + (x.total_cost || 0), 0) || 0) +
              (additionalSelectedServices?.reduce((s, x) => s + (x.total_cost || 0), 0) || 0) +
              (cartService?.reduce((s, x) => {
                const sp = x.sellingPrice || x.unit_cost || 0;
                const markup = x.originalMarkup || x.product_markup || 0;
                const final = sp + (sp * markup / 100);
                return s + ((x.qty || 0) * final);
              }, 0) || 0)  
              // (invoice?.cust_product?.reduce((sum, val) => {
              //   const labourService = val?.services?.find(
              //     s => s.labour_cost_service_id === 10
              //   );
              //   return (
              //     sum +
              //     (labourService?.service_original_cost || 0) *
              //       (labourService?.prQty || 0) *
              //       (val?.locationQuantity || 1)
              //   )
              // }, 0) || 0)
            )}
          </Typography>
        </Box>
        {/* Discount hidden — restore when needed
        {invoice?.extra_discount > 0 && (
        <Box style={{ display: 'flex', alignItems: 'center',justifyContent:'space-between'  }}>
          <Typography id="discount" variant="h3" style={{ textAlign: 'left', margin: '4px', padding: 0 }}>Discount</Typography>
          <Typography variant="h3" style={{ textAlign: 'right', margin: '4px', padding: 0 }}>${invoice ? invoice?.extra_discount?.toFixed(2) : 0.00}</Typography>
        </Box>
        )}
        */}
        {invoice?.tax_amount > 0 && (
        <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Typography id="discount" variant="h3" style={{ textAlign: 'left', margin: '4px', padding: 0 }}>Tax</Typography>
          <Typography variant="h3" style={{ textAlign: 'right', margin: '4px', padding: 0 }}>${invoice ? invoice?.tax_amount?.toFixed(2) : 0.00}</Typography>
        </Box>
        )}
        <Box style={{ display: 'flex', alignItems: 'center',justifyContent:'space-between' }}>
          <Typography id="totalmain" variant="h3" style={{ textAlign: 'left', margin: '4px', padding: 0 }}>Total</Typography>
          <Typography variant="h3" style={{ textAlign: 'right', margin: '4px', padding: 0 }}>${fUSPrice(invoice?.total ?? 0)}</Typography>
        </Box>
                   
          </Box>
        </Grid>
                      
          </Grid>
          </Stack>
            
  )
})